/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, callbacks = [];
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId])
/******/ 				callbacks.push.apply(callbacks, installedChunks[chunkId]);
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules);
/******/ 		while(callbacks.length)
/******/ 			callbacks.shift().call(null, __webpack_require__);
/******/ 		if(moreModules[0]) {
/******/ 			installedModules[0] = 0;
/******/ 			return __webpack_require__(0);
/******/ 		}
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// object to store loaded and loading chunks
/******/ 	// "0" means "already loaded"
/******/ 	// Array means "loading", array contains callbacks
/******/ 	var installedChunks = {
/******/ 		168707334958949:0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId, callback) {
/******/ 		// "0" is the signal for "already loaded"
/******/ 		if(installedChunks[chunkId] === 0)
/******/ 			return callback.call(null, __webpack_require__);
/******/
/******/ 		// an array means "currently loading".
/******/ 		if(installedChunks[chunkId] !== undefined) {
/******/ 			installedChunks[chunkId].push(callback);
/******/ 		} else {
/******/ 			// start chunk loading
/******/ 			installedChunks[chunkId] = [callback];
/******/ 			var head = document.getElementsByTagName('head')[0];
/******/ 			var script = document.createElement('script');
/******/ 			script.type = 'text/javascript';
/******/ 			script.charset = 'utf-8';
/******/ 			script.async = true;
/******/
/******/ 			script.src = __webpack_require__.p + window["webpackManifest"][chunkId];
/******/ 			head.appendChild(script);
/******/ 		}
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// expose the chunks object
/******/ 	__webpack_require__.s = installedChunks;
/******/ })
/************************************************************************/
/******/ ([
/* 0 */,
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(944);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(874)();
	}


/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(902);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(405);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(903);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(390);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ }),
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(515);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import styles from "./styles"
	
	var cleanups = {
	  // some useless stuff for us
	  // that svgo doesn't remove
	  title: /<title>.*<\/title>/gi,
	  desc: /<desc>.*<\/desc>/gi,
	  comment: /<!--.*-->/gi,
	  defs: /<defs>.*<\/defs>/gi,
	
	  // remove hardcoded dimensions
	  width: / +width="\d+(\.\d+)?(px)?"/gi,
	  height: / +height="\d+(\.\d+)?(px)?"/gi,
	
	  // remove fill
	  fill: / +fill=\"(none|#[0-9a-f]+)\"/gi,
	
	  // Sketch.app shit
	  sketchMSShapeGroup: / +sketch:type=\"MSShapeGroup\"/gi,
	  sketchMSPage: / +sketch:type=\"MSPage\"/gi,
	  sketchMSLayerGroup: / +sketch:type=\"MSLayerGroup\"/gi
	};
	
	// @styled(styles)
	
	var SVGInline = function (_Component) {
	  _inherits(SVGInline, _Component);
	
	  function SVGInline() {
	    _classCallCheck(this, SVGInline);
	
	    return _possibleConstructorReturn(this, (SVGInline.__proto__ || Object.getPrototypeOf(SVGInline)).apply(this, arguments));
	  }
	
	  _createClass(SVGInline, [{
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          component = _props.component,
	          svg = _props.svg,
	          fill = _props.fill,
	          width = _props.width,
	          classSuffix = _props.classSuffix,
	          cleanupExceptions = _props.cleanupExceptions,
	          componentProps = _objectWithoutProperties(_props, ["className", "component", "svg", "fill", "width", "classSuffix", "cleanupExceptions"]);
	
	      var _props2 = this.props,
	          cleanup = _props2.cleanup,
	          height = _props2.height;
	
	
	      if (
	      // simple way to enable entire cleanup
	      cleanup === true ||
	      // passing cleanupExceptions enable cleanup as well
	      cleanup.length === 0 && cleanupExceptions.length > 0) {
	        cleanup = Object.keys(cleanups);
	      }
	      cleanup = cleanup.filter(function (key) {
	        return !(cleanupExceptions.indexOf(key) > -1);
	      });
	
	      if (width && height === undefined) {
	        height = width;
	      }
	
	      // remove useless props for wrapper
	      delete componentProps.cleanup;
	      delete componentProps.height;
	
	      var classes = (0, _classnames2.default)(_defineProperty({
	        "SVGInline": true,
	        "SVGInline--cleaned": cleanup.length
	      }, className, className));
	      var svgClasses = classes.split(" ").join(classSuffix + " ") + classSuffix;
	
	      return _react2.default.createElement(component, _extends({}, componentProps, { // take most props
	        className: classes,
	        dangerouslySetInnerHTML: {
	          __html: SVGInline.cleanupSvg(svg, cleanup).replace(/<svg/, "<svg class=\"" + svgClasses + "\"" + (fill ? " fill=\"" + fill + "\"" : "") + (width || height ? " style=\"" + (width ? "width: " + width + ";" : "") + (height ? "height: " + height + ";" : "") + "\"" : ""))
	        }
	      }));
	    }
	  }]);
	
	  return SVGInline;
	}(_react.Component);
	
	SVGInline.propTypes = {
	  className: _propTypes2.default.string,
	  classSuffix: _propTypes2.default.string,
	  component: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
	  svg: _propTypes2.default.string.isRequired,
	  fill: _propTypes2.default.string,
	  cleanup: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.array]),
	  cleanupExceptions: _propTypes2.default.array,
	  width: _propTypes2.default.string,
	  height: _propTypes2.default.string
	};
	
	SVGInline.defaultProps = {
	  component: "span",
	  classSuffix: "-svg",
	  cleanup: [],
	  cleanupExceptions: []
	};
	
	SVGInline.cleanupSvg = function (svg) {
	  var cleanup = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  return Object.keys(cleanups).filter(function (key) {
	    return cleanup.indexOf(key) > -1;
	  }).reduce(function (acc, key) {
	    return acc.replace(cleanups[key], "");
	  }, svg).trim();
	};
	
	exports.default = SVGInline;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.navigateTo = undefined;
	
	var _extends2 = __webpack_require__(513);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(509);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(514);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(250);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(288);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(287);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.withPrefix = withPrefix;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(223);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pathPrefix = "/"; /*global __PREFIX_PATHS__, __PATH_PREFIX__ */
	
	if (false) {
	  pathPrefix = __PATH_PREFIX__;
	}
	
	function withPrefix(path) {
	  return normalizePath(pathPrefix + path);
	}
	
	function normalizePath(path) {
	  return path.replace(/^\/\//g, "/");
	}
	
	var NavLinkPropTypes = {
	  activeClassName: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  isActive: _propTypes2.default.func,
	  location: _propTypes2.default.object
	
	  // Set up IntersectionObserver
	};var handleIntersection = function handleIntersection(el, cb) {
	  var io = new window.IntersectionObserver(function (entries) {
	    entries.forEach(function (entry) {
	      if (el === entry.target) {
	        // Check if element is within viewport, remove listener, destroy observer, and run link callback.
	        // MSEdge doesn't currently support isIntersecting, so also test for  an intersectionRatio > 0
	        if (entry.isIntersecting || entry.intersectionRatio > 0) {
	          io.unobserve(el);
	          io.disconnect();
	          cb();
	        }
	      }
	    });
	  });
	  // Add element to the observer
	  io.observe(el);
	};
	
	var GatsbyLink = function (_React$Component) {
	  (0, _inherits3.default)(GatsbyLink, _React$Component);
	
	  function GatsbyLink(props) {
	    (0, _classCallCheck3.default)(this, GatsbyLink);
	
	    // Default to no support for IntersectionObserver
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this));
	
	    var IOSupported = false;
	    if (typeof window !== "undefined" && window.IntersectionObserver) {
	      IOSupported = true;
	    }
	
	    _this.state = {
	      to: withPrefix(props.to),
	      IOSupported: IOSupported
	    };
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  GatsbyLink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.to !== nextProps.to) {
	      this.setState({
	        to: withPrefix(nextProps.to)
	      });
	      // Preserve non IO functionality if no support
	      if (!this.state.IOSupported) {
	        ___loader.enqueue(this.state.to);
	      }
	    }
	  };
	
	  GatsbyLink.prototype.componentDidMount = function componentDidMount() {
	    // Preserve non IO functionality if no support
	    if (!this.state.IOSupported) {
	      ___loader.enqueue(this.state.to);
	    }
	  };
	
	  GatsbyLink.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      // If IO supported and element reference found, setup Observer functionality
	      handleIntersection(ref, function () {
	        ___loader.enqueue(_this2.state.to);
	      });
	    }
	  };
	
	  GatsbyLink.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        _onClick = _props.onClick,
	        rest = (0, _objectWithoutProperties3.default)(_props, ["onClick"]);
	
	    var El = void 0;
	    if ((0, _keys2.default)(NavLinkPropTypes).some(function (propName) {
	      return _this3.props[propName];
	    })) {
	      El = _reactRouterDom.NavLink;
	    } else {
	      El = _reactRouterDom.Link;
	    }
	
	    return _react2.default.createElement(El, (0, _extends3.default)({
	      onClick: function onClick(e) {
	        // eslint-disable-line
	        _onClick && _onClick(e);
	
	        if (e.button === 0 && // ignore right clicks
	        !_this3.props.target && // let browser handle "target=_blank"
	        !e.defaultPrevented && // onClick prevented default
	        !e.metaKey && // ignore clicks with modifier keys...
	        !e.altKey && !e.ctrlKey && !e.shiftKey) {
	          // Is this link pointing to a hash on the same page? If so,
	          // just scroll there.
	          var pathname = _this3.state.to;
	          if (pathname.split("#").length > 1) {
	            pathname = pathname.split("#").slice(0, -1).join("");
	          }
	          if (pathname === window.location.pathname) {
	            var hashFragment = _this3.state.to.split("#").slice(1).join("#");
	            var element = document.getElementById(hashFragment);
	            if (element !== null) {
	              element.scrollIntoView();
	              return true;
	            }
	          }
	
	          // In production, make sure the necessary scripts are
	          // loaded before continuing.
	          if (true) {
	            e.preventDefault();
	            window.___navigateTo(_this3.state.to);
	          }
	        }
	
	        return true;
	      }
	    }, rest, {
	      to: this.state.to,
	      innerRef: this.handleRef
	    }));
	  };
	
	  return GatsbyLink;
	}(_react2.default.Component);
	
	GatsbyLink.propTypes = (0, _extends3.default)({}, NavLinkPropTypes, {
	  to: _propTypes2.default.string.isRequired,
	  onClick: _propTypes2.default.func
	});
	
	GatsbyLink.contextTypes = {
	  router: _propTypes2.default.object
	};
	
	exports.default = GatsbyLink;
	var navigateTo = exports.navigateTo = function navigateTo(pathname) {
	  window.___navigateTo(withPrefix(pathname));
	};

/***/ }),
/* 11 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowserEnv = function isBrowserEnv() {
	  return (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && _typeof(window.document) === "object";
	};
	
	exports.default = isBrowserEnv;
	module.exports = exports["default"];

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(371)('wks');
	var uid = __webpack_require__(259);
	var Symbol = __webpack_require__(18).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    isObjectLike = __webpack_require__(29);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var bind = __webpack_require__(338);
	var isBuffer = __webpack_require__(730);
	
	/*global toString:true*/
	
	// utils is a library of generic helper functions non-specific to axios
	
	var toString = Object.prototype.toString;
	
	/**
	 * Determine if a value is an Array
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Array, otherwise false
	 */
	function isArray(val) {
	  return toString.call(val) === '[object Array]';
	}
	
	/**
	 * Determine if a value is an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
	 */
	function isArrayBuffer(val) {
	  return toString.call(val) === '[object ArrayBuffer]';
	}
	
	/**
	 * Determine if a value is a FormData
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an FormData, otherwise false
	 */
	function isFormData(val) {
	  return (typeof FormData !== 'undefined') && (val instanceof FormData);
	}
	
	/**
	 * Determine if a value is a view on an ArrayBuffer
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
	 */
	function isArrayBufferView(val) {
	  var result;
	  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
	    result = ArrayBuffer.isView(val);
	  } else {
	    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
	  }
	  return result;
	}
	
	/**
	 * Determine if a value is a String
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a String, otherwise false
	 */
	function isString(val) {
	  return typeof val === 'string';
	}
	
	/**
	 * Determine if a value is a Number
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Number, otherwise false
	 */
	function isNumber(val) {
	  return typeof val === 'number';
	}
	
	/**
	 * Determine if a value is undefined
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if the value is undefined, otherwise false
	 */
	function isUndefined(val) {
	  return typeof val === 'undefined';
	}
	
	/**
	 * Determine if a value is an Object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is an Object, otherwise false
	 */
	function isObject(val) {
	  return val !== null && typeof val === 'object';
	}
	
	/**
	 * Determine if a value is a Date
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Date, otherwise false
	 */
	function isDate(val) {
	  return toString.call(val) === '[object Date]';
	}
	
	/**
	 * Determine if a value is a File
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a File, otherwise false
	 */
	function isFile(val) {
	  return toString.call(val) === '[object File]';
	}
	
	/**
	 * Determine if a value is a Blob
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Blob, otherwise false
	 */
	function isBlob(val) {
	  return toString.call(val) === '[object Blob]';
	}
	
	/**
	 * Determine if a value is a Function
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Function, otherwise false
	 */
	function isFunction(val) {
	  return toString.call(val) === '[object Function]';
	}
	
	/**
	 * Determine if a value is a Stream
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a Stream, otherwise false
	 */
	function isStream(val) {
	  return isObject(val) && isFunction(val.pipe);
	}
	
	/**
	 * Determine if a value is a URLSearchParams object
	 *
	 * @param {Object} val The value to test
	 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
	 */
	function isURLSearchParams(val) {
	  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
	}
	
	/**
	 * Trim excess whitespace off the beginning and end of a string
	 *
	 * @param {String} str The String to trim
	 * @returns {String} The String freed of excess whitespace
	 */
	function trim(str) {
	  return str.replace(/^\s*/, '').replace(/\s*$/, '');
	}
	
	/**
	 * Determine if we're running in a standard browser environment
	 *
	 * This allows axios to run in a web worker, and react-native.
	 * Both environments support XMLHttpRequest, but not fully standard globals.
	 *
	 * web workers:
	 *  typeof window -> undefined
	 *  typeof document -> undefined
	 *
	 * react-native:
	 *  navigator.product -> 'ReactNative'
	 */
	function isStandardBrowserEnv() {
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    return false;
	  }
	  return (
	    typeof window !== 'undefined' &&
	    typeof document !== 'undefined'
	  );
	}
	
	/**
	 * Iterate over an Array or an Object invoking a function for each item.
	 *
	 * If `obj` is an Array callback will be called passing
	 * the value, index, and complete array for each item.
	 *
	 * If 'obj' is an Object callback will be called passing
	 * the value, key, and complete object for each property.
	 *
	 * @param {Object|Array} obj The object to iterate
	 * @param {Function} fn The callback to invoke for each item
	 */
	function forEach(obj, fn) {
	  // Don't bother if no value provided
	  if (obj === null || typeof obj === 'undefined') {
	    return;
	  }
	
	  // Force an array if not already something iterable
	  if (typeof obj !== 'object') {
	    /*eslint no-param-reassign:0*/
	    obj = [obj];
	  }
	
	  if (isArray(obj)) {
	    // Iterate over array values
	    for (var i = 0, l = obj.length; i < l; i++) {
	      fn.call(null, obj[i], i, obj);
	    }
	  } else {
	    // Iterate over object keys
	    for (var key in obj) {
	      if (Object.prototype.hasOwnProperty.call(obj, key)) {
	        fn.call(null, obj[key], key, obj);
	      }
	    }
	  }
	}
	
	/**
	 * Accepts varargs expecting each argument to be an object, then
	 * immutably merges the properties of each object and returns result.
	 *
	 * When multiple objects contain the same key the later object in
	 * the arguments list will take precedence.
	 *
	 * Example:
	 *
	 * ```js
	 * var result = merge({foo: 123}, {foo: 456});
	 * console.log(result.foo); // outputs 456
	 * ```
	 *
	 * @param {Object} obj1 Object to merge
	 * @returns {Object} Result of all merge properties
	 */
	function merge(/* obj1, obj2, obj3, ... */) {
	  var result = {};
	  function assignValue(val, key) {
	    if (typeof result[key] === 'object' && typeof val === 'object') {
	      result[key] = merge(result[key], val);
	    } else {
	      result[key] = val;
	    }
	  }
	
	  for (var i = 0, l = arguments.length; i < l; i++) {
	    forEach(arguments[i], assignValue);
	  }
	  return result;
	}
	
	/**
	 * Extends object a by mutably adding to it the properties of object b.
	 *
	 * @param {Object} a The object to be extended
	 * @param {Object} b The object to copy properties from
	 * @param {Object} thisArg The object to bind function to
	 * @return {Object} The resulting value of object a
	 */
	function extend(a, b, thisArg) {
	  forEach(b, function assignValue(val, key) {
	    if (thisArg && typeof val === 'function') {
	      a[key] = bind(val, thisArg);
	    } else {
	      a[key] = val;
	    }
	  });
	  return a;
	}
	
	module.exports = {
	  isArray: isArray,
	  isArrayBuffer: isArrayBuffer,
	  isBuffer: isBuffer,
	  isFormData: isFormData,
	  isArrayBufferView: isArrayBufferView,
	  isString: isString,
	  isNumber: isNumber,
	  isObject: isObject,
	  isUndefined: isUndefined,
	  isDate: isDate,
	  isFile: isFile,
	  isBlob: isBlob,
	  isFunction: isFunction,
	  isStream: isStream,
	  isURLSearchParams: isURLSearchParams,
	  isStandardBrowserEnv: isStandardBrowserEnv,
	  forEach: forEach,
	  merge: merge,
	  extend: extend,
	  trim: trim
	};


/***/ }),
/* 18 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(7);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.requestReportDownload = exports.requestFilteredArticlesDownload = exports.requestSavedArticlesDownload = exports.mailchimpRequest = exports.requestDownload = exports.hideModal = exports.showModal = exports.getModalProps = exports.getModalType = exports.getModal = exports.modals = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // eslint-disable-line no-unused-vars
	// eslint-disable-line no-unused-vars
	
	
	exports.modalReducer = modalReducer;
	
	var _axios = __webpack_require__(422);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _user = __webpack_require__(125);
	
	var _save = __webpack_require__(81);
	
	var _filter = __webpack_require__(247);
	
	var _chart = __webpack_require__(285);
	
	var _analytics = __webpack_require__(345);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	var _chart2 = __webpack_require__(248);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Global axios config
	var req = _axios2.default.create({
	  timeout: 10000,
	  headers: { "x-api-key": "ZXybxPpalb82ygfwt2Oxy8qtM6D9Ozp82xWs5nEq" }
	});
	
	/**
	 * This list is used to map modals to different components and / or actions.
	 */
	var modals = exports.modals = {
	  DOWNLOAD_SAVED_ARTICLES: Symbol("DOWNLOAD_SAVED_ARTICLES"),
	  DOWNLOAD_FILTERED_ARTICLES: Symbol("DOWNLOAD_FILTERED_ARTICLES"),
	  DOWNLOAD_REPORT: Symbol("DOWNLOAD_REPORT"),
	  DOWNLOAD_CHART: Symbol("DOWNLOAD_CHART"),
	  DOWNLOAD_SUCCESS: Symbol("DOWNLOAD_SUCCESS"),
	  DOWNLOAD_ERROR: Symbol("DOWNLOAD_ERROR")
	};
	
	// Actions
	var typePrefix = "modal/";
	var SHOW = typePrefix + "SHOW";
	var HIDE = typePrefix + "HIDE";
	
	// Selectors
	
	var getModal = exports.getModal = function getModal(state) {
	  return state.modal;
	};
	var getModalType = exports.getModalType = function getModalType(state) {
	  return state.modal.modalType;
	};
	var getModalProps = exports.getModalProps = function getModalProps(state) {
	  return state.modal.modalProps;
	};
	
	// Action creators
	
	var showModal = exports.showModal = function showModal(_ref) {
	  var modalType = _ref.modalType,
	      modalProps = _ref.modalProps;
	  return {
	    type: SHOW,
	    modalType: modalType,
	    modalProps: modalProps
	  };
	};
	
	var hideModal = exports.hideModal = function hideModal() {
	  return { type: HIDE };
	};
	
	/**
	 * Download requests typically happen as part of a modal flow. Decide what
	 * should happen for a particular download request and what should happen
	 * after the request is fulfilled.
	 *
	 * @param {*} user
	 */
	var requestDownload = exports.requestDownload = function requestDownload(user) {
	  return function (dispatch, getState) {
	    dispatch((0, _user.setUser)(user));
	    var state = getState();
	    var modalType = getModalType(state);
	    var nextAction = showModal({ modalType: modals.DOWNLOAD_ERROR });
	    var modalProps = {};
	    switch (modalType) {
	      case modals.DOWNLOAD_SAVED_ARTICLES:
	        nextAction = requestSavedArticlesDownload;
	        break;
	      case modals.DOWNLOAD_FILTERED_ARTICLES:
	        nextAction = requestFilteredArticlesDownload;
	        break;
	      case modals.DOWNLOAD_REPORT:
	        nextAction = requestReportDownload;
	        modalProps.text = "Your download will start in a few moments. Check your browser's download folder.";
	        break;
	      case modals.DOWNLOAD_CHART:
	        nextAction = _chart2.prepChartDownload;
	        break;
	    }
	    dispatch(nextAction());
	  };
	};
	
	// Make a request to mailchimp
	var mailchimpRequest = exports.mailchimpRequest = function mailchimpRequest(email, wantsNewsletter) {
	  var MAILCHIMP_NEWSLETTER = "https://4xin66b3g0.execute-api.eu-west-1.amazonaws.com/prod/newsletter";
	  var MAILCHIMP_NO_NEWSLETTER = "https://4xin66b3g0.execute-api.eu-west-1.amazonaws.com/prod/email";
	  var signupUrl = wantsNewsletter ? MAILCHIMP_NEWSLETTER : MAILCHIMP_NO_NEWSLETTER;
	  return req({
	    data: { email: email },
	    method: "post",
	    url: signupUrl
	  }).then(function (res) {
	    return res;
	  }).catch(function (err) {
	    // Sometimes these are invalid/duplicate address errors, sometimes other
	    // errors. We can't tell the difference for now, so just ignore.
	    console.log("err", err); // eslint-disable-line no-console
	  });
	};
	
	// Make a request for a pdf
	var customPdfRequest = function customPdfRequest(ids) {
	  return req({
	    data: { ids: ids },
	    method: "post",
	    url: "https://4xin66b3g0.execute-api.eu-west-1.amazonaws.com/prod"
	  }).then(function (res) {
	    var body = void 0;
	    if (res.status === 200) {
	      body = JSON.parse(res.data.body);
	      if (body.message === "success" && body.file) window.location.href = body.file;
	    }
	    return status;
	  }).catch(function (err) {
	    return Promise.reject(err);
	  });
	};
	
	// eslint-disable-next-line no-unused-vars
	var requestSavedArticlesDownload = exports.requestSavedArticlesDownload = function requestSavedArticlesDownload() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var savedArticleIds = (0, _save.getSavedArticleIds)(state).filter(function (item) {
	      if (item) {
	        return item;
	      }
	    });
	    var user = (0, _user.getUser)(state);
	
	    var nextModal = showModal({
	      modalType: modals.DOWNLOAD_SUCCESS,
	      modalProps: {
	        text: "Your download will start in a few moments. Check your browser's download folder."
	      }
	    });
	
	    _axios2.default.all([mailchimpRequest(user.email, user.newsletter), customPdfRequest(savedArticleIds.map(function (id) {
	      return "" + id;
	    }))]).then(function () {
	      dispatch(nextModal);
	      (0, _analytics2.default)("send", "event", "download", "downloadSavedArticles", {
	        articleIds: savedArticleIds
	      });
	    }).catch(function (err) {
	      console.log("err", err); // eslint-disable-line no-console
	      dispatch(showModal({ modalType: modals.DOWNLOAD_ERROR }));
	    });
	  };
	};
	
	// eslint-disable-next-line no-unused-vars
	var requestFilteredArticlesDownload = exports.requestFilteredArticlesDownload = function requestFilteredArticlesDownload() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var articleIds = (0, _filter.getFilterArticles)(state).filter(function (item) {
	      if (item) {
	        return item;
	      }
	    });
	    var user = (0, _user.getUser)(state);
	
	    var nextModal = showModal({
	      modalType: modals.DOWNLOAD_SUCCESS,
	      modalProps: {
	        text: "Your download will start in a few moments. Check your browser's download folder."
	      }
	    });
	
	    _axios2.default.all([mailchimpRequest(user.email, user.newsletter), customPdfRequest(articleIds.map(function (id) {
	      return "" + id;
	    }))]).then(function () {
	      dispatch(nextModal);
	      (0, _analytics2.default)("send", "event", "download", "downloadFilteredArticles", {
	        articleIds: articleIds
	      });
	    }).catch(function (err) {
	      console.log("err", err); // eslint-disable-line no-console
	      dispatch(showModal({ modalType: modals.DOWNLOAD_ERROR }));
	    });
	  };
	};
	
	// eslint-disable-next-line no-unused-vars
	var requestReportDownload = exports.requestReportDownload = function requestReportDownload() {
	  return function (dispatch, getState) {
	    var user = (0, _user.getUser)(getState());
	    mailchimpRequest(user.email, user.newsletter).then(function () {
	      window.location.href = "https://s3.eu-west-2.amazonaws.com/soet-pdf/State_of_European_Tech_2017_FullReport.pdf";
	      dispatch(showModal({
	        modalType: modals.DOWNLOAD_SUCCESS,
	        modalProps: {
	          text: "Your download will start in a few moments. Check your browser's download folder."
	        }
	      }));
	      (0, _analytics2.default)("send", "event", "download", "downloadFullReport");
	    });
	  };
	};
	
	// Reducer
	
	var initialState = {
	  isOpen: false,
	  modalType: null,
	  modalProps: {}
	};
	
	function modalReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SHOW:
	      return {
	        isOpen: true,
	        modalType: action.modalType,
	        modalProps: action.modalProps
	      };
	    case HIDE:
	      return _extends({}, state, { isOpen: false });
	    default:
	      return state;
	  }
	}

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ }),
/* 30 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ }),
/* 32 */
/***/ (function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.navSectionReducer = navSectionReducer;
	// Actions
	var typePrefix = "navSection/";
	var SET = typePrefix + "SET";
	var CLEAR = typePrefix + "CLEAR";
	
	// Selectors
	
	var getNavSection = exports.getNavSection = function getNavSection(state) {
	  return state.navSection;
	};
	
	// Action creators
	var setNavSection = exports.setNavSection = function setNavSection(_ref) {
	  var title = _ref.title,
	      backUrl = _ref.backUrl;
	  return {
	    type: SET,
	    title: title,
	    backUrl: backUrl
	  };
	};
	
	var clearNavSection = exports.clearNavSection = {
	  type: CLEAR
	};
	
	var emptyState = {
	  title: false,
	  backUrl: false
	};
	
	// Reducer
	function navSectionReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET:
	      return {
	        title: action.title,
	        backUrl: action.backUrl
	      };
	    case CLEAR:
	      return _extends({}, emptyState);
	    default:
	      return state;
	  }
	}

/***/ }),
/* 34 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ }),
/* 36 */
/***/ (function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(929);


/***/ }),
/* 65 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.previewScrollReducer = previewScrollReducer;
	// Actions
	var typePrefix = "previewScroll/";
	var SET = typePrefix + "SET";
	var CLEAR = typePrefix + "CLEAR";
	
	// Selectors
	
	var getPreviewScroll = exports.getPreviewScroll = function getPreviewScroll(state) {
	  return state.previewScroll;
	};
	
	// Action creators
	var setPreviewScroll = exports.setPreviewScroll = function setPreviewScroll(_ref) {
	  var position = _ref.position;
	  return {
	    type: SET,
	    position: position
	  };
	};
	
	var clearPreviewScroll = exports.clearPreviewScroll = { type: CLEAR };
	
	var emptyState = 0;
	
	// Reducer
	function previewScrollReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET:
	      return action.position;
	    case CLEAR:
	      return 0;
	    default:
	      return state;
	  }
	}

/***/ }),
/* 66 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(256)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 68 */
/***/ (function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ }),
/* 69 */
/***/ (function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(855),
	    mapCacheDelete = __webpack_require__(856),
	    mapCacheGet = __webpack_require__(857),
	    mapCacheHas = __webpack_require__(858),
	    mapCacheSet = __webpack_require__(859);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(263),
	    stackClear = __webpack_require__(864),
	    stackDelete = __webpack_require__(865),
	    stackGet = __webpack_require__(866),
	    stackHas = __webpack_require__(867),
	    stackSet = __webpack_require__(868);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ }),
/* 72 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(71),
	    arrayEach = __webpack_require__(72),
	    assignValue = __webpack_require__(387),
	    baseAssign = __webpack_require__(267),
	    baseAssignIn = __webpack_require__(820),
	    cloneBuffer = __webpack_require__(827),
	    copyArray = __webpack_require__(32),
	    copySymbols = __webpack_require__(834),
	    copySymbolsIn = __webpack_require__(835),
	    getAllKeys = __webpack_require__(271),
	    getAllKeysIn = __webpack_require__(837),
	    getTag = __webpack_require__(273),
	    initCloneArray = __webpack_require__(845),
	    initCloneByTag = __webpack_require__(846),
	    initCloneObject = __webpack_require__(847),
	    isArray = __webpack_require__(5),
	    isBuffer = __webpack_require__(205),
	    isObject = __webpack_require__(11),
	    keys = __webpack_require__(97);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(822),
	    getValue = __webpack_require__(839);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ }),
/* 75 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(821),
	    isObjectLike = __webpack_require__(29);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(593);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionButton = function ActionButton(_ref) {
	  var onClick = _ref.onClick,
	      disabled = _ref.disabled,
	      label = _ref.label,
	      large = _ref.large;
	
	  var attrs = {};
	  var className = large ? _indexModule2.default.rootLarge : _indexModule2.default.root;
	  if (disabled === true) attrs.disabled = disabled;
	  return _react2.default.createElement(
	    "button",
	    _extends({}, attrs, { className: className, onClick: onClick }),
	    label
	  );
	};
	
	ActionButton.defaultProps = {
	  label: "Download"
	};
	
	ActionButton.propTypes = {
	  label: _propTypes2.default.string,
	  disabled: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  large: _propTypes2.default.bool
	};
	
	exports.default = ActionButton;
	module.exports = exports["default"];

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(399);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/*  */
	var LayoutHead = function LayoutHead(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    _reactHelmet2.default,
	    {
	      title: "The State of European Tech 2017",
	      meta: [{ name: "description", content: "The State of European Tech 2017" }, { name: "keywords", content: "atomico, european tech" }]
	    },
	    _react2.default.createElement("html", { lang: "en" }),
	    children
	  );
	};
	// import PropTypes from "prop-types";
	exports.default = LayoutHead;
	module.exports = exports["default"];

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactFlipMove = __webpack_require__(892);
	
	var _reactFlipMove2 = _interopRequireDefault(_reactFlipMove);
	
	var _indexModule = __webpack_require__(614);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _Preview = __webpack_require__(478);
	
	var _Preview2 = _interopRequireDefault(_Preview);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PreviewsWrapper = function PreviewsWrapper(_ref) {
	  var enableAnims = _ref.enableAnims,
	      className = _ref.className,
	      children = _ref.children;
	
	  return enableAnims ? _react2.default.createElement(
	    _reactFlipMove2.default,
	    {
	      typeName: "div",
	      className: className,
	      duration: 250,
	      easing: "ease-in-out",
	      enterAnimation: "fade",
	      leaveAnimation: "fade",
	      maintainContainerHeight: true
	    },
	    children
	  ) : _react2.default.createElement(
	    "div",
	    { className: className },
	    children
	  );
	};
	
	PreviewsWrapper.propTypes = {
	  enableAnims: _propTypes2.default.bool,
	  className: _propTypes2.default.string
	};
	
	var PreviewList = function (_Component) {
	  _inherits(PreviewList, _Component);
	
	  function PreviewList(props) {
	    _classCallCheck(this, PreviewList);
	
	    return _possibleConstructorReturn(this, _Component.call(this, props));
	  }
	
	  PreviewList.prototype.render = function render() {
	    var _props = this.props,
	        previews = _props.previews,
	        selectedId = _props.selectedId,
	        enableAnims = _props.enableAnims;
	
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.root },
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.inner },
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.header },
	          _react2.default.createElement(
	            "h1",
	            { className: _indexModule2.default.title },
	            "The Research"
	          )
	        ),
	        _react2.default.createElement(
	          PreviewsWrapper,
	          { enableAnims: enableAnims, className: _indexModule2.default.list },
	          previews.map(function (preview) {
	            return _react2.default.createElement(
	              "div",
	              { key: preview.titleNumber },
	              _react2.default.createElement(_Preview2.default, _extends({
	                isSelected: selectedId && selectedId === preview.articleId
	              }, preview))
	            );
	          })
	        )
	      )
	    );
	  };
	
	  return PreviewList;
	}(_react.Component);
	
	PreviewList.defaultProps = {
	  enableAnims: false
	};
	
	PreviewList.propTypes = {
	  enableAnims: _propTypes2.default.bool,
	  previews: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
	  selectedId: _propTypes2.default.number
	};
	
	exports.default = PreviewList;
	module.exports = exports["default"];

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(615);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrimaryButton = function PrimaryButton(_ref) {
	  var onClick = _ref.onClick,
	      children = _ref.children,
	      disabled = _ref.disabled,
	      type = _ref.type,
	      to = _ref.to,
	      inverted = _ref.inverted;
	
	  var El = type === "link" ? _gatsbyLink2.default : "button";
	  var className = inverted ? _indexModule2.default.rootInverted : _indexModule2.default.root;
	  return _react2.default.createElement(
	    El,
	    { className: className, onClick: onClick, disabled: disabled, to: to },
	    children
	  );
	};
	
	PrimaryButton.defaultProps = {
	  disabled: false,
	  type: "button"
	};
	
	PrimaryButton.propTypes = {
	  onClick: _propTypes2.default.func,
	  disabled: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(["button", "link"]),
	  to: _propTypes2.default.string,
	  inverted: _propTypes2.default.bool
	};
	
	exports.default = PrimaryButton;
	module.exports = exports["default"];

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.rehydrate = exports.emptyState = exports.setSelectedArticleId = exports.toggleArticle = exports.getSelectedArticleId = exports.getSavedCount = exports.getSavedArticleIds = exports.getSaved = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.saveReducer = saveReducer;
	
	var _storage = __webpack_require__(249);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _objectKeysMatch = __webpack_require__(346);
	
	var _objectKeysMatch2 = _interopRequireDefault(_objectKeysMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var typePrefix = "articles/save/";
	var CLEAR_SAVED = typePrefix + "CLEAR_SAVED";
	var TOGGLE_SAVED = typePrefix + "TOGGLE_SAVED";
	var SET_SELECTED = typePrefix + "SET_SELECTED";
	var CLEAR_SELECTED = typePrefix + "CLEAR_SELECTED";
	
	// Selectors
	
	var getSaved = exports.getSaved = function getSaved(state) {
	  return state.articles.save;
	};
	var getSavedArticleIds = exports.getSavedArticleIds = function getSavedArticleIds(state) {
	  return state.articles.save.savedIds;
	};
	var getSavedCount = exports.getSavedCount = function getSavedCount(state) {
	  return state.articles.save.savedIds.length;
	};
	var getSelectedArticleId = exports.getSelectedArticleId = function getSelectedArticleId(state) {
	  return state.articles.save.selectedArticleId;
	};
	
	// Action creators
	
	/**
	 *
	 * @param {string} articleId the article Id to be toggled
	 * @return {function} thunk action creator
	 */
	var toggleArticle = exports.toggleArticle = function toggleArticle(articleId) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: TOGGLE_SAVED,
	      articleId: articleId
	    });
	    var serialised = JSON.stringify(getSaved(getState()));
	    _storage2.default.setItem("savedArticles", serialised);
	  };
	};
	
	/**
	 *
	 * @param {string} articleId the article Id to be toggled
	 * @return {function} thunk action creator
	 */
	var setSelectedArticleId = exports.setSelectedArticleId = function setSelectedArticleId(articleId) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: SET_SELECTED,
	      articleId: articleId
	    });
	    var serialised = JSON.stringify(getSaved(getState()));
	    _storage2.default.setItem("savedArticles", serialised);
	  };
	};
	
	var emptyState = exports.emptyState = {
	  savedIds: [],
	  selectedArticleId: null
	};
	
	/**
	 * Rehydrate the state from storage.
	 * @return {object} Previously saved auth state or an empty object
	 */
	var rehydrate = exports.rehydrate = function rehydrate() {
	  var saved = _storage2.default.getItem("savedArticles");
	  var hydrated = emptyState;
	  if (typeof saved === "string" && saved !== "undefined") {
	    try {
	      hydrated = JSON.parse(saved);
	    } catch (e) {
	      hydrated = emptyState;
	      // eslint-disable-next-line no-console
	      console.log("Could not rehydrate from storage", e);
	    }
	  }
	  // guard against unusual state coming back from storage
	  if (!(0, _objectKeysMatch2.default)(emptyState, hydrated)) return emptyState;
	  return hydrated;
	};
	
	// Reducer
	function saveReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rehydrate();
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var savedIds = state.savedIds;
	
	  switch (action.type) {
	    case TOGGLE_SAVED:
	      // remove article
	      if (savedIds.includes(action.articleId)) {
	        return _extends({}, state, {
	          savedIds: savedIds.filter(function (id) {
	            return id !== action.articleId;
	          })
	        });
	      }
	
	      // add article
	      return _extends({}, state, { savedIds: [].concat(savedIds, [action.articleId]) });
	    case CLEAR_SAVED:
	      return _extends({}, state, { savedIds: [] });
	    case SET_SELECTED:
	      return _extends({}, state, { selectedArticleId: action.articleId });
	    case CLEAR_SELECTED:
	      return _extends({}, state, { selectedArticleId: null });
	    default:
	      return state;
	  }
	}
	
	/**
	 * Clears saved article data
	 * @return {function} Thunk
	 */
	// export const unpersist = () => dispatch => {
	//   storage.removeItem("savedArticles");
	//   dispatch({ type: UNPERSIST });
	// };

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(84)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var core = __webpack_require__(34);
	var ctx = __webpack_require__(349);
	var hide = __webpack_require__(85);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 84 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(86);
	var createDesc = __webpack_require__(252);
	module.exports = __webpack_require__(82) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(127);
	var IE8_DOM_DEFINE = __webpack_require__(351);
	var toPrimitive = __webpack_require__(300);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(82) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(352);
	var defined = __webpack_require__(289);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

	var store = __webpack_require__(297)('wks');
	var uid = __webpack_require__(253);
	var Symbol = __webpack_require__(36).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ }),
/* 89 */
/***/ (function(module, exports) {

	var core = module.exports = { version: '2.5.1' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(254);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(92);
	var createDesc = __webpack_require__(310);
	module.exports = __webpack_require__(67) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(37);
	var IE8_DOM_DEFINE = __webpack_require__(362);
	var toPrimitive = __webpack_require__(374);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(67) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var hide = __webpack_require__(91);
	var has = __webpack_require__(68);
	var SRC = __webpack_require__(259)('src');
	var TO_STRING = 'toString';
	var $toString = Function[TO_STRING];
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(89).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ }),
/* 94 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(19),
	    getRawTag = __webpack_require__(838),
	    objectToString = __webpack_require__(863);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ }),
/* 96 */,
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(385),
	    baseKeys = __webpack_require__(268),
	    isArrayLike = __webpack_require__(394);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11),
	    isSymbol = __webpack_require__(15);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(887);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(63);
	
	var ReactCurrentOwner = __webpack_require__(413);
	
	var warning = __webpack_require__(261);
	var canDefineProperty = __webpack_require__(416);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(414);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ }),
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.ShareTwitter = exports.ShareLinkedIn = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__(9);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _indexModule = __webpack_require__(619);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _twitterIcon = __webpack_require__(886);
	
	var _twitterIcon2 = _interopRequireDefault(_twitterIcon);
	
	var _linkedInIcon = __webpack_require__(885);
	
	var _linkedInIcon2 = _interopRequireDefault(_linkedInIcon);
	
	var _sharingConfig = __webpack_require__(286);
	
	var _sharingConfig2 = _interopRequireDefault(_sharingConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ShareLinkedIn = exports.ShareLinkedIn = function ShareLinkedIn(_ref) {
	  var url = _ref.url,
	      sourceUrl = _ref.sourceUrl,
	      summary = _ref.summary,
	      title = _ref.title;
	
	  var queryParams = {
	    url: url,
	    sourceUrl: sourceUrl,
	    title: title,
	    summary: summary || "",
	    source: _sharingConfig2.default.linkedInSource
	  };
	  var queryString = Object.keys(queryParams).map(function (k) {
	    return encodeURIComponent(k) + "=" + encodeURIComponent(queryParams[k]);
	  }).join("&");
	
	  return _react2.default.createElement(Share, {
	    icon: _linkedInIcon2.default,
	    url: "https://www.linkedin.com/shareArticle?" + queryString
	  });
	};
	
	ShareLinkedIn.propTypes = {
	  image: _propTypes2.default.string,
	  url: _propTypes2.default.string,
	  sourceUrl: _propTypes2.default.string,
	  summary: _propTypes2.default.string,
	  title: _propTypes2.default.string
	};
	
	var ShareTwitter = exports.ShareTwitter = function ShareTwitter(_ref2) {
	  var text = _ref2.text;
	
	  var queryParams = {
	    text: text,
	    hashtags: _sharingConfig2.default.hashtags
	  };
	  var queryString = Object.keys(queryParams).map(function (k) {
	    return encodeURIComponent(k) + "=" + encodeURIComponent(queryParams[k]);
	  }).join("&");
	  return _react2.default.createElement(Share, {
	    icon: _twitterIcon2.default,
	    url: "https://twitter.com/intent/tweet?" + queryString
	  });
	};
	
	ShareTwitter.propTypes = {
	  hashtags: _propTypes2.default.string,
	  text: _propTypes2.default.string
	};
	
	var Share = function Share(_ref3) {
	  var url = _ref3.url,
	      icon = _ref3.icon;
	
	  return _react2.default.createElement(
	    "a",
	    { className: _indexModule2.default.root, href: url, target: "_blank" },
	    _react2.default.createElement(_reactSvgInline2.default, { className: _indexModule2.default.icon, svg: icon })
	  );
	};
	
	Share.defaultProps = {
	  type: "twitter"
	};
	
	Share.propTypes = {
	  url: _propTypes2.default.string,
	  icon: _propTypes2.default.string // an svg
	};
	
	exports.default = Share;

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.rehydrate = exports.clearUser = exports.setUser = exports.getUser = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.userReducer = userReducer;
	
	var _storage = __webpack_require__(249);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Actions
	var typePrefix = "user/";
	var CLEAR = typePrefix + "CLEAR";
	var SET = typePrefix + "SET";
	
	// Selectors
	
	var getUser = exports.getUser = function getUser(state) {
	  return state.user;
	};
	
	// Action creators
	
	/**
	 *
	 * @param {string} articleId the article Id to be toggled
	 * @return {function} thunk action creator
	 */
	var setUser = exports.setUser = function setUser(_ref) {
	  var email = _ref.email,
	      newsletter = _ref.newsletter,
	      termsAgreed = _ref.termsAgreed;
	  return function (dispatch, getState) {
	    dispatch({
	      type: SET,
	      email: email,
	      newsletter: newsletter,
	      termsAgreed: termsAgreed
	    });
	    var serialised = JSON.stringify(getState().user);
	    _storage2.default.setItem(typePrefix, serialised);
	  };
	};
	
	var clearUser = exports.clearUser = function clearUser() {
	  return function (dispatch) {
	    dispatch({ type: CLEAR });
	    var serialised = JSON.stringify(emptyState);
	    _storage2.default.setItem(typePrefix, serialised);
	  };
	};
	
	var emptyState = {
	  email: null,
	  newsletter: true,
	  termsAgreed: false
	};
	
	/**
	 * Rehydrate the state from storage.
	 * @return {object} Previously saved auth state or an empty object
	 */
	var rehydrate = exports.rehydrate = function rehydrate() {
	  var user = _storage2.default.getItem(typePrefix);
	  var hydrated = typeof user === "string" ? JSON.parse(user) : _extends({}, emptyState);
	  return hydrated;
	};
	
	// Reducer
	function userReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rehydrate();
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET:
	      return {
	        email: action.email,
	        newsletter: action.newsletter,
	        termsAgreed: action.termsAgreed
	      };
	    case CLEAR:
	      return _extends({}, emptyState);
	    default:
	      return state;
	  }
	}

/***/ }),
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(128);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(356);
	var enumBugKeys = __webpack_require__(290);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */
/***/ (function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ }),
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(7),
	    stubFalse = __webpack_require__(870);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(281)(module)))

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    isObject = __webpack_require__(11);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ }),
/* 207 */
/***/ (function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ }),
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(911);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(912);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(409);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(913);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(914);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(915);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(916);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(410);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(329);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(917);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(918);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(919);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(330);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(420);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(949);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(948);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(947);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(419);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(421);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _slugify = __webpack_require__(953);
	
	var _slugify2 = _interopRequireDefault(_slugify);
	
	var _indexModule = __webpack_require__(595);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _Chart = __webpack_require__(452);
	
	var _Chart2 = _interopRequireDefault(_Chart);
	
	var _Table = __webpack_require__(486);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _SelectControl = __webpack_require__(485);
	
	var _SelectControl2 = _interopRequireDefault(_SelectControl);
	
	var _FigureFooter = __webpack_require__(341);
	
	var _FigureFooter2 = _interopRequireDefault(_FigureFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Wrapper around charts and tables. Provides switching, download and sharing
	 * functionality.
	 */
	var BlockChart = function (_Component) {
	  _inherits(BlockChart, _Component);
	
	  function BlockChart(props) {
	    _classCallCheck(this, BlockChart);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    var selectedGroupId = 0;
	    if (props.groups) {
	      selectedGroupId = props.groups[0].id;
	    }
	    _this.state = { selectedGroupId: selectedGroupId };
	
	    _this.onGroupChange = _this.onGroupChange.bind(_this);
	    return _this;
	  }
	
	  // Recreate the charts config using the newly selected group
	
	
	  BlockChart.prototype.onGroupChange = function onGroupChange(event) {
	    var selectedGroupId = parseInt(event.target.value, 10);
	    this.setState({ selectedGroupId: selectedGroupId });
	  };
	
	  BlockChart.prototype.render = function render() {
	    var _props = this.props,
	        chartId = _props.chartId,
	        type = _props.type,
	        title = _props.title,
	        insight = _props.insight,
	        groups = _props.groups,
	        onDownloadClick = _props.onDownloadClick,
	        sources = _props.sources,
	        note = _props.note;
	
	    if (!groups) return _react2.default.createElement("div", { className: _indexModule2.default.root });
	    var selectedGroupId = this.state.selectedGroupId;
	    var selectedGroup = groups.find(function (group) {
	      return group.id === selectedGroupId;
	    });
	    if (!selectedGroup) {
	      selectedGroup = groups[0];
	    }
	    var isTable = type === "table";
	    var Figure = isTable ? _Table2.default : _Chart2.default;
	    var slug = title ? (0, _slugify2.default)(title) : "";
	
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.root },
	      insight && _react2.default.createElement(
	        "h1",
	        { className: _indexModule2.default.insight },
	        insight
	      ),
	      title && _react2.default.createElement(
	        "h2",
	        { id: slug, className: _indexModule2.default.title },
	        title
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.select },
	        groups.length > 1 && _react2.default.createElement(_SelectControl2.default, {
	          values: groups,
	          selectedId: selectedGroupId,
	          onChange: this.onGroupChange
	        })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.figure },
	        _react2.default.createElement(
	          Figure,
	          _extends({}, this.props, { groups: null, group: selectedGroup }),
	          _react2.default.createElement(_FigureFooter2.default, {
	            onDownloadClick: onDownloadClick ? function () {
	              return onDownloadClick(chartId, selectedGroup.id);
	            } : null,
	            sources: sources,
	            note: note,
	            chartId: chartId,
	            groupId: selectedGroup.id,
	            title: title,
	            slug: slug
	          })
	        )
	      )
	    );
	  };
	
	  return BlockChart;
	}(_react.Component);
	
	BlockChart.defaultProps = {
	  groups: []
	};
	
	BlockChart.propTypes = {
	  title: _propTypes2.default.string,
	  insight: _propTypes2.default.string,
	  type: _propTypes2.default.oneOf(["column", "bar", "line", "pie", "column_line", "table"]),
	  onDownloadClick: _propTypes2.default.func,
	  chartId: _propTypes2.default.number,
	  sources: _propTypes2.default.string,
	  note: _propTypes2.default.string,
	  // Highcharts data
	  groups: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    categories: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    name: _propTypes2.default.string,
	    series: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      name: _propTypes2.default.string,
	      data: _propTypes2.default.array // numbers or objects
	    }))
	  }))
	};
	
	exports.default = BlockChart;
	module.exports = exports["default"];

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(596);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _FigureFooter = __webpack_require__(341);
	
	var _FigureFooter2 = _interopRequireDefault(_FigureFooter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var BlockChartImage = function BlockChartImage(_ref) {
	  var insight = _ref.insight,
	      title = _ref.title,
	      image = _ref.image,
	      sources = _ref.sources,
	      note = _ref.note,
	      svg = _ref.svg;
	
	  var src = svg && svg.indexOf(".svg") > -1 ? svg : image;
	  return _react2.default.createElement(
	    "div",
	    { className: _indexModule2.default.root },
	    insight && _react2.default.createElement(
	      "h1",
	      { className: _indexModule2.default.insight },
	      insight
	    ),
	    title && _react2.default.createElement(
	      "h2",
	      { className: _indexModule2.default.title },
	      title
	    ),
	    _react2.default.createElement("img", { className: _indexModule2.default.image, alt: title, src: src }),
	    _react2.default.createElement(_FigureFooter2.default, { sources: sources, note: note })
	  );
	};
	
	BlockChartImage.propTypes = {
	  title: _propTypes2.default.string,
	  insight: _propTypes2.default.string,
	  sources: _propTypes2.default.string,
	  note: _propTypes2.default.string,
	  image: _propTypes2.default.string,
	  svg: _propTypes2.default.string
	};
	
	exports.default = BlockChartImage;
	module.exports = exports["default"];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _reactRedux = __webpack_require__(6);
	
	var _Save = __webpack_require__(343);
	
	var _Save2 = _interopRequireDefault(_Save);
	
	var _save = __webpack_require__(81);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isActive = function isActive(currentId, articleIds) {
	  if (!articleIds) return false;
	  return articleIds.filter(function (id) {
	    return id === currentId;
	  }).length > 0;
	};
	
	var withRedux = (0, _reactRedux.connect)(function (state, props) {
	  return {
	    active: isActive(props.articleId, (0, _save.getSavedArticleIds)(state))
	  };
	}, function (dispatch, props) {
	  return {
	    onClick: function onClick(e) {
	      e.stopPropagation();
	      e.preventDefault();
	      dispatch((0, _save.toggleArticle)(props.articleId));
	    }
	  };
	});
	
	exports.default = withRedux(_Save2.default);
	module.exports = exports["default"];

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.setArticleIds = exports.setSelectedId = exports.setFiltered = exports.getSelectedId = exports.getFilterArticles = exports.getFilterTags = exports.getFilterState = exports.rehydrate = exports.emptyState = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.filterReducer = filterReducer;
	
	var _storage = __webpack_require__(249);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _objectKeysMatch = __webpack_require__(346);
	
	var _objectKeysMatch2 = _interopRequireDefault(_objectKeysMatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyState = exports.emptyState = {
	  tagIds: [],
	  currentArticleId: null,
	  articleIds: []
	};
	
	var typePrefix = "articles/filter/";
	var SET_FILTERED = typePrefix + "SET_FILTERED";
	var CLEAR_FILTERED = typePrefix + "CLEAR_FILTERED";
	var SET_SELECTED = typePrefix + "SET_SELECTED";
	var CLEAR_SELECTED = typePrefix + "CLEAR_SELECTED";
	var SET_ARTICLES = typePrefix + "SET_ARTICLES";
	var storageName = typePrefix.replace("/", "");
	
	// Helpers
	
	/**
	 * Rehydrate the state from storage.
	 * @return {object} Previously saved state or default state
	 */
	var rehydrate = exports.rehydrate = function rehydrate() {
	  var saved = _storage2.default.getItem(storageName);
	  var hydrated = emptyState;
	  if (typeof saved === "string" && saved !== "undefined") {
	    try {
	      hydrated = JSON.parse(saved);
	    } catch (e) {
	      hydrated = emptyState;
	      // eslint-disable-next-line no-console
	      console.log("Could not rehydrate from storage", e);
	    }
	  }
	  // guard against unusual state coming back from storage
	  if (!(0, _objectKeysMatch2.default)(emptyState, hydrated)) return emptyState;
	  return hydrated;
	};
	
	// Selectors
	
	var getFilterState = exports.getFilterState = function getFilterState(state) {
	  return state.articles.filter;
	};
	var getFilterTags = exports.getFilterTags = function getFilterTags(state) {
	  return state.articles.filter.tagIds;
	};
	var getFilterArticles = exports.getFilterArticles = function getFilterArticles(state) {
	  return state.articles.filter.articleIds;
	};
	var getSelectedId = exports.getSelectedId = function getSelectedId(state) {
	  return state.articles.filter.currentArticleId;
	};
	
	// Action creators
	
	/**
	 *
	 * @param {string} tagIds the ids of tags to filter on
	 * @return {function} thunk action creator
	 */
	var setFiltered = exports.setFiltered = function setFiltered(tagIds) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: SET_FILTERED,
	      tagIds: tagIds
	    });
	    var serialised = JSON.stringify(getFilterState(getState()));
	    _storage2.default.setItem(storageName, serialised);
	  };
	};
	
	/**
	 *
	 * @param {string} articleId the article Id to be marked as selected
	 * @return {function} thunk action creator
	 */
	var setSelectedId = exports.setSelectedId = function setSelectedId(articleId) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: SET_SELECTED,
	      articleId: articleId
	    });
	    var serialised = JSON.stringify(getFilterState(getState()));
	    _storage2.default.setItem(storageName, serialised);
	  };
	};
	
	/**
	 *
	 * @param {string} articleId the article Id to be marked as selected
	 * @return {function} thunk action creator
	 */
	var setArticleIds = exports.setArticleIds = function setArticleIds(articleIds) {
	  return function (dispatch, getState) {
	    dispatch({
	      type: SET_ARTICLES,
	      articleIds: articleIds
	    });
	    var serialised = JSON.stringify(getFilterArticles(getState()));
	    _storage2.default.setItem(storageName, serialised);
	  };
	};
	
	// Reducer
	
	function filterReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : rehydrate();
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET_FILTERED:
	      return _extends({}, state, { tagIds: action.tagIds });
	    case CLEAR_FILTERED:
	      return _extends({}, state, { tagIds: [] });
	    case SET_SELECTED:
	      return _extends({}, state, { currentArticleId: action.articleId });
	    case CLEAR_SELECTED:
	      return _extends({}, state, { currentArticleId: null });
	    case SET_ARTICLES:
	      return _extends({}, state, { articleIds: action.articleIds });
	    default:
	      return state;
	  }
	}

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.downloadChart = exports.prepChartDownload = exports.requestChartDownload = undefined;
	
	var _user = __webpack_require__(125);
	
	var _chart = __webpack_require__(285);
	
	var _modal = __webpack_require__(20);
	
	var _analytics = __webpack_require__(345);
	
	var _analytics2 = _interopRequireDefault(_analytics);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Request chart download - check for user details. If available then skip
	 * straight to triggering the chart download. If _not_ available, show the
	 * standard user request details.
	 **/
	// eslint-disable-next-line no-unused-vars
	// eslint-disable-line no-unused-vars
	/**
	 * This file responsible for the download chart flow. The first time a user
	 * requests to download a chart, they will be asked for their email address
	 * and to agree to the terms and conditions.
	 *
	 * The flow is roughly like this:
	 *
	 * - Click 'download chart button'
	 * - Do we have state.user?
	 *    - No, trigger request user details modal flow
	 *    - Yes, go to next step
	 * - Trigger file download
	 */
	var requestChartDownload = exports.requestChartDownload = function requestChartDownload(_ref) {
	  var chartId = _ref.chartId,
	      groupId = _ref.groupId;
	  return function (dispatch, getState) {
	    var state = getState();
	    var user = (0, _user.getUser)(state);
	
	    // set chart
	    dispatch((0, _chart.setChart)({ chartId: chartId, groupId: groupId }));
	
	    // get user details
	    var hasUser = typeof user.email === "string" && user.email.length > 1 && user.termsAgreed === true;
	
	    if (hasUser) {
	      // if user details, dispatch immediate download
	      dispatch(downloadChart());
	    } else {
	      // if no user details, dispatch download modal flow
	      var modal = { modalType: _modal.modals.DOWNLOAD_CHART };
	      dispatch((0, _modal.showModal)(modal));
	    }
	  };
	};
	
	// eslint-disable-next-line no-unused-vars
	var prepChartDownload = exports.prepChartDownload = function prepChartDownload() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var user = (0, _user.getUser)(state);
	
	    (0, _modal.mailchimpRequest)(user.email, user.newsletter).then(function () {
	      dispatch((0, _modal.showModal)({
	        modalType: _modal.modals.DOWNLOAD_SUCCESS,
	        modalProps: {
	          text: "Your download will start in a few moments. Check your browser's download folder."
	        }
	      }));
	      dispatch(downloadChart());
	    });
	  };
	};
	
	/**
	 * Trigger the download of the current chart
	 */
	var downloadChart = exports.downloadChart = function downloadChart() {
	  return function (dispatch, getState) {
	    var state = getState();
	    var chartDetails = (0, _chart.getChart)(state);
	    var filePrefix = "chart/state-of-european-tech-2017-";
	    var fileSuffix = chartDetails.chartId + "-" + chartDetails.groupId;
	    var filename = "" + filePrefix + fileSuffix + ".jpg";
	    var chart = window.location.origin + "/" + filename;
	    (0, _analytics2.default)("send", "event", "download", "downloadChart", {
	      chart: chart
	    });
	    // Create a temporary element and click it to download the image.
	    // These images do not have the "Content-Disposition: attachment" header.
	    // So we do this to try and force the image to download, instead of display
	    // in the browser
	    var element = document.createElement("a");
	    element.setAttribute("href", chart);
	    element.setAttribute("download", filename);
	    element.style.display = "none";
	
	    // if download attribute not supported, just open in a new browser window
	    if (!element.hasAttribute("download")) element.target = "_blank";
	
	    // Attach, click, remove:
	    document.body.appendChild(element);
	    element.click();
	    document.body.removeChild(element);
	  };
	};

/***/ }),
/* 249 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Feature test for sessionStorage and localStorage browser apis. If they are
	 * present use the real modules, otherwise use noop mocks instead.
	 */
	
	var storageAvailable = function storageAvailable(type) {
	  try {
	    var _storage = window[type];
	    var x = "__storage_test__";
	    _storage.setItem(x, x);
	    _storage.removeItem(x);
	    return true;
	  } catch (e) {
	    return false;
	  }
	};
	
	var noop = function noop() {
	  return null;
	};
	
	var noopStorage = {
	  getItem: noop,
	  removeItem: noop,
	  setItem: noop
	};
	
	var sessionStorage = storageAvailable("sessionStorage") ? window.sessionStorage : noopStorage;
	
	var localStorage = storageAvailable("localStorage") ? window.localStorage : noopStorage;
	
	var storage = {
	  getItem: function getItem(keyName) {
	    return sessionStorage.getItem(keyName) || localStorage.getItem(keyName);
	  },
	  removeItem: function removeItem(keyName) {
	    localStorage.removeItem(keyName);
	    sessionStorage.removeItem(keyName);
	  },
	  setItem: function setItem(keyName, keyValue) {
	    localStorage.setItem(keyName, keyValue);
	    sessionStorage.setItem(keyName, keyValue);
	  }
	};
	
	exports.default = storage;
	module.exports = exports["default"];

/***/ }),
/* 250 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ }),
/* 251 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 252 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 253 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 254 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 255 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 256 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(92).f;
	var has = __webpack_require__(68);
	var TAG = __webpack_require__(14)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(558);
	var defined = __webpack_require__(305);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ }),
/* 259 */
/***/ (function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(69);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(950);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(957);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(94);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(850),
	    listCacheDelete = __webpack_require__(851),
	    listCacheGet = __webpack_require__(852),
	    listCacheHas = __webpack_require__(853),
	    listCacheSet = __webpack_require__(854);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(7);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(74),
	    root = __webpack_require__(7);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(198);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(269),
	    keys = __webpack_require__(97);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(325),
	    nativeKeys = __webpack_require__(860);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(387),
	    baseAssignValue = __webpack_require__(388);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(74);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(389),
	    getSymbols = __webpack_require__(324),
	    keys = __webpack_require__(97);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(848);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(813),
	    Map = __webpack_require__(321),
	    Promise = __webpack_require__(815),
	    Set = __webpack_require__(816),
	    WeakMap = __webpack_require__(265),
	    baseGetTag = __webpack_require__(95),
	    toSource = __webpack_require__(393);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ }),
/* 274 */
/***/ (function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(74);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ }),
/* 276 */
/***/ (function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(823),
	    baseUnary = __webpack_require__(826),
	    nodeUtil = __webpack_require__(862);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ }),
/* 278 */
/***/ (function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;(function(root, factory) {
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	            return factory(root);
	        }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof module === "object" && module.exports) {
	        module.exports = factory(root);
	    } else {
	        root.lottie = factory(root);
	        root.bodymovin = root.lottie;
	    }
	}((window || {}), function(window) {
	    var svgNS = "http://www.w3.org/2000/svg";
	
	var locationHref = '';
	
	var subframeEnabled = true;
	var expressionsPlugin;
	var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
	var cachedColors = {};
	var bm_rounder = Math.round;
	var bm_rnd;
	var bm_pow = Math.pow;
	var bm_sqrt = Math.sqrt;
	var bm_abs = Math.abs;
	var bm_floor = Math.floor;
	var bm_max = Math.max;
	var bm_min = Math.min;
	var blitter = 10;
	
	var BMMath = {};
	(function(){
	    var propertyNames = Object.getOwnPropertyNames(Math);
	    var i, len = propertyNames.length;
	    for(i=0;i<len;i+=1){
	        BMMath[propertyNames[i]] = Math[propertyNames[i]];
	    }
	}());
	
	function ProjectInterface(){return {}};
	
	BMMath.random = Math.random;
	BMMath.abs = function(val){
	    var tOfVal = typeof val;
	    if(tOfVal === 'object' && val.length){
	        var absArr = Array.apply(null,{length:val.length});
	        var i, len = val.length;
	        for(i=0;i<len;i+=1){
	            absArr[i] = Math.abs(val[i]);
	        }
	        return absArr;
	    }
	    return Math.abs(val);
	
	}
	var defaultCurveSegments = 150;
	var degToRads = Math.PI/180;
	var roundCorner = 0.5519;
	
	function roundValues(flag){
	    if(flag){
	        bm_rnd = Math.round;
	    }else{
	        bm_rnd = function(val){
	            return val;
	        };
	    }
	}
	roundValues(false);
	
	function styleDiv(element){
	    element.style.position = 'absolute';
	    element.style.top = 0;
	    element.style.left = 0;
	    element.style.display = 'block';
	    element.style.transformOrigin = element.style.webkitTransformOrigin = '0 0';
	    element.style.backfaceVisibility  = element.style.webkitBackfaceVisibility = 'visible';
	    element.style.transformStyle = element.style.webkitTransformStyle = element.style.mozTransformStyle = "preserve-3d";
	}
	
	function styleUnselectableDiv(element){
	    element.style.userSelect = 'none';
	    element.style.MozUserSelect = 'none';
	    element.style.webkitUserSelect = 'none';
	    element.style.oUserSelect = 'none';
	
	}
	
	function BMEnterFrameEvent(n,c,t,d){
	    this.type = n;
	    this.currentTime = c;
	    this.totalTime = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteEvent(n,d){
	    this.type = n;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMCompleteLoopEvent(n,c,t,d){
	    this.type = n;
	    this.currentLoop = c;
	    this.totalLoops = t;
	    this.direction = d < 0 ? -1:1;
	}
	
	function BMSegmentStartEvent(n,f,t){
	    this.type = n;
	    this.firstFrame = f;
	    this.totalFrames = t;
	}
	
	function BMDestroyEvent(n,t){
	    this.type = n;
	    this.target = t;
	}
	
	function _addEventListener(eventName, callback){
	
	    if (!this._cbs[eventName]){
	        this._cbs[eventName] = [];
	    }
	    this._cbs[eventName].push(callback);
	
		return function() {
			this.removeEventListener(eventName, callback);
		}.bind(this);
	}
	
	function _removeEventListener(eventName,callback){
	
	    if (!callback){
	        this._cbs[eventName] = null;
	    }else if(this._cbs[eventName]){
	        var i = 0, len = this._cbs[eventName].length;
	        while(i<len){
	            if(this._cbs[eventName][i] === callback){
	                this._cbs[eventName].splice(i,1);
	                i -=1;
	                len -= 1;
	            }
	            i += 1;
	        }
	        if(!this._cbs[eventName].length){
	            this._cbs[eventName] = null;
	        }
	    }
	
	}
	
	function _triggerEvent(eventName, args){
	    if (this._cbs[eventName]) {
	        var len = this._cbs[eventName].length;
	        for (var i = 0; i < len; i++){
	            this._cbs[eventName][i](args);
	        }
	    }
	}
	
	function randomString(length, chars){
	    if(chars === undefined){
	        chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890';
	    }
	    var i;
	    var result = '';
	    for (i = length; i > 0; --i) result += chars[Math.round(Math.random() * (chars.length - 1))];
	    return result;
	}
	
	function HSVtoRGB(h, s, v) {
	    var r, g, b, i, f, p, q, t;
	    if (arguments.length === 1) {
	        s = h.s, v = h.v, h = h.h;
	    }
	    i = Math.floor(h * 6);
	    f = h * 6 - i;
	    p = v * (1 - s);
	    q = v * (1 - f * s);
	    t = v * (1 - (1 - f) * s);
	    switch (i % 6) {
	        case 0: r = v, g = t, b = p; break;
	        case 1: r = q, g = v, b = p; break;
	        case 2: r = p, g = v, b = t; break;
	        case 3: r = p, g = q, b = v; break;
	        case 4: r = t, g = p, b = v; break;
	        case 5: r = v, g = p, b = q; break;
	    }
	    return [ r,
	        g,
	         b ];
	}
	
	function RGBtoHSV(r, g, b) {
	    if (arguments.length === 1) {
	        g = r.g, b = r.b, r = r.r;
	    }
	    var max = Math.max(r, g, b), min = Math.min(r, g, b),
	        d = max - min,
	        h,
	        s = (max === 0 ? 0 : d / max),
	        v = max / 255;
	
	    switch (max) {
	        case min: h = 0; break;
	        case r: h = (g - b) + d * (g < b ? 6: 0); h /= 6 * d; break;
	        case g: h = (b - r) + d * 2; h /= 6 * d; break;
	        case b: h = (r - g) + d * 4; h /= 6 * d; break;
	    }
	
	    return [
	         h,
	         s,
	         v
	    ];
	}
	
	function addSaturationToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[1] += offset;
	    if (hsv[1] > 1) {
	        hsv[1] = 1;
	    }
	    else if (hsv[1] <= 0) {
	        hsv[1] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addBrightnessToRGB(color,offset){
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[2] += offset;
	    if (hsv[2] > 1) {
	        hsv[2] = 1;
	    }
	    else if (hsv[2] < 0) {
	        hsv[2] = 0;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	function addHueToRGB(color,offset) {
	    var hsv = RGBtoHSV(color[0]*255,color[1]*255,color[2]*255);
	    hsv[0] += offset/360;
	    if (hsv[0] > 1) {
	        hsv[0] -= 1;
	    }
	    else if (hsv[0] < 0) {
	        hsv[0] += 1;
	    }
	    return HSVtoRGB(hsv[0],hsv[1],hsv[2]);
	}
	
	var rgbToHex = (function(){
	    var colorMap = [];
	    var i;
	    var hex;
	    for(i=0;i<256;i+=1){
	        hex = i.toString(16);
	        colorMap[i] = hex.length == 1 ? '0' + hex : hex;
	    }
	
	    return function(r, g, b) {
	        if(r<0){
	            r = 0;
	        }
	        if(g<0){
	            g = 0;
	        }
	        if(b<0){
	            b = 0;
	        }
	        return '#' + colorMap[r] + colorMap[g] + colorMap[b];
	    };
	}());
	var createTypedArray = (function(){
		function createRegularArray(type, len){
			var i = 0, arr = [], value;
			switch(type) {
				case 'int16':
				case 'uint8c':
					value = 1;
					break;
				default:
					value = 1.1;
					break;
			}
			for(i = 0; i < len; i += 1) {
				arr.push(value);
			}
			return arr;
		}
		function createTypedArray(type, len){
			if(type === 'float32') {
				return new Float32Array(len);
			} else if(type === 'int16') {
				return new Int16Array(len);
			} else if(type === 'uint8c') {
				return new Uint8ClampedArray(len);
			}
		}
		if(typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
			return createTypedArray
		} else {
			return createRegularArray
		}
	}())
	function createNS(type) {
		return document.createElementNS(svgNS, type);
	}
	/*!
	 Transformation Matrix v2.0
	 (c) Epistemex 2014-2015
	 www.epistemex.com
	 By Ken Fyrstenberg
	 Contributions by leeoniya.
	 License: MIT, header required.
	 */
	
	/**
	 * 2D transformation matrix object initialized with identity matrix.
	 *
	 * The matrix can synchronize a canvas context by supplying the context
	 * as an argument, or later apply current absolute transform to an
	 * existing context.
	 *
	 * All values are handled as floating point values.
	 *
	 * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
	 * @prop {number} a - scale x
	 * @prop {number} b - shear y
	 * @prop {number} c - shear x
	 * @prop {number} d - scale y
	 * @prop {number} e - translate x
	 * @prop {number} f - translate y
	 * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
	 * @constructor
	 */
	
	var Matrix = (function(){
	
	    var _cos = Math.cos;
	    var _sin = Math.sin;
	    var _tan = Math.tan;
	    var _rnd = Math.round;
	
	    function reset(){
	        this.props[0] = 1;
	        this.props[1] = 0;
	        this.props[2] = 0;
	        this.props[3] = 0;
	        this.props[4] = 0;
	        this.props[5] = 1;
	        this.props[6] = 0;
	        this.props[7] = 0;
	        this.props[8] = 0;
	        this.props[9] = 0;
	        this.props[10] = 1;
	        this.props[11] = 0;
	        this.props[12] = 0;
	        this.props[13] = 0;
	        this.props[14] = 0;
	        this.props[15] = 1;
	        return this;
	    }
	
	    function rotate(angle) {
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateX(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(1, 0, 0, 0
	            , 0, mCos, -mSin, 0
	            , 0, mSin,  mCos, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateY(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos,  0,  mSin, 0
	            , 0, 1, 0, 0
	            , -mSin,  0,  mCos, 0
	            , 0, 0, 0, 1);
	    }
	
	    function rotateZ(angle){
	        if(angle === 0){
	            return this;
	        }
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	    }
	
	    function shear(sx,sy){
	        return this._t(1, sy, sx, 1, 0, 0);
	    }
	
	    function skew(ax, ay){
	        return this.shear(_tan(ax), _tan(ay));
	    }
	
	    function skewFromAxis(ax, angle){
	        var mCos = _cos(angle);
	        var mSin = _sin(angle);
	        return this._t(mCos, mSin,  0, 0
	            , -mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1)
	            ._t(1, 0,  0, 0
	            , _tan(ax),  1, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1)
	            ._t(mCos, -mSin,  0, 0
	            , mSin,  mCos, 0, 0
	            , 0,  0,  1, 0
	            , 0, 0, 0, 1);
	        //return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
	    }
	
	    function scale(sx, sy, sz) {
	        sz = isNaN(sz) ? 1 : sz;
	        if(sx == 1 && sy == 1 && sz == 1){
	            return this;
	        }
	        return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
	    }
	
	    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
	        this.props[0] = a;
	        this.props[1] = b;
	        this.props[2] = c;
	        this.props[3] = d;
	        this.props[4] = e;
	        this.props[5] = f;
	        this.props[6] = g;
	        this.props[7] = h;
	        this.props[8] = i;
	        this.props[9] = j;
	        this.props[10] = k;
	        this.props[11] = l;
	        this.props[12] = m;
	        this.props[13] = n;
	        this.props[14] = o;
	        this.props[15] = p;
	        return this;
	    }
	
	    function translate(tx, ty, tz) {
	        tz = tz || 0;
	        if(tx !== 0 || ty !== 0 || tz !== 0){
	            return this._t(1,0,0,0,0,1,0,0,0,0,1,0,tx,ty,tz,1);
	        }
	        return this;
	    }
	
	    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
	
	        if(a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0){
	            if(m2 !== 0 || n2 !== 0 || o2 !== 0){
	
	                this.props[12] = this.props[12] * a2 + this.props[13] * e2 + this.props[14] * i2 + this.props[15] * m2 ;
	                this.props[13] = this.props[12] * b2 + this.props[13] * f2 + this.props[14] * j2 + this.props[15] * n2 ;
	                this.props[14] = this.props[12] * c2 + this.props[13] * g2 + this.props[14] * k2 + this.props[15] * o2 ;
	                this.props[15] = this.props[12] * d2 + this.props[13] * h2 + this.props[14] * l2 + this.props[15] * p2 ;
	            }
	            this._identityCalculated = false;
	            return this;
	        }
	
	        var a1 = this.props[0];
	        var b1 = this.props[1];
	        var c1 = this.props[2];
	        var d1 = this.props[3];
	        var e1 = this.props[4];
	        var f1 = this.props[5];
	        var g1 = this.props[6];
	        var h1 = this.props[7];
	        var i1 = this.props[8];
	        var j1 = this.props[9];
	        var k1 = this.props[10];
	        var l1 = this.props[11];
	        var m1 = this.props[12];
	        var n1 = this.props[13];
	        var o1 = this.props[14];
	        var p1 = this.props[15];
	
	        /* matrix order (canvas compatible):
	         * ace
	         * bdf
	         * 001
	         */
	        this.props[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
	        this.props[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2 ;
	        this.props[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2 ;
	        this.props[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2 ;
	
	        this.props[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2 ;
	        this.props[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2 ;
	        this.props[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2 ;
	        this.props[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2 ;
	
	        this.props[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2 ;
	        this.props[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2 ;
	        this.props[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2 ;
	        this.props[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2 ;
	
	        this.props[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2 ;
	        this.props[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2 ;
	        this.props[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2 ;
	        this.props[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2 ;
	
	        this._identityCalculated = false;
	        return this;
	    }
	
	    function isIdentity() {
	        if(!this._identityCalculated){
	            this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0
	                || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0
	                || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0
	                || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
	            this._identityCalculated = true;
	        }
	        return this._identity;
	    }
	
	    function clone(matr){
	        var i;
	        for(i=0;i<16;i+=1){
	            matr.props[i] = this.props[i];
	        }
	    }
	
	    function cloneFromProps(props){
	        var i;
	        for(i=0;i<16;i+=1){
	            this.props[i] = props[i];
	        }
	    }
	
	    function applyToPoint(x, y, z) {
	
	        return {
	            x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
	            y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
	            z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
	        };
	        /*return {
	         x: x * me.a + y * me.c + me.e,
	         y: x * me.b + y * me.d + me.f
	         };*/
	    }
	    function applyToX(x, y, z) {
	        return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
	    }
	    function applyToY(x, y, z) {
	        return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
	    }
	    function applyToZ(x, y, z) {
	        return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
	    }
	
	    function inversePoint(pt) {
	        var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
	        var a = this.props[5]/determinant;
	        var b = - this.props[1]/determinant;
	        var c = - this.props[4]/determinant;
	        var d = this.props[0]/determinant;
	        var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12])/determinant;
	        var f = - (this.props[0] * this.props[13] - this.props[1] * this.props[12])/determinant;
	        return [pt[0] * a + pt[1] * c + e, pt[0] * b + pt[1] * d + f, 0];
	    }
	
	    function inversePoints(pts){
	        var i, len = pts.length, retPts = [];
	        for(i=0;i<len;i+=1){
	            retPts[i] = inversePoint(pts[i]);
	        }
	        return retPts;
	    }
	
	    function applyToPointArray(x,y,z,dimensions){
	        if(dimensions && dimensions === 2) {
	            var arr = point_pool.newPoint();
	            arr[0] = x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12]; 
	            arr[1] = x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13]; 
	            return arr;    
	        }
	        return [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
	    }
	    function applyToPointStringified(x, y) {
	        if(this.isIdentity()) {
	            return x + ',' + y;
	        }
	        return (bm_rnd(x * this.props[0] + y * this.props[4] + this.props[12]))+','+(bm_rnd(x * this.props[1] + y * this.props[5] + this.props[13]));
	    }
	
	    function toCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            return '';
	        }*/
	        var i = 0;
	        var props = this.props;
	        var cssValue = 'matrix3d(';
	        var v = 10000;
	        while(i<16){
	            cssValue += _rnd(props[i]*v)/v
	            cssValue += i === 15 ? ')':',';
	            i += 1;
	        }
	        return cssValue;
	    }
	
	    function to2dCSS() {
	        //Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.
	        /*if(this.isIdentity()) {
	            console.log(new Error().stack)
	            return '';
	        }*/
	        var v = 10000;
	        var props = this.props;
	        return "matrix(" + _rnd(props[0]*v)/v + ',' + _rnd(props[1]*v)/v + ',' + _rnd(props[4]*v)/v + ',' + _rnd(props[5]*v)/v + ',' + _rnd(props[12]*v)/v + ',' + _rnd(props[13]*v)/v + ")";
	    }
	
	    return function(){
	        this.reset = reset;
	        this.rotate = rotate;
	        this.rotateX = rotateX;
	        this.rotateY = rotateY;
	        this.rotateZ = rotateZ;
	        this.skew = skew;
	        this.skewFromAxis = skewFromAxis;
	        this.shear = shear;
	        this.scale = scale;
	        this.setTransform = setTransform;
	        this.translate = translate;
	        this.transform = transform;
	        this.applyToPoint = applyToPoint;
	        this.applyToX = applyToX;
	        this.applyToY = applyToY;
	        this.applyToZ = applyToZ;
	        this.applyToPointArray = applyToPointArray;
	        this.applyToPointStringified = applyToPointStringified;
	        this.toCSS = toCSS;
	        this.to2dCSS = to2dCSS;
	        this.clone = clone;
	        this.cloneFromProps = cloneFromProps;
	        this.inversePoints = inversePoints;
	        this.inversePoint = inversePoint;
	        this._t = this.transform;
	        this.isIdentity = isIdentity;
	        this._identity = true;
	        this._identityCalculated = false;
	
	        this.props = createTypedArray('float32', 16);
	        this.reset();
	    }
	}());
	
	/*
	 Copyright 2014 David Bau.
	
	 Permission is hereby granted, free of charge, to any person obtaining
	 a copy of this software and associated documentation files (the
	 "Software"), to deal in the Software without restriction, including
	 without limitation the rights to use, copy, modify, merge, publish,
	 distribute, sublicense, and/or sell copies of the Software, and to
	 permit persons to whom the Software is furnished to do so, subject to
	 the following conditions:
	
	 The above copyright notice and this permission notice shall be
	 included in all copies or substantial portions of the Software.
	
	 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
	 EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	 */
	
	(function (pool, math) {
	//
	// The following constants are related to IEEE 754 limits.
	//
	    var global = this,
	        width = 256,        // each RC4 output is 0 <= x < 256
	        chunks = 6,         // at least six RC4 outputs for each double
	        digits = 52,        // there are 52 significant digits in a double
	        rngname = 'random', // rngname: name for Math.random and Math.seedrandom
	        startdenom = math.pow(width, chunks),
	        significance = math.pow(2, digits),
	        overflow = significance * 2,
	        mask = width - 1,
	        nodecrypto;         // node.js crypto module, initialized at the bottom.
	
	//
	// seedrandom()
	// This is the seedrandom function described above.
	//
	    function seedrandom(seed, options, callback) {
	        var key = [];
	        options = (options == true) ? { entropy: true } : (options || {});
	
	        // Flatten the seed string or build one from local entropy if needed.
	        var shortseed = mixkey(flatten(
	            options.entropy ? [seed, tostring(pool)] :
	                (seed == null) ? autoseed() : seed, 3), key);
	
	        // Use the seed to initialize an ARC4 generator.
	        var arc4 = new ARC4(key);
	
	        // This function returns a random double in [0, 1) that contains
	        // randomness in every bit of the mantissa of the IEEE 754 value.
	        var prng = function() {
	            var n = arc4.g(chunks),             // Start with a numerator n < 2 ^ 48
	                d = startdenom,                 //   and denominator d = 2 ^ 48.
	                x = 0;                          //   and no 'extra last byte'.
	            while (n < significance) {          // Fill up all significant digits by
	                n = (n + x) * width;              //   shifting numerator and
	                d *= width;                       //   denominator and generating a
	                x = arc4.g(1);                    //   new least-significant-byte.
	            }
	            while (n >= overflow) {             // To avoid rounding up, before adding
	                n /= 2;                           //   last byte, shift everything
	                d /= 2;                           //   right using integer math until
	                x >>>= 1;                         //   we have exactly the desired bits.
	            }
	            return (n + x) / d;                 // Form the number within [0, 1).
	        };
	
	        prng.int32 = function() { return arc4.g(4) | 0; }
	        prng.quick = function() { return arc4.g(4) / 0x100000000; }
	        prng.double = prng;
	
	        // Mix the randomness into accumulated entropy.
	        mixkey(tostring(arc4.S), pool);
	
	        // Calling convention: what to return as a function of prng, seed, is_math.
	        return (options.pass || callback ||
	        function(prng, seed, is_math_call, state) {
	            if (state) {
	                // Load the arc4 state from the given state if it has an S array.
	                if (state.S) { copy(state, arc4); }
	                // Only provide the .state method if requested via options.state.
	                prng.state = function() { return copy(arc4, {}); }
	            }
	
	            // If called as a method of Math (Math.seedrandom()), mutate
	            // Math.random because that is how seedrandom.js has worked since v1.0.
	            if (is_math_call) { math[rngname] = prng; return seed; }
	
	            // Otherwise, it is a newer calling convention, so return the
	            // prng directly.
	            else return prng;
	        })(
	            prng,
	            shortseed,
	            'global' in options ? options.global : (this == math),
	            options.state);
	    }
	    math['seed' + rngname] = seedrandom;
	
	//
	// ARC4
	//
	// An ARC4 implementation.  The constructor takes a key in the form of
	// an array of at most (width) integers that should be 0 <= x < (width).
	//
	// The g(count) method returns a pseudorandom integer that concatenates
	// the next (count) outputs from ARC4.  Its return value is a number x
	// that is in the range 0 <= x < (width ^ count).
	//
	    function ARC4(key) {
	        var t, keylen = key.length,
	            me = this, i = 0, j = me.i = me.j = 0, s = me.S = [];
	
	        // The empty key [] is treated as [0].
	        if (!keylen) { key = [keylen++]; }
	
	        // Set up S using the standard key scheduling algorithm.
	        while (i < width) {
	            s[i] = i++;
	        }
	        for (i = 0; i < width; i++) {
	            s[i] = s[j = mask & (j + key[i % keylen] + (t = s[i]))];
	            s[j] = t;
	        }
	
	        // The "g" method returns the next (count) outputs as one number.
	        (me.g = function(count) {
	            // Using instance members instead of closure state nearly doubles speed.
	            var t, r = 0,
	                i = me.i, j = me.j, s = me.S;
	            while (count--) {
	                t = s[i = mask & (i + 1)];
	                r = r * width + s[mask & ((s[i] = s[j = mask & (j + t)]) + (s[j] = t))];
	            }
	            me.i = i; me.j = j;
	            return r;
	            // For robust unpredictability, the function call below automatically
	            // discards an initial batch of values.  This is called RC4-drop[256].
	            // See http://google.com/search?q=rsa+fluhrer+response&btnI
	        })(width);
	    }
	
	//
	// copy()
	// Copies internal state of ARC4 to or from a plain object.
	//
	    function copy(f, t) {
	        t.i = f.i;
	        t.j = f.j;
	        t.S = f.S.slice();
	        return t;
	    };
	
	//
	// flatten()
	// Converts an object tree to nested arrays of strings.
	//
	    function flatten(obj, depth) {
	        var result = [], typ = (typeof obj), prop;
	        if (depth && typ == 'object') {
	            for (prop in obj) {
	                try { result.push(flatten(obj[prop], depth - 1)); } catch (e) {}
	            }
	        }
	        return (result.length ? result : typ == 'string' ? obj : obj + '\0');
	    }
	
	//
	// mixkey()
	// Mixes a string seed into a key that is an array of integers, and
	// returns a shortened string seed that is equivalent to the result key.
	//
	    function mixkey(seed, key) {
	        var stringseed = seed + '', smear, j = 0;
	        while (j < stringseed.length) {
	            key[mask & j] =
	                mask & ((smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++));
	        }
	        return tostring(key);
	    }
	
	//
	// autoseed()
	// Returns an object for autoseeding, using window.crypto and Node crypto
	// module if available.
	//
	    function autoseed() {
	        try {
	            if (nodecrypto) { return tostring(nodecrypto.randomBytes(width)); }
	            var out = new Uint8Array(width);
	            (global.crypto || global.msCrypto).getRandomValues(out);
	            return tostring(out);
	        } catch (e) {
	            var browser = global.navigator,
	                plugins = browser && browser.plugins;
	            return [+new Date, global, plugins, global.screen, tostring(pool)];
	        }
	    }
	
	//
	// tostring()
	// Converts an array of charcodes to a string
	//
	    function tostring(a) {
	        return String.fromCharCode.apply(0, a);
	    }
	
	//
	// When seedrandom.js is loaded, we immediately mix a few bits
	// from the built-in RNG into the entropy pool.  Because we do
	// not want to interfere with deterministic PRNG state later,
	// seedrandom will not call math.random on its own again after
	// initialization.
	//
	    mixkey(math.random(), pool);
	
	//
	// Nodejs and AMD support: export the implementation as a module using
	// either convention.
	//
	
	// End anonymous scope, and pass initial values.
	})(
	    [],     // pool: entropy pool starts empty
	    BMMath    // math: package containing random, pow, and seedrandom
	);
	var BezierFactory = (function(){
	    /**
	     * BezierEasing - use bezier curve for transition easing function
	     * by Gaëtan Renaudeau 2014 - 2015 – MIT License
	     *
	     * Credits: is based on Firefox's nsSMILKeySpline.cpp
	     * Usage:
	     * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
	     * spline.get(x) => returns the easing value | x must be in [0, 1] range
	     *
	     */
	
	        var ob = {};
	    ob.getBezierEasing = getBezierEasing;
	    var beziers = {};
	
	    function getBezierEasing(a,b,c,d,nm){
	        var str = nm || ('bez_' + a+'_'+b+'_'+c+'_'+d).replace(/\./g, 'p');
	        if(beziers[str]){
	            return beziers[str];
	        }
	        var bezEasing = new BezierEasing([a,b,c,d]);
	        beziers[str] = bezEasing;
	        return bezEasing;
	    }
	
	// These values are established by empiricism with tests (tradeoff: performance VS precision)
	    var NEWTON_ITERATIONS = 4;
	    var NEWTON_MIN_SLOPE = 0.001;
	    var SUBDIVISION_PRECISION = 0.0000001;
	    var SUBDIVISION_MAX_ITERATIONS = 10;
	
	    var kSplineTableSize = 11;
	    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
	
	    var float32ArraySupported = typeof Float32Array === "function";
	
	    function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
	    function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
	    function C (aA1)      { return 3.0 * aA1; }
	
	// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
	    function calcBezier (aT, aA1, aA2) {
	        return ((A(aA1, aA2)*aT + B(aA1, aA2))*aT + C(aA1))*aT;
	    }
	
	// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
	    function getSlope (aT, aA1, aA2) {
	        return 3.0 * A(aA1, aA2)*aT*aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
	    }
	
	    function binarySubdivide (aX, aA, aB, mX1, mX2) {
	        var currentX, currentT, i = 0;
	        do {
	            currentT = aA + (aB - aA) / 2.0;
	            currentX = calcBezier(currentT, mX1, mX2) - aX;
	            if (currentX > 0.0) {
	                aB = currentT;
	            } else {
	                aA = currentT;
	            }
	        } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
	        return currentT;
	    }
	
	    function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
	        for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
	            var currentSlope = getSlope(aGuessT, mX1, mX2);
	            if (currentSlope === 0.0) return aGuessT;
	            var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
	            aGuessT -= currentX / currentSlope;
	        }
	        return aGuessT;
	    }
	
	    /**
	     * points is an array of [ mX1, mY1, mX2, mY2 ]
	     */
	    function BezierEasing (points) {
	        this._p = points;
	        this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
	        this._precomputed = false;
	
	        this.get = this.get.bind(this);
	    }
	
	    BezierEasing.prototype = {
	
	        get: function (x) {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            if (!this._precomputed) this._precompute();
	            if (mX1 === mY1 && mX2 === mY2) return x; // linear
	            // Because JavaScript number are imprecise, we should guarantee the extremes are right.
	            if (x === 0) return 0;
	            if (x === 1) return 1;
	            return calcBezier(this._getTForX(x), mY1, mY2);
	        },
	
	        // Private part
	
	        _precompute: function () {
	            var mX1 = this._p[0],
	                mY1 = this._p[1],
	                mX2 = this._p[2],
	                mY2 = this._p[3];
	            this._precomputed = true;
	            if (mX1 !== mY1 || mX2 !== mY2)
	                this._calcSampleValues();
	        },
	
	        _calcSampleValues: function () {
	            var mX1 = this._p[0],
	                mX2 = this._p[2];
	            for (var i = 0; i < kSplineTableSize; ++i) {
	                this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
	            }
	        },
	
	        /**
	         * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
	         */
	        _getTForX: function (aX) {
	            var mX1 = this._p[0],
	                mX2 = this._p[2],
	                mSampleValues = this._mSampleValues;
	
	            var intervalStart = 0.0;
	            var currentSample = 1;
	            var lastSample = kSplineTableSize - 1;
	
	            for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
	                intervalStart += kSampleStepSize;
	            }
	            --currentSample;
	
	            // Interpolate to provide an initial guess for t
	            var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample+1] - mSampleValues[currentSample]);
	            var guessForT = intervalStart + dist * kSampleStepSize;
	
	            var initialSlope = getSlope(guessForT, mX1, mX2);
	            if (initialSlope >= NEWTON_MIN_SLOPE) {
	                return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
	            } else if (initialSlope === 0.0) {
	                return guessForT;
	            } else {
	                return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
	            }
	        }
	    };
	
	    return ob;
	
	}());
	(function () {
	    var lastTime = 0;
	    var vendors = ['ms', 'moz', 'webkit', 'o'];
	    for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
	        window.requestAnimationFrame = window[vendors[x] + 'RequestAnimationFrame'];
	        window.cancelAnimationFrame = window[vendors[x] + 'CancelAnimationFrame'] || window[vendors[x] + 'CancelRequestAnimationFrame'];
	    }
	    if(!window.requestAnimationFrame)
	        window.requestAnimationFrame = function (callback, element) {
	            var currTime = new Date().getTime();
	            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
	            var id = setTimeout(function () {
	                    callback(currTime + timeToCall);
	                },
	                timeToCall);
	            lastTime = currTime + timeToCall;
	            return id;
	        };
	    if(!window.cancelAnimationFrame)
	        window.cancelAnimationFrame = function (id) {
	            clearTimeout(id);
	        };
	}());
	
	function createElement(parent,child,params){
	    if(child){
	        child.prototype = Object.create(parent.prototype);
	        child.prototype.constructor = child;
	        child.prototype._parent = parent.prototype;
	    }else{
	        var instance = Object.create(parent.prototype,params);
	        var getType = {};
	        if(instance && getType.toString.call(instance.init) === '[object Function]'){
	            instance.init();
	        }
	        return instance;
	    }
	}
	
	function extendPrototype(source,destination){
	    for (var attr in source.prototype) {
	        if (source.prototype.hasOwnProperty(attr)) destination.prototype[attr] = source.prototype[attr];
	    }
	}
	
	function getDescriptor(object, prop) {
	    return Object.getOwnPropertyDescriptor(object, prop);
	}
	function bezFunction(){
	
	    var easingFunctions = [];
	    var math = Math;
	
	    function pointOnLine2D(x1,y1, x2,y2, x3,y3){
	        var det1 = (x1*y2) + (y1*x3) + (x2*y3) - (x3*y2) - (y3*x1) - (x2*y1);
	        return det1 > -0.0001 && det1 < 0.0001;
	    }
	
	    function pointOnLine3D(x1,y1,z1, x2,y2,z2, x3,y3,z3){
	        if(z1 === 0 && z2 === 0 && z3 === 0) {
	            return pointOnLine2D(x1,y1, x2,y2, x3,y3);
	        }
	        var dist1 = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2) + Math.pow(z2 - z1, 2));
	        var dist2 = Math.sqrt(Math.pow(x3 - x1, 2) + Math.pow(y3 - y1, 2) + Math.pow(z3 - z1, 2));
	        var dist3 = Math.sqrt(Math.pow(x3 - x2, 2) + Math.pow(y3 - y2, 2) + Math.pow(z3 - z2, 2));
	        var diffDist;
	        if(dist1 > dist2){
	            if(dist1 > dist3){
	                diffDist = dist1 - dist2 - dist3;
	            } else {
	                diffDist = dist3 - dist2 - dist1;
	            }
	        } else if(dist3 > dist2){
	            diffDist = dist3 - dist2 - dist1;
	        } else {
	            diffDist = dist2 - dist1 - dist3;
	        }
	        return diffDist > -0.0001 && diffDist < 0.0001;
	    }
	
	    /*function getEasingCurve(aa,bb,cc,dd,encodedFuncName) {
	        if(!encodedFuncName){
	            encodedFuncName = ('bez_' + aa+'_'+bb+'_'+cc+'_'+dd).replace(/\./g, 'p');
	        }
	        if(easingFunctions[encodedFuncName]){
	            return easingFunctions[encodedFuncName];
	        }
	        var A0, B0, C0;
	        var A1, B1, C1;
	        easingFunctions[encodedFuncName] = function(tt) {
	            var x = tt;
	            var i = 0, z;
	            while (++i < 20) {
	                C0 = 3 * aa;
	                B0 = 3 * (cc - aa) - C0;
	                A0 = 1 - C0 - B0;
	                z = (x * (C0 + x * (B0 + x * A0))) - tt;
	                if (bm_abs(z) < 1e-3) break;
	                x -= z / (C0 + x * (2 * B0 + 3 * A0 * x));
	            }
	            C1 = 3 * bb;
	            B1 = 3 * (dd - bb) - C1;
	            A1 = 1 - C1 - B1;
	            var polyB = x * (C1 + x * (B1 + x * A1));
	            //return c * polyB + b;
	            return polyB;
	        };
	        return easingFunctions[encodedFuncName];
	    }*/
	    var getBezierLength = (function(){
	
	        function Segment(l,p){
	            this.l = l;
	            this.p = p;
	        }
	
	        return function(pt1,pt2,pt3,pt4){
	            var curveSegments = defaultCurveSegments;
	            var k;
	            var i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point = [],lastPoint = [];
	            var lengthData = {
	                addedLength: 0,
	                segments: Array.apply(null,{length:curveSegments})
	            };
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                    ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*pt3[i]+3*(1-perc)*bm_pow(perc,2)*pt4[i]+bm_pow(perc,3)*pt2[i];
	                    point[i] = ptCoord;
	                    if(lastPoint[i] !== null){
	                        ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                    lastPoint[i] = point[i];
	                }
	                if(ptDistance){
	                    ptDistance = bm_sqrt(ptDistance);
	                    addedLength += ptDistance;
	                }
	                lengthData.segments[k] = new Segment(addedLength,perc);
	            }
	            lengthData.addedLength = addedLength;
	            return lengthData;
	        };
	    }());
	
	    function getSegmentsLength(shapeData) {
	        var closed = shapeData.c;
	        var pathV = shapeData.v;
	        var pathO = shapeData.o;
	        var pathI = shapeData.i;
	        var i, len = shapeData._length;
	        var lengths = [];
	        var totalLength = 0;
	        for(i=0;i<len-1;i+=1){
	            lengths[i] = getBezierLength(pathV[i],pathV[i+1],pathO[i],pathI[i+1]);
	            totalLength += lengths[i].addedLength;
	        }
	        if(closed){
	            lengths[i] = getBezierLength(pathV[i],pathV[0],pathO[i],pathI[0]);
	            totalLength += lengths[i].addedLength;
	        }
	        return {lengths:lengths,totalLength:totalLength};
	    }
	
	    function BezierData(length){
	        this.segmentLength = 0;
	        this.points = new Array(length);
	    }
	
	    function PointData(partial,point){
	        this.partialLength = partial;
	        this.point = point;
	    }
	
	    var buildBezierData = (function(){
	
	        var storedData = {};
	
	        return function (keyData){
	            var pt1 = keyData.s;
	            var pt2 = keyData.e;
	            var pt3 = keyData.to;
	            var pt4 = keyData.ti;
	            var bezierName = (pt1[0]+'_'+pt1[1]+'_'+pt2[0]+'_'+pt2[1]+'_'+pt3[0]+'_'+pt3[1]+'_'+pt4[0]+'_'+pt4[1]).replace(/\./g, 'p');
	            if(storedData[bezierName]){
	                keyData.bezierData = storedData[bezierName];
	                return;
	            }
	        var curveSegments = defaultCurveSegments;
	        var k, i, len;
	            var ptCoord,perc,addedLength = 0;
	            var ptDistance;
	            var point,lastPoint = null;
	            if(pt1.length === 2 && (pt1[0] != pt2[0] || pt1[1] != pt2[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt1[0]+pt3[0],pt1[1]+pt3[1]) && pointOnLine2D(pt1[0],pt1[1],pt2[0],pt2[1],pt2[0]+pt4[0],pt2[1]+pt4[1])){
	                curveSegments = 2;
	            }
	            var bezierData = new BezierData(curveSegments);
	            len = pt3.length;
	            for(k=0;k<curveSegments;k+=1){
	            point = new Array(len);
	                perc = k/(curveSegments-1);
	                ptDistance = 0;
	                for(i=0;i<len;i+=1){
	                ptCoord = bm_pow(1-perc,3)*pt1[i]+3*bm_pow(1-perc,2)*perc*(pt1[i] + pt3[i])+3*(1-perc)*bm_pow(perc,2)*(pt2[i] + pt4[i])+bm_pow(perc,3)*pt2[i];
	                point[i] = ptCoord;
	                    if(lastPoint !== null){
	                    ptDistance += bm_pow(point[i] - lastPoint[i],2);
	                    }
	                }
	            ptDistance = bm_sqrt(ptDistance);
	                addedLength += ptDistance;
	                bezierData.points[k] = new PointData(ptDistance,point);
	                lastPoint = point;
	            }
	            bezierData.segmentLength = addedLength;
	            keyData.bezierData = bezierData;
	            storedData[bezierName] = bezierData;
	
	        }
	    }());
	
	    function getDistancePerc(perc,bezierData){
	        var segments = bezierData.segments;
	        var len = segments.length;
	        var initPos = bm_floor((len-1)*perc);
	        var lengthPos = perc*bezierData.addedLength;
	        var lPerc = 0;
	        if(lengthPos == segments[initPos].l){
	            return segments[initPos].p;
	        }else{
	            var dir = segments[initPos].l > lengthPos ? -1 : 1;
	            var flag = true;
	            while(flag){
	                if(segments[initPos].l <= lengthPos && segments[initPos+1].l > lengthPos){
	                    lPerc = (lengthPos - segments[initPos].l)/(segments[initPos+1].l-segments[initPos].l);
	                    flag = false;
	                }else{
	                    initPos += dir;
	                }
	                if(initPos < 0 || initPos >= len - 1){
	                    flag = false;
	                }
	            }
	            return segments[initPos].p + (segments[initPos+1].p - segments[initPos].p)*lPerc;
	        }
	    }
	
	    function SegmentPoints(){
	        this.pt1 = new Array(2);
	        this.pt2 = new Array(2);
	        this.pt3 = new Array(2);
	        this.pt4 = new Array(2);
	    }
	
	    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
	        var t1 = getDistancePerc(percent,bezierData);
	        var u0 = 1;
	        var u1 = 1 - t1;
	        var ptX = Math.round((u1*u1*u1* pt1[0] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[0] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[0] + t1*t1*t1* pt2[0])* 1000) / 1000;
	        var ptY = Math.round((u1*u1*u1* pt1[1] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[1] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[1] + t1*t1*t1* pt2[1])* 1000) / 1000;
	        return [ptX, ptY];
	    }
	
	    function getNewSegment(pt1,pt2,pt3,pt4,startPerc,endPerc, bezierData){
	
	        var pts = new SegmentPoints();
	        startPerc = startPerc < 0 ? 0 : startPerc > 1 ? 1 : startPerc;
	        var t0 = getDistancePerc(startPerc,bezierData);
	        endPerc = endPerc > 1 ? 1 : endPerc;
	        var t1 = getDistancePerc(endPerc,bezierData);
	        var i, len = pt1.length;
	        var u0 = 1 - t0;
	        var u1 = 1 - t1;
	        //Math.round(num * 100) / 100
	        for(i=0;i<len;i+=1){
	            pts.pt1[i] =  Math.round((u0*u0*u0* pt1[i] + (t0*u0*u0 + u0*t0*u0 + u0*u0*t0) * pt3[i] + (t0*t0*u0 + u0*t0*t0 + t0*u0*t0)* pt4[i] + t0*t0*t0* pt2[i])* 1000) / 1000;
	            pts.pt3[i] = Math.round((u0*u0*u1*pt1[i] + (t0*u0*u1 + u0*t0*u1 + u0*u0*t1)* pt3[i] + (t0*t0*u1 + u0*t0*t1 + t0*u0*t1)* pt4[i] + t0*t0*t1* pt2[i])* 1000) / 1000;
	            pts.pt4[i] = Math.round((u0*u1*u1* pt1[i] + (t0*u1*u1 + u0*t1*u1 + u0*u1*t1)* pt3[i] + (t0*t1*u1 + u0*t1*t1 + t0*u1*t1)* pt4[i] + t0*t1*t1* pt2[i])* 1000) / 1000;
	            pts.pt2[i] = Math.round((u1*u1*u1* pt1[i] + (t1*u1*u1 + u1*t1*u1 + u1*u1*t1)* pt3[i] + (t1*t1*u1 + u1*t1*t1 + t1*u1*t1)*pt4[i] + t1*t1*t1* pt2[i])* 1000) / 1000;
	        }
	        return pts;
	    }
	
	    return {
	        //getEasingCurve : getEasingCurve,
	        getBezierLength : getBezierLength,
	        getSegmentsLength : getSegmentsLength,
	        getNewSegment : getNewSegment,
	        getPointInSegment : getPointInSegment,
	        buildBezierData : buildBezierData,
	        pointOnLine2D : pointOnLine2D,
	        pointOnLine3D : pointOnLine3D
	    };
	}
	
	var bez = bezFunction();
	function dataFunctionManager(){
	
	    //var tCanvasHelper = document.createElement('canvas').getContext('2d');
	
	    function completeLayers(layers, comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData) || layerData.completed){
	                continue;
	            }
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.layers = findCompLayers(layerData.refId, comps);
	                completeLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                completeShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                completeText(layerData, fontManager);
	            }
	        }
	    }
	
	    function findCompLayers(id,comps){
	        var i = 0, len = comps.length;
	        while(i<len){
	            if(comps[i].id === id){
	                if(!comps[i].layers.__used) {
	                    comps[i].layers.__used = true;
	                    return comps[i].layers;
	                }
	                return JSON.parse(JSON.stringify(comps[i].layers));
	            }
	            i += 1;
	        }
	    }
	
	    function completeShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    convertPathsToAbsoluteValues(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                completeShapes(arr[i].it);
	            }
	        }
	        /*if(hasPaths){
	            //mx: distance
	            //ss: sensitivity
	            //dc: decay
	            arr.splice(arr.length-1,0,{
	                "ty": "ms",
	                "mx":20,
	                "ss":10,
	                 "dc":0.001,
	                "maxDist":200
	            });
	        }*/
	    }
	
	    function convertPathsToAbsoluteValues(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] += path.v[i][0];
	            path.i[i][1] += path.v[i][1];
	            path.o[i][0] += path.v[i][0];
	            path.o[i][1] += path.v[i][1];
	        }
	    }
	
	    function checkVersion(minimum,animVersionString){
	        var animVersion = animVersionString ? animVersionString.split('.') : [100,100,100];
	        if(minimum[0]>animVersion[0]){
	            return true;
	        } else if(animVersion[0] > minimum[0]){
	            return false;
	        }
	        if(minimum[1]>animVersion[1]){
	            return true;
	        } else if(animVersion[1] > minimum[1]){
	            return false;
	        }
	        if(minimum[2]>animVersion[2]){
	            return true;
	        } else if(animVersion[2] > minimum[2]){
	            return false;
	        }
	    }
	
	    var checkText = (function(){
	        var minimumVersion = [4,4,14];
	
	        function updateTextLayer(textLayer){
	            var documentData = textLayer.t.d;
	            textLayer.t.d = {
	                k: [
	                    {
	                        s:documentData,
	                        t:0
	                    }
	                ]
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 5){
	                    updateTextLayer(layers[i]);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }())
	
	    var checkChars = (function() {
	        var minimumVersion = [4,7,99];
	        return function (animationData){
	            if(animationData.chars && !checkVersion(minimumVersion,animationData.v)){
	                var i, len = animationData.chars.length, j, jLen, k, kLen;
	                var pathData, paths;
	                for(i = 0; i < len; i += 1) {
	                    if(animationData.chars[i].data && animationData.chars[i].data.shapes) {
	                        paths = animationData.chars[i].data.shapes[0].it;
	                        jLen = paths.length;
	
	                        for(j = 0; j < jLen; j += 1) {
	                            pathData = paths[j].ks.k;
	                            if(!pathData.__converted) {
	                                convertPathsToAbsoluteValues(paths[j].ks.k);
	                                pathData.__converted = true;
	                            }
	                        }
	                    }
	                }
	            }
	        }
	
	    }())
	
	    var checkColors = (function(){
	        var minimumVersion = [4,1,9];
	
	        function iterateShapes(shapes){
	            var i, len = shapes.length;
	            var j, jLen;
	            for(i=0;i<len;i+=1){
	                if(shapes[i].ty === 'gr'){
	                    iterateShapes(shapes[i].it);
	                }else if(shapes[i].ty === 'fl' || shapes[i].ty === 'st'){
	                    if(shapes[i].c.k && shapes[i].c.k[0].i){
	                        jLen = shapes[i].c.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(shapes[i].c.k[j].s){
	                                shapes[i].c.k[j].s[0] /= 255;
	                                shapes[i].c.k[j].s[1] /= 255;
	                                shapes[i].c.k[j].s[2] /= 255;
	                                shapes[i].c.k[j].s[3] /= 255;
	                            }
	                            if(shapes[i].c.k[j].e){
	                                shapes[i].c.k[j].e[0] /= 255;
	                                shapes[i].c.k[j].e[1] /= 255;
	                                shapes[i].c.k[j].e[2] /= 255;
	                                shapes[i].c.k[j].e[3] /= 255;
	                            }
	                        }
	                    } else {
	                        shapes[i].c.k[0] /= 255;
	                        shapes[i].c.k[1] /= 255;
	                        shapes[i].c.k[2] /= 255;
	                        shapes[i].c.k[3] /= 255;
	                    }
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var i, len = layers.length;
	            for(i=0;i<len;i+=1){
	                if(layers[i].ty === 4){
	                    iterateShapes(layers[i].shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }());
	
	    var checkShapes = (function(){
	        var minimumVersion = [4,4,18];
	
	
	
	        function completeShapes(arr){
	            var i, len = arr.length;
	            var j, jLen;
	            var hasPaths = false;
	            for(i=len-1;i>=0;i-=1){
	                if(arr[i].ty == 'sh'){
	                    if(arr[i].ks.k.i){
	                        arr[i].ks.k.c = arr[i].closed;
	                    }else{
	                        jLen = arr[i].ks.k.length;
	                        for(j=0;j<jLen;j+=1){
	                            if(arr[i].ks.k[j].s){
	                                arr[i].ks.k[j].s[0].c = arr[i].closed;
	                            }
	                            if(arr[i].ks.k[j].e){
	                                arr[i].ks.k[j].e[0].c = arr[i].closed;
	                            }
	                        }
	                    }
	                    hasPaths = true;
	                }else if(arr[i].ty == 'gr'){
	                    completeShapes(arr[i].it);
	                }
	            }
	        }
	
	        function iterateLayers(layers){
	            var layerData;
	            var i, len = layers.length;
	            var j, jLen, k, kLen;
	            for(i=0;i<len;i+=1){
	                layerData = layers[i];
	                if(layerData.hasMask){
	                    var maskProps = layerData.masksProperties;
	                    jLen = maskProps.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(maskProps[j].pt.k.i){
	                            maskProps[j].pt.k.c = maskProps[j].cl;
	                        }else{
	                            kLen = maskProps[j].pt.k.length;
	                            for(k=0;k<kLen;k+=1){
	                                if(maskProps[j].pt.k[k].s){
	                                    maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
	                                }
	                                if(maskProps[j].pt.k[k].e){
	                                    maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
	                                }
	                            }
	                        }
	                    }
	                }
	                if(layerData.ty === 4){
	                    completeShapes(layerData.shapes);
	                }
	            }
	        }
	
	        return function (animationData){
	            if(checkVersion(minimumVersion,animationData.v)){
	                iterateLayers(animationData.layers);
	                if(animationData.assets){
	                    var i, len = animationData.assets.length;
	                    for(i=0;i<len;i+=1){
	                        if(animationData.assets[i].layers){
	                            iterateLayers(animationData.assets[i].layers);
	
	                        }
	                    }
	                }
	            }
	        }
	    }());
	
	    /*function blitPaths(path){
	        var i, len = path.i.length;
	        for(i=0;i<len;i+=1){
	            path.i[i][0] /= blitter;
	            path.i[i][1] /= blitter;
	            path.o[i][0] /= blitter;
	            path.o[i][1] /= blitter;
	            path.v[i][0] /= blitter;
	            path.v[i][1] /= blitter;
	        }
	    }
	
	    function blitShapes(arr){
	        var i, len = arr.length;
	        var j, jLen;
	        var hasPaths = false;
	        for(i=len-1;i>=0;i-=1){
	            if(arr[i].ty == 'sh'){
	                if(arr[i].ks.k.i){
	                    blitPaths(arr[i].ks.k);
	                }else{
	                    jLen = arr[i].ks.k.length;
	                    for(j=0;j<jLen;j+=1){
	                        if(arr[i].ks.k[j].s){
	                            blitPaths(arr[i].ks.k[j].s[0]);
	                        }
	                        if(arr[i].ks.k[j].e){
	                            blitPaths(arr[i].ks.k[j].e[0]);
	                        }
	                    }
	                }
	                hasPaths = true;
	            }else if(arr[i].ty == 'gr'){
	                blitShapes(arr[i].it);
	            }else if(arr[i].ty == 'rc'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].s);
	            }else if(arr[i].ty == 'st'){
	                blitProperty(arr[i].w);
	            }else if(arr[i].ty == 'tr'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].sk);
	                blitProperty(arr[i].a);
	            }else if(arr[i].ty == 'el'){
	                blitProperty(arr[i].p);
	                blitProperty(arr[i].s);
	            }else if(arr[i].ty == 'rd'){
	                blitProperty(arr[i].r);
	            }else{
	
	                //console.log(arr[i].ty );
	            }
	        }
	    }
	
	    function blitText(data, fontManager){
	
	    }
	
	    function blitValue(val){
	        if(typeof(val) === 'number'){
	            val /= blitter;
	        } else {
	            var i = val.length-1;
	            while(i>=0){
	                val[i] /= blitter;
	                i-=1;
	            }
	        }
	        return val;
	    }
	
	    function blitProperty(data){
	        if(!data.k.length){
	            data.k = blitValue(data.k);
	        }else if(typeof(data.k[0]) === 'number'){
	            data.k = blitValue(data.k);
	        } else {
	            var i, len = data.k.length;
	            for(i=0;i<len;i+=1){
	                if(data.k[i].s){
	                    //console.log('pre S: ', data.k[i].s);
	                    data.k[i].s = blitValue(data.k[i].s);
	                    //console.log('post S: ', data.k[i].s);
	                }
	                if(data.k[i].e){
	                    //console.log('pre E: ', data.k[i].e);
	                    data.k[i].e = blitValue(data.k[i].e);
	                    //console.log('post E: ', data.k[i].e);
	                }
	            }
	        }
	    }
	
	    function blitLayers(layers,comps, fontManager){
	        var layerData;
	        var animArray, lastFrame;
	        var i, len = layers.length;
	        var j, jLen, k, kLen;
	        for(i=0;i<len;i+=1){
	            layerData = layers[i];
	            if(!('ks' in layerData)){
	                continue;
	            }
	            blitProperty(layerData.ks.a);
	            blitProperty(layerData.ks.p);
	            layerData.completed = true;
	            if(layerData.tt){
	                layers[i-1].td = layerData.tt;
	            }
	            animArray = [];
	            lastFrame = -1;
	            if(layerData.hasMask){
	                var maskProps = layerData.masksProperties;
	                jLen = maskProps.length;
	                for(j=0;j<jLen;j+=1){
	                    if(maskProps[j].pt.k.i){
	                        blitPaths(maskProps[j].pt.k);
	                    }else{
	                        kLen = maskProps[j].pt.k.length;
	                        for(k=0;k<kLen;k+=1){
	                            if(maskProps[j].pt.k[k].s){
	                                blitPaths(maskProps[j].pt.k[k].s[0]);
	                            }
	                            if(maskProps[j].pt.k[k].e){
	                                blitPaths(maskProps[j].pt.k[k].e[0]);
	                            }
	                        }
	                    }
	                }
	            }
	            if(layerData.ty===0){
	                layerData.w = Math.round(layerData.w/blitter);
	                layerData.h = Math.round(layerData.h/blitter);
	                blitLayers(layerData.layers,comps, fontManager);
	            }else if(layerData.ty === 4){
	                blitShapes(layerData.shapes);
	            }else if(layerData.ty == 5){
	                blitText(layerData, fontManager);
	            }else if(layerData.ty == 1){
	                layerData.sh /= blitter;
	                layerData.sw /= blitter;
	            } else {
	            }
	        }
	    }
	
	    function blitAnimation(animationData,comps, fontManager){
	        blitLayers(animationData.layers,comps, fontManager);
	    }*/
	
	    function completeData(animationData, fontManager){
	        if(animationData.__complete){
	            return;
	        }
	        checkColors(animationData);
	        checkText(animationData);
	        checkChars(animationData);
	        checkShapes(animationData);
	        completeLayers(animationData.layers, animationData.assets, fontManager);
	        animationData.__complete = true;
	        //blitAnimation(animationData, animationData.assets, fontManager);
	    }
	
	    function completeText(data, fontManager){
	        if(data.t.a.length === 0 && !('m' in data.t.p)){
	            data.singleShape = true;
	        }
	    }
	
	    var moduleOb = {};
	    moduleOb.completeData = completeData;
	
	    return moduleOb;
	}
	
	var dataManager = dataFunctionManager();
	var FontManager = (function(){
	
	    var maxWaitingTime = 5000;
	    var emptyChar = {
	        w: 0,
	        size:0,
	        shapes:[]
	    }
	
	    function setUpNode(font, family){
	        var parentNode = document.createElement('span');
	        parentNode.style.fontFamily    = family;
	        var node = document.createElement('span');
	        // Characters that vary significantly among different fonts
	        node.innerHTML = 'giItT1WQy@!-/#';
	        // Visible - so we can measure it - but not on the screen
	        parentNode.style.position      = 'absolute';
	        parentNode.style.left          = '-10000px';
	        parentNode.style.top           = '-10000px';
	        // Large font size makes even subtle changes obvious
	        parentNode.style.fontSize      = '300px';
	        // Reset any font properties
	        parentNode.style.fontVariant   = 'normal';
	        parentNode.style.fontStyle     = 'normal';
	        parentNode.style.fontWeight    = 'normal';
	        parentNode.style.letterSpacing = '0';
	        parentNode.appendChild(node);
	        document.body.appendChild(parentNode);
	
	        // Remember width with no applied web font
	        var width = node.offsetWidth;
	        node.style.fontFamily = font + ', '+family;
	        return {node:node, w:width, parent:parentNode};
	    }
	
	    function checkLoadedFonts() {
	        var i, len = this.fonts.length;
	        var node, w;
	        var loadedCount = len;
	        for(i=0;i<len; i+= 1){
	            if(this.fonts[i].loaded){
	                loadedCount -= 1;
	                continue;
	            }
	            if(this.fonts[i].fOrigin === 't' || this.fonts[i].origin === 2){
	                if(window.Typekit && window.Typekit.load && this.typekitLoaded === 0){
	                    this.typekitLoaded = 1;
	                    try{window.Typekit.load({
	                        async: true,
	                        active: function() {
	                            this.typekitLoaded = 2;
	                        }.bind(this)
	                    });}catch(e){}
	                }
	                if(this.typekitLoaded === 2) {
	                    this.fonts[i].loaded = true;
	                }
	            } else if(this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0){
	                this.fonts[i].loaded = true;
	            } else{
	                node = this.fonts[i].monoCase.node;
	                w = this.fonts[i].monoCase.w;
	                if(node.offsetWidth !== w){
	                    loadedCount -= 1;
	                    this.fonts[i].loaded = true;
	                }else{
	                    node = this.fonts[i].sansCase.node;
	                    w = this.fonts[i].sansCase.w;
	                    if(node.offsetWidth !== w){
	                        loadedCount -= 1;
	                        this.fonts[i].loaded = true;
	                    }
	                }
	                if(this.fonts[i].loaded){
	                    this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
	                    this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
	                }
	            }
	        }
	
	        if(loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime){
	            setTimeout(checkLoadedFonts.bind(this),20);
	        }else{
	            setTimeout(function(){this.loaded = true;}.bind(this),0);
	
	        }
	    };
	
	    function createHelper(def, fontData){
	        var tHelper = createNS('text');
	        tHelper.style.fontSize = '100px';
	        tHelper.style.fontFamily = fontData.fFamily;
	        tHelper.textContent = '1';
	        if(fontData.fClass){
	            tHelper.style.fontFamily = 'inherit';
	            tHelper.className = fontData.fClass;
	        } else {
	            tHelper.style.fontFamily = fontData.fFamily;
	        }
	        def.appendChild(tHelper);
	        var tCanvasHelper = document.createElement('canvas').getContext('2d');
	        tCanvasHelper.font = '100px '+ fontData.fFamily;
	        return tCanvasHelper;
	    }
	
	    function addFonts(fontData, defs){
	        if(!fontData){
	            this.loaded = true;
	            return;
	        }
	        if(this.chars){
	            this.loaded = true;
	            this.fonts = fontData.list;
	            return;
	        }
	
	        var fontArr = fontData.list;
	        var i, len = fontArr.length;
	        for(i=0; i<len; i+= 1){
	            fontArr[i].loaded = false;
	            fontArr[i].monoCase = setUpNode(fontArr[i].fFamily,'monospace');
	            fontArr[i].sansCase = setUpNode(fontArr[i].fFamily,'sans-serif');
	            if(!fontArr[i].fPath) {
	                fontArr[i].loaded = true;
	            }else if(fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3){
	                var s = document.createElement('style');
	                s.type = "text/css";
	                s.innerHTML = "@font-face {" + "font-family: "+fontArr[i].fFamily+"; font-style: normal; src: url('"+fontArr[i].fPath+"');}";
	                defs.appendChild(s);
	            } else if(fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1){
	                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
	                var l = document.createElement('link');
	                l.type = "text/css";
	                l.rel = "stylesheet";
	                l.href = fontArr[i].fPath;
	                defs.appendChild(l);
	            } else if(fontArr[i].fOrigin === 't' || fontArr[i].origin === 2){
	                //<link href='https://fonts.googleapis.com/css?family=Montserrat' rel='stylesheet' type='text/css'>
	                var sc = document.createElement('script');
	                sc.setAttribute('src',fontArr[i].fPath);
	                defs.appendChild(sc);
	            }
	            fontArr[i].helper = createHelper(defs,fontArr[i]);
	            this.fonts.push(fontArr[i]);
	        }
	        checkLoadedFonts.bind(this)();
	    }
	
	    function addChars(chars){
	        if(!chars){
	            return;
	        }
	        if(!this.chars){
	            this.chars = [];
	        }
	        var i, len = chars.length;
	        var j, jLen = this.chars.length, found;
	        for(i=0;i<len;i+=1){
	            j = 0;
	            found = false;
	            while(j<jLen){
	                if(this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch){
	                    found = true;
	                }
	                j += 1;
	            }
	            if(!found){
	                this.chars.push(chars[i]);
	                jLen += 1;
	            }
	        }
	    }
	
	    function getCharData(char, style, font){
	        var i = 0, len = this.chars.length;
	        while( i < len) {
	            if(this.chars[i].ch === char && this.chars[i].style === style && this.chars[i].fFamily === font){
	                return this.chars[i];
	            }
	            i+= 1;
	        }
	        if(console && console.warn) {
	            console.warn('Missing character from exported characters list: ', char, style, font);
	        }
	        return emptyChar;
	    }
	
	    function measureText(char, fontName, size){
	        var fontData = this.getFontByName(fontName);
	        var tHelper = fontData.helper;
	        //tHelper.textContent = char;
	        return tHelper.measureText(char).width*size/100;
	        //return tHelper.getComputedTextLength()*size/100;
	    }
	
	    function getFontByName(name){
	        var i = 0, len = this.fonts.length;
	        while(i<len){
	            if(this.fonts[i].fName === name) {
	                return this.fonts[i];
	            }
	            i += 1;
	        }
	        return 'sans-serif';
	    }
	
	    var Font = function(){
	        this.fonts = [];
	        this.chars = null;
	        this.typekitLoaded = 0;
	        this.loaded = false;
	        this.initTime = Date.now();
	    };
	    Font.prototype.addChars = addChars;
	    Font.prototype.addFonts = addFonts;
	    Font.prototype.getCharData = getCharData;
	    Font.prototype.getFontByName = getFontByName;
	    Font.prototype.measureText = measureText;
	
	    return Font;
	
	}());
	var PropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function interpolateValue(frameNum, iterationIndex, previousValue, caching){
	        var offsetTime = this.offsetTime;
	        var newValue;
	        if(this.propType === 'multidimensional') {
	            newValue = createTypedArray('float32', previousValue.length);
	        }
	        var i = iterationIndex;
	        var len = this.keyframes.length- 1,flag = true;
	        var keyData, nextKeyData;
	
	        while(flag){
	            keyData = this.keyframes[i];
	            nextKeyData = this.keyframes[i+1];
	            if(i == len-1 && frameNum >= nextKeyData.t - offsetTime){
	                if(keyData.h){
	                    keyData = nextKeyData;
	                }
	                iterationIndex = 0;
	                break;
	            }
	            if((nextKeyData.t - offsetTime) > frameNum){
	                iterationIndex = i;
	                break;
	            }
	            if(i < len - 1){
	                i += 1;
	            }else{
	                iterationIndex = 0;
	                flag = false;
	            }
	        }
	
	        var k, kLen,perc,jLen, j, fnc;
	        if(keyData.to){
	
	            if(!keyData.bezierData){
	                bez.buildBezierData(keyData);
	            }
	            var bezierData = keyData.bezierData;
	            if(frameNum >= nextKeyData.t-offsetTime || frameNum < keyData.t-offsetTime){
	                var ind = frameNum >= nextKeyData.t-offsetTime ? bezierData.points.length - 1 : 0;
	                kLen = bezierData.points[ind].point.length;
	                for(k = 0; k < kLen; k += 1){
	                    newValue[k] = bezierData.points[ind].point[k];
	                }
	                caching._lastBezierData = null;
	            }else{
	                if(keyData.__fnct){
	                    fnc = keyData.__fnct;
	                }else{
	                    fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y,keyData.n).get;
	                    keyData.__fnct = fnc;
	                }
	                perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
	                var distanceInLine = bezierData.segmentLength*perc;
	
	                var segmentPerc;
	                var addedLength =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastAddedLength : 0;
	                j =  (caching.lastFrame < frameNum && caching._lastBezierData === bezierData) ? caching._lastPoint : 0;
	                flag = true;
	                jLen = bezierData.points.length;
	                while(flag){
	                    addedLength +=bezierData.points[j].partialLength;
	                    if(distanceInLine === 0 || perc === 0 || j == bezierData.points.length - 1){
	                        kLen = bezierData.points[j].point.length;
	                        for(k=0;k<kLen;k+=1){
	                            newValue[k] = bezierData.points[j].point[k];
	                        }
	                        break;
	                    }else if(distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j+1].partialLength){
	                        segmentPerc = (distanceInLine-addedLength)/(bezierData.points[j+1].partialLength);
	                        kLen = bezierData.points[j].point.length;
	                        for(k=0;k<kLen;k+=1){
	                            newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j+1].point[k] - bezierData.points[j].point[k])*segmentPerc;
	                        }
	                        break;
	                    }
	                    if(j < jLen - 1){
	                        j += 1;
	                    }else{
	                        flag = false;
	                    }
	                }
	                caching._lastPoint = j;
	                caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
	                caching._lastBezierData = bezierData;
	            }
	        }else{
	            var outX,outY,inX,inY, keyValue;
	            len = keyData.s.length;
	            for(i=0;i<len;i+=1){
	                if(keyData.h !== 1){
	                    if(frameNum >= nextKeyData.t-offsetTime){
	                        perc = 1;
	                    }else if(frameNum < keyData.t-offsetTime){
	                        perc = 0;
	                    }else{
	                        if(keyData.o.x.constructor === Array){
	                            if(!keyData.__fnct){
	                                keyData.__fnct = [];
	                            }
	                            if (!keyData.__fnct[i]) {
	                                outX = keyData.o.x[i] || keyData.o.x[0];
	                                outY = keyData.o.y[i] || keyData.o.y[0];
	                                inX = keyData.i.x[i] || keyData.i.x[0];
	                                inY = keyData.i.y[i] || keyData.i.y[0];
	                                fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                                keyData.__fnct[i] = fnc;
	                            } else {
	                                fnc = keyData.__fnct[i];
	                            }
	                        } else {
	                            if (!keyData.__fnct) {
	                                outX = keyData.o.x;
	                                outY = keyData.o.y;
	                                inX = keyData.i.x;
	                                inY = keyData.i.y;
	                                fnc = BezierFactory.getBezierEasing(outX,outY,inX,inY).get;
	                                keyData.__fnct = fnc;
	                            } else{
	                                fnc = keyData.__fnct;
	                            }
	                        }
	                        perc = fnc((frameNum-(keyData.t-offsetTime))/((nextKeyData.t-offsetTime)-(keyData.t-offsetTime)));
	                    }
	                }
	                if(this.sh && keyData.h !== 1){
	                    var initP = keyData.s[i];
	                    var endP = keyData.e[i];
	                    if(initP-endP < -180){
	                        initP += 360;
	                    } else if(initP-endP > 180){
	                        initP -= 360;
	                    }
	                    keyValue = initP+(endP-initP)*perc;
	                } else {
	                    keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i]+(keyData.e[i]-keyData.s[i])*perc;
	                }
	                if(len === 1){
	                    newValue = keyValue;
	                }else{
	                    newValue[i] = keyValue;
	                }
	            }
	        }
	        return {
	            value: newValue,
	            iterationIndex: iterationIndex
	        }
	    }
	
	    function getValueAtCurrentTime(){
	        if(this.elem.globalData.frameId === this.frameId){
	            return;
	        }
	        this.mdf = false;
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t-this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length- 1].t-this.offsetTime;
	        if(!(frameNum === this._caching.lastFrame || (this._caching.lastFrame !== initFrame && ((this._caching.lastFrame >= endTime && frameNum >= endTime) || (this._caching.lastFrame < initTime && frameNum < initTime))))){
	            var i = this._caching.lastFrame < frameNum ? this._caching.lastIndex : 0;
	            var renderResult = this.interpolateValue(frameNum, i, this.pv, this._caching);
	            this._caching.lastIndex = renderResult.iterationIndex;
	            if(this.propType === 'multidimensional'){
	                i = 0;
	                while(i<this.v.length){
	                    this.pv[i] = renderResult.value[i];
	                    this.v[i] = this.mult ? this.pv[i] * this.mult : this.pv[i];
	                    if(this.lastPValue[i] !== this.pv[i]) {
	                        this.mdf = true;
	                        this.lastPValue[i] = this.pv[i];
	                    }
	                    i += 1;
	                }
	                if(this.firstFrame) {
	                    this.firstFrame = false;
	                    this.mdf = true;
	                }
	            } else {
	                this.pv = renderResult.value;
	                this.v = this.mult ? this.pv*this.mult : this.pv;
	                if(this.lastPValue != this.pv){
	                    this.mdf = true;
	                    this.lastPValue = this.pv;
	                }
	            }
	            
	        }
	        this._caching.lastFrame = frameNum;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function getNoValue(){}
	
	    function ValueProperty(elem,data, mult){
	        this.propType = 'unidimensional';
	        this.mult = mult;
	        this.v = mult ? data.k * mult : data.k;
	        this.pv = data.k;
	        this.mdf = false;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.vel = 0;
	        this.getValue = getNoValue;
	    }
	
	    function MultiDimensionalProperty(elem,data, mult){
	        this.propType = 'multidimensional';
	        this.mult = mult;
	        this.data = data;
	        this.mdf = false;
	        this.comp = elem.comp;
	        this.k = false;
	        this.kf = false;
	        this.frameId = -1;
	        this.v = createTypedArray('float32', data.k.length);
	        this.pv = createTypedArray('float32', data.k.length);
	        this.lastValue = createTypedArray('float32', data.k.length);
	        var arr = createTypedArray('float32', data.k.length);
	        this.vel = createTypedArray('float32', data.k.length);
	        var i, len = data.k.length;
	        for(i = 0;i<len;i+=1){
	            this.v[i] = mult ? data.k[i] * mult : data.k[i];
	            this.pv[i] = data.k[i];
	        }
	        this.getValue = getNoValue;
	    }
	
	    function KeyframedValueProperty(elem, data, mult){
	        this.propType = 'unidimensional';
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.lastValue = -99999;
	        this.lastPValue = -99999;
	        this.frameId = -1;
	        this._caching={lastFrame:initFrame,lastIndex:0};
	        this.k = true;
	        this.kf = true;
	        this.data = data;
	        this.mult = mult;
	        this.elem = elem;
	        this.firstFrame = false;
	        this.comp = elem.comp;
	        this.v = mult ? data.k[0].s[0]*mult : data.k[0].s[0];
	        this.pv = data.k[0].s[0];
	        this.getValue = getValueAtCurrentTime;
	        this.interpolateValue = interpolateValue;
	    }
	
	    function KeyframedMultidimensionalProperty(elem, data, mult){
	        var i, len = data.k.length;
	        var s, e,to,ti;
	        for(i=0;i<len-1;i+=1){
	            if(data.k[i].to && data.k[i].s && data.k[i].e){
	                s = data.k[i].s;
	                e = data.k[i].e;
	                to = data.k[i].to;
	                ti = data.k[i].ti;
	                if((s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],s[0] + to[0],s[1] + to[1]) && bez.pointOnLine2D(s[0],s[1],e[0],e[1],e[0] + ti[0],e[1] + ti[1])) || (s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],s[0] + to[0],s[1] + to[1],s[2] + to[2]) && bez.pointOnLine3D(s[0],s[1],s[2],e[0],e[1],e[2],e[0] + ti[0],e[1] + ti[1],e[2] + ti[2]))){
	                    data.k[i].to = null;
	                    data.k[i].ti = null;
	                }
	            }
	        }
	        this.propType = 'multidimensional';
	        this.keyframes = data.k;
	        this.offsetTime = elem.data.st;
	        this.k = true;
	        this.kf = true;
	        this.firstFrame = true;
	        this.mult = mult;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this._caching={lastFrame:initFrame,lastIndex:0};
	        this.getValue = getValueAtCurrentTime;
	        this.interpolateValue = interpolateValue;
	        this.frameId = -1;
	        var arrLen = data.k[0].s.length;
	        this.v = createTypedArray('float32', arrLen);
	        this.pv = createTypedArray('float32', arrLen);
	        this.lastValue = createTypedArray('float32', arrLen);
	        this.lastPValue = createTypedArray('float32', arrLen);
	    }
	
	    function getProp(elem,data,type, mult, arr) {
	        var p;
	        if(data.a === 0){
	            if(type === 0) {
	                p = new ValueProperty(elem,data,mult);
	            } else {
	                p = new MultiDimensionalProperty(elem,data, mult);
	            }
	        } else if(data.a === 1){
	            if(type === 0) {
	                p = new KeyframedValueProperty(elem,data,mult);
	            } else {
	                p = new KeyframedMultidimensionalProperty(elem,data, mult);
	            }
	        } else if(!data.k.length){
	            p = new ValueProperty(elem,data, mult);
	        }else if(typeof(data.k[0]) === 'number'){
	            p = new MultiDimensionalProperty(elem,data, mult);
	        }else{
	            switch(type){
	                case 0:
	                    p = new KeyframedValueProperty(elem,data,mult);
	                    break;
	                case 1:
	                    p = new KeyframedMultidimensionalProperty(elem,data,mult);
	                    break;
	            }
	        }
	        if(p.k){
	            arr.push(p);
	        }
	        return p;
	    }
	
	    var ob = {
	        getProp: getProp
	    };
	    return ob;
	}());
	var TransformPropertyFactory = (function() {
	    
	    function applyToMatrix(mat) {
	        var i, len = this.dynamicProperties.length;
	        for(i = 0; i < len; i += 1) {
	            this.dynamicProperties[i].getValue();
	            if (this.dynamicProperties[i].mdf) {
	                this.mdf = true;
	            }
	        }
	        if (this.a) {
	            mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	        }
	        if (this.s) {
	            mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	        }
	        if (this.r) {
	            mat.rotate(-this.r.v);
	        } else {
	            mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	        }
	        if (this.data.p.s) {
	            if (this.data.p.z) {
	                mat.translate(this.px.v, this.py.v, -this.pz.v);
	            } else {
	                mat.translate(this.px.v, this.py.v, 0);
	            }
	        } else {
	            mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
	        }
	    }
	    function processKeys(){
	        if (this.elem.globalData.frameId === this.frameId) {
	            return;
	        }
	
	        this.mdf = false;
	        var i, len = this.dynamicProperties.length;
	
	        for(i = 0; i < len; i += 1) {
	            this.dynamicProperties[i].getValue();
	            if (this.dynamicProperties[i].mdf) {
	                this.mdf = true;
	            }
	        }
	
	        if (this.mdf) {
	            this.v.reset();
	            if (this.a) {
	                this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
	            }
	            if(this.s) {
	                this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
	            }
	            if (this.sk) {
	                this.v.skewFromAxis(-this.sk.v, this.sa.v);
	            }
	            if (this.r) {
	                this.v.rotate(-this.r.v);
	            } else {
	                this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if (this.autoOriented && this.p.keyframes && this.p.getValueAtTime) {
	                var v1,v2;
	                if (this.p._caching.lastFrame+this.p.offsetTime <= this.p.keyframes[0].t) {
	                    v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / this.elem.globalData.frameRate,0);
	                    v2 = this.p.getValueAtTime(this.p.keyframes[0].t / this.elem.globalData.frameRate, 0);
	                } else if(this.p._caching.lastFrame+this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
	                    v1 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t / this.elem.globalData.frameRate), 0);
	                    v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.01) / this.elem.globalData.frameRate, 0);
	                } else {
	                    v1 = this.p.pv;
	                    v2 = this.p.getValueAtTime((this.p._caching.lastFrame+this.p.offsetTime - 0.01) / this.elem.globalData.frameRate, this.p.offsetTime);
	                }
	                this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
	            }
	            if(this.data.p.s){
	                if(this.data.p.z) {
	                    this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    this.v.translate(this.px.v, this.py.v, 0);
	                }
	            }else{
	                this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	        }
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function setInverted(){
	        this.inverted = true;
	        this.iv = new Matrix();
	        if(!this.k){
	            if(this.data.p.s){
	                this.iv.translate(this.px.v,this.py.v,-this.pz.v);
	            }else{
	                this.iv.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	            if(this.r){
	                this.iv.rotate(-this.r.v);
	            }else{
	                this.iv.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	            }
	            if(this.s){
	                this.iv.scale(this.s.v[0],this.s.v[1],1);
	            }
	            if(this.a){
	                this.iv.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
	            }
	        }
	    }
	
	    function autoOrient(){
	        //
	        //var prevP = this.getValueAtTime();
	    }
	
	    function TransformProperty(elem,data,arr){
	        this.elem = elem;
	        this.frameId = -1;
	        this.type = 'transform';
	        this.dynamicProperties = [];
	        this.mdf = false;
	        this.data = data;
	        this.v = new Matrix();
	        if(data.p.s){
	            this.px = PropertyFactory.getProp(elem,data.p.x,0,0,this.dynamicProperties);
	            this.py = PropertyFactory.getProp(elem,data.p.y,0,0,this.dynamicProperties);
	            if(data.p.z){
	                this.pz = PropertyFactory.getProp(elem,data.p.z,0,0,this.dynamicProperties);
	            }
	        }else{
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	        }
	        if(data.r) {
	            this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this.dynamicProperties);
	        } else if(data.rx) {
	            this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this.dynamicProperties);
	            this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this.dynamicProperties);
	            this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this.dynamicProperties);
	            if(data.or.k[0].ti) {
	                var i, len = data.or.k.length;
	                for(i=0;i<len;i+=1) {
	                    data.or.k[i].to = data.or.k[i].ti = null;
	                }
	            }
	            this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this.dynamicProperties);
	            //sh Indicates it needs to be capped between -180 and 180
	            this.or.sh = true;
	        }
	        if(data.sk){
	            this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this.dynamicProperties);
	            this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this.dynamicProperties);
	        }
	        if(data.a) {
	            this.a = PropertyFactory.getProp(elem,data.a,1,0,this.dynamicProperties);
	        }
	        if(data.s) {
	            this.s = PropertyFactory.getProp(elem,data.s,1,0.01,this.dynamicProperties);
	        }
	        if(data.o){
	            this.o = PropertyFactory.getProp(elem,data.o,0,0.01,arr);
	        } else {
	            this.o = {mdf:false,v:1};
	        }
	        if(this.dynamicProperties.length){
	            arr.push(this);
	        }else{
	            if(this.a){
	                this.v.translate(-this.a.v[0],-this.a.v[1],this.a.v[2]);
	            }
	            if(this.s){
	                this.v.scale(this.s.v[0],this.s.v[1],this.s.v[2]);
	            }
	            if(this.sk){
	                this.v.skewFromAxis(-this.sk.v,this.sa.v);
	            }
	            if(this.r){
	                this.v.rotate(-this.r.v);
	            }else{
	                this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
	            }
	            if(this.data.p.s){
	                if(data.p.z) {
	                    this.v.translate(this.px.v, this.py.v, -this.pz.v);
	                } else {
	                    this.v.translate(this.px.v, this.py.v, 0);
	                }
	            }else{
	                this.v.translate(this.p.v[0],this.p.v[1],-this.p.v[2]);
	            }
	        }
	    }
	
	    TransformProperty.prototype.applyToMatrix = applyToMatrix;
	    TransformProperty.prototype.getValue = processKeys;
	    TransformProperty.prototype.setInverted = setInverted;
	    TransformProperty.prototype.autoOrient = autoOrient;
	
	    function getTransformProperty(elem,data,arr){
	        return new TransformProperty(elem,data,arr)
	    }
	
	    return {
	        getTransformProperty: getTransformProperty
	    };
	
	}());
	function ShapePath(){
		this.c = false;
		this._length = 0;
		this._maxLength = 8;
		this.v = Array.apply(null,{length:this._maxLength});
		this.o = Array.apply(null,{length:this._maxLength});
		this.i = Array.apply(null,{length:this._maxLength});
	};
	
	ShapePath.prototype.setPathData = function(closed, len) {
		this.c = closed;
		this.setLength(len);
		var i = 0;
		while(i < len){
			this.v[i] = point_pool.newPoint();
			this.o[i] = point_pool.newPoint();
			this.i[i] = point_pool.newPoint();
			i += 1;
		}
	};
	
	ShapePath.prototype.setLength = function(len) {
		while(this._maxLength < len) {
			this.doubleArrayLength();
		}
		this._length = len;
	}
	
	ShapePath.prototype.doubleArrayLength = function() {
		this.v = this.v.concat(Array.apply(null,{length:this._maxLength}))
		this.i = this.i.concat(Array.apply(null,{length:this._maxLength}))
		this.o = this.o.concat(Array.apply(null,{length:this._maxLength}))
		this._maxLength *= 2;
	};
	
	ShapePath.prototype.setXYAt = function(x, y, type, pos, replace) {
		var arr;
		this._length = Math.max(this._length, pos + 1);
		if(this._length >= this._maxLength) {
			this.doubleArrayLength();
		}
		switch(type){
			case 'v':
				arr = this.v;
				break;
			case 'i':
				arr = this.i;
				break;
			case 'o':
				arr = this.o;
				break;
		}
		if(!arr[pos] || (arr[pos] && !replace)){
			arr[pos] = point_pool.newPoint();
		}
		arr[pos][0] = x;
		arr[pos][1] = y;
	};
	
	ShapePath.prototype.setTripleAt = function(vX,vY,oX,oY,iX,iY,pos, replace) {
		this.setXYAt(vX,vY,'v',pos, replace);
		this.setXYAt(oX,oY,'o',pos, replace);
		this.setXYAt(iX,iY,'i',pos, replace);
	};
	
	ShapePath.prototype.reverse = function() {
		var newPath = new ShapePath();
		newPath.setPathData(this.c, this._length);
		var vertices = this.v, outPoints = this.o, inPoints = this.i;
		var init = 0;
		if (this.c) {
			newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
	        init = 1;
	    }
	    var cnt = this._length - 1;
	    var len = this._length;
	
	    for (i = init; i < len; i += 1) {
	    	newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
	        cnt -= 1;
	    }
	    return newPath;
	};
	var ShapePropertyFactory = (function(){
	
	    var initFrame = -999999;
	
	    function interpolateShape(frameNum, iterationIndex, previousValue, isCurrentRender) {
	        var keyPropS,keyPropE,isHold;
	        if(frameNum < this.keyframes[0].t-this.offsetTime){
	            keyPropS = this.keyframes[0].s[0];
	            isHold = true;
	            iterationIndex = 0;
	        }else if(frameNum >= this.keyframes[this.keyframes.length - 1].t-this.offsetTime){
	            if(this.keyframes[this.keyframes.length - 2].h === 1){
	                keyPropS = this.keyframes[this.keyframes.length - 1].s[0];
	            }else{
	                keyPropS = this.keyframes[this.keyframes.length - 2].e[0];
	            }
	            isHold = true;
	        }else{
	            var i = iterationIndex;
	            var len = this.keyframes.length- 1,flag = true,keyData,nextKeyData, j, jLen, k, kLen;
	            while(flag){
	                keyData = this.keyframes[i];
	                nextKeyData = this.keyframes[i+1];
	                if((nextKeyData.t - this.offsetTime) > frameNum){
	                    break;
	                }
	                if(i < len - 1){
	                    i += 1;
	                }else{
	                    flag = false;
	                }
	            }
	            isHold = keyData.h === 1;
	            iterationIndex = i;
	
	            var perc;
	            if(!isHold){
	                if(frameNum >= nextKeyData.t-this.offsetTime){
	                    perc = 1;
	                }else if(frameNum < keyData.t-this.offsetTime){
	                    perc = 0;
	                }else{
	                    var fnc;
	                    if(keyData.__fnct){
	                        fnc = keyData.__fnct;
	                    }else{
	                        fnc = BezierFactory.getBezierEasing(keyData.o.x,keyData.o.y,keyData.i.x,keyData.i.y).get;
	                        keyData.__fnct = fnc;
	                    }
	                    perc = fnc((frameNum-(keyData.t-this.offsetTime))/((nextKeyData.t-this.offsetTime)-(keyData.t-this.offsetTime)));
	                }
	                keyPropE = keyData.e[0];
	            }
	            keyPropS = keyData.s[0];
	        }
	        jLen = previousValue._length;
	        kLen = keyPropS.i[0].length;
	        var hasModified = false;
	        var vertexValue;
	        for(j=0;j<jLen;j+=1){
	            for(k=0;k<kLen;k+=1){
	                if(isHold){
	                    vertexValue = keyPropS.i[j][k];
	                    if(previousValue.i[j][k] !== vertexValue){
	                        previousValue.i[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.i[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                    vertexValue = keyPropS.o[j][k];
	                    if(previousValue.o[j][k] !== vertexValue){
	                        previousValue.o[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.o[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                    vertexValue = keyPropS.v[j][k];
	                    if(previousValue.v[j][k] !== vertexValue){
	                        previousValue.v[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.v[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                }else{
	                    vertexValue = keyPropS.i[j][k]+(keyPropE.i[j][k]-keyPropS.i[j][k])*perc;
	                    if(previousValue.i[j][k] !== vertexValue){
	                        previousValue.i[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.i[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                    vertexValue = keyPropS.o[j][k]+(keyPropE.o[j][k]-keyPropS.o[j][k])*perc;
	                    if(previousValue.o[j][k] !== vertexValue){
	                        previousValue.o[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.o[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                    vertexValue = keyPropS.v[j][k]+(keyPropE.v[j][k]-keyPropS.v[j][k])*perc;
	                    if(previousValue.v[j][k] !== vertexValue){
	                        previousValue.v[j][k] = vertexValue;
	                        if(isCurrentRender) {
	                            this.pv.v[j][k] = vertexValue;
	                        }
	                        hasModified = true;
	                    }
	                }
	            }
	        }
	        if(hasModified) {
	            previousValue.c = keyPropS.c;
	        }
	        return {
	            iterationIndex: iterationIndex,
	            hasModified: hasModified
	        }
	    }
	
	    function interpolateShapeCurrentTime(){
	        if(this.elem.globalData.frameId === this.frameId){
	            return;
	        }
	        this.mdf = false;
	        var frameNum = this.comp.renderedFrame - this.offsetTime;
	        var initTime = this.keyframes[0].t - this.offsetTime;
	        var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
	        if(!(this.lastFrame !== initFrame && ((this.lastFrame < initTime && frameNum < initTime) || (this.lastFrame > endTime && frameNum > endTime)))){
	            ////
	            var i = this.lastFrame < frameNum ? this._lastIndex : 0;
	            var renderResult = this.interpolateShape(frameNum, i, this.v, true);
	            ////
	            this._lastIndex = renderResult.iterationIndex;
	            this.mdf = renderResult.hasModified;
	            if(renderResult.hasModified) {
	                this.paths = this.localShapeCollection;
	            }
	        }
	        this.lastFrame = frameNum;
	        this.frameId = this.elem.globalData.frameId;
	    }
	
	    function getShapeValue(){
	        return this.v;
	    }
	
	    function resetShape(){
	        this.paths = this.localShapeCollection;
	        if(!this.k){
	            this.mdf = false;
	        }
	    }
	
	    function ShapeProperty(elem, data, type){
	        this.__shapeObject = 1;
	        this.comp = elem.comp;
	        this.k = false;
	        this.mdf = false;
	        var pathData = type === 3 ? data.pt.k : data.ks.k;
	        this.v = shape_pool.clone(pathData);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.reset = resetShape;
	    }
	    ShapeProperty.prototype.interpolateShape = interpolateShape;
	    ShapeProperty.prototype.getValue = getShapeValue;
	
	    function KeyframedShapeProperty(elem,data,type){
	        this.__shapeObject = 1;
	        this.comp = elem.comp;
	        this.elem = elem;
	        this.offsetTime = elem.data.st;
	        this._lastIndex = 0;
	        this.keyframes = type === 3 ? data.pt.k : data.ks.k;
	        this.k = true;
	        this.kf = true;
	        var i, len = this.keyframes[0].s[0].i.length;
	        var jLen = this.keyframes[0].s[0].i[0].length;
	        this.v = shape_pool.newShape();
	        this.v.setPathData(this.keyframes[0].s[0].c, len);
	        this.pv = shape_pool.clone(this.v);
	        this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	        this.paths = this.localShapeCollection;
	        this.paths.addShape(this.v);
	        this.lastFrame = initFrame;
	        this.reset = resetShape;
	    }
	    KeyframedShapeProperty.prototype.getValue = interpolateShapeCurrentTime;
	    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
	
	    var EllShapeProperty = (function(){
	
	        var cPoint = roundCorner;
	
	        function convertEllToPath(){
	            var p0 = this.p.v[0], p1 = this.p.v[1], s0 = this.s.v[0]/2, s1 = this.s.v[1]/2;
	            if(this.d !== 3){
	                this.v.v[0][0] = p0;
	                this.v.v[0][1] = p1-s1;
	                this.v.v[1][0] = p0 + s0;
	                this.v.v[1][1] = p1;
	                this.v.v[2][0] = p0;
	                this.v.v[2][1] = p1+s1;
	                this.v.v[3][0] = p0 - s0;
	                this.v.v[3][1] = p1;
	                this.v.i[0][0] = p0 - s0*cPoint;
	                this.v.i[0][1] = p1 - s1;
	                this.v.i[1][0] = p0 + s0;
	                this.v.i[1][1] = p1 - s1*cPoint;
	                this.v.i[2][0] = p0 + s0*cPoint;
	                this.v.i[2][1] = p1 + s1;
	                this.v.i[3][0] = p0 - s0;
	                this.v.i[3][1] = p1 + s1*cPoint;
	                this.v.o[0][0] = p0 + s0*cPoint;
	                this.v.o[0][1] = p1 - s1;
	                this.v.o[1][0] = p0 + s0;
	                this.v.o[1][1] = p1 + s1*cPoint;
	                this.v.o[2][0] = p0 - s0*cPoint;
	                this.v.o[2][1] = p1 + s1;
	                this.v.o[3][0] = p0 - s0;
	                this.v.o[3][1] = p1 - s1*cPoint;
	            }else{
	                this.v.v[0][0] = p0;
	                this.v.v[0][1] = p1-s1;
	                this.v.v[1][0] = p0 - s0;
	                this.v.v[1][1] = p1;
	                this.v.v[2][0] = p0;
	                this.v.v[2][1] = p1+s1;
	                this.v.v[3][0] = p0 + s0;
	                this.v.v[3][1] = p1;
	                this.v.i[0][0] = p0 + s0*cPoint;
	                this.v.i[0][1] = p1 - s1;
	                this.v.i[1][0] = p0 - s0;
	                this.v.i[1][1] = p1 - s1*cPoint;
	                this.v.i[2][0] = p0 - s0*cPoint;
	                this.v.i[2][1] = p1 + s1;
	                this.v.i[3][0] = p0 + s0;
	                this.v.i[3][1] = p1 + s1*cPoint;
	                this.v.o[0][0] = p0 - s0*cPoint;
	                this.v.o[0][1] = p1 - s1;
	                this.v.o[1][0] = p0 - s0;
	                this.v.o[1][1] = p1 + s1*cPoint;
	                this.v.o[2][0] = p0 + s0*cPoint;
	                this.v.o[2][1] = p1 + s1;
	                this.v.o[3][0] = p0 + s0;
	                this.v.o[3][1] = p1 - s1*cPoint;
	            }
	        }
	
	        function processKeys(frameNum){
	            var i, len = this.dynamicProperties.length;
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue(frameNum);
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertEllToPath();
	            }
	        }
	
	        return function EllShapeProperty(elem,data) {
	            /*this.v = {
	                v: Array.apply(null,{length:4}),
	                i: Array.apply(null,{length:4}),
	                o: Array.apply(null,{length:4}),
	                c: true
	            };*/
	            this.v = shape_pool.newShape();
	            this.v.setPathData(true, 4);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.paths = this.localShapeCollection;
	            this.localShapeCollection.addShape(this.v);
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.convertEllToPath = convertEllToPath;
	            this.reset = resetShape;
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertEllToPath();
	            }
	        }
	    }());
	
	    var StarShapeProperty = (function() {
	
	        function convertPolygonToPath(){
	            var numPts = Math.floor(this.pt.v);
	            var angle = Math.PI*2/numPts;
	            /*this.v.v.length = numPts;
	            this.v.i.length = numPts;
	            this.v.o.length = numPts;*/
	            var rad = this.or.v;
	            var roundness = this.os.v;
	            var perimSegment = 2*Math.PI*rad/(numPts*4);
	            var i, currentAng = -Math.PI/ 2;
	            var dir = this.data.d === 3 ? -1 : 1;
	            currentAng += this.r.v;
	            this.v._length = 0;
	            for(i=0;i<numPts;i+=1){
	                var x = rad * Math.cos(currentAng);
	                var y = rad * Math.sin(currentAng);
	                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                x +=  + this.p.v[0];
	                y +=  + this.p.v[1];
	                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	                /*this.v.v[i] = [x,y];
	                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];*/
	                currentAng += angle*dir;
	            }
	            this.paths.length = 0;
	            this.paths[0] = this.v;
	        }
	
	        function convertStarToPath() {
	            var numPts = Math.floor(this.pt.v)*2;
	            var angle = Math.PI*2/numPts;
	            /*this.v.v.length = numPts;
	            this.v.i.length = numPts;
	            this.v.o.length = numPts;*/
	            var longFlag = true;
	            var longRad = this.or.v;
	            var shortRad = this.ir.v;
	            var longRound = this.os.v;
	            var shortRound = this.is.v;
	            var longPerimSegment = 2*Math.PI*longRad/(numPts*2);
	            var shortPerimSegment = 2*Math.PI*shortRad/(numPts*2);
	            var i, rad,roundness,perimSegment, currentAng = -Math.PI/ 2;
	            currentAng += this.r.v;
	            var dir = this.data.d === 3 ? -1 : 1;
	            this.v._length = 0;
	            for(i=0;i<numPts;i+=1){
	                rad = longFlag ? longRad : shortRad;
	                roundness = longFlag ? longRound : shortRound;
	                perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
	                var x = rad * Math.cos(currentAng);
	                var y = rad * Math.sin(currentAng);
	                var ox = x === 0 && y === 0 ? 0 : y/Math.sqrt(x*x + y*y);
	                var oy = x === 0 && y === 0 ? 0 : -x/Math.sqrt(x*x + y*y);
	                x +=  + this.p.v[0];
	                y +=  + this.p.v[1];
	                this.v.setTripleAt(x,y,x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir,x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir, i, true);
	
	                /*this.v.v[i] = [x,y];
	                this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
	                this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
	                this.v._length = numPts;*/
	                longFlag = !longFlag;
	                currentAng += angle*dir;
	            }
	        }
	
	        function processKeys() {
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	            var i, len = this.dynamicProperties.length;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue();
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertToPath();
	            }
	        }
	
	        return function StarShapeProperty(elem,data) {
	            /*this.v = {
	                v: [],
	                i: [],
	                o: [],
	                c: true
	            };*/
	            this.v = shape_pool.newShape();
	            this.v.setPathData(true, 0);
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.data = data;
	            this.frameId = -1;
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.reset = resetShape;
	            if(data.sy === 1){
	                this.ir = PropertyFactory.getProp(elem,data.ir,0,0,this.dynamicProperties);
	                this.is = PropertyFactory.getProp(elem,data.is,0,0.01,this.dynamicProperties);
	                this.convertToPath = convertStarToPath;
	            } else {
	                this.convertToPath = convertPolygonToPath;
	            }
	            this.pt = PropertyFactory.getProp(elem,data.pt,0,0,this.dynamicProperties);
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.r = PropertyFactory.getProp(elem,data.r,0,degToRads,this.dynamicProperties);
	            this.or = PropertyFactory.getProp(elem,data.or,0,0,this.dynamicProperties);
	            this.os = PropertyFactory.getProp(elem,data.os,0,0.01,this.dynamicProperties);
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertToPath();
	            }
	        }
	    }());
	
	    var RectShapeProperty = (function() {
	        function processKeys(frameNum){
	            if(this.elem.globalData.frameId === this.frameId){
	                return;
	            }
	            this.mdf = false;
	            this.frameId = this.elem.globalData.frameId;
	            var i, len = this.dynamicProperties.length;
	
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue(frameNum);
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	            if(this.mdf){
	                this.convertRectToPath();
	            }
	
	        }
	
	        function convertRectToPath(){
	            var p0 = this.p.v[0], p1 = this.p.v[1], v0 = this.s.v[0]/2, v1 = this.s.v[1]/2;
	            var round = bm_min(v0,v1,this.r.v);
	            var cPoint = round*(1-roundCorner);
	            this.v._length = 0;
	
	            if(this.d === 2 || this.d === 1) {
	                this.v.setTripleAt(p0+v0, p1-v1+round,p0+v0, p1-v1+round,p0+v0,p1-v1+cPoint,0, true);
	                this.v.setTripleAt(p0+v0, p1+v1-round,p0+v0, p1+v1-cPoint,p0+v0, p1+v1-round,1, true);
	                if(round!== 0){
	                    this.v.setTripleAt(p0+v0-round, p1+v1,p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,2, true);
	                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,p0-v0+round,p1+v1,3, true);
	                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,4, true);
	                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,p0-v0,p1-v1+round,5, true);
	                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,6, true);
	                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,p0+v0-round,p1-v1,7, true);
	                } else {
	                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0+cPoint,p1+v1,p0-v0,p1+v1,2);
	                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0,p1-v1+cPoint,p0-v0,p1-v1,3);
	                }
	            }else{
	                this.v.setTripleAt(p0+v0,p1-v1+round,p0+v0,p1-v1+cPoint,p0+v0,p1-v1+round,0, true);
	                if(round!== 0){
	                    this.v.setTripleAt(p0+v0-round,p1-v1,p0+v0-round,p1-v1,p0+v0-cPoint,p1-v1,1, true);
	                    this.v.setTripleAt(p0-v0+round,p1-v1,p0-v0+cPoint,p1-v1,p0-v0+round,p1-v1,2, true);
	                    this.v.setTripleAt(p0-v0,p1-v1+round,p0-v0,p1-v1+round,p0-v0,p1-v1+cPoint,3, true);
	                    this.v.setTripleAt(p0-v0,p1+v1-round,p0-v0,p1+v1-cPoint,p0-v0,p1+v1-round,4, true);
	                    this.v.setTripleAt(p0-v0+round,p1+v1,p0-v0+round,p1+v1,p0-v0+cPoint,p1+v1,5, true);
	                    this.v.setTripleAt(p0+v0-round,p1+v1,p0+v0-cPoint,p1+v1,p0+v0-round,p1+v1,6, true);
	                    this.v.setTripleAt(p0+v0,p1+v1-round,p0+v0,p1+v1-round,p0+v0,p1+v1-cPoint,7, true);
	                } else {
	                    this.v.setTripleAt(p0-v0,p1-v1,p0-v0+cPoint,p1-v1,p0-v0,p1-v1,1, true);
	                    this.v.setTripleAt(p0-v0,p1+v1,p0-v0,p1+v1-cPoint,p0-v0,p1+v1,2, true);
	                    this.v.setTripleAt(p0+v0,p1+v1,p0+v0-cPoint,p1+v1,p0+v0,p1+v1,3, true);
	
	                }
	            }
	        }
	
	        return function RectShapeProperty(elem,data) {
	            this.v = shape_pool.newShape();
	            this.v.c = true;
	            this.localShapeCollection = shapeCollection_pool.newShapeCollection();
	            this.localShapeCollection.addShape(this.v);
	            this.paths = this.localShapeCollection;
	            this.elem = elem;
	            this.comp = elem.comp;
	            this.frameId = -1;
	            this.d = data.d;
	            this.dynamicProperties = [];
	            this.mdf = false;
	            this.getValue = processKeys;
	            this.convertRectToPath = convertRectToPath;
	            this.reset = resetShape;
	            this.p = PropertyFactory.getProp(elem,data.p,1,0,this.dynamicProperties);
	            this.s = PropertyFactory.getProp(elem,data.s,1,0,this.dynamicProperties);
	            this.r = PropertyFactory.getProp(elem,data.r,0,0,this.dynamicProperties);
	            if(this.dynamicProperties.length){
	                this.k = true;
	            }else{
	                this.convertRectToPath();
	            }
	        }
	    }());
	
	    function getShapeProp(elem,data,type, arr){
	        var prop;
	        if(type === 3 || type === 4){
	            var dataProp = type === 3 ? data.pt : data.ks;
	            var keys = dataProp.k;
	            if(dataProp.a === 1 || keys.length){
	                prop = new KeyframedShapeProperty(elem, data, type);
	            }else{
	                prop = new ShapeProperty(elem, data, type);
	            }
	        }else if(type === 5){
	            prop = new RectShapeProperty(elem, data);
	        }else if(type === 6){
	            prop = new EllShapeProperty(elem, data);
	        }else if(type === 7){
	            prop = new StarShapeProperty(elem, data);
	        }
	        if(prop.k){
	            arr.push(prop);
	        }
	        return prop;
	    }
	
	    function getConstructorFunction() {
	        return ShapeProperty;
	    }
	
	    function getKeyframedConstructorFunction() {
	        return KeyframedShapeProperty;
	    }
	
	    var ob = {};
	    ob.getShapeProp = getShapeProp;
	    ob.getConstructorFunction = getConstructorFunction;
	    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
	    return ob;
	}());
	var ShapeModifiers = (function(){
	    var ob = {};
	    var modifiers = {};
	    ob.registerModifier = registerModifier;
	    ob.getModifier = getModifier;
	
	    function registerModifier(nm,factory){
	        if(!modifiers[nm]){
	            modifiers[nm] = factory;
	        }
	    }
	
	    function getModifier(nm,elem, data, dynamicProperties){
	        return new modifiers[nm](elem, data, dynamicProperties);
	    }
	
	    return ob;
	}());
	
	function ShapeModifier(){}
	ShapeModifier.prototype.initModifierProperties = function(){};
	ShapeModifier.prototype.addShapeToModifier = function(){};
	ShapeModifier.prototype.addShape = function(data){
	    if(!this.closed){
	        this.shapes.push({shape:data.sh, data: data, localShapeCollection:shapeCollection_pool.newShapeCollection()});
	        this.addShapeToModifier(data.sh);
	    }
	}
	ShapeModifier.prototype.init = function(elem,data,dynamicProperties){
	    this.elem = elem;
	    this.frameId = -1;
	    this.shapes = [];
	    this.dynamicProperties = [];
	    this.mdf = false;
	    this.closed = false;
	    this.k = false;
	    this.comp = elem.comp;
	    this.initModifierProperties(elem,data);
	    if(this.dynamicProperties.length){
	        this.k = true;
	        dynamicProperties.push(this);
	    }else{
	        this.getValue(true);
	    }
	}
	function TrimModifier(){};
	extendPrototype(ShapeModifier,TrimModifier);
	TrimModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    this.frameId = this.elem.globalData.frameId;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	    if(this.mdf || forceRender){
	        var o = (this.o.v%360)/360;
	        if(o < 0){
	            o += 1;
	        }
	        var s = this.s.v + o;
	        var e = this.e.v + o;
	        if(s == e){
	
	        }
	        if(s>e){
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        this.sValue = s;
	        this.eValue = e;
	        this.oValue = o;
	    }
	}
	TrimModifier.prototype.initModifierProperties = function(elem,data){
	    this.sValue = 0;
	    this.eValue = 0;
	    this.oValue = 0;
	    this.getValue = this.processKeys;
	    this.s = PropertyFactory.getProp(elem,data.s,0,0.01,this.dynamicProperties);
	    this.e = PropertyFactory.getProp(elem,data.e,0,0.01,this.dynamicProperties);
	    this.o = PropertyFactory.getProp(elem,data.o,0,0,this.dynamicProperties);
	    this.m = data.m;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	};
	
	TrimModifier.prototype.calculateShapeEdges = function(s, e, shapeLength, addedLength, totalModifierLength) {
	    var segments = []
	    if(e <= 1){
	        segments.push({
	            s: s,
	            e: e
	        })
	    }else if(s >= 1){
	        segments.push({
	            s: s - 1,
	            e: e - 1
	        })
	    }else{
	        segments.push({
	            s: s,
	            e: 1
	        })
	        segments.push({
	            s: 0,
	            e: e - 1
	        })
	    }
	    var shapeSegments = [];
	    var i, len = segments.length, segmentOb;
	    for(i = 0; i < len; i += 1) {
	        segmentOb = segments[i];
	        if (segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength) {
	            
	        } else {
	            var shapeS, shapeE;
	            if(segmentOb.s * totalModifierLength <= addedLength) {
	                shapeS = 0;
	            } else {
	                shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
	            }
	            if(segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
	                shapeE = 1;
	            } else {
	                shapeE = ((segmentOb.e * totalModifierLength - addedLength) / shapeLength);
	            }
	            shapeSegments.push([shapeS, shapeE]);
	        }
	    }
	    if(!shapeSegments.length){
	        shapeSegments.push([0,0]);
	    }
	    return shapeSegments;
	}
	
	TrimModifier.prototype.processShapes = function(firstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var s = this.sValue;
	    var e = this.eValue;
	    var pathsData,pathData, totalShapeLength, totalModifierLength = 0;
	
	    if(e === s){
	        for(i=0;i<len;i+=1){
	            this.shapes[i].localShapeCollection.releaseShapes();
	            this.shapes[i].shape.mdf = true;
	            this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;
	        }
	    } else if(!((e === 1 && s === 0) || (e===0 && s === 1))){
	        var segments = [], shapeData, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            if(!shapeData.shape.mdf && !this.mdf && !firstFrame && this.m !== 2){
	                shapeData.shape.paths = shapeData.localShapeCollection;
	            } else {
	                shapePaths = shapeData.shape.paths;
	                jLen = shapePaths._length;
	                totalShapeLength = 0;
	                if(!shapeData.shape.mdf && shapeData.pathsData){
	                    totalShapeLength = shapeData.totalShapeLength;
	                } else {
	                    pathsData = [];
	                    for(j=0;j<jLen;j+=1){
	                        pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
	                        pathsData.push(pathData);
	                        totalShapeLength += pathData.totalLength;
	                    }
	                    shapeData.totalShapeLength = totalShapeLength;
	                    shapeData.pathsData = pathsData;
	                }
	
	                totalModifierLength += totalShapeLength;
	                shapeData.shape.mdf = true;
	            }
	        }
	        var shapeS = s, shapeE = e, addedLength = 0;
	        var j, jLen;
	        for(i = len - 1; i >= 0; i -= 1){
	            shapeData = this.shapes[i];
	            if (shapeData.shape.mdf) {
	                localShapeCollection = shapeData.localShapeCollection;
	                localShapeCollection.releaseShapes();
	                if(this.m === 2 && len > 1) {
	                    var edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
	                    addedLength += shapeData.totalShapeLength;
	                } else {
	                    edges = [[shapeS, shapeE]]
	                }
	                jLen = edges.length;
	                for (j = 0; j < jLen; j += 1) {
	                    shapeS = edges[j][0];
	                    shapeE = edges[j][1];
	                    segments.length = 0;
	                    if(shapeE <= 1){
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength * shapeE
	                        })
	                    }else if(shapeS >= 1){
	                        segments.push({
	                            s:shapeData.totalShapeLength * (shapeS - 1),
	                            e:shapeData.totalShapeLength * (shapeE - 1)
	                        })
	                    }else{
	                        segments.push({
	                            s:shapeData.totalShapeLength * shapeS,
	                            e:shapeData.totalShapeLength
	                        })
	                        segments.push({
	                            s:0,
	                            e:shapeData.totalShapeLength*(shapeE - 1)
	                        })
	                    }
	                    var newShapesData = this.addShapes(shapeData,segments[0]);
	                    if (segments[0].s !== segments[0].e) {
	                        var lastPos;
	                        if(segments.length > 1){
	                            if(shapeData.shape.v.c){
	                                var lastShape = newShapesData.pop();
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData,segments[1], lastShape);
	                            } else {
	                                this.addPaths(newShapesData, localShapeCollection);
	                                newShapesData = this.addShapes(shapeData,segments[1]);
	                            }
	                        } 
	                        this.addPaths(newShapesData, localShapeCollection);
	                    }
	                    
	                }
	                shapeData.shape.paths = localShapeCollection;
	            }
	        }
	    } else if(this.mdf){
	        for(i=0;i<len;i+=1){
	            this.shapes[i].shape.mdf = true;
	        }
	    }
	    if(!this.dynamicProperties.length){
	        this.mdf = false;
	    }
	}
	
	TrimModifier.prototype.addPaths = function(newPaths, localShapeCollection) {
	    var i, len = newPaths.length;
	    for(i = 0; i < len; i += 1) {
	        localShapeCollection.addShape(newPaths[i])
	    }
	}
	
	TrimModifier.prototype.addSegment = function(pt1,pt2,pt3,pt4,shapePath,pos, newShape) {
	    /*console.log(pt1, 'vertex: v, at: ', pos);
	    console.log(pt2, 'vertex: o, at: ', pos);
	    console.log(pt3, 'vertex: i, at: ', pos + 1);
	    console.log(pt4, 'vertex: v, at: ', pos + 1);
	    console.log('newShape: ', newShape);*/
	    shapePath.setXYAt(pt2[0],pt2[1],'o',pos);
	    shapePath.setXYAt(pt3[0],pt3[1],'i',pos + 1);
	    if(newShape){
	        shapePath.setXYAt(pt1[0],pt1[1],'v',pos);
	    }
	    shapePath.setXYAt(pt4[0],pt4[1],'v',pos + 1);
	}
	
	TrimModifier.prototype.addShapes = function(shapeData, shapeSegment, shapePath){
	    var pathsData = shapeData.pathsData;
	    var shapePaths = shapeData.shape.paths.shapes;
	    var i, len = shapeData.shape.paths._length, j, jLen;
	    var addedLength = 0;
	    var currentLengthData,segmentCount;
	    var lengths;
	    var segment;
	    var shapes = [];
	    var initPos;
	    var newShape = true;
	    if(!shapePath){
	        shapePath = shape_pool.newShape();
	        segmentCount = 0;
	        initPos = 0;
	    } else {
	        segmentCount = shapePath._length;
	        initPos = shapePath._length;
	    }
	    shapes.push(shapePath);
	    for(i=0;i<len;i+=1){
	        lengths = pathsData[i].lengths;
	        shapePath.c = shapePaths[i].c;
	        jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;
	        for(j=1;j<jLen;j+=1){
	            currentLengthData = lengths[j-1];
	            if(addedLength + currentLengthData.addedLength < shapeSegment.s){
	                addedLength += currentLengthData.addedLength;
	                shapePath.c = false;
	            } else if(addedLength > shapeSegment.e){
	                shapePath.c = false;
	                break;
	            } else {
	                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength){
	                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[j],shapePaths[i].v[j],shapePath,segmentCount,newShape);
	                    newShape = false;
	                } else {
	                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[j],shapePaths[i].o[j-1],shapePaths[i].i[j], (shapeSegment.s - addedLength)/currentLengthData.addedLength,(shapeSegment.e - addedLength)/currentLengthData.addedLength, lengths[j-1]);
	                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	                addedLength += currentLengthData.addedLength;
	                segmentCount += 1;
	            }
	        }
	        if(shapePaths[i].c){
	            currentLengthData = lengths[j-1];
	            if(addedLength <= shapeSegment.e){
	                var segmentLength = lengths[j-1].addedLength;
	                if(shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength){
	                    this.addSegment(shapePaths[i].v[j-1],shapePaths[i].o[j-1],shapePaths[i].i[0],shapePaths[i].v[0],shapePath,segmentCount,newShape);
	                    newShape = false;
	                }else{
	                    segment = bez.getNewSegment(shapePaths[i].v[j-1],shapePaths[i].v[0],shapePaths[i].o[j-1],shapePaths[i].i[0], (shapeSegment.s - addedLength)/segmentLength,(shapeSegment.e - addedLength)/segmentLength, lengths[j-1]);
	                    this.addSegment(segment.pt1,segment.pt3,segment.pt4,segment.pt2,shapePath,segmentCount,newShape);
	                    newShape = false;
	                    shapePath.c = false;
	                }
	            } else {
	                shapePath.c = false;
	            }
	            addedLength += currentLengthData.addedLength;
	            segmentCount += 1;
	        }
	        if(shapePath._length){
	            shapePath.setXYAt(shapePath.v[initPos][0],shapePath.v[initPos][1],'i',initPos);
	            shapePath.setXYAt(shapePath.v[shapePath._length - 1][0],shapePath.v[shapePath._length - 1][1],'o',shapePath._length - 1);
	        }
	        if(addedLength > shapeSegment.e){
	            break;
	        }
	        if(i<len-1){
	            shapePath = shape_pool.newShape();
	            newShape = true;
	            shapes.push(shapePath);
	            segmentCount = 0;
	        }
	    }
	    return shapes;
	
	}
	
	
	ShapeModifiers.registerModifier('tm',TrimModifier);
	function RoundCornersModifier(){};
	extendPrototype(ShapeModifier,RoundCornersModifier);
	RoundCornersModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    this.frameId = this.elem.globalData.frameId;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	}
	RoundCornersModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.rd = PropertyFactory.getProp(elem,data.r,0,null,this.dynamicProperties);
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	};
	
	RoundCornersModifier.prototype.processPath = function(path, round){
	    var cloned_path = shape_pool.newShape();
	    cloned_path.c = path.c;
	    var i, len = path._length;
	    var currentV,currentI,currentO,closerV, newV,newO,newI,distance,newPosPerc,index = 0;
	    var vX,vY,oX,oY,iX,iY;
	    for(i=0;i<len;i+=1){
	        currentV = path.v[i];
	        currentO = path.o[i];
	        currentI = path.i[i];
	        if(currentV[0]===currentO[0] && currentV[1]===currentO[1] && currentV[0]===currentI[0] && currentV[1]===currentI[1]){
	            if((i===0 || i === len - 1) && !path.c){
	                cloned_path.setTripleAt(currentV[0],currentV[1],currentO[0],currentO[1],currentI[0],currentI[1],index);
	                /*cloned_path.v[index] = currentV;
	                cloned_path.o[index] = currentO;
	                cloned_path.i[index] = currentI;*/
	                index += 1;
	            } else {
	                if(i===0){
	                    closerV = path.v[len-1];
	                } else {
	                    closerV = path.v[i-1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = iX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = iY = currentV[1]-(currentV[1]-closerV[1])*newPosPerc;
	                oX = vX-(vX-currentV[0])*roundCorner;
	                oY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	
	                if(i === len - 1){
	                    closerV = path.v[0];
	                } else {
	                    closerV = path.v[i+1];
	                }
	                distance = Math.sqrt(Math.pow(currentV[0]-closerV[0],2)+Math.pow(currentV[1]-closerV[1],2));
	                newPosPerc = distance ? Math.min(distance/2,round)/distance : 0;
	                vX = oX = currentV[0]+(closerV[0]-currentV[0])*newPosPerc;
	                vY = oY = currentV[1]+(closerV[1]-currentV[1])*newPosPerc;
	                iX = vX-(vX-currentV[0])*roundCorner;
	                iY = vY-(vY-currentV[1])*roundCorner;
	                cloned_path.setTripleAt(vX,vY,oX,oY,iX,iY,index);
	                index += 1;
	            }
	        } else {
	            cloned_path.setTripleAt(path.v[i][0],path.v[i][1],path.o[i][0],path.o[i][1],path.i[i][0],path.i[i][1],index);
	            index += 1;
	        }
	    }
	    return cloned_path;
	}
	
	RoundCornersModifier.prototype.processShapes = function(firstFrame){
	    var shapePaths;
	    var i, len = this.shapes.length;
	    var j, jLen;
	    var rd = this.rd.v;
	
	    if(rd !== 0){
	        var shapeData, newPaths, localShapeCollection;
	        for(i=0;i<len;i+=1){
	            shapeData = this.shapes[i];
	            newPaths = shapeData.shape.paths;
	            localShapeCollection = shapeData.localShapeCollection;
	            if(!(!shapeData.shape.mdf && !this.mdf && !firstFrame)){
	                localShapeCollection.releaseShapes();
	                shapeData.shape.mdf = true;
	                shapePaths = shapeData.shape.paths.shapes;
	                jLen = shapeData.shape.paths._length;
	                for(j=0;j<jLen;j+=1){
	                    localShapeCollection.addShape(this.processPath(shapePaths[j],rd));
	                }
	            }
	            shapeData.shape.paths = shapeData.localShapeCollection;
	        }
	
	    }
	    if(!this.dynamicProperties.length){
	        this.mdf = false;
	    }
	}
	
	
	ShapeModifiers.registerModifier('rd',RoundCornersModifier);
	function RepeaterModifier(){};
	RepeaterModifier.prototype.processKeys = function(forceRender){
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    this.mdf = forceRender ? true : false;
	    var i, len = this.dynamicProperties.length;
	
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        if(this.dynamicProperties[i].mdf){
	            this.mdf = true;
	        }
	    }
	};
	
	RepeaterModifier.prototype.initModifierProperties = function(elem,data){
	    this.getValue = this.processKeys;
	    this.c = PropertyFactory.getProp(elem,data.c,0,null,this.dynamicProperties);
	    this.o = PropertyFactory.getProp(elem,data.o,0,null,this.dynamicProperties);
	    this.tr = TransformPropertyFactory.getTransformProperty(elem,data.tr,this.dynamicProperties);
	    this.data = data;
	    if(!this.dynamicProperties.length){
	        this.getValue(true);
	    }
	    this.pMatrix = new Matrix();
	    this.rMatrix = new Matrix();
	    this.sMatrix = new Matrix();
	    this.tMatrix = new Matrix();
	    this.matrix = new Matrix();
	};
	
	RepeaterModifier.prototype.applyTransforms = function(pMatrix, rMatrix, sMatrix, transform, perc, inv){
	    var dir = inv ? -1 : 1;
	    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
	    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
	    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
	    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    rMatrix.rotate(-transform.r.v * dir * perc);
	    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
	    sMatrix.scale(inv ? 1/scaleX : scaleX, inv ? 1/scaleY : scaleY);
	    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
	}
	
	RepeaterModifier.prototype.init = function(elem, arr, pos, elemsData, dynamicProperties) {
	    this.elem = elem;
	    this.arr = arr;
	    this.pos = pos;
	    this.elemsData = elemsData;
	    this._currentCopies = 0;
	    this._elements = [];
	    this._groups = [];
	    this.dynamicProperties = [];
	    this.frameId = -1;
	    this.initModifierProperties(elem,arr[pos]);
	    var cont = 0;
	    while(pos>0){
	        pos -= 1;
	        //this._elements.unshift(arr.splice(pos,1)[0]);
	        this._elements.unshift(arr[pos]);
	        cont += 1;
	    }
	    if(this.dynamicProperties.length){
	        this.k = true;
	        dynamicProperties.push(this);
	    }else{
	        this.getValue(true);
	    }
	}
	
	RepeaterModifier.prototype.resetElements = function(elements){
	    var i, len = elements.length;
	    for(i = 0; i < len; i += 1) {
	        elements[i]._processed = false;
	        if(elements[i].ty === 'gr'){
	            this.resetElements(elements[i].it);
	        }
	    }
	}
	
	RepeaterModifier.prototype.cloneElements = function(elements){
	    var i, len = elements.length;
	    var newElements = JSON.parse(JSON.stringify(elements));
	    this.resetElements(newElements);
	    return newElements;
	}
	
	RepeaterModifier.prototype.changeGroupRender = function(elements, renderFlag) {
	    var i, len = elements.length;
	    for(i = 0; i < len ; i += 1) {
	        elements[i]._render = renderFlag;
	        if(elements[i].ty === 'gr') {
	            this.changeGroupRender(elements[i].it, renderFlag);
	        }
	    }
	}
	
	RepeaterModifier.prototype.processShapes = function(firstFrame){
	
	    if(this.elem.globalData.frameId === this.frameId){
	        return;
	    }
	    this.frameId = this.elem.globalData.frameId;
	    if(!this.dynamicProperties.length && !firstFrame){
	        this.mdf = false;
	    }
	    if(this.mdf){
	        var copies = Math.ceil(this.c.v);
	        if(this._groups.length < copies){
	            while(this._groups.length < copies){
	                var group = {
	                    it:this.cloneElements(this._elements),
	                    ty:'gr'
	                }
	                group.it.push({"a":{"a":0,"ix":1,"k":[0,0]},"nm":"Transform","o":{"a":0,"ix":7,"k":100},"p":{"a":0,"ix":2,"k":[0,0]},"r":{"a":0,"ix":6,"k":0},"s":{"a":0,"ix":3,"k":[100,100]},"sa":{"a":0,"ix":5,"k":0},"sk":{"a":0,"ix":4,"k":0},"ty":"tr"});
	                
	                this.arr.splice(0,0,group);
	                this._groups.splice(0,0,group);
	                this._currentCopies += 1;
	            }
	            this.elem.reloadShapes();
	        }
	        var i, cont = 0, renderFlag;
	        for(i = 0; i  <= this._groups.length - 1; i += 1){
	            renderFlag = cont < copies;
	            this._groups[i]._render = renderFlag;
	            this.changeGroupRender(this._groups[i].it, renderFlag);
	            cont += 1;
	        }
	        
	        this._currentCopies = copies;
	        this.elem.firstFrame = true;
	        ////
	
	        var offset = this.o.v;
	        var offsetModulo = offset%1;
	        var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
	        var k;
	        var tMat = this.tr.v.props;
	        var pProps = this.pMatrix.props;
	        var rProps = this.rMatrix.props;
	        var sProps = this.sMatrix.props;
	        this.pMatrix.reset();
	        this.rMatrix.reset();
	        this.sMatrix.reset();
	        this.tMatrix.reset();
	        this.matrix.reset();
	        var iteration = 0;
	
	        if(offset > 0) {
	            while(iteration<roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                iteration += 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
	                iteration += offsetModulo;
	            }
	        } else if(offset < 0) {
	            while(iteration>roundOffset){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
	                iteration -= 1;
	            }
	            if(offsetModulo){
	                this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, - offsetModulo, true);
	                iteration -= offsetModulo;
	            }
	        }
	        i = this.data.m === 1 ? 0 : this._currentCopies - 1;
	        var dir = this.data.m === 1 ? 1 : -1;
	        cont = this._currentCopies;
	        while(cont){
	            if(iteration !== 0){
	                if((i !== 0 && dir === 1) || (i !== this._currentCopies - 1 && dir === -1)){
	                    this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
	                }
	                this.matrix.transform(rProps[0],rProps[1],rProps[2],rProps[3],rProps[4],rProps[5],rProps[6],rProps[7],rProps[8],rProps[9],rProps[10],rProps[11],rProps[12],rProps[13],rProps[14],rProps[15]);
	                this.matrix.transform(sProps[0],sProps[1],sProps[2],sProps[3],sProps[4],sProps[5],sProps[6],sProps[7],sProps[8],sProps[9],sProps[10],sProps[11],sProps[12],sProps[13],sProps[14],sProps[15]);
	                this.matrix.transform(pProps[0],pProps[1],pProps[2],pProps[3],pProps[4],pProps[5],pProps[6],pProps[7],pProps[8],pProps[9],pProps[10],pProps[11],pProps[12],pProps[13],pProps[14],pProps[15]);
	                var items = this.elemsData[i].it;
	                var itemsTransform = items[items.length - 1].transform.mProps.v.props;
	                var j, jLen = itemsTransform.length;
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	                this.matrix.reset();
	            } else {
	                this.matrix.reset();
	                var items = this.elemsData[i].it;
	                var itemsTransform = items[items.length - 1].transform.mProps.v.props;
	                var j, jLen = itemsTransform.length;
	                for(j=0;j<jLen;j+=1) {
	                    itemsTransform[j] = this.matrix.props[j];
	                }
	            }
	            iteration += 1;
	            cont -= 1;
	            i += dir;
	        }
	    }
	}
	
	RepeaterModifier.prototype.addShape = function(){}
	
	ShapeModifiers.registerModifier('rp',RepeaterModifier);
	function ShapeCollection(){
		this._length = 0;
		this._maxLength = 4;
		this.shapes = Array.apply(null,{length:this._maxLength});
	};
	
	ShapeCollection.prototype.addShape = function(shapeData){
		if(this._length === this._maxLength){
			this.shapes = this.shapes.concat(Array.apply(null,{length:this._maxLength}));
			this._maxLength *= 2;
		}
		this.shapes[this._length] = shapeData;
		this._length += 1;
	};
	
	ShapeCollection.prototype.releaseShapes = function(){
		var i;
		for(i = 0; i < this._length; i += 1) {
			shape_pool.release(this.shapes[i]);
		}
		this._length = 0;
	};
	function DashProperty(elem, data, renderer, dynamicProperties) {
	    this.elem = elem;
	    this.frameId = -1;
	    this.dataProps = Array.apply(null,{length:data.length});
	    this.renderer = renderer;
	    this.mdf = false;
	    this.k = false;
	    this.dashStr = '';
	    this.dashArray = createTypedArray('float32',  data.length - 1);
	    this.dashoffset = createTypedArray('float32',  1);
	    var i, len = data.length, prop;
	    for(i=0;i<len;i+=1){
	        prop = PropertyFactory.getProp(elem,data[i].v,0, 0, dynamicProperties);
	        this.k = prop.k ? true : this.k;
	        this.dataProps[i] = {n:data[i].n,p:prop};
	    }
	    if(this.k){
	        dynamicProperties.push(this);
	    }else{
	        this.getValue(true);
	    }
	}
	
	DashProperty.prototype.getValue = function(forceRender) {
	    if(this.elem.globalData.frameId === this.frameId && !forceRender){
	        return;
	    }
	    var i = 0, len = this.dataProps.length;
	    this.mdf = false;
	    this.frameId = this.elem.globalData.frameId;
	    while(i<len){
	        if(this.dataProps[i].p.mdf){
	            this.mdf = !forceRender;
	            break;
	        }
	        i+=1;
	    }
	    if(this.mdf || forceRender){
	        if(this.renderer === 'svg') {
	            this.dashStr = '';
	        }
	        for(i=0;i<len;i+=1){
	            if(this.dataProps[i].n != 'o'){
	                if(this.renderer === 'svg') {
	                    this.dashStr += ' ' + this.dataProps[i].p.v;
	                }else{
	                    this.dashArray[i] = this.dataProps[i].p.v;
	                }
	            }else{
	                this.dashoffset[0] = this.dataProps[i].p.v;
	            }
	        }
	    }
	}
	function GradientProperty(elem,data,arr){
	    this.prop = PropertyFactory.getProp(elem,data.k,1,null,[]);
	    this.data = data;
	    this.k = this.prop.k;
	    this.c = createTypedArray('uint8c', data.p*4)
	    var cLength = data.k.k[0].s ? (data.k.k[0].s.length - data.p*4) : data.k.k.length - data.p*4;
	    this.o = createTypedArray('float32', cLength);
	    this.cmdf = false;
	    this.omdf = false;
	    if(this.prop.k){
	        arr.push(this);
	    }
	    this.getValue(true);
	}
	
	GradientProperty.prototype.getValue = function(forceRender){
	    this.prop.getValue();
	    this.cmdf = false;
	    this.omdf = false;
	    if(this.prop.mdf || forceRender){
	        var i, len = this.data.p*4;
	        var mult, val;
	        for(i=0;i<len;i+=1){
	            mult = i%4 === 0 ? 100 : 255;
	            val = Math.round(this.prop.v[i]*mult);
	            if(this.c[i] !== val){
	                this.c[i] = val;
	                this.cmdf = !forceRender;
	            }
	        }
	        if(this.o.length){
	            len = this.prop.v.length;
	            for(i=this.data.p*4;i<len;i+=1){
	                mult = i%2 === 0 ? 100 : 1;
	                val = i%2 === 0 ?  Math.round(this.prop.v[i]*100):this.prop.v[i];
	                if(this.o[i-this.data.p*4] !== val){
	                    this.o[i-this.data.p*4] = val;
	                    this.omdf = !forceRender;
	                }
	            }
	        }
	    }
	}
	var ImagePreloader = (function(){
	
	    function imageLoaded(){
	        this.loadedAssets += 1;
	        if(this.loadedAssets === this.totalImages){
	            if(this.imagesLoadedCb) {
	                this.imagesLoadedCb(null);
	            }
	        }
	    }
	
	    function getAssetsPath(assetData){
	        var path = '';
	        if(this.assetsPath){
	            var imagePath = assetData.p;
	            if(imagePath.indexOf('images/') !== -1){
	                imagePath = imagePath.split('/')[1];
	            }
	            path = this.assetsPath + imagePath;
	        } else {
	            path = this.path;
	            path += assetData.u ? assetData.u : '';
	            path += assetData.p;
	        }
	        return path;
	    }
	
	    function loadImage(path){
	        var img = document.createElement('img');
	        img.addEventListener('load', imageLoaded.bind(this), false);
	        img.addEventListener('error', imageLoaded.bind(this), false);
	        img.src = path;
	    }
	    function loadAssets(assets, cb){
	        this.imagesLoadedCb = cb;
	        this.totalAssets = assets.length;
	        var i;
	        for(i=0;i<this.totalAssets;i+=1){
	            if(!assets[i].layers){
	                loadImage.bind(this)(getAssetsPath.bind(this)(assets[i]));
	                this.totalImages += 1;
	            }
	        }
	    }
	
	    function setPath(path){
	        this.path = path || '';
	    }
	
	    function setAssetsPath(path){
	        this.assetsPath = path || '';
	    }
	
	    function destroy() {
	        this.imagesLoadedCb = null;
	    }
	
	    return function ImagePreloader(){
	        this.loadAssets = loadAssets;
	        this.setAssetsPath = setAssetsPath;
	        this.setPath = setPath;
	        this.destroy = destroy;
	        this.assetsPath = '';
	        this.path = '';
	        this.totalAssets = 0;
	        this.totalImages = 0;
	        this.loadedAssets = 0;
	        this.imagesLoadedCb = null;
	    }
	}());
	var featureSupport = (function(){
		var ob = {
			maskType: true
		}
		if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
		   ob.maskType = false;
		}
		return ob;
	}());
	var filtersFactory = (function(){
		var ob = {};
		ob.createFilter = createFilter;
		ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;
	
		function createFilter(filId){
	        	var fil = createNS('filter');
	        	fil.setAttribute('id',filId);
	                fil.setAttribute('filterUnits','objectBoundingBox');
	                fil.setAttribute('x','0%');
	                fil.setAttribute('y','0%');
	                fil.setAttribute('width','100%');
	                fil.setAttribute('height','100%');
	                return fil;
		}
	
		function createAlphaToLuminanceFilter(){
	                var feColorMatrix = createNS('feColorMatrix');
	                feColorMatrix.setAttribute('type','matrix');
	                feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	                feColorMatrix.setAttribute('values','0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
	                return feColorMatrix;
		}
	
		return ob;
	}())
	function TextAnimatorProperty(textData, renderType, elem){
	    this.mdf = false;
	    this._firstFrame = true;
		this._hasMaskedPath = false;
		this._frameId = -1;
		this._dynamicProperties = [];
		this._textData = textData;
		this._renderType = renderType;
		this._elem = elem;
		this._animatorsData = Array.apply(null,{length:this._textData.a.length});
		this._pathData = {}
		this._moreOptions = {
			alignment: {}
		};
		this.renderedLetters = [];
	    this.lettersChangedFlag = false;
	
	}
	
	TextAnimatorProperty.prototype.searchProperties = function(dynamicProperties){
	    var i, len = this._textData.a.length, animatorData, animatorProps;
	    var getProp = PropertyFactory.getProp;
	    for(i=0;i<len;i+=1){
	        animatorProps = this._textData.a[i];
	        animatorData = {
	            a: {},
	            s: {}
	        };
	        if('r' in animatorProps.a) {
	            animatorData.a.r = getProp(this._elem,animatorProps.a.r,0,degToRads,this._dynamicProperties);
	        }
	        if('rx' in animatorProps.a) {
	            animatorData.a.rx = getProp(this._elem,animatorProps.a.rx,0,degToRads,this._dynamicProperties);
	        }
	        if('ry' in animatorProps.a) {
	            animatorData.a.ry = getProp(this._elem,animatorProps.a.ry,0,degToRads,this._dynamicProperties);
	        }
	        if('sk' in animatorProps.a) {
	            animatorData.a.sk = getProp(this._elem,animatorProps.a.sk,0,degToRads,this._dynamicProperties);
	        }
	        if('sa' in animatorProps.a) {
	            animatorData.a.sa = getProp(this._elem,animatorProps.a.sa,0,degToRads,this._dynamicProperties);
	        }
	        if('s' in animatorProps.a) {
	            animatorData.a.s = getProp(this._elem,animatorProps.a.s,1,0.01,this._dynamicProperties);
	        }
	        if('a' in animatorProps.a) {
	            animatorData.a.a = getProp(this._elem,animatorProps.a.a,1,0,this._dynamicProperties);
	        }
	        if('o' in animatorProps.a) {
	            animatorData.a.o = getProp(this._elem,animatorProps.a.o,0,0.01,this._dynamicProperties);
	        }
	        if('p' in animatorProps.a) {
	            animatorData.a.p = getProp(this._elem,animatorProps.a.p,1,0,this._dynamicProperties);
	        }
	        if('sw' in animatorProps.a) {
	            animatorData.a.sw = getProp(this._elem,animatorProps.a.sw,0,0,this._dynamicProperties);
	        }
	        if('sc' in animatorProps.a) {
	            animatorData.a.sc = getProp(this._elem,animatorProps.a.sc,1,0,this._dynamicProperties);
	        }
	        if('fc' in animatorProps.a) {
	            animatorData.a.fc = getProp(this._elem,animatorProps.a.fc,1,0,this._dynamicProperties);
	        }
	        if('fh' in animatorProps.a) {
	            animatorData.a.fh = getProp(this._elem,animatorProps.a.fh,0,0,this._dynamicProperties);
	        }
	        if('fs' in animatorProps.a) {
	            animatorData.a.fs = getProp(this._elem,animatorProps.a.fs,0,0.01,this._dynamicProperties);
	        }
	        if('fb' in animatorProps.a) {
	            animatorData.a.fb = getProp(this._elem,animatorProps.a.fb,0,0.01,this._dynamicProperties);
	        }
	        if('t' in animatorProps.a) {
	            animatorData.a.t = getProp(this._elem,animatorProps.a.t,0,0,this._dynamicProperties);
	        }
	        animatorData.s = TextSelectorProp.getTextSelectorProp(this._elem,animatorProps.s,this._dynamicProperties);
	        animatorData.s.t = animatorProps.s.t;
	        this._animatorsData[i] = animatorData;
	    }
	    if(this._textData.p && 'm' in this._textData.p){
	        this._pathData = {
	            f: getProp(this._elem,this._textData.p.f,0,0,this._dynamicProperties),
	            l: getProp(this._elem,this._textData.p.l,0,0,this._dynamicProperties),
	            r: this._textData.p.r,
	            m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
	        };
	        this._hasMaskedPath = true;
	    } else {
	        this._hasMaskedPath = false;
	    }
	    this._moreOptions.alignment = getProp(this._elem,this._textData.m.a,1,0,this._dynamicProperties);
	    if(this._dynamicProperties.length) {
	    	dynamicProperties.push(this);
	    }
	}
	
	TextAnimatorProperty.prototype.getMeasures = function(documentData, lettersChangedFlag){
	    this.lettersChangedFlag = lettersChangedFlag;
	    if(!this.mdf && !this._firstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m.mdf)) {
	        return;
	    }
	    this._firstFrame = false;
	    var alignment = this._moreOptions.alignment.v;
	    var animators = this._animatorsData;
	    var textData = this._textData;
	    var matrixHelper = this.mHelper;
	    var renderType = this._renderType;
	    var renderedLettersCount = this.renderedLetters.length;
	    var data = this.data;
	    var xPos,yPos;
	    var i, len;
	    var letters = documentData.l;
	    if(this._hasMaskedPath) {
	        var mask = this._pathData.m;
	        if(!this._pathData.n || this._pathData.mdf){
	            var paths = mask.v;
	            if(this._pathData.r){
	                paths = paths.reverse();
	            }
	            var pathInfo = {
	                tLength: 0,
	                segments: []
	            };
	            len = paths._length - 1;
	            var pathData;
	            var totalLength = 0;
	            for (i = 0; i < len; i += 1) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[i + 1],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            i = len;
	            if (mask.v.c) {
	                pathData = {
	                    s: paths.v[i],
	                    e: paths.v[0],
	                    to: [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]],
	                    ti: [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]
	                };
	                bez.buildBezierData(pathData);
	                pathInfo.tLength += pathData.bezierData.segmentLength;
	                pathInfo.segments.push(pathData);
	                totalLength += pathData.bezierData.segmentLength;
	            }
	            this._pathData.pi = pathInfo;
	        }
	        var pathInfo = this._pathData.pi;
	
	        var currentLength = this._pathData.f.v, segmentInd = 0, pointInd = 1, currentPoint, prevPoint, points;
	        var segmentLength = 0, flag = true;
	        var segments = pathInfo.segments;
	        if (currentLength < 0 && mask.v.c) {
	            if (pathInfo.tLength < Math.abs(currentLength)) {
	                currentLength = -Math.abs(currentLength) % pathInfo.tLength;
	            }
	            segmentInd = segments.length - 1;
	            points = segments[segmentInd].bezierData.points;
	            pointInd = points.length - 1;
	            while (currentLength < 0) {
	                currentLength += points[pointInd].partialLength;
	                pointInd -= 1;
	                if (pointInd < 0) {
	                    segmentInd -= 1;
	                    points = segments[segmentInd].bezierData.points;
	                    pointInd = points.length - 1;
	                }
	            }
	
	        }
	        points = segments[segmentInd].bezierData.points;
	        prevPoint = points[pointInd - 1];
	        currentPoint = points[pointInd];
	        var partialLength = currentPoint.partialLength;
	        var perc, tanAngle;
	    }
	
	
	    len = letters.length;
	    xPos = 0;
	    yPos = 0;
	    var yOff = documentData.s*1.2*.714;
	    var firstLine = true;
	    var animatorProps, animatorSelector;
	    var j, jLen;
	    var letterValue;
	
	    jLen = animators.length;
	    //Todo Confirm this is not necessary here. Text Animator Selectors should not be called without a text index. And it is later correctly called.
	    /*if (lettersChangedFlag) {
	        for (j = 0; j < jLen; j += 1) {
	            animatorSelector = animators[j].s;
	            //animatorSelector.getValue(true);
	        }
	    }*/
	    var lastLetter;
	
	    var mult, ind = -1, offf, xPathPos, yPathPos;
	    var initPathPos = currentLength,initSegmentInd = segmentInd, initPointInd = pointInd, currentLine = -1;
	    var elemOpacity;
	    var sc,sw,fc,k;
	    var lineLength = 0;
	    var letterSw,letterSc,letterFc,letterM = '',letterP = this.defaultPropsArray,letterO;
	    for( i = 0; i < len; i += 1) {
	        matrixHelper.reset();
	        elemOpacity = 1;
	        if(letters[i].n) {
	            xPos = 0;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            currentLength = initPathPos ;
	            firstLine = false;
	            lineLength = 0;
	            if(this._hasMaskedPath) {
	                segmentInd = initSegmentInd;
	                pointInd = initPointInd;
	                points = segments[segmentInd].bezierData.points;
	                prevPoint = points[pointInd - 1];
	                currentPoint = points[pointInd];
	                partialLength = currentPoint.partialLength;
	                segmentLength = 0;
	            }
	            letterO = letterSw = letterFc = letterM = '';
	            letterP = this.defaultPropsArray;
	        }else{
	            if(this._hasMaskedPath) {
	                if(currentLine !== letters[i].line){
	                    switch(documentData.j){
	                        case 1:
	                            currentLength += totalLength - documentData.lineWidths[letters[i].line];
	                            break;
	                        case 2:
	                            currentLength += (totalLength - documentData.lineWidths[letters[i].line])/2;
	                            break;
	                    }
	                    currentLine = letters[i].line;
	                }
	                if (ind !== letters[i].ind) {
	                    if (letters[ind]) {
	                        currentLength += letters[ind].extra;
	                    }
	                    currentLength += letters[i].an / 2;
	                    ind = letters[i].ind;
	                }
	                currentLength += alignment[0] * letters[i].an / 200;
	                var animatorOffset = 0;
	                for (j = 0; j < jLen; j += 1) {
	                    animatorProps = animators[j].a;
	                    if ('p' in animatorProps) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.p.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.p.v[0] * mult;
	                        }
	
	                    }
	                    if ('a' in animatorProps) {
	                        animatorSelector = animators[j].s;
	                        mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                        if(mult.length){
	                            animatorOffset += animatorProps.a.v[0] * mult[0];
	                        } else{
	                            animatorOffset += animatorProps.a.v[0] * mult;
	                        }
	
	                    }
	                }
	                flag = true;
	                while (flag) {
	                    if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
	                        perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
	                        xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
	                        yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
	                        matrixHelper.translate(-alignment[0]*letters[i].an/200, -(alignment[1] * yOff / 100));
	                        flag = false;
	                    } else if (points) {
	                        segmentLength += currentPoint.partialLength;
	                        pointInd += 1;
	                        if (pointInd >= points.length) {
	                            pointInd = 0;
	                            segmentInd += 1;
	                            if (!segments[segmentInd]) {
	                                if (mask.v.c) {
	                                    pointInd = 0;
	                                    segmentInd = 0;
	                                    points = segments[segmentInd].bezierData.points;
	                                } else {
	                                    segmentLength -= currentPoint.partialLength;
	                                    points = null;
	                                }
	                            } else {
	                                points = segments[segmentInd].bezierData.points;
	                            }
	                        }
	                        if (points) {
	                            prevPoint = currentPoint;
	                            currentPoint = points[pointInd];
	                            partialLength = currentPoint.partialLength;
	                        }
	                    }
	                }
	                offf = letters[i].an / 2 - letters[i].add;
	                matrixHelper.translate(-offf, 0, 0);
	            } else {
	                offf = letters[i].an/2 - letters[i].add;
	                matrixHelper.translate(-offf,0,0);
	
	                // Grouping alignment
	                matrixHelper.translate(-alignment[0]*letters[i].an/200, -alignment[1]*yOff/100, 0);
	            }
	
	            lineLength += letters[i].l/2;
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if ('t' in animatorProps) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(this._hasMaskedPath) {
	                        if(mult.length) {
	                            currentLength += animatorProps.t*mult[0];
	                        } else {
	                            currentLength += animatorProps.t*mult;
	                        }
	                    }else{
	                        if(mult.length) {
	                            xPos += animatorProps.t.v*mult[0];
	                        } else {
	                            xPos += animatorProps.t.v*mult;
	                        }
	                    }
	                }
	            }
	            lineLength += letters[i].l/2;
	            if(documentData.strokeWidthAnim) {
	                sw = documentData.sw || 0;
	            }
	            if(documentData.strokeColorAnim) {
	                if(documentData.sc){
	                    sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
	                }else{
	                    sc = [0,0,0];
	                }
	            }
	            if(documentData.fillColorAnim && documentData.fc) {
	                fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if ('a' in animatorProps) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	
	                    if(mult.length){
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult[0], -animatorProps.a.v[1]*mult[1], animatorProps.a.v[2]*mult[2]);
	                    } else {
	                        matrixHelper.translate(-animatorProps.a.v[0]*mult, -animatorProps.a.v[1]*mult, animatorProps.a.v[2]*mult);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	                if ('s' in animatorProps) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(mult.length){
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult[0]),1+((animatorProps.s.v[1]-1)*mult[1]),1);
	                    } else {
	                        matrixHelper.scale(1+((animatorProps.s.v[0]-1)*mult),1+((animatorProps.s.v[1]-1)*mult),1);
	                    }
	                }
	            }
	            for(j=0;j<jLen;j+=1) {
	                animatorProps = animators[j].a;
	                animatorSelector = animators[j].s;
	                mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                if ('sk' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
	                    } else {
	                        matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
	                    }
	                }
	                if ('r' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
	                    } else {
	                        matrixHelper.rotateZ(-animatorProps.r.v * mult);
	                    }
	                }
	                if ('ry' in animatorProps) {
	
	                    if(mult.length) {
	                        matrixHelper.rotateY(animatorProps.ry.v*mult[1]);
	                    }else{
	                        matrixHelper.rotateY(animatorProps.ry.v*mult);
	                    }
	                }
	                if ('rx' in animatorProps) {
	                    if(mult.length) {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult[0]);
	                    } else {
	                        matrixHelper.rotateX(animatorProps.rx.v*mult);
	                    }
	                }
	                if ('o' in animatorProps) {
	                    if(mult.length) {
	                        elemOpacity += ((animatorProps.o.v)*mult[0] - elemOpacity)*mult[0];
	                    } else {
	                        elemOpacity += ((animatorProps.o.v)*mult - elemOpacity)*mult;
	                    }
	                }
	                if (documentData.strokeWidthAnim && 'sw' in animatorProps) {
	                    if(mult.length) {
	                        sw += animatorProps.sw.v*mult[0];
	                    } else {
	                        sw += animatorProps.sw.v*mult;
	                    }
	                }
	                if (documentData.strokeColorAnim && 'sc' in animatorProps) {
	                    for(k=0;k<3;k+=1){
	                        if(mult.length) {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult[0]
	                        } else {
	                            sc[k] = sc[k] + (animatorProps.sc.v[k] - sc[k])*mult;
	                        }
	                    }
	                }
	                if (documentData.fillColorAnim && documentData.fc) {
	                    if('fc' in animatorProps){
	                        for(k=0;k<3;k+=1){
	                            if(mult.length) {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult[0];
	                            } else {
	                                fc[k] = fc[k] + (animatorProps.fc.v[k] - fc[k])*mult;
	                            }
	                        }
	                    }
	                    if('fh' in animatorProps){
	                        if(mult.length) {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult[0]);
	                        } else {
	                            fc = addHueToRGB(fc,animatorProps.fh.v*mult);
	                        }
	                    }
	                    if('fs' in animatorProps){
	                        if(mult.length) {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult[0]);
	                        } else {
	                            fc = addSaturationToRGB(fc,animatorProps.fs.v*mult);
	                        }
	                    }
	                    if('fb' in animatorProps){
	                        if(mult.length) {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult[0]);
	                        } else {
	                            fc = addBrightnessToRGB(fc,animatorProps.fb.v*mult);
	                        }
	                    }
	                }
	            }
	
	            for(j=0;j<jLen;j+=1){
	                animatorProps = animators[j].a;
	
	                if ('p' in animatorProps) {
	                    animatorSelector = animators[j].s;
	                    mult = animatorSelector.getMult(letters[i].anIndexes[j],textData.a[j].s.totalChars);
	                    if(this._hasMaskedPath) {
	                        if(mult.length) {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
	                        } else {
	                            matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }else{
	                        if(mult.length) {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
	                        } else {
	                            matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
	                        }
	                    }
	                }
	            }
	            if(documentData.strokeWidthAnim){
	                letterSw = sw < 0 ? 0 : sw;
	            }
	            if(documentData.strokeColorAnim){
	                letterSc = 'rgb('+Math.round(sc[0]*255)+','+Math.round(sc[1]*255)+','+Math.round(sc[2]*255)+')';
	            }
	            if(documentData.fillColorAnim && documentData.fc){
	                letterFc = 'rgb('+Math.round(fc[0]*255)+','+Math.round(fc[1]*255)+','+Math.round(fc[2]*255)+')';
	            }
	
	            if(this._hasMaskedPath) {
	                matrixHelper.translate(0,-documentData.ls);
	
	                matrixHelper.translate(0, alignment[1]*yOff/100 + yPos,0);
	                if (textData.p.p) {
	                    tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
	                    var rot = Math.atan(tanAngle) * 180 / Math.PI;
	                    if (currentPoint.point[0] < prevPoint.point[0]) {
	                        rot += 180;
	                    }
	                    matrixHelper.rotate(-rot * Math.PI / 180);
	                }
	                matrixHelper.translate(xPathPos, yPathPos, 0);
	                currentLength -= alignment[0]*letters[i].an/200;
	                if(letters[i+1] && ind !== letters[i+1].ind){
	                    currentLength += letters[i].an / 2;
	                    currentLength += documentData.tr/1000*documentData.s;
	                }
	            }else{
	
	                matrixHelper.translate(xPos,yPos,0);
	
	                if(documentData.ps){
	                    //matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
	                    matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	                }
	                switch(documentData.j){
	                    case 1:
	                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]),0,0);
	                        break;
	                    case 2:
	                        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line])/2,0,0);
	                        break;
	                }
	                matrixHelper.translate(0,-documentData.ls);
	                matrixHelper.translate(offf,0,0);
	                matrixHelper.translate(alignment[0]*letters[i].an/200,alignment[1]*yOff/100,0);
	                xPos += letters[i].l + documentData.tr/1000*documentData.s;
	            }
	            if(renderType === 'html'){
	                letterM = matrixHelper.toCSS();
	            }else if(renderType === 'svg'){
	                letterM = matrixHelper.to2dCSS();
	            }else{
	                letterP = [matrixHelper.props[0],matrixHelper.props[1],matrixHelper.props[2],matrixHelper.props[3],matrixHelper.props[4],matrixHelper.props[5],matrixHelper.props[6],matrixHelper.props[7],matrixHelper.props[8],matrixHelper.props[9],matrixHelper.props[10],matrixHelper.props[11],matrixHelper.props[12],matrixHelper.props[13],matrixHelper.props[14],matrixHelper.props[15]];
	            }
	            letterO = elemOpacity;
	        }
	
	        if(renderedLettersCount <= i) {
	            letterValue = new LetterProps(letterO,letterSw,letterSc,letterFc,letterM,letterP);
	            this.renderedLetters.push(letterValue);
	            renderedLettersCount += 1;
	            this.lettersChangedFlag = true;
	        } else {
	            letterValue = this.renderedLetters[i];
	            this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
	        }
	    }
	}
	
	TextAnimatorProperty.prototype.getValue = function(){
		if(this._elem.globalData.frameId === this._frameId){
	        return;
	    }
	    this._frameId = this._elem.globalData.frameId;
		var i, len = this._dynamicProperties.length;
	    this.mdf = false;
		for(i = 0; i < len; i += 1) {
			this._dynamicProperties[i].getValue();
	        this.mdf = this._dynamicProperties[i].mdf || this.mdf;
		}
	}
	
	TextAnimatorProperty.prototype.mHelper = new Matrix();
	TextAnimatorProperty.prototype.defaultPropsArray = [];
	function LetterProps(o, sw, sc, fc, m, p){
	    this.o = o;
	    this.sw = sw;
	    this.sc = sc;
	    this.fc = fc;
	    this.m = m;
	    this.p = p;
	    this.mdf = {
	    	o: true,
	    	sw: !!sw,
	    	sc: !!sc,
	    	fc: !!fc,
	    	m: true,
	    	p: true
	    };
	}
	
	LetterProps.prototype.update = function(o, sw, sc, fc, m, p) {
		this.mdf.o = false;
		this.mdf.sw = false;
		this.mdf.sc = false;
		this.mdf.fc = false;
		this.mdf.m = false;
		this.mdf.p = false;
		var updated = false;
	
		if(this.o !== o) {
			this.o = o;
			this.mdf.o = true;
			updated = true;
		}
		if(this.sw !== sw) {
			this.sw = sw;
			this.mdf.sw = true;
			updated = true;
		}
		if(this.sc !== sc) {
			this.sc = sc;
			this.mdf.sc = true;
			updated = true;
		}
		if(this.fc !== fc) {
			this.fc = fc;
			this.mdf.fc = true;
			updated = true;
		}
		if(this.m !== m) {
			this.m = m;
			this.mdf.m = true;
			updated = true;
		}
		if(p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
			this.p = p;
			this.mdf.p = true;
			updated = true;
		}
		return updated;
	}
	function TextProperty(elem, data, dynamicProperties){
		this._frameId = -99999;
		this.pv = '';
		this.v = '';
		this.kf = false;
		this.firstFrame = true;
		this.mdf = true;
		this.data = data;
		this.elem = elem;
		this.keysIndex = -1;
		this.currentData = {
			ascent: 0,
	        boxWidth: [0,0],
	        f: '',
	        fStyle: '',
	        fWeight: '',
	        fc: '',
	        j: '',
	        justifyOffset: '',
	        l: [],
	        lh: 0,
	        lineWidths: [],
	        ls: '',
	        of: '',
	        s: '',
	        sc: '',
	        sw: 0,
	        t: 0,
	        tr: 0,
	        sz:0,
	        ps:[0,0],
	        fillColorAnim: false,
	        strokeColorAnim: false,
	        strokeWidthAnim: false,
	        yOffset: 0,
	        __complete: false
	
		}
		if(this.searchProperty()) {
			dynamicProperties.push(this);
		} else {
			this.getValue(true);
		}
	}
	
	TextProperty.prototype.setCurrentData = function(data){
			var currentData = this.currentData;
	        currentData.ascent = data.ascent;
	        currentData.boxWidth = data.boxWidth ? data.boxWidth : currentData.boxWidth;
	        currentData.f = data.f;
	        currentData.fStyle = data.fStyle;
	        currentData.fWeight = data.fWeight;
	        currentData.fc = data.fc;
	        currentData.j = data.j;
	        currentData.justifyOffset = data.justifyOffset;
	        currentData.l = data.l;
	        currentData.lh = data.lh;
	        currentData.lineWidths = data.lineWidths;
	        currentData.ls = data.ls;
	        currentData.of = data.of;
	        currentData.s = data.s;
	        currentData.sc = data.sc;
	        currentData.sw = data.sw;
	        currentData.sz = data.sz;
	        currentData.ps = data.ps;
	        currentData.t = data.t;
	        currentData.tr = data.tr;
	        currentData.fillColorAnim = data.fillColorAnim || currentData.fillColorAnim;
	        currentData.strokeColorAnim = data.strokeColorAnim || currentData.strokeColorAnim;
	        currentData.strokeWidthAnim = data.strokeWidthAnim || currentData.strokeWidthAnim;
	        currentData.yOffset = data.yOffset;
	        currentData.__complete = false;
	}
	
	TextProperty.prototype.searchProperty = function() {
		this.kf = this.data.d.k.length > 1;
		return this.kf;
	}
	
	TextProperty.prototype.getValue = function() {
		this.mdf = false;
		var frameId = this.elem.globalData.frameId;
		if((frameId === this._frameId || !this.kf) && !this.firstFrame) {
			return;
		}
		var textKeys = this.data.d.k, textDocumentData;
	    var i = 0, len = textKeys.length;
	    while(i <= len - 1) {
	        textDocumentData = textKeys[i].s;
	        if(i === len - 1 || textKeys[i+1].t > frameId){
	            break;
	        }
	        i += 1;
	    }
	    if(this.keysIndex !== i) {
	    	if(!textDocumentData.__complete) {
	            this.completeTextData(textDocumentData);
	        }
	        this.setCurrentData(textDocumentData);
	        this.mdf = this.firstFrame ? false : true;
	        this.pv = this.v = this.currentData.t;
	        this.keysIndex = i;
	    }
		this._frameId = frameId;
	}
	
	TextProperty.prototype.completeTextData = function(documentData) {
	    documentData.__complete = true;
	    var fontManager = this.elem.globalData.fontManager;
	    var data = this.data;
	    var letters = [];
	    var i, len;
	    var newLineFlag, index = 0, val;
	    var anchorGrouping = data.m.g;
	    var currentSize = 0, currentPos = 0, currentLine = 0, lineWidths = [];
	    var lineWidth = 0;
	    var maxLineWidth = 0;
	    var j, jLen;
	    var fontData = fontManager.getFontByName(documentData.f);
	    var charData, cLength = 0;
	    var styles = fontData.fStyle.split(' ');
	
	    var fWeight = 'normal', fStyle = 'normal';
	    len = styles.length;
	    var styleName;
	    for(i=0;i<len;i+=1){
	        styleName = styles[i].toLowerCase();
	        switch(styleName) {
	            case 'italic':
	            fStyle = 'italic';
	            break;
	            case 'bold':
	            fWeight = '700';
	            break;
	            case 'black':
	            fWeight = '900';
	            break;
	            case 'medium':
	            fWeight = '500';
	            break;
	            case 'regular':
	            case 'normal':
	            fWeight = '400';
	            case 'light':
	            case 'thin':
	            fWeight = '200';
	            break;
	        }
	    }
	    documentData.fWeight = fWeight;
	    documentData.fStyle = fStyle;
	    len = documentData.t.length;
	    var trackingOffset = documentData.tr/1000*documentData.s;
	    if(documentData.sz){
	        var boxWidth = documentData.sz[0];
	        var lastSpaceIndex = -1;
	        for(i=0;i<len;i+=1){
	            newLineFlag = false;
	            if(documentData.t.charAt(i) === ' '){
	                lastSpaceIndex = i;
	            }else if(documentData.t.charCodeAt(i) === 13){
	                lineWidth = 0;
	                newLineFlag = true;
	            }
	            if(fontManager.chars){
	                charData = fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, fontData.fFamily);
	                cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
	            }else{
	                //tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
	                cLength = fontManager.measureText(documentData.t.charAt(i), documentData.f, documentData.s);
	            }
	            if(lineWidth + cLength > boxWidth && documentData.t.charAt(i) !== ' '){
	                if(lastSpaceIndex === -1){
	                    len += 1;
	                } else {
	                    i = lastSpaceIndex;
	                }
	                documentData.t = documentData.t.substr(0,i) + "\r" + documentData.t.substr(i === lastSpaceIndex ? i + 1 : i);
	                lastSpaceIndex = -1;
	                lineWidth = 0;
	            }else {
	                lineWidth += cLength;
	                lineWidth += trackingOffset;
	            }
	        }
	        len = documentData.t.length;
	    }
	    lineWidth = - trackingOffset;
	    cLength = 0;
	    var uncollapsedSpaces = 0;
	    var currentChar;
	    for (i = 0;i < len ;i += 1) {
	        newLineFlag = false;
	        currentChar = documentData.t.charAt(i);
	        if(currentChar === ' '){
	            val = '\u00A0';
	        }else if(currentChar.charCodeAt(0) === 13){
	            uncollapsedSpaces = 0;
	            lineWidths.push(lineWidth);
	            maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	            lineWidth = - 2 * trackingOffset;
	            val = '';
	            newLineFlag = true;
	            currentLine += 1;
	        }else{
	            val = documentData.t.charAt(i);
	        }
	        if(fontManager.chars){
	            charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
	            cLength = newLineFlag ? 0 : charData.w*documentData.s/100;
	        }else{
	            //var charWidth = fontManager.measureText(val, documentData.f, documentData.s);
	            //tCanvasHelper.font = documentData.s + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
	            cLength = fontManager.measureText(val, documentData.f, documentData.s);
	        }
	
	        //
	        if(currentChar === ' '){
	            uncollapsedSpaces += cLength + trackingOffset;
	        } else {
	            lineWidth += cLength + trackingOffset + uncollapsedSpaces;
	            uncollapsedSpaces = 0;
	        }
	        letters.push({l:cLength,an:cLength,add:currentSize,n:newLineFlag, anIndexes:[], val: val, line: currentLine});
	        if(anchorGrouping == 2){
	            currentSize += cLength;
	            if(val == '' || val == '\u00A0' || i == len - 1){
	                if(val == '' || val == '\u00A0'){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                index += 1;
	                currentSize = 0;
	            }
	        }else if(anchorGrouping == 3){
	            currentSize += cLength;
	            if(val == '' || i == len - 1){
	                if(val == ''){
	                    currentSize -= cLength;
	                }
	                while(currentPos<=i){
	                    letters[currentPos].an = currentSize;
	                    letters[currentPos].ind = index;
	                    letters[currentPos].extra = cLength;
	                    currentPos += 1;
	                }
	                currentSize = 0;
	                index += 1;
	            }
	        }else{
	            letters[index].ind = index;
	            letters[index].extra = 0;
	            index += 1;
	        }
	    }
	    documentData.l = letters;
	    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
	    lineWidths.push(lineWidth);
	    if(documentData.sz){
	        documentData.boxWidth = documentData.sz[0];
	        documentData.justifyOffset = 0;
	    }else{
	        documentData.boxWidth = maxLineWidth;
	        switch(documentData.j){
	            case 1:
	                documentData.justifyOffset = - documentData.boxWidth;
	                break;
	            case 2:
	                documentData.justifyOffset = - documentData.boxWidth/2;
	                break;
	            default:
	                documentData.justifyOffset = 0;
	        }
	    }
	    documentData.lineWidths = lineWidths;
	
	    var animators = data.a, animatorData, letterData;
	    jLen = animators.length;
	    var based, ind, indexes = [];
	    for(j=0;j<jLen;j+=1){
	        animatorData = animators[j];
	        if(animatorData.a.sc){
	            documentData.strokeColorAnim = true;
	        }
	        if(animatorData.a.sw){
	            documentData.strokeWidthAnim = true;
	        }
	        if(animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb){
	            documentData.fillColorAnim = true;
	        }
	        ind = 0;
	        based = animatorData.s.b;
	        for(i=0;i<len;i+=1){
	            letterData = letters[i];
	            letterData.anIndexes[j] = ind;
	            if((based == 1 && letterData.val != '') || (based == 2 && letterData.val != '' && letterData.val != '\u00A0') || (based == 3 && (letterData.n || letterData.val == '\u00A0' || i == len - 1)) || (based == 4 && (letterData.n || i == len - 1))){
	                if(animatorData.s.rn === 1){
	                    indexes.push(ind);
	                }
	                ind += 1;
	            }
	        }
	        data.a[j].s.totalChars = ind;
	        var currentInd = -1, newInd;
	        if(animatorData.s.rn === 1){
	            for(i = 0; i < len; i += 1){
	                letterData = letters[i];
	                if(currentInd != letterData.anIndexes[j]){
	                    currentInd = letterData.anIndexes[j];
	                    newInd = indexes.splice(Math.floor(Math.random()*indexes.length),1)[0];
	                }
	                letterData.anIndexes[j] = newInd;
	            }
	        }
	    }
	    documentData.yOffset = documentData.lh || documentData.s*1.2;
	    documentData.ls = documentData.ls || 0;
	    documentData.ascent = fontData.ascent*documentData.s/100;
	}
	
	TextProperty.prototype.updateDocumentData = function(newData, index) {
		index = index === undefined ? this.keysIndex : index;
	    var dData = this.data.d.k[index].s;
	    dData.__complete = false;
	    dData.t = newData.t;
	    this.keysIndex = -1;
	    this.firstFrame = true;
	    this.getValue();
	}
	
	var TextSelectorProp = (function(){
	    var max = Math.max;
	    var min = Math.min;
	    var floor = Math.floor;
	    function updateRange(newCharsFlag){
	        this.mdf = newCharsFlag || false;
	        if(this.dynamicProperties.length){
	            var i, len = this.dynamicProperties.length;
	            for(i=0;i<len;i+=1){
	                this.dynamicProperties[i].getValue();
	                if(this.dynamicProperties[i].mdf){
	                    this.mdf = true;
	                }
	            }
	        }
	        var totalChars = this.elem.textProperty.currentData ? this.elem.textProperty.currentData.l.length : 0;
	        if(newCharsFlag && this.data.r === 2) {
	            this.e.v = totalChars;
	        }
	        var divisor = this.data.r === 2 ? 1 : 100 / totalChars;
	        var o = this.o.v/divisor;
	        var s = this.s.v/divisor + o;
	        var e = (this.e.v/divisor) + o;
	        if(s>e){
	            var _s = s;
	            s = e;
	            e = _s;
	        }
	        this.finalS = s;
	        this.finalE = e;
	    }
	
	    function getMult(ind){
	        //var easer = bez.getEasingCurve(this.ne.v/100,0,1-this.xe.v/100,1);
	        var easer = BezierFactory.getBezierEasing(this.ne.v/100,0,1-this.xe.v/100,1).get;
	        var mult = 0;
	        var s = this.finalS;
	        var e = this.finalE;
	        var type = this.data.sh;
	        if(type == 2){
	            if(e === s){
	                mult = ind >= e ? 1 : 0;
	            }else{
	                mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	            }
	            mult = easer(mult);
	        }else if(type == 3){
	            if(e === s){
	                mult = ind >= e ? 0 : 1;
	            }else{
	                mult = 1 - max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	            }
	
	            mult = easer(mult);
	        }else if(type == 4){
	            if(e === s){
	                mult = 0;
	            }else{
	                mult = max(0,min(0.5/(e-s) + (ind-s)/(e-s),1));
	                if(mult<.5){
	                    mult *= 2;
	                }else{
	                    mult = 1 - 2*(mult-0.5);
	                }
	            }
	            mult = easer(mult);
	        }else if(type == 5){
	            if(e === s){
	                mult = 0;
	            }else{
	                var tot = e - s;
	                /*ind += 0.5;
	                mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind;*/
	                ind = min(max(0,ind+0.5-s),e-s);
	                var x = -tot/2+ind;
	                var a = tot/2;
	                mult = Math.sqrt(1 - (x*x)/(a*a));
	            }
	            mult = easer(mult);
	        }else if(type == 6){
	            if(e === s){
	                mult = 0;
	            }else{
	                ind = min(max(0,ind+0.5-s),e-s);
	                mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind)/(e-s)))))/2;
	                /*
	                 ind = Math.min(Math.max(s,ind),e-1);
	                 mult = (1+(Math.cos((Math.PI+Math.PI*2*(ind-s)/(e-1-s)))))/2;
	                 mult = Math.max(mult,(1/(e-1-s))/(e-1-s));*/
	            }
	            mult = easer(mult);
	        }else {
	            if(ind >= floor(s)){
	                if(ind-s < 0){
	                    mult = 1 - (s - ind);
	                }else{
	                    mult = max(0,min(e-ind,1));
	                }
	            }
	            mult = easer(mult);
	        }
	        return mult*this.a.v;
	    }
	
	    function TextSelectorProp(elem,data, arr){
	        this.mdf = false;
	        this.k = false;
	        this.data = data;
	        this.dynamicProperties = [];
	        this.getValue = updateRange;
	        this.getMult = getMult;
	        this.elem = elem;
	        this.comp = elem.comp;
	        this.finalS = 0;
	        this.finalE = 0;
	        this.s = PropertyFactory.getProp(elem,data.s || {k:0},0,0,this.dynamicProperties);
	        if('e' in data){
	            this.e = PropertyFactory.getProp(elem,data.e,0,0,this.dynamicProperties);
	        }else{
	            this.e = {v:100};
	        }
	        this.o = PropertyFactory.getProp(elem,data.o || {k:0},0,0,this.dynamicProperties);
	        this.xe = PropertyFactory.getProp(elem,data.xe || {k:0},0,0,this.dynamicProperties);
	        this.ne = PropertyFactory.getProp(elem,data.ne || {k:0},0,0,this.dynamicProperties);
	        this.a = PropertyFactory.getProp(elem,data.a,0,0.01,this.dynamicProperties);
	        if(this.dynamicProperties.length){
	            arr.push(this);
	        }else{
	            this.getValue();
	        }
	    }
	
	    function getTextSelectorProp(elem, data,arr) {
	        return new TextSelectorProp(elem, data, arr);
	    };
	
	    return {
	        getTextSelectorProp: getTextSelectorProp
	    }
	}());
	
	    
	var pooling = (function(){
	
		function double(arr){
			return arr.concat(Array.apply(null,{length:arr.length}))
		}
	
		return {
			double: double
		}
	}());
	var point_pool = (function(){
		var ob = {
			newPoint: newPoint,
			release: release
		}
	
		var _length = 0;
		var _maxLength = 8;
		var pool = Array.apply(null,{length:_maxLength});
	
		function newPoint(){
			var point;
			if(_length){
				_length -= 1;
				point = pool[_length];
			} else {
				point = createTypedArray('float32', 2);
			}
			return point;
		}
	
		function release(point) {
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = point;
			_length += 1;
		}
	
	
		return ob;
	}());
	var shape_pool = (function(){
		var ob = {
			clone: clone,
			newShape: newShape,
			release: release,
			releaseArray: releaseArray
		}
	
		var _length = 0;
		var _maxLength = 4;
		var pool = Array.apply(null,{length:_maxLength});
	
		function newShape(){
			var shapePath;
			if(_length){
				_length -= 1;
				shapePath = pool[_length];
			} else {
				shapePath = new ShapePath();
			}
			return shapePath;
		}
	
		function release(shapePath) {
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			var len = shapePath._length, i;
			for(i = 0; i < len; i += 1) {
				point_pool.release(shapePath.v[i]);
				point_pool.release(shapePath.i[i]);
				point_pool.release(shapePath.o[i]);
				shapePath.v[i] = null;
				shapePath.i[i] = null;
				shapePath.o[i] = null;
			}
			shapePath._length = 0;
			shapePath.c = false;
			pool[_length] = shapePath;
			_length += 1;
		}
	
		function releaseArray(shapePathsCollection, length) {
			while(length--) {
				release(shapePathsCollection[length]);
			}
		}
	
		function clone(shape, transform) {
			var i, len = shape._length === undefined ? shape.v.length : shape._length;
			var cloned = newShape();
			cloned.setLength(len);
			cloned.c = shape.c;
	
			var pt;
			
			for(i = 0; i < len; i += 1) {
				if(transform){
					pt = transform.applyToPointArray(shape.v[i][0],shape.v[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'v',i);
					point_pool.release(pt);
					pt = transform.applyToPointArray(shape.o[i][0],shape.o[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'o',i);
					point_pool.release(pt);
					pt = transform.applyToPointArray(shape.i[i][0],shape.i[i][1],0,2);
					cloned.setXYAt(pt[0],pt[1],'i',i);
					point_pool.release(pt);
				}else{
					cloned.setTripleAt(shape.v[i][0],shape.v[i][1],shape.o[i][0],shape.o[i][1],shape.i[i][0],shape.i[i][1], i);
				}
			}
			return cloned
		}
	
	
		return ob;
	}());
	var shapeCollection_pool = (function(){
		var ob = {
			newShapeCollection: newShapeCollection,
			release: release,
			clone: clone
		}
	
		var _length = 0;
		var _maxLength = 4;
		var pool = Array.apply(null,{length:_maxLength});
	
		var cont = 0;
	
		function newShapeCollection(){
			var shapeCollection;
			if(_length){
				_length -= 1;
				shapeCollection = pool[_length];
			} else {
				shapeCollection = new ShapeCollection();
			}
			return shapeCollection;
		}
	
		function release(shapeCollection) {
			var i, len = shapeCollection._length;
			for(i = 0; i < len; i += 1) {
				shape_pool.release(shapeCollection.shapes[i]);
			}
			shapeCollection._length = 0;
	
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
		function clone(shapeCollection, originCollection) {
			release(shapeCollection);
			if(_length === _maxLength) {
				pool = pooling.double(pool);
				_maxLength = _maxLength*2;
			}
			pool[_length] = shapeCollection;
			_length += 1;
		}
	
	
		return ob;
	}());
	function BaseRenderer(){}
	BaseRenderer.prototype.checkLayers = function(num){
	    var i, len = this.layers.length, data;
	    this.completeLayers = true;
	    for (i = len - 1; i >= 0; i--) {
	        if (!this.elements[i]) {
	            data = this.layers[i];
	            if(data.ip - data.st <= (num - this.layers[i].st) && data.op - data.st > (num - this.layers[i].st))
	            {
	                this.buildItem(i);
	            }
	        }
	        this.completeLayers = this.elements[i] ? this.completeLayers:false;
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.createItem = function(layer){
	    switch(layer.ty){
	        case 2:
	            return this.createImage(layer);
	        case 0:
	            return this.createComp(layer);
	        case 1:
	            return this.createSolid(layer);
	        case 4:
	            return this.createShape(layer);
	        case 5:
	            return this.createText(layer);
	        case 13:
	            return this.createCamera(layer);
	        case 99:
	            return null;
	    }
	    return this.createBase(layer);
	};
	
	BaseRenderer.prototype.createCamera = function(){
	    throw new Error('You\'re using a 3d camera. Try the html renderer.');
	}
	
	BaseRenderer.prototype.buildAllItems = function(){
	    var i, len = this.layers.length;
	    for(i=0;i<len;i+=1){
	        this.buildItem(i);
	    }
	    this.checkPendingElements();
	};
	
	BaseRenderer.prototype.includeLayers = function(newLayers){
	    this.completeLayers = false;
	    var i, len = newLayers.length;
	    var j, jLen = this.layers.length;
	    for(i=0;i<len;i+=1){
	        j = 0;
	        while(j<jLen){
	            if(this.layers[j].id == newLayers[i].id){
	                this.layers[j] = newLayers[i];
	                break;
	            }
	            j += 1;
	        }
	    }
	};
	
	BaseRenderer.prototype.setProjectInterface = function(pInterface){
	    this.globalData.projectInterface = pInterface;
	};
	
	BaseRenderer.prototype.initItems = function(){
	    if(!this.globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	};
	BaseRenderer.prototype.buildElementParenting = function(element, parentName, hierarchy){
	    hierarchy = hierarchy || [];
	    var elements = this.elements;
	    var layers = this.layers;
	    var i=0, len = layers.length;
	    while(i<len){
	        if(layers[i].ind == parentName){
	            if(!elements[i] || elements[i] === true){
	                this.buildItem(i);
	                this.addPendingElement(element);
	            } else if(layers[i].parent !== undefined){
	                hierarchy.push(elements[i]);
	                elements[i]._isParent = true;
	                this.buildElementParenting(element,layers[i].parent, hierarchy);
	            } else {
	                hierarchy.push(elements[i]);
	                elements[i]._isParent = true;
	                element.setHierarchy(hierarchy);
	            }
	
	
	        }
	        i += 1;
	    }
	};
	
	BaseRenderer.prototype.addPendingElement = function(element){
	    this.pendingElements.push(element);
	};
	function SVGRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.renderConfig = {
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        hideOnTransparent: (config && config.hideOnTransparent === false) ? false : true,
	        viewBoxOnly: (config && config.viewBoxOnly) || false,
	        className: (config && config.className) || ''
	    };
	    this.globalData.renderConfig = this.renderConfig;
	    this.elements = [];
	    this.pendingElements = [];
	    this.destroyed = false;
	
	}
	
	extendPrototype(BaseRenderer,SVGRenderer);
	
	SVGRenderer.prototype.createBase = function (data) {
	    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createShape = function (data) {
	    return new IShapeElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createText = function (data) {
	    return new SVGTextElement(data, this.layerElement,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createImage = function (data) {
	    return new IImageElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.createComp = function (data) {
	    return new ICompElement(data, this.layerElement,this.globalData,this);
	
	};
	
	SVGRenderer.prototype.createSolid = function (data) {
	    return new ISolidElement(data, this.layerElement,this.globalData,this);
	};
	
	SVGRenderer.prototype.configAnimation = function(animData){
	    this.layerElement = createNS('svg');
	    this.layerElement.setAttribute('xmlns','http://www.w3.org/2000/svg');
	    this.layerElement.setAttribute('viewBox','0 0 '+animData.w+' '+animData.h);
	    if(!this.renderConfig.viewBoxOnly) {
	        this.layerElement.setAttribute('width',animData.w);
	        this.layerElement.setAttribute('height',animData.h);
	        this.layerElement.style.width = '100%';
	        this.layerElement.style.height = '100%';
	    }
	    if(this.renderConfig.className) {
	        this.layerElement.setAttribute('class', this.renderConfig.className);
	    }
	    this.layerElement.setAttribute('preserveAspectRatio',this.renderConfig.preserveAspectRatio);
	    //this.layerElement.style.transform = 'translate3d(0,0,0)';
	    //this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";
	    this.animationItem.wrapper.appendChild(this.layerElement);
	    //Mask animation
	    var defs = createNS( 'defs');
	    this.globalData.defs = defs;
	    this.layerElement.appendChild(defs);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.globalData.frameId = 0;
	    this.globalData.nm = animData.nm;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.data = animData;
	    this.globalData.frameRate = animData.fr;
	    var maskElement = createNS( 'clipPath');
	    var rect = createNS('rect');
	    rect.setAttribute('width',animData.w);
	    rect.setAttribute('height',animData.h);
	    rect.setAttribute('x',0);
	    rect.setAttribute('y',0);
	    var maskId = 'animationMask_'+randomString(10);
	    maskElement.setAttribute('id', maskId);
	    maskElement.appendChild(rect);
	    var maskedElement = createNS('g');
	    maskedElement.setAttribute("clip-path", "url(" + locationHref + "#"+maskId+")");
	    this.layerElement.appendChild(maskedElement);
	    defs.appendChild(maskElement);
	    this.layerElement = maskedElement;
	    this.layers = animData.layers;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,defs);
	    this.elements = Array.apply(null,{length:animData.layers.length});
	};
	
	
	SVGRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.layerElement = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	SVGRenderer.prototype.updateContainerSize = function () {
	};
	
	SVGRenderer.prototype.buildItem  = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    elements[pos] = true;
	    var element = this.createItem(this.layers[pos]);
	
	    elements[pos] = element;
	    if(expressionsPlugin){
	        if(this.layers[pos].ty === 0){
	            this.globalData.projectInterface.registerComposition(element);
	        }
	        element.initExpressions();
	    }
	    this.appendElementInPos(element,pos);
	    if(this.layers[pos].tt){
	        if(!this.elements[pos - 1] || this.elements[pos - 1] === true){
	            this.buildItem(pos - 1);
	            this.addPendingElement(element);
	        } else {
	            element.setMatte(elements[pos - 1].layerId);
	        }
	    }
	};
	
	SVGRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	        if(element.data.tt){
	            var i = 0, len = this.elements.length;
	            while(i<len){
	                if(this.elements[i] === element){
	                    element.setMatte(this.elements[i - 1].layerId);
	                    break;
	                }
	                i += 1;
	            }
	        }
	    }
	};
	
	SVGRenderer.prototype.renderFrame = function(num){
	    if(this.renderedFrame == num || this.destroyed){
	        return;
	    }
	    if(num === null){
	        num = this.renderedFrame;
	    }else{
	        this.renderedFrame = num;
	    }
	    //clearPoints();
	    /*console.log('-------');
	    console.log('FRAME ',num);*/
	    this.globalData.frameNum = num;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    for (i = len - 1; i >= 0; i--) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	};
	
	SVGRenderer.prototype.appendElementInPos = function(element, pos){
	    var newElement = element.getBaseElement();
	    if(!newElement){
	        return;
	    }
	    var i = 0;
	    var nextElement;
	    while(i<pos){
	        if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement()){
	            nextElement = this.elements[i].getBaseElement();
	        }
	        i += 1;
	    }
	    if(nextElement){
	        this.layerElement.insertBefore(newElement, nextElement);
	    } else {
	        this.layerElement.appendChild(newElement);
	    }
	};
	
	SVGRenderer.prototype.hide = function(){
	    this.layerElement.style.display = 'none';
	};
	
	SVGRenderer.prototype.show = function(){
	    this.layerElement.style.display = 'block';
	};
	
	SVGRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = createNS('g');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            //comp.compInterface = CompExpressionInterface(comp);
	            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function MaskElement(data,element,globalData) {
	    this.dynamicProperties = [];
	    this.data = data;
	    this.element = element;
	    this.globalData = globalData;
	    this.storedData = [];
	    this.masksProperties = this.data.masksProperties;
	    this.viewData = Array.apply(null,{length:this.masksProperties.length});
	    this.maskElement = null;
	    this.firstFrame = true;
	    var defs = this.globalData.defs;
	    var i, len = this.masksProperties.length;
	
	
	    var path, properties = this.masksProperties;
	    var count = 0;
	    var currentMasks = [];
	    var j, jLen;
	    var layerId = randomString(10);
	    var rect, expansor, feMorph,x;
	    var maskType = 'clipPath', maskRef = 'clip-path';
	    for (i = 0; i < len; i++) {
	
	        if((properties[i].mode !== 'a' && properties[i].mode !== 'n')|| properties[i].inv || properties[i].o.k !== 100){
	            maskType = 'mask';
	            maskRef = 'mask';
	        }
	
	        if((properties[i].mode == 's' || properties[i].mode == 'i') && count == 0){
	            rect = createNS( 'rect');
	            rect.setAttribute('fill', '#ffffff');
	            rect.setAttribute('width', this.element.comp.data.w);
	            rect.setAttribute('height', this.element.comp.data.h);
	            currentMasks.push(rect);
	        } else {
	            rect = null;
	        }
	
	        path = createNS( 'path');
	        if(properties[i].mode == 'n') {
	            this.viewData[i] = {
	                op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
	                prop: ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null),
	                elem: path
	            };
	            defs.appendChild(path);
	            continue;
	        }
	        count += 1;
	
	        if(properties[i].mode == 's'){
	            path.setAttribute('fill', '#000000');
	        }else{
	            path.setAttribute('fill', '#ffffff');
	        }
	        path.setAttribute('clip-rule','nonzero');
	
	        if(properties[i].x.k !== 0){
	            maskType = 'mask';
	            maskRef = 'mask';
	            x = PropertyFactory.getProp(this.element,properties[i].x,0,null,this.dynamicProperties);
	            var filterID = 'fi_'+randomString(10);
	            expansor = createNS('filter');
	            expansor.setAttribute('id',filterID);
	            feMorph = createNS('feMorphology');
	            feMorph.setAttribute('operator','dilate');
	            feMorph.setAttribute('in','SourceGraphic');
	            feMorph.setAttribute('radius','0');
	            expansor.appendChild(feMorph);
	            defs.appendChild(expansor);
	            if(properties[i].mode == 's'){
	                path.setAttribute('stroke', '#000000');
	            }else{
	                path.setAttribute('stroke', '#ffffff');
	            }
	        }else{
	            feMorph = null;
	            x = null;
	        }
	
	
	        this.storedData[i] = {
	             elem: path,
	             x: x,
	             expan: feMorph,
	            lastPath: '',
	            lastOperator:'',
	            filterId:filterID,
	            lastRadius:0
	        };
	        if(properties[i].mode == 'i'){
	            jLen = currentMasks.length;
	            var g = createNS('g');
	            for(j=0;j<jLen;j+=1){
	                g.appendChild(currentMasks[j]);
	            }
	            var mask = createNS('mask');
	            mask.setAttribute('mask-type','alpha');
	            mask.setAttribute('id',layerId+'_'+count);
	            mask.appendChild(path);
	            defs.appendChild(mask);
	            g.setAttribute('mask','url(' + locationHref + '#'+layerId+'_'+count+')');
	
	            currentMasks.length = 0;
	            currentMasks.push(g);
	        }else{
	            currentMasks.push(path);
	        }
	        if(properties[i].inv && !this.solidPath){
	            this.solidPath = this.createLayerSolidPath();
	        }
	        this.viewData[i] = {
	            elem: path,
	            lastPath: '',
	            op: PropertyFactory.getProp(this.element,properties[i].o,0,0.01,this.dynamicProperties),
	            prop:ShapePropertyFactory.getShapeProp(this.element,properties[i],3,this.dynamicProperties,null)
	        };
	        if(rect){
	            this.viewData[i].invRect = rect;
	        }
	        if(!this.viewData[i].prop.k){
	            this.drawPath(properties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	    }
	
	    this.maskElement = createNS( maskType);
	
	    len = currentMasks.length;
	    for(i=0;i<len;i+=1){
	        this.maskElement.appendChild(currentMasks[i]);
	    }
	
	    this.maskElement.setAttribute('id', layerId);
	    if(count > 0){
	        this.element.maskedElement.setAttribute(maskRef, "url(" + locationHref + "#" + layerId + ")");
	    }
	
	    defs.appendChild(this.maskElement);
	};
	
	MaskElement.prototype.getMaskProperty = function(pos){
	    return this.viewData[pos].prop;
	};
	
	MaskElement.prototype.prepareFrame = function(){
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	
	    }
	};
	
	MaskElement.prototype.renderFrame = function (finalMat) {
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        if(this.viewData[i].prop.mdf || this.firstFrame){
	            this.drawPath(this.masksProperties[i],this.viewData[i].prop.v,this.viewData[i]);
	        }
	        if(this.viewData[i].op.mdf || this.firstFrame){
	            this.viewData[i].elem.setAttribute('fill-opacity',this.viewData[i].op.v);
	        }
	        if(this.masksProperties[i].mode !== 'n'){
	            if(this.viewData[i].invRect && (this.element.finalTransform.mProp.mdf || this.firstFrame)){
	                this.viewData[i].invRect.setAttribute('x', -finalMat.props[12]);
	                this.viewData[i].invRect.setAttribute('y', -finalMat.props[13]);
	            }
	            if(this.storedData[i].x && (this.storedData[i].x.mdf || this.firstFrame)){
	                var feMorph = this.storedData[i].expan;
	                if(this.storedData[i].x.v < 0){
	                    if(this.storedData[i].lastOperator !== 'erode'){
	                        this.storedData[i].lastOperator = 'erode';
	                        this.storedData[i].elem.setAttribute('filter','url(' + locationHref + '#'+this.storedData[i].filterId+')');
	                    }
	                    feMorph.setAttribute('radius',-this.storedData[i].x.v);
	                }else{
	                    if(this.storedData[i].lastOperator !== 'dilate'){
	                        this.storedData[i].lastOperator = 'dilate';
	                        this.storedData[i].elem.setAttribute('filter',null);
	                    }
	                    this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v*2);
	
	                }
	            }
	        }
	    }
	    this.firstFrame = false;
	};
	
	MaskElement.prototype.getMaskelement = function () {
	    return this.maskElement;
	};
	
	MaskElement.prototype.createLayerSolidPath = function(){
	    var path = 'M0,0 ';
	    path += ' h' + this.globalData.compSize.w ;
	    path += ' v' + this.globalData.compSize.h ;
	    path += ' h-' + this.globalData.compSize.w ;
	    path += ' v-' + this.globalData.compSize.h + ' ';
	    return path;
	};
	
	MaskElement.prototype.drawPath = function(pathData,pathNodes,viewData){
	    var pathString = " M"+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    var i, len;
	    len = pathNodes._length;
	    for(i=1;i<len;i+=1){
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
	        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[i][0])+','+bm_rnd(pathNodes.i[i][1]) + " "+bm_rnd(pathNodes.v[i][0])+','+bm_rnd(pathNodes.v[i][1]);
	    }
	        //pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];
	    if(pathNodes.c && len > 1){
	        pathString += " C"+bm_rnd(pathNodes.o[i-1][0])+','+bm_rnd(pathNodes.o[i-1][1]) + " "+bm_rnd(pathNodes.i[0][0])+','+bm_rnd(pathNodes.i[0][1]) + " "+bm_rnd(pathNodes.v[0][0])+','+bm_rnd(pathNodes.v[0][1]);
	    }
	    //pathNodes.__renderedString = pathString;
	
	
	    if(viewData.lastPath !== pathString){
	        if(viewData.elem){
	            if(!pathNodes.c){
	                viewData.elem.setAttribute('d','');
	            }else if(pathData.inv){
	                viewData.elem.setAttribute('d',this.solidPath + pathString);
	            }else{
	                viewData.elem.setAttribute('d',pathString);
	            }
	        }
	        viewData.lastPath = pathString;
	    }
	};
	
	MaskElement.prototype.destroy = function(){
	    this.element = null;
	    this.globalData = null;
	    this.maskElement = null;
	    this.data = null;
	    this.masksProperties = null;
	};
	function BaseElement(){
	};
	BaseElement.prototype.checkMasks = function(){
	    if(!this.data.hasMask){
	        return false;
	    }
	    var i = 0, len = this.data.masksProperties.length;
	    while(i<len) {
	        if((this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false)) {
	            return true;
	        }
	        i += 1;
	    }
	    return false;
	}
	
	BaseElement.prototype.checkParenting = function(){
	    if(this.data.parent !== undefined){
	        this.comp.buildElementParenting(this, this.data.parent);
	    }
	}
	
	BaseElement.prototype.prepareFrame = function(num){
	    if(this.data.ip - this.data.st <= num && this.data.op - this.data.st > num)
	    {
	        if(this.isVisible !== true){
	            this.elemMdf = true;
	            this.globalData.mdf = true;
	            this.isVisible = true;
	            this.firstFrame = true;
	            if(this.data.hasMask){
	                this.maskManager.firstFrame = true;
	            }
	        }
	    }else{
	        if(this.isVisible !== false){
	            this.elemMdf = true;
	            this.globalData.mdf = true;
	            this.isVisible = false;
	        }
	    }
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        if(this.isVisible || (this._isParent && this.dynamicProperties[i].type === 'transform')){
	            this.dynamicProperties[i].getValue();
	            if(this.dynamicProperties[i].mdf){
	                this.elemMdf = true;
	                this.globalData.mdf = true;
	            }
	        }
	    }
	    if(this.data.hasMask && this.isVisible){
	        this.maskManager.prepareFrame(num*this.data.sr);
	    }
	    
	    /* TODO check this
	    if(this.data.sy){
	        if(this.data.sy[0].renderedData[num]){
	            if(this.data.sy[0].renderedData[num].c){
	                this.feFlood.setAttribute('flood-color','rgb('+Math.round(this.data.sy[0].renderedData[num].c[0])+','+Math.round(this.data.sy[0].renderedData[num].c[1])+','+Math.round(this.data.sy[0].renderedData[num].c[2])+')');
	            }
	            if(this.data.sy[0].renderedData[num].s){
	                this.feMorph.setAttribute('radius',this.data.sy[0].renderedData[num].s);
	            }
	        }
	    }
	    */
	
	
	    this.currentFrameNum = num*this.data.sr;
	    return this.isVisible;
	};
	
	BaseElement.prototype.globalToLocal = function(pt){
	    var transforms = [];
	    transforms.push(this.finalTransform);
	    var flag = true;
	    var comp = this.comp;
	    while(flag){
	        if(comp.finalTransform){
	            if(comp.data.hasMask){
	                transforms.splice(0,0,comp.finalTransform);
	            }
	            comp = comp.comp;
	        } else {
	            flag = false;
	        }
	    }
	    var i, len = transforms.length,ptNew;
	    for(i=0;i<len;i+=1){
	        ptNew = transforms[i].mat.applyToPointArray(0,0,0);
	        //ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);
	        pt = [pt[0] - ptNew[0],pt[1] - ptNew[1],0];
	    }
	    return pt;
	};
	
	BaseElement.prototype.initExpressions = function(){
	    this.layerInterface = LayerExpressionInterface(this);
	    if(this.data.hasMask){
	        this.layerInterface.registerMaskInterface(this.maskManager);
	    }
	    var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this,this.layerInterface);
	    this.layerInterface.registerEffectsInterface(effectsInterface);
	
	    if(this.data.ty === 0 || this.data.xt){
	        this.compInterface = CompExpressionInterface(this);
	    } else if(this.data.ty === 4){
	        this.layerInterface.shapeInterface = ShapeExpressionInterface.createShapeInterface(this.shapesData,this.itemsData,this.layerInterface);
	        this.layerInterface.content = this.layerInterface.shapeInterface;
	    } else if(this.data.ty === 5){
	        this.layerInterface.textInterface = TextExpressionInterface(this);
	        this.layerInterface.text = this.layerInterface.textInterface;
	    }
	}
	
	BaseElement.prototype.setBlendMode = function(){
	    var blendModeValue = '';
	    switch(this.data.bm){
	        case 1:
	            blendModeValue = 'multiply';
	            break;
	        case 2:
	            blendModeValue = 'screen';
	            break;
	        case 3:
	            blendModeValue = 'overlay';
	            break;
	        case 4:
	            blendModeValue = 'darken';
	            break;
	        case 5:
	            blendModeValue = 'lighten';
	            break;
	        case 6:
	            blendModeValue = 'color-dodge';
	            break;
	        case 7:
	            blendModeValue = 'color-burn';
	            break;
	        case 8:
	            blendModeValue = 'hard-light';
	            break;
	        case 9:
	            blendModeValue = 'soft-light';
	            break;
	        case 10:
	            blendModeValue = 'difference';
	            break;
	        case 11:
	            blendModeValue = 'exclusion';
	            break;
	        case 12:
	            blendModeValue = 'hue';
	            break;
	        case 13:
	            blendModeValue = 'saturation';
	            break;
	        case 14:
	            blendModeValue = 'color';
	            break;
	        case 15:
	            blendModeValue = 'luminosity';
	            break;
	    }
	    var elem = this.baseElement || this.layerElement;
	
	    elem.style['mix-blend-mode'] = blendModeValue;
	}
	
	BaseElement.prototype.init = function(){
	    if(!this.data.sr){
	        this.data.sr = 1;
	    }
	    this.dynamicProperties = this.dynamicProperties || [];
	    if(this.data.ef){
	        this.effects = new EffectsManager(this.data,this,this.dynamicProperties);
	        //this.effect = this.effectsManager.bind(this.effectsManager);
	    }
	    //this.elemInterface = buildLayerExpressionInterface(this);
	    this.hidden = false;
	    this.firstFrame = true;
	    this.isVisible = false;
	    this._isParent = false;
	    this.currentFrameNum = -99999;
	    this.lastNum = -99999;
	    if(this.data.ks){
	        this.finalTransform = {
	            mProp: TransformPropertyFactory.getTransformProperty(this,this.data.ks,this.dynamicProperties),
	            //mProp: PropertyFactory.getProp(this,this.data.ks,2,null,this.dynamicProperties),
	            matMdf: false,
	            opMdf: false,
	            mat: new Matrix(),
	            opacity: 1
	        };
	        if(this.data.ao){
	            this.finalTransform.mProp.autoOriented = true;
	        }
	        this.finalTransform.op = this.finalTransform.mProp.o;
	        this.transform = this.finalTransform.mProp;
	        if(this.data.ty !== 11){
	            this.createElements();
	        }
	        if(this.data.hasMask){
	            this.addMasks(this.data);
	        }
	    }
	    this.elemMdf = false;
	};
	BaseElement.prototype.getType = function(){
	    return this.type;
	};
	
	BaseElement.prototype.resetHierarchy = function(){
	    if(!this.hierarchy){
	        this.hierarchy = [];
	    }else{
	        this.hierarchy.length = 0;
	    }
	};
	
	BaseElement.prototype.getHierarchy = function(){
	    if(!this.hierarchy){
	        this.hierarchy = [];
	    }
	    return this.hierarchy;
	};
	
	BaseElement.prototype.setHierarchy = function(hierarchy){
	    this.hierarchy = hierarchy;
	};
	
	BaseElement.prototype.getLayerSize = function(){
	    if(this.data.ty === 5){
	        return {w:this.data.textData.width,h:this.data.textData.height};
	    }else{
	        return {w:this.data.width,h:this.data.height};
	    }
	};
	
	BaseElement.prototype.hide = function(){
	
	};
	
	BaseElement.prototype.sourceRectAtTime = function(){
	    return {
	        top:0,
	        left:0,
	        width:100,
	        height:100
	    }
	};
	
	BaseElement.prototype.mHelper = new Matrix();
	function SVGBaseElement(data,parentContainer,globalData,comp, placeholder){
	    this.globalData = globalData;
	    this.comp = comp;
	    this.data = data;
	    this.matteElement = null;
	    this.transformedElement = null;
	    this.isTransparent = false;
	    this.parentContainer = parentContainer;
	    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
	    this.placeholder = placeholder;
	    this._sizeChanged = false;
	    this.init();
	};
	
	createElement(BaseElement, SVGBaseElement);
	
	SVGBaseElement.prototype.createElements = function(){
	    this.layerElement = createNS('g');
	    this.transformedElement = this.layerElement;
	    if(this.data.hasMask){
	        this.maskedElement = this.layerElement;
	    }
	    var layerElementParent = null;
	    if(this.data.td){
	        if(this.data.td == 3 || this.data.td == 1){
	            var masker = createNS('mask');
	            masker.setAttribute('id',this.layerId);
	            masker.setAttribute('mask-type',this.data.td == 3 ? 'luminance':'alpha');
	            masker.appendChild(this.layerElement);
	            layerElementParent = masker;
	            this.globalData.defs.appendChild(masker);
	            ////// This is only for IE and Edge when mask if of type alpha
	            if(!featureSupport.maskType && this.data.td == 1){
	                masker.setAttribute('mask-type','luminance');
	                var filId = randomString(10);
	                var fil = filtersFactory.createFilter(filId);
	                this.globalData.defs.appendChild(fil);
	                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                var gg = createNS('g');
	                gg.appendChild(this.layerElement);
	                layerElementParent = gg;
	                masker.appendChild(gg);
	                gg.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	            }
	        }else if(this.data.td == 2){
	            var maskGroup = createNS('mask');
	            maskGroup.setAttribute('id',this.layerId);
	            maskGroup.setAttribute('mask-type','alpha');
	            var maskGrouper = createNS('g');
	            maskGroup.appendChild(maskGrouper);
	            var filId = randomString(10);
	            var fil = filtersFactory.createFilter(filId);
	            ////
	
	            var feColorMatrix = createNS('feColorMatrix');
	            feColorMatrix.setAttribute('type','matrix');
	            feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	            feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 -1 1');
	            fil.appendChild(feColorMatrix);
	
	            ////
	            /*var feCTr = createNS('feComponentTransfer');
	            feCTr.setAttribute('in','SourceGraphic');
	            fil.appendChild(feCTr);
	            var feFunc = createNS('feFuncA');
	            feFunc.setAttribute('type','table');
	            feFunc.setAttribute('tableValues','1.0 0.0');
	            feCTr.appendChild(feFunc);*/
	            this.globalData.defs.appendChild(fil);
	            var alphaRect = createNS('rect');
	            alphaRect.setAttribute('width',this.comp.data.w);
	            alphaRect.setAttribute('height',this.comp.data.h);
	            alphaRect.setAttribute('x','0');
	            alphaRect.setAttribute('y','0');
	            alphaRect.setAttribute('fill','#ffffff');
	            alphaRect.setAttribute('opacity','0');
	            maskGrouper.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	            maskGrouper.appendChild(alphaRect);
	            maskGrouper.appendChild(this.layerElement);
	            layerElementParent = maskGrouper;
	            if(!featureSupport.maskType){
	                maskGroup.setAttribute('mask-type','luminance');
	                fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
	                var gg = createNS('g');
	                maskGrouper.appendChild(alphaRect);
	                gg.appendChild(this.layerElement);
	                layerElementParent = gg;
	                maskGrouper.appendChild(gg);
	            }
	            this.globalData.defs.appendChild(maskGroup);
	        }
	    }else if(this.data.hasMask || this.data.tt){
	        if(this.data.tt){
	            this.matteElement = createNS('g');
	            this.matteElement.appendChild(this.layerElement);
	            layerElementParent = this.matteElement;
	            this.baseElement = this.matteElement;
	        }else{
	            this.baseElement = this.layerElement;
	        }
	    }else{
	        this.baseElement = this.layerElement;
	    }
	    if((this.data.ln || this.data.cl) && (this.data.ty === 4 || this.data.ty === 0)){
	        if(this.data.ln){
	            this.layerElement.setAttribute('id',this.data.ln);
	        }
	        if(this.data.cl){
	            this.layerElement.setAttribute('class',this.data.cl);
	        }
	    }
	    if(this.data.ty === 0){
	            var cp = createNS( 'clipPath');
	            var pt = createNS('path');
	            pt.setAttribute('d','M0,0 L'+this.data.w+',0'+' L'+this.data.w+','+this.data.h+' L0,'+this.data.h+'z');
	            var clipId = 'cp_'+randomString(8);
	            cp.setAttribute('id',clipId);
	            cp.appendChild(pt);
	            this.globalData.defs.appendChild(cp);
	        if(this.checkMasks()){
	            var cpGroup = createNS('g');
	            cpGroup.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
	            cpGroup.appendChild(this.layerElement);
	            this.transformedElement = cpGroup;
	            if(layerElementParent){
	                layerElementParent.appendChild(this.transformedElement);
	            } else {
	                this.baseElement = this.transformedElement;
	            }
	        } else {
	            this.layerElement.setAttribute('clip-path','url(' + locationHref + '#'+clipId+')');
	        }
	        
	    }
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    if(this.layerElement !== this.parentContainer){
	        this.placeholder = null;
	    }
	    /* Todo performance killer
	    if(this.data.sy){
	        var filterID = 'st_'+randomString(10);
	        var c = this.data.sy[0].c.k;
	        var r = this.data.sy[0].s.k;
	        var expansor = createNS('filter');
	        expansor.setAttribute('id',filterID);
	        var feFlood = createNS('feFlood');
	        this.feFlood = feFlood;
	        if(!c[0].e){
	            feFlood.setAttribute('flood-color','rgb('+c[0]+','+c[1]+','+c[2]+')');
	        }
	        feFlood.setAttribute('result','base');
	        expansor.appendChild(feFlood);
	        var feMorph = createNS('feMorphology');
	        feMorph.setAttribute('operator','dilate');
	        feMorph.setAttribute('in','SourceGraphic');
	        feMorph.setAttribute('result','bigger');
	        this.feMorph = feMorph;
	        if(!r.length){
	            feMorph.setAttribute('radius',this.data.sy[0].s.k);
	        }
	        expansor.appendChild(feMorph);
	        var feColorMatrix = createNS('feColorMatrix');
	        feColorMatrix.setAttribute('result','mask');
	        feColorMatrix.setAttribute('in','bigger');
	        feColorMatrix.setAttribute('type','matrix');
	        feColorMatrix.setAttribute('values','0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0');
	        expansor.appendChild(feColorMatrix);
	        var feComposite = createNS('feComposite');
	        feComposite.setAttribute('result','drop');
	        feComposite.setAttribute('in','base');
	        feComposite.setAttribute('in2','mask');
	        feComposite.setAttribute('operator','in');
	        expansor.appendChild(feComposite);
	        var feBlend = createNS('feBlend');
	        feBlend.setAttribute('in','SourceGraphic');
	        feBlend.setAttribute('in2','drop');
	        feBlend.setAttribute('mode','normal');
	        expansor.appendChild(feBlend);
	        this.globalData.defs.appendChild(expansor);
	        var cont = createNS('g');
	        if(this.layerElement === this.parentContainer){
	            this.layerElement = cont;
	        }else{
	            cont.appendChild(this.layerElement);
	        }
	        cont.setAttribute('filter','url(#'+filterID+')');
	        if(this.data.td){
	            cont.setAttribute('data-td',this.data.td);
	        }
	        if(this.data.td == 3){
	            this.globalData.defs.appendChild(cont);
	        }else if(this.data.td == 2){
	            maskGrouper.appendChild(cont);
	        }else if(this.data.td == 1){
	            masker.appendChild(cont);
	        }else{
	            if(this.data.hasMask && this.data.tt){
	                this.matteElement.appendChild(cont);
	            }else{
	                this.appendNodeToParent(cont);
	            }
	        }
	    }*/
	    if(this.data.ef){
	        this.effectsManager = new SVGEffects(this);
	    }
	    this.checkParenting();
	};
	
	
	SVGBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;
	
	SVGBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3 || this.data.hd || !this.isVisible){
	        return false;
	    }
	
	    this.lastNum = this.currentFrameNum;
	    this.finalTransform.opMdf = this.firstFrame || this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.firstFrame || this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i = 0, len = this.hierarchy.length;
	        if(!this.finalTransform.matMdf) {
	            while(i < len) {
	                if(this.hierarchy[i].finalTransform.mProp.mdf) {
	                    this.finalTransform.matMdf = true;
	                    break;
	                }
	                i += 1;
	            }
	        }
	        
	        if(this.finalTransform.matMdf) {
	            mat = this.finalTransform.mProp.v.props;
	            finalMat.cloneFromProps(mat);
	            for(i=0;i<len;i+=1){
	                mat = this.hierarchy[i].finalTransform.mProp.v.props;
	                finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	            }
	        }
	        
	    }else if(this.isVisible){
	        finalMat = this.finalTransform.mProp.v;
	    }
	    if(this.finalTransform.matMdf && this.layerElement){
	        this.transformedElement.setAttribute('transform',finalMat.to2dCSS());
	    }
	    if(this.finalTransform.opMdf && this.layerElement){
	        if(this.finalTransform.op.v <= 0) {
	            if(!this.isTransparent && this.globalData.renderConfig.hideOnTransparent){
	                this.isTransparent = true;
	                this.hide();
	            }
	        } else if(this.hidden && this.isTransparent){
	            this.isTransparent = false;
	            this.show();
	        }
	        this.transformedElement.setAttribute('opacity',this.finalTransform.op.v);
	    }
	
	    if(this.data.hasMask){
	        this.maskManager.renderFrame(finalMat);
	    }
	    if(this.effectsManager){
	        this.effectsManager.renderFrame(this.firstFrame);
	    }
	    return this.isVisible;
	};
	
	SVGBaseElement.prototype.destroy = function(){
	    this.layerElement = null;
	    this.parentContainer = null;
	    if(this.matteElement) {
	        this.matteElement = null;
	    }
	    if(this.maskManager) {
	        this.maskManager.destroy();
	    }
	};
	
	SVGBaseElement.prototype.getBaseElement = function(){
	    return this.baseElement;
	};
	SVGBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new MaskElement(data,this,this.globalData);
	};
	
	SVGBaseElement.prototype.setMatte = function(id){
	    if(!this.matteElement){
	        return;
	    }
	    this.matteElement.setAttribute("mask", "url(" + locationHref + "#" + id + ")");
	};
	
	SVGBaseElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.layerElement.style.display = 'none';
	        this.hidden = true;
	    }
	};
	
	SVGBaseElement.prototype.show = function(){
	    if(this.isVisible && !this.isTransparent){
	        this.hidden = false;
	        this.layerElement.style.display = 'block';
	    }
	};
	
	function IShapeElement(data,parentContainer,globalData,comp, placeholder){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, IShapeElement);
	
	IShapeElement.prototype.identityMatrix = new Matrix();
	
	IShapeElement.prototype.lcEnum = {
	    '1': 'butt',
	    '2': 'round',
	    '3': 'square'
	}
	
	IShapeElement.prototype.ljEnum = {
	    '1': 'miter',
	    '2': 'round',
	    '3': 'butt'
	}
	
	IShapeElement.prototype.searchProcessedElement = function(elem){
	    var i = this.processedElements.length;
	    while(i){
	        i -= 1;
	        if(this.processedElements[i].elem === elem){
	            return this.processedElements[i].pos;
	        }
	    }
	    return 0;
	};
	
	IShapeElement.prototype.addProcessedElement = function(elem, pos){
	    var i = this.processedElements.length;
	    while(i){
	        i -= 1;
	        if(this.processedElements[i].elem === elem){
	            this.processedElements[i].pos = pos;
	            break;
	        }
	    }
	    if(i === 0){
	        this.processedElements.push({
	            elem: elem,
	            pos: pos
	        })
	    }
	};
	
	IShapeElement.prototype.buildExpressionInterface = function(){};
	
	IShapeElement.prototype.createElements = function(){
	    //TODO check if I can use symbol so i can set its viewBox
	    this._parent.createElements.call(this);
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties, 0, [], true);
	    if(!this.data.hd || this.data.td){
	        styleUnselectableDiv(this.layerElement);
	    }
	};
	
	IShapeElement.prototype.setGradientData = function(pathElement,arr,data){
	
	    var gradientId = 'gr_'+randomString(10);
	    var gfill;
	    if(arr.t === 1){
	        gfill = createNS('linearGradient');
	    } else {
	        gfill = createNS('radialGradient');
	    }
	    gfill.setAttribute('id',gradientId);
	    gfill.setAttribute('spreadMethod','pad');
	    gfill.setAttribute('gradientUnits','userSpaceOnUse');
	    var stops = [];
	    var stop, j, jLen;
	    jLen = arr.g.p*4;
	    for(j=0;j<jLen;j+=4){
	        stop = createNS('stop');
	        gfill.appendChild(stop);
	        stops.push(stop);
	    }
	    pathElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+gradientId+')');
	    this.globalData.defs.appendChild(gfill);
	    data.gf = gfill;
	    data.cst = stops;
	}
	
	IShapeElement.prototype.setGradientOpacity = function(arr, data, styleOb){
	    if((arr.g.k.k[0].s && arr.g.k.k[0].s.length > arr.g.p*4) || arr.g.k.k.length > arr.g.p*4){
	        var opFill;
	        var stop, j, jLen;
	        var mask = createNS("mask");
	        var maskElement = createNS( 'path');
	        mask.appendChild(maskElement);
	        var opacityId = 'op_'+randomString(10);
	        var maskId = 'mk_'+randomString(10);
	        mask.setAttribute('id',maskId);
	        if(arr.t === 1){
	            opFill = createNS('linearGradient');
	        } else {
	            opFill = createNS('radialGradient');
	        }
	        opFill.setAttribute('id',opacityId);
	        opFill.setAttribute('spreadMethod','pad');
	        opFill.setAttribute('gradientUnits','userSpaceOnUse');
	        jLen = arr.g.k.k[0].s ? arr.g.k.k[0].s.length : arr.g.k.k.length;
	        var stops = [];
	        for(j=arr.g.p*4;j<jLen;j+=2){
	            stop = createNS('stop');
	            stop.setAttribute('stop-color','rgb(255,255,255)');
	            //stop.setAttribute('offset',Math.round(arr.y[j][0]*100)+'%');
	            //stop.setAttribute('style','stop-color:rgb(255,255,255);stop-opacity:'+arr.y[j][1]);
	            opFill.appendChild(stop);
	            stops.push(stop);
	        }
	        maskElement.setAttribute( arr.ty === 'gf' ? 'fill':'stroke','url(#'+opacityId+')');
	        this.globalData.defs.appendChild(opFill);
	        this.globalData.defs.appendChild(mask);
	        data.of = opFill;
	        data.ost = stops;
	        styleOb.msElem = maskElement;
	        return maskId;
	    }
	};
	
	IShapeElement.prototype.createStyleElement = function(data, level, dynamicProperties){
	    var elementData = {
	    };
	    var styleOb = {
	        data: data,
	        type: data.ty,
	        d: '',
	        ld: '',
	        lvl: level,
	        mdf: false,
	        closed: false
	    };
	    var pathElement = createNS( "path");
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties);
	    if(data.ty == 'st' || data.ty == 'gs') {
	        pathElement.setAttribute('stroke-linecap', this.lcEnum[data.lc] || 'round');
	        ////pathElement.style.strokeLinecap = this.lcEnum[data.lc] || 'round';
	        pathElement.setAttribute('stroke-linejoin',this.ljEnum[data.lj] || 'round');
	        ////pathElement.style.strokeLinejoin = this.ljEnum[data.lj] || 'round';
	        pathElement.setAttribute('fill-opacity','0');
	        ////pathElement.style.fillOpacity = 0;
	        if(data.lj == 1) {
	            pathElement.setAttribute('stroke-miterlimit',data.ml);
	            ////pathElement.style.strokeMiterlimit = data.ml;
	        }
	
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,dynamicProperties);
	        if(data.d){
	            var d = new DashProperty(this,data.d,'svg',dynamicProperties);
	            if(!d.k){
	                pathElement.setAttribute('stroke-dasharray', d.dasharray);
	                ////pathElement.style.strokeDasharray = d.dasharray;
	                pathElement.setAttribute('stroke-dashoffset', d.dashoffset[0]);
	                ////pathElement.style.strokeDashoffset = d.dashoffset;
	            }
	            elementData.d = d;
	        }
	
	    }
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,dynamicProperties);
	    } else {
	        elementData.g = new GradientProperty(this,data.g,dynamicProperties);
	        if(data.t == 2){
	            elementData.h = PropertyFactory.getProp(this,data.h,0,0.01,dynamicProperties);
	            elementData.a = PropertyFactory.getProp(this,data.a,0,degToRads,dynamicProperties);
	        }
	        elementData.s = PropertyFactory.getProp(this,data.s,1,null,dynamicProperties);
	        elementData.e = PropertyFactory.getProp(this,data.e,1,null,dynamicProperties);
	        this.setGradientData(pathElement,data,elementData, styleOb);
	        var maskId = this.setGradientOpacity(data,elementData, styleOb);
	        if(maskId){
	            pathElement.setAttribute('mask','url(#'+maskId+')');
	        }
	    }
	    elementData.elem = pathElement;
	    //container.appendChild(pathElement);
	    if(data.r === 2) {
	        pathElement.setAttribute('fill-rule', 'evenodd');
	    }
	
	    if(data.ln){
	        pathElement.setAttribute('id',data.ln);
	    }
	    if(data.cl){
	        pathElement.setAttribute('class',data.cl);
	    }
	    styleOb.pElem = pathElement;
	    this.stylesList.push(styleOb);
	    elementData.style = styleOb;
	    return elementData;
	}
	
	IShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    var g = createNS('g');
	    elementData.gr = g;
	    if(data.ln){
	        elementData.gr.setAttribute('id',data.ln);
	    }
	    return elementData;
	}
	
	IShapeElement.prototype.createTransformElement = function(data, dynamicProperties) {
	    var elementData = {
	        transform : {
	            op: PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties),
	            mProps: TransformPropertyFactory.getTransformProperty(this,data,dynamicProperties)
	            //mProps: PropertyFactory.getProp(this,data,2,null,dynamicProperties)
	        },
	        elements: []
	    };
	    return elementData;
	}
	
	IShapeElement.prototype.createShapeElement = function(data, ownTransformers, level, dynamicProperties) {
	    var elementData = {
	        elements : [],
	        caches:[],
	        styles : [],
	        transformers: ownTransformers,
	        lStr: ''
	    };
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    elementData.sh = ShapePropertyFactory.getShapeProp(this,data,ty,dynamicProperties);
	    elementData.lvl = level;
	    this.shapes.push(elementData.sh);
	    this.addShapeToModifiers(elementData);
	    return elementData;
	}
	
	var cont = 0;
	
	IShapeElement.prototype.setElementStyles = function(){
	    var j, jLen = this.stylesList.length;
	    var arr = [];
	    for(j=0;j<jLen;j+=1){
	        if(!this.stylesList[j].closed){
	            arr.push(this.stylesList[j]);
	        }
	    }
	    return arr;
	}
	
	IShapeElement.prototype.reloadShapes = function(){
	    this.firstFrame = true;
	    var i, len = this.itemsData.length;
	    for(i=0;i<len;i+=1){
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties, 0, [], true);
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	}
	
	IShapeElement.prototype.searchShapes = function(arr,itemsData,prevViewData,container,dynamicProperties, level, transformers, render){
	    var ownTransformers = [].concat(transformers);
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownStyles = [], ownModifiers = [], styleOb, currentTransform, modifier, processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st' || arr[i].ty == 'gf' || arr[i].ty == 'gs'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], level, dynamicProperties);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].elem);
	            }
	            ownStyles.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,itemsData[i].gr,dynamicProperties, level + 1, ownTransformers, render);
	            if(arr[i]._render){
	                container.appendChild(itemsData[i].gr);
	            }
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], dynamicProperties);
	            }
	            currentTransform = itemsData[i].transform;
	            ownTransformers.push(currentTransform);
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level, dynamicProperties);
	            }
	            itemsData[i].elements = this.setElementStyles();
	
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd' || arr[i].ty == 'ms'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i],dynamicProperties);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        }else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData,dynamicProperties);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownStyles.length;
	    for(i=0;i<len;i+=1){
	        ownStyles[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	IShapeElement.prototype.addShapeToModifiers = function(data) {
	    var i, len = this.shapeModifiers.length;
	    for(i=0;i<len;i+=1){
	        this.shapeModifiers[i].addShape(data);
	    }
	};
	
	IShapeElement.prototype.renderModifiers = function() {
	    if(!this.shapeModifiers.length){
	        return;
	    }
	    var i, len = this.shapes.length;
	    for(i=0;i<len;i+=1){
	        this.shapes[i].reset();
	    }
	
	
	    len = this.shapeModifiers.length;
	
	    for(i=len-1;i>=0;i-=1){
	        this.shapeModifiers[i].processShapes(this.firstFrame);
	    }
	};
	
	IShapeElement.prototype.renderFrame = function(parentMatrix){
	    //this.reloadShapes();
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.layerElement.style.display = 'block';
	        this.hidden = false;
	    }
	    this.renderModifiers();
	    var i, len = this.stylesList.length;
	    for(i=0;i<len;i+=1){
	        this.stylesList[i].d = '';
	        this.stylesList[i].mdf = false;
	    }
	    this.renderShape(this.shapesData,this.itemsData, null);
	
	    for (i = 0; i < len; i += 1) {
	        if (this.stylesList[i].ld === '0') {
	            this.stylesList[i].ld = '1';
	            this.stylesList[i].pElem.style.display = 'block';
	            //this.stylesList[i].parent.appendChild(this.stylesList[i].pElem);
	        }
	        if (this.stylesList[i].mdf || this.firstFrame) {
	            this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
	            if(this.stylesList[i].msElem){
	                this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d);
	            }
	        }
	    }
	    if (this.firstFrame) {
	        this.firstFrame = false;
	    }
	};
	
	IShapeElement.prototype.hide = function(){
	    if(!this.hidden){
	        this.layerElement.style.display = 'none';
	        var i, len = this.stylesList.length;
	        for(i=len-1;i>=0;i-=1){
	            if(this.stylesList[i].ld !== '0'){
	                this.stylesList[i].ld = '0';
	                this.stylesList[i].pElem.style.display = 'none';
	                if(this.stylesList[i].pElem.parentNode){
	                    this.stylesList[i].parent = this.stylesList[i].pElem.parentNode;
	                    //this.stylesList[i].pElem.parentNode.removeChild(this.stylesList[i].pElem);
	                }
	            }
	        }
	        this.hidden = true;
	    }
	};
	
	IShapeElement.prototype.renderShape = function(items,data, container){
	    var i, len = items.length - 1;
	    var ty;
	    for(i=0;i<=len;i+=1){
	        ty = items[i].ty;
	        if(ty == 'tr'){
	            if(this.firstFrame || data[i].transform.op.mdf && container){
	                container.setAttribute('opacity',data[i].transform.op.v);
	            }
	            if(this.firstFrame || data[i].transform.mProps.mdf && container){
	                container.setAttribute('transform',data[i].transform.mProps.v.to2dCSS());
	            }
	        }else if(ty == 'sh' || ty == 'el' || ty == 'rc' || ty == 'sr'){
	            this.renderPath(items[i],data[i]);
	        }else if(ty == 'fl'){
	            this.renderFill(items[i],data[i]);
	        }else if(ty == 'gf'){
	            this.renderGradient(items[i],data[i]);
	        }else if(ty == 'gs'){
	            this.renderGradient(items[i],data[i]);
	            this.renderStroke(items[i],data[i]);
	        }else if(ty == 'st'){
	            this.renderStroke(items[i],data[i]);
	        }else if(ty == 'gr'){
	            this.renderShape(items[i].it,data[i].it, data[i].gr);
	        }else if(ty == 'tm'){
	            //
	        }
	    }
	
	};
	
	IShapeElement.prototype.buildShapeString = function(pathNodes, length, closed, mat) {
	    var i, shapeString = '';
	    for(i = 1; i < length; i += 1) {
	        if (i === 1) {
	            shapeString += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	        }
	        shapeString += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[i][0], pathNodes.i[i][1]) + " " + mat.applyToPointStringified(pathNodes.v[i][0], pathNodes.v[i][1]);
	    }
	    if (length === 1) {
	        shapeString += " M" + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	    }
	    if (closed && length) {
	        shapeString += " C" + mat.applyToPointStringified(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1]) + " " + mat.applyToPointStringified(pathNodes.i[0][0], pathNodes.i[0][1]) + " " + mat.applyToPointStringified(pathNodes.v[0][0], pathNodes.v[0][1]);
	        shapeString += 'z';
	    }
	    return shapeString;
	};
	
	IShapeElement.prototype.renderPath = function(pathData,itemData){
	    var len, i, j, jLen,pathStringTransformed,redraw,pathNodes,l, lLen = itemData.elements.length;
	    var lvl = itemData.lvl;
	    if(!pathData._render){
	        return;
	    }
	    for(l=0;l<lLen;l+=1){
	        if(itemData.elements[l].data._render){
	            redraw = itemData.sh.mdf || this.firstFrame;
	            //M0 0 is needed for IE and Edge bug. If it's missing, and shape has a mask with a gradient fill, it won't show up. :/
	            pathStringTransformed = 'M0 0';
	            var paths = itemData.sh.paths;
	            jLen = paths._length;
	
	            if(itemData.elements[l].lvl < lvl){
	                mat = this.mHelper.reset();
	                iterations = lvl - itemData.elements[l].lvl;
	                k = itemData.transformers.length-1;
	                while(iterations > 0) {
	                    redraw = itemData.transformers[k].mProps.mdf || redraw;
	                    props = itemData.transformers[k].mProps.v.props;
	                    mat.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	                    iterations --;
	                    k --;
	                }
	            } else {
	                mat = this.identityMatrix;
	            }
	            if(redraw){
	                for(j=0;j<jLen;j+=1){
	                    pathNodes = paths.shapes[j];
	                    if(pathNodes && pathNodes._length){
	                        pathStringTransformed += this.buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
	                    }
	                }
	                itemData.caches[l] = pathStringTransformed;
	            } else {
	                pathStringTransformed = itemData.caches[l];
	            }
	            itemData.elements[l].d += pathStringTransformed;
	            itemData.elements[l].mdf = redraw || itemData.elements[l].mdf;
	        } else {
	            itemData.elements[l].mdf = true;
	        }
	    }
	};
	
	IShapeElement.prototype.renderFill = function(styleData,itemData){
	    var styleElem = itemData.style;
	
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('fill','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
	        ////styleElem.pElem.style.fill = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('fill-opacity',itemData.o.v);
	    }
	};
	
	IShapeElement.prototype.renderGradient = function(styleData,itemData){
	    var gfill = itemData.gf;
	    var opFill = itemData.of;
	    var pt1 = itemData.s.v,pt2 = itemData.e.v;
	
	    if(itemData.o.mdf || this.firstFrame){
	        var attr = styleData.ty === 'gf' ? 'fill-opacity':'stroke-opacity';
	        itemData.elem.setAttribute(attr,itemData.o.v);
	    }
	    //clippedElement.setAttribute('transform','matrix(1,0,0,1,-100,0)');
	    if(itemData.s.mdf || this.firstFrame){
	        var attr1 = styleData.t === 1 ? 'x1':'cx';
	        var attr2 = attr1 === 'x1' ? 'y1':'cy';
	        gfill.setAttribute(attr1,pt1[0]);
	        gfill.setAttribute(attr2,pt1[1]);
	        if(opFill){
	            opFill.setAttribute(attr1,pt1[0]);
	            opFill.setAttribute(attr2,pt1[1]);
	        }
	    }
	    var stops, i, len, stop;
	    if(itemData.g.cmdf || this.firstFrame){
	        stops = itemData.cst;
	        var cValues = itemData.g.c;
	        len = stops.length;
	        for(i=0;i<len;i+=1){
	            stop = stops[i];
	            stop.setAttribute('offset',cValues[i*4]+'%');
	            stop.setAttribute('stop-color','rgb('+cValues[i*4+1]+','+cValues[i*4+2]+','+cValues[i*4+3]+')');
	        }
	    }
	    if(opFill && (itemData.g.omdf || this.firstFrame)){
	        stops = itemData.ost;
	        var oValues = itemData.g.o;
	        len = stops.length;
	        for(i=0;i<len;i+=1){
	            stop = stops[i];
	            stop.setAttribute('offset',oValues[i*2]+'%');
	            stop.setAttribute('stop-opacity',oValues[i*2+1]);
	        }
	    }
	    if(styleData.t === 1){
	        if(itemData.e.mdf  || this.firstFrame){
	            gfill.setAttribute('x2',pt2[0]);
	            gfill.setAttribute('y2',pt2[1]);
	            if(opFill){
	                opFill.setAttribute('x2',pt2[0]);
	                opFill.setAttribute('y2',pt2[1]);
	            }
	        }
	    } else {
	        var rad;
	        if(itemData.s.mdf || itemData.e.mdf || this.firstFrame){
	            rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
	            gfill.setAttribute('r',rad);
	            if(opFill){
	                opFill.setAttribute('r',rad);
	            }
	        }
	        if(itemData.e.mdf || itemData.h.mdf || itemData.a.mdf || this.firstFrame){
	            if(!rad){
	                rad = Math.sqrt(Math.pow(pt1[0]-pt2[0],2)+Math.pow(pt1[1]-pt2[1],2));
	            }
	            var ang = Math.atan2(pt2[1]-pt1[1], pt2[0]-pt1[0]);
	
	            var percent = itemData.h.v >= 1 ? 0.99 : itemData.h.v <= -1 ? -0.99:itemData.h.v;
	            var dist = rad*percent;
	            var x = Math.cos(ang + itemData.a.v)*dist + pt1[0];
	            var y = Math.sin(ang + itemData.a.v)*dist + pt1[1];
	            gfill.setAttribute('fx',x);
	            gfill.setAttribute('fy',y);
	            if(opFill){
	                opFill.setAttribute('fx',x);
	                opFill.setAttribute('fy',y);
	            }
	        }
	        //gfill.setAttribute('fy','200');
	    }
	};
	
	IShapeElement.prototype.renderStroke = function(styleData,itemData){
	    var styleElem = itemData.style;
	    var d = itemData.d;
	    if(d && (d.mdf || this.firstFrame)){
	        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
	        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
	    }
	    if(itemData.c && (itemData.c.mdf || this.firstFrame)){
	        styleElem.pElem.setAttribute('stroke','rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')');
	    }
	    if(itemData.o.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('stroke-opacity',itemData.o.v);
	    }
	    if(itemData.w.mdf || this.firstFrame){
	        styleElem.pElem.setAttribute('stroke-width',itemData.w.v);
	        if(styleElem.msElem){
	            styleElem.msElem.setAttribute('stroke-width',itemData.w.v);
	        }
	    }
	};
	
	IShapeElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    this.shapeData = null;
	    this.itemsData = null;
	    this.parentContainer = null;
	    this.placeholder = null;
	};
	
	function ITextElement(data, animationItem,parentContainer,globalData){
	}
	ITextElement.prototype.init = function(){
	    this.lettersChangedFlag = true;
	    this.dynamicProperties = this.dynamicProperties || [];
	    this.textAnimator = new TextAnimatorProperty(this.data.t, this.renderType, this);
	    this.textProperty = new TextProperty(this, this.data.t, this.dynamicProperties);
	    this._parent.init.call(this);
	    this.textAnimator.searchProperties(this.dynamicProperties);
	};
	
	ITextElement.prototype.prepareFrame = function(num) {
	    this._parent.prepareFrame.call(this, num);
	    if(this.textProperty.mdf || this.textProperty.firstFrame) {
	        this.buildNewText();
	        this.textProperty.firstFrame = false;
	    }
	}
	
	ITextElement.prototype.createPathShape = function(matrixHelper, shapes) {
	    var j,jLen = shapes.length;
	    var k, kLen, pathNodes;
	    var shapeStr = '';
	    for(j=0;j<jLen;j+=1){
	        pathNodes = shapes[j].ks.k;
	        shapeStr += this.buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
	    }
	    return shapeStr;
	};
	
	ITextElement.prototype.updateDocumentData = function(newData, index) {
	    this.textProperty.updateDocumentData(newData, index);
	}
	
	ITextElement.prototype.applyTextPropertiesToMatrix = function(documentData, matrixHelper, lineNumber, xPos, yPos) {
	    if(documentData.ps){
	        matrixHelper.translate(documentData.ps[0],documentData.ps[1] + documentData.ascent,0);
	    }
	    matrixHelper.translate(0,-documentData.ls,0);
	    switch(documentData.j){
	        case 1:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]),0,0);
	            break;
	        case 2:
	            matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber] )/2,0,0);
	            break;
	    }
	    matrixHelper.translate(xPos, yPos, 0);
	}
	
	ITextElement.prototype.buildColor = function(colorData) {
	    return 'rgb(' + Math.round(colorData[0]*255) + ',' + Math.round(colorData[1]*255) + ',' + Math.round(colorData[2]*255) + ')';
	}
	
	ITextElement.prototype.buildShapeString = IShapeElement.prototype.buildShapeString;
	
	ITextElement.prototype.emptyProp = new LetterProps();
	
	ITextElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	};
	function SVGTextElement(data,parentContainer,globalData,comp, placeholder){
	    this.textSpans = [];
	    this.renderType = 'svg';
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, SVGTextElement);
	
	extendPrototype(ITextElement, SVGTextElement);
	
	SVGTextElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	
	
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	    if (this.data.singleShape && !this.globalData.fontManager.chars) {
	        this.textContainer = createNS('text');
	    }
	};
	
	SVGTextElement.prototype.buildNewText = function(){
	    var i, len;
	
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = Array.apply(null,{length:documentData ? documentData.l.length : 0});
	    if(documentData.fc) {
	        this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
	    }else{
	        this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
	    }
	    if(documentData.sc){
	        this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
	        this.layerElement.setAttribute('stroke-width', documentData.sw);
	    }
	    this.layerElement.setAttribute('font-size', documentData.s);
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(fontData.fClass){
	        this.layerElement.setAttribute('class',fontData.fClass);
	    } else {
	        this.layerElement.setAttribute('font-family', fontData.fFamily);
	        var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	        this.layerElement.setAttribute('font-style', fStyle);
	        this.layerElement.setAttribute('font-weight', fWeight);
	    }
	
	    var letters = documentData.l || [];
	    var usesGlyphs = this.globalData.fontManager.chars;
	    len = letters.length;
	    if(!len){
	        return;
	    }
	    var tSpan;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '', singleShape = this.data.singleShape;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var trackingOffset = documentData.tr/1000*documentData.s;
	    if(singleShape && !usesGlyphs) {
	        var tElement = this.textContainer;
	        var justify = '';
	        switch(documentData.j) {
	            case 1:
	                justify = 'end';
	                break;
	            case 2:
	                justify = 'middle';
	                break;
	            case 2:
	                justify = 'start';
	                break;
	        }
	        tElement.setAttribute('text-anchor',justify);
	        tElement.setAttribute('letter-spacing',trackingOffset);
	        var textContent = documentData.t.split(String.fromCharCode(13));
	        len = textContent.length;
	        var yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;
	        for ( i = 0; i < len; i += 1) {
	            tSpan = this.textSpans[i] || createNS('tspan');
	            tSpan.textContent = textContent[i];
	            tSpan.setAttribute('x', 0);
	            tSpan.setAttribute('y', yPos);
	            tSpan.style.display = 'inherit';
	            tElement.appendChild(tSpan);
	            this.textSpans[i] = tSpan;
	            yPos += documentData.lh;
	        }
	        
	        this.layerElement.appendChild(tElement);
	    } else {
	        var cachedSpansLength = this.textSpans.length;
	        var shapeData, charData;
	        for (i = 0; i < len; i += 1) {
	            if(!usesGlyphs || !singleShape || i === 0){
	                tSpan = cachedSpansLength > i ? this.textSpans[i] : createNS(usesGlyphs?'path':'text');
	                if (cachedSpansLength <= i) {
	                    tSpan.setAttribute('stroke-linecap', 'butt');
	                    tSpan.setAttribute('stroke-linejoin','round');
	                    tSpan.setAttribute('stroke-miterlimit','4');
	                    this.textSpans[i] = tSpan;
	                    this.layerElement.appendChild(tSpan);
	                }
	                tSpan.style.display = 'inherit';
	            }
	            
	            matrixHelper.reset();
	            if(usesGlyphs) {
	                matrixHelper.scale(documentData.s / 100, documentData.s / 100);
	                if (singleShape) {
	                    if(letters[i].n) {
	                        xPos = -trackingOffset;
	                        yPos += documentData.yOffset;
	                        yPos += firstLine ? 1 : 0;
	                        firstLine = false;
	                    }
	                    this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	                    xPos += letters[i].l || 0;
	                    //xPos += letters[i].val === ' ' ? 0 : trackingOffset;
	                    xPos += trackingOffset;
	                }
	                charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	                shapeData = charData && charData.data || {};
	                shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	                if(!singleShape){
	                    tSpan.setAttribute('d',this.createPathShape(matrixHelper,shapes));
	                } else {
	                    shapeStr += this.createPathShape(matrixHelper,shapes);
	                }
	            } else {
	                tSpan.textContent = letters[i].val;
	                tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            }
	            //
	        }
	        if (singleShape) {
	            tSpan.setAttribute('d',shapeStr);
	        }
	    }
	    while (i < this.textSpans.length){
	        this.textSpans[i].style.display = 'none';
	        i += 1;
	    }
	    
	    this._sizeChanged = true;
	}
	
	SVGTextElement.prototype.sourceRectAtTime = function(time){
	    this.prepareFrame(this.comp.renderedFrame - this.data.st);
	    this.renderLetters();
	    if(this._sizeChanged){
	        this._sizeChanged = false;
	        var textBox = this.layerElement.getBBox();
	        this.bbox = {
	            top: textBox.y,
	            left: textBox.x,
	            width: textBox.width,
	            height: textBox.height
	        }
	    }
	    return this.bbox;
	}
	
	SVGTextElement.prototype.renderLetters = function(){
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	        if(this.lettersChangedFlag || this.textAnimator.lettersChangedFlag){
	            this._sizeChanged = true;
	            var  i,len;
	            var renderedLetters = this.textAnimator.renderedLetters;
	
	            var letters = this.textProperty.currentData.l;
	
	            len = letters.length;
	            var renderedLetter, textSpan;
	            for(i=0;i<len;i+=1){
	                if(letters[i].n){
	                    continue;
	                }
	                renderedLetter = renderedLetters[i];
	                textSpan = this.textSpans[i];
	                if(renderedLetter.mdf.m) {
	                    textSpan.setAttribute('transform',renderedLetter.m);
	                }
	                if(renderedLetter.mdf.o) {
	                    textSpan.setAttribute('opacity',renderedLetter.o);
	                }
	                if(renderedLetter.mdf.sw){
	                    textSpan.setAttribute('stroke-width',renderedLetter.sw);
	                }
	                if(renderedLetter.mdf.sc){
	                    textSpan.setAttribute('stroke',renderedLetter.sc);
	                }
	                if(renderedLetter.mdf.fc){
	                    textSpan.setAttribute('fill',renderedLetter.fc);
	                }
	            }
	        }
	    }
	}
	
	SVGTextElement.prototype.renderFrame = function(parentMatrix){
	
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.show();
	    }
	    if(this.firstFrame) {
	        this.firstFrame = false;
	    }
	    this.renderLetters();
	}
	function SVGTintFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f2');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	    if(filterManager.effectElements[2].p.v !== 100 || filterManager.effectElements[2].p.k){
	        var feMerge = createNS('feMerge');
	        filter.appendChild(feMerge);
	        var feMergeNode;
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','SourceGraphic');
	        feMerge.appendChild(feMergeNode);
	        feMergeNode = createNS('feMergeNode');
	        feMergeNode.setAttribute('in','f2');
	        feMerge.appendChild(feMergeNode);
	    }
	}
	
	SVGTintFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var colorBlack = this.filterManager.effectElements[0].p.v;
	        var colorWhite = this.filterManager.effectElements[1].p.v;
	        var opacity = this.filterManager.effectElements[2].p.v/100;
	        this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGFillFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','sRGB');
	    feColorMatrix.setAttribute('values','1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
	    filter.appendChild(feColorMatrix);
	    this.matrixFilter = feColorMatrix;
	}
	SVGFillFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var color = this.filterManager.effectElements[2].p.v;
	        var opacity = this.filterManager.effectElements[6].p.v;
	        this.matrixFilter.setAttribute('values','0 0 0 0 '+color[0]+' 0 0 0 0 '+color[1]+' 0 0 0 0 '+color[2]+' 0 0 0 '+opacity+' 0');
	    }
	};
	function SVGStrokeEffect(elem, filterManager){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.elem = elem;
	    this.paths = [];
	}
	
	SVGStrokeEffect.prototype.initialize = function(){
	
	    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	    var path,groupPath, i, len;
	    if(this.filterManager.effectElements[1].p.v === 1){
	        len = this.elem.maskManager.masksProperties.length;
	        i = 0;
	    } else {
	        i = this.filterManager.effectElements[0].p.v - 1;
	        len = i + 1;
	    }
	    groupPath = createNS('g'); 
	    groupPath.setAttribute('fill','none');
	    groupPath.setAttribute('stroke-linecap','round');
	    groupPath.setAttribute('stroke-dashoffset',1);
	    for(i;i<len;i+=1){
	        path = createNS('path');
	        groupPath.appendChild(path);
	        this.paths.push({p:path,m:i});
	    }
	    if(this.filterManager.effectElements[10].p.v === 3){
	        var mask = createNS('mask');
	        var id = 'stms_' + randomString(10);
	        mask.setAttribute('id',id);
	        mask.setAttribute('mask-type','alpha');
	        mask.appendChild(groupPath);
	        this.elem.globalData.defs.appendChild(mask);
	        var g = createNS('g');
	        g.setAttribute('mask','url(' + locationHref + '#'+id+')');
	        if(elemChildren[0]){
	            g.appendChild(elemChildren[0]);
	        }
	        this.elem.layerElement.appendChild(g);
	        this.masker = mask;
	        groupPath.setAttribute('stroke','#fff');
	    } else if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(this.filterManager.effectElements[10].p.v === 2){
	            var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
	            while(elemChildren.length){
	                this.elem.layerElement.removeChild(elemChildren[0]);
	            }
	        }
	        this.elem.layerElement.appendChild(groupPath);
	        this.elem.layerElement.removeAttribute('mask');
	        groupPath.setAttribute('stroke','#fff');
	    }
	    this.initialized = true;
	    this.pathMasker = groupPath;
	}
	
	SVGStrokeEffect.prototype.renderFrame = function(forceRender){
	    if(!this.initialized){
	        this.initialize();
	    }
	    var i, len = this.paths.length;
	    var mask, path;
	    for(i=0;i<len;i+=1){
	        mask = this.elem.maskManager.viewData[this.paths[i].m];
	        path = this.paths[i].p;
	        if(forceRender || this.filterManager.mdf || mask.prop.mdf){
	            path.setAttribute('d',mask.lastPath);
	        }
	        if(forceRender || this.filterManager.effectElements[9].p.mdf || this.filterManager.effectElements[4].p.mdf || this.filterManager.effectElements[7].p.mdf || this.filterManager.effectElements[8].p.mdf || mask.prop.mdf){
	            var dasharrayValue;
	            if(this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100){
	                var s = Math.min(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var e = Math.max(this.filterManager.effectElements[7].p.v,this.filterManager.effectElements[8].p.v)/100;
	                var l = path.getTotalLength();
	                dasharrayValue = '0 0 0 ' + l*s + ' ';
	                var lineLength = l*(e-s);
	                var segment = 1+this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	                var units = Math.floor(lineLength/segment);
	                var j;
	                for(j=0;j<units;j+=1){
	                    dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100 + ' ';
	                }
	                dasharrayValue += '0 ' + l*10 + ' 0 0';
	            } else {
	                dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v*2*this.filterManager.effectElements[9].p.v/100;
	            }
	            path.setAttribute('stroke-dasharray',dasharrayValue);
	        }
	    }
	    if(forceRender || this.filterManager.effectElements[4].p.mdf){
	        this.pathMasker.setAttribute('stroke-width',this.filterManager.effectElements[4].p.v*2);
	    }
	    
	    if(forceRender || this.filterManager.effectElements[6].p.mdf){
	        this.pathMasker.setAttribute('opacity',this.filterManager.effectElements[6].p.v);
	    }
	    if(this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2){
	        if(forceRender || this.filterManager.effectElements[3].p.mdf){
	            var color = this.filterManager.effectElements[3].p.v;
	            this.pathMasker.setAttribute('stroke','rgb('+bm_floor(color[0]*255)+','+bm_floor(color[1]*255)+','+bm_floor(color[2]*255)+')');
	        }
	    }
	};
	function SVGTritoneFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var feColorMatrix = createNS('feColorMatrix');
	    feColorMatrix.setAttribute('type','matrix');
	    feColorMatrix.setAttribute('color-interpolation-filters','linearRGB');
	    feColorMatrix.setAttribute('values','0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
	    feColorMatrix.setAttribute('result','f1');
	    filter.appendChild(feColorMatrix);
	    var feComponentTransfer = createNS('feComponentTransfer');
	    feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	    filter.appendChild(feComponentTransfer);
	    this.matrixFilter = feComponentTransfer;
	    var feFuncR = createNS('feFuncR');
	    feFuncR.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncR);
	    this.feFuncR = feFuncR;
	    var feFuncG = createNS('feFuncG');
	    feFuncG.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncG);
	    this.feFuncG = feFuncG;
	    var feFuncB = createNS('feFuncB');
	    feFuncB.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFuncB);
	    this.feFuncB = feFuncB;
	}
	
	SVGTritoneFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var color1 = this.filterManager.effectElements[0].p.v;
	        var color2 = this.filterManager.effectElements[1].p.v;
	        var color3 = this.filterManager.effectElements[2].p.v;
	        var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0]
	        var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1]
	        var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2]
	        this.feFuncR.setAttribute('tableValues', tableR);
	        this.feFuncG.setAttribute('tableValues', tableG);
	        this.feFuncB.setAttribute('tableValues', tableB);
	        //var opacity = this.filterManager.effectElements[2].p.v/100;
	        //this.matrixFilter.setAttribute('values',(colorWhite[0]- colorBlack[0])+' 0 0 0 '+ colorBlack[0] +' '+ (colorWhite[1]- colorBlack[1]) +' 0 0 0 '+ colorBlack[1] +' '+ (colorWhite[2]- colorBlack[2]) +' 0 0 0 '+ colorBlack[2] +' 0 0 0 ' + opacity + ' 0');
	    }
	};
	function SVGProLevelsFilter(filter, filterManager){
	    this.filterManager = filterManager;
	    var effectElements = this.filterManager.effectElements;
	    var feComponentTransfer = createNS('feComponentTransfer');
	    var feFuncR, feFuncG, feFuncB;
	    
	    if(effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1){
	        this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
	    }
	    if(effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1){
	        this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
	    }
	    if(effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1){
	        this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	    if(effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1){
	        this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
	    }
	    
	    if(this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA){
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        feComponentTransfer = createNS('feComponentTransfer');
	    }
	
	    if(effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1){
	
	        feComponentTransfer.setAttribute('color-interpolation-filters','sRGB');
	        filter.appendChild(feComponentTransfer);
	        this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
	        this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
	        this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
	    }
	}
	
	SVGProLevelsFilter.prototype.createFeFunc = function(type, feComponentTransfer) {
	    var feFunc = createNS(type);
	    feFunc.setAttribute('type','table');
	    feComponentTransfer.appendChild(feFunc);
	    return feFunc;
	};
	
	SVGProLevelsFilter.prototype.getTableValue = function(inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
	    var cnt = 0;
	    var segments = 256;
	    var perc;
	    var min = Math.min(inputBlack, inputWhite);
	    var max = Math.max(inputBlack, inputWhite);
	    var table = Array.call(null,{length:segments});
	    var colorValue;
	    var pos = 0;
	    var outputDelta = outputWhite - outputBlack; 
	    var inputDelta = inputWhite - inputBlack; 
	    while(cnt <= 256) {
	        perc = cnt/256;
	        if(perc <= min){
	            colorValue = inputDelta < 0 ? outputWhite : outputBlack;
	        } else if(perc >= max){
	            colorValue = inputDelta < 0 ? outputBlack : outputWhite;
	        } else {
	            colorValue = (outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma));
	        }
	        table[pos++] = colorValue;
	        cnt += 256/(segments-1);
	    }
	    return table.join(' ');
	};
	
	SVGProLevelsFilter.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        var val, cnt, perc, bezier;
	        var effectElements = this.filterManager.effectElements;
	        if(this.feFuncRComposed && (forceRender || effectElements[3].p.mdf || effectElements[4].p.mdf || effectElements[5].p.mdf || effectElements[6].p.mdf || effectElements[7].p.mdf)){
	            val = this.getTableValue(effectElements[3].p.v,effectElements[4].p.v,effectElements[5].p.v,effectElements[6].p.v,effectElements[7].p.v);
	            this.feFuncRComposed.setAttribute('tableValues',val);
	            this.feFuncGComposed.setAttribute('tableValues',val);
	            this.feFuncBComposed.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncR && (forceRender || effectElements[10].p.mdf || effectElements[11].p.mdf || effectElements[12].p.mdf || effectElements[13].p.mdf || effectElements[14].p.mdf)){
	            val = this.getTableValue(effectElements[10].p.v,effectElements[11].p.v,effectElements[12].p.v,effectElements[13].p.v,effectElements[14].p.v);
	            this.feFuncR.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncG && (forceRender || effectElements[17].p.mdf || effectElements[18].p.mdf || effectElements[19].p.mdf || effectElements[20].p.mdf || effectElements[21].p.mdf)){
	            val = this.getTableValue(effectElements[17].p.v,effectElements[18].p.v,effectElements[19].p.v,effectElements[20].p.v,effectElements[21].p.v);
	            this.feFuncG.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncB && (forceRender || effectElements[24].p.mdf || effectElements[25].p.mdf || effectElements[26].p.mdf || effectElements[27].p.mdf || effectElements[28].p.mdf)){
	            val = this.getTableValue(effectElements[24].p.v,effectElements[25].p.v,effectElements[26].p.v,effectElements[27].p.v,effectElements[28].p.v);
	            this.feFuncB.setAttribute('tableValues',val);
	        }
	
	        if(this.feFuncA && (forceRender || effectElements[31].p.mdf || effectElements[32].p.mdf || effectElements[33].p.mdf || effectElements[34].p.mdf || effectElements[35].p.mdf)){
	            val = this.getTableValue(effectElements[31].p.v,effectElements[32].p.v,effectElements[33].p.v,effectElements[34].p.v,effectElements[35].p.v);
	            this.feFuncA.setAttribute('tableValues',val);
	        }
	        
	    }
	};
	function SVGDropShadowEffect(filter, filterManager){
	    /*<feGaussianBlur in="SourceAlpha" stdDeviation="3"/> <!-- stdDeviation is how much to blur -->
	  <feOffset dx="2" dy="2" result="offsetblur"/> <!-- how much to offset -->
	  <feMerge> 
	    <feMergeNode/> <!-- this contains the offset blurred image -->
	    <feMergeNode in="SourceGraphic"/> <!-- this contains the element that the filter is applied to -->
	  </feMerge>*/
	  /*<feFlood flood-color="#3D4574" flood-opacity="0.5" result="offsetColor"/>*/
	    filter.setAttribute('x','-100%');
	    filter.setAttribute('y','-100%');
	    filter.setAttribute('width','400%');
	    filter.setAttribute('height','400%');
	    this.filterManager = filterManager;
	
	    var feGaussianBlur = createNS('feGaussianBlur');
	    feGaussianBlur.setAttribute('in','SourceAlpha');
	    feGaussianBlur.setAttribute('result','drop_shadow_1');
	    feGaussianBlur.setAttribute('stdDeviation','0');
	    this.feGaussianBlur = feGaussianBlur;
	    filter.appendChild(feGaussianBlur);
	
	    var feOffset = createNS('feOffset');
	    feOffset.setAttribute('dx','25');
	    feOffset.setAttribute('dy','0');
	    feOffset.setAttribute('in','drop_shadow_1');
	    feOffset.setAttribute('result','drop_shadow_2');
	    this.feOffset = feOffset;
	    filter.appendChild(feOffset);
	    var feFlood = createNS('feFlood');
	    feFlood.setAttribute('flood-color','#00ff00');
	    feFlood.setAttribute('flood-opacity','1');
	    feFlood.setAttribute('result','drop_shadow_3');
	    this.feFlood = feFlood;
	    filter.appendChild(feFlood);
	
	    var feComposite = createNS('feComposite');
	    feComposite.setAttribute('in','drop_shadow_3');
	    feComposite.setAttribute('in2','drop_shadow_2');
	    feComposite.setAttribute('operator','in');
	    feComposite.setAttribute('result','drop_shadow_4');
	    filter.appendChild(feComposite);
	
	
	    var feMerge = createNS('feMerge');
	    filter.appendChild(feMerge);
	    var feMergeNode;
	    feMergeNode = createNS('feMergeNode');
	    feMerge.appendChild(feMergeNode);
	    feMergeNode = createNS('feMergeNode');
	    feMergeNode.setAttribute('in','SourceGraphic');
	    this.feMergeNode = feMergeNode;
	    this.feMerge = feMerge;
	    this.originalNodeAdded = false;
	    feMerge.appendChild(feMergeNode);
	}
	
	SVGDropShadowEffect.prototype.renderFrame = function(forceRender){
	    if(forceRender || this.filterManager.mdf){
	        if(forceRender || this.filterManager.effectElements[4].p.mdf){
	            this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
	        }
	        if(forceRender || this.filterManager.effectElements[0].p.mdf){
	            var col = this.filterManager.effectElements[0].p.v;
	            this.feFlood.setAttribute('flood-color',rgbToHex(Math.round(col[0]*255),Math.round(col[1]*255),Math.round(col[2]*255)));
	        }
	        if(forceRender || this.filterManager.effectElements[1].p.mdf){
	            this.feFlood.setAttribute('flood-opacity',this.filterManager.effectElements[1].p.v/255);
	        }
	        if(forceRender || this.filterManager.effectElements[2].p.mdf || this.filterManager.effectElements[3].p.mdf){
	            var distance = this.filterManager.effectElements[3].p.v
	            var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads
	            var x = distance * Math.cos(angle)
	            var y = distance * Math.sin(angle)
	            this.feOffset.setAttribute('dx', x);
	            this.feOffset.setAttribute('dy', y);
	        }
	        /*if(forceRender || this.filterManager.effectElements[5].p.mdf){
	            if(this.filterManager.effectElements[5].p.v === 1 && this.originalNodeAdded) {
	                this.feMerge.removeChild(this.feMergeNode);
	                this.originalNodeAdded = false;
	            } else if(this.filterManager.effectElements[5].p.v === 0 && !this.originalNodeAdded) {
	                this.feMerge.appendChild(this.feMergeNode);
	                this.originalNodeAdded = true;
	            }
	        }*/
	    }
	};
	function SVGMatte3Effect(filterElem, filterManager, elem){
	    this.initialized = false;
	    this.filterManager = filterManager;
	    this.filterElem = filterElem;
	    this.elem = elem;
	    elem.matteElement = createNS('g');
	    elem.matteElement.appendChild(elem.layerElement);
	    elem.matteElement.appendChild(elem.transformedElement);
	    elem.baseElement = elem.matteElement;
	}
	
	SVGMatte3Effect.prototype.setElementAsMask = function(elem, mask) {
	    var masker = createNS('mask');
	    masker.setAttribute('id',mask.layerId);
	    masker.setAttribute('mask-type','alpha');
	    masker.appendChild(mask.layerElement);
	    elem.setMatte(mask.layerId);
	    mask.data.hd = false;
	    var defs = elem.globalData.defs;
	    defs.appendChild(masker);
	}
	
	SVGMatte3Effect.prototype.initialize = function() {
	    var ind = this.filterManager.effectElements[0].p.v;
	    var i = 0, len = this.elem.comp.elements.length;
	    while(i < len) {
	    	if(this.elem.comp.elements[i].data.ind === ind) {
	    		this.setElementAsMask(this.elem, this.elem.comp.elements[i]);
	    	}
	    	i += 1;
	    }
	    this.initialized = true;
	}
	
	SVGMatte3Effect.prototype.renderFrame = function() {
		if(!this.initialized) {
			this.initialize();
		}
	}
	function SVGEffects(elem){
	    var i, len = elem.data.ef.length;
	    var filId = randomString(10);
	    var fil = filtersFactory.createFilter(filId);
	    var count = 0;
	    this.filters = [];
	    var filterManager;
	    for(i=0;i<len;i+=1){
	        if(elem.data.ef[i].ty === 20){
	            count += 1;
	            filterManager = new SVGTintFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 21){
	            count += 1;
	            filterManager = new SVGFillFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 22){
	            filterManager = new SVGStrokeEffect(elem, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 23){
	            count += 1;
	            filterManager = new SVGTritoneFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 24){
	            count += 1;
	            filterManager = new SVGProLevelsFilter(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 25){
	            count += 1;
	            filterManager = new SVGDropShadowEffect(fil, elem.effects.effectElements[i]);
	            this.filters.push(filterManager);
	        }else if(elem.data.ef[i].ty === 28){
	            //count += 1;
	            filterManager = new SVGMatte3Effect(fil, elem.effects.effectElements[i], elem);
	            this.filters.push(filterManager);
	        }
	    }
	    if(count){
	        elem.globalData.defs.appendChild(fil);
	        elem.layerElement.setAttribute('filter','url(' + locationHref + '#'+filId+')');
	    }
	}
	
	SVGEffects.prototype.renderFrame = function(firstFrame){
	    var i, len = this.filters.length;
	    for(i=0;i<len;i+=1){
	        this.filters[i].renderFrame(firstFrame);
	    }
	};
	function ICompElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = this.layers ? Array.apply(null,{length:this.layers.length}) : [];
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.xt){
	        this.layerElement = createNS('g');
	        this.buildAllItems();
	    } else if(!globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	}
	createElement(SVGBaseElement, ICompElement);
	
	ICompElement.prototype.hide = function(){
	    if(!this.hidden){
	        this._parent.hide.call(this);
	        var i,len = this.elements.length;
	        for( i = 0; i < len; i+=1 ){
	            if(this.elements[i]){
	                this.elements[i].hide();
	            }
	        }
	    }
	};
	
	ICompElement.prototype.prepareFrame = function(num){
	    this._parent.prepareFrame.call(this,num);
	    if(this.isVisible===false && !this.data.xt){
	        return;
	    }
	
	    if(this.tm){
	        var timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	        this.renderedFrame = timeRemapped;
	    } else {
	        this.renderedFrame = num/this.data.sr;
	    }
	    var i,len = this.elements.length;
	    if(!this.completeLayers){
	        this.checkLayers(this.renderedFrame);
	    }
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);
	        }
	    }
	};
	
	ICompElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    var i,len = this.layers.length;
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	
	    if(this.hidden) {
	        this.show();
	    }
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	ICompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	ICompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	ICompElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    var i,len = this.layers.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i]){
	            this.elements[i].destroy();
	        }
	    }
	};
	
	ICompElement.prototype.checkLayers = SVGRenderer.prototype.checkLayers;
	ICompElement.prototype.buildItem = SVGRenderer.prototype.buildItem;
	ICompElement.prototype.buildAllItems = SVGRenderer.prototype.buildAllItems;
	ICompElement.prototype.buildElementParenting = SVGRenderer.prototype.buildElementParenting;
	ICompElement.prototype.createItem = SVGRenderer.prototype.createItem;
	ICompElement.prototype.createImage = SVGRenderer.prototype.createImage;
	ICompElement.prototype.createComp = SVGRenderer.prototype.createComp;
	ICompElement.prototype.createSolid = SVGRenderer.prototype.createSolid;
	ICompElement.prototype.createShape = SVGRenderer.prototype.createShape;
	ICompElement.prototype.createText = SVGRenderer.prototype.createText;
	ICompElement.prototype.createBase = SVGRenderer.prototype.createBase;
	ICompElement.prototype.appendElementInPos = SVGRenderer.prototype.appendElementInPos;
	ICompElement.prototype.checkPendingElements = SVGRenderer.prototype.checkPendingElements;
	ICompElement.prototype.addPendingElement = SVGRenderer.prototype.addPendingElement;
	function IImageElement(data,parentContainer,globalData,comp,placeholder){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp,placeholder);
	}
	createElement(SVGBaseElement, IImageElement);
	
	IImageElement.prototype.createElements = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	
	    this._parent.createElements.call(this);
	
	    this.innerElem = createNS('image');
	    this.innerElem.setAttribute('width',this.assetData.w+"px");
	    this.innerElem.setAttribute('height',this.assetData.h+"px");
	    this.innerElem.setAttribute('preserveAspectRatio','xMidYMid slice');
	    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	    this.maskedElement = this.innerElem;
	    this.layerElement.appendChild(this.innerElem);
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	
	};
	
	IImageElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.show();
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	IImageElement.prototype.destroy = function(){
	    this._parent.destroy.call(this._parent);
	    this.innerElem =  null;
	};
	function ISolidElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(SVGBaseElement, ISolidElement);
	
	ISolidElement.prototype.createElements = function(){
	    this._parent.createElements.call(this);
	
	    var rect = createNS('rect');
	    ////rect.style.width = this.data.sw;
	    ////rect.style.height = this.data.sh;
	    ////rect.style.fill = this.data.sc;
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    this.layerElement.appendChild(rect);
	    this.innerElem = rect;
	    if(this.data.ln){
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    if(this.data.cl){
	        this.layerElement.setAttribute('class',this.data.cl);
	    }
	};
	
	ISolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
	ISolidElement.prototype.destroy = IImageElement.prototype.destroy;
	
	var animationManager = (function(){
	    var moduleOb = {};
	    var registeredAnimations = [];
	    var initTime = 0;
	    var len = 0;
	    var idled = true;
	    var playingAnimationsNum = 0;
	
	    function removeElement(ev){
	        var i = 0;
	        var animItem = ev.target;
	        while(i<len) {
	            if (registeredAnimations[i].animation === animItem) {
	                registeredAnimations.splice(i, 1);
	                i -= 1;
	                len -= 1;
	                if(!animItem.isPaused){
	                    subtractPlayingCount();
	                }
	            }
	            i += 1;
	        }
	    }
	
	    function registerAnimation(element, animationData){
	        if(!element){
	            return null;
	        }
	        var i=0;
	        while(i<len){
	            if(registeredAnimations[i].elem == element && registeredAnimations[i].elem !== null ){
	                return registeredAnimations[i].animation;
	            }
	            i+=1;
	        }
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, element);
	        animItem.setData(element, animationData);
	        return animItem;
	    }
	
	    function addPlayingCount(){
	        playingAnimationsNum += 1;
	        activate();
	    }
	
	    function subtractPlayingCount(){
	        playingAnimationsNum -= 1;
	        if(playingAnimationsNum === 0){
	            idled = true;
	        }
	    }
	
	    function setupAnimation(animItem, element){
	        animItem.addEventListener('destroy',removeElement);
	        animItem.addEventListener('_active',addPlayingCount);
	        animItem.addEventListener('_idle',subtractPlayingCount);
	        registeredAnimations.push({elem: element,animation:animItem});
	        len += 1;
	    }
	
	    function loadAnimation(params){
	        var animItem = new AnimationItem();
	        setupAnimation(animItem, null);
	        animItem.setParams(params);
	        return animItem;
	    }
	
	
	    function setSpeed(val,animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setSpeed(val, animation);
	        }
	    }
	
	    function setDirection(val, animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.setDirection(val, animation);
	        }
	    }
	
	    function play(animation){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.play(animation);
	        }
	    }
	
	    function moveFrame (value, animation) {
	        initTime = Date.now();
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.moveFrame(value,animation);
	        }
	    }
	
	    function resume(nowTime) {
	
	        var elapsedTime = nowTime - initTime;
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.advanceTime(elapsedTime);
	        }
	        initTime = nowTime;
	        if(!idled) {
	            window.requestAnimationFrame(resume);
	        }
	    }
	
	    function first(nowTime){
	        initTime = nowTime;
	        window.requestAnimationFrame(resume);
	    }
	
	    function pause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.pause(animation);
	        }
	    }
	
	    function goToAndStop(value,isFrame,animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.goToAndStop(value,isFrame,animation);
	        }
	    }
	
	    function stop(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.stop(animation);
	        }
	    }
	
	    function togglePause(animation) {
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.togglePause(animation);
	        }
	    }
	
	    function destroy(animation) {
	        var i;
	        for(i=(len-1);i>=0;i-=1){
	            registeredAnimations[i].animation.destroy(animation);
	        }
	    }
	
	    function searchAnimations(animationData, standalone, renderer){
	        var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')),
	                  [].slice.call(document.getElementsByClassName('bodymovin')));
	        var i, len = animElements.length;
	        for(i=0;i<len;i+=1){
	            if(renderer){
	                animElements[i].setAttribute('data-bm-type',renderer);
	            }
	            registerAnimation(animElements[i], animationData);
	        }
	        if(standalone && len === 0){
	            if(!renderer){
	                renderer = 'svg';
	            }
	            var body = document.getElementsByTagName('body')[0];
	            body.innerHTML = '';
	            var div = document.createElement('div');
	            div.style.width = '100%';
	            div.style.height = '100%';
	            div.setAttribute('data-bm-type',renderer);
	            body.appendChild(div);
	            registerAnimation(div, animationData);
	        }
	    }
	
	    function resize(){
	        var i;
	        for(i=0;i<len;i+=1){
	            registeredAnimations[i].animation.resize();
	        }
	    }
	
	    function start(){
	        window.requestAnimationFrame(first);
	    }
	
	    function activate(){
	        if(idled){
	            idled = false;
	            window.requestAnimationFrame(first);
	        }
	    }
	
	    //start();
	
	    setTimeout(start,0);
	
	    moduleOb.registerAnimation = registerAnimation;
	    moduleOb.loadAnimation = loadAnimation;
	    moduleOb.setSpeed = setSpeed;
	    moduleOb.setDirection = setDirection;
	    moduleOb.play = play;
	    moduleOb.moveFrame = moveFrame;
	    moduleOb.pause = pause;
	    moduleOb.stop = stop;
	    moduleOb.togglePause = togglePause;
	    moduleOb.searchAnimations = searchAnimations;
	    moduleOb.resize = resize;
	    moduleOb.start = start;
	    moduleOb.goToAndStop = goToAndStop;
	    moduleOb.destroy = destroy;
	    return moduleOb;
	}());
	
	var AnimationItem = function () {
	    this._cbs = [];
	    this.name = '';
	    this.path = '';
	    this.isLoaded = false;
	    this.currentFrame = 0;
	    this.currentRawFrame = 0;
	    this.totalFrames = 0;
	    this.frameRate = 0;
	    this.frameMult = 0;
	    this.playSpeed = 1;
	    this.playDirection = 1;
	    this.pendingElements = 0;
	    this.playCount = 0;
	    this.prerenderFramesFlag = true;
	    this.animationData = {};
	    this.layers = [];
	    this.assets = [];
	    this.isPaused = true;
	    this.autoplay = false;
	    this.loop = true;
	    this.renderer = null;
	    this.animationID = randomString(10);
	    this.scaleMode = 'fit';
	    this.assetsPath = '';
	    this.timeCompleted = 0;
	    this.segmentPos = 0;
	    this.subframeEnabled = subframeEnabled;
	    this.segments = [];
	    this.pendingSegment = false;
	    this._idle = true;
	    this.projectInterface = ProjectInterface();
	};
	
	AnimationItem.prototype.setParams = function(params) {
	    var self = this;
	    if(params.context){
	        this.context = params.context;
	    }
	    if(params.wrapper || params.container){
	        this.wrapper = params.wrapper || params.container;
	    }
	    var animType = params.animType ? params.animType : params.renderer ? params.renderer : 'svg';
	    switch(animType){
	        case 'canvas':
	            this.renderer = new CanvasRenderer(this, params.rendererSettings);
	            break;
	        case 'svg':
	            this.renderer = new SVGRenderer(this, params.rendererSettings);
	            break;
	        case 'hybrid':
	        case 'html':
	        default:
	            this.renderer = new HybridRenderer(this, params.rendererSettings);
	            break;
	    }
	    this.renderer.setProjectInterface(this.projectInterface);
	    this.animType = animType;
	
	    if(params.loop === '' || params.loop === null){
	    }else if(params.loop === false){
	        this.loop = false;
	    }else if(params.loop === true){
	        this.loop = true;
	    }else{
	        this.loop = parseInt(params.loop);
	    }
	    this.autoplay = 'autoplay' in params ? params.autoplay : true;
	    this.name = params.name ? params.name :  '';
	    this.prerenderFramesFlag = 'prerender' in params ? params.prerender : true;
	    this.autoloadSegments = params.hasOwnProperty('autoloadSegments') ? params.autoloadSegments :  true;
	    if(params.animationData){
	        self.configAnimation(params.animationData);
	    }else if(params.path){
	        if(params.path.substr(-4) != 'json'){
	            if (params.path.substr(-1, 1) != '/') {
	                params.path += '/';
	            }
	            params.path += 'data.json';
	        }
	
	        var xhr = new XMLHttpRequest();
	        if(params.path.lastIndexOf('\\') != -1){
	            this.path = params.path.substr(0,params.path.lastIndexOf('\\')+1);
	        }else{
	            this.path = params.path.substr(0,params.path.lastIndexOf('/')+1);
	        }
	        this.assetsPath = params.assetsPath;
	        this.fileName = params.path.substr(params.path.lastIndexOf('/')+1);
	        this.fileName = this.fileName.substr(0,this.fileName.lastIndexOf('.json'));
	        xhr.open('GET', params.path, true);
	        xhr.send();
	        xhr.onreadystatechange = function () {
	            if (xhr.readyState == 4) {
	                if(xhr.status == 200){
	                    self.configAnimation(JSON.parse(xhr.responseText));
	                }else{
	                    try{
	                        var response = JSON.parse(xhr.responseText);
	                        self.configAnimation(response);
	                    }catch(err){
	                    }
	                }
	            }
	        };
	    }
	};
	
	AnimationItem.prototype.setData = function (wrapper, animationData) {
	    var params = {
	        wrapper: wrapper,
	        animationData: animationData ? (typeof animationData  === "object") ? animationData : JSON.parse(animationData) : null
	    };
	    var wrapperAttributes = wrapper.attributes;
	
	    params.path = wrapperAttributes.getNamedItem('data-animation-path') ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') ? wrapperAttributes.getNamedItem('data-bm-path').value :  wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
	    params.animType = wrapperAttributes.getNamedItem('data-anim-type') ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') ? wrapperAttributes.getNamedItem('bm-type').value :  wrapperAttributes.getNamedItem('data-bm-renderer') ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : 'canvas';
	
	    var loop = wrapperAttributes.getNamedItem('data-anim-loop') ? wrapperAttributes.getNamedItem('data-anim-loop').value :  wrapperAttributes.getNamedItem('data-bm-loop') ? wrapperAttributes.getNamedItem('data-bm-loop').value :  wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';
	    if(loop === ''){
	    }else if(loop === 'false'){
	        params.loop = false;
	    }else if(loop === 'true'){
	        params.loop = true;
	    }else{
	        params.loop = parseInt(loop);
	    }
	    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') ? wrapperAttributes.getNamedItem('data-anim-autoplay').value :  wrapperAttributes.getNamedItem('data-bm-autoplay') ? wrapperAttributes.getNamedItem('data-bm-autoplay').value :  wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
	    params.autoplay = autoplay !== "false";
	
	    params.name = wrapperAttributes.getNamedItem('data-name') ? wrapperAttributes.getNamedItem('data-name').value :  wrapperAttributes.getNamedItem('data-bm-name') ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value :  '';
	    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') ? wrapperAttributes.getNamedItem('data-anim-prerender').value :  wrapperAttributes.getNamedItem('data-bm-prerender') ? wrapperAttributes.getNamedItem('data-bm-prerender').value :  wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';
	
	    if(prerender === 'false'){
	        params.prerender = false;
	    }
	    this.setParams(params);
	};
	
	AnimationItem.prototype.includeLayers = function(data) {
	    if(data.op > this.animationData.op){
	        this.animationData.op = data.op;
	        this.totalFrames = Math.floor(data.op - this.animationData.ip);
	        this.animationData.tf = this.totalFrames;
	    }
	    var layers = this.animationData.layers;
	    var i, len = layers.length;
	    var newLayers = data.layers;
	    var j, jLen = newLayers.length;
	    for(j=0;j<jLen;j+=1){
	        i = 0;
	        while(i<len){
	            if(layers[i].id == newLayers[j].id){
	                layers[i] = newLayers[j];
	                break;
	            }
	            i += 1;
	        }
	    }
	    if(data.chars || data.fonts){
	        this.renderer.globalData.fontManager.addChars(data.chars);
	        this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
	    }
	    if(data.assets){
	        len = data.assets.length;
	        for(i = 0; i < len; i += 1){
	            this.animationData.assets.push(data.assets[i]);
	        }
	    }
	    //this.totalFrames = 50;
	    //this.animationData.tf = 50;
	    this.animationData.__complete = false;
	    dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	    this.renderer.includeLayers(data.layers);
	    if(expressionsPlugin){
	        expressionsPlugin.initExpressions(this);
	    }
	    this.renderer.renderFrame(null);
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.loadNextSegment = function() {
	    var segments = this.animationData.segments;
	    if(!segments || segments.length === 0 || !this.autoloadSegments){
	        this.trigger('data_ready');
	        this.timeCompleted = this.animationData.tf;
	        return;
	    }
	    var segment = segments.shift();
	    this.timeCompleted = segment.time * this.frameRate;
	    var xhr = new XMLHttpRequest();
	    var self = this;
	    var segmentPath = this.path+this.fileName+'_' + this.segmentPos + '.json';
	    this.segmentPos += 1;
	    xhr.open('GET', segmentPath, true);
	    xhr.send();
	    xhr.onreadystatechange = function () {
	        if (xhr.readyState == 4) {
	            if(xhr.status == 200){
	                self.includeLayers(JSON.parse(xhr.responseText));
	            }else{
	                try{
	                    var response = JSON.parse(xhr.responseText);
	                    self.includeLayers(response);
	                }catch(err){
	                }
	            }
	        }
	    };
	};
	
	AnimationItem.prototype.loadSegments = function() {
	    var segments = this.animationData.segments;
	    if(!segments) {
	        this.timeCompleted = this.animationData.tf;
	    }
	    this.loadNextSegment();
	};
	
	AnimationItem.prototype.configAnimation = function (animData) {
	    var _this = this;
	    if(this.renderer && this.renderer.destroyed){
	        return;
	    }
	    //console.log(JSON.parse(JSON.stringify(animData)));
	    //animData.w = Math.round(animData.w/blitter);
	    //animData.h = Math.round(animData.h/blitter);
	    this.animationData = animData;
	    this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
	    this.animationData.tf = this.totalFrames;
	    this.renderer.configAnimation(animData);
	    if(!animData.assets){
	        animData.assets = [];
	    }
	    if(animData.comps) {
	        animData.assets = animData.assets.concat(animData.comps);
	        animData.comps = null;
	    }
	    this.renderer.searchExtraCompositions(animData.assets);
	
	    this.layers = this.animationData.layers;
	    this.assets = this.animationData.assets;
	    this.frameRate = this.animationData.fr;
	    this.firstFrame = Math.round(this.animationData.ip);
	    this.frameMult = this.animationData.fr / 1000;
	    this.trigger('config_ready');
	    this.imagePreloader = new ImagePreloader();
	    this.imagePreloader.setAssetsPath(this.assetsPath);
	    this.imagePreloader.setPath(this.path);
	    this.imagePreloader.loadAssets(animData.assets, function(err) {
	        if(!err) {
	            _this.trigger('loaded_images');
	        }
	    });
	    this.loadSegments();
	    this.updaFrameModifier();
	    if(this.renderer.globalData.fontManager){
	        this.waitForFontsLoaded();
	    }else{
	        dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	        this.checkLoaded();
	    }
	};
	
	AnimationItem.prototype.waitForFontsLoaded = (function(){
	    function checkFontsLoaded(){
	        if(this.renderer.globalData.fontManager.loaded){
	            dataManager.completeData(this.animationData,this.renderer.globalData.fontManager);
	            //this.renderer.buildItems(this.animationData.layers);
	            this.checkLoaded();
	        }else{
	            setTimeout(checkFontsLoaded.bind(this),20);
	        }
	    }
	
	    return function(){
	        checkFontsLoaded.bind(this)();
	    }
	}());
	
	AnimationItem.prototype.addPendingElement = function () {
	    this.pendingElements += 1;
	}
	
	AnimationItem.prototype.elementLoaded = function () {
	    this.pendingElements--;
	    this.checkLoaded();
	};
	
	AnimationItem.prototype.checkLoaded = function () {
	    if (this.pendingElements === 0) {
	        if(expressionsPlugin){
	            expressionsPlugin.initExpressions(this);
	        }
	        this.renderer.initItems();
	        setTimeout(function(){
	            this.trigger('DOMLoaded');
	        }.bind(this),0);
	        this.isLoaded = true;
	        this.gotoFrame();
	        if(this.autoplay){
	            this.play();
	        }
	    }
	};
	
	AnimationItem.prototype.resize = function () {
	    this.renderer.updateContainerSize();
	};
	
	AnimationItem.prototype.setSubframe = function(flag){
	    this.subframeEnabled = flag ? true : false;
	}
	
	AnimationItem.prototype.gotoFrame = function () {
	    if(this.subframeEnabled){
	        this.currentFrame = this.currentRawFrame;
	    }else{
	        this.currentFrame = Math.floor(this.currentRawFrame);
	    }
	
	    if(this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted){
	        this.currentFrame = this.timeCompleted;
	    }
	    this.trigger('enterFrame');
	    this.renderFrame();
	};
	
	AnimationItem.prototype.renderFrame = function () {
	    if(this.isLoaded === false){
	        return;
	    }
	    //console.log('this.currentFrame:',this.currentFrame + this.firstFrame);
	    this.renderer.renderFrame(this.currentFrame + this.firstFrame);
	};
	
	AnimationItem.prototype.play = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.isPaused = false;
	        if(this._idle){
	            this._idle = false;
	            this.trigger('_active');
	        }
	    }
	};
	
	AnimationItem.prototype.pause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === false){
	        this.isPaused = true;
	        if(!this.pendingSegment){
	            this._idle = true;
	            this.trigger('_idle');
	        }
	    }
	};
	
	AnimationItem.prototype.togglePause = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(this.isPaused === true){
	        this.play();
	    }else{
	        this.pause();
	    }
	};
	
	AnimationItem.prototype.stop = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.pause();
	    this.currentFrame = this.currentRawFrame = 0;
	    this.playCount = 0;
	    this.gotoFrame();
	};
	
	AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
	    if(name && this.name != name){
	        return;
	    }
	    if(isFrame){
	        this.setCurrentRawFrameValue(value);
	    }else{
	        this.setCurrentRawFrameValue(value * this.frameModifier);
	    }
	    this.pause();
	};
	
	AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
	    this.goToAndStop(value, isFrame, name);
	    this.play();
	};
	
	AnimationItem.prototype.advanceTime = function (value) {
	    if(this.pendingSegment){
	        this.pendingSegment = false;
	        this.adjustSegment(this.segments.shift());
	        if(this.isPaused){
	            this.play();
	        }
	        return;
	    }
	    if (this.isPaused === true || this.isLoaded === false) {
	        return;
	    }
	    this.setCurrentRawFrameValue(this.currentRawFrame + value * this.frameModifier);
	};
	
	AnimationItem.prototype.updateAnimation = function (perc) {
	    this.setCurrentRawFrameValue(this.totalFrames * perc);
	};
	
	AnimationItem.prototype.moveFrame = function (value, name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.setCurrentRawFrameValue(this.currentRawFrame+value);
	};
	
	AnimationItem.prototype.adjustSegment = function(arr){
	    this.playCount = 0;
	    if(arr[1] < arr[0]){
	        if(this.frameModifier > 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(-1);
	            }
	        }
	        this.totalFrames = arr[0] - arr[1];
	        this.firstFrame = arr[1];
	        this.setCurrentRawFrameValue(this.totalFrames - 0.01);
	    } else if(arr[1] > arr[0]){
	        if(this.frameModifier < 0){
	            if(this.playSpeed < 0){
	                this.setSpeed(-this.playSpeed);
	            } else {
	                this.setDirection(1);
	            }
	        }
	        this.totalFrames = arr[1] - arr[0];
	        this.firstFrame = arr[0];
	        this.setCurrentRawFrameValue(0);
	    }
	    this.trigger('segmentStart');
	};
	AnimationItem.prototype.setSegment = function (init,end) {
	    var pendingFrame = -1;
	    if(this.isPaused) {
	        if (this.currentRawFrame + this.firstFrame < init) {
	            pendingFrame = init;
	        } else if (this.currentRawFrame + this.firstFrame > end) {
	            pendingFrame = end - init - 0.01;
	        }
	    }
	
	    this.firstFrame = init;
	    this.totalFrames = end - init;
	    if(pendingFrame !== -1) {
	        this.goToAndStop(pendingFrame,true);
	    }
	}
	
	AnimationItem.prototype.playSegments = function (arr,forceFlag) {
	    if(typeof arr[0] === 'object'){
	        var i, len = arr.length;
	        for(i=0;i<len;i+=1){
	            this.segments.push(arr[i]);
	        }
	    }else{
	        this.segments.push(arr);
	    }
	    if(forceFlag){
	        this.adjustSegment(this.segments.shift());
	    }
	    if(this.isPaused){
	        this.play();
	    }
	};
	
	AnimationItem.prototype.resetSegments = function (forceFlag) {
	    this.segments.length = 0;
	    this.segments.push([this.animationData.ip*this.frameRate,Math.floor(this.animationData.op - this.animationData.ip+this.animationData.ip*this.frameRate)]);
	    if(forceFlag){
	        this.adjustSegment(this.segments.shift());
	    }
	};
	AnimationItem.prototype.checkSegments = function(){
	    if(this.segments.length){
	        this.pendingSegment = true;
	    }
	}
	
	AnimationItem.prototype.remove = function (name) {
	    if(name && this.name != name){
	        return;
	    }
	    this.renderer.destroy();
	};
	
	AnimationItem.prototype.destroy = function (name) {
	    if((name && this.name != name) || (this.renderer && this.renderer.destroyed)){
	        return;
	    }
	    this.renderer.destroy();
	    this.trigger('destroy');
	    this._cbs = null;
	    this.onEnterFrame = this.onLoopComplete = this.onComplete = this.onSegmentStart = this.onDestroy = null;
	    this.renderer = null;
	};
	
	AnimationItem.prototype.setCurrentRawFrameValue = function(value){
	    this.currentRawFrame = value;
	    //console.log(this.totalFrames);
	    if (this.currentRawFrame >= this.totalFrames) {
	        this.checkSegments();
	        if(this.loop === false){
	            this.currentRawFrame = this.totalFrames - 0.01;
	            this.gotoFrame();
	            this.pause();
	            this.trigger('complete');
	            return;
	        }else{
	            this.trigger('loopComplete');
	            this.playCount += 1;
	            if((this.loop !== true && this.playCount == this.loop) || this.pendingSegment){
	                this.currentRawFrame = this.totalFrames - 0.01;
	                this.gotoFrame();
	                this.pause();
	                this.trigger('complete');
	                return;
	            } else {
	                this.currentRawFrame = this.currentRawFrame % this.totalFrames;
	            }
	        }
	    } else if (this.currentRawFrame < 0) {
	        this.checkSegments();
	        this.playCount -= 1;
	        if(this.playCount < 0){
	            this.playCount = 0;
	        }
	        if(this.loop === false  || this.pendingSegment){
	            this.currentRawFrame = 0;
	            this.gotoFrame();
	            this.pause();
	            this.trigger('complete');
	            return;
	        }else{
	            this.trigger('loopComplete');
	            this.currentRawFrame = (this.totalFrames + this.currentRawFrame) % this.totalFrames;
	            this.gotoFrame();
	            return;
	        }
	    }
	
	    this.gotoFrame();
	};
	
	AnimationItem.prototype.setSpeed = function (val) {
	    this.playSpeed = val;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.setDirection = function (val) {
	    this.playDirection = val < 0 ? -1 : 1;
	    this.updaFrameModifier();
	};
	
	AnimationItem.prototype.updaFrameModifier = function () {
	    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
	};
	
	AnimationItem.prototype.getPath = function () {
	    return this.path;
	};
	
	AnimationItem.prototype.getAssetsPath = function (assetData) {
	    var path = '';
	    if(this.assetsPath){
	        var imagePath = assetData.p;
	        if(imagePath.indexOf('images/') !== -1){
	            imagePath = imagePath.split('/')[1];
	        }
	        path = this.assetsPath + imagePath;
	    } else {
	        path = this.path;
	        path += assetData.u ? assetData.u : '';
	        path += assetData.p;
	    }
	    return path;
	};
	
	AnimationItem.prototype.getAssetData = function (id) {
	    var i = 0, len = this.assets.length;
	    while (i < len) {
	        if(id == this.assets[i].id){
	            return this.assets[i];
	        }
	        i += 1;
	    }
	};
	
	AnimationItem.prototype.hide = function () {
	    this.renderer.hide();
	};
	
	AnimationItem.prototype.show = function () {
	    this.renderer.show();
	};
	
	AnimationItem.prototype.getAssets = function () {
	    return this.assets;
	};
	
	AnimationItem.prototype.trigger = function(name){
	    if(this._cbs && this._cbs[name]){
	        switch(name){
	            case 'enterFrame':
	                this.triggerEvent(name,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	                break;
	            case 'loopComplete':
	                this.triggerEvent(name,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	                break;
	            case 'complete':
	                this.triggerEvent(name,new BMCompleteEvent(name,this.frameMult));
	                break;
	            case 'segmentStart':
	                this.triggerEvent(name,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	                break;
	            case 'destroy':
	                this.triggerEvent(name,new BMDestroyEvent(name,this));
	                break;
	            default:
	                this.triggerEvent(name);
	        }
	    }
	    if(name === 'enterFrame' && this.onEnterFrame){
	        this.onEnterFrame.call(this,new BMEnterFrameEvent(name,this.currentFrame,this.totalFrames,this.frameMult));
	    }
	    if(name === 'loopComplete' && this.onLoopComplete){
	        this.onLoopComplete.call(this,new BMCompleteLoopEvent(name,this.loop,this.playCount,this.frameMult));
	    }
	    if(name === 'complete' && this.onComplete){
	        this.onComplete.call(this,new BMCompleteEvent(name,this.frameMult));
	    }
	    if(name === 'segmentStart' && this.onSegmentStart){
	        this.onSegmentStart.call(this,new BMSegmentStartEvent(name,this.firstFrame,this.totalFrames));
	    }
	    if(name === 'destroy' && this.onDestroy){
	        this.onDestroy.call(this,new BMDestroyEvent(name,this));
	    }
	};
	
	AnimationItem.prototype.addEventListener = _addEventListener;
	AnimationItem.prototype.removeEventListener = _removeEventListener;
	AnimationItem.prototype.triggerEvent = _triggerEvent;
	
	function CanvasRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.renderConfig = {
	        clearCanvas: (config && config.clearCanvas !== undefined) ? config.clearCanvas : true,
	        context: (config && config.context) || null,
	        progressiveLoad: (config && config.progressiveLoad) || false,
	        preserveAspectRatio: (config && config.preserveAspectRatio) || 'xMidYMid meet',
	        className: (config && config.className) || ''
	    };
	    this.renderConfig.dpr = (config && config.dpr) || 1;
	    if (this.animationItem.wrapper) {
	        this.renderConfig.dpr = (config && config.dpr) || window.devicePixelRatio || 1;
	    }
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.contextData = {
	        saved : Array.apply(null,{length:15}),
	        savedOp: Array.apply(null,{length:15}),
	        cArrPos : 0,
	        cTr : new Matrix(),
	        cO : 1
	    };
	    var i, len = 15;
	    for(i=0;i<len;i+=1){
	        this.contextData.saved[i] = Array.apply(null,{length:16});
	    }
	    this.elements = [];
	    this.pendingElements = [];
	    this.transformMat = new Matrix();
	    this.completeLayers = false;
	}
	extendPrototype(BaseRenderer,CanvasRenderer);
	
	CanvasRenderer.prototype.createBase = function (data) {
	    return new CVBaseElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createShape = function (data) {
	    return new CVShapeElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createText = function (data) {
	    return new CVTextElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createImage = function (data) {
	    return new CVImageElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createComp = function (data) {
	    return new CVCompElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.createSolid = function (data) {
	    return new CVSolidElement(data, this, this.globalData);
	};
	
	CanvasRenderer.prototype.ctxTransform = function(props){
	    if(props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.transform(props[0],props[1],props[4],props[5],props[12],props[13]);
	        return;
	    }
	    this.transformMat.cloneFromProps(props);
	    this.transformMat.transform(this.contextData.cTr.props[0],this.contextData.cTr.props[1],this.contextData.cTr.props[2],this.contextData.cTr.props[3],this.contextData.cTr.props[4],this.contextData.cTr.props[5],this.contextData.cTr.props[6],this.contextData.cTr.props[7],this.contextData.cTr.props[8],this.contextData.cTr.props[9],this.contextData.cTr.props[10],this.contextData.cTr.props[11],this.contextData.cTr.props[12],this.contextData.cTr.props[13],this.contextData.cTr.props[14],this.contextData.cTr.props[15])
	    //this.contextData.cTr.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	    this.contextData.cTr.cloneFromProps(this.transformMat.props);
	    var trProps = this.contextData.cTr.props;
	    this.canvasContext.setTransform(trProps[0],trProps[1],trProps[4],trProps[5],trProps[12],trProps[13]);
	};
	
	CanvasRenderer.prototype.ctxOpacity = function(op){
	    if(op === 1){
	        return;
	    }
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
	        return;
	    }
	    this.contextData.cO *= op < 0 ? 0 : op;
	    this.canvasContext.globalAlpha = this.contextData.cO;
	};
	
	CanvasRenderer.prototype.reset = function(){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    this.contextData.cArrPos = 0;
	    this.contextData.cTr.reset();
	    this.contextData.cO = 1;
	};
	
	CanvasRenderer.prototype.save = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.save();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.save();
	    }
	    var props = this.contextData.cTr.props;
	    if(this.contextData.saved[this.contextData.cArrPos] === null || this.contextData.saved[this.contextData.cArrPos] === undefined){
	        this.contextData.saved[this.contextData.cArrPos] = new Array(16);
	    }
	    var i,arr = this.contextData.saved[this.contextData.cArrPos];
	    for(i=0;i<16;i+=1){
	        arr[i] = props[i];
	    }
	    this.contextData.savedOp[this.contextData.cArrPos] = this.contextData.cO;
	    this.contextData.cArrPos += 1;
	};
	
	CanvasRenderer.prototype.restore = function(actionFlag){
	    if(!this.renderConfig.clearCanvas){
	        this.canvasContext.restore();
	        return;
	    }
	    if(actionFlag){
	        this.canvasContext.restore();
	    }
	    this.contextData.cArrPos -= 1;
	    var popped = this.contextData.saved[this.contextData.cArrPos];
	    var i,arr = this.contextData.cTr.props;
	    for(i=0;i<16;i+=1){
	        arr[i] = popped[i];
	    }
	    this.canvasContext.setTransform(popped[0],popped[1],popped[4],popped[5],popped[12],popped[13]);
	    popped = this.contextData.savedOp[this.contextData.cArrPos];
	    this.contextData.cO = popped;
	    this.canvasContext.globalAlpha = popped;
	};
	
	CanvasRenderer.prototype.configAnimation = function(animData){
	    if(this.animationItem.wrapper){
	        this.animationItem.container = document.createElement('canvas');
	        this.animationItem.container.style.width = '100%';
	        this.animationItem.container.style.height = '100%';
	        //this.animationItem.container.style.transform = 'translate3d(0,0,0)';
	        //this.animationItem.container.style.webkitTransform = 'translate3d(0,0,0)';
	        this.animationItem.container.style.transformOrigin = this.animationItem.container.style.mozTransformOrigin = this.animationItem.container.style.webkitTransformOrigin = this.animationItem.container.style['-webkit-transform'] = "0px 0px 0px";
	        this.animationItem.wrapper.appendChild(this.animationItem.container);
	        this.canvasContext = this.animationItem.container.getContext('2d');
	        if(this.renderConfig.className) {
	            this.animationItem.container.setAttribute('class', this.renderConfig.className);
	        }
	    }else{
	        this.canvasContext = this.renderConfig.context;
	    }
	    this.data = animData;
	    this.globalData.canvasContext = this.canvasContext;
	    this.globalData.renderer = this;
	    this.globalData.isDashed = false;
	    this.globalData.totalFrames = Math.floor(animData.tf);
	    this.globalData.compWidth = animData.w;
	    this.globalData.compHeight = animData.h;
	    this.globalData.frameRate = animData.fr;
	    this.globalData.frameId = 0;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
	    this.layers = animData.layers;
	    this.transformCanvas = {};
	    this.transformCanvas.w = animData.w;
	    this.transformCanvas.h = animData.h;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,document.body);
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
	    this.globalData.addPendingElement = this.animationItem.addPendingElement.bind(this.animationItem);
	    this.globalData.transformCanvas = this.transformCanvas;
	    this.elements = Array.apply(null,{length:animData.layers.length});
	
	    this.updateContainerSize();
	};
	
	CanvasRenderer.prototype.updateContainerSize = function () {
	    var elementWidth,elementHeight;
	    if(this.animationItem.wrapper && this.animationItem.container){
	        elementWidth = this.animationItem.wrapper.offsetWidth;
	        elementHeight = this.animationItem.wrapper.offsetHeight;
	        this.animationItem.container.setAttribute('width',elementWidth * this.renderConfig.dpr );
	        this.animationItem.container.setAttribute('height',elementHeight * this.renderConfig.dpr);
	    }else{
	        elementWidth = this.canvasContext.canvas.width * this.renderConfig.dpr;
	        elementHeight = this.canvasContext.canvas.height * this.renderConfig.dpr;
	    }
	    var elementRel,animationRel;
	    if(this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1){
	        var par = this.renderConfig.preserveAspectRatio.split(' ');
	        var fillType = par[1] || 'meet';
	        var pos = par[0] || 'xMidYMid';
	        var xPos = pos.substr(0,4);
	        var yPos = pos.substr(4);
	        elementRel = elementWidth/elementHeight;
	        animationRel = this.transformCanvas.w/this.transformCanvas.h;
	        if(animationRel>elementRel && fillType === 'meet' || animationRel<elementRel && fillType === 'slice'){
	            this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	            this.transformCanvas.sy = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        }else{
	            this.transformCanvas.sx = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	            this.transformCanvas.sy = elementHeight/(this.transformCanvas.h / this.renderConfig.dpr);
	        }
	
	        if(xPos === 'xMid' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))/2*this.renderConfig.dpr;
	        } else if(xPos === 'xMax' && ((animationRel<elementRel && fillType==='meet') || (animationRel>elementRel && fillType === 'slice'))){
	            this.transformCanvas.tx = (elementWidth-this.transformCanvas.w*(elementHeight/this.transformCanvas.h))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.tx = 0;
	        }
	        if(yPos === 'YMid' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w))/2)*this.renderConfig.dpr;
	        } else if(yPos === 'YMax' && ((animationRel>elementRel && fillType==='meet') || (animationRel<elementRel && fillType === 'slice'))){
	            this.transformCanvas.ty = ((elementHeight-this.transformCanvas.h*(elementWidth/this.transformCanvas.w)))*this.renderConfig.dpr;
	        } else {
	            this.transformCanvas.ty = 0;
	        }
	
	    }else if(this.renderConfig.preserveAspectRatio == 'none'){
	        this.transformCanvas.sx = elementWidth/(this.transformCanvas.w/this.renderConfig.dpr);
	        this.transformCanvas.sy = elementHeight/(this.transformCanvas.h/this.renderConfig.dpr);
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }else{
	        this.transformCanvas.sx = this.renderConfig.dpr;
	        this.transformCanvas.sy = this.renderConfig.dpr;
	        this.transformCanvas.tx = 0;
	        this.transformCanvas.ty = 0;
	    }
	    this.transformCanvas.props = [this.transformCanvas.sx,0,0,0,0,this.transformCanvas.sy,0,0,0,0,1,0,this.transformCanvas.tx,this.transformCanvas.ty,0,1];
	    var i, len = this.elements.length;
	    for(i=0;i<len;i+=1){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(this.globalData.transformCanvas);
	        }
	    }
	};
	
	CanvasRenderer.prototype.destroy = function () {
	    if(this.renderConfig.clearCanvas) {
	        this.animationItem.wrapper.innerHTML = '';
	    }
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.elements[i]) {
	            this.elements[i].destroy();
	        }
	    }
	    this.elements.length = 0;
	    this.globalData.canvasContext = null;
	    this.animationItem.container = null;
	    this.destroyed = true;
	};
	
	CanvasRenderer.prototype.renderFrame = function(num){
	    if((this.renderedFrame == num && this.renderConfig.clearCanvas === true) || this.destroyed || num === null){
	        return;
	    }
	    this.renderedFrame = num;
	    this.globalData.frameNum = num - this.animationItem.firstFrame;
	    this.globalData.frameId += 1;
	    this.globalData.projectInterface.currentFrame = num;
	    if(this.renderConfig.clearCanvas === true){
	        this.reset();
	        this.canvasContext.save();
	        //this.canvasContext.canvas.width = this.canvasContext.canvas.width;
	        this.canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w*this.transformCanvas.sx, this.transformCanvas.h*this.transformCanvas.sy);
	    }else{
	        this.save();
	    }
	    this.ctxTransform(this.transformCanvas.props);
	    this.canvasContext.beginPath();
	    this.canvasContext.rect(0,0,this.transformCanvas.w,this.transformCanvas.h);
	    this.canvasContext.closePath();
	    this.canvasContext.clip();
	
	    //console.log('--------');
	    //console.log('NEW: ',num);
	    var i, len = this.layers.length;
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for (i = 0; i < len; i++) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(num - this.layers[i].st);
	        }
	    }
	    for (i = len - 1; i >= 0; i-=1) {
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.renderConfig.clearCanvas !== true){
	        this.restore();
	    } else {
	        this.canvasContext.restore();
	    }
	};
	
	CanvasRenderer.prototype.buildItem = function(pos){
	    var elements = this.elements;
	    if(elements[pos] || this.layers[pos].ty == 99){
	        return;
	    }
	    var element = this.createItem(this.layers[pos], this,this.globalData);
	    elements[pos] = element;
	    element.initExpressions();
	    if(this.layers[pos].ty === 0){
	        element.resize(this.globalData.transformCanvas);
	    }
	};
	
	CanvasRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	CanvasRenderer.prototype.hide = function(){
	    this.animationItem.container.style.display = 'none';
	};
	
	CanvasRenderer.prototype.show = function(){
	    this.animationItem.container.style.display = 'block';
	};
	
	CanvasRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = createNS('g');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],this.globalData.comp,this.globalData);
	            comp.initExpressions();
	            //comp.compInterface = CompExpressionInterface(comp);
	            //Expressions.addLayersInterface(comp.elements, this.globalData.projectInterface);
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function HybridRenderer(animationItem, config){
	    this.animationItem = animationItem;
	    this.layers = null;
	    this.renderedFrame = -1;
	    this.globalData = {
	        frameNum: -1
	    };
	    this.renderConfig = {
	        className: (config && config.className) || ''
	    };
	    this.pendingElements = [];
	    this.elements = [];
	    this.threeDElements = [];
	    this.destroyed = false;
	    this.camera = null;
	    this.supports3d = true;
	
	}
	
	extendPrototype(BaseRenderer,HybridRenderer);
	
	HybridRenderer.prototype.buildItem = SVGRenderer.prototype.buildItem;
	
	HybridRenderer.prototype.checkPendingElements  = function(){
	    while(this.pendingElements.length){
	        var element = this.pendingElements.pop();
	        element.checkParenting();
	    }
	};
	
	HybridRenderer.prototype.appendElementInPos = function(element, pos){
	    var newDOMElement = element.getBaseElement();
	    if(!newDOMElement){
	        return;
	    }
	    var layer = this.layers[pos];
	    if(!layer.ddd || !this.supports3d){
	        var i = 0;
	        var nextDOMElement, nextLayer;
	        while(i<pos){
	            if(this.elements[i] && this.elements[i]!== true && this.elements[i].getBaseElement){
	                nextLayer = this.elements[i];
	                nextDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
	            }
	            i += 1;
	        }
	        if(nextDOMElement){
	            if(!layer.ddd || !this.supports3d){
	                this.layerElement.insertBefore(newDOMElement, nextDOMElement);
	            }
	        } else {
	            if(!layer.ddd || !this.supports3d){
	                this.layerElement.appendChild(newDOMElement);
	            }
	        }
	    } else {
	        this.addTo3dContainer(newDOMElement,pos);
	    }
	};
	
	
	HybridRenderer.prototype.createBase = function (data) {
	    return new SVGBaseElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createShape = function (data) {
	    if(!this.supports3d){
	        return new IShapeElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HShapeElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createText = function (data) {
	    if(!this.supports3d){
	        return new SVGTextElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HTextElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createCamera = function (data) {
	    this.camera = new HCameraElement(data, this.layerElement,this.globalData,this);
	    return this.camera;
	};
	
	HybridRenderer.prototype.createImage = function (data) {
	    if(!this.supports3d){
	        return new IImageElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HImageElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.createComp = function (data) {
	    if(!this.supports3d){
	        return new ICompElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HCompElement(data, this.layerElement,this.globalData,this);
	
	};
	
	HybridRenderer.prototype.createSolid = function (data) {
	    if(!this.supports3d){
	        return new ISolidElement(data, this.layerElement,this.globalData,this);
	    }
	    return new HSolidElement(data, this.layerElement,this.globalData,this);
	};
	
	HybridRenderer.prototype.getThreeDContainerByPos = function(pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len) {
	        if(this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
	            return this.threeDElements[i].perspectiveElem;
	        }
	        i += 1;
	    }
	}
	
	HybridRenderer.prototype.createThreeDContainer = function(pos){
	    var perspectiveElem = document.createElement('div');
	    styleDiv(perspectiveElem);
	    perspectiveElem.style.width = this.globalData.compSize.w+'px';
	    perspectiveElem.style.height = this.globalData.compSize.h+'px';
	    perspectiveElem.style.transformOrigin = perspectiveElem.style.mozTransformOrigin = perspectiveElem.style.webkitTransformOrigin = "50% 50%";
	    var container = document.createElement('div');
	    styleDiv(container);
	    container.style.transform = container.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    perspectiveElem.appendChild(container);
	    this.resizerElem.appendChild(perspectiveElem);
	    var threeDContainerData = {
	        container:container,
	        perspectiveElem:perspectiveElem,
	        startPos: pos,
	        endPos: pos
	    };
	    this.threeDElements.push(threeDContainerData);
	    return threeDContainerData;
	};
	
	HybridRenderer.prototype.build3dContainers = function(){
	    var i, len = this.layers.length;
	    var lastThreeDContainerData;
	    for(i=0;i<len;i+=1){
	        if(this.layers[i].ddd){
	            if(!lastThreeDContainerData){
	                lastThreeDContainerData = this.createThreeDContainer(i);
	            }
	            lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos,i);
	        } else {
	            lastThreeDContainerData = null;
	        }
	    }
	};
	
	HybridRenderer.prototype.addTo3dContainer = function(elem,pos){
	    var i = 0, len = this.threeDElements.length;
	    while(i<len){
	        if(pos <= this.threeDElements[i].endPos){
	            var j = this.threeDElements[i].startPos;
	            var nextElement;
	            while(j<pos){
	                if(this.elements[j] && this.elements[j].getBaseElement){
	                    nextElement = this.elements[j].getBaseElement();
	                }
	                j += 1;
	            }
	            if(nextElement){
	                this.threeDElements[i].container.insertBefore(elem, nextElement);
	            } else {
	                this.threeDElements[i].container.appendChild(elem);
	            }
	            break;
	        }
	        i += 1;
	    }
	};
	
	HybridRenderer.prototype.configAnimation = function(animData){
	    var resizerElem = document.createElement('div');
	    var wrapper = this.animationItem.wrapper;
	    resizerElem.style.width = animData.w+'px';
	    resizerElem.style.height = animData.h+'px';
	    this.resizerElem = resizerElem;
	    styleDiv(resizerElem);
	    resizerElem.style.transformStyle = resizerElem.style.webkitTransformStyle = resizerElem.style.mozTransformStyle = "flat";
	    if(this.renderConfig.className) {
	      wrapper.setAttribute('class', this.renderConfig.className);
	    }
	    wrapper.appendChild(resizerElem);
	
	    resizerElem.style.overflow = 'hidden';
	    var svg = createNS('svg');
	    svg.setAttribute('width','1');
	    svg.setAttribute('height','1');
	    styleDiv(svg);
	    this.resizerElem.appendChild(svg);
	    var defs = createNS('defs');
	    svg.appendChild(defs);
	    this.globalData.defs = defs;
	    this.data = animData;
	    //Mask animation
	    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
	    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
	    this.globalData.elementLoaded = this.animationItem.elementLoaded.bind(this.animationItem);
	    this.globalData.frameId = 0;
	    this.globalData.compSize = {
	        w: animData.w,
	        h: animData.h
	    };
	    this.globalData.frameRate = animData.fr;
	    this.layers = animData.layers;
	    this.globalData.fontManager = new FontManager();
	    this.globalData.fontManager.addChars(animData.chars);
	    this.globalData.fontManager.addFonts(animData.fonts,svg);
	    this.layerElement = this.resizerElem;
	    this.build3dContainers();
	    this.updateContainerSize();
	};
	
	HybridRenderer.prototype.destroy = function () {
	    this.animationItem.wrapper.innerHTML = '';
	    this.animationItem.container = null;
	    this.globalData.defs = null;
	    var i, len = this.layers ? this.layers.length : 0;
	    for (i = 0; i < len; i++) {
	        this.elements[i].destroy();
	    }
	    this.elements.length = 0;
	    this.destroyed = true;
	    this.animationItem = null;
	};
	
	HybridRenderer.prototype.updateContainerSize = function () {
	    var elementWidth = this.animationItem.wrapper.offsetWidth;
	    var elementHeight = this.animationItem.wrapper.offsetHeight;
	    var elementRel = elementWidth/elementHeight;
	    var animationRel = this.globalData.compSize.w/this.globalData.compSize.h;
	    var sx,sy,tx,ty;
	    if(animationRel>elementRel){
	        sx = elementWidth/(this.globalData.compSize.w);
	        sy = elementWidth/(this.globalData.compSize.w);
	        tx = 0;
	        ty = ((elementHeight-this.globalData.compSize.h*(elementWidth/this.globalData.compSize.w))/2);
	    }else{
	        sx = elementHeight/(this.globalData.compSize.h);
	        sy = elementHeight/(this.globalData.compSize.h);
	        tx = (elementWidth-this.globalData.compSize.w*(elementHeight/this.globalData.compSize.h))/2;
	        ty = 0;
	    }
	    this.resizerElem.style.transform = this.resizerElem.style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,'+sy+',0,0,0,0,1,0,'+tx+','+ty+',0,1)';
	};
	
	HybridRenderer.prototype.renderFrame = SVGRenderer.prototype.renderFrame;
	
	HybridRenderer.prototype.hide = function(){
	    this.resizerElem.style.display = 'none';
	};
	
	HybridRenderer.prototype.show = function(){
	    this.resizerElem.style.display = 'block';
	};
	
	HybridRenderer.prototype.initItems = function(){
	    this.buildAllItems();
	    if(this.camera){
	        this.camera.setup();
	    } else {
	        var cWidth = this.globalData.compSize.w;
	        var cHeight = this.globalData.compSize.h;
	        var i, len = this.threeDElements.length;
	        for(i=0;i<len;i+=1){
	            this.threeDElements[i].perspectiveElem.style.perspective = this.threeDElements[i].perspectiveElem.style.webkitPerspective = Math.sqrt(Math.pow(cWidth,2) + Math.pow(cHeight,2)) + 'px';
	        }
	    }
	};
	
	HybridRenderer.prototype.searchExtraCompositions = function(assets){
	    var i, len = assets.length;
	    var floatingContainer = document.createElement('div');
	    for(i=0;i<len;i+=1){
	        if(assets[i].xt){
	            var comp = this.createComp(assets[i],floatingContainer,this.globalData.comp,null);
	            comp.initExpressions();
	            this.globalData.projectInterface.registerComposition(comp);
	        }
	    }
	};
	
	function CVBaseElement(data, comp,globalData){
	    this.globalData = globalData;
	    this.data = data;
	    this.comp = comp;
	    this.canvasContext = globalData.canvasContext;
	    this.init();
	}
	
	createElement(BaseElement, CVBaseElement);
	
	CVBaseElement.prototype.createElements = function(){
	    this.checkParenting();
	};
	
	CVBaseElement.prototype.checkBlendMode = function(globalData){
	    if(globalData.blendMode !== this.data.bm) {
	        globalData.blendMode = this.data.bm;
	
	        var blendModeValue = '';
	        switch (this.data.bm) {
	            case 0:
	                blendModeValue = 'normal';
	                break;
	            case 1:
	                blendModeValue = 'multiply';
	                break;
	            case 2:
	                blendModeValue = 'screen';
	                break;
	            case 3:
	                blendModeValue = 'overlay';
	                break;
	            case 4:
	                blendModeValue = 'darken';
	                break;
	            case 5:
	                blendModeValue = 'lighten';
	                break;
	            case 6:
	                blendModeValue = 'color-dodge';
	                break;
	            case 7:
	                blendModeValue = 'color-burn';
	                break;
	            case 8:
	                blendModeValue = 'hard-light';
	                break;
	            case 9:
	                blendModeValue = 'soft-light';
	                break;
	            case 10:
	                blendModeValue = 'difference';
	                break;
	            case 11:
	                blendModeValue = 'exclusion';
	                break;
	            case 12:
	                blendModeValue = 'hue';
	                break;
	            case 13:
	                blendModeValue = 'saturation';
	                break;
	            case 14:
	                blendModeValue = 'color';
	                break;
	            case 15:
	                blendModeValue = 'luminosity';
	                break;
	        }
	        globalData.canvasContext.globalCompositeOperation = blendModeValue;
	    }
	};
	
	
	CVBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3){
	        return false;
	    }
	        this.checkBlendMode(this.data.ty === 0?this.parentGlobalData:this.globalData);
	
	    if(!this.isVisible){
	        return this.isVisible;
	    }
	    this.finalTransform.opMdf = this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i, len = this.hierarchy.length;
	        mat = this.finalTransform.mProp.v.props;
	        finalMat.cloneFromProps(mat);
	        for(i=0;i<len;i+=1){
	            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
	            mat = this.hierarchy[i].finalTransform.mProp.v.props;
	            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        }
	    }else{
	        if(!parentTransform){
	            finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
	        }else{
	            mat = this.finalTransform.mProp.v.props;
	            finalMat.cloneFromProps(mat);
	        }
	    }
	
	    if(parentTransform){
	        mat = parentTransform.mat.props;
	        finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        this.finalTransform.opacity *= parentTransform.opacity;
	        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
	        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
	    }
	
	    if(this.data.hasMask){
	        this.globalData.renderer.save(true);
	        this.maskManager.renderFrame(this.data.ty === 0?null:finalMat);
	    }
	    if(this.data.hd){
	        this.isVisible = false;
	    }
	    return this.isVisible;
	
	};
	
	CVBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new CVMaskElement(data,this,this.globalData);
	};
	
	
	CVBaseElement.prototype.destroy = function(){
	    this.canvasContext = null;
	    this.data = null;
	    this.globalData = null;
	    if(this.maskManager) {
	        this.maskManager.destroy();
	    }
	};
	
	CVBaseElement.prototype.mHelper = new Matrix();
	
	function CVCompElement(data, comp,globalData){
	    this._parent.constructor.call(this,data, comp,globalData);
	    var compGlobalData = {};
	    for(var s in globalData){
	        if(globalData.hasOwnProperty(s)){
	            compGlobalData[s] = globalData[s];
	        }
	    }
	    compGlobalData.renderer = this;
	    compGlobalData.compHeight = this.data.h;
	    compGlobalData.compWidth = this.data.w;
	    this.renderConfig = {
	        clearCanvas: true
	    };
	    this.contextData = {
	        saved : Array.apply(null,{length:15}),
	        savedOp: Array.apply(null,{length:15}),
	        cArrPos : 0,
	        cTr : new Matrix(),
	        cO : 1
	    };
	    this.completeLayers = false;
	    var i, len = 15;
	    for(i=0;i<len;i+=1){
	        this.contextData.saved[i] = Array.apply(null,{length:16});
	    }
	    this.transformMat = new Matrix();
	    this.parentGlobalData = this.globalData;
	    var cv = document.createElement('canvas');
	    //document.body.appendChild(cv);
	    compGlobalData.canvasContext = cv.getContext('2d');
	    this.canvasContext = compGlobalData.canvasContext;
	    cv.width = this.data.w;
	    cv.height = this.data.h;
	    this.canvas = cv;
	    this.globalData = compGlobalData;
	    this.layers = data.layers;
	    this.pendingElements = [];
	    this.elements = Array.apply(null,{length:this.layers.length});
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.xt || !globalData.progressiveLoad){
	        this.buildAllItems();
	    }
	}
	createElement(CVBaseElement, CVCompElement);
	
	CVCompElement.prototype.ctxTransform = CanvasRenderer.prototype.ctxTransform;
	CVCompElement.prototype.ctxOpacity = CanvasRenderer.prototype.ctxOpacity;
	CVCompElement.prototype.save = CanvasRenderer.prototype.save;
	CVCompElement.prototype.restore = CanvasRenderer.prototype.restore;
	CVCompElement.prototype.reset =  function(){
	    this.contextData.cArrPos = 0;
	    this.contextData.cTr.reset();
	    this.contextData.cO = 1;
	};
	CVCompElement.prototype.resize = function(transformCanvas){
	    var maxScale = Math.max(transformCanvas.sx,transformCanvas.sy);
	    this.canvas.width = this.data.w*maxScale;
	    this.canvas.height = this.data.h*maxScale;
	    this.transformCanvas = {
	        sc:maxScale,
	        w:this.data.w*maxScale,
	        h:this.data.h*maxScale,
	        props:[maxScale,0,0,0,0,maxScale,0,0,0,0,1,0,0,0,0,1]
	    }
	    var i,len = this.elements.length;
	    for( i = 0; i < len; i+=1 ){
	        if(this.elements[i] && this.elements[i].data.ty === 0){
	            this.elements[i].resize(transformCanvas);
	        }
	    }
	};
	
	CVCompElement.prototype.prepareFrame = function(num){
	    this.globalData.frameId = this.parentGlobalData.frameId;
	    this.globalData.mdf = false;
	    this._parent.prepareFrame.call(this,num);
	    if(this.isVisible===false && !this.data.xt){
	        return;
	    }
	    var timeRemapped = num;
	    if(this.tm){
	        timeRemapped = this.tm.v;
	        if(timeRemapped === this.data.op){
	            timeRemapped = this.data.op - 1;
	        }
	    }
	    this.renderedFrame = timeRemapped/this.data.sr;
	    var i,len = this.elements.length;
	
	    if(!this.completeLayers){
	        this.checkLayers(num);
	    }
	
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].prepareFrame(timeRemapped/this.data.sr - this.layers[i].st);
	            if(this.elements[i].data.ty === 0 && this.elements[i].globalData.mdf){
	                this.globalData.mdf = true;
	            }
	        }
	    }
	    if(this.globalData.mdf && !this.data.xt){
	        this.canvasContext.clearRect(0, 0, this.data.w, this.data.h);
	        this.ctxTransform(this.transformCanvas.props);
	    }
	};
	
	CVCompElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this,parentMatrix)===false){
	        return;
	    }
	    if(this.globalData.mdf){
	        var i,len = this.layers.length;
	        for( i = len - 1; i >= 0; i -= 1 ){
	            if(this.completeLayers || this.elements[i]){
	                this.elements[i].renderFrame();
	            }
	        }
	    }
	    if(this.data.hasMask){
	        this.globalData.renderer.restore(true);
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	    this.parentGlobalData.renderer.save();
	    this.parentGlobalData.renderer.ctxTransform(this.finalTransform.mat.props);
	    this.parentGlobalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    this.parentGlobalData.renderer.canvasContext.drawImage(this.canvas,0,0,this.data.w,this.data.h);
	    this.parentGlobalData.renderer.restore();
	
	    if(this.globalData.mdf){
	        this.reset();
	    }
	};
	
	CVCompElement.prototype.setElements = function(elems){
	    this.elements = elems;
	};
	
	CVCompElement.prototype.getElements = function(){
	    return this.elements;
	};
	
	CVCompElement.prototype.destroy = function(){
	    var i,len = this.layers.length;
	    for( i = len - 1; i >= 0; i -= 1 ){
	        this.elements[i].destroy();
	    }
	    this.layers = null;
	    this.elements = null;
	    this._parent.destroy.call(this._parent);
	};
	CVCompElement.prototype.checkLayers = CanvasRenderer.prototype.checkLayers;
	CVCompElement.prototype.buildItem = CanvasRenderer.prototype.buildItem;
	CVCompElement.prototype.checkPendingElements = CanvasRenderer.prototype.checkPendingElements;
	CVCompElement.prototype.addPendingElement = CanvasRenderer.prototype.addPendingElement;
	CVCompElement.prototype.buildAllItems = CanvasRenderer.prototype.buildAllItems;
	CVCompElement.prototype.createItem = CanvasRenderer.prototype.createItem;
	CVCompElement.prototype.createImage = CanvasRenderer.prototype.createImage;
	CVCompElement.prototype.createComp = CanvasRenderer.prototype.createComp;
	CVCompElement.prototype.createSolid = CanvasRenderer.prototype.createSolid;
	CVCompElement.prototype.createShape = CanvasRenderer.prototype.createShape;
	CVCompElement.prototype.createText = CanvasRenderer.prototype.createText;
	CVCompElement.prototype.createBase = CanvasRenderer.prototype.createBase;
	CVCompElement.prototype.buildElementParenting = CanvasRenderer.prototype.buildElementParenting;
	function CVImageElement(data, comp,globalData){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data, comp,globalData);
	    this.globalData.addPendingElement();
	}
	createElement(CVBaseElement, CVImageElement);
	
	CVImageElement.prototype.createElements = function(){
	    var imageLoaded = function(){
	        this.globalData.elementLoaded();
	        if(this.assetData.w !== this.img.width || this.assetData.h !== this.img.height){
	            var canvas = document.createElement('canvas');
	            canvas.width = this.assetData.w;
	            canvas.height = this.assetData.h;
	            var ctx = canvas.getContext('2d');
	
	            var imgW = this.img.width;
	            var imgH = this.img.height;
	            var imgRel = imgW / imgH;
	            var canvasRel = this.assetData.w/this.assetData.h;
	            var widthCrop, heightCrop;
	            if(imgRel>canvasRel){
	                heightCrop = imgH;
	                widthCrop = heightCrop*canvasRel;
	            } else {
	                widthCrop = imgW;
	                heightCrop = widthCrop/canvasRel;
	            }
	            ctx.drawImage(this.img,(imgW-widthCrop)/2,(imgH-heightCrop)/2,widthCrop,heightCrop,0,0,this.assetData.w,this.assetData.h);
	            this.img = canvas;
	        }
	    }.bind(this);
	    var imageFailed = function(){
	        this.failed = true;
	        this.globalData.elementLoaded();
	    }.bind(this);
	
	    this.img = new Image();
	    this.img.addEventListener('load', imageLoaded, false);
	    this.img.addEventListener('error', imageFailed, false);
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    this.img.src = assetPath;
	
	    this._parent.createElements.call(this);
	
	};
	
	CVImageElement.prototype.renderFrame = function(parentMatrix){
	    if(this.failed){
	        return;
	    }
	    if(this._parent.renderFrame.call(this,parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    this.globalData.renderer.save();
	    var finalMat = this.finalTransform.mat.props;
	    this.globalData.renderer.ctxTransform(finalMat);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.drawImage(this.img,0,0);
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	CVImageElement.prototype.destroy = function(){
	    this.img = null;
	    this._parent.destroy.call(this._parent);
	};
	
	function CVMaskElement(data,element){
	    this.data = data;
	    this.element = element;
	    this.dynamicProperties = [];
	    this.masksProperties = this.data.masksProperties;
	    this.viewData = Array.apply(null,{length:this.masksProperties.length});
	    var i, len = this.masksProperties.length;
	    for (i = 0; i < len; i++) {
	        this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element,this.masksProperties[i],3,this.dynamicProperties,null);
	    }
	}
	
	CVMaskElement.prototype.prepareFrame = function(num){
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue(num);
	        if(this.dynamicProperties[i].mdf){
	            this.element.globalData.mdf = true;
	        }
	    }
	};
	
	CVMaskElement.prototype.renderFrame = function (transform) {
	    var ctx = this.element.canvasContext;
	    var i, len = this.data.masksProperties.length;
	    var pt,pt2,pt3,data, hasMasks = false;
	    for (i = 0; i < len; i++) {
	        if(this.masksProperties[i].mode === 'n'){
	            continue;
	        }
	        if(hasMasks === false){
	            ctx.beginPath();
	            hasMasks = true;
	        }
	        if (this.masksProperties[i].inv) {
	            ctx.moveTo(0, 0);
	            ctx.lineTo(this.element.globalData.compWidth, 0);
	            ctx.lineTo(this.element.globalData.compWidth, this.element.globalData.compHeight);
	            ctx.lineTo(0, this.element.globalData.compHeight);
	            ctx.lineTo(0, 0);
	        }
	        data = this.viewData[i].v;
	        pt = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0):data.v[0];
	        ctx.moveTo(pt[0], pt[1]);
	        var j, jLen = data._length;
	        for (j = 1; j < jLen; j++) {
	            pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
	            pt2 = transform ? transform.applyToPointArray(data.i[j][0],data.i[j][1],0) : data.i[j];
	            pt3 = transform ? transform.applyToPointArray(data.v[j][0],data.v[j][1],0) : data.v[j];
	            ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
	        }
	        pt = transform ? transform.applyToPointArray(data.o[j - 1][0],data.o[j - 1][1],0) : data.o[j - 1];
	        pt2 = transform ? transform.applyToPointArray(data.i[0][0],data.i[0][1],0) : data.i[0];
	        pt3 = transform ? transform.applyToPointArray(data.v[0][0],data.v[0][1],0) : data.v[0];
	        ctx.bezierCurveTo(pt[0], pt[1], pt2[0], pt2[1], pt3[0], pt3[1]);
	    }
	    if(hasMasks){
	        ctx.clip();
	    }
	};
	
	CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;
	
	CVMaskElement.prototype.destroy = function(){
	    this.element = null;
	};
	function CVShapeElement(data, comp,globalData){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data, comp,globalData);
	}
	createElement(CVBaseElement, CVShapeElement);
	
	CVShapeElement.prototype.transformHelper = {opacity:1,mat:new Matrix(),matMdf:false,opMdf:false};
	
	CVShapeElement.prototype.dashResetter = [];
	
	CVShapeElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties, true);
	};
	
	CVShapeElement.prototype.createStyleElement = function(data, dynamicProperties){
	    var styleElem = {
	        data: data,
	        type: data.ty,
	        elements: []
	    };
	    var elementData = {};
	    if(data.ty == 'fl' || data.ty == 'st'){
	        elementData.c = PropertyFactory.getProp(this,data.c,1,255,dynamicProperties);
	        if(!elementData.c.k){
	            styleElem.co = 'rgb('+bm_floor(elementData.c.v[0])+','+bm_floor(elementData.c.v[1])+','+bm_floor(elementData.c.v[2])+')';
	        }
	    }
	    elementData.o = PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties);
	    if(data.ty == 'st') {
	        styleElem.lc = this.lcEnum[data.lc] || 'round';
	        styleElem.lj = this.ljEnum[data.lj] || 'round';
	        if(data.lj == 1) {
	            styleElem.ml = data.ml;
	        }
	        elementData.w = PropertyFactory.getProp(this,data.w,0,null,dynamicProperties);
	        if(!elementData.w.k){
	            styleElem.wi = elementData.w.v;
	        }
	        if(data.d){
	            var d = new DashProperty(this,data.d,'canvas',dynamicProperties);
	            elementData.d = d;
	            if(!elementData.d.k){
	                styleElem.da = elementData.d.dashArray;
	                styleElem.do = elementData.d.dashoffset[0];
	            }
	        }
	
	    } else {
	
	        styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
	    }
	    this.stylesList.push(styleElem);
	    elementData.style = styleElem;
	    return elementData;
	}
	
	CVShapeElement.prototype.createGroupElement = function(data) {
	    var elementData = {
	        it: [],
	        prevViewData: []
	    };
	    return elementData;
	}
	
	CVShapeElement.prototype.createTransformElement = function(data, dynamicProperties) {
	    var elementData = {
	        transform : {
	            mat: new Matrix(),
	            opacity: 1,
	            matMdf:false,
	            opMdf:false,
	            op: PropertyFactory.getProp(this,data.o,0,0.01,dynamicProperties),
	            //mProps: PropertyFactory.getProp(this,data,2,null,dynamicProperties)
	            mProps: TransformPropertyFactory.getTransformProperty(this,data,dynamicProperties)
	        },
	        elements: []
	    };
	    return elementData;
	}
	
	CVShapeElement.prototype.createShapeElement = function(data, dynamicProperties) {
	    var elementData = {
	        nodes:[],
	        trNodes:[],
	        tr:[0,0,0,0,0,0]
	    };
	    var ty = 4;
	    if(data.ty == 'rc'){
	        ty = 5;
	    }else if(data.ty == 'el'){
	        ty = 6;
	    }else if(data.ty == 'sr'){
	        ty = 7;
	    }
	    elementData.sh = ShapePropertyFactory.getShapeProp(this,data,ty,dynamicProperties);
	    this.shapes.push(elementData.sh);
	    this.addShapeToModifiers(elementData);
	    jLen = this.stylesList.length;
	    var hasStrokes = false, hasFills = false;
	    for(j=0;j<jLen;j+=1){
	        if(!this.stylesList[j].closed){
	            this.stylesList[j].elements.push(elementData);
	            if(this.stylesList[j].type === 'st'){
	                hasStrokes = true;
	            }else{
	                hasFills = true;
	            }
	        }
	    }
	    elementData.st = hasStrokes;
	    elementData.fl = hasFills;
	    return elementData;
	}
	
	CVShapeElement.prototype.reloadShapes = function(){
	    this.firstFrame = true;
	    var i, len = this.itemsData.length;
	    for(i=0;i<len;i+=1){
	        this.prevViewData[i] = this.itemsData[i];
	    }
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.dynamicProperties, true);
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	    }
	    this.renderModifiers();
	}
	
	CVShapeElement.prototype.searchShapes = function(arr,itemsData, prevViewData,dynamicProperties, render){
	    var i, len = arr.length - 1;
	    var j, jLen;
	    var ownArrays = [], ownModifiers = [], processedPos;
	    for(i=len;i>=0;i-=1){
	        processedPos = this.searchProcessedElement(arr[i]);
	        if(!processedPos){
	            arr[i]._render = render;
	        } else {
	            itemsData[i] = prevViewData[processedPos - 1];
	        }
	        if(arr[i].ty == 'fl' || arr[i].ty == 'st'){
	            if(!processedPos){
	                itemsData[i] = this.createStyleElement(arr[i], dynamicProperties);
	            } else {
	                itemsData[i].style.closed = false;
	            }
	            
	            ownArrays.push(itemsData[i].style);
	        }else if(arr[i].ty == 'gr'){
	            if(!processedPos){
	                itemsData[i] = this.createGroupElement(arr[i]);
	            } else {
	                jLen = itemsData[i].it.length;
	                for(j=0;j<jLen;j+=1){
	                    itemsData[i].prevViewData[j] = itemsData[i].it[j];
	                }
	            }
	            this.searchShapes(arr[i].it,itemsData[i].it,itemsData[i].prevViewData,dynamicProperties, render);
	        }else if(arr[i].ty == 'tr'){
	            if(!processedPos){
	                itemsData[i] = this.createTransformElement(arr[i], dynamicProperties);
	            }
	        }else if(arr[i].ty == 'sh' || arr[i].ty == 'rc' || arr[i].ty == 'el' || arr[i].ty == 'sr'){
	            if(!processedPos){
	                itemsData[i] = this.createShapeElement(arr[i], dynamicProperties);
	            }
	            
	        }else if(arr[i].ty == 'tm' || arr[i].ty == 'rd'){
	            if(!processedPos){
	                var modifier = ShapeModifiers.getModifier(arr[i].ty);
	                modifier.init(this,arr[i],dynamicProperties);
	                itemsData[i] = modifier;
	                this.shapeModifiers.push(modifier);
	            } else {
	                modifier = itemsData[i];
	                modifier.closed = false;
	            }
	            ownModifiers.push(modifier);
	        } else if(arr[i].ty == 'rp'){
	            if(!processedPos){
	                modifier = ShapeModifiers.getModifier(arr[i].ty);
	                itemsData[i] = modifier;
	                modifier.init(this,arr,i,itemsData,dynamicProperties);
	                this.shapeModifiers.push(modifier);
	                render = false;
	            }else{
	                modifier = itemsData[i];
	                modifier.closed = true;
	            }
	            ownModifiers.push(modifier);
	        }
	        this.addProcessedElement(arr[i], i + 1);
	    }
	    len = ownArrays.length;
	    for(i=0;i<len;i+=1){
	        ownArrays[i].closed = true;
	    }
	    len = ownModifiers.length;
	    for(i=0;i<len;i+=1){
	        ownModifiers[i].closed = true;
	    }
	};
	
	CVShapeElement.prototype.addShapeToModifiers = IShapeElement.prototype.addShapeToModifiers;
	CVShapeElement.prototype.renderModifiers = IShapeElement.prototype.renderModifiers;
	CVShapeElement.prototype.lcEnum = IShapeElement.prototype.lcEnum;
	CVShapeElement.prototype.ljEnum = IShapeElement.prototype.ljEnum;
	CVShapeElement.prototype.searchProcessedElement = IShapeElement.prototype.searchProcessedElement;
	CVShapeElement.prototype.addProcessedElement = IShapeElement.prototype.addProcessedElement;
	
	CVShapeElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    this.transformHelper.mat.reset();
	    this.transformHelper.opacity = this.finalTransform.opacity;
	    this.transformHelper.matMdf = false;
	    this.transformHelper.opMdf = this.finalTransform.opMdf;
	    this.renderModifiers();
	    this.renderShape(this.transformHelper,null,null,true);
	    if(this.data.hasMask){
	        this.globalData.renderer.restore(true);
	    }
	};
	
	CVShapeElement.prototype.renderShape = function(parentTransform,items,data,isMain){
	    var i, len;
	    if(!items){
	        items = this.shapesData;
	        len = this.stylesList.length;
	        for(i=0;i<len;i+=1){
	            this.stylesList[i].d = '';
	            this.stylesList[i].mdf = false;
	        }
	    }
	    if(!data){
	        data = this.itemsData;
	    }
	    ///
	    ///
	    len = items.length - 1;
	    var groupTransform,groupMatrix;
	    groupTransform = parentTransform;
	    for(i=len;i>=0;i-=1){
	        if(items[i].ty == 'tr'){
	            groupTransform = data[i].transform;
	            var mtArr = data[i].transform.mProps.v.props;
	            groupTransform.matMdf = groupTransform.mProps.mdf;
	            groupTransform.opMdf = groupTransform.op.mdf;
	            groupMatrix = groupTransform.mat;
	            groupMatrix.cloneFromProps(mtArr);
	            if(parentTransform){
	                var props = parentTransform.mat.props;
	                groupTransform.opacity = parentTransform.opacity;
	                groupTransform.opacity *= data[i].transform.op.v;
	                groupTransform.matMdf = parentTransform.matMdf ? true : groupTransform.matMdf;
	                groupTransform.opMdf = parentTransform.opMdf ? true : groupTransform.opMdf;
	                groupMatrix.transform(props[0],props[1],props[2],props[3],props[4],props[5],props[6],props[7],props[8],props[9],props[10],props[11],props[12],props[13],props[14],props[15]);
	            }else{
	                groupTransform.opacity = groupTransform.op.o;
	            }
	        }else if(items[i].ty == 'sh' || items[i].ty == 'el' || items[i].ty == 'rc' || items[i].ty == 'sr'){
	            this.renderPath(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'fl'){
	            this.renderFill(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'st'){
	            this.renderStroke(items[i],data[i],groupTransform);
	        }else if(items[i].ty == 'gr'){
	            this.renderShape(groupTransform,items[i].it,data[i].it);
	        }else if(items[i].ty == 'tm'){
	            //
	        }
	    }
	    if(!isMain){
	        return;
	    }
	    len = this.stylesList.length;
	    var j, jLen, k, kLen,elems,nodes, renderer = this.globalData.renderer, ctx = this.globalData.canvasContext, type;
	    renderer.save();
	    renderer.ctxTransform(this.finalTransform.mat.props);
	    for(i=0;i<len;i+=1){
	        type = this.stylesList[i].type;
	        if((type === 'st' && this.stylesList[i].wi === 0) || !this.stylesList[i].data._render){
	            continue;
	        }
	        renderer.save();
	        elems = this.stylesList[i].elements;
	        if(type === 'st'){
	            ctx.strokeStyle = this.stylesList[i].co;
	            ctx.lineWidth = this.stylesList[i].wi;
	            ctx.lineCap = this.stylesList[i].lc;
	            ctx.lineJoin = this.stylesList[i].lj;
	            ctx.miterLimit = this.stylesList[i].ml || 0;
	        }else{
	            ctx.fillStyle = this.stylesList[i].co;
	        }
	        renderer.ctxOpacity(this.stylesList[i].coOp);
	        if(type !== 'st'){
	            ctx.beginPath();
	        }
	        jLen = elems.length;
	        for(j=0;j<jLen;j+=1){
	            if(type === 'st'){
	                ctx.beginPath();
	                if(this.stylesList[i].da){
	                    ctx.setLineDash(this.stylesList[i].da);
	                    ctx.lineDashOffset = this.stylesList[i].do;
	                    this.globalData.isDashed = true;
	                }else if(this.globalData.isDashed){
	                    ctx.setLineDash(this.dashResetter);
	                    this.globalData.isDashed = false;
	                }
	            }
	            nodes = elems[j].trNodes;
	            kLen = nodes.length;
	
	            for(k=0;k<kLen;k+=1){
	                if(nodes[k].t == 'm'){
	                    ctx.moveTo(nodes[k].p[0],nodes[k].p[1]);
	                }else if(nodes[k].t == 'c'){
	                    ctx.bezierCurveTo(nodes[k].p1[0],nodes[k].p1[1],nodes[k].p2[0],nodes[k].p2[1],nodes[k].p3[0],nodes[k].p3[1]);
	                }else{
	                    ctx.closePath();
	                }
	            }
	            if(type === 'st'){
	                ctx.stroke();
	            }
	        }
	        if(type !== 'st'){
	            ctx.fill(this.stylesList[i].r);
	        }
	        renderer.restore();
	    }
	    renderer.restore();
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	CVShapeElement.prototype.renderPath = function(pathData,itemData,groupTransform){
	    var len, i, j,jLen;
	    var redraw = groupTransform.matMdf || itemData.sh.mdf || this.firstFrame;
	    if(redraw) {
	        var paths = itemData.sh.paths, groupTransformMat = groupTransform.mat;
	        jLen = paths._length;
	        var pathStringTransformed = itemData.trNodes;
	        pathStringTransformed.length = 0;
	        for(j=0;j<jLen;j+=1){
	            var pathNodes = paths.shapes[j];
	            if(pathNodes && pathNodes.v){
	                len = pathNodes._length;
	                for (i = 1; i < len; i += 1) {
	                    if (i == 1) {
	                        pathStringTransformed.push({
	                            t: 'm',
	                            p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                        });
	                    }
	                    pathStringTransformed.push({
	                        t: 'c',
	                        p1: groupTransformMat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
	                        p2: groupTransformMat.applyToPointArray(pathNodes.i[i][0], pathNodes.i[i][1], 0),
	                        p3: groupTransformMat.applyToPointArray(pathNodes.v[i][0], pathNodes.v[i][1], 0)
	                    });
	                }
	                if (len == 1) {
	                    pathStringTransformed.push({
	                        t: 'm',
	                        p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                }
	                if (pathNodes.c && len) {
	                    pathStringTransformed.push({
	                        t: 'c',
	                        p1: groupTransformMat.applyToPointArray(pathNodes.o[i - 1][0], pathNodes.o[i - 1][1], 0),
	                        p2: groupTransformMat.applyToPointArray(pathNodes.i[0][0], pathNodes.i[0][1], 0),
	                        p3: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
	                    });
	                    pathStringTransformed.push({
	                        t: 'z'
	                    });
	                }
	                itemData.lStr = pathStringTransformed;
	            }
	
	        }
	
	        if (itemData.st) {
	            for (i = 0; i < 16; i += 1) {
	                itemData.tr[i] = groupTransform.mat.props[i];
	            }
	        }
	        itemData.trNodes = pathStringTransformed;
	
	    }
	};
	
	
	
	CVShapeElement.prototype.renderFill = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || groupTransform.opMdf || this.firstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	};
	
	CVShapeElement.prototype.renderStroke = function(styleData,itemData, groupTransform){
	    var styleElem = itemData.style;
	    //TODO fix dashes
	    var d = itemData.d;
	    if(d && (d.mdf  || this.firstFrame)){
	        styleElem.da = d.dashArray;
	        styleElem.do = d.dashoffset[0];
	    }
	    if(itemData.c.mdf || this.firstFrame){
	        styleElem.co = 'rgb('+bm_floor(itemData.c.v[0])+','+bm_floor(itemData.c.v[1])+','+bm_floor(itemData.c.v[2])+')';
	    }
	    if(itemData.o.mdf || groupTransform.opMdf || this.firstFrame){
	        styleElem.coOp = itemData.o.v*groupTransform.opacity;
	    }
	    if(itemData.w.mdf || this.firstFrame){
	        styleElem.wi = itemData.w.v;
	    }
	};
	
	
	CVShapeElement.prototype.destroy = function(){
	    this.shapesData = null;
	    this.globalData = null;
	    this.canvasContext = null;
	    this.stylesList.length = 0;
	    this.itemData.length = 0;
	    this._parent.destroy.call(this._parent);
	};
	
	
	function CVSolidElement(data, comp,globalData){
	    this._parent.constructor.call(this,data, comp,globalData);
	}
	createElement(CVBaseElement, CVSolidElement);
	
	CVSolidElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    this.globalData.renderer.save();
	    this.globalData.renderer.ctxTransform(this.finalTransform.mat.props);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.fillStyle=this.data.sc;
	    ctx.fillRect(0,0,this.data.sw,this.data.sh);
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	function CVTextElement(data, comp, globalData){
	    this.textSpans = [];
	    this.yOffset = 0;
	    this.fillColorAnim = false;
	    this.strokeColorAnim = false;
	    this.strokeWidthAnim = false;
	    this.stroke = false;
	    this.fill = false;
	    this.justifyOffset = 0;
	    this.currentRender = null;
	    this.renderType = 'canvas';
	    this.values = {
	        fill: 'rgba(0,0,0,0)',
	        stroke: 'rgba(0,0,0,0)',
	        sWidth: 0,
	        fValue: ''
	    }
	    this._parent.constructor.call(this,data,comp, globalData);
	}
	createElement(CVBaseElement, CVTextElement);
	
	extendPrototype(ITextElement, CVTextElement);
	
	CVTextElement.prototype.tHelper = document.createElement('canvas').getContext('2d');
	
	CVTextElement.prototype.createElements = function(){
	
	    this._parent.createElements.call(this);
	    //console.log('this.data: ',this.data);
	
	};
	
	CVTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = Array.apply(null,{length:documentData.l ? documentData.l.length : 0});
	
	    var hasFill = false;
	    if(documentData.fc) {
	        hasFill = true;
	        this.values.fill = this.buildColor(documentData.fc);
	    }else{
	        this.values.fill = 'rgba(0,0,0,0)';
	    }
	    this.fill = hasFill;
	    var hasStroke = false;
	    if(documentData.sc){
	        hasStroke = true;
	        this.values.stroke = this.buildColor(documentData.sc);
	        this.values.sWidth = documentData.sw;
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    var i, len;
	    var letters = documentData.l;
	    var matrixHelper = this.mHelper;
	    this.stroke = hasStroke;
	    this.values.fValue = documentData.s + 'px '+ this.globalData.fontManager.getFontByName(documentData.f).fFamily;
	    len = documentData.t.length;
	    //this.tHelper.font = this.values.fValue;
	    var charData, shapeData, k, kLen, shapes, j, jLen, pathNodes, commands, pathArr, singleShape = this.data.singleShape;
	    var trackingOffset = documentData.tr/1000*documentData.s;
	    var xPos = 0, yPos = 0, firstLine = true;
	    var cnt = 0;
	    for (i = 0; i < len; i += 1) {
	        charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	        shapeData = charData && charData.data || {};
	        matrixHelper.reset();
	        if(singleShape && letters[i].n) {
	            xPos = -trackingOffset;
	            yPos += documentData.yOffset;
	            yPos += firstLine ? 1 : 0;
	            firstLine = false;
	        }
	
	        shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
	        jLen = shapes.length;
	        matrixHelper.scale(documentData.s/100,documentData.s/100);
	        if(singleShape){
	            this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
	        }
	        commands = Array.apply(null,{length:jLen})
	        for(j=0;j<jLen;j+=1){
	            kLen = shapes[j].ks.k.i.length;
	            pathNodes = shapes[j].ks.k;
	            pathArr = [];
	            for(k=1;k<kLen;k+=1){
	                if(k==1){
	                    pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	                }
	                pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToY(pathNodes.i[k][0],pathNodes.i[k][1],0),matrixHelper.applyToX(pathNodes.v[k][0],pathNodes.v[k][1],0),matrixHelper.applyToY(pathNodes.v[k][0],pathNodes.v[k][1],0));
	            }
	            pathArr.push(matrixHelper.applyToX(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToY(pathNodes.o[k-1][0],pathNodes.o[k-1][1],0),matrixHelper.applyToX(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToY(pathNodes.i[0][0],pathNodes.i[0][1],0),matrixHelper.applyToX(pathNodes.v[0][0],pathNodes.v[0][1],0),matrixHelper.applyToY(pathNodes.v[0][0],pathNodes.v[0][1],0));
	            commands[j] = pathArr;
	        }
	        if(singleShape){
	            xPos += letters[i].l;
	            xPos += trackingOffset;
	        }
	        if(this.textSpans[cnt]){
	            this.textSpans[cnt].elem = commands;
	        } else {
	            this.textSpans[cnt] = {elem: commands};
	        }
	        cnt +=1;
	    }
	}
	
	CVTextElement.prototype.renderFrame = function(parentMatrix){
	    if(this._parent.renderFrame.call(this, parentMatrix)===false){
	        return;
	    }
	    var ctx = this.canvasContext;
	    var finalMat = this.finalTransform.mat.props;
	    this.globalData.renderer.save();
	    this.globalData.renderer.ctxTransform(finalMat);
	    this.globalData.renderer.ctxOpacity(this.finalTransform.opacity);
	    ctx.font = this.values.fValue;
	    ctx.lineCap = 'butt';
	    ctx.lineJoin = 'miter';
	    ctx.miterLimit = 4;
	
	    if(!this.data.singleShape){
	        this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    }
	
	    var  i,len, j, jLen, k, kLen;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter;
	    var lastFill = null, lastStroke = null, lastStrokeW = null, commands, pathArr;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            continue;
	        }
	        renderedLetter = renderedLetters[i];
	        if(renderedLetter){
	            this.globalData.renderer.save();
	            this.globalData.renderer.ctxTransform(renderedLetter.p);
	            this.globalData.renderer.ctxOpacity(renderedLetter.o);
	        }
	        if(this.fill){
	            if(renderedLetter && renderedLetter.fc){
	                if(lastFill !== renderedLetter.fc){
	                    lastFill = renderedLetter.fc;
	                    ctx.fillStyle = renderedLetter.fc;
	                }
	            }else if(lastFill !== this.values.fill){
	                lastFill = this.values.fill;
	                ctx.fillStyle = this.values.fill;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.fill();
	            ///ctx.fillText(this.textSpans[i].val,0,0);
	        }
	        if(this.stroke){
	            if(renderedLetter && renderedLetter.sw){
	                if(lastStrokeW !== renderedLetter.sw){
	                    lastStrokeW = renderedLetter.sw;
	                    ctx.lineWidth = renderedLetter.sw;
	                }
	            }else if(lastStrokeW !== this.values.sWidth){
	                lastStrokeW = this.values.sWidth;
	                ctx.lineWidth = this.values.sWidth;
	            }
	            if(renderedLetter && renderedLetter.sc){
	                if(lastStroke !== renderedLetter.sc){
	                    lastStroke = renderedLetter.sc;
	                    ctx.strokeStyle = renderedLetter.sc;
	                }
	            }else if(lastStroke !== this.values.stroke){
	                lastStroke = this.values.stroke;
	                ctx.strokeStyle = this.values.stroke;
	            }
	            commands = this.textSpans[i].elem;
	            jLen = commands.length;
	            this.globalData.canvasContext.beginPath();
	            for(j=0;j<jLen;j+=1) {
	                pathArr = commands[j];
	                kLen = pathArr.length;
	                this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);
	                for (k = 2; k < kLen; k += 6) {
	                    this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
	                }
	            }
	            this.globalData.canvasContext.closePath();
	            this.globalData.canvasContext.stroke();
	            ///ctx.strokeText(letters[i].val,0,0);
	        }
	        if(renderedLetter) {
	            this.globalData.renderer.restore();
	        }
	    }
	    /*if(this.data.hasMask){
	     this.globalData.renderer.restore(true);
	     }*/
	    this.globalData.renderer.restore(this.data.hasMask);
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	function HBaseElement(data,parentContainer,globalData,comp, placeholder){
	    this.globalData = globalData;
	    this.comp = comp;
	    this.data = data;
	    this.matteElement = null;
	    this.parentContainer = parentContainer;
	    this.layerId = placeholder ? placeholder.layerId : 'ly_'+randomString(10);
	    this.placeholder = placeholder;
	    this.init();
	};
	
	createElement(BaseElement, HBaseElement);
	HBaseElement.prototype.checkBlendMode = function(){
	
	};
	HBaseElement.prototype.setBlendMode = BaseElement.prototype.setBlendMode;
	
	/*HBaseElement.prototype.appendNodeToParent = function(node) {
	    if(this.data.hd){
	        return;
	    }
	    if(this.placeholder){
	        var g = this.placeholder.phElement;
	        g.parentNode.insertBefore(node, g);
	        //g.parentNode.removeChild(g);
	    }else{
	        this.parentContainer.appendChild(node);
	    }
	};*/
	
	
	HBaseElement.prototype.getBaseElement = function(){
	    return this.baseElement;
	};
	
	HBaseElement.prototype.createElements = function(){
	    if(this.data.hasMask){
	        this.layerElement = createNS('svg');
	        styleDiv(this.layerElement);
	        //this.appendNodeToParent(this.layerElement);
	        this.baseElement = this.layerElement;
	        this.maskedElement = this.layerElement;
	    }else{
	        this.layerElement = this.parentContainer;
	    }
	    this.transformedElement = this.layerElement;
	    if(this.data.ln && (this.data.ty === 4 || this.data.ty === 0)){
	        if(this.layerElement === this.parentContainer){
	            this.layerElement = createNS('g');
	            //this.appendNodeToParent(this.layerElement);
	            this.baseElement = this.layerElement;
	        }
	        this.layerElement.setAttribute('id',this.data.ln);
	    }
	    this.setBlendMode();
	    if(this.layerElement !== this.parentContainer){
	        this.placeholder = null;
	    }
	    this.checkParenting();
	};
	
	HBaseElement.prototype.renderFrame = function(parentTransform){
	    if(this.data.ty === 3){
	        return false;
	    }
	
	    if(this.currentFrameNum === this.lastNum || !this.isVisible){
	        return this.isVisible;
	    }
	    this.lastNum = this.currentFrameNum;
	
	    this.finalTransform.opMdf = this.finalTransform.op.mdf;
	    this.finalTransform.matMdf = this.finalTransform.mProp.mdf;
	    this.finalTransform.opacity = this.finalTransform.op.v;
	    if(this.firstFrame){
	        this.finalTransform.opMdf = true;
	        this.finalTransform.matMdf = true;
	    }
	
	    var mat;
	    var finalMat = this.finalTransform.mat;
	
	    if(this.hierarchy){
	        var i, len = this.hierarchy.length;
	
	        mat = this.finalTransform.mProp.v.props;
	        finalMat.cloneFromProps(mat);
	        for(i=0;i<len;i+=1){
	            this.finalTransform.matMdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : this.finalTransform.matMdf;
	            mat = this.hierarchy[i].finalTransform.mProp.v.props;
	            finalMat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],mat[12],mat[13],mat[14],mat[15]);
	        }
	    }else{
	        if(this.isVisible && this.finalTransform.matMdf){
	            if(!parentTransform){
	                finalMat.cloneFromProps(this.finalTransform.mProp.v.props);
	            }else{
	                mat = this.finalTransform.mProp.v.props;
	                finalMat.cloneFromProps(mat);
	            }
	        }
	    }
	    if(this.data.hasMask){
	        this.maskManager.renderFrame(finalMat);
	    }
	
	    if(parentTransform){
	        mat = parentTransform.mat.props;
	        finalMat.cloneFromProps(mat);
	        this.finalTransform.opacity *= parentTransform.opacity;
	        this.finalTransform.opMdf = parentTransform.opMdf ? true : this.finalTransform.opMdf;
	        this.finalTransform.matMdf = parentTransform.matMdf ? true : this.finalTransform.matMdf
	    }
	
	    if(this.finalTransform.matMdf){
	        this.transformedElement.style.transform = this.transformedElement.style.webkitTransform = finalMat.toCSS();
	        this.finalMat = finalMat;
	    }
	    if(this.finalTransform.opMdf){
	        this.transformedElement.style.opacity = this.finalTransform.opacity;
	    }
	    return this.isVisible;
	};
	
	HBaseElement.prototype.destroy = function(){
	    this.layerElement = null;
	    this.transformedElement = null;
	    this.parentContainer = null;
	    if(this.matteElement) {
	        this.matteElement = null;
	    }
	    if(this.maskManager) {
	        this.maskManager.destroy();
	        this.maskManager = null;
	    }
	};
	
	HBaseElement.prototype.getDomElement = function(){
	    return this.layerElement;
	};
	HBaseElement.prototype.addMasks = function(data){
	    this.maskManager = new MaskElement(data,this,this.globalData);
	};
	
	HBaseElement.prototype.hide = function(){
	};
	
	HBaseElement.prototype.setMatte = function(){
	
	}
	
	HBaseElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	function HSolidElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(HBaseElement, HSolidElement);
	
	HSolidElement.prototype.createElements = function(){
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    var cont = createNS('svg');
	    styleDiv(cont);
	    cont.setAttribute('width',this.data.sw);
	    cont.setAttribute('height',this.data.sh);
	    parent.appendChild(cont);
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    //this.appendNodeToParent(parent);
	    this.baseElement = parent;
	    this.innerElem = parent;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    var rect = createNS('rect');
	    rect.setAttribute('width',this.data.sw);
	    rect.setAttribute('height',this.data.sh);
	    rect.setAttribute('fill',this.data.sc);
	    cont.appendChild(rect);
	    if(this.data.hasMask){
	        this.maskedElement = rect;
	    }
	    this.checkParenting();
	};
	
	
	
	HSolidElement.prototype.hide = SVGBaseElement.prototype.hide;
	HSolidElement.prototype.show = SVGBaseElement.prototype.show;
	HSolidElement.prototype.renderFrame = IImageElement.prototype.renderFrame;
	HSolidElement.prototype.destroy = IImageElement.prototype.destroy;
	function HCompElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.layers = data.layers;
	    this.supports3d = true;
	    this.completeLayers = false;
	    this.pendingElements = [];
	    this.elements = Array.apply(null,{length:this.layers.length});
	    if(this.data.tm){
	        this.tm = PropertyFactory.getProp(this,this.data.tm,0,globalData.frameRate,this.dynamicProperties);
	    }
	    if(this.data.hasMask) {
	        this.supports3d = false;
	    }
	    if(this.data.xt){
	        this.layerElement = document.createElement('div');
	    }
	    this.buildAllItems();
	
	}
	createElement(HBaseElement, HCompElement);
	
	HCompElement.prototype.createElements = function(){
	    var divElement = document.createElement('div');
	    styleDiv(divElement);
	    if(this.data.ln){
	        divElement.setAttribute('id',this.data.ln);
	    }
	    divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';
	    if(this.data.hasMask){
	        var compSvg = createNS('svg');
	        styleDiv(compSvg);
	        compSvg.setAttribute('width',this.data.w);
	        compSvg.setAttribute('height',this.data.h);
	        var g = createNS('g');
	        compSvg.appendChild(g);
	        divElement.appendChild(compSvg);
	        this.maskedElement = g;
	        this.baseElement = divElement;
	        this.layerElement = g;
	        this.transformedElement = divElement;
	    }else{
	        this.layerElement = divElement;
	        this.baseElement = this.layerElement;
	        this.transformedElement = divElement;
	    }
	    //this.appendNodeToParent(this.layerElement);
	    this.checkParenting();
	};
	
	HCompElement.prototype.hide = ICompElement.prototype.hide;
	HCompElement.prototype.prepareFrame = ICompElement.prototype.prepareFrame;
	HCompElement.prototype.setElements = ICompElement.prototype.setElements;
	HCompElement.prototype.getElements = ICompElement.prototype.getElements;
	HCompElement.prototype.destroy = ICompElement.prototype.destroy;
	
	HCompElement.prototype.renderFrame = function(parentMatrix){
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    var i,len = this.layers.length;
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	
	    this.hidden = false;
	
	    for( i = 0; i < len; i+=1 ){
	        if(this.completeLayers || this.elements[i]){
	            this.elements[i].renderFrame();
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	};
	
	HCompElement.prototype.checkLayers = BaseRenderer.prototype.checkLayers;
	HCompElement.prototype.buildItem = HybridRenderer.prototype.buildItem;
	HCompElement.prototype.checkPendingElements = HybridRenderer.prototype.checkPendingElements;
	HCompElement.prototype.addPendingElement = HybridRenderer.prototype.addPendingElement;
	HCompElement.prototype.buildAllItems = BaseRenderer.prototype.buildAllItems;
	HCompElement.prototype.createItem = HybridRenderer.prototype.createItem;
	HCompElement.prototype.buildElementParenting = HybridRenderer.prototype.buildElementParenting;
	HCompElement.prototype.createImage = HybridRenderer.prototype.createImage;
	HCompElement.prototype.createComp = HybridRenderer.prototype.createComp;
	HCompElement.prototype.createSolid = HybridRenderer.prototype.createSolid;
	HCompElement.prototype.createShape = HybridRenderer.prototype.createShape;
	HCompElement.prototype.createText = HybridRenderer.prototype.createText;
	HCompElement.prototype.createBase = HybridRenderer.prototype.createBase;
	HCompElement.prototype.appendElementInPos = HybridRenderer.prototype.appendElementInPos;
	function HShapeElement(data,parentContainer,globalData,comp, placeholder){
	    this.shapes = [];
	    this.shapesData = data.shapes;
	    this.stylesList = [];
	    this.itemsData = [];
	    this.prevViewData = [];
	    this.shapeModifiers = [];
	    this.processedElements = [];
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    };
	}
	createElement(HBaseElement, HShapeElement);
	var parent = HShapeElement.prototype._parent;
	extendPrototype(IShapeElement, HShapeElement);
	HShapeElement.prototype._parent = parent;
	HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderFrame;
	
	HShapeElement.prototype.createElements = function(){
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    var cont = createNS('svg');
	    styleDiv(cont);
	    var size = this.comp.data ? this.comp.data : this.globalData.compSize;
	    cont.setAttribute('width',size.w);
	    cont.setAttribute('height',size.h);
	    if(this.data.hasMask){
	        var g = createNS('g');
	        parent.appendChild(cont);
	        cont.appendChild(g);
	        this.maskedElement = g;
	        this.layerElement = g;
	        this.shapesContainer = g;
	    }else{
	        parent.appendChild(cont);
	        this.layerElement = cont;
	        this.shapesContainer = createNS('g');
	        this.layerElement.appendChild(this.shapesContainer);
	    }
	    if(!this.data.hd){
	        //this.parentContainer.appendChild(parent);
	        this.baseElement = parent;
	    }
	    this.innerElem = parent;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	
	    this.searchShapes(this.shapesData,this.itemsData,this.prevViewData,this.layerElement,this.dynamicProperties,0, [], true);
	    this.buildExpressionInterface();
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    this.shapeCont = cont;
	    if(this.data.bm !== 0){
	        this.setBlendMode();
	    }
	    this.checkParenting();
	};
	
	HShapeElement.prototype.renderFrame = function(parentMatrix){
	    var firstFrame = this.firstFrame;
	    this._renderShapeFrame();
	
	    if(this.isVisible && (this.elemMdf || firstFrame)){
	        var boundingBox = this.shapeCont.getBBox();
	        var changed = false;
	        if(this.currentBBox.w !== boundingBox.width){
	            this.currentBBox.w = boundingBox.width;
	            this.shapeCont.setAttribute('width',boundingBox.width);
	            changed = true;
	        }
	        if(this.currentBBox.h !== boundingBox.height){
	            this.currentBBox.h = boundingBox.height;
	            this.shapeCont.setAttribute('height',boundingBox.height);
	            changed = true;
	        }
	        if(changed  || this.currentBBox.x !== boundingBox.x  || this.currentBBox.y !== boundingBox.y){
	            this.currentBBox.w = boundingBox.width;
	            this.currentBBox.h = boundingBox.height;
	            this.currentBBox.x = boundingBox.x;
	            this.currentBBox.y = boundingBox.y;
	
	            this.shapeCont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	            this.shapeCont.style.transform = this.shapeCont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	        }
	    }
	
	};
	function HTextElement(data,parentContainer,globalData,comp, placeholder){
	    this.textSpans = [];
	    this.textPaths = [];
	    this.currentBBox = {
	        x:999999,
	        y: -999999,
	        h: 0,
	        w: 0
	    }
	    this.renderType = 'svg';
	    this.isMasked = false;
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	
	}
	createElement(HBaseElement, HTextElement);
	
	extendPrototype(ITextElement, HTextElement);
	
	HTextElement.prototype.createElements = function(){
	    this.isMasked = this.checkMasks();
	    var parent = document.createElement('div');
	    styleDiv(parent);
	    this.layerElement = parent;
	    this.transformedElement = parent;
	    if(this.isMasked){
	        this.renderType = 'svg';
	        var cont = createNS('svg');
	        styleDiv(cont);
	        this.cont = cont;
	        this.compW = this.comp.data.w;
	        this.compH = this.comp.data.h;
	        cont.setAttribute('width',this.compW);
	        cont.setAttribute('height',this.compH);
	        var g = createNS('g');
	        cont.appendChild(g);
	        parent.appendChild(cont);
	        this.maskedElement = g;
	        this.innerElem = g;
	    } else {
	        this.renderType = 'html';
	        this.innerElem = parent;
	    }
	    this.baseElement = parent;
	
	    this.checkParenting();
	
	};
	
	HTextElement.prototype.buildNewText = function(){
	    var documentData = this.textProperty.currentData;
	    this.renderedLetters = Array.apply(null,{length:this.textProperty.currentData.l ? this.textProperty.currentData.l.length : 0});
	    var innerElemStyle = this.innerElem.style;
	    innerElemStyle.color = innerElemStyle.fill = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
	    if(documentData.sc){
	        innerElemStyle.stroke = this.buildColor(documentData.sc);
	        innerElemStyle.strokeWidth = documentData.sw+'px';
	    }
	    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
	    if(!this.globalData.fontManager.chars){
	        innerElemStyle.fontSize = documentData.s+'px';
	        innerElemStyle.lineHeight = documentData.s+'px';
	        if(fontData.fClass){
	            this.innerElem.className = fontData.fClass;
	        } else {
	            innerElemStyle.fontFamily = fontData.fFamily;
	            var fWeight = documentData.fWeight, fStyle = documentData.fStyle;
	            innerElemStyle.fontStyle = fStyle;
	            innerElemStyle.fontWeight = fWeight;
	        }
	    }
	    var i, len;
	
	    var letters = documentData.l;
	    len = letters.length;
	    var tSpan,tParent,tCont;
	    var matrixHelper = this.mHelper;
	    var shapes, shapeStr = '';
	    var cnt = 0;
	    for (i = 0;i < len ;i += 1) {
	        if(this.globalData.fontManager.chars){
	            if(!this.textPaths[cnt]){
	                tSpan = createNS('path');
	                tSpan.setAttribute('stroke-linecap', 'butt');
	                tSpan.setAttribute('stroke-linejoin','round');
	                tSpan.setAttribute('stroke-miterlimit','4');
	            } else {
	                tSpan = this.textPaths[cnt];
	            }
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tCont = tParent.children[0];
	                } else {
	
	                    tParent = document.createElement('div');
	                    tCont = createNS('svg');
	                    tCont.appendChild(tSpan);
	                    styleDiv(tParent);
	                }
	            }
	        }else{
	            if(!this.isMasked){
	                if(this.textSpans[cnt]){
	                    tParent = this.textSpans[cnt];
	                    tSpan = this.textPaths[cnt];
	                } else {
	                    tParent = document.createElement('span');
	                    styleDiv(tParent);
	                    tSpan = document.createElement('span');
	                    styleDiv(tSpan);
	                    tParent.appendChild(tSpan);
	                }
	            } else {
	                tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
	            }
	        }
	        //tSpan.setAttribute('visibility', 'hidden');
	        if(this.globalData.fontManager.chars){
	            var charData = this.globalData.fontManager.getCharData(documentData.t.charAt(i), fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
	            var shapeData;
	            if(charData){
	                shapeData = charData.data;
	            } else {
	                shapeData = null;
	            }
	            matrixHelper.reset();
	            if(shapeData && shapeData.shapes){
	                shapes = shapeData.shapes[0].it;
	                matrixHelper.scale(documentData.s/100,documentData.s/100);
	                shapeStr = this.createPathShape(matrixHelper,shapes);
	                tSpan.setAttribute('d',shapeStr);
	            }
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                if(shapeData && shapeData.shapes){
	                    document.body.appendChild(tCont);
	
	                    var boundingBox = tCont.getBBox();
	                    tCont.setAttribute('width',boundingBox.width + 2);
	                    tCont.setAttribute('height',boundingBox.height + 2);
	                    tCont.setAttribute('viewBox',(boundingBox.x-1)+' '+ (boundingBox.y-1)+' '+ (boundingBox.width+2)+' '+ (boundingBox.height+2));
	                    tCont.style.transform = tCont.style.webkitTransform = 'translate(' + (boundingBox.x-1) + 'px,' + (boundingBox.y-1) + 'px)';
	
	                    letters[i].yOffset = boundingBox.y-1;
	                    tParent.appendChild(tCont);
	
	                } else{
	                    tCont.setAttribute('width',1);
	                    tCont.setAttribute('height',1);
	                }
	            }else{
	                this.innerElem.appendChild(tSpan);
	            }
	        }else{
	            tSpan.textContent = letters[i].val;
	            tSpan.setAttributeNS("http://www.w3.org/XML/1998/namespace", "xml:space","preserve");
	            if(!this.isMasked){
	                this.innerElem.appendChild(tParent);
	                //
	                tSpan.style.transform = tSpan.style.webkitTransform = 'translate3d(0,'+ -documentData.s/1.2+'px,0)';
	            } else {
	                this.innerElem.appendChild(tSpan);
	            }
	        }
	        //
	        if(!this.isMasked){
	            this.textSpans[cnt] = tParent;
	        }else{
	            this.textSpans[cnt] = tSpan;
	        }
	        this.textSpans[cnt].style.display = 'block';
	        this.textPaths[cnt] = tSpan;
	        cnt += 1;
	    }
	    while(cnt < this.textSpans.length){
	        this.textSpans[cnt].style.display = 'none';
	        cnt += 1;
	    }
	}
	
	HTextElement.prototype.hide = SVGTextElement.prototype.hide;
	
	HTextElement.prototype.renderFrame = function(parentMatrix){
	
	    var renderParent = this._parent.renderFrame.call(this,parentMatrix);
	    if(renderParent===false){
	        this.hide();
	        return;
	    }
	    if(this.hidden){
	        this.hidden = false;
	        this.innerElem.style.display = 'block';
	        this.layerElement.style.display = 'block';
	    }
	
	    if(this.data.singleShape){
	        if(!this.firstFrame && !this.lettersChangedFlag){
	            return;
	        } else {
	            // Todo Benchmark if using this is better than getBBox
	             if(this.isMasked && this.finalTransform.matMdf){
	                 this.cont.setAttribute('viewBox',-this.finalTransform.mProp.p.v[0]+' '+ -this.finalTransform.mProp.p.v[1]+' '+this.compW+' '+this.compH);
	                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
	             }
	        }
	    }
	
	    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
	    if(!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag){
	        return;
	    }
	    var  i,len, count = 0;
	    var renderedLetters = this.textAnimator.renderedLetters;
	
	    var letters = this.textProperty.currentData.l;
	
	    len = letters.length;
	    var renderedLetter, textSpan, textPath;
	    for(i=0;i<len;i+=1){
	        if(letters[i].n){
	            count += 1;
	            continue;
	        }
	        textSpan = this.textSpans[i];
	        textPath = this.textPaths[i];
	        renderedLetter = renderedLetters[count];
	        count += 1;
	        if(!this.isMasked){
	            textSpan.style.transform = textSpan.style.webkitTransform = renderedLetter.m;
	        }else{
	            textSpan.setAttribute('transform',renderedLetter.m);
	        }
	        ////textSpan.setAttribute('opacity',renderedLetter.o);
	        textSpan.style.opacity = renderedLetter.o;
	        if(renderedLetter.sw){
	            textPath.setAttribute('stroke-width',renderedLetter.sw);
	        }
	        if(renderedLetter.sc){
	            textPath.setAttribute('stroke',renderedLetter.sc);
	        }
	        if(renderedLetter.fc){
	            textPath.setAttribute('fill',renderedLetter.fc);
	            textPath.style.color = renderedLetter.fc;
	        }
	    }
	    if(this.isVisible && (this.elemMdf || this.firstFrame)){
	        if(this.innerElem.getBBox){
	            var boundingBox = this.innerElem.getBBox();
	
	            if(this.currentBBox.w !== boundingBox.width){
	                this.currentBBox.w = boundingBox.width;
	                this.cont.setAttribute('width',boundingBox.width);
	            }
	            if(this.currentBBox.h !== boundingBox.height){
	                this.currentBBox.h = boundingBox.height;
	                this.cont.setAttribute('height',boundingBox.height);
	            }
	
	            var margin = 1;
	            if(this.currentBBox.w !== (boundingBox.width + margin*2) || this.currentBBox.h !== (boundingBox.height + margin*2)  || this.currentBBox.x !== (boundingBox.x - margin)  || this.currentBBox.y !== (boundingBox.y - margin)){
	                this.currentBBox.w = boundingBox.width + margin*2;
	                this.currentBBox.h = boundingBox.height + margin*2;
	                this.currentBBox.x = boundingBox.x - margin;
	                this.currentBBox.y = boundingBox.y - margin;
	
	                this.cont.setAttribute('viewBox',this.currentBBox.x+' '+this.currentBBox.y+' '+this.currentBBox.w+' '+this.currentBBox.h);
	                this.cont.style.transform = this.cont.style.webkitTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
	            }
	        }
	    }
	    if(this.firstFrame){
	        this.firstFrame = false;
	    }
	}
	function HImageElement(data,parentContainer,globalData,comp, placeholder){
	    this.assetData = globalData.getAssetData(data.refId);
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	}
	createElement(HBaseElement, HImageElement);
	
	HImageElement.prototype.createElements = function(){
	
	    var assetPath = this.globalData.getAssetsPath(this.assetData);
	    var img = new Image();
	
	    if(this.data.hasMask){
	        var parent = document.createElement('div');
	        styleDiv(parent);
	        var cont = createNS('svg');
	        styleDiv(cont);
	        cont.setAttribute('width',this.assetData.w);
	        cont.setAttribute('height',this.assetData.h);
	        parent.appendChild(cont);
	        this.imageElem = createNS('image');
	        this.imageElem.setAttribute('width',this.assetData.w+"px");
	        this.imageElem.setAttribute('height',this.assetData.h+"px");
	        this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink','href',assetPath);
	        cont.appendChild(this.imageElem);
	        this.layerElement = parent;
	        this.transformedElement = parent;
	        this.baseElement = parent;
	        this.innerElem = parent;
	        this.maskedElement = this.imageElem;
	    } else {
	        styleDiv(img);
	        this.layerElement = img;
	        this.baseElement = img;
	        this.innerElem = img;
	        this.transformedElement = img;
	    }
	    img.src = assetPath;
	    if(this.data.ln){
	        this.innerElem.setAttribute('id',this.data.ln);
	    }
	    this.checkParenting();
	};
	
	HImageElement.prototype.show = HSolidElement.prototype.show;
	HImageElement.prototype.hide = HSolidElement.prototype.hide;
	HImageElement.prototype.renderFrame = HSolidElement.prototype.renderFrame;
	HImageElement.prototype.destroy = HSolidElement.prototype.destroy;
	function HCameraElement(data,parentContainer,globalData,comp, placeholder){
	    this._parent.constructor.call(this,data,parentContainer,globalData,comp, placeholder);
	    var getProp = PropertyFactory.getProp;
	    this.pe = getProp(this,data.pe,0,0,this.dynamicProperties);
	    if(data.ks.p.s){
	        this.px = getProp(this,data.ks.p.x,1,0,this.dynamicProperties);
	        this.py = getProp(this,data.ks.p.y,1,0,this.dynamicProperties);
	        this.pz = getProp(this,data.ks.p.z,1,0,this.dynamicProperties);
	    }else{
	        this.p = getProp(this,data.ks.p,1,0,this.dynamicProperties);
	    }
	    if(data.ks.a){
	        this.a = getProp(this,data.ks.a,1,0,this.dynamicProperties);
	    }
	    if(data.ks.or.k.length && data.ks.or.k[0].to){
	        var i,len = data.ks.or.k.length;
	        for(i=0;i<len;i+=1){
	            data.ks.or.k[i].to = null;
	            data.ks.or.k[i].ti = null;
	        }
	    }
	    this.or = getProp(this,data.ks.or,1,degToRads,this.dynamicProperties);
	    this.or.sh = true;
	    this.rx = getProp(this,data.ks.rx,0,degToRads,this.dynamicProperties);
	    this.ry = getProp(this,data.ks.ry,0,degToRads,this.dynamicProperties);
	    this.rz = getProp(this,data.ks.rz,0,degToRads,this.dynamicProperties);
	    this.mat = new Matrix();
	}
	createElement(HBaseElement, HCameraElement);
	
	HCameraElement.prototype.setup = function() {
	    var i, len = this.comp.threeDElements.length, comp;
	    for(i=0;i<len;i+=1){
	        //[perspectiveElem,container]
	        comp = this.comp.threeDElements[i];
	        comp.perspectiveElem.style.perspective = comp.perspectiveElem.style.webkitPerspective = this.pe.v+'px';
	        comp.container.style.transformOrigin = comp.container.style.mozTransformOrigin = comp.container.style.webkitTransformOrigin = "0px 0px 0px";
	        comp.perspectiveElem.style.transform = comp.perspectiveElem.style.webkitTransform = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
	    }
	};
	
	HCameraElement.prototype.createElements = function(){
	};
	
	HCameraElement.prototype.hide = function(){
	};
	
	HCameraElement.prototype.renderFrame = function(){
	    var mdf = this.firstFrame;
	    var i, len;
	    if(this.hierarchy){
	        len = this.hierarchy.length;
	        for(i=0;i<len;i+=1){
	            mdf = this.hierarchy[i].finalTransform.mProp.mdf ? true : mdf;
	        }
	    }
	    if(mdf || (this.p && this.p.mdf) || (this.px && (this.px.mdf || this.py.mdf || this.pz.mdf)) || this.rx.mdf || this.ry.mdf || this.rz.mdf || this.or.mdf || (this.a && this.a.mdf)) {
	        this.mat.reset();
	
	        if(this.p){
	            this.mat.translate(-this.p.v[0],-this.p.v[1],this.p.v[2]);
	        }else{
	            this.mat.translate(-this.px.v,-this.py.v,this.pz.v);
	        }
	        if(this.a){
	            var diffVector = [this.p.v[0]-this.a.v[0],this.p.v[1]-this.a.v[1],this.p.v[2]-this.a.v[2]];
	            var mag = Math.sqrt(Math.pow(diffVector[0],2)+Math.pow(diffVector[1],2)+Math.pow(diffVector[2],2));
	            //var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));
	            var lookDir = [diffVector[0]/mag,diffVector[1]/mag,diffVector[2]/mag];
	            var lookLengthOnXZ = Math.sqrt( lookDir[2]*lookDir[2] + lookDir[0]*lookDir[0] );
	            var m_rotationX = (Math.atan2( lookDir[1], lookLengthOnXZ ));
	            var m_rotationY = (Math.atan2( lookDir[0], -lookDir[2]));
	            this.mat.rotateY(m_rotationY).rotateX(-m_rotationX);
	
	        }
	        this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
	        this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
	        this.mat.translate(this.globalData.compSize.w/2,this.globalData.compSize.h/2,0);
	        this.mat.translate(0,0,this.pe.v);
	        if(this.hierarchy){
	            var mat;
	            len = this.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                mat = this.hierarchy[i].finalTransform.mProp.iv.props;
	                this.mat.transform(mat[0],mat[1],mat[2],mat[3],mat[4],mat[5],mat[6],mat[7],mat[8],mat[9],mat[10],mat[11],-mat[12],-mat[13],mat[14],mat[15]);
	            }
	        }
	        len = this.comp.threeDElements.length;
	        var comp;
	        for(i=0;i<len;i+=1){
	            comp = this.comp.threeDElements[i];
	            comp.container.style.transform = comp.container.style.webkitTransform = this.mat.toCSS();
	        }
	    }
	    this.firstFrame = false;
	};
	
	HCameraElement.prototype.destroy = function(){
	};
	var Expressions = (function(){
	    var ob = {};
	    ob.initExpressions = initExpressions;
	
	
	    function initExpressions(animation){
	        animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
	        animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
	    }
	   return ob;
	}());
	
	expressionsPlugin = Expressions;
	
	(function addPropertyDecorator() {
	
	    function getStaticValueAtTime() {
	        return this.pv;
	    }
	
	    function loopOut(type,duration,durationFlag){
	        if(!this.k || !this.keyframes){
	            return this.pv;
	        }
	        type = type.toLowerCase();
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var lastKeyFrame = keyframes[keyframes.length - 1].t;
	        if(currentFrame<=lastKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, firstKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,lastKeyFrame - this.elem.data.ip);
	                } else {
	                    cycleDuration = Math.abs(lastKeyFrame - elem.comp.globalData.frameRate*duration);
	                }
	                firstKeyFrame = lastKeyFrame - cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(iterations % 2 !== 0){
	                    return this.getValueAtTime(((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((currentFrame - firstKeyFrame)/cycleDuration);
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = (endV[i]-initV[i])*repeats + current[i];
	                    }
	                    return ret;
	                }
	                return (endV-initV)*repeats + current;
	            } else if(type === 'continue'){
	                var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(lastValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = lastValue[i] + (lastValue[i]-nextLastValue[i])*((currentFrame - lastKeyFrame)/ this.comp.globalData.frameRate)/0.0005;
	                    }
	                    return ret;
	                }
	                return lastValue + (lastValue-nextLastValue)*(((currentFrame - lastKeyFrame))/0.001);
	            }
	            return this.getValueAtTime((((currentFrame - firstKeyFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function loopIn(type,duration, durationFlag) {
	        if(!this.k){
	            return this.pv;
	        }
	        type = type.toLowerCase();
	        var currentFrame = this.comp.renderedFrame;
	        var keyframes = this.keyframes;
	        var firstKeyFrame = keyframes[0].t;
	        if(currentFrame>=firstKeyFrame){
	            return this.pv;
	        }else{
	            var cycleDuration, lastKeyFrame;
	            if(!durationFlag){
	                if(!duration || duration > keyframes.length - 1){
	                    duration = keyframes.length - 1;
	                }
	                lastKeyFrame = keyframes[duration].t;
	                cycleDuration = lastKeyFrame - firstKeyFrame;
	            } else {
	                if(!duration){
	                    cycleDuration = Math.max(0,this.elem.data.op - firstKeyFrame);
	                } else {
	                    cycleDuration = Math.abs(elem.comp.globalData.frameRate*duration);
	                }
	                lastKeyFrame = firstKeyFrame + cycleDuration;
	            }
	            var i, len, ret;
	            if(type === 'pingpong') {
	                var iterations = Math.floor((firstKeyFrame - currentFrame)/cycleDuration);
	                if(iterations % 2 === 0){
	                    return this.getValueAtTime((((firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	                }
	            } else if(type === 'offset'){
	                var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
	                var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame)%cycleDuration +  firstKeyFrame) / this.comp.globalData.frameRate, 0);
	                var repeats = Math.floor((firstKeyFrame - currentFrame)/cycleDuration)+1;
	                if(this.pv.length){
	                    ret = new Array(initV.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = current[i]-(endV[i]-initV[i])*repeats;
	                    }
	                    return ret;
	                }
	                return current-(endV-initV)*repeats;
	            } else if(type === 'continue'){
	                var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
	                var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);
	                if(this.pv.length){
	                    ret = new Array(firstValue.length);
	                    len = ret.length;
	                    for(i=0;i<len;i+=1){
	                        ret[i] = firstValue[i] + (firstValue[i]-nextFirstValue[i])*(firstKeyFrame - currentFrame)/0.001;
	                    }
	                    return ret;
	                }
	                return firstValue + (firstValue-nextFirstValue)*(firstKeyFrame - currentFrame)/0.001;
	            }
	            return this.getValueAtTime(((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration +  firstKeyFrame)) / this.comp.globalData.frameRate, 0);
	        }
	    }
	
	    function getValueAtTime(frameNum) {
	        if(!this._cachingAtTime) {
	            this._cachingAtTime = {lastValue:-99999,lastIndex:0};
	        }
	        if(frameNum !== this._cachingAtTime.lastFrame) {
	            frameNum *= this.elem.globalData.frameRate;
	            frameNum -= this.offsetTime;
	            var i = this._caching.lastFrame < frameNum ? this._caching.lastIndex : 0;
	            var interpolationResult = this.interpolateValue(frameNum, i, this.pv, this._cachingAtTime);
	            this._cachingAtTime.lastIndex = interpolationResult.iterationIndex;
	            this._cachingAtTime.value = interpolationResult.value;
	            this._cachingAtTime.lastFrame = frameNum;
	        }
	        return this._cachingAtTime.value;
	
	    }
	
	    function getVelocityAtTime(frameNum) {
	        if(this.vel !== undefined){
	            return this.vel;
	        }
	        var delta = -0.01;
	        //frameNum += this.elem.data.st;
	        var v1 = this.getValueAtTime(frameNum);
	        var v2 = this.getValueAtTime(frameNum + delta);
	        var velocity;
	        if(v1.length){
	            velocity = createTypedArray('float32', v1.length);
	            var i;
	            for(i=0;i<v1.length;i+=1){
	                //removing frameRate
	                //if needed, don't add it here
	                //velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
	                velocity[i] = (v2[i] - v1[i])/delta;
	            }
	        } else {
	            velocity = (v2 - v1)/delta;
	        }
	        return velocity;
	    };
	
	    function setGroupProperty(propertyGroup){
	        this.propertyGroup = propertyGroup;
	    }
	
	    function searchExpressions(elem,data,prop){
	        if(data.x){
	            prop.k = true;
	            prop.x = true;
	            if(prop.getValue) {
	                prop.getPreValue = prop.getValue;
	            }
	            prop.getValue = ExpressionManager.initiateExpression.bind(prop)(elem,data,prop);
	        }
	    }
	
	    function getTransformValueAtTime(time) {
	        //console.log('time:', time)
	    }
	
	    function getTransformStaticValueAtTime(time) {
	
	    }
	
	    var TextExpressionSelectorProp = (function(){
	
	        function getValueProxy(index,total){
	            this.textIndex = index+1;
	            this.textTotal = total;
	            this.getValue();
	            return this.v;
	        }
	
	        return function TextExpressionSelectorProp(elem,data){
	            this.pv = 1;
	            this.comp = elem.comp;
	            this.elem = elem;
	            this.mult = .01;
	            this.type = 'textSelector';
	            this.textTotal = data.totalChars;
	            this.selectorValue = 100;
	            this.lastValue = [1,1,1];
	            searchExpressions.bind(this)(elem,data,this);
	            this.getMult = getValueProxy;
	            this.getVelocityAtTime = getVelocityAtTime;
	            if(this.kf){
	                this.getValueAtTime = getValueAtTime.bind(this);
	            } else {
	                this.getValueAtTime = getStaticValueAtTime.bind(this);
	            }
	            this.setGroupProperty = setGroupProperty;
	        }
	    }());
	
	    var getTransformProperty = TransformPropertyFactory.getTransformProperty;
	    TransformPropertyFactory.getTransformProperty = function(elem, data, arr) {
	        var prop = getTransformProperty(elem, data, arr);
	        if(prop.dynamicProperties.length) {
	            prop.getValueAtTime = getTransformValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        return prop;
	    }
	
	    var propertyGetProp = PropertyFactory.getProp;
	    PropertyFactory.getProp = function(elem,data,type, mult, arr){
	        var prop = propertyGetProp(elem,data,type, mult, arr);
	        //prop.getVelocityAtTime = getVelocityAtTime;
	        //prop.loopOut = loopOut;
	        //prop.loopIn = loopIn;
	        if(prop.kf){
	            prop.getValueAtTime = getValueAtTime.bind(prop);
	        } else {
	            prop.getValueAtTime = getStaticValueAtTime.bind(prop);
	        }
	        prop.setGroupProperty = setGroupProperty;
	        prop.loopOut = loopOut;
	        prop.loopIn = loopIn;
	        prop.getVelocityAtTime = getVelocityAtTime;
	        prop.numKeys = data.a === 1 ? data.k.length : 0;
	        var isAdded = prop.k;
	        prop.propertyIndex = data.ix;
	        searchExpressions(elem,data,prop);
	        if(!isAdded && prop.x){
	            arr.push(prop);
	        }
	
	        return prop;
	    }
	
	    function getShapeValueAtTime(frameNum) {
	        if (!this._shapeValueAtTime) {
	            this._lastIndexAtTime = 0;
	            this._lastTimeAtTime = -999999;
	            this._shapeValueAtTime = shape_pool.clone(this.pv);
	        }
	        if(frameNum !== this._lastTimeAtTime) {
	            this._lastTimeAtTime = frameNum;
	            frameNum *= this.elem.globalData.frameRate;
	            var interpolationResult = this.interpolateShape(frameNum, this._lastIndexAtTime, this._shapeValueAtTime, false);
	            this._lastIndexAtTime = interpolationResult.iterationIndex;
	        }
	        return this._shapeValueAtTime;
	    }
	
	    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
	    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();
	
	    ShapePropertyConstructorFunction.prototype.vertices = function(prop, time){
	        var shapePath = this.v;
	        if(time !== undefined) {
	            shapePath = this.getValueAtTime(time, 0);
	        }
	        var i, len = shapePath._length;
	        var vertices = shapePath[prop];
	        var points = shapePath.v;
	        var arr = Array.apply(null,{length:len})
	        for(i = 0; i < len; i += 1) {
	            if(prop === 'i' || prop === 'o') {
	                arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]]
	            } else {
	                arr[i] = [vertices[i][0], vertices[i][1]]
	            }
	            
	        }
	        return arr;
	    }
	
	    ShapePropertyConstructorFunction.prototype.points = function(time){
	        return this.vertices('v', time);
	    }
	
	    ShapePropertyConstructorFunction.prototype.inTangents = function(time){
	        return this.vertices('i', time);
	    }
	
	    ShapePropertyConstructorFunction.prototype.outTangents = function(time){
	        return this.vertices('o', time);
	    }
	
	    ShapePropertyConstructorFunction.prototype.isClosed = function(){
	        return this.v.c;
	    }
	
	    ShapePropertyConstructorFunction.prototype.pointOnPath = function(perc, time){
	        var shapePath = this.v;
	        if(time !== undefined) {
	            shapePath = this.getValueAtTime(time, 0);
	        }
	        if(!this._segmentsLength) {
	            this._segmentsLength = bez.getSegmentsLength(shapePath);
	        }
	
	        var segmentsLength = this._segmentsLength;
	        var lengths = segmentsLength.lengths;
	        var lengthPos = segmentsLength.totalLength * perc;
	        var i = 0, len = lengths.length;
	        var j = 0, jLen;
	        var accumulatedLength = 0;
	        var segments;
	        while(i < len) {
	            if(accumulatedLength + lengths[i].addedLength > lengthPos) {
	                segments = lengths[i].segments;
	                var initIndex = i;
	                var endIndex = (shapePath.c && i === len - 1) ? 0 : i + 1;
	                var segmentPerc = (lengthPos - accumulatedLength)/lengths[i].addedLength;
	                var pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i])
	                break;
	            } else {
	                accumulatedLength += lengths[i].addedLength;
	            }
	            i += 1;
	        }
	        if(!pt){
	            pt = shapePath.c ? [shapePath.v[0][0],shapePath.v[0][1]]:[shapePath.v[shapePath._length-1][0],shapePath.v[shapePath._length-1][1]]
	        }
	        return pt;
	    }
	
	    ShapePropertyConstructorFunction.prototype.vectorOnPath = function(perc, time, vectorType){
	        //perc doesn't use triple equality because can be a Number object, not a primitive.
	        perc = perc == 1 ? this.v.c ? 0 : 0.999 : perc;
	        var pt1 = this.pointOnPath(perc, time);
	        var pt2 = this.pointOnPath(perc + 0.001, time);
	        var xLength = pt2[0] - pt1[0];
	        var yLength = pt2[1] - pt1[1];
	        var magnitude = Math.sqrt(Math.pow(xLength,2) + Math.pow(yLength,2));
	        var unitVector = vectorType === 'tangent' ? [xLength/magnitude, yLength/magnitude] : [-yLength/magnitude, xLength/magnitude];
	        return unitVector;
	    }
	
	    ShapePropertyConstructorFunction.prototype.tangentOnPath = function(perc, time){
	        return this.vectorOnPath(perc, time, 'tangent');
	    }
	
	    ShapePropertyConstructorFunction.prototype.normalOnPath = function(perc, time){
	        return this.vectorOnPath(perc, time, 'normal');
	    }
	
	    ShapePropertyConstructorFunction.prototype.setGroupProperty = setGroupProperty;
	    ShapePropertyConstructorFunction.prototype.getValueAtTime = getStaticValueAtTime;
	
	    KeyframedShapePropertyConstructorFunction.prototype.vertices = ShapePropertyConstructorFunction.prototype.vertices;
	    KeyframedShapePropertyConstructorFunction.prototype.points = ShapePropertyConstructorFunction.prototype.points;
	    KeyframedShapePropertyConstructorFunction.prototype.inTangents = ShapePropertyConstructorFunction.prototype.inTangents;
	    KeyframedShapePropertyConstructorFunction.prototype.outTangents = ShapePropertyConstructorFunction.prototype.outTangents;
	    KeyframedShapePropertyConstructorFunction.prototype.isClosed = ShapePropertyConstructorFunction.prototype.isClosed;
	    KeyframedShapePropertyConstructorFunction.prototype.pointOnPath = ShapePropertyConstructorFunction.prototype.pointOnPath;
	    KeyframedShapePropertyConstructorFunction.prototype.vectorOnPath = ShapePropertyConstructorFunction.prototype.vectorOnPath;
	    KeyframedShapePropertyConstructorFunction.prototype.tangentOnPath = ShapePropertyConstructorFunction.prototype.tangentOnPath;
	    KeyframedShapePropertyConstructorFunction.prototype.normalOnPath = ShapePropertyConstructorFunction.prototype.normalOnPath;
	    KeyframedShapePropertyConstructorFunction.prototype.setGroupProperty = ShapePropertyConstructorFunction.prototype.setGroupProperty;
	    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
	
	    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;
	    ShapePropertyFactory.getShapeProp = function(elem,data,type, arr, trims){
	        var prop = propertyGetShapeProp(elem,data,type, arr, trims);
	        var isAdded = prop.k;
	        prop.propertyIndex = data.ix;
	        if(type === 3){
	            searchExpressions(elem,data.pt,prop);
	        } else if(type === 4){
	            searchExpressions(elem,data.ks,prop);
	        }
	        if(!isAdded && prop.x){
	            arr.push(prop);
	        }
	        return prop;
	    }
	
	    var propertyGetTextProp = TextSelectorProp.getTextSelectorProp;
	    TextSelectorProp.getTextSelectorProp = function(elem, data,arr){
	        if(data.t === 1){
	            return new TextExpressionSelectorProp(elem, data,arr);
	        } else {
	            return propertyGetTextProp(elem,data,arr);
	        }
	    }
	}());
	(function addTextPropertyDecorator() {
	
	    function searchExpressions(){
	        if(this.data.d.x){
	            this.comp = this.elem.comp;
	            if(this.getValue) {
	                this.getPreValue = this.getValue;
	            }
	            this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem,this.data.d,this);
	            this.getValue = this.getExpressionValue;
	            return true;
	        }
	        return false;
	    }
	
	    TextProperty.prototype.searchProperty = function(){
	        this.kf = this.searchExpressions() || this.data.d.k.length > 1;
	        return this.kf;
	    }
	
	    TextProperty.prototype.getExpressionValue = function(num){
	        this.calculateExpression();
	        if(this.mdf) {
	            this.currentData.t = this.v.toString();
	            this.completeTextData(this.currentData);
	        }
	    }
	
	    TextProperty.prototype.searchExpressions = searchExpressions;
	    
	}());
	var ExpressionManager = (function(){
	    var ob = {};
	    var Math = BMMath;
	    var window = null;
	    var document = null;
	
	    function duplicatePropertyValue(value, mult){
	        mult = mult || 1;
	
	        if(typeof value === 'number'  || value instanceof Number){
	            return value*mult;
	        }else if(value.i){
	            return JSON.parse(JSON.stringify(value));
	        }else{
	            var arr = createTypedArray('int16', value.length);
	            var i, len = value.length;
	            for(i=0;i<len;i+=1){
	                arr[i]=value[i]*mult;
	            }
	            return arr;
	        }
	    }
	
	    function isTypeOfArray(arr) {
	        return arr.constructor === Array || arr.constructor === Float32Array;
	    }
	
	    function shapesEqual(shape1, shape2) {
	        if(shape1._length !== shape2._length || shape1.c !== shape2.c){
	            return false;
	        }
	        var i, len = shape1._length;
	        for(i = 0; i < len; i += 1) {
	            if(shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1]
	                || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1]
	                || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]){
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function $bm_neg(a){
	        var tOfA = typeof a;
	        if(tOfA === 'number' || tOfA === 'boolean'  || a instanceof Number ){
	            return -a;
	        }
	        if(isTypeOfArray(a)){
	            var i, lenA = a.length;
	            var retArr = [];
	            for(i=0;i<lenA;i+=1){
	                retArr[i] = -a[i];
	            }
	            return retArr;
	        }
	    }
	
	    function sum(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if(tOfA === 'string' || tOfB === 'string'){
	            return a + b;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string'  || b instanceof Number)) {
	            return a + b;
	        }
	        if(isTypeOfArray(a) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            a[0] = a[0] + b;
	            return a;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && isTypeOfArray(b)){
	            b[0] = a + b[0];
	            return b;
	        }
	        if(isTypeOfArray(a) && isTypeOfArray(b)){
	            
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] + b[i];
	                }else{
	                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	    var add = sum;
	
	    function sub(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            if(tOfA === 'string') {
	                a = parseInt(a);
	            }
	            if(tOfB === 'string') {
	                b = parseInt(b);
	            }
	            return a - b;
	        }
	        if( isTypeOfArray(a) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            a[0] = a[0] - b;
	            return a;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) &&  isTypeOfArray(b)){
	            b[0] = a - b[0];
	            return b;
	        }
	        if(isTypeOfArray(a) && isTypeOfArray(b)){
	            var i = 0, lenA = a.length, lenB = b.length;
	            var retArr = [];
	            while(i<lenA || i < lenB){
	                if((typeof a[i] === 'number' || a[i] instanceof Number) && typeof (typeof b[i] === 'number' || b[i] instanceof Number)){
	                    retArr[i] = a[i] - b[i];
	                }else{
	                    retArr[i] = b[i] == undefined ? a[i] : a[i] || b[i];
	                }
	                i += 1;
	            }
	            return retArr;
	        }
	        return 0;
	    }
	
	    function mul(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            return a * b;
	        }
	
	        var i, len;
	        if(isTypeOfArray(a) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] * b;
	            }
	            return arr;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && isTypeOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a * b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	
	    function div(a,b) {
	        var tOfA = typeof a;
	        var tOfB = typeof b;
	        var arr;
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number )) {
	            return a / b;
	        }
	        var i, len;
	        if(isTypeOfArray(a) && (tOfB === 'number' || tOfB === 'boolean' || tOfB === 'string' || b instanceof Number  )){
	            len = a.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a[i] / b;
	            }
	            return arr;
	        }
	        if((tOfA === 'number' || tOfA === 'boolean' || tOfA === 'string' || a instanceof Number ) && isTypeOfArray(b)){
	            len = b.length;
	            arr = createTypedArray('float32', len);
	            for(i=0;i<len;i+=1){
	                arr[i] = a / b[i];
	            }
	            return arr;
	        }
	        return 0;
	    }
	    function mod(a,b) {
	        if(typeof a === 'string') {
	            a = parseInt(a);
	        }
	        if(typeof b === 'string') {
	            b = parseInt(b);
	        }
	        return a % b;
	    }
	
	    function clamp(num, min, max) {
	        if(min > max){
	            var mm = max;
	            max = min;
	            min = mm;
	        }
	        return Math.min(Math.max(num, min), max);
	    }
	
	    function radiansToDegrees(val) {
	        return val/degToRads;
	    }
	    var radians_to_degrees = radiansToDegrees;
	
	    function degreesToRadians(val) {
	        return val*degToRads;
	    }
	    var degrees_to_radians = radiansToDegrees;
	
	    var helperLengthArray = [0,0,0,0,0,0];
	
	    function length(arr1,arr2){
	        if(typeof arr1 === 'number' || arr1 instanceof Number){
	            arr2 = arr2 || 0;
	            return Math.abs(arr1 - arr2);
	        }
	        if(!arr2){
	            arr2 = helperLengthArray;
	        }
	        var i,len = Math.min(arr1.length,arr2.length);
	        var addedLength = 0;
	        for(i=0;i<len;i+=1){
	            addedLength += Math.pow(arr2[i]-arr1[i],2);
	        }
	        return Math.sqrt(addedLength);
	    }
	
	    function normalize(vec){
	        return div(vec, length(vec));
	    }
	
	    function rgbToHsl(val){
	        var r = val[0]; var g = val[1]; var b = val[2];
	        var max = Math.max(r, g, b), min = Math.min(r, g, b);
	        var h, s, l = (max + min) / 2;
	
	        if(max == min){
	            h = s = 0; // achromatic
	        }else{
	            var d = max - min;
	            s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	            switch(max){
	                case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	                case g: h = (b - r) / d + 2; break;
	                case b: h = (r - g) / d + 4; break;
	            }
	            h /= 6;
	        }
	
	        return [h, s, l,val[3]];
	    }
	    function hslToRgb(val){
	        var h = val[0];
	        var s = val[1];
	        var l = val[2];
	
	        var r, g, b;
	
	        if(s == 0){
	            r = g = b = l; // achromatic
	        }else{
	            function hue2rgb(p, q, t){
	                if(t < 0) t += 1;
	                if(t > 1) t -= 1;
	                if(t < 1/6) return p + (q - p) * 6 * t;
	                if(t < 1/2) return q;
	                if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	                return p;
	            }
	
	            var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	            var p = 2 * l - q;
	            r = hue2rgb(p, q, h + 1/3);
	            g = hue2rgb(p, q, h);
	            b = hue2rgb(p, q, h - 1/3);
	        }
	
	        return [r, g , b, val[3]];
	    }
	
	    function linear(t, tMin, tMax, value1, value2){
	        if(value1 === undefined || value2 === undefined){
	            return linear(t,0,1,tMin,tMax);
	        }
	        if(t <= tMin) {
	            return value1;
	        }else if(t >= tMax){
	            return value2;
	        }
	        var perc = tMax === tMin ? 0 : (t-tMin)/(tMax-tMin);
	        if(!value1.length){
	            return value1 + (value2-value1)*perc;
	        }
	        var i, len = value1.length;
	        var arr = createTypedArray('float32', len);
	        for(i=0;i<len;i+=1){
	            arr[i] = value1[i] + (value2[i]-value1[i])*perc;
	        }
	        return arr;
	    }
	    function random(min,max){
	        if(max === undefined){
	            if(min === undefined){
	                min = 0;
	                max = 1;
	            } else {
	                max = min;
	                min = undefined;
	            }
	        }
	        if(max.length){
	            var i, len = max.length;
	            if(!min){
	                min = createTypedArray('float32', len);
	            }
	            var arr = createTypedArray('float32', len);
	            var rnd = BMMath.random();
	            for(i=0;i<len;i+=1){
	                arr[i] = min[i] + rnd*(max[i]-min[i])
	            }
	            return arr;
	        }
	        if(min === undefined){
	            min = 0;
	        }
	        var rndm = BMMath.random();
	        return min + rndm*(max-min);
	    }
	
	    function createPath(points, inTangents, outTangents, closed) {
	        inTangents = inTangents && inTangents.length ? inTangents : points;
	        outTangents = outTangents && outTangents.length ? outTangents : points;
	        var path = shape_pool.newShape();
	        var len = points.length;
	        path.setPathData(closed, len);
	        for(i = 0; i < len; i += 1) {
	            path.setTripleAt(points[i][0],points[i][1],outTangents[i][0] + points[i][0],outTangents[i][1] + points[i][1],inTangents[i][0] + points[i][0],inTangents[i][1] + points[i][1],i,true)
	        }
	        return path
	    }
	
	    function initiateExpression(elem,data,property){
	        var val = data.x;
	        var needsVelocity = /velocity(?![\w\d])/.test(val);
	        var _needsRandom = val.indexOf('random') !== -1;
	        var elemType = elem.data.ty;
	        var transform,content,effect;
	        var thisComp = elem.comp;
	        var thisProperty = property;
	        elem.comp.frameDuration = 1/elem.comp.globalData.frameRate;
	        var inPoint = elem.data.ip/elem.comp.globalData.frameRate;
	        var outPoint = elem.data.op/elem.comp.globalData.frameRate;
	        var width = elem.data.sw ? elem.data.sw : 0;
	        var height = elem.data.sh ? elem.data.sh : 0;
	        var loopIn, loop_in, loopOut, loop_out;
	        var toWorld,fromWorld,fromComp,fromCompToSurface,anchorPoint,thisLayer,thisComp,mask,valueAtTime,velocityAtTime;
	        var fn = new Function();
	        //var fnStr = 'var fn = function(){'+val+';this.v = $bm_rt;}';
	        //eval(fnStr);
	
	        var fn = eval('[function(){' + val+';if($bm_rt.__shapeObject){this.v=shape_pool.clone($bm_rt.v);}else{this.v=$bm_rt;}}' + ']')[0];
	        var bindedFn = fn.bind(this);
	        var numKeys = property.kf ? data.k.length : 0;
	
	        var wiggle = function wiggle(freq,amp){
	            var i,j, len = this.pv.length ? this.pv.length : 1;
	            var addedAmps = createTypedArray('float32', len);
	            freq = 5;
	            var iterations = Math.floor(time*freq);
	            i = 0;
	            j = 0;
	            while(i<iterations){
	                //var rnd = BMMath.random();
	                for(j=0;j<len;j+=1){
	                    addedAmps[j] += -amp + amp*2*BMMath.random();
	                    //addedAmps[j] += -amp + amp*2*rnd;
	                }
	                i += 1;
	            }
	            //var rnd2 = BMMath.random();
	            var periods = time*freq;
	            var perc = periods - Math.floor(periods);
	            var arr = createTypedArray('float32', len);
	            if(len>1){
	                for(j=0;j<len;j+=1){
	                    arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*BMMath.random())*perc;
	                    //arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
	                    //arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
	                }
	                return arr;
	            } else {
	                return this.pv + addedAmps[0] + (-amp + amp*2*BMMath.random())*perc;
	            }
	        }.bind(this);
	
	        if(thisProperty.loopIn) {
	            loopIn = thisProperty.loopIn.bind(thisProperty);
	            loop_in = loopIn;
	        }
	
	        if(thisProperty.loopOut) {
	            loopOut = thisProperty.loopOut.bind(thisProperty);
	            loop_out = loopOut;
	        }
	
	        var loopInDuration = function loopInDuration(type,duration){
	            return loopIn(type,duration,true);
	        }.bind(this);
	
	        var loopOutDuration = function loopOutDuration(type,duration){
	            return loopOut(type,duration,true);
	        }.bind(this);
	
	        if(this.getValueAtTime) {
	            valueAtTime = this.getValueAtTime.bind(this);
	        }
	
	        if(this.getVelocityAtTime) {
	            velocityAtTime = this.getVelocityAtTime.bind(this);
	        }
	
	        var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);
	
	        function lookAt(elem1,elem2){
	            var fVec = [elem2[0]-elem1[0],elem2[1]-elem1[1],elem2[2]-elem1[2]];
	            var pitch = Math.atan2(fVec[0],Math.sqrt(fVec[1]*fVec[1]+fVec[2]*fVec[2]))/degToRads;
	            var yaw = -Math.atan2(fVec[1],fVec[2])/degToRads;
	            return [yaw,pitch,0];
	        };
	
	        function easeOut(t, tMin, tMax, val1, val2){
	            if(val1 === undefined){
	                val1 = tMin;
	                val2 = tMax;
	            } else {
	                t = (t - tMin) / (tMax - tMin);
	            }
	            return -(val2-val1) * t*(t-2) + val1;
	        };
	
	        function easeIn(t, tMin, tMax, val1, val2){
	            if(val1 === undefined){
	                val1 = tMin;
	                val2 = tMax;
	            } else {
	                t = (t - tMin) / (tMax - tMin);
	            }
	            return (val2-val1)*t*t + val1;
	        };
	
	        function nearestKey(time){
	            var i, len = data.k.length,index,keyTime;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                index = 0;
	                keyTime = 0;
	            } else {
	                index = -1;
	                time *= elem.comp.globalData.frameRate;
	                if (time < data.k[0].t) {
	                    index = 1;
	                    keyTime = data.k[0].t;
	                } else {
	                    for(i=0;i<len-1;i+=1){
	                        if(time === data.k[i].t){
	                            index = i + 1;
	                            keyTime = data.k[i].t;
	                            break;
	                        }else if(time>data.k[i].t && time<data.k[i+1].t){
	                            if(time-data.k[i].t > data.k[i+1].t - time){
	                                index = i + 2;
	                                keyTime = data.k[i+1].t;
	                            } else {
	                                index = i + 1;
	                                keyTime = data.k[i].t;
	                            }
	                            break;
	                        }
	                    }
	                    if(index === -1){
	                        index = i + 1;
	                        keyTime = data.k[i].t;
	                    }
	                }
	                
	            }
	            var ob = {};
	            ob.index = index;
	            ob.time = keyTime/elem.comp.globalData.frameRate;
	            return ob;
	        };
	
	        function key(ind){
	            var ob, i, len;
	            if(!data.k.length || typeof(data.k[0]) === 'number'){
	                throw new Error('The property has no keyframe at index ' + ind);
	            }
	            ind -= 1;
	            ob = {
	                time: data.k[ind].t/elem.comp.globalData.frameRate
	            };
	            var arr;
	            if(ind === data.k.length - 1 && !data.k[ind].h){
	                arr = data.k[ind-1].e;
	            }else{
	                arr = data.k[ind].s;
	            }
	            len = arr.length;
	            for(i=0;i<len;i+=1){
	                ob[i] = arr[i];
	            }
	            return ob;
	        };
	
	        function framesToTime(frames,fps){
	            if(!fps){
	                fps = elem.comp.globalData.frameRate;
	            }
	            return frames/fps;
	        };
	
	        function timeToFrames(t,fps){
	            if(!t && t !== 0){
	                t = time;
	            }
	            if(!fps){
	                fps = elem.comp.globalData.frameRate;
	            }
	            return t*fps;
	        };
	
	        function seedRandom(seed){
	            BMMath.seedrandom(randSeed + seed);
	        };
	
	        function sourceRectAtTime() {
	            return elem.sourceRectAtTime();
	        }
	
	        var time,velocity, value,textIndex,textTotal,selectorValue;
	        var index = elem.data.ind;
	        var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	        var parent;
	        var randSeed = Math.floor(Math.random()*1000000);
	        function executeExpression(){
	            if(_needsRandom){
	                seedRandom(randSeed);
	            }
	            if(this.frameExpressionId === elem.globalData.frameId && this.type !== 'textSelector'){
	                return;
	            }
	            if(this.lock){
	                this.v = duplicatePropertyValue(this.pv,this.mult);
	                return true;
	            }
	            if(this.type === 'textSelector'){
	                textIndex = this.textIndex;
	                textTotal = this.textTotal;
	                selectorValue = this.selectorValue;
	            }
	            if(!thisLayer){
	                thisLayer = elem.layerInterface;
	                thisComp = elem.comp.compInterface;
	                toWorld = thisLayer.toWorld.bind(thisLayer);
	                fromWorld = thisLayer.fromWorld.bind(thisLayer);
	                fromComp = thisLayer.fromComp.bind(thisLayer);
	                mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer):null;
	                fromCompToSurface = fromComp;
	            }
	            if(!transform){
	                transform = elem.layerInterface("ADBE Transform Group");
	                anchorPoint = transform.anchorPoint;
	            }
	            
	            if(elemType === 4 && !content){
	                content = thisLayer("ADBE Root Vectors Group");
	            }
	            if(!effect){
	                effect = thisLayer(4);
	            }
	            hasParent = !!(elem.hierarchy && elem.hierarchy.length);
	            if(hasParent && !parent){
	                parent = elem.hierarchy[0].layerInterface;
	            }
	            this.lock = true;
	            if(this.getPreValue){
	                this.getPreValue();
	            }
	            value = this.pv;
	            time = this.comp.renderedFrame/this.comp.globalData.frameRate;
	            if(needsVelocity){
	                velocity = velocityAtTime(time);
	            }
	            bindedFn();
	            this.frameExpressionId = elem.globalData.frameId;
	            var i,len;
	            if(this.mult){
	                if(typeof this.v === 'number' || this.v instanceof Number || this.v instanceof String || typeof this.v === 'string'){
	                    this.v *= this.mult;
	                }else if(this.v.length === 1){
	                    this.v = this.v[0] * this.mult;
	                }else{
	                    len = this.v.length;
	                    if(value === this.v){
	                        this.v = len === 2 ? [value[0],value[1]] : [value[0],value[1],value[2]];
	                    }
	                    for(i = 0; i < len; i += 1){
	                        this.v[i] *= this.mult;
	                    }
	                }
	            }
	            if(this.v.length === 1){
	                this.v = this.v[0];
	            }
	            if(typeof this.v === 'number' || this.v instanceof Number || this.v instanceof String || typeof this.v === 'string'){
	                if(this.lastValue !== this.v){
	                    this.lastValue = this.v;
	                    this.mdf = true;
	                }
	            }else if( this.v._length){
	                if(!shapesEqual(this.v,this.localShapeCollection.shapes[0])){
	                    this.mdf = true;
	                    this.localShapeCollection.releaseShapes();
	                    this.localShapeCollection.addShape(shape_pool.clone(this.v));
	                }
	            }else{
	                len = this.v.length;
	                for(i = 0; i < len; i += 1){
	                    if(this.v[i] !== this.lastValue[i]){
	                        this.lastValue[i] = this.v[i];
	                        this.mdf = true;
	                    }
	                }
	            }
	            this.lock = false;
	        }
	        return executeExpression;
	    };
	
	    ob.initiateExpression = initiateExpression;
	    return ob;
	}());
	var ShapeExpressionInterface = (function(){
	    var ob = {
	        createShapeInterface:createShapeInterface,
	        createGroupInterface:createGroupInterface,
	        createTrimInterface:createTrimInterface,
	        createStrokeInterface:createStrokeInterface,
	        createTransformInterface:createTransformInterface,
	        createEllipseInterface:createEllipseInterface,
	        createStarInterface:createStarInterface,
	        createRectInterface:createRectInterface,
	        createRoundedInterface:createRoundedInterface,
	        createRepatearInterface:createRepatearInterface,
	        createPathInterface:createPathInterface,
	        createFillInterface:createFillInterface
	    };
	    function createShapeInterface(shapes,view,propertyGroup){
	        return shapeInterfaceFactory(shapes,view,propertyGroup);
	    }
	    function createGroupInterface(shapes,view,propertyGroup){
	        return groupInterfaceFactory(shapes,view,propertyGroup);
	    }
	    function createFillInterface(shape,view,propertyGroup){
	        return fillInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createStrokeInterface(shape,view,propertyGroup){
	        return strokeInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createTrimInterface(shape,view,propertyGroup){
	        return trimInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createTransformInterface(shape,view,propertyGroup){
	        return transformInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createEllipseInterface(shape,view,propertyGroup){
	        return ellipseInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createStarInterface(shape,view,propertyGroup){
	        return starInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRectInterface(shape,view,propertyGroup){
	        return rectInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRoundedInterface(shape,view,propertyGroup){
	        return roundedInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createRepatearInterface(shape,view,propertyGroup){
	        return repeaterInterfaceFactory(shape,view,propertyGroup);
	    }
	    function createPathInterface(shape,view,propertyGroup){
	        return pathInterfaceFactory(shape,view,propertyGroup);
	    }
	
	    function iterateElements(shapes,view, propertyGroup){
	        var arr = [];
	        var i, len = shapes ? shapes.length : 0;
	        for(i=0;i<len;i+=1){
	            if(shapes[i].ty == 'gr'){
	                arr.push(ShapeExpressionInterface.createGroupInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'fl'){
	                arr.push(ShapeExpressionInterface.createFillInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'st'){
	                arr.push(ShapeExpressionInterface.createStrokeInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tm'){
	                arr.push(ShapeExpressionInterface.createTrimInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'tr'){
	                //arr.push(ShapeExpressionInterface.createTransformInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'el'){
	                arr.push(ShapeExpressionInterface.createEllipseInterface(shapes[i],view[i],propertyGroup));
	            }else if(shapes[i].ty == 'sr'){
	                arr.push(ShapeExpressionInterface.createStarInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'sh'){
	                arr.push(ShapeExpressionInterface.createPathInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rc'){
	                arr.push(ShapeExpressionInterface.createRectInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rd'){
	                arr.push(ShapeExpressionInterface.createRoundedInterface(shapes[i],view[i],propertyGroup));
	            } else if(shapes[i].ty == 'rp'){
	                arr.push(ShapeExpressionInterface.createRepatearInterface(shapes[i],view[i],propertyGroup));
	            } else{
	                //console.log(shapes[i].ty);
	            }
	        }
	        return arr;
	    }
	
	    var shapeInterfaceFactory = (function(){
	        return function(shapes,view,propertyGroup){
	            var interfaces;
	            function _interfaceFunction(value){
	                if(typeof value === 'number'){
	                    return interfaces[value-1];
	                } else {
	                    var i = 0, len = interfaces.length;
	                    while(i<len){
	                        if(interfaces[i]._name === value){
	                            return interfaces[i];
	                        }
	                        i+=1;
	                    }
	                }
	            }
	            _interfaceFunction.propertyGroup = propertyGroup;
	            interfaces = iterateElements(shapes, view, _interfaceFunction);
	            return _interfaceFunction;
	        }
	    }());
	
	    var contentsInterfaceFactory = (function(){
	       return function(shape,view, propertyGroup){
	           var interfaces;
	           var interfaceFunction = function _interfaceFunction(value){
	               var i = 0, len = interfaces.length;
	                while(i<len){
	                    if(interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value){
	                       return interfaces[i];
	                    }
	                    i+=1;
	                }
	                if(typeof value === 'number'){
	                   return interfaces[value-1];
	                }
	           };
	           interfaceFunction.propertyGroup = function(val){
	               if(val === 1){
	                   return interfaceFunction;
	               } else{
	                   return propertyGroup(val-1);
	               }
	           };
	           interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
	           interfaceFunction.numProperties = interfaces.length;
	           interfaceFunction.propertyIndex = shape.cix;
	
	           return interfaceFunction;
	       }
	    }());
	
	    var groupInterfaceFactory = (function(){
	        return function(shape,view, propertyGroup){
	            var interfaceFunction = function _interfaceFunction(value){
	                switch(value){
	                    case 'ADBE Vectors Group':
	                    case 'Contents':
	                    case 2:
	                        return interfaceFunction.content;
	                    case 'ADBE Vector Transform Group':
	                    case 3:
	                    default:
	                        return interfaceFunction.transform;
	                }
	            }
	            interfaceFunction.propertyGroup = function(val){
	                if(val === 1){
	                    return interfaceFunction;
	                } else{
	                    return propertyGroup(val-1);
	                }
	            };
	            var content = contentsInterfaceFactory(shape,view,interfaceFunction.propertyGroup);
	            var transformInterface = ShapeExpressionInterface.createTransformInterface(shape.it[shape.it.length - 1],view.it[view.it.length - 1],interfaceFunction.propertyGroup);
	            interfaceFunction.content = content;
	            interfaceFunction.transform = transformInterface;
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            //interfaceFunction.content = interfaceFunction;
	            interfaceFunction.numProperties = shape.np;
	            interfaceFunction.propertyIndex = shape.ix;
	            interfaceFunction.nm = shape.nm;
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var fillInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	
	            function interfaceFunction(val){
	                if(val === 'Color' || val === 'color'){
	                    return interfaceFunction.color;
	                } else if(val === 'Opacity' || val === 'opacity'){
	                    return interfaceFunction.opacity;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'color', {
	                get: function(){
	                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.o, 100);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	
	            view.c.setGroupProperty(propertyGroup);
	            view.o.setGroupProperty(propertyGroup);
	            return interfaceFunction;
	        }
	    }());
	
	    var strokeInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val === 1){
	                    return ob;
	                } else{
	                    return propertyGroup(val-1);
	                }
	            };
	            function _dashPropertyGroup(val){
	                if(val === 1){
	                    return dashOb;
	                } else{
	                    return _propertyGroup(val-1);
	                }
	            };
	            function addPropertyToDashOb(i) {
	                Object.defineProperty(dashOb, shape.d[i].nm, {
	                    get: function(){
	                        return ExpressionValue(view.d.dataProps[i].p)
	                    }
	                });
	            }
	            var i, len = shape.d ? shape.d.length : 0;
	            var dashOb = {}
	            for (i = 0; i < len; i += 1) {
	                addPropertyToDashOb(i);
	                view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
	            }
	
	            function interfaceFunction(val){
	                if(val === 'Color' || val === 'color'){
	                    return interfaceFunction.color;
	                } else if(val === 'Opacity' || val === 'opacity'){
	                    return interfaceFunction.opacity;
	                } else if(val === 'Stroke Width' || val === 'stroke width'){
	                    return interfaceFunction.strokeWidth;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'color', {
	                get: function(){
	                    return ExpressionValue(view.c, 1 / view.c.mult, 'color');
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.o, 100);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'strokeWidth', {
	                get: function(){
	                    return ExpressionValue(view.w);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'dash', {
	                get: function(){
	                    return dashOb;
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	
	            view.c.setGroupProperty(_propertyGroup);
	            view.o.setGroupProperty(_propertyGroup);
	            view.w.setGroupProperty(_propertyGroup);
	            return interfaceFunction;
	        }
	    }());
	
	    var trimInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	
	            view.s.setGroupProperty(_propertyGroup);
	            view.e.setGroupProperty(_propertyGroup);
	            view.o.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(val){
	                if(val === shape.e.ix || val === 'End' || val === 'end'){
	                    return interfaceFunction.end;
	                }
	                if(val === shape.s.ix){
	                    return interfaceFunction.start;
	                }
	                if(val === shape.o.ix){
	                    return interfaceFunction.offset;
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	            Object.defineProperty(interfaceFunction, 'start', {
	                get: function(){
	                    return ExpressionValue(view.s, 1 / view.s.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'end', {
	                get: function(){
	                    return ExpressionValue(view.e, 1 / view.e.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'offset', {
	                get: function(){
	                    return ExpressionValue(view.o);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var transformInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            view.transform.mProps.o.setGroupProperty(_propertyGroup);
	            view.transform.mProps.p.setGroupProperty(_propertyGroup);
	            view.transform.mProps.a.setGroupProperty(_propertyGroup);
	            view.transform.mProps.s.setGroupProperty(_propertyGroup);
	            view.transform.mProps.r.setGroupProperty(_propertyGroup);
	            if(view.transform.mProps.sk){
	                view.transform.mProps.sk.setGroupProperty(_propertyGroup);
	                view.transform.mProps.sa.setGroupProperty(_propertyGroup);
	            }
	            view.transform.op.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.a.ix === value){
	                    return interfaceFunction.anchorPoint;
	                }
	                if(shape.o.ix === value){
	                    return interfaceFunction.opacity;
	                }
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.rotation;
	                }
	                if(shape.s.ix === value){
	                    return interfaceFunction.scale;
	                }
	                if(shape.sk && shape.sk.ix === value){
	                    return interfaceFunction.skew;
	                }
	                if(shape.sa && shape.sa.ix === value){
	                    return interfaceFunction.skewAxis;
	                }
	                if(value === 'Opacity') {
	                    return interfaceFunction.opacity;
	                }
	                if(value === 'Position') {
	                    return interfaceFunction.position;
	                }
	                if(value === 'Anchor Point') {
	                    return interfaceFunction.anchorPoint;
	                }
	                if(value === 'Scale') {
	                    return interfaceFunction.scale;
	                }
	                if(value === 'Rotation' || value === 'ADBE Vector Rotation') {
	                    return interfaceFunction.rotation;
	                }
	                if(value === 'Skew') {
	                    return interfaceFunction.skew;
	                }
	                if(value === 'Skew Axis') {
	                    return interfaceFunction.skewAxis;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'opacity', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.o, 1/view.transform.mProps.o.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'anchorPoint', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.a);
	                }
	            });
	            var scaleArray = [];
	            Object.defineProperty(interfaceFunction, 'scale', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.s, 1 / view.transform.mProps.s.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'rotation', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.r, 1 / view.transform.mProps.r.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'skew', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.sk);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'skewAxis', {
	                get: function(){
	                    return ExpressionValue(view.transform.mProps.sa);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.ty = 'tr';
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var ellipseInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            interfaceFunction.propertyIndex = shape.ix;
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            prop.s.setGroupProperty(_propertyGroup);
	            prop.p.setGroupProperty(_propertyGroup);
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.s.ix === value){
	                    return interfaceFunction.size;
	                }
	            }
	            Object.defineProperty(interfaceFunction, 'size', {
	                get: function(){
	                    return ExpressionValue(prop.s);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var starInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.or.setGroupProperty(_propertyGroup);
	            prop.os.setGroupProperty(_propertyGroup);
	            prop.pt.setGroupProperty(_propertyGroup);
	            prop.p.setGroupProperty(_propertyGroup);
	            prop.r.setGroupProperty(_propertyGroup);
	            if(shape.ir){
	                prop.ir.setGroupProperty(_propertyGroup);
	                prop.is.setGroupProperty(_propertyGroup);
	            }
	
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.rotation;
	                }
	                if(shape.pt.ix === value){
	                    return interfaceFunction.points;
	                }
	                if(shape.or.ix === value || 'ADBE Vector Star Outer Radius' === value){
	                    return interfaceFunction.outerRadius;
	                }
	                if(shape.os.ix === value){
	                    return interfaceFunction.outerRoundness;
	                }
	                if(shape.ir && (shape.ir.ix === value || 'ADBE Vector Star Inner Radius' === value)){
	                    return interfaceFunction.innerRadius;
	                }
	                if(shape.is && shape.is.ix === value){
	                    return interfaceFunction.innerRoundness;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'rotation', {
	                get: function(){
	                    return ExpressionValue(prop.r, 1 / prop.r.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'points', {
	                get: function(){
	                    return ExpressionValue(prop.pt);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'outerRadius', {
	                get: function(){
	                    return ExpressionValue(prop.or);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'outerRoundness', {
	                get: function(){
	                    return ExpressionValue(prop.os);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'innerRadius', {
	                get: function(){
	                    if(!prop.ir){
	                        return 0;
	                    }
	                    return ExpressionValue(prop.ir);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'innerRoundness', {
	                get: function(){
	                    if(!prop.is){
	                        return 0;
	                    }
	                    return ExpressionValue(prop.is, 1 / prop.is.mult);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var rectInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.p.setGroupProperty(_propertyGroup);
	            prop.s.setGroupProperty(_propertyGroup);
	            prop.r.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.p.ix === value){
	                    return interfaceFunction.position;
	                }
	                if(shape.r.ix === value){
	                    return interfaceFunction.roundness;
	                }
	                if(shape.s.ix === value || value === 'Size'){
	                    return interfaceFunction.size;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'position', {
	                get: function(){
	                    return ExpressionValue(prop.p);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'roundness', {
	                get: function(){
	                    return ExpressionValue(prop.r);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'size', {
	                get: function(){
	                    return ExpressionValue(prop.s);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var roundedInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.rd.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.r.ix === value || 'Round Corners 1' === value){
	                    return interfaceFunction.radius;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'radius', {
	                get: function(){
	                    return ExpressionValue(prop.rd);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var repeaterInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            var prop = view;
	            interfaceFunction.propertyIndex = shape.ix;
	            prop.c.setGroupProperty(_propertyGroup);
	            prop.o.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(value){
	                if(shape.c.ix === value || 'Copies' === value){
	                    return interfaceFunction.copies;
	                } else if(shape.o.ix === value || 'Offset' === value){
	                    return interfaceFunction.offset;
	                }
	
	            }
	            Object.defineProperty(interfaceFunction, 'copies', {
	                get: function(){
	                    return ExpressionValue(prop.c);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, 'offset', {
	                get: function(){
	                    return ExpressionValue(prop.o);
	                }
	            });
	
	            Object.defineProperty(interfaceFunction, '_name', {
	                get: function(){
	                    return shape.nm;
	                }
	            });
	            interfaceFunction.mn = shape.mn;
	            return interfaceFunction;
	        }
	    }());
	
	    var pathInterfaceFactory = (function(){
	        return function(shape,view,propertyGroup){
	            var prop = view.sh;
	            function _propertyGroup(val){
	                if(val == 1){
	                    return interfaceFunction;
	                } else {
	                    return propertyGroup(--val);
	                }
	            }
	            prop.setGroupProperty(_propertyGroup);
	
	            function interfaceFunction(val){
	                if(val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2){
	                    return interfaceFunction.path;
	                }
	            }
	
	            Object.defineProperty(interfaceFunction, 'path', {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                    //return shape_pool.clone(prop.v);
	                }
	            });
	            Object.defineProperty(interfaceFunction, 'shape', {
	                get: function(){
	                    if(prop.k){
	                        prop.getValue();
	                    }
	                    return prop;
	                    //return shape_pool.clone(prop.v);
	                }
	            });
	            Object.defineProperty(interfaceFunction, '_name', { value: shape.nm });
	            Object.defineProperty(interfaceFunction, 'ix', { value: shape.ix });
	            Object.defineProperty(interfaceFunction, 'mn', { value: shape.mn });
	            return interfaceFunction;
	        }
	    }());
	
	
	    return ob;
	}())
	
	var TextExpressionInterface = (function(){
		return function(elem){
	        var _prevValue, _sourceText;
	        function _thisLayerFunction(){
	        }
	        Object.defineProperty(_thisLayerFunction, "sourceText", {
	            get: function(){
	                var stringValue = elem.textProperty.currentData.t;
	                if(elem.textProperty.currentData.t !== _prevValue) {
	                    elem.textProperty.currentData.t = _prevValue;
	                    _sourceText = new String(stringValue);
	                    //If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive
	                    _sourceText.value = stringValue ? stringValue : new String(stringValue);
	                }
	                return _sourceText;
	            }
	        });
	        return _thisLayerFunction;
	    }
	}())
	var LayerExpressionInterface = (function (){
	    function toWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	        }
	        return toWorldMat.applyToPointArray(arr[0],arr[1],arr[2]||0);
	    }
	    function fromWorld(arr, time){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        var transformMat;
	        if(time) {
	            //Todo implement value at time on transform properties
	            //transformMat = this._elem.finalTransform.mProp.getValueAtTime(time);
	            transformMat = this._elem.finalTransform.mProp;
	        } else {
	            transformMat = this._elem.finalTransform.mProp;
	        }
	        transformMat.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	    function fromComp(arr){
	        var toWorldMat = new Matrix();
	        toWorldMat.reset();
	        this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);
	        if(this._elem.hierarchy && this._elem.hierarchy.length){
	            var i, len = this._elem.hierarchy.length;
	            for(i=0;i<len;i+=1){
	                this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
	            }
	            return toWorldMat.inversePoint(arr);
	        }
	        return toWorldMat.inversePoint(arr);
	    }
	
	
	    return function(elem){
	
	        var transformInterface = TransformExpressionInterface(elem.transform);
	
	        function _registerMaskInterface(maskManager){
	            _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
	        }
	        function _registerEffectsInterface(effects){
	            _thisLayerFunction.effect = effects;
	        }
	
	        function _thisLayerFunction(name){
	            switch(name){
	                case "ADBE Root Vectors Group":
	                case "Contents":
	                case 2:
	                    return _thisLayerFunction.shapeInterface;
	                case 1:
	                case 6:
	                case "Transform":
	                case "transform":
	                case "ADBE Transform Group":
	                    return transformInterface;
	                case 4:
	                case "ADBE Effect Parade":
	                    return _thisLayerFunction.effect;
	            }
	        }
	        _thisLayerFunction.toWorld = toWorld;
	        _thisLayerFunction.fromWorld = fromWorld;
	        _thisLayerFunction.toComp = toWorld;
	        _thisLayerFunction.fromComp = fromComp;
	        _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
	        _thisLayerFunction._elem = elem;
	        Object.defineProperty(_thisLayerFunction, 'hasParent', {
	            get: function(){
	                return !!elem.hierarchy;
	            }
	        });
	        Object.defineProperty(_thisLayerFunction, 'parent', {
	            get: function(){
	                return elem.hierarchy[0].layerInterface;
	            }
	        });
	        Object.defineProperty(_thisLayerFunction, "rotation", getDescriptor(transformInterface, 'rotation'));
	        Object.defineProperty(_thisLayerFunction, "scale", getDescriptor(transformInterface, 'scale'));
	        Object.defineProperty(_thisLayerFunction, "position", getDescriptor(transformInterface, 'position'));
	        Object.defineProperty(_thisLayerFunction, "opacity", getDescriptor(transformInterface, 'opacity'));
	        var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
	        Object.defineProperty(_thisLayerFunction, "anchorPoint", anchorPointDescriptor);
	        Object.defineProperty(_thisLayerFunction, "anchor_point", anchorPointDescriptor);
	
	        Object.defineProperty(_thisLayerFunction, "transform", {
	            get: function () {
	                return transformInterface;
	            }
	        });
	
	        Object.defineProperty(_thisLayerFunction, "_name", { value:elem.data.nm });
	
	        Object.defineProperty(_thisLayerFunction, "active", {
	            get: function(){
	                return elem.isVisible;
	            }
	        });
	
	        _thisLayerFunction.startTime = elem.data.st;
	        _thisLayerFunction.index = elem.data.ind;
	        _thisLayerFunction.source = elem.data.refId;
	        _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
	        _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
	
	        _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
	        _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
	        return _thisLayerFunction;
	    }
	}());
	
	var CompExpressionInterface = (function (){
	    return function(comp){
	        function _thisLayerFunction(name){
	            var i=0, len = comp.layers.length;
	            while(i<len){
	                if(comp.layers[i].nm === name || comp.layers[i].ind === name){
	                    return comp.elements[i].layerInterface;
	                }
	                i += 1;
	            }
	            return {active:false}
	        }
	        Object.defineProperty(_thisLayerFunction, "_name", { value:comp.data.nm });
	        _thisLayerFunction.layer = _thisLayerFunction;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.height = comp.globalData.compSize.h;
	        _thisLayerFunction.width = comp.globalData.compSize.w;
	        _thisLayerFunction.pixelAspect = 1;
	        _thisLayerFunction.frameDuration = 1/comp.globalData.frameRate;
	        return _thisLayerFunction;
	    }
	}());
	var TransformExpressionInterface = (function (){
	    return function(transform){
	        function _thisFunction(name){
	            switch(name){
	                case "scale":
	                case "Scale":
	                case "ADBE Scale":
	                case 6:
	                    return _thisFunction.scale;
	                case "rotation":
	                case "Rotation":
	                case "ADBE Rotation":
	                case "ADBE Rotate Z":
	                case 10:
	                    return _thisFunction.rotation;
	                case "position":
	                case "Position":
	                case "ADBE Position":
	                case 2:
	                    return _thisFunction.position;
	                case "anchorPoint":
	                case "AnchorPoint":
	                case "Anchor Point":
	                case "ADBE AnchorPoint":
	                case 1:
	                    return _thisFunction.anchorPoint;
	                case "opacity":
	                case "Opacity":
	                case 11:
	                    return _thisFunction.opacity;
	            }
	        }
	
	        Object.defineProperty(_thisFunction, "rotation", {
	            get: function(){
	                if(transform.r) {
	                    return ExpressionValue(transform.r, 1/degToRads);
	                } else {
	                    return ExpressionValue(transform.rz, 1/degToRads);
	                }
	            }
	        });
	        Object.defineProperty(_thisFunction, "scale", {
	            get: function () {
	                return ExpressionValue(transform.s, 100);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "position", {
	            get: function () {
	                if(transform.p) {
	                    return ExpressionValue(transform.p);
	                } else {
	                    return [transform.px.v, transform.py.v, transform.pz ? transform.pz.v : 0];
	                };
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "xPosition", {
	            get: function () {
	                return ExpressionValue(transform.px);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "yPosition", {
	            get: function () {
	                return ExpressionValue(transform.py);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "zPosition", {
	            get: function () {
	                return ExpressionValue(transform.pz);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "anchorPoint", {
	            get: function () {
	                return ExpressionValue(transform.a);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "opacity", {
	            get: function () {
	                return ExpressionValue(transform.o, 100);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "skew", {
	            get: function () {
	                return ExpressionValue(transform.sk);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "skewAxis", {
	            get: function () {
	                return ExpressionValue(transform.sa);
	            }
	        });
	
	        Object.defineProperty(_thisFunction, "orientation", {
	            get: function () {
	                return ExpressionValue(transform.or);
	            }
	        });
	
	        return _thisFunction;
	    }
	}());
	var ProjectInterface = (function (){
	
	    function registerComposition(comp){
	        this.compositions.push(comp);
	    }
	
	    return function(){
	        function _thisProjectFunction(name){
	            var i = 0, len = this.compositions.length;
	            while(i<len){
	                if(this.compositions[i].data && this.compositions[i].data.nm === name){
	                    if(this.compositions[i].prepareFrame) {
	                        this.compositions[i].prepareFrame(this.compositions[i].data.xt ? this.currentFrame : this.compositions[i].currentFrameNum);
	                    }
	                    return this.compositions[i].compInterface;
	                }
	                i+=1;
	            }
	        }
	
	        _thisProjectFunction.compositions = [];
	        _thisProjectFunction.currentFrame = 0;
	
	        _thisProjectFunction.registerComposition = registerComposition;
	
	
	
	        return _thisProjectFunction;
	    }
	}());
	var EffectsExpressionInterface = (function (){
	    var ob = {
	        createEffectsInterface: createEffectsInterface
	    };
	
	    function createEffectsInterface(elem, propertyGroup){
	        if(elem.effects){
	
	            var effectElements = [];
	            var effectsData = elem.data.ef;
	            var i, len = elem.effects.effectElements.length;
	            for(i=0;i<len;i+=1){
	                effectElements.push(createGroupInterface(effectsData[i],elem.effects.effectElements[i],propertyGroup,elem));
	            }
	
	            return function(name){
	                var effects = elem.data.ef, i = 0, len = effects.length;
	                while(i<len) {
	                    if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                        return effectElements[i];
	                    }
	                    i += 1;
	                }
	            }
	        }
	    }
	
	    function createGroupInterface(data,elements, propertyGroup, elem){
	        var effectElements = [];
	        var i, len = data.ef.length;
	        for(i=0;i<len;i+=1){
	            if(data.ef[i].ty === 5){
	                effectElements.push(createGroupInterface(data.ef[i],elements.effectElements[i],elements.effectElements[i].propertyGroup, elem));
	            } else {
	                effectElements.push(createValueInterface(elements.effectElements[i],data.ef[i].ty, elem, _propertyGroup));
	            }
	        }
	
	        function _propertyGroup(val) {
	            if(val === 1){
	               return groupInterface;
	            } else{
	               return propertyGroup(val-1);
	            }
	        }
	
	        var groupInterface = function(name){
	            var effects = data.ef, i = 0, len = effects.length;
	            while(i<len) {
	                if(name === effects[i].nm || name === effects[i].mn || name === effects[i].ix){
	                    if(effects[i].ty === 5){
	                        return effectElements[i];
	                    } else {
	                        return effectElements[i]();
	                    }
	                }
	                i += 1;
	            }
	            return effectElements[0]();
	        }
	
	        groupInterface.propertyGroup = _propertyGroup;
	
	        if(data.mn === 'ADBE Color Control'){
	            Object.defineProperty(groupInterface, 'color', {
	                get: function(){
	                    return effectElements[0]();
	                }
	            });
	        }
	        Object.defineProperty(groupInterface, 'numProperties', {
	            get: function(){
	                return data.np;
	            }
	        });
	        groupInterface.active = data.en !== 0;
	        return groupInterface
	    }
	
	    function createValueInterface(element, type, elem, propertyGroup){
	        function interfaceFunction(){
	            if(type === 10){
	                return elem.comp.compInterface(element.p.v);
	            }
	            return ExpressionValue(element.p);
	        }
	
	        if(element.p.setGroupProperty) {
	            element.p.setGroupProperty(propertyGroup);
	        }
	
	        return interfaceFunction;
	    }
	
	    return ob;
	
	}());
	var MaskManagerInterface = (function(){
	
		function MaskInterface(mask, data){
			this._mask = mask;
			this._data = data;
		}
		Object.defineProperty(MaskInterface.prototype, 'maskPath', {
	        get: function(){
	                if(this._mask.prop.k){
	                    this._mask.prop.getValue();
	                }
	                return this._mask.prop;
	            }
	        });
	
		var MaskManager = function(maskManager, elem){
			var _maskManager = maskManager;
			var _elem = elem;
			var _masksInterfaces = Array.apply(null,{length: maskManager.viewData.length});
			var i, len = maskManager.viewData.length;
			for(i = 0; i < len; i += 1) {
				_masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
			}
	
			var maskFunction = function(name){
				i = 0;
			    while(i<len){
			        if(maskManager.masksProperties[i].nm === name){
			            return _masksInterfaces[i];
			        }
			        i += 1;
			    }
			}
			return maskFunction
		}
		return MaskManager
	}())
	
	
	var ExpressionValue = (function() {
		return function(elementProp, mult, type) {
	        var expressionValue, arrayValue;
	
			if (elementProp.k) {
	            elementProp.getValue();
	        }
	        var i, len, arrValue;
	        if (type) {
	        	if(type === 'color') {
	        		len = 4;
	                expressionValue = createTypedArray('float32', len);
	                arrValue = createTypedArray('float32', len);
			        for (i = 0; i < len; i += 1) {
			            expressionValue[i] = arrValue[i] = (mult && i < 3) ? elementProp.v[i] * mult : 1;
			        }
		        	expressionValue.value = arrValue;
	        	}
	        } else if (typeof elementProp.v === 'number' || elementProp.v instanceof Number){
	            expressionValue = mult ? new Number(elementProp.v * mult) : new Number(elementProp.v);
	            expressionValue.value = mult ? elementProp.v * mult : elementProp.v;
	        } else {
	        	len = elementProp.v.length;
	            expressionValue = createTypedArray('float32', len);
	            arrValue = createTypedArray('float32', len);
		        for (i = 0; i < len; i += 1) {
		            expressionValue[i] = arrValue[i] = mult ? elementProp.v[i] * mult : elementProp.v[i];
		        }
		        expressionValue.value = arrValue;
	        }
	        
	        expressionValue.numKeys = elementProp.keyframes ? elementProp.keyframes.length : 0;
	        expressionValue.key = function(pos) {
	            if (!expressionValue.numKeys) {
	                return 0;
	            } else {
	                return elementProp.keyframes[pos-1].t;
	            }
	        };
	        expressionValue.valueAtTime = elementProp.getValueAtTime;
	        expressionValue.propertyGroup = elementProp.propertyGroup;
	        return expressionValue;
		}
	}())
	function SliderEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function AngleEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function ColorEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
	}
	function PointEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,1,0,dynamicProperties);
	}
	function LayerIndexEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function MaskIndexEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function CheckboxEffect(data,elem, dynamicProperties){
	    this.p = PropertyFactory.getProp(elem,data.v,0,0,dynamicProperties);
	}
	function NoValueEffect(){
	    this.p = {};
	}
	function EffectsManager(data,element,dynamicProperties){
	    var effects = data.ef;
	    this.effectElements = [];
	    var i,len = effects.length;
	    var effectItem;
	    for(i=0;i<len;i++) {
	        effectItem = new GroupEffect(effects[i],element,dynamicProperties);
	        this.effectElements.push(effectItem);
	    }
	}
	
	function GroupEffect(data,element,dynamicProperties){
	    this.dynamicProperties = [];
	    this.init(data,element,this.dynamicProperties);
	    if(this.dynamicProperties.length){
	        dynamicProperties.push(this);
	    }
	}
	
	GroupEffect.prototype.getValue = function(){
	    this.mdf = false;
	    var i, len = this.dynamicProperties.length;
	    for(i=0;i<len;i+=1){
	        this.dynamicProperties[i].getValue();
	        this.mdf = this.dynamicProperties[i].mdf ? true : this.mdf;
	    }
	};
	
	GroupEffect.prototype.init = function(data,element,dynamicProperties){
	    this.data = data;
	    this.mdf = false;
	    this.effectElements = [];
	    var i, len = this.data.ef.length;
	    var eff, effects = this.data.ef;
	    for(i=0;i<len;i+=1){
	        switch(effects[i].ty){
	            case 0:
	                eff = new SliderEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 1:
	                eff = new AngleEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 2:
	                eff = new ColorEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 3:
	                eff = new PointEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 4:
	            case 7:
	                eff = new CheckboxEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 10:
	                eff = new LayerIndexEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 11:
	                eff = new MaskIndexEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 5:
	                eff = new EffectsManager(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	            case 6:
	            default:
	                eff = new NoValueEffect(effects[i],element,dynamicProperties);
	                this.effectElements.push(eff);
	                break;
	        }
	    }
	};
	    var lottiejs = {};
	
	    function setLocationHref (href) {
	        locationHref = href;
	    }
	    function play(animation){
	        animationManager.play(animation);
	    }
	
	    function pause(animation) {
	        animationManager.pause(animation);
	    }
	
	    function togglePause(animation) {
	        animationManager.togglePause(animation);
	    }
	
	    function setSpeed(value, animation) {
	        animationManager.setSpeed(value, animation);
	    }
	
	    function setDirection(value, animation) {
	        animationManager.setDirection(value, animation);
	    }
	
	    function stop(animation) {
	        animationManager.stop(animation);
	    }
	
	    function moveFrame(value) {
	        animationManager.moveFrame(value);
	    }
	
	    function searchAnimations() {
	        if (standalone === true) {
	            animationManager.searchAnimations(animationData, standalone, renderer);
	        } else {
	            animationManager.searchAnimations();
	        }
	    }
	
	    function registerAnimation(elem) {
	        return animationManager.registerAnimation(elem);
	    }
	
	    function resize() {
	        animationManager.resize();
	    }
	
	    function start() {
	        animationManager.start();
	    }
	
	    function goToAndStop(val, isFrame, animation) {
	        animationManager.goToAndStop(val, isFrame, animation);
	    }
	
	    function setSubframeRendering(flag) {
	        subframeEnabled = flag;
	    }
	
	    function loadAnimation(params) {
	        if (standalone === true) {
	            params.animationData = JSON.parse(animationData);
	        }
	        return animationManager.loadAnimation(params);
	    }
	
	    function destroy(animation) {
	        return animationManager.destroy(animation);
	    }
	
	    function setQuality(value) {
	        if (typeof value === 'string') {
	            switch (value) {
	                case 'high':
	                    defaultCurveSegments = 200;
	                    break;
	                case 'medium':
	                    defaultCurveSegments = 50;
	                    break;
	                case 'low':
	                    defaultCurveSegments = 10;
	                    break;
	            }
	        } else if (!isNaN(value) && value > 1) {
	            defaultCurveSegments = value;
	        }
	        if (defaultCurveSegments >= 50) {
	            roundValues(false);
	        } else {
	            roundValues(true);
	        }
	    }
	
	    function inBrowser() {
	        return typeof navigator !== 'undefined';
	    }
	
	    function installPlugin(type, plugin) {
	        if (type === 'expressions') {
	            expressionsPlugin = plugin;
	        }
	    }
	
	    function getFactory(name) {
	        switch (name) {
	            case "propertyFactory":
	                return PropertyFactory;
	            case "shapePropertyFactory":
	                return ShapePropertyFactory;
	            case "matrix":
	                return Matrix;
	        }
	    }
	    lottiejs.play = play;
	    lottiejs.pause = pause;
	    lottiejs.setLocationHref = setLocationHref;
	    lottiejs.togglePause = togglePause;
	    lottiejs.setSpeed = setSpeed;
	    lottiejs.setDirection = setDirection;
	    lottiejs.stop = stop;
	    lottiejs.moveFrame = moveFrame;
	    lottiejs.searchAnimations = searchAnimations;
	    lottiejs.registerAnimation = registerAnimation;
	    lottiejs.loadAnimation = loadAnimation;
	    lottiejs.setSubframeRendering = setSubframeRendering;
	    lottiejs.resize = resize;
	    lottiejs.start = start;
	    lottiejs.goToAndStop = goToAndStop;
	    lottiejs.destroy = destroy;
	    lottiejs.setQuality = setQuality;
	    lottiejs.inBrowser = inBrowser;
	    lottiejs.installPlugin = installPlugin;
	    lottiejs.__getFactory = getFactory;
	    lottiejs.version = '5.0.4';
	
	    function checkReady() {
	        if (document.readyState === "complete") {
	            clearInterval(readyStateCheckInterval);
	            searchAnimations();
	        }
	    }
	
	    function getQueryVariable(variable) {
	        var vars = queryString.split('&');
	        for (var i = 0; i < vars.length; i++) {
	            var pair = vars[i].split('=');
	            if (decodeURIComponent(pair[0]) == variable) {
	                return decodeURIComponent(pair[1]);
	            }
	        }
	    }
	    var standalone = '__[STANDALONE]__';
	    var animationData = '__[ANIMATIONDATA]__';
	    var renderer = '';
	    if (standalone) {
	        var scripts = document.getElementsByTagName('script');
	        var index = scripts.length - 1;
	        var myScript = scripts[index] || {
	            src: ''
	        };
	        var queryString = myScript.src.replace(/^[^\?]+\??/, '');
	        renderer = getQueryVariable('renderer');
	    }
	    var readyStateCheckInterval = setInterval(checkReady, 100);
	    return lottiejs;
	}));

/***/ }),
/* 280 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ }),
/* 281 */
/***/ (function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	var utils = __webpack_require__(17);
	var normalizeHeaderName = __webpack_require__(437);
	
	var DEFAULT_CONTENT_TYPE = {
	  'Content-Type': 'application/x-www-form-urlencoded'
	};
	
	function setContentTypeIfUnset(headers, value) {
	  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
	    headers['Content-Type'] = value;
	  }
	}
	
	function getDefaultAdapter() {
	  var adapter;
	  if (typeof XMLHttpRequest !== 'undefined') {
	    // For browsers use XHR adapter
	    adapter = __webpack_require__(334);
	  } else if (typeof process !== 'undefined') {
	    // For node use HTTP adapter
	    adapter = __webpack_require__(334);
	  }
	  return adapter;
	}
	
	var defaults = {
	  adapter: getDefaultAdapter(),
	
	  transformRequest: [function transformRequest(data, headers) {
	    normalizeHeaderName(headers, 'Content-Type');
	    if (utils.isFormData(data) ||
	      utils.isArrayBuffer(data) ||
	      utils.isBuffer(data) ||
	      utils.isStream(data) ||
	      utils.isFile(data) ||
	      utils.isBlob(data)
	    ) {
	      return data;
	    }
	    if (utils.isArrayBufferView(data)) {
	      return data.buffer;
	    }
	    if (utils.isURLSearchParams(data)) {
	      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
	      return data.toString();
	    }
	    if (utils.isObject(data)) {
	      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
	      return JSON.stringify(data);
	    }
	    return data;
	  }],
	
	  transformResponse: [function transformResponse(data) {
	    /*eslint no-param-reassign:0*/
	    if (typeof data === 'string') {
	      try {
	        data = JSON.parse(data);
	      } catch (e) { /* Ignore */ }
	    }
	    return data;
	  }],
	
	  timeout: 0,
	
	  xsrfCookieName: 'XSRF-TOKEN',
	  xsrfHeaderName: 'X-XSRF-TOKEN',
	
	  maxContentLength: -1,
	
	  validateStatus: function validateStatus(status) {
	    return status >= 200 && status < 300;
	  }
	};
	
	defaults.headers = {
	  common: {
	    'Accept': 'application/json, text/plain, */*'
	  }
	};
	
	utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
	  defaults.headers[method] = {};
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
	});
	
	module.exports = defaults;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(397)))

/***/ }),
/* 283 */,
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An SVG icon. Stroke and fill can be supplied as props OR applied via CSS
	 * using the className prop.
	 *
	 * @param {string} className  A classname to be applied to the element
	 * @param {string} stroke     A colour
	 * @param {string} fill       A colour
	 */
	var SaveIcon = function SaveIcon(_ref) {
	  var className = _ref.className,
	      stroke = _ref.stroke,
	      fill = _ref.fill;
	
	  return _react2.default.createElement(
	    "span",
	    { className: className },
	    _react2.default.createElement(
	      "svg",
	      {
	        xmlns: "http://www.w3.org/2000/svg",
	        width: "17",
	        height: "16",
	        viewBox: "0 0 17 16"
	      },
	      _react2.default.createElement("polygon", {
	        stroke: stroke,
	        fill: fill,
	        points: "292.482 2 295.256 6.329 299.964 7.812 296.971 11.971 297.106 17.217 292.482 15.459 287.858 17.217 287.993 11.971 285 7.812 289.708 6.329",
	        transform: "translate(-284 -2)"
	      })
	    )
	  );
	};
	
	SaveIcon.propTypes = {
	  className: _propTypes2.default.string,
	  fill: _propTypes2.default.string,
	  stroke: _propTypes2.default.string
	};
	
	exports.default = SaveIcon;
	module.exports = exports["default"];

/***/ }),
/* 285 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.chartReducer = chartReducer;
	// Actions
	var typePrefix = "chart/";
	var SET = typePrefix + "SET";
	
	// Selectors
	
	var getChart = exports.getChart = function getChart(state) {
	  return state.chart;
	};
	
	// Action creators
	
	/**
	 *
	 * @param {string} articleId the article Id to be toggled
	 * @return {function} thunk action creator
	 */
	var setChart = exports.setChart = function setChart(_ref) {
	  var chartId = _ref.chartId,
	      groupId = _ref.groupId;
	  return {
	    type: SET,
	    chartId: chartId,
	    groupId: groupId
	  };
	};
	
	var emptyState = {
	  chartId: null,
	  groupId: false
	};
	
	// Reducer
	function chartReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : emptyState;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  switch (action.type) {
	    case SET:
	      return {
	        chartId: action.chartId,
	        groupId: action.groupId
	      };
	    default:
	      return state;
	  }
	}

/***/ }),
/* 286 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	/**
	 * Strings for sharing/meta data
	 */
	
	var sharingConfig = {
	  defaultShareTextTwitter: "The State of European Tech 2017 is the deepest, data-led investigation into the European tech ecosystem - read it here:",
	  defaultShareTextLinkedin: "The State of European Tech 2017 is the deepest, data-led investigation into the European tech ecosystem",
	  defaultShareUrl: "http://www.stateofeuropeantech.com",
	  linkedInSource: "Atomico",
	  hashtags: "europeantech",
	  shareImage: "https://2017.stateofeuropeantech.com/TheStateofEuropeanTech_2017.jpg"
	};
	
	exports.default = sharingConfig;
	module.exports = exports["default"];

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(510);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(508);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(347);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(347);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ }),
/* 289 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 290 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 291 */
/***/ (function(module, exports) {

	module.exports = {};


/***/ }),
/* 292 */
/***/ (function(module, exports) {

	module.exports = true;


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(127);
	var dPs = __webpack_require__(535);
	var enumBugKeys = __webpack_require__(290);
	var IE_PROTO = __webpack_require__(296)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(350)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(529).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 294 */
/***/ (function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

	var def = __webpack_require__(86).f;
	var has = __webpack_require__(66);
	var TAG = __webpack_require__(88)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(297)('keys');
	var uid = __webpack_require__(253);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 298 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(289);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(128);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(36);
	var core = __webpack_require__(34);
	var LIBRARY = __webpack_require__(292);
	var wksExt = __webpack_require__(302);
	var defineProperty = __webpack_require__(86).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(88);


/***/ }),
/* 303 */
/***/ (function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(255);
	var TAG = __webpack_require__(14)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ }),
/* 305 */
/***/ (function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30);
	var document = __webpack_require__(18).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var core = __webpack_require__(89);
	var hide = __webpack_require__(91);
	var redefine = __webpack_require__(93);
	var ctx = __webpack_require__(90);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(90);
	var call = __webpack_require__(560);
	var isArrayIter = __webpack_require__(559);
	var anObject = __webpack_require__(37);
	var toLength = __webpack_require__(373);
	var getIterFn = __webpack_require__(575);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(365);
	var $export = __webpack_require__(307);
	var redefine = __webpack_require__(93);
	var hide = __webpack_require__(91);
	var has = __webpack_require__(68);
	var Iterators = __webpack_require__(130);
	var $iterCreate = __webpack_require__(561);
	var setToStringTag = __webpack_require__(257);
	var getPrototypeOf = __webpack_require__(565);
	var ITERATOR = __webpack_require__(14)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 310 */
/***/ (function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(93);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(371)('keys');
	var uid = __webpack_require__(259);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ }),
/* 313 */
/***/ (function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ }),
/* 315 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	module.exports = exports['default'];

/***/ }),
/* 316 */,
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(262);
	
	var _PathUtils = __webpack_require__(94);
	
	var _createTransitionManager = __webpack_require__(318);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ }),
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(74),
	    root = __webpack_require__(7);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(264);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(392);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(819),
	    stubArray = __webpack_require__(396);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ }),
/* 325 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    getPrototype = __webpack_require__(323),
	    isObjectLike = __webpack_require__(29);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ }),
/* 327 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.omit = omit;
	exports.arraysEqual = arraysEqual;
	var isElementAnSFC = exports.isElementAnSFC = function isElementAnSFC(element) {
	  var isNativeDOMElement = typeof element.type === 'string';
	
	  if (isNativeDOMElement) {
	    return false;
	  }
	
	  return !element.type.prototype.isReactComponent;
	};
	function omit(obj) {
	  var attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var result = {};
	  Object.keys(obj).forEach(function (key) {
	    if (attrs.indexOf(key) === -1) {
	      result[key] = obj[key];
	    }
	  });
	  return result;
	}
	
	function arraysEqual(a, b) {
	  var sameObject = a === b;
	  if (sameObject) {
	    return true;
	  }
	
	  var notBothArrays = !Array.isArray(a) || !Array.isArray(b);
	  var differentLengths = a.length !== b.length;
	
	  if (notBothArrays || differentLengths) {
	    return false;
	  }
	
	  return a.every(function (element, index) {
	    return element === b[index];
	  });
	}
	
	function memoizeString(fn) {
	  var cache = {};
	
	  return function (str) {
	    if (!cache[str]) {
	      cache[str] = fn(str);
	    }
	    return cache[str];
	  };
	}
	
	var hyphenate = exports.hyphenate = memoizeString(function (str) {
	  return str.replace(/([A-Z])/g, '-$1').toLowerCase();
	});

/***/ }),
/* 328 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(331);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(939);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(926);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ }),
/* 333 */,
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var settle = __webpack_require__(429);
	var buildURL = __webpack_require__(432);
	var parseHeaders = __webpack_require__(438);
	var isURLSameOrigin = __webpack_require__(436);
	var createError = __webpack_require__(337);
	var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(431);
	
	module.exports = function xhrAdapter(config) {
	  return new Promise(function dispatchXhrRequest(resolve, reject) {
	    var requestData = config.data;
	    var requestHeaders = config.headers;
	
	    if (utils.isFormData(requestData)) {
	      delete requestHeaders['Content-Type']; // Let the browser set it
	    }
	
	    var request = new XMLHttpRequest();
	    var loadEvent = 'onreadystatechange';
	    var xDomain = false;
	
	    // For IE 8/9 CORS support
	    // Only supports POST and GET calls and doesn't returns the response headers.
	    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
	    if (("production") !== 'test' &&
	        typeof window !== 'undefined' &&
	        window.XDomainRequest && !('withCredentials' in request) &&
	        !isURLSameOrigin(config.url)) {
	      request = new window.XDomainRequest();
	      loadEvent = 'onload';
	      xDomain = true;
	      request.onprogress = function handleProgress() {};
	      request.ontimeout = function handleTimeout() {};
	    }
	
	    // HTTP basic authentication
	    if (config.auth) {
	      var username = config.auth.username || '';
	      var password = config.auth.password || '';
	      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
	    }
	
	    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
	    // Set the request timeout in MS
	    request.timeout = config.timeout;
	
	    // Listen for ready state
	    request[loadEvent] = function handleLoad() {
	      if (!request || (request.readyState !== 4 && !xDomain)) {
	        return;
	      }
	
	      // The request errored out and we didn't get a response, this will be
	      // handled by onerror instead
	      // With one exception: request that using file: protocol, most browsers
	      // will return status as 0 even though it's a successful request
	      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
	        return;
	      }
	
	      // Prepare the response
	      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
	      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
	      var response = {
	        data: responseData,
	        // IE sends 1223 instead of 204 (https://github.com/axios/axios/issues/201)
	        status: request.status === 1223 ? 204 : request.status,
	        statusText: request.status === 1223 ? 'No Content' : request.statusText,
	        headers: responseHeaders,
	        config: config,
	        request: request
	      };
	
	      settle(resolve, reject, response);
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle low level network errors
	    request.onerror = function handleError() {
	      // Real errors are hidden from us by the browser
	      // onerror should only fire if it's a network error
	      reject(createError('Network Error', config, null, request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Handle timeout
	    request.ontimeout = function handleTimeout() {
	      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
	        request));
	
	      // Clean up request
	      request = null;
	    };
	
	    // Add xsrf header
	    // This is only done if running in a standard browser environment.
	    // Specifically not if we're in a web worker, or react-native.
	    if (utils.isStandardBrowserEnv()) {
	      var cookies = __webpack_require__(434);
	
	      // Add xsrf header
	      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
	          cookies.read(config.xsrfCookieName) :
	          undefined;
	
	      if (xsrfValue) {
	        requestHeaders[config.xsrfHeaderName] = xsrfValue;
	      }
	    }
	
	    // Add headers to the request
	    if ('setRequestHeader' in request) {
	      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
	        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
	          // Remove Content-Type if data is undefined
	          delete requestHeaders[key];
	        } else {
	          // Otherwise add header to the request
	          request.setRequestHeader(key, val);
	        }
	      });
	    }
	
	    // Add withCredentials to request if needed
	    if (config.withCredentials) {
	      request.withCredentials = true;
	    }
	
	    // Add responseType to request if needed
	    if (config.responseType) {
	      try {
	        request.responseType = config.responseType;
	      } catch (e) {
	        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
	        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
	        if (config.responseType !== 'json') {
	          throw e;
	        }
	      }
	    }
	
	    // Handle progress if needed
	    if (typeof config.onDownloadProgress === 'function') {
	      request.addEventListener('progress', config.onDownloadProgress);
	    }
	
	    // Not all browsers support upload events
	    if (typeof config.onUploadProgress === 'function' && request.upload) {
	      request.upload.addEventListener('progress', config.onUploadProgress);
	    }
	
	    if (config.cancelToken) {
	      // Handle cancellation
	      config.cancelToken.promise.then(function onCanceled(cancel) {
	        if (!request) {
	          return;
	        }
	
	        request.abort();
	        reject(cancel);
	        // Clean up request
	        request = null;
	      });
	    }
	
	    if (requestData === undefined) {
	      requestData = null;
	    }
	
	    // Send the request
	    request.send(requestData);
	  });
	};


/***/ }),
/* 335 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * A `Cancel` is an object that is thrown when an operation is canceled.
	 *
	 * @class
	 * @param {string=} message The message.
	 */
	function Cancel(message) {
	  this.message = message;
	}
	
	Cancel.prototype.toString = function toString() {
	  return 'Cancel' + (this.message ? ': ' + this.message : '');
	};
	
	Cancel.prototype.__CANCEL__ = true;
	
	module.exports = Cancel;


/***/ }),
/* 336 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function isCancel(value) {
	  return !!(value && value.__CANCEL__);
	};


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var enhanceError = __webpack_require__(428);
	
	/**
	 * Create an Error with the specified message, config, error code, request and response.
	 *
	 * @param {string} message The error message.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The created error.
	 */
	module.exports = function createError(message, config, code, request, response) {
	  var error = new Error(message);
	  return enhanceError(error, config, code, request, response);
	};


/***/ }),
/* 338 */
/***/ (function(module, exports) {

	'use strict';
	
	module.exports = function bind(fn, thisArg) {
	  return function wrap() {
	    var args = new Array(arguments.length);
	    for (var i = 0; i < args.length; i++) {
	      args[i] = arguments[i];
	    }
	    return fn.apply(thisArg, args);
	  };
	};


/***/ }),
/* 339 */,
/* 340 */,
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(606);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _Share = __webpack_require__(124);
	
	var _isBrowserEnv = __webpack_require__(13);
	
	var _isBrowserEnv2 = _interopRequireDefault(_isBrowserEnv);
	
	var _ActionButton = __webpack_require__(77);
	
	var _ActionButton2 = _interopRequireDefault(_ActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FigureFooter = function FigureFooter(_ref) {
	  var onDownloadClick = _ref.onDownloadClick,
	      note = _ref.note,
	      sources = _ref.sources,
	      title = _ref.title,
	      chartId = _ref.chartId,
	      groupId = _ref.groupId;
	
	  var here = void 0;
	  var imagePath = void 0;
	  var linkedinText = title;
	  var twitterText = title;
	  if ((0, _isBrowserEnv2.default)() && window.location.href) {
	    here = window.location.href;
	    imagePath = window.location.origin + "/chart/state-of-european-tech-2017-" + chartId + "-" + groupId + ".jpg";
	    twitterText = title + " " + imagePath;
	  }
	  return _react2.default.createElement(
	    "div",
	    { className: _indexModule2.default.root },
	    onDownloadClick && _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.section },
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.button },
	        _react2.default.createElement(_ActionButton2.default, { onClick: onDownloadClick })
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.social },
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.socialAction },
	          _react2.default.createElement(_Share.ShareLinkedIn, {
	            url: here,
	            sourceUrl: imagePath,
	            title: linkedinText,
	            image: imagePath
	          })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _indexModule2.default.socialAction },
	          _react2.default.createElement(_Share.ShareTwitter, { text: twitterText })
	        )
	      )
	    ),
	    note && _react2.default.createElement(
	      "dl",
	      { className: _indexModule2.default.list },
	      _react2.default.createElement(
	        "dt",
	        { className: _indexModule2.default.term },
	        "Note:"
	      ),
	      _react2.default.createElement(
	        "dd",
	        { className: _indexModule2.default.definition },
	        note
	      )
	    ),
	    sources && _react2.default.createElement(
	      "dl",
	      { className: _indexModule2.default.list },
	      _react2.default.createElement(
	        "dt",
	        { className: _indexModule2.default.term },
	        "Source:"
	      ),
	      _react2.default.createElement(
	        "dd",
	        { className: _indexModule2.default.definition },
	        sources
	      )
	    )
	  );
	};
	
	FigureFooter.propTypes = {
	  insight: _propTypes2.default.string,
	  note: _propTypes2.default.string,
	  onDownloadClick: _propTypes2.default.func,
	  sources: _propTypes2.default.string,
	  title: _propTypes2.default.string,
	  chartId: _propTypes2.default.number,
	  groupId: _propTypes2.default.number
	};
	
	exports.default = FigureFooter;
	module.exports = exports["default"];

/***/ }),
/* 342 */,
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(616);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _SaveIcon = __webpack_require__(284);
	
	var _SaveIcon2 = _interopRequireDefault(_SaveIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Save = function Save(_ref) {
	  var active = _ref.active,
	      onClick = _ref.onClick,
	      largeText = _ref.largeText;
	
	  var activeModifier = active ? "Active" : "";
	  var textStyle = largeText ? _indexModule2.default.textLarge : _indexModule2.default.text;
	  return _react2.default.createElement(
	    "button",
	    { className: _indexModule2.default.root, onClick: onClick },
	    _react2.default.createElement(
	      "span",
	      { className: textStyle },
	      "Save"
	    ),
	    _react2.default.createElement(_SaveIcon2.default, { className: _indexModule2.default["saveIcon" + activeModifier] })
	  );
	};
	
	Save.defaultProps = {
	  active: false,
	  onClick: function onClick() {}
	};
	
	Save.propTypes = {
	  active: _propTypes2.default.bool,
	  onClick: _propTypes2.default.func,
	  largeText: _propTypes2.default.bool
	};
	
	exports.default = Save;
	module.exports = exports["default"];

/***/ }),
/* 344 */,
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isBrowserEnv = __webpack_require__(13);
	
	var _isBrowserEnv2 = _interopRequireDefault(_isBrowserEnv);
	
	var _noop = __webpack_require__(278);
	
	var _noop2 = _interopRequireDefault(_noop);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Export the ga object only if analytics is enabled for the env,
	 * otherwise just export a noop mock.
	 */
	var isDOM = (0, _isBrowserEnv2.default)();
	var analytics = isDOM && window.ga ? window.ga : _noop2.default;
	
	exports.default = analytics;
	module.exports = exports["default"];

/***/ }),
/* 346 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = function () {
	  for (var _len = arguments.length, objects = Array(_len), _key = 0; _key < _len; _key++) {
	    objects[_key] = arguments[_key];
	  }
	
	  // Check inputs are all objects
	  var inputValid = true;
	  objects.forEach(function (object) {
	    if ((typeof object === "undefined" ? "undefined" : _typeof(object)) !== "object") inputValid = false;
	    if (object === null) inputValid = false;
	    if (object === undefined) inputValid = false;
	  });
	  if (!inputValid) return false;
	
	  var allKeys = objects.reduce(function (keys, object) {
	    return keys.concat(Object.keys(object));
	  }, []);
	  var union = new Set(allKeys);
	  return objects.every(function (object) {
	    return union.size === Object.keys(object).length;
	  });
	};
	
	module.exports = exports["default"];

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(512);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(511);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ }),
/* 348 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(525);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(128);
	var document = __webpack_require__(36).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(82) && !__webpack_require__(84)(function () {
	  return Object.defineProperty(__webpack_require__(350)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(348);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(292);
	var $export = __webpack_require__(83);
	var redefine = __webpack_require__(357);
	var hide = __webpack_require__(85);
	var has = __webpack_require__(66);
	var Iterators = __webpack_require__(291);
	var $iterCreate = __webpack_require__(531);
	var setToStringTag = __webpack_require__(295);
	var getPrototypeOf = __webpack_require__(537);
	var ITERATOR = __webpack_require__(88)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(251);
	var createDesc = __webpack_require__(252);
	var toIObject = __webpack_require__(87);
	var toPrimitive = __webpack_require__(300);
	var has = __webpack_require__(66);
	var IE8_DOM_DEFINE = __webpack_require__(351);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(82) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(356);
	var hiddenKeys = __webpack_require__(290).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(66);
	var toIObject = __webpack_require__(87);
	var arrayIndexOf = __webpack_require__(527)(false);
	var IE_PROTO = __webpack_require__(296)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(85);


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(92).f;
	var create = __webpack_require__(368);
	var redefineAll = __webpack_require__(311);
	var ctx = __webpack_require__(90);
	var anInstance = __webpack_require__(303);
	var forOf = __webpack_require__(308);
	var $iterDefine = __webpack_require__(309);
	var step = __webpack_require__(364);
	var setSpecies = __webpack_require__(370);
	var DESCRIPTORS = __webpack_require__(67);
	var fastKey = __webpack_require__(366).fastKey;
	var validate = __webpack_require__(314);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var $export = __webpack_require__(307);
	var redefine = __webpack_require__(93);
	var redefineAll = __webpack_require__(311);
	var meta = __webpack_require__(366);
	var forOf = __webpack_require__(308);
	var anInstance = __webpack_require__(303);
	var isObject = __webpack_require__(30);
	var fails = __webpack_require__(256);
	var $iterDetect = __webpack_require__(363);
	var setToStringTag = __webpack_require__(257);
	var inheritIfRequired = __webpack_require__(556);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ }),
/* 360 */
/***/ (function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(18).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(67) && !__webpack_require__(256)(function () {
	  return Object.defineProperty(__webpack_require__(306)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(14)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ }),
/* 364 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 365 */
/***/ (function(module, exports) {

	module.exports = false;


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(259)('meta');
	var isObject = __webpack_require__(30);
	var has = __webpack_require__(68);
	var setDesc = __webpack_require__(92).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(256)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(254);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(37);
	var dPs = __webpack_require__(563);
	var enumBugKeys = __webpack_require__(360);
	var IE_PROTO = __webpack_require__(312)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(306)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(361).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(566);
	var enumBugKeys = __webpack_require__(360);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(18);
	var dP = __webpack_require__(92);
	var DESCRIPTORS = __webpack_require__(67);
	var SPECIES = __webpack_require__(14)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(90);
	var invoke = __webpack_require__(557);
	var html = __webpack_require__(361);
	var cel = __webpack_require__(306);
	var global = __webpack_require__(18);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(255)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(313);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(30);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(304);
	var test = {};
	test[__webpack_require__(14)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(93)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(572)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(309)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(576);
	var getKeys = __webpack_require__(369);
	var redefine = __webpack_require__(93);
	var global = __webpack_require__(18);
	var hide = __webpack_require__(91);
	var Iterators = __webpack_require__(130);
	var wks = __webpack_require__(14);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(63);
	
	var emptyObject = __webpack_require__(260);
	var _invariant = __webpack_require__(35);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ }),
/* 379 */
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getWindow;
	function getWindow(node) {
	  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
	}
	module.exports = exports["default"];

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),
/* 381 */
/***/ (function(module, exports) {

	/*
	 Highcharts JS v6.0.3 (2017-11-14)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(S,N){"object"===typeof module&&module.exports?module.exports=S.document?N(S):N:S.Highcharts=N(S)})("undefined"!==typeof window?window:this,function(S){var N=function(){var a="undefined"===typeof S?window:S,D=a.document,B=a.navigator&&a.navigator.userAgent||"",G=D&&D.createElementNS&&!!D.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,p=/(edge|msie|trident)/i.test(B)&&!a.opera,g=/Firefox/.test(B),l=g&&4>parseInt(B.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,
	!0):{product:"Highcharts",version:"6.0.3",deg2rad:2*Math.PI/360,doc:D,hasBidiBug:l,hasTouch:D&&void 0!==D.documentElement.ontouchstart,isMS:p,isWebKit:/AppleWebKit/.test(B),isFirefox:g,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(B),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:G,win:a,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){a.timers=[];var D=a.charts,B=a.doc,G=a.win;a.error=function(p,
	g){p=a.isNumber(p)?"Highcharts error #"+p+": www.highcharts.com/errors/"+p:p;if(g)throw Error(p);G.console&&console.log(p)};a.Fx=function(a,g,l){this.options=g;this.elem=a;this.prop=l};a.Fx.prototype={dSetter:function(){var a=this.paths[0],g=this.paths[1],l=[],r=this.now,n=a.length,w;if(1===r)l=this.toD;else if(n===g.length&&1>r)for(;n--;)w=parseFloat(a[n]),l[n]=isNaN(w)?g[n]:r*parseFloat(g[n]-w)+w;else l=g;this.elem.attr("d",l,null,!0)},update:function(){var a=this.elem,g=this.prop,l=this.now,r=
	this.options.step;if(this[g+"Setter"])this[g+"Setter"]();else a.attr?a.element&&a.attr(g,l,null,!0):a.style[g]=l+this.unit;r&&r.call(a,l,this)},run:function(p,g,l){var r=this,n=r.options,w=function(a){return w.stopped?!1:r.step(a)},v=G.requestAnimationFrame||function(a){setTimeout(a,13)},e=function(){a.timers=a.grep(a.timers,function(a){return a()});a.timers.length&&v(e)};p===g?(delete n.curAnim[this.prop],n.complete&&0===a.keys(n.curAnim).length&&n.complete()):(this.startTime=+new Date,this.start=
	p,this.end=g,this.unit=l,this.now=this.start,this.pos=0,w.elem=this.elem,w.prop=this.prop,w()&&1===a.timers.push(w)&&v(e))},step:function(p){var g=+new Date,l,r=this.options,n=this.elem,w=r.complete,v=r.duration,e=r.curAnim;n.attr&&!n.element?p=!1:p||g>=v+this.startTime?(this.now=this.end,this.pos=1,this.update(),l=e[this.prop]=!0,a.objectEach(e,function(a){!0!==a&&(l=!1)}),l&&w&&w.call(n),p=!1):(this.pos=r.easing((g-this.startTime)/v),this.now=this.start+(this.end-this.start)*this.pos,this.update(),
	p=!0);return p},initPath:function(p,g,l){function r(a){var b,f;for(d=a.length;d--;)b="M"===a[d]||"L"===a[d],f=/[a-zA-Z]/.test(a[d+3]),b&&f&&a.splice(d+1,0,a[d+1],a[d+2],a[d+1],a[d+2])}function n(a,b){for(;a.length<f;){a[0]=b[f-a.length];var e=a.slice(0,c);[].splice.apply(a,[0,0].concat(e));y&&(e=a.slice(a.length-c),[].splice.apply(a,[a.length,0].concat(e)),d--)}a[0]="M"}function w(a,d){for(var e=(f-a.length)/c;0<e&&e--;)b=a.slice().splice(a.length/H-c,c*H),b[0]=d[f-c-e*c],m&&(b[c-6]=b[c-2],b[c-5]=
	b[c-1]),[].splice.apply(a,[a.length/H,0].concat(b)),y&&e--}g=g||"";var v,e=p.startX,h=p.endX,m=-1<g.indexOf("C"),c=m?7:3,f,b,d;g=g.split(" ");l=l.slice();var y=p.isArea,H=y?2:1,J;m&&(r(g),r(l));if(e&&h){for(d=0;d<e.length;d++)if(e[d]===h[0]){v=d;break}else if(e[0]===h[h.length-e.length+d]){v=d;J=!0;break}void 0===v&&(g=[])}g.length&&a.isNumber(v)&&(f=l.length+v*H*c,J?(n(g,l),w(l,g)):(n(l,g),w(g,l)));return[g,l]}};a.Fx.prototype.fillSetter=a.Fx.prototype.strokeSetter=function(){this.elem.attr(this.prop,
	a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)};a.extend=function(a,g){var l;a||(a={});for(l in g)a[l]=g[l];return a};a.merge=function(){var p,g=arguments,l,r={},n=function(l,v){"object"!==typeof l&&(l={});a.objectEach(v,function(e,h){!a.isObject(e,!0)||a.isClass(e)||a.isDOMElement(e)?l[h]=v[h]:l[h]=n(l[h]||{},e)});return l};!0===g[0]&&(r=g[1],g=Array.prototype.slice.call(g,2));l=g.length;for(p=0;p<l;p++)r=n(r,g[p]);return r};a.pInt=function(a,g){return parseInt(a,g||10)};a.isString=
	function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(p,g){return!!p&&"object"===typeof p&&(!g||!a.isArray(p))};a.isDOMElement=function(p){return a.isObject(p)&&"number"===typeof p.nodeType};a.isClass=function(p){var g=p&&p.constructor;return!(!a.isObject(p,!0)||a.isDOMElement(p)||!g||!g.name||"Object"===g.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=
	function(a,g){for(var l=a.length;l--;)if(a[l]===g){a.splice(l,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(p,g,l){var r;a.isString(g)?a.defined(l)?p.setAttribute(g,l):p&&p.getAttribute&&(r=p.getAttribute(g)):a.defined(g)&&a.isObject(g)&&a.objectEach(g,function(a,l){p.setAttribute(l,a)});return r};a.splat=function(p){return a.isArray(p)?p:[p]};a.syncTimeout=function(a,g,l){if(g)return setTimeout(a,g,l);a.call(0,l)};a.pick=function(){var a=arguments,g,l,r=a.length;for(g=
	0;g<r;g++)if(l=a[g],void 0!==l&&null!==l)return l};a.css=function(p,g){a.isMS&&!a.svg&&g&&void 0!==g.opacity&&(g.filter="alpha(opacity\x3d"+100*g.opacity+")");a.extend(p.style,g)};a.createElement=function(p,g,l,r,n){p=B.createElement(p);var w=a.css;g&&a.extend(p,g);n&&w(p,{padding:0,border:"none",margin:0});l&&w(p,l);r&&r.appendChild(p);return p};a.extendClass=function(p,g){var l=function(){};l.prototype=new p;a.extend(l.prototype,g);return l};a.pad=function(a,g,l){return Array((g||2)+1-String(a).length).join(l||
	0)+a};a.relativeLength=function(a,g,l){return/%$/.test(a)?g*parseFloat(a)/100+(l||0):parseFloat(a)};a.wrap=function(a,g,l){var r=a[g];a[g]=function(){var a=Array.prototype.slice.call(arguments),g=arguments,v=this;v.proceed=function(){r.apply(v,arguments.length?arguments:g)};a.unshift(r);a=l.apply(this,a);v.proceed=null;return a}};a.getTZOffset=function(p){var g=a.Date;return 6E4*(g.hcGetTimezoneOffset&&g.hcGetTimezoneOffset(p)||g.hcTimezoneOffset||0)};a.dateFormat=function(p,g,l){if(!a.defined(g)||
	isNaN(g))return a.defaultOptions.lang.invalidDate||"";p=a.pick(p,"%Y-%m-%d %H:%M:%S");var r=a.Date,n=new r(g-a.getTZOffset(g)),w=n[r.hcGetHours](),v=n[r.hcGetDay](),e=n[r.hcGetDate](),h=n[r.hcGetMonth](),m=n[r.hcGetFullYear](),c=a.defaultOptions.lang,f=c.weekdays,b=c.shortWeekdays,d=a.pad,r=a.extend({a:b?b[v]:f[v].substr(0,3),A:f[v],d:d(e),e:d(e,2," "),w:v,b:c.shortMonths[h],B:c.months[h],m:d(h+1),y:m.toString().substr(2,2),Y:m,H:d(w),k:w,I:d(w%12||12),l:w%12||12,M:d(n[r.hcGetMinutes]()),p:12>w?"AM":
	"PM",P:12>w?"am":"pm",S:d(n.getSeconds()),L:d(Math.round(g%1E3),3)},a.dateFormats);a.objectEach(r,function(a,b){for(;-1!==p.indexOf("%"+b);)p=p.replace("%"+b,"function"===typeof a?a(g):a)});return l?p.substr(0,1).toUpperCase()+p.substr(1):p};a.formatSingle=function(p,g){var l=/\.([0-9])/,r=a.defaultOptions.lang;/f$/.test(p)?(l=(l=p.match(l))?l[1]:-1,null!==g&&(g=a.numberFormat(g,l,r.decimalPoint,-1<p.indexOf(",")?r.thousandsSep:""))):g=a.dateFormat(p,g);return g};a.format=function(p,g){for(var l=
	"{",r=!1,n,w,v,e,h=[],m;p;){l=p.indexOf(l);if(-1===l)break;n=p.slice(0,l);if(r){n=n.split(":");w=n.shift().split(".");e=w.length;m=g;for(v=0;v<e;v++)m&&(m=m[w[v]]);n.length&&(m=a.formatSingle(n.join(":"),m));h.push(m)}else h.push(n);p=p.slice(l+1);l=(r=!r)?"}":"{"}h.push(p);return h.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(p,g,l,r,n){var w,v=p;l=a.pick(l,1);w=p/l;g||(g=n?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],
	!1===r&&(1===l?g=a.grep(g,function(a){return 0===a%1}):.1>=l&&(g=[1/l])));for(r=0;r<g.length&&!(v=g[r],n&&v*l>=p||!n&&w<=(g[r]+(g[r+1]||g[r]))/2);r++);return v=a.correctFloat(v*l,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,g){var l=a.length,r,n;for(n=0;n<l;n++)a[n].safeI=n;a.sort(function(a,n){r=g(a,n);return 0===r?a.safeI-n.safeI:r});for(n=0;n<l;n++)delete a[n].safeI};a.arrayMin=function(a){for(var g=a.length,l=a[0];g--;)a[g]<l&&(l=a[g]);return l};a.arrayMax=function(a){for(var g=
	a.length,l=a[0];g--;)a[g]>l&&(l=a[g]);return l};a.destroyObjectProperties=function(p,g){a.objectEach(p,function(a,r){a&&a!==g&&a.destroy&&a.destroy();delete p[r]})};a.discardElement=function(p){var g=a.garbageBin;g||(g=a.createElement("div"));p&&g.appendChild(p);g.innerHTML=""};a.correctFloat=function(a,g){return parseFloat(a.toPrecision(g||14))};a.setAnimation=function(p,g){g.renderer.globalAnimation=a.pick(p,g.options.chart.animation,!0)};a.animObject=function(p){return a.isObject(p)?a.merge(p):
	{duration:p?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(p,g,l,r){p=+p||0;g=+g;var n=a.defaultOptions.lang,w=(p.toString().split(".")[1]||"").split("e")[0].length,v,e,h=p.toString().split("e");-1===g?g=Math.min(w,20):a.isNumber(g)||(g=2);e=(Math.abs(h[1]?h[0]:p)+Math.pow(10,-Math.max(g,w)-1)).toFixed(g);w=String(a.pInt(e));v=3<w.length?w.length%3:0;l=a.pick(l,n.decimalPoint);r=a.pick(r,n.thousandsSep);
	p=(0>p?"-":"")+(v?w.substr(0,v)+r:"");p+=w.substr(v).replace(/(\d{3})(?=\d)/g,"$1"+r);g&&(p+=l+e.slice(-g));h[1]&&(p+="e"+h[1]);return p};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(p,g,l){if("width"===g)return Math.min(p.offsetWidth,p.scrollWidth)-a.getStyle(p,"padding-left")-a.getStyle(p,"padding-right");if("height"===g)return Math.min(p.offsetHeight,p.scrollHeight)-a.getStyle(p,"padding-top")-a.getStyle(p,"padding-bottom");G.getComputedStyle||a.error(27,
	!0);if(p=G.getComputedStyle(p,void 0))p=p.getPropertyValue(g),a.pick(l,"opacity"!==g)&&(p=a.pInt(p));return p};a.inArray=function(p,g){return(a.indexOfPolyfill||Array.prototype.indexOf).call(g,p)};a.grep=function(p,g){return(a.filterPolyfill||Array.prototype.filter).call(p,g)};a.find=Array.prototype.find?function(a,g){return a.find(g)}:function(a,g){var l,r=a.length;for(l=0;l<r;l++)if(g(a[l],l))return a[l]};a.map=function(a,g){for(var l=[],r=0,n=a.length;r<n;r++)l[r]=g.call(a[r],a[r],r,a);return l};
	a.keys=function(p){return(a.keysPolyfill||Object.keys).call(void 0,p)};a.reduce=function(p,g,l){return(a.reducePolyfill||Array.prototype.reduce).call(p,g,l)};a.offset=function(a){var g=B.documentElement;a=a.parentElement?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(G.pageYOffset||g.scrollTop)-(g.clientTop||0),left:a.left+(G.pageXOffset||g.scrollLeft)-(g.clientLeft||0)}};a.stop=function(p,g){for(var l=a.timers.length;l--;)a.timers[l].elem!==p||g&&g!==a.timers[l].prop||(a.timers[l].stopped=
	!0)};a.each=function(p,g,l){return(a.forEachPolyfill||Array.prototype.forEach).call(p,g,l)};a.objectEach=function(a,g,l){for(var r in a)a.hasOwnProperty(r)&&g.call(l,a[r],r,a)};a.addEvent=function(p,g,l){var r,n,w=p.addEventListener||a.addEventListenerPolyfill;p.hcEvents&&!p.hasOwnProperty("hcEvents")&&(n={},a.objectEach(p.hcEvents,function(a,e){n[e]=a.slice(0)}),p.hcEvents=n);r=p.hcEvents=p.hcEvents||{};w&&w.call(p,g,l,!1);r[g]||(r[g]=[]);r[g].push(l);return function(){a.removeEvent(p,g,l)}};a.removeEvent=
	function(p,g,l){function r(e,m){var c=p.removeEventListener||a.removeEventListenerPolyfill;c&&c.call(p,e,m,!1)}function n(){var e,m;p.nodeName&&(g?(e={},e[g]=!0):e=v,a.objectEach(e,function(a,f){if(v[f])for(m=v[f].length;m--;)r(f,v[f][m])}))}var w,v=p.hcEvents,e;v&&(g?(w=v[g]||[],l?(e=a.inArray(l,w),-1<e&&(w.splice(e,1),v[g]=w),r(g,l)):(n(),v[g]=[])):(n(),p.hcEvents={}))};a.fireEvent=function(p,g,l,r){var n;n=p.hcEvents;var w,v;l=l||{};if(B.createEvent&&(p.dispatchEvent||p.fireEvent))n=B.createEvent("Events"),
	n.initEvent(g,!0,!0),a.extend(n,l),p.dispatchEvent?p.dispatchEvent(n):p.fireEvent(g,n);else if(n)for(n=n[g]||[],w=n.length,l.target||a.extend(l,{preventDefault:function(){l.defaultPrevented=!0},target:p,type:g}),g=0;g<w;g++)(v=n[g])&&!1===v.call(p,l)&&l.preventDefault();r&&!l.defaultPrevented&&r(l)};a.animate=function(p,g,l){var r,n="",w,v,e;a.isObject(l)||(e=arguments,l={duration:e[2],easing:e[3],complete:e[4]});a.isNumber(l.duration)||(l.duration=400);l.easing="function"===typeof l.easing?l.easing:
	Math[l.easing]||Math.easeInOutSine;l.curAnim=a.merge(g);a.objectEach(g,function(e,m){a.stop(p,m);v=new a.Fx(p,l,m);w=null;"d"===m?(v.paths=v.initPath(p,p.d,g.d),v.toD=g.d,r=0,w=1):p.attr?r=p.attr(m):(r=parseFloat(a.getStyle(p,m))||0,"opacity"!==m&&(n="px"));w||(w=e);w&&w.match&&w.match("px")&&(w=w.replace(/px/g,""));v.run(r,w,n)})};a.seriesType=function(p,g,l,r,n){var w=a.getOptions(),v=a.seriesTypes;w.plotOptions[p]=a.merge(w.plotOptions[g],l);v[p]=a.extendClass(v[g]||function(){},r);v[p].prototype.type=
	p;n&&(v[p].prototype.pointClass=a.extendClass(a.Point,n));return v[p]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),g=0;return function(){return"highcharts-"+a+"-"+g++}}();G.jQuery&&(G.jQuery.fn.highcharts=function(){var p=[].slice.call(arguments);if(this[0])return p[0]?(new (a[a.isString(p[0])?p.shift():"Chart"])(this[0],p[0],p[1]),this):D[a.attr(this[0],"data-highcharts-chart")]})})(N);(function(a){var D=a.each,B=a.isNumber,G=a.map,p=a.merge,g=a.pInt;a.Color=function(l){if(!(this instanceof
	a.Color))return new a.Color(l);this.init(l)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[g(a[1]),g(a[2]),g(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[g(a[1]),g(a[2]),g(a[3]),1]}}],names:{none:"rgba(255,255,255,0)",white:"#ffffff",black:"#000000"},init:function(l){var g,n,w,v;if((this.input=l=this.names[l&&
	l.toLowerCase?l.toLowerCase():""]||l)&&l.stops)this.stops=G(l.stops,function(e){return new a.Color(e[1])});else if(l&&l.charAt&&"#"===l.charAt()&&(g=l.length,l=parseInt(l.substr(1),16),7===g?n=[(l&16711680)>>16,(l&65280)>>8,l&255,1]:4===g&&(n=[(l&3840)>>4|(l&3840)>>8,(l&240)>>4|l&240,(l&15)<<4|l&15,1])),!n)for(w=this.parsers.length;w--&&!n;)v=this.parsers[w],(g=v.regex.exec(l))&&(n=v.parse(g));this.rgba=n||[]},get:function(a){var l=this.input,n=this.rgba,g;this.stops?(g=p(l),g.stops=[].concat(g.stops),
	D(this.stops,function(n,e){g.stops[e]=[g.stops[e][0],n.get(a)]})):g=n&&B(n[0])?"rgb"===a||!a&&1===n[3]?"rgb("+n[0]+","+n[1]+","+n[2]+")":"a"===a?n[3]:"rgba("+n.join(",")+")":l;return g},brighten:function(a){var l,n=this.rgba;if(this.stops)D(this.stops,function(n){n.brighten(a)});else if(B(a)&&0!==a)for(l=0;3>l;l++)n[l]+=g(255*a),0>n[l]&&(n[l]=0),255<n[l]&&(n[l]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,g){var n=this.rgba,l=a.rgba;l.length&&n&&n.length?
	(a=1!==l[3]||1!==n[3],g=(a?"rgba(":"rgb(")+Math.round(l[0]+(n[0]-l[0])*(1-g))+","+Math.round(l[1]+(n[1]-l[1])*(1-g))+","+Math.round(l[2]+(n[2]-l[2])*(1-g))+(a?","+(l[3]+(n[3]-l[3])*(1-g)):"")+")"):g=a.input||"none";return g}};a.color=function(g){return new a.Color(g)}})(N);(function(a){var D,B,G=a.addEvent,p=a.animate,g=a.attr,l=a.charts,r=a.color,n=a.css,w=a.createElement,v=a.defined,e=a.deg2rad,h=a.destroyObjectProperties,m=a.doc,c=a.each,f=a.extend,b=a.erase,d=a.grep,y=a.hasTouch,H=a.inArray,J=
	a.isArray,t=a.isFirefox,K=a.isMS,x=a.isObject,C=a.isString,L=a.isWebKit,q=a.merge,A=a.noop,E=a.objectEach,F=a.pick,k=a.pInt,u=a.removeEvent,R=a.stop,M=a.svg,P=a.SVG_NS,I=a.symbolSizes,Q=a.win;D=a.SVGElement=function(){return this};f(D.prototype,{opacity:1,SVG_NS:P,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "),init:function(a,k){this.element="span"===k?w(k):m.createElementNS(this.SVG_NS,k);this.renderer=
	a},animate:function(z,k,b){k=a.animObject(F(k,this.renderer.globalAnimation,!0));0!==k.duration?(b&&(k.complete=b),p(this,z,k)):(this.attr(z,null,b),k.step&&k.step.call(this));return this},colorGradient:function(z,k,b){var u=this.renderer,f,O,d,e,y,m,h,M,A,I,x=[],t;z.radialGradient?O="radialGradient":z.linearGradient&&(O="linearGradient");O&&(d=z[O],y=u.gradients,h=z.stops,I=b.radialReference,J(d)&&(z[O]=d={x1:d[0],y1:d[1],x2:d[2],y2:d[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===O&&I&&
	!v(d.gradientUnits)&&(e=d,d=q(d,u.getRadialAttr(I,e),{gradientUnits:"userSpaceOnUse"})),E(d,function(a,z){"id"!==z&&x.push(z,a)}),E(h,function(a){x.push(a)}),x=x.join(","),y[x]?I=y[x].attr("id"):(d.id=I=a.uniqueKey(),y[x]=m=u.createElement(O).attr(d).add(u.defs),m.radAttr=e,m.stops=[],c(h,function(z){0===z[1].indexOf("rgba")?(f=a.color(z[1]),M=f.get("rgb"),A=f.get("a")):(M=z[1],A=1);z=u.createElement("stop").attr({offset:z[0],"stop-color":M,"stop-opacity":A}).add(m);m.stops.push(z)})),t="url("+u.url+
	"#"+I+")",b.setAttribute(k,t),b.gradient=x,z.toString=function(){return t})},applyTextOutline:function(z){var k=this.element,u,f,d,q,e;-1!==z.indexOf("contrast")&&(z=z.replace(/contrast/g,this.renderer.getContrast(k.style.fill)));z=z.split(" ");f=z[z.length-1];if((d=z[0])&&"none"!==d&&a.svg){this.fakeTS=!0;z=[].slice.call(k.getElementsByTagName("tspan"));this.ySetter=this.xSetter;d=d.replace(/(^[\d\.]+)(.*?)$/g,function(a,z,k){return 2*z+k});for(e=z.length;e--;)u=z[e],"highcharts-text-outline"===
	u.getAttribute("class")&&b(z,k.removeChild(u));q=k.firstChild;c(z,function(a,z){0===z&&(a.setAttribute("x",k.getAttribute("x")),z=k.getAttribute("y"),a.setAttribute("y",z||0),null===z&&k.setAttribute("y",0));a=a.cloneNode(1);g(a,{"class":"highcharts-text-outline",fill:f,stroke:f,"stroke-width":d,"stroke-linejoin":"round"});k.insertBefore(a,q)})}},attr:function(a,k,b,u){var z,f=this.element,d,c=this,O,q;"string"===typeof a&&void 0!==k&&(z=a,a={},a[z]=k);"string"===typeof a?c=(this[a+"Getter"]||this._defaultGetter).call(this,
	a,f):(E(a,function(z,k){O=!1;u||R(this,k);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(k)&&(d||(this.symbolAttr(a),d=!0),O=!0);!this.rotation||"x"!==k&&"y"!==k||(this.doTransform=!0);O||(q=this[k+"Setter"]||this._defaultSetter,q.call(this,z,k,f),this.shadows&&/^(width|height|visibility|x|y|d|transform|cx|cy|r)$/.test(k)&&this.updateShadows(k,z,q))},this),this.afterSetters());b&&b();return c},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=
	!1)},updateShadows:function(a,k,b){for(var z=this.shadows,u=z.length;u--;)b.call(z[u],"height"===a?Math.max(k-(z[u].cutHeight||0),0):"d"===a?this.d:k,a,z[u])},addClass:function(a,k){var z=this.attr("class")||"";-1===z.indexOf(a)&&(k||(a=(z+(z?" ":"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==H(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var z=
	this;c("x y r start end width height innerR anchorX anchorY".split(" "),function(k){z[k]=F(a[k],z[k])});z.attr({d:z.renderer.symbols[z.symbolName](z.x,z.y,z.width,z.height,z)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+"#"+a.id+")":"none")},crisp:function(a,k){var z=this,b={},u;k=k||a.strokeWidth||0;u=Math.round(k)%2/2;a.x=Math.floor(a.x||z.x||0)+u;a.y=Math.floor(a.y||z.y||0)+u;a.width=Math.floor((a.width||z.width||0)-2*u);a.height=Math.floor((a.height||z.height||0)-
	2*u);v(a.strokeWidth)&&(a.strokeWidth=k);E(a,function(a,k){z[k]!==a&&(z[k]=b[k]=a)});return b},css:function(a){var z=this.styles,b={},u=this.element,d,c="",q,e=!z,y=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);z&&E(a,function(a,k){a!==z[k]&&(b[k]=a,e=!0)});e&&(z&&(a=f(z,b)),d=this.textWidth=a&&a.width&&"auto"!==a.width&&"text"===u.nodeName.toLowerCase()&&k(a.width),this.styles=a,d&&!M&&this.renderer.forExport&&delete a.width,K&&!M?n(this.element,a):(q=function(a,z){return"-"+
	z.toLowerCase()},E(a,function(a,z){-1===H(z,y)&&(c+=z.replace(/([A-Z])/g,q)+":"+a+";")}),c&&g(u,"style",c)),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},strokeWidth:function(){return this["stroke-width"]||0},on:function(a,k){var z=this,b=z.element;y&&"click"===a?(b.ontouchstart=function(a){z.touchEventFired=Date.now();a.preventDefault();k.call(b,a)},b.onclick=function(a){(-1===Q.navigator.userAgent.indexOf("Android")||
	1100<Date.now()-(z.touchEventFired||0))&&k.call(b,a)}):b["on"+a]=k;return this},setRadialReference:function(a){var z=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;z&&z.radAttr&&z.animate(this.renderer.getRadialAttr(a,z.radAttr));return this},translate:function(a,k){return this.attr({translateX:a,translateY:k})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=this.translateX||0,k=this.translateY||0,b=this.scaleX,
	u=this.scaleY,f=this.inverted,d=this.rotation,c=this.matrix,q=this.element;f&&(a+=this.width,k+=this.height);a=["translate("+a+","+k+")"];v(c)&&a.push("matrix("+c.join(",")+")");f?a.push("rotate(90) scale(-1,1)"):d&&a.push("rotate("+d+" "+F(this.rotationOriginX,q.getAttribute("x"),0)+" "+F(this.rotationOriginY,q.getAttribute("y")||0)+")");(v(b)||v(u))&&a.push("scale("+F(b,1)+" "+F(u,1)+")");a.length&&q.setAttribute("transform",a.join(" "))},toFront:function(){var a=this.element;a.parentNode.appendChild(a);
	return this},align:function(a,k,u){var z,f,d,c,q={};f=this.renderer;d=f.alignedObjects;var e,O;if(a){if(this.alignOptions=a,this.alignByTranslate=k,!u||C(u))this.alignTo=z=u||"renderer",b(d,this),d.push(this),u=null}else a=this.alignOptions,k=this.alignByTranslate,z=this.alignTo;u=F(u,f[z],f);z=a.align;f=a.verticalAlign;d=(u.x||0)+(a.x||0);c=(u.y||0)+(a.y||0);"right"===z?e=1:"center"===z&&(e=2);e&&(d+=(u.width-(a.width||0))/e);q[k?"translateX":"x"]=Math.round(d);"bottom"===f?O=1:"middle"===f&&(O=
	2);O&&(c+=(u.height-(a.height||0))/O);q[k?"translateY":"y"]=Math.round(c);this[this.placed?"animate":"attr"](q);this.placed=!0;this.alignAttr=q;return this},getBBox:function(a,k){var z,b=this.renderer,u,d=this.element,q=this.styles,O,y=this.textStr,m,h=b.cache,M=b.cacheKeys,A;k=F(k,this.rotation);u=k*e;O=q&&q.fontSize;v(y)&&(A=y.toString(),-1===A.indexOf("\x3c")&&(A=A.replace(/[0-9]/g,"0")),A+=["",k||0,O,q&&q.width,q&&q.textOverflow].join());A&&!a&&(z=h[A]);if(!z){if(d.namespaceURI===this.SVG_NS||
	b.forExport){try{(m=this.fakeTS&&function(a){c(d.querySelectorAll(".highcharts-text-outline"),function(z){z.style.display=a})})&&m("none"),z=d.getBBox?f({},d.getBBox()):{width:d.offsetWidth,height:d.offsetHeight},m&&m("")}catch(W){}if(!z||0>z.width)z={width:0,height:0}}else z=this.htmlGetBBox();b.isSVG&&(a=z.width,b=z.height,q&&"11px"===q.fontSize&&17===Math.round(b)&&(z.height=b=14),k&&(z.width=Math.abs(b*Math.sin(u))+Math.abs(a*Math.cos(u)),z.height=Math.abs(b*Math.cos(u))+Math.abs(a*Math.sin(u))));
	if(A&&0<z.height){for(;250<M.length;)delete h[M.shift()];h[A]||M.push(A);h[A]=z}}return z},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var z=this;z.animate({opacity:0},{duration:a||150,complete:function(){z.attr({y:-9999})}})},add:function(a){var z=this.renderer,k=this.element,b;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;void 0!==this.textStr&&z.buildText(this);this.added=!0;if(!a||
	a.handleZ||this.zIndex)b=this.zIndexSetter();b||(a?a.element:z.box).appendChild(k);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var z=a.parentNode;z&&z.removeChild(a)},destroy:function(){var a=this,k=a.element||{},u=a.renderer.isSVG&&"SPAN"===k.nodeName&&a.parentGroup,f=k.ownerSVGElement;k.onclick=k.onmouseout=k.onmouseover=k.onmousemove=k.point=null;R(a);a.clipPath&&f&&(c(f.querySelectorAll("[clip-path],[CLIP-PATH]"),function(k){k.getAttribute("clip-path").match(RegExp('[("]#'+
	a.clipPath.element.id+'[)"]'))&&k.removeAttribute("clip-path")}),a.clipPath=a.clipPath.destroy());if(a.stops){for(f=0;f<a.stops.length;f++)a.stops[f]=a.stops[f].destroy();a.stops=null}a.safeRemoveChild(k);for(a.destroyShadows();u&&u.div&&0===u.div.childNodes.length;)k=u.parentGroup,a.safeRemoveChild(u.div),delete u.div,u=k;a.alignTo&&b(a.renderer.alignedObjects,a);E(a,function(k,z){delete a[z]});return null},shadow:function(a,k,b){var z=[],u,f,d=this.element,c,q,e,y;if(!a)this.destroyShadows();else if(!this.shadows){q=
	F(a.width,3);e=(a.opacity||.15)/q;y=this.parentInverted?"(-1,-1)":"("+F(a.offsetX,1)+", "+F(a.offsetY,1)+")";for(u=1;u<=q;u++)f=d.cloneNode(0),c=2*q+1-2*u,g(f,{isShadow:"true",stroke:a.color||"#000000","stroke-opacity":e*u,"stroke-width":c,transform:"translate"+y,fill:"none"}),b&&(g(f,"height",Math.max(g(f,"height")-c,0)),f.cutHeight=c),k?k.element.appendChild(f):d.parentNode&&d.parentNode.insertBefore(f,d),z.push(f);this.shadows=z}return this},destroyShadows:function(){c(this.shadows||[],function(a){this.safeRemoveChild(a)},
	this);this.shadows=void 0},xGetter:function(a){"circle"===this.element.nodeName&&("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=F(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,k,b){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[k]!==a&&(b.setAttribute(k,a),this[k]=a)},dashstyleSetter:function(a){var b,u=this["stroke-width"];"inherit"===u&&(u=1);if(a=
	a&&a.toLowerCase()){a=a.replace("shortdashdotdot","3,1,1,1,1,1,").replace("shortdashdot","3,1,1,1").replace("shortdot","1,1,").replace("shortdash","3,1,").replace("longdash","8,3,").replace(/dot/g,"1,3,").replace("dash","4,3,").replace(/,$/,"").split(",");for(b=a.length;b--;)a[b]=k(a[b])*u;a=a.join(",").replace(/NaN/g,"none");this.element.setAttribute("stroke-dasharray",a)}},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,
	k,b){this[k]=a;b.setAttribute(k,a)},titleSetter:function(a){var k=this.element.getElementsByTagName("title")[0];k||(k=m.createElementNS(this.SVG_NS,"title"),this.element.appendChild(k));k.firstChild&&k.removeChild(k.firstChild);k.appendChild(m.createTextNode(String(F(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,k,b){"string"===typeof a?b.setAttribute(k,a):a&&this.colorGradient(a,
	k,b)},visibilitySetter:function(a,k,b){"inherit"===a?b.removeAttribute(k):this[k]!==a&&b.setAttribute(k,a);this[k]=a},zIndexSetter:function(a,b){var u=this.renderer,z=this.parentGroup,f=(z||u).element||u.box,d,c=this.element,q,e,u=f===u.box;d=this.added;var y;v(a)&&(c.zIndex=a,a=+a,this[b]===a&&(d=!1),this[b]=a);if(d){(a=this.zIndex)&&z&&(z.handleZ=!0);b=f.childNodes;for(y=b.length-1;0<=y&&!q;y--)if(z=b[y],d=z.zIndex,e=!v(d),z!==c)if(0>a&&e&&!u&&!y)f.insertBefore(c,b[y]),q=!0;else if(k(d)<=a||e&&
	(!v(a)||0<=a))f.insertBefore(c,b[y+1]||null),q=!0;q||(f.insertBefore(c,b[u?3:0]||null),q=!0)}return q},_defaultSetter:function(a,k,b){b.setAttribute(k,a)}});D.prototype.yGetter=D.prototype.xGetter;D.prototype.translateXSetter=D.prototype.translateYSetter=D.prototype.rotationSetter=D.prototype.verticalAlignSetter=D.prototype.rotationOriginXSetter=D.prototype.rotationOriginYSetter=D.prototype.scaleXSetter=D.prototype.scaleYSetter=D.prototype.matrixSetter=function(a,k){this[k]=a;this.doTransform=!0};
	D.prototype["stroke-widthSetter"]=D.prototype.strokeSetter=function(a,k,b){this[k]=a;this.stroke&&this["stroke-width"]?(D.prototype.fillSetter.call(this,this.stroke,"stroke",b),b.setAttribute("stroke-width",this["stroke-width"]),this.hasStroke=!0):"stroke-width"===k&&0===a&&this.hasStroke&&(b.removeAttribute("stroke"),this.hasStroke=!1)};B=a.SVGRenderer=function(){this.init.apply(this,arguments)};f(B.prototype,{Element:D,SVG_NS:P,init:function(a,k,b,u,f,d){var z;u=this.createElement("svg").attr({version:"1.1",
	"class":"highcharts-root"}).css(this.getStyle(u));z=u.element;a.appendChild(z);g(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&g(z,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=z;this.boxWrapper=u;this.alignedObjects=[];this.url=(t||L)&&m.getElementsByTagName("base").length?Q.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(m.createTextNode("Created with Highcharts 6.0.3"));this.defs=
	this.createElement("defs").add();this.allowHTML=d;this.forExport=f;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(k,b,!1);var c;t&&a.getBoundingClientRect&&(k=function(){n(a,{left:0,top:0});c=a.getBoundingClientRect();n(a,{left:Math.ceil(c.left)-c.left+"px",top:Math.ceil(c.top)-c.top+"px"})},k(),this.unSubPixelFix=G(Q,"resize",k))},getStyle:function(a){return this.style=f({fontFamily:'"Lucida Grande", "Lucida Sans Unicode", Arial, Helvetica, sans-serif',fontSize:"12px"},
	a)},setStyle:function(a){this.boxWrapper.css(this.getStyle(a))},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();h(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var k=new this.Element;k.init(this,a);return k},draw:A,getRadialAttr:function(a,k){return{cx:a[0]-a[2]/2+k.cx*a[2],cy:a[1]-
	a[2]/2+k.cy*a[2],r:k.r*a[2]}},getSpanWidth:function(a,k){var b=a.getBBox(!0).width;!M&&this.forExport&&(b=this.measureSpanWidth(k.firstChild.data,a.styles));return b},applyEllipsis:function(a,k,b,u){var f=a.rotation,z=b,d,c=0,q=b.length,e=function(a){k.removeChild(k.firstChild);a&&k.appendChild(m.createTextNode(a))},y;a.rotation=0;z=this.getSpanWidth(a,k);if(y=z>u){for(;c<=q;)d=Math.ceil((c+q)/2),z=b.substring(0,d)+"\u2026",e(z),z=this.getSpanWidth(a,k),c===q?c=q+1:z>u?q=d-1:c=d;0===q&&e("")}a.rotation=
	f;return y},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot"},buildText:function(a){var b=a.element,u=this,f=u.forExport,z=F(a.textStr,"").toString(),q=-1!==z.indexOf("\x3c"),e=b.childNodes,y,h,A,I,x=g(b,"x"),t=a.styles,H=a.textWidth,l=t&&t.lineHeight,C=t&&t.textOutline,v=t&&"ellipsis"===t.textOverflow,R=t&&"nowrap"===t.whiteSpace,w=t&&t.fontSize,Q,J,r=e.length,t=H&&!a.added&&this.box,K=function(a){var f;f=/(px|em)$/.test(a&&a.style.fontSize)?a.style.fontSize:
	w||u.style.fontSize||12;return l?k(l):u.fontMetrics(f,a.getAttribute("style")?a:b).h},p=function(a){E(u.escapes,function(k,b){a=a.replace(new RegExp(k,"g"),b)});return a};Q=[z,v,R,l,C,w,H].join();if(Q!==a.textCache){for(a.textCache=Q;r--;)b.removeChild(e[r]);q||C||v||H||-1!==z.indexOf(" ")?(y=/<.*class="([^"]+)".*>/,h=/<.*style="([^"]+)".*>/,A=/<.*href="([^"]+)".*>/,t&&t.appendChild(b),z=q?z.replace(/<(b|strong)>/g,'\x3cspan style\x3d"font-weight:bold"\x3e').replace(/<(i|em)>/g,'\x3cspan style\x3d"font-style:italic"\x3e').replace(/<a/g,
	"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[z],z=d(z,function(a){return""!==a}),c(z,function(k,z){var d,q=0;k=k.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");d=k.split("|||");c(d,function(k){if(""!==k||1===d.length){var c={},e=m.createElementNS(u.SVG_NS,"tspan"),t,E;y.test(k)&&(t=k.match(y)[1],g(e,"class",t));h.test(k)&&(E=k.match(h)[1].replace(/(;| |^)color([ :])/,"$1fill$2"),g(e,"style",E));A.test(k)&&!f&&(g(e,
	"onclick",'location.href\x3d"'+k.match(A)[1]+'"'),g(e,"class","highcharts-anchor"),n(e,{cursor:"pointer"}));k=p(k.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==k){e.appendChild(m.createTextNode(k));q?c.dx=0:z&&null!==x&&(c.x=x);g(e,c);b.appendChild(e);!q&&J&&(!M&&f&&n(e,{display:"block"}),g(e,"dy",K(e)));if(H){c=k.replace(/([^\^])-/g,"$1- ").split(" ");t=1<d.length||z||1<c.length&&!R;var O=[],l,C=K(e),F=a.rotation;for(v&&(I=u.applyEllipsis(a,e,k,H));!v&&t&&(c.length||O.length);)a.rotation=0,
	l=u.getSpanWidth(a,e),k=l>H,void 0===I&&(I=k),k&&1!==c.length?(e.removeChild(e.firstChild),O.unshift(c.pop())):(c=O,O=[],c.length&&!R&&(e=m.createElementNS(P,"tspan"),g(e,{dy:C,x:x}),E&&g(e,"style",E),b.appendChild(e)),l>H&&(H=l)),c.length&&e.appendChild(m.createTextNode(c.join(" ").replace(/- /g,"-")));a.rotation=F}q++}}});J=J||b.childNodes.length}),I&&a.attr("title",a.textStr),t&&t.removeChild(b),C&&a.applyTextOutline&&a.applyTextOutline(C)):b.appendChild(m.createTextNode(p(z)))}},getContrast:function(a){a=
	r(a).rgba;return 510<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,k,b,u,d,c,e,y,m){var z=this.label(a,k,b,m,null,null,null,null,"button"),h=0;z.attr(q({padding:8,r:2},d));var A,M,I,t;d=q({fill:"#f7f7f7",stroke:"#cccccc","stroke-width":1,style:{color:"#333333",cursor:"pointer",fontWeight:"normal"}},d);A=d.style;delete d.style;c=q(d,{fill:"#e6e6e6"},c);M=c.style;delete c.style;e=q(d,{fill:"#e6ebf5",style:{color:"#000000",fontWeight:"bold"}},e);I=e.style;delete e.style;y=q(d,{style:{color:"#cccccc"}},
	y);t=y.style;delete y.style;G(z.element,K?"mouseover":"mouseenter",function(){3!==h&&z.setState(1)});G(z.element,K?"mouseout":"mouseleave",function(){3!==h&&z.setState(h)});z.setState=function(a){1!==a&&(z.state=h=a);z.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal","hover","pressed","disabled"][a||0]);z.attr([d,c,e,y][a||0]).css([A,M,I,t][a||0])};z.attr(d).css(f({cursor:"default"},A));return z.on("click",function(a){3!==h&&u.call(z,a)})},crispLine:function(a,
	k){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-k%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+k%2/2);return a},path:function(a){var k={fill:"none"};J(a)?k.d=a:x(a)&&f(k,a);return this.createElement("path").attr(k)},circle:function(a,k,b){a=x(a)?a:{x:a,y:k,r:b};k=this.createElement("circle");k.xSetter=k.ySetter=function(a,k,b){b.setAttribute("c"+k,a)};return k.attr(a)},arc:function(a,k,b,u,d,f){x(a)?(u=a,k=u.y,b=u.r,a=u.x):u={innerR:u,start:d,end:f};a=this.symbol("arc",a,k,b,b,u);a.r=b;return a},rect:function(a,
	k,b,u,d,f){d=x(a)?a.r:d;var c=this.createElement("rect");a=x(a)?a:void 0===a?{}:{x:a,y:k,width:Math.max(b,0),height:Math.max(u,0)};void 0!==f&&(a.strokeWidth=f,a=c.crisp(a));a.fill="none";d&&(a.r=d);c.rSetter=function(a,k,b){g(b,{rx:a,ry:a})};return c.attr(a)},setSize:function(a,k,b){var u=this.alignedObjects,d=u.length;this.width=a;this.height=k;for(this.boxWrapper.animate({width:a,height:k},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+" "+this.attr("height")})},duration:F(b,!0)?
	void 0:0});d--;)u[d].align()},g:function(a){var k=this.createElement("g");return a?k.attr({"class":"highcharts-"+a}):k},image:function(a,k,b,u,d){var c={preserveAspectRatio:"none"};1<arguments.length&&f(c,{x:k,y:b,width:u,height:d});c=this.createElement("image").attr(c);c.element.setAttributeNS?c.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):c.element.setAttribute("hc-svg-href",a);return c},symbol:function(a,k,b,u,d,q){var e=this,z,y=/^url\((.*?)\)$/,h=y.test(a),A=!h&&(this.symbols[a]?
	a:"circle"),M=A&&this.symbols[A],t=v(k)&&M&&M.call(this.symbols,Math.round(k),Math.round(b),u,d,q),x,E;M?(z=this.path(t),z.attr("fill","none"),f(z,{symbolName:A,x:k,y:b,width:u,height:d}),q&&f(z,q)):h&&(x=a.match(y)[1],z=this.image(x),z.imgwidth=F(I[x]&&I[x].width,q&&q.width),z.imgheight=F(I[x]&&I[x].height,q&&q.height),E=function(){z.attr({width:z.width,height:z.height})},c(["width","height"],function(a){z[a+"Setter"]=function(a,k){var b={},u=this["img"+k],d="width"===k?"translateX":"translateY";
	this[k]=a;v(u)&&(this.element&&this.element.setAttribute(k,u),this.alignByTranslate||(b[d]=((this[k]||0)-u)/2,this.attr(b)))}}),v(k)&&z.attr({x:k,y:b}),z.isImg=!0,v(z.imgwidth)&&v(z.imgheight)?E():(z.attr({width:0,height:0}),w("img",{onload:function(){var a=l[e.chartIndex];0===this.width&&(n(this,{position:"absolute",top:"-999em"}),m.body.appendChild(this));I[x]={width:this.width,height:this.height};z.imgwidth=this.width;z.imgheight=this.height;z.element&&E();this.parentNode&&this.parentNode.removeChild(this);
	e.imgCount--;if(!e.imgCount&&a&&a.onload)a.onload()},src:x}),this.imgCount++));return z},symbols:{circle:function(a,k,b,u){return this.arc(a+b/2,k+u/2,b/2,u/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,k,b,u){return["M",a,k,"L",a+b,k,a+b,k+u,a,k+u,"Z"]},triangle:function(a,k,b,u){return["M",a+b/2,k,"L",a+b,k+u,a,k+u,"Z"]},"triangle-down":function(a,k,b,u){return["M",a,k,"L",a+b,k,a+b/2,k+u,"Z"]},diamond:function(a,k,b,u){return["M",a+b/2,k,"L",a+b,k+u/2,a+b/2,k+u,a,k+u/2,"Z"]},arc:function(a,
	k,b,u,d){var f=d.start,c=d.r||b,q=d.r||u||b,e=d.end-.001;b=d.innerR;u=F(d.open,.001>Math.abs(d.end-d.start-2*Math.PI));var z=Math.cos(f),y=Math.sin(f),h=Math.cos(e),e=Math.sin(e);d=.001>d.end-f-Math.PI?0:1;c=["M",a+c*z,k+q*y,"A",c,q,0,d,1,a+c*h,k+q*e];v(b)&&c.push(u?"M":"L",a+b*h,k+b*e,"A",b,b,0,d,0,a+b*z,k+b*y);c.push(u?"":"Z");return c},callout:function(a,k,b,u,d){var f=Math.min(d&&d.r||0,b,u),c=f+6,q=d&&d.anchorX;d=d&&d.anchorY;var e;e=["M",a+f,k,"L",a+b-f,k,"C",a+b,k,a+b,k,a+b,k+f,"L",a+b,k+u-
	f,"C",a+b,k+u,a+b,k+u,a+b-f,k+u,"L",a+f,k+u,"C",a,k+u,a,k+u,a,k+u-f,"L",a,k+f,"C",a,k,a,k,a+f,k];q&&q>b?d>k+c&&d<k+u-c?e.splice(13,3,"L",a+b,d-6,a+b+6,d,a+b,d+6,a+b,k+u-f):e.splice(13,3,"L",a+b,u/2,q,d,a+b,u/2,a+b,k+u-f):q&&0>q?d>k+c&&d<k+u-c?e.splice(33,3,"L",a,d+6,a-6,d,a,d-6,a,k+f):e.splice(33,3,"L",a,u/2,q,d,a,u/2,a,k+f):d&&d>u&&q>a+c&&q<a+b-c?e.splice(23,3,"L",q+6,k+u,q,k+u+6,q-6,k+u,a+f,k+u):d&&0>d&&q>a+c&&q<a+b-c&&e.splice(3,3,"L",q-6,k,q,k-6,q+6,k,b-f,k);return e}},clipRect:function(k,b,u,
	d){var f=a.uniqueKey(),c=this.createElement("clipPath").attr({id:f}).add(this.defs);k=this.rect(k,b,u,d,0).add(c);k.id=f;k.clipPath=c;k.count=0;return k},text:function(a,k,b,u){var d={};if(u&&(this.allowHTML||!this.forExport))return this.html(a,k,b);d.x=Math.round(k||0);b&&(d.y=Math.round(b));if(a||0===a)d.text=a;a=this.createElement("text").attr(d);u||(a.xSetter=function(a,k,b){var u=b.getElementsByTagName("tspan"),d,f=b.getAttribute(k),c;for(c=0;c<u.length;c++)d=u[c],d.getAttribute(k)===f&&d.setAttribute(k,
	a);b.setAttribute(k,a)});return a},fontMetrics:function(a,b){a=a||b&&b.style&&b.style.fontSize||this.style&&this.style.fontSize;a=/px/.test(a)?k(a):/em/.test(a)?parseFloat(a)*(b?this.fontMetrics(null,b.parentNode).f:16):12;b=24>a?a+3:Math.round(1.2*a);return{h:b,b:Math.round(.8*b),f:a}},rotCorr:function(a,k,b){var u=a;k&&b&&(u=Math.max(u*Math.cos(k*e),4));return{x:-a/3*Math.sin(k*e),y:u}},label:function(k,b,d,e,y,h,m,A,M){var z=this,I=z.g("button"!==M&&"label"),x=I.text=z.text("",0,0,m).attr({zIndex:1}),
	t,E,H=0,n=3,l=0,g,C,R,F,w,Q={},P,J,r=/^url\((.*?)\)$/.test(e),K=r,p,O,L,T;M&&I.addClass("highcharts-"+M);K=r;p=function(){return(P||0)%2/2};O=function(){var a=x.element.style,k={};E=(void 0===g||void 0===C||w)&&v(x.textStr)&&x.getBBox();I.width=(g||E.width||0)+2*n+l;I.height=(C||E.height||0)+2*n;J=n+z.fontMetrics(a&&a.fontSize,x).b;K&&(t||(I.box=t=z.symbols[e]||r?z.symbol(e):z.rect(),t.addClass(("button"===M?"":"highcharts-label-box")+(M?" highcharts-"+M+"-box":"")),t.add(I),a=p(),k.x=a,k.y=(A?-J:
	0)+a),k.width=Math.round(I.width),k.height=Math.round(I.height),t.attr(f(k,Q)),Q={})};L=function(){var a=l+n,k;k=A?0:J;v(g)&&E&&("center"===w||"right"===w)&&(a+={center:.5,right:1}[w]*(g-E.width));if(a!==x.x||k!==x.y)x.attr("x",a),void 0!==k&&x.attr("y",k);x.x=a;x.y=k};T=function(a,k){t?t.attr(a,k):Q[a]=k};I.onAdd=function(){x.add(I);I.attr({text:k||0===k?k:"",x:b,y:d});t&&v(y)&&I.attr({anchorX:y,anchorY:h})};I.widthSetter=function(k){g=a.isNumber(k)?k:null};I.heightSetter=function(a){C=a};I["text-alignSetter"]=
	function(a){w=a};I.paddingSetter=function(a){v(a)&&a!==n&&(n=I.padding=a,L())};I.paddingLeftSetter=function(a){v(a)&&a!==l&&(l=a,L())};I.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==H&&(H=a,E&&I.attr({x:R}))};I.textSetter=function(a){void 0!==a&&x.textSetter(a);O();L()};I["stroke-widthSetter"]=function(a,k){a&&(K=!0);P=this["stroke-width"]=a;T(k,a)};I.strokeSetter=I.fillSetter=I.rSetter=function(a,k){"r"!==k&&("fill"===k&&a&&(K=!0),I[k]=a);T(k,a)};I.anchorXSetter=function(a,k){y=I.anchorX=
	a;T(k,Math.round(a)-p()-R)};I.anchorYSetter=function(a,k){h=I.anchorY=a;T(k,a-F)};I.xSetter=function(a){I.x=a;H&&(a-=H*((g||E.width)+2*n));R=Math.round(a);I.attr("translateX",R)};I.ySetter=function(a){F=I.y=Math.round(a);I.attr("translateY",F)};var U=I.css;return f(I,{css:function(a){if(a){var k={};a=q(a);c(I.textProps,function(b){void 0!==a[b]&&(k[b]=a[b],delete a[b])});x.css(k)}return U.call(I,a)},getBBox:function(){return{width:E.width+2*n,height:E.height+2*n,x:E.x-n,y:E.y-n}},shadow:function(a){a&&
	(O(),t&&t.shadow(a));return I},destroy:function(){u(I.element,"mouseenter");u(I.element,"mouseleave");x&&(x=x.destroy());t&&(t=t.destroy());D.prototype.destroy.call(I);I=z=O=L=T=null}})}});a.Renderer=B})(N);(function(a){var D=a.attr,B=a.createElement,G=a.css,p=a.defined,g=a.each,l=a.extend,r=a.isFirefox,n=a.isMS,w=a.isWebKit,v=a.pick,e=a.pInt,h=a.SVGRenderer,m=a.win,c=a.wrap;l(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&"SPAN"===b.tagName&&a.width)delete a.width,this.textWidth=
	b,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=l(this.styles,a);G(this.element,a);return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,b=this.element,d=this.translateX||0,c=this.translateY||0,h=this.x||0,m=this.y||0,t=this.textAlign||"left",n={left:0,center:.5,right:1}[t],x=this.styles;
	G(b,{marginLeft:d,marginTop:c});this.shadows&&g(this.shadows,function(a){G(a,{marginLeft:d+1,marginTop:c+1})});this.inverted&&g(b.childNodes,function(d){a.invertChild(d,b)});if("SPAN"===b.tagName){var l=this.rotation,v=e(this.textWidth),q=x&&x.whiteSpace,A=[l,t,b.innerHTML,this.textWidth,this.textAlign].join();A!==this.cTT&&(x=a.fontMetrics(b.style.fontSize).b,p(l)&&this.setSpanRotation(l,n,x),G(b,{width:"",whiteSpace:q||"nowrap"}),b.offsetWidth>v&&/[ \-]/.test(b.textContent||b.innerText)&&G(b,{width:v+
	"px",display:"block",whiteSpace:q||"normal"}),this.getSpanCorrection(b.offsetWidth,x,n,l,t));G(b,{left:h+(this.xCorr||0)+"px",top:m+(this.yCorr||0)+"px"});w&&(x=b.offsetHeight);this.cTT=A}}else this.alignOnAdd=!0},setSpanRotation:function(a,b,d){var c={},f=this.renderer.getTransformKey();c[f]=c.transform="rotate("+a+"deg)";c[f+(r?"Origin":"-origin")]=c.transformOrigin=100*b+"% "+d+"px";G(this.element,c)},getSpanCorrection:function(a,b,d){this.xCorr=-a*d;this.yCorr=-b}});l(h.prototype,{getTransformKey:function(){return n&&
	!/Edge/.test(m.navigator.userAgent)?"-ms-transform":w?"-webkit-transform":r?"MozTransform":m.opera?"-o-transform":""},html:function(a,b,d){var f=this.createElement("span"),e=f.element,h=f.renderer,m=h.isSVG,w=function(a,b){g(["opacity","visibility"],function(d){c(a,d+"Setter",function(a,d,f,c){a.call(this,d,f,c);b[f]=d})})};f.textSetter=function(a){a!==e.innerHTML&&delete this.bBox;this.textStr=a;e.innerHTML=v(a,"");f.htmlUpdateTransform()};m&&w(f,f.element.style);f.xSetter=f.ySetter=f.alignSetter=
	f.rotationSetter=function(a,b){"align"===b&&(b="textAlign");f[b]=a;f.htmlUpdateTransform()};f.attr({text:a,x:Math.round(b),y:Math.round(d)}).css({fontFamily:this.style.fontFamily,fontSize:this.style.fontSize,position:"absolute"});e.style.whiteSpace="nowrap";f.css=f.htmlCss;m&&(f.add=function(a){var b,d=h.box.parentNode,c=[];if(this.parentGroup=a){if(b=a.div,!b){for(;a;)c.push(a),a=a.parentGroup;g(c.reverse(),function(a){function e(k,b){a[b]=k;n?q[h.getTransformKey()]="translate("+(a.x||a.translateX)+
	"px,"+(a.y||a.translateY)+"px)":"translateX"===b?q.left=k+"px":q.top=k+"px";a.doTransform=!0}var q,k=D(a.element,"class");k&&(k={className:k});b=a.div=a.div||B("div",k,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},b||d);q=b.style;l(a,{classSetter:function(a){this.element.setAttribute("class",a);b.className=a},on:function(){c[0].div&&f.on.apply({element:c[0].div},arguments);return a},translateXSetter:e,
	translateYSetter:e});w(a,q)})}}else b=d;b.appendChild(e);f.added=!0;f.alignOnAdd&&f.htmlUpdateTransform();return f});return f}})})(N);(function(a){function D(){var n=a.defaultOptions.global,l=r.moment;if(n.timezone){if(l)return function(a){return-l.tz(a,n.timezone).utcOffset()};a.error(25)}return n.useUTC&&n.getTimezoneOffset}function B(){var n=a.defaultOptions.global,g,v=n.useUTC,e=v?"getUTC":"get",h=v?"setUTC":"set",m="Minutes Hours Day Date Month FullYear".split(" "),c=m.concat(["Milliseconds",
	"Seconds"]);a.Date=g=n.Date||r.Date;g.hcTimezoneOffset=v&&n.timezoneOffset;g.hcGetTimezoneOffset=D();g.hcMakeTime=function(a,b,d,c,e,h){var f;v?(f=g.UTC.apply(0,arguments),f+=p(f)):f=(new g(a,b,l(d,1),l(c,0),l(e,0),l(h,0))).getTime();return f};for(n=0;n<m.length;n++)g["hcGet"+m[n]]=e+m[n];for(n=0;n<c.length;n++)g["hcSet"+c[n]]=h+c[n]}var G=a.color,p=a.getTZOffset,g=a.merge,l=a.pick,r=a.win;a.defaultOptions={colors:"#7cb5ec #434348 #90ed7d #f7a35c #8085e9 #f15c80 #e4d354 #2b908f #f45b5b #91e8e1".split(" "),
	symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0},chart:{borderRadius:0,
	defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null,borderColor:"#335cad",backgroundColor:"#ffffff",plotBorderColor:"#cccccc"},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},
	borderColor:"#999999",borderRadius:0,navigation:{activeColor:"#003399",inactiveColor:"#cccccc"},itemStyle:{color:"#333333",fontSize:"12px",fontWeight:"bold",textOverflow:"ellipsis"},itemHoverStyle:{color:"#000000"},itemHiddenStyle:{color:"#cccccc"},shadow:!1,itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{style:{fontWeight:"bold"}}},loading:{labelStyle:{fontWeight:"bold",position:"relative",top:"45%"},style:{position:"absolute",
	backgroundColor:"#ffffff",opacity:.5,textAlign:"center"}},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,backgroundColor:G("#f7f7f7").setOpacity(.85).get(),borderWidth:1,headerFormat:'\x3cspan style\x3d"font-size: 10px"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',
	pointFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e',shadow:!0,style:{color:"#333333",cursor:"default",fontSize:"12px",pointerEvents:"none",whiteSpace:"nowrap"}},credits:{enabled:!0,href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",y:-5},style:{cursor:"pointer",color:"#999999",fontSize:"9px"},text:"Highcharts.com"}};a.setOptions=function(n){a.defaultOptions=g(!0,a.defaultOptions,n);B();
	return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;B()})(N);(function(a){var D=a.correctFloat,B=a.defined,G=a.destroyObjectProperties,p=a.isNumber,g=a.merge,l=a.pick,r=a.deg2rad;a.Tick=function(a,g,l,e){this.axis=a;this.pos=g;this.type=l||"";this.isNewLabel=this.isNew=!0;l||e||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=this.axis,w=a.options,v=a.chart,e=a.categories,h=a.names,m=this.pos,c=w.labels,f=a.tickPositions,
	b=m===f[0],d=m===f[f.length-1],h=e?l(e[m],h[m],m):m,e=this.label,f=f.info,y;a.isDatetimeAxis&&f&&(y=w.dateTimeLabelFormats[f.higherRanks[m]||f.unitName]);this.isFirst=b;this.isLast=d;w=a.labelFormatter.call({axis:a,chart:v,isFirst:b,isLast:d,dateTimeLabelFormat:y,value:a.isLog?D(a.lin2log(h)):h,pos:m});B(e)?e&&e.attr({text:w}):(this.labelLength=(this.label=e=B(w)&&c.enabled?v.renderer.text(w,0,0,c.useHTML).css(g(c.style)).add(a.labelGroup):null)&&e.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?
	this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var g=this.axis,n=a.x,e=g.chart.chartWidth,h=g.chart.spacing,m=l(g.labelLeft,Math.min(g.pos,h[3])),h=l(g.labelRight,Math.max(g.pos+g.len,e-h[1])),c=this.label,f=this.rotation,b={left:0,center:.5,right:1}[g.labelAlign],d=c.getBBox().width,y=g.getSlotWidth(),H=y,J=1,t,p={};if(f)0>f&&n-b*d<m?t=Math.round(n/Math.cos(f*r)-m):0<f&&n+b*d>h&&(t=Math.round((e-n)/Math.cos(f*r)));else if(e=n+(1-b)*d,n-b*d<m?H=a.x+H*(1-b)-m:
	e>h&&(H=h-a.x+H*b,J=-1),H=Math.min(y,H),H<y&&"center"===g.labelAlign&&(a.x+=J*(y-H-b*(y-Math.min(d,H)))),d>H||g.autoRotation&&(c.styles||{}).width)t=H;t&&(p.width=t,(g.options.labels.style||{}).textOverflow||(p.textOverflow="ellipsis"),c.css(p))},getPosition:function(a,g,l,e){var h=this.axis,m=h.chart,c=e&&m.oldChartHeight||m.chartHeight;return{x:a?h.translate(g+l,null,null,e)+h.transB:h.left+h.offset+(h.opposite?(e&&m.oldChartWidth||m.chartWidth)-h.right-h.left:0),y:a?c-h.bottom+h.offset-(h.opposite?
	h.height:0):c-h.translate(g+l,null,null,e)-h.transB}},getLabelPosition:function(a,g,l,e,h,m,c,f){var b=this.axis,d=b.transA,y=b.reversed,n=b.staggerLines,v=b.tickRotCorr||{x:0,y:0},t=h.y;B(t)||(t=0===b.side?l.rotation?-8:-l.getBBox().height:2===b.side?v.y+8:Math.cos(l.rotation*r)*(v.y-l.getBBox(!1,0).height/2));a=a+h.x+v.x-(m&&e?m*d*(y?-1:1):0);g=g+t-(m&&!e?m*d*(y?1:-1):0);n&&(l=c/(f||1)%n,b.opposite&&(l=n-l-1),g+=b.labelOffset/n*l);return{x:a,y:Math.round(g)}},getMarkPath:function(a,g,l,e,h,m){return m.crispLine(["M",
	a,g,"L",a+(h?0:-l),g+(h?l:0)],e)},renderGridLine:function(a,g,l){var e=this.axis,h=e.options,m=this.gridLine,c={},f=this.pos,b=this.type,d=e.tickmarkOffset,y=e.chart.renderer,n=b?b+"Grid":"grid",v=h[n+"LineWidth"],t=h[n+"LineColor"],h=h[n+"LineDashStyle"];m||(c.stroke=t,c["stroke-width"]=v,h&&(c.dashstyle=h),b||(c.zIndex=1),a&&(c.opacity=0),this.gridLine=m=y.path().attr(c).addClass("highcharts-"+(b?b+"-":"")+"grid-line").add(e.gridGroup));if(!a&&m&&(a=e.getPlotLinePath(f+d,m.strokeWidth()*l,a,!0)))m[this.isNew?
	"attr":"animate"]({d:a,opacity:g})},renderMark:function(a,g,v){var e=this.axis,h=e.options,m=e.chart.renderer,c=this.type,f=c?c+"Tick":"tick",b=e.tickSize(f),d=this.mark,y=!d,n=a.x;a=a.y;var r=l(h[f+"Width"],!c&&e.isXAxis?1:0),h=h[f+"Color"];b&&(e.opposite&&(b[0]=-b[0]),y&&(this.mark=d=m.path().addClass("highcharts-"+(c?c+"-":"")+"tick").add(e.axisGroup),d.attr({stroke:h,"stroke-width":r})),d[y?"attr":"animate"]({d:this.getMarkPath(n,a,b[0],d.strokeWidth()*v,e.horiz,m),opacity:g}))},renderLabel:function(a,
	g,v,e){var h=this.axis,m=h.horiz,c=h.options,f=this.label,b=c.labels,d=b.step,y=h.tickmarkOffset,H=!0,n=a.x;a=a.y;f&&p(n)&&(f.xy=a=this.getLabelPosition(n,a,f,m,b,y,e,d),this.isFirst&&!this.isLast&&!l(c.showFirstLabel,1)||this.isLast&&!this.isFirst&&!l(c.showLastLabel,1)?H=!1:!m||h.isRadial||b.step||b.rotation||g||0===v||this.handleOverflow(a),d&&e%d&&(H=!1),H&&p(a.y)?(a.opacity=v,f[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(f.attr("y",-9999),this.isNewLabel=!0))},render:function(a,
	g,v){var e=this.axis,h=e.horiz,m=this.getPosition(h,this.pos,e.tickmarkOffset,g),c=m.x,f=m.y,e=h&&c===e.pos+e.len||!h&&f===e.pos?-1:1;v=l(v,1);this.isActive=!0;this.renderGridLine(g,v,e);this.renderMark(m,v,e);this.renderLabel(m,g,v,a);this.isNew=!1},destroy:function(){G(this,this.axis)}}})(N);var V=function(a){var D=a.addEvent,B=a.animObject,G=a.arrayMax,p=a.arrayMin,g=a.color,l=a.correctFloat,r=a.defaultOptions,n=a.defined,w=a.deg2rad,v=a.destroyObjectProperties,e=a.each,h=a.extend,m=a.fireEvent,
	c=a.format,f=a.getMagnitude,b=a.grep,d=a.inArray,y=a.isArray,H=a.isNumber,J=a.isString,t=a.merge,K=a.normalizeTickInterval,x=a.objectEach,C=a.pick,L=a.removeEvent,q=a.splat,A=a.syncTimeout,E=a.Tick,F=function(){this.init.apply(this,arguments)};a.extend(F.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,style:{color:"#666666",cursor:"default",
	fontSize:"11px"},x:0},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",title:{align:"middle",style:{color:"#666666"}},type:"linear",minorGridLineColor:"#f2f2f2",minorGridLineWidth:1,minorTickColor:"#999999",lineColor:"#ccd6eb",lineWidth:1,gridLineColor:"#e6e6e6",tickColor:"#ccd6eb"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},
	maxPadding:.05,minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"#000000",textOutline:"1px contrast"}},gridLineWidth:1,lineWidth:0},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},defaultTopAxisOptions:{labels:{autoRotation:[-45],
	x:0},title:{rotation:0}},init:function(a,b){var k=b.isX,u=this;u.chart=a;u.horiz=a.inverted&&!u.isZAxis?!k:k;u.isXAxis=k;u.coll=u.coll||(k?"xAxis":"yAxis");u.opposite=b.opposite;u.side=b.side||(u.horiz?u.opposite?0:2:u.opposite?1:3);u.setOptions(b);var f=this.options,c=f.type;u.labelFormatter=f.labels.formatter||u.defaultLabelFormatter;u.userOptions=b;u.minPixelPadding=0;u.reversed=f.reversed;u.visible=!1!==f.visible;u.zoomEnabled=!1!==f.zoomEnabled;u.hasNames="category"===c||!0===f.categories;u.categories=
	f.categories||u.hasNames;u.names=u.names||[];u.plotLinesAndBandsGroups={};u.isLog="logarithmic"===c;u.isDatetimeAxis="datetime"===c;u.positiveValuesOnly=u.isLog&&!u.allowNegativeLog;u.isLinked=n(f.linkedTo);u.ticks={};u.labelEdge=[];u.minorTicks={};u.plotLinesAndBands=[];u.alternateBands={};u.len=0;u.minRange=u.userMinRange=f.minRange||f.maxZoom;u.range=f.range;u.offset=f.offset||0;u.stacks={};u.oldStacks={};u.stacksTouched=0;u.max=null;u.min=null;u.crosshair=C(f.crosshair,q(a.options.tooltip.crosshairs)[k?
	0:1],!1);b=u.options.events;-1===d(u,a.axes)&&(k?a.axes.splice(a.xAxis.length,0,u):a.axes.push(u),a[u.coll].push(u));u.series=u.series||[];a.inverted&&!u.isZAxis&&k&&void 0===u.reversed&&(u.reversed=!0);x(b,function(a,k){D(u,k,a)});u.lin2log=f.linearToLogConverter||u.lin2log;u.isLog&&(u.val2lin=u.log2lin,u.lin2val=u.lin2log)},setOptions:function(a){this.options=t(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,this.defaultRightAxisOptions,this.defaultBottomAxisOptions,
	this.defaultLeftAxisOptions][this.side],t(r[this.coll],a))},defaultLabelFormatter:function(){var k=this.axis,b=this.value,d=k.categories,f=this.dateTimeLabelFormat,e=r.lang,q=e.numericSymbols,e=e.numericSymbolMagnitude||1E3,h=q&&q.length,m,y=k.options.labels.format,k=k.isLog?Math.abs(b):k.tickInterval;if(y)m=c(y,this);else if(d)m=b;else if(f)m=a.dateFormat(f,b);else if(h&&1E3<=k)for(;h--&&void 0===m;)d=Math.pow(e,h+1),k>=d&&0===10*b%d&&null!==q[h]&&0!==b&&(m=a.numberFormat(b/d,-1)+q[h]);void 0===
	m&&(m=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,-1,void 0,""));return m},getSeriesExtremes:function(){var a=this,u=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();e(a.series,function(k){if(k.visible||!u.options.chart.ignoreHiddenSeries){var d=k.options,f=d.threshold,c;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=f&&(f=null);if(a.isXAxis)d=k.xData,d.length&&(k=p(d),c=G(d),H(k)||k instanceof Date||(d=b(d,H),
	k=p(d)),a.dataMin=Math.min(C(a.dataMin,d[0],k),k),a.dataMax=Math.max(C(a.dataMax,d[0],c),c));else if(k.getExtremes(),c=k.dataMax,k=k.dataMin,n(k)&&n(c)&&(a.dataMin=Math.min(C(a.dataMin,k),k),a.dataMax=Math.max(C(a.dataMax,c),c)),n(f)&&(a.threshold=f),!d.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})},translate:function(a,b,d,f,c,e){var k=this.linkedParent||this,u=1,q=0,h=f?k.oldTransA:k.transA;f=f?k.oldMin:k.min;var m=k.minPixelPadding;c=(k.isOrdinal||k.isBroken||k.isLog&&c)&&k.lin2val;
	h||(h=k.transA);d&&(u*=-1,q=k.len);k.reversed&&(u*=-1,q-=u*(k.sector||k.len));b?(a=(a*u+q-m)/h+f,c&&(a=k.lin2val(a))):(c&&(a=k.val2lin(a)),a=H(f)?u*(a-f)*h+q+u*m+(H(e)?h*e:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,d,f,c){var k=this.chart,u=this.left,q=this.top,e,h,m=d&&k.oldChartHeight||k.chartHeight,y=d&&k.oldChartWidth||
	k.chartWidth,A;e=this.transB;var t=function(a,k,b){if(a<k||a>b)f?a=Math.min(Math.max(k,a),b):A=!0;return a};c=C(c,this.translate(a,null,null,d));a=d=Math.round(c+e);e=h=Math.round(m-c-e);H(c)?this.horiz?(e=q,h=m-this.bottom,a=d=t(a,u,u+this.width)):(a=u,d=y-this.right,e=h=t(e,q,q+this.height)):(A=!0,f=!1);return A&&!f?null:k.renderer.crispLine(["M",a,e,"L",d,h],b||1)},getLinearTickPositions:function(a,b,d){var k,u=l(Math.floor(b/a)*a);d=l(Math.ceil(d/a)*a);var f=[],c;l(u+a)===u&&(c=20);if(this.single)return[b];
	for(b=u;b<=d;){f.push(b);b=l(b+a,c);if(b===k)break;k=b}return f},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?C(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,d=a.tickPositions,f=a.minorTickInterval,c=[],q=a.pointRangePadding||0,h=a.min-q,q=a.max+q,m=q-h;if(m&&m/f<a.len/3)if(a.isLog)e(this.paddedTicks,function(k,b,u){b&&c.push.apply(c,a.getLogTickPositions(f,u[b-1],u[b],!0))});else if(a.isDatetimeAxis&&
	"auto"===this.getMinorTickInterval())c=c.concat(a.getTimeTicks(a.normalizeTimeTickInterval(f),h,q,b.startOfWeek));else for(b=h+(d[0]-h)%f;b<=q&&b!==c[0];b+=f)c.push(b);0!==c.length&&a.trimTicks(c);return c},adjustForMinRange:function(){var a=this.options,b=this.min,d=this.max,f,c,q,h,m,y,A,t;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(n(a.min)||n(a.max)?this.minRange=null:(e(this.series,function(a){y=a.xData;for(h=A=a.xIncrement?1:y.length-1;0<h;h--)if(m=y[h]-y[h-1],void 0===q||m<q)q=m}),
	this.minRange=Math.min(5*q,this.dataMax-this.dataMin)));d-b<this.minRange&&(c=this.dataMax-this.dataMin>=this.minRange,t=this.minRange,f=(t-d+b)/2,f=[b-f,C(a.min,b-f)],c&&(f[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=G(f),d=[b+t,C(a.max,b+t)],c&&(d[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),d=p(d),d-b<t&&(f[0]=d-t,f[1]=C(a.min,d-t),b=G(f)));this.min=b;this.max=d},getClosest:function(){var a;this.categories?a=1:e(this.series,function(k){var b=k.closestPointRange,u=k.visible||
	!k.chart.options.chart.ignoreHiddenSeries;!k.noSharedTooltip&&n(b)&&u&&(a=n(a)?Math.min(a,b):b)});return a},nameToX:function(a){var k=y(this.categories),b=k?this.categories:this.names,f=a.options.x,c;a.series.requireSorting=!1;n(f)||(f=!1===this.options.uniqueNames?a.series.autoIncrement():d(a.name,b));-1===f?k||(c=b.length):c=f;void 0!==c&&(this.names[c]=a.name);return c},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=0,this.minRange=this.userMinRange,e(this.series||[],
	function(k){k.xIncrement=null;if(!k.points||k.isDirtyData)k.processData(),k.generatePoints();e(k.points,function(b,u){var d;b.options&&(d=a.nameToX(b),void 0!==d&&d!==b.x&&(b.x=d,k.xData[u]=d))})}))},setAxisTranslation:function(a){var k=this,b=k.max-k.min,d=k.axisPointRange||0,f,c=0,q=0,h=k.linkedParent,m=!!k.categories,y=k.transA,A=k.isXAxis;if(A||m||d)f=k.getClosest(),h?(c=h.minPointOffset,q=h.pointRangePadding):e(k.series,function(a){var b=m?1:A?C(a.options.pointRange,f,0):k.axisPointRange||0;
	a=a.options.pointPlacement;d=Math.max(d,b);k.single||(c=Math.max(c,J(a)?0:b/2),q=Math.max(q,"on"===a?0:b))}),h=k.ordinalSlope&&f?k.ordinalSlope/f:1,k.minPointOffset=c*=h,k.pointRangePadding=q*=h,k.pointRange=Math.min(d,b),A&&(k.closestPointRange=f);a&&(k.oldTransA=y);k.translationSlope=k.transA=y=k.options.staticScale||k.len/(b+q||1);k.transB=k.horiz?k.left:k.bottom;k.minPixelPadding=y*c},minFromRange:function(){return this.max-this.range},setTickInterval:function(k){var b=this,d=b.chart,c=b.options,
	q=b.isLog,h=b.log2lin,y=b.isDatetimeAxis,A=b.isXAxis,t=b.isLinked,x=c.maxPadding,g=c.minPadding,E=c.tickInterval,v=c.tickPixelInterval,F=b.categories,r=b.threshold,J=b.softThreshold,p,w,L,B;y||F||t||this.getTickAmount();L=C(b.userMin,c.min);B=C(b.userMax,c.max);t?(b.linkedParent=d[b.coll][c.linkedTo],d=b.linkedParent.getExtremes(),b.min=C(d.min,d.dataMin),b.max=C(d.max,d.dataMax),c.type!==b.linkedParent.options.type&&a.error(11,1)):(!J&&n(r)&&(b.dataMin>=r?(p=r,g=0):b.dataMax<=r&&(w=r,x=0)),b.min=
	C(L,p,b.dataMin),b.max=C(B,w,b.dataMax));q&&(b.positiveValuesOnly&&!k&&0>=Math.min(b.min,C(b.dataMin,b.min))&&a.error(10,1),b.min=l(h(b.min),15),b.max=l(h(b.max),15));b.range&&n(b.max)&&(b.userMin=b.min=L=Math.max(b.dataMin,b.minFromRange()),b.userMax=B=b.max,b.range=null);m(b,"foundExtremes");b.beforePadding&&b.beforePadding();b.adjustForMinRange();!(F||b.axisPointRange||b.usePercentage||t)&&n(b.min)&&n(b.max)&&(h=b.max-b.min)&&(!n(L)&&g&&(b.min-=h*g),!n(B)&&x&&(b.max+=h*x));H(c.softMin)&&(b.min=
	Math.min(b.min,c.softMin));H(c.softMax)&&(b.max=Math.max(b.max,c.softMax));H(c.floor)&&(b.min=Math.max(b.min,c.floor));H(c.ceiling)&&(b.max=Math.min(b.max,c.ceiling));J&&n(b.dataMin)&&(r=r||0,!n(L)&&b.min<r&&b.dataMin>=r?b.min=r:!n(B)&&b.max>r&&b.dataMax<=r&&(b.max=r));b.tickInterval=b.min===b.max||void 0===b.min||void 0===b.max?1:t&&!E&&v===b.linkedParent.options.tickPixelInterval?E=b.linkedParent.tickInterval:C(E,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,F?1:(b.max-b.min)*
	v/Math.max(b.len,v));A&&!k&&e(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!E&&(b.tickInterval=Math.max(b.pointRange,b.tickInterval));k=C(c.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);!E&&b.tickInterval<k&&(b.tickInterval=k);y||q||E||(b.tickInterval=K(b.tickInterval,null,f(b.tickInterval),
	C(c.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=b.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,d=a.tickPositions;b=this.getMinorTickInterval();var c=a.tickPositioner,f=a.startOnTick,q=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===b&&this.tickInterval?this.tickInterval/5:b;this.single=
	this.min===this.max&&n(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=d&&d.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=[b[0],b.pop()],
	b[0]===b[1]&&(b.length=1)),this.tickPositions=b,c&&(c=c.apply(this,[this.min,this.max])))&&(this.tickPositions=b=c);this.paddedTicks=b.slice(0);this.trimTicks(b,f,q);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),d||c||this.adjustTickAmount())},trimTicks:function(a,b,d){var k=a[0],c=a[a.length-1],f=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==k)this.min=k;else for(;this.min-f>a[0];)a.shift();if(d)this.max=c;else for(;this.max+f<a[a.length-1];)a.pop();0===a.length&&
	n(k)&&a.push((c+k)/2)}},alignToOthers:function(){var a={},b,d=this.options;!1===this.chart.options.chart.alignTicks||!1===d.alignTicks||this.isLog||e(this.chart[this.coll],function(k){var d=k.options,d=[k.horiz?d.left:d.top,d.width,d.height,d.pane].join();k.series.length&&(a[d]?b=!0:a[d]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,d=a.tickPixelInterval;!n(a.tickInterval)&&this.len<d&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&
	(b=Math.ceil(this.len/d)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,d=this.tickAmount,c=this.finalTickAmt,f=b&&b.length;if(f<d){for(;b.length<d;)b.push(l(b[b.length-1]+a));this.transA*=(f-1)/(d-1);this.max=b[b.length-1]}else f>d&&(this.tickInterval*=2,this.setTickPositions());if(n(c)){for(a=d=b.length;a--;)(3===c&&1===a%2||2>=c&&0<a&&a<d-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,b;this.oldMin=
	this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;e(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=
	b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,d,c,f){var k=this,q=k.chart;d=C(d,!0);e(k.series,function(a){delete a.kdTree});f=h(f,{min:a,max:b});m(k,"setExtremes",f,function(){k.userMin=a;k.userMax=b;k.eventArgs=f;d&&q.redraw(c)})},zoom:function(a,b){var k=this.dataMin,d=this.dataMax,c=this.options,f=Math.min(k,C(c.min,k)),c=Math.max(d,C(c.max,d));if(a!==this.min||b!==this.max)this.allowZoomOutside||(n(k)&&(a<f&&(a=f),a>c&&(a=c)),
	n(d)&&(b<f&&(b=f),b>c&&(b=c))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,d=this.options,c=d.offsets||[0,0,0,0],f=this.horiz,q=this.width=Math.round(a.relativeLength(C(d.width,b.plotWidth-c[3]+c[1]),b.plotWidth)),e=this.height=Math.round(a.relativeLength(C(d.height,b.plotHeight-c[0]+c[2]),b.plotHeight)),h=this.top=Math.round(a.relativeLength(C(d.top,b.plotTop+c[0]),b.plotHeight,b.plotTop)),d=this.left=Math.round(a.relativeLength(C(d.left,
	b.plotLeft+c[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-e-h;this.right=b.chartWidth-q-d;this.len=Math.max(f?q:e,0);this.pos=f?d:h},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?l(b(this.min)):this.min,max:a?l(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,k=this.lin2log,d=b?k(this.min):this.min,b=b?k(this.max):this.max;null===a?a=d:d>a?a=d:b<a&&(a=b);return this.translate(a,
	0,1,0,1)},autoLabelAlign:function(a){a=(C(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,k=b[a+"Length"],d=C(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(d&&k)return"inside"===b[a+"Position"]&&(k=-k),[k,d]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=
	this.options.labels,b=this.horiz,d=this.tickInterval,c=d,f=this.len/(((this.categories?1:0)+this.max-this.min)/d),q,h=a.rotation,m=this.labelMetrics(),y,A=Number.MAX_VALUE,t,x=function(a){a/=f||1;a=1<a?Math.ceil(a):1;return a*d};b?(t=!a.staggerLines&&!a.step&&(n(h)?[h]:f<C(a.autoRotationLimit,80)&&a.autoRotation))&&e(t,function(a){var b;if(a===h||a&&-90<=a&&90>=a)y=x(Math.abs(m.h/Math.sin(w*a))),b=y+Math.abs(a/360),b<A&&(A=b,q=a,c=y)}):a.step||(c=x(m.h));this.autoRotation=t;this.labelRotation=C(q,
	h);return c},getSlotWidth:function(){var a=this.chart,b=this.horiz,d=this.options.labels,c=Math.max(this.tickPositions.length-(this.categories?0:1),1),f=a.margin[3];return b&&2>(d.step||0)&&!d.rotation&&(this.staggerLines||1)*this.len/c||!b&&(d.style&&parseInt(d.style.width,10)||f&&f-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,d=this.tickPositions,c=this.ticks,f=this.options.labels,q=this.horiz,h=this.getSlotWidth(),m=Math.max(1,Math.round(h-2*(f.padding||
	5))),y={},A=this.labelMetrics(),x=f.style&&f.style.textOverflow,g,E=0,l,n;J(f.rotation)||(y.rotation=f.rotation||0);e(d,function(a){(a=c[a])&&a.labelLength>E&&(E=a.labelLength)});this.maxLabelLength=E;if(this.autoRotation)E>m&&E>A.h?y.rotation=this.labelRotation:this.labelRotation=0;else if(h&&(g={width:m+"px"},!x))for(g.textOverflow="clip",l=d.length;!q&&l--;)if(n=d[l],m=c[n].label)m.styles&&"ellipsis"===m.styles.textOverflow?m.css({textOverflow:"clip"}):c[n].labelLength>h&&m.css({width:h+"px"}),
	m.getBBox().height>this.len/d.length-(A.h-A.f)&&(m.specCss={textOverflow:"ellipsis"});y.rotation&&(g={width:(E>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},x||(g.textOverflow="ellipsis"));if(this.labelAlign=f.align||this.autoLabelAlign(this.labelRotation))y.align=this.labelAlign;e(d,function(a){var b=(a=c[a])&&a.label;b&&(b.attr(y),g&&b.css(t(g,b.specCss)),delete b.specCss,a.rotation=y.rotation)});this.tickRotCorr=b.rotCorr(A.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||
	n(this.min)&&n(this.max)&&this.tickPositions&&0<this.tickPositions.length},addTitle:function(a){var b=this.chart.renderer,k=this.horiz,d=this.opposite,c=this.options.title,f;this.axisTitle||((f=c.textAlign)||(f=(k?{low:"left",middle:"center",high:"right"}:{low:d?"right":"left",middle:"center",high:d?"left":"right"})[c.align]),this.axisTitle=b.text(c.text,0,0,c.useHTML).attr({zIndex:7,rotation:c.rotation||0,align:f}).addClass("highcharts-axis-title").css(c.style).add(this.axisGroup),this.axisTitle.isNew=
	!0);c.style.width||this.isRadial||this.axisTitle.css({width:this.len});this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new E(this,a)},getOffset:function(){var a=this,b=a.chart,d=b.renderer,c=a.options,f=a.tickPositions,q=a.ticks,h=a.horiz,m=a.side,y=b.inverted&&!a.isZAxis?[1,0,3,2][m]:m,A,t,g=0,E,l=0,H=c.title,v=c.labels,F=0,r=b.axisOffset,b=b.clipOffset,J=[-1,1,1,-1][m],p=c.className,w=a.axisParent,K=this.tickSize("tick");A=a.hasData();a.showAxis=
	t=A||C(c.showEmpty,!0);a.staggerLines=a.horiz&&v.staggerLines;a.axisGroup||(a.gridGroup=d.g("grid").attr({zIndex:c.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(p||"")).add(w),a.axisGroup=d.g("axis").attr({zIndex:c.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(p||"")).add(w),a.labelGroup=d.g("axis-labels").attr({zIndex:v.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(p||"")).add(w));A||a.isLinked?(e(f,function(b,k){a.generateTick(b,
	k)}),a.renderUnsquish(),!1===v.reserveSpace||0!==m&&2!==m&&{1:"left",3:"right"}[m]!==a.labelAlign&&"center"!==a.labelAlign||e(f,function(a){F=Math.max(q[a].getLabelSize(),F)}),a.staggerLines&&(F*=a.staggerLines,a.labelOffset=F*(a.opposite?-1:1))):x(q,function(a,b){a.destroy();delete q[b]});H&&H.text&&!1!==H.enabled&&(a.addTitle(t),t&&!1!==H.reserveSpace&&(a.titleOffset=g=a.axisTitle.getBBox()[h?"height":"width"],E=H.offset,l=n(E)?0:C(H.margin,h?5:10)));a.renderLine();a.offset=J*C(c.offset,r[m]);a.tickRotCorr=
	a.tickRotCorr||{x:0,y:0};d=0===m?-a.labelMetrics().h:2===m?a.tickRotCorr.y:0;l=Math.abs(F)+l;F&&(l=l-d+J*(h?C(v.y,a.tickRotCorr.y+8*J):v.x));a.axisTitleMargin=C(E,l);r[m]=Math.max(r[m],a.axisTitleMargin+g+J*a.offset,l,A&&f.length&&K?K[0]+J*a.offset:0);c=c.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[y]=Math.max(b[y],c)},getLinePath:function(a){var b=this.chart,k=this.opposite,d=this.offset,c=this.horiz,f=this.left+(k?this.width:0)+d,d=b.chartHeight-this.bottom-(k?this.height:0)+d;k&&(a*=-1);
	return b.renderer.crispLine(["M",c?this.left:f,c?d:this.top,"L",c?b.chartWidth-this.right:f,c?d:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup),this.axisLine.attr({stroke:this.options.lineColor,"stroke-width":this.options.lineWidth,zIndex:7}))},getTitlePosition:function(){var a=this.horiz,b=this.left,d=this.top,c=this.len,f=this.options.title,q=a?b:d,e=this.opposite,h=this.offset,m=f.x||
	0,y=f.y||0,A=this.axisTitle,t=this.chart.renderer.fontMetrics(f.style&&f.style.fontSize,A),A=Math.max(A.getBBox(null,0).height-t.h-1,0),c={low:q+(a?0:c),middle:q+c/2,high:q+(a?c:0)}[f.align],b=(a?d+this.height:b)+(a?1:-1)*(e?-1:1)*this.axisTitleMargin+[-A,A,t.f,-A][this.side];return{x:a?c+m:b+(e?this.width:0)+h+m,y:a?b+y-(e?this.height:0)+h:c+y}},renderMinorTick:function(a){var b=this.chart.hasRendered&&H(this.oldMin),d=this.minorTicks;d[a]||(d[a]=new E(this,a,"minor"));b&&d[a].isNew&&d[a].render(null,
	!0);d[a].render(null,!1,1)},renderTick:function(a,b){var d=this.isLinked,k=this.ticks,c=this.chart.hasRendered&&H(this.oldMin);if(!d||a>=this.min&&a<=this.max)k[a]||(k[a]=new E(this,a)),c&&k[a].isNew&&k[a].render(b,!0,.1),k[a].render(b)},render:function(){var b=this,d=b.chart,c=b.options,f=b.isLog,q=b.lin2log,h=b.isLinked,m=b.tickPositions,y=b.axisTitle,t=b.ticks,g=b.minorTicks,l=b.alternateBands,n=c.stackLabels,C=c.alternateGridColor,v=b.tickmarkOffset,F=b.axisLine,r=b.showAxis,J=B(d.renderer.globalAnimation),
	p,w;b.labelEdge.length=0;b.overlap=!1;e([t,g,l],function(a){x(a,function(a){a.isActive=!1})});if(b.hasData()||h)b.minorTickInterval&&!b.categories&&e(b.getMinorTickPositions(),function(a){b.renderMinorTick(a)}),m.length&&(e(m,function(a,d){b.renderTick(a,d)}),v&&(0===b.min||b.single)&&(t[-1]||(t[-1]=new E(b,-1,null,!0)),t[-1].render(-1))),C&&e(m,function(c,k){w=void 0!==m[k+1]?m[k+1]+v:b.max-v;0===k%2&&c<b.max&&w<=b.max+(d.polar?-v:v)&&(l[c]||(l[c]=new a.PlotLineOrBand(b)),p=c+v,l[c].options={from:f?
	q(p):p,to:f?q(w):w,color:C},l[c].render(),l[c].isActive=!0)}),b._addedPlotLB||(e((c.plotLines||[]).concat(c.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=!0);e([t,g,l],function(a){var b,c=[],k=J.duration;x(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,c.push(b))});A(function(){for(b=c.length;b--;)a[c[b]]&&!a[c[b]].isActive&&(a[c[b]].destroy(),delete a[c[b]])},a!==l&&d.hasRendered&&k?k:0)});F&&(F[F.isPlaced?"animate":"attr"]({d:this.getLinePath(F.strokeWidth())}),
	F.isPlaced=!0,F[r?"show":"hide"](!0));y&&r&&(c=b.getTitlePosition(),H(c.y)?(y[y.isNew?"attr":"animate"](c),y.isNew=!1):(y.attr("y",-9999),y.isNew=!0));n&&n.enabled&&b.renderStackTotals();b.isDirty=!1},redraw:function(){this.visible&&(this.render(),e(this.plotLinesAndBands,function(a){a.render()}));e(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,c=b.stacks,k=b.plotLinesAndBands,f;a||L(b);x(c,function(a,b){v(a);
	c[b]=null});e([b.ticks,b.minorTicks,b.alternateBands],function(a){v(a)});if(k)for(a=k.length;a--;)k[a].destroy();e("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),function(a){b[a]&&(b[a]=b[a].destroy())});for(f in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[f]=b.plotLinesAndBandsGroups[f].destroy();x(b,function(a,c){-1===d(c,b.keepProps)&&delete b[c]})},drawCrosshair:function(a,b){var d,c=this.crosshair,k=C(c.snap,!0),f,q=this.cross;a||(a=this.cross&&this.cross.e);
	this.crosshair&&!1!==(n(b)||!k)?(k?n(b)&&(f=this.isXAxis?b.plotX:this.len-b.plotY):f=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),n(f)&&(d=this.getPlotLinePath(b&&(this.isXAxis?b.x:C(b.stackY,b.y)),null,null,null,f)||null),n(d)?(b=this.categories&&!this.isRadial,q||(this.cross=q=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(b?"category ":"thin ")+c.className).attr({zIndex:C(c.zIndex,2)}).add(),q.attr({stroke:c.color||(b?g("#ccd6eb").setOpacity(.25).get():
	"#cccccc"),"stroke-width":C(c.width,1)}).css({"pointer-events":"none"}),c.dashStyle&&q.attr({dashstyle:c.dashStyle})),q.show().attr({d:d}),b&&!c.width&&q.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=F}(N);(function(a){var D=a.Axis,B=a.Date,G=a.dateFormat,p=a.defaultOptions,g=a.defined,l=a.each,r=a.extend,n=a.getMagnitude,w=a.getTZOffset,v=a.normalizeTickInterval,e=a.pick,h=a.timeUnits;
	D.prototype.getTimeTicks=function(a,c,f,b){var d=[],m={},n=p.global.useUTC,v,t=new B(c-Math.max(w(c),w(f))),K=B.hcMakeTime,x=a.unitRange,C=a.count,L,q;if(g(c)){t[B.hcSetMilliseconds](x>=h.second?0:C*Math.floor(t.getMilliseconds()/C));if(x>=h.second)t[B.hcSetSeconds](x>=h.minute?0:C*Math.floor(t.getSeconds()/C));if(x>=h.minute)t[B.hcSetMinutes](x>=h.hour?0:C*Math.floor(t[B.hcGetMinutes]()/C));if(x>=h.hour)t[B.hcSetHours](x>=h.day?0:C*Math.floor(t[B.hcGetHours]()/C));if(x>=h.day)t[B.hcSetDate](x>=h.month?
	1:C*Math.floor(t[B.hcGetDate]()/C));x>=h.month&&(t[B.hcSetMonth](x>=h.year?0:C*Math.floor(t[B.hcGetMonth]()/C)),v=t[B.hcGetFullYear]());if(x>=h.year)t[B.hcSetFullYear](v-v%C);if(x===h.week)t[B.hcSetDate](t[B.hcGetDate]()-t[B.hcGetDay]()+e(b,1));v=t[B.hcGetFullYear]();b=t[B.hcGetMonth]();var A=t[B.hcGetDate](),E=t[B.hcGetHours]();if(B.hcTimezoneOffset||B.hcGetTimezoneOffset)q=(!n||!!B.hcGetTimezoneOffset)&&(f-c>4*h.month||w(c)!==w(f)),t=t.getTime(),L=w(t),t=new B(t+L);n=t.getTime();for(c=1;n<f;)d.push(n),
	n=x===h.year?K(v+c*C,0):x===h.month?K(v,b+c*C):!q||x!==h.day&&x!==h.week?q&&x===h.hour?K(v,b,A,E+c*C,0,0,L)-L:n+x*C:K(v,b,A+c*C*(x===h.day?1:7)),c++;d.push(n);x<=h.hour&&1E4>d.length&&l(d,function(a){0===a%18E5&&"000000000"===G("%H%M%S%L",a)&&(m[a]="day")})}d.info=r(a,{higherRanks:m,totalRange:x*C});return d};D.prototype.normalizeTimeTickInterval=function(a,c){var f=c||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],
	["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];c=f[f.length-1];var b=h[c[0]],d=c[1],e;for(e=0;e<f.length&&!(c=f[e],b=h[c[0]],d=c[1],f[e+1]&&a<=(b*d[d.length-1]+h[f[e+1][0]])/2);e++);b===h.year&&a<5*b&&(d=[1,2,5]);a=v(a/b,d,"year"===c[0]?Math.max(n(a/b),1):1);return{unitRange:b,count:a,unitName:c[0]}}})(N);(function(a){var D=a.Axis,B=a.getMagnitude,G=a.map,p=a.normalizeTickInterval,g=a.pick;D.prototype.getLogTickPositions=function(a,r,n,w){var l=this.options,e=this.len,h=this.lin2log,
	m=this.log2lin,c=[];w||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),c=this.getLinearTickPositions(a,r,n);else if(.08<=a)for(var e=Math.floor(r),f,b,d,y,H,l=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];e<n+1&&!H;e++)for(b=l.length,f=0;f<b&&!H;f++)d=m(h(e)*l[f]),d>r&&(!w||y<=n)&&void 0!==y&&c.push(y),y>n&&(H=!0),y=d;else r=h(r),n=h(n),a=w?this.getMinorTickInterval():l.tickInterval,a=g("auto"===a?null:a,this._minorAutoInterval,l.tickPixelInterval/(w?5:1)*(n-r)/((w?e/this.tickPositions.length:
	e)||1)),a=p(a,null,B(a)),c=G(this.getLinearTickPositions(a,r,n),m),w||(this._minorAutoInterval=a/5);w||(this.tickInterval=a);return c};D.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};D.prototype.lin2log=function(a){return Math.pow(10,a)}})(N);(function(a,D){var B=a.arrayMax,G=a.arrayMin,p=a.defined,g=a.destroyObjectProperties,l=a.each,r=a.erase,n=a.merge,w=a.pick;a.PlotLineOrBand=function(a,e){this.axis=a;e&&(this.options=e,this.id=e.id)};a.PlotLineOrBand.prototype={render:function(){var g=
	this,e=g.axis,h=e.horiz,m=g.options,c=m.label,f=g.label,b=m.to,d=m.from,y=m.value,l=p(d)&&p(b),r=p(y),t=g.svgElem,K=!t,x=[],C=m.color,L=w(m.zIndex,0),q=m.events,x={"class":"highcharts-plot-"+(l?"band ":"line ")+(m.className||"")},A={},E=e.chart.renderer,F=l?"bands":"lines",k=e.log2lin;e.isLog&&(d=k(d),b=k(b),y=k(y));r?(x={stroke:C,"stroke-width":m.width},m.dashStyle&&(x.dashstyle=m.dashStyle)):l&&(C&&(x.fill=C),m.borderWidth&&(x.stroke=m.borderColor,x["stroke-width"]=m.borderWidth));A.zIndex=L;F+=
	"-"+L;(C=e.plotLinesAndBandsGroups[F])||(e.plotLinesAndBandsGroups[F]=C=E.g("plot-"+F).attr(A).add());K&&(g.svgElem=t=E.path().attr(x).add(C));if(r)x=e.getPlotLinePath(y,t.strokeWidth());else if(l)x=e.getPlotBandPath(d,b,m);else return;K&&x&&x.length?(t.attr({d:x}),q&&a.objectEach(q,function(a,b){t.on(b,function(a){q[b].apply(g,[a])})})):t&&(x?(t.show(),t.animate({d:x})):(t.hide(),f&&(g.label=f=f.destroy())));c&&p(c.text)&&x&&x.length&&0<e.width&&0<e.height&&!x.flat?(c=n({align:h&&l&&"center",x:h?
	!l&&4:10,verticalAlign:!h&&l&&"middle",y:h?l?16:10:l?6:-4,rotation:h&&!l&&90},c),this.renderLabel(c,x,l,L)):f&&f.hide();return g},renderLabel:function(a,e,h,m){var c=this.label,f=this.axis.chart.renderer;c||(c={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(h?"band":"line")+"-label "+(a.className||"")},c.zIndex=m,this.label=c=f.text(a.text,0,0,a.useHTML).attr(c).add(),c.css(a.style));m=e.xBounds||[e[1],e[4],h?e[6]:e[1]];e=e.yBounds||[e[2],e[5],h?e[7]:e[2]];h=G(m);f=G(e);
	c.align(a,!1,{x:h,y:f,width:B(m)-h,height:B(e)-f});c.show()},destroy:function(){r(this.axis.plotLinesAndBands,this);delete this.axis;g(this)}};a.extend(D.prototype,{getPlotBandPath:function(a,e){var h=this.getPlotLinePath(e,null,null,!0),m=this.getPlotLinePath(a,null,null,!0),c=[],f=this.horiz,b=1,d;a=a<this.min&&e<this.min||a>this.max&&e>this.max;if(m&&h)for(a&&(d=m.toString()===h.toString(),b=0),a=0;a<m.length;a+=6)f&&h[a+1]===m[a+1]?(h[a+1]+=b,h[a+4]+=b):f||h[a+2]!==m[a+2]||(h[a+2]+=b,h[a+5]+=
	b),c.push("M",m[a+1],m[a+2],"L",m[a+4],m[a+5],h[a+4],h[a+5],h[a+1],h[a+2],"z"),c.flat=d;return c},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(g,e){var h=(new a.PlotLineOrBand(this,g)).render(),m=this.userOptions;h&&(e&&(m[e]=m[e]||[],m[e].push(g)),this.plotLinesAndBands.push(h));return h},removePlotBandOrLine:function(a){for(var e=this.plotLinesAndBands,h=this.options,m=this.userOptions,
	c=e.length;c--;)e[c].id===a&&e[c].destroy();l([h.plotLines||[],m.plotLines||[],h.plotBands||[],m.plotBands||[]],function(f){for(c=f.length;c--;)f[c].id===a&&r(f,f[c])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(N,V);(function(a){var D=a.dateFormat,B=a.each,G=a.extend,p=a.format,g=a.isNumber,l=a.map,r=a.merge,n=a.pick,w=a.splat,v=a.syncTimeout,e=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype=
	{init:function(a,e){this.chart=a;this.options=e;this.crosshairs=[];this.now={x:0,y:0};this.isHidden=!0;this.split=e.split&&!a.inverted;this.shared=e.shared||this.split},cleanSplit:function(a){B(this.chart.series,function(e){var c=e&&e.tt;c&&(!c.isActive||a?e.tt=c.destroy():c.isActive=!1)})},getLabel:function(){var a=this.chart.renderer,e=this.options;this.label||(this.split?this.label=a.g("tooltip"):(this.label=a.label("",0,0,e.shape||"callout",null,null,e.useHTML,null,"tooltip").attr({padding:e.padding,
	r:e.borderRadius}),this.label.attr({fill:e.backgroundColor,"stroke-width":e.borderWidth}).css(e.style).shadow(e.shadow)),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();r(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,r(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},
	move:function(a,e,c,f){var b=this,d=b.now,h=!1!==b.options.animation&&!b.isHidden&&(1<Math.abs(a-d.x)||1<Math.abs(e-d.y)),m=b.followPointer||1<b.len;G(d,{x:h?(2*d.x+a)/3:a,y:h?(d.y+e)/2:e,anchorX:m?void 0:h?(2*d.anchorX+c)/3:c,anchorY:m?void 0:h?(d.anchorY+f)/2:f});b.getLabel().attr(d);h&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){b&&b.move(a,e,c,f)},32))},hide:function(a){var e=this;clearTimeout(this.hideTimer);a=n(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=
	v(function(){e.getLabel()[a?"fadeOut":"hide"]();e.isHidden=!0},a))},getAnchor:function(a,e){var c,f=this.chart,b=f.inverted,d=f.plotTop,h=f.plotLeft,m=0,g=0,t,n;a=w(a);c=a[0].tooltipPos;this.followPointer&&e&&(void 0===e.chartX&&(e=f.pointer.normalize(e)),c=[e.chartX-f.plotLeft,e.chartY-d]);c||(B(a,function(a){t=a.series.yAxis;n=a.series.xAxis;m+=a.plotX+(!b&&n?n.left-h:0);g+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!b&&t?t.top-d:0)}),m/=a.length,g/=a.length,c=[b?f.plotWidth-g:m,this.shared&&
	!b&&1<a.length&&e?e.chartY-d:b?f.plotHeight-m:g]);return l(c,Math.round)},getPosition:function(a,e,c){var f=this.chart,b=this.distance,d={},h=f.inverted&&c.h||0,m,g=["y",f.chartHeight,e,c.plotY+f.plotTop,f.plotTop,f.plotTop+f.plotHeight],t=["x",f.chartWidth,a,c.plotX+f.plotLeft,f.plotLeft,f.plotLeft+f.plotWidth],l=!this.followPointer&&n(c.ttBelow,!f.inverted===!!c.negative),x=function(a,c,f,k,e,q){var m=f<k-b,y=k+b+f<c,u=k-b-f;k+=b;if(l&&y)d[a]=k;else if(!l&&m)d[a]=u;else if(m)d[a]=Math.min(q-f,0>
	u-h?u:u-h);else if(y)d[a]=Math.max(e,k+h+f>c?k:k+h);else return!1},C=function(a,c,f,k){var e;k<b||k>c-b?e=!1:d[a]=k<f/2?1:k>c-f/2?c-f-2:k-f/2;return e},r=function(a){var b=g;g=t;t=b;m=a},q=function(){!1!==x.apply(0,g)?!1!==C.apply(0,t)||m||(r(!0),q()):m?d.x=d.y=0:(r(!0),q())};(f.inverted||1<this.len)&&r();q();return d},defaultFormatter:function(a){var e=this.points||w(this),c;c=[a.tooltipFooterHeaderFormatter(e[0])];c=c.concat(a.bodyFormatter(e));c.push(a.tooltipFooterHeaderFormatter(e[0],!0));return c},
	refresh:function(a,e){var c,f=this.options,b,d=a,h,m={},g=[];c=f.formatter||this.defaultFormatter;var m=this.shared,t;f.enabled&&(clearTimeout(this.hideTimer),this.followPointer=w(d)[0].series.tooltipOptions.followPointer,h=this.getAnchor(d,e),e=h[0],b=h[1],!m||d.series&&d.series.noSharedTooltip?m=d.getLabelConfig():(B(d,function(a){a.setState("hover");g.push(a.getLabelConfig())}),m={x:d[0].category,y:d[0].y},m.points=g,d=d[0]),this.len=g.length,m=c.call(m,this),t=d.series,this.distance=n(t.tooltipOptions.distance,
	16),!1===m?this.hide():(c=this.getLabel(),this.isHidden&&c.attr({opacity:1}).show(),this.split?this.renderSplit(m,w(a)):(f.style.width||c.css({width:this.chart.spacingBox.width}),c.attr({text:m&&m.join?m.join(""):m}),c.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+n(d.colorIndex,t.colorIndex)),c.attr({stroke:f.borderColor||d.color||t.color||"#666666"}),this.updatePosition({plotX:e,plotY:b,negative:d.negative,ttBelow:d.ttBelow,h:h[2]||0})),this.isHidden=!1))},renderSplit:function(e,
	m){var c=this,f=[],b=this.chart,d=b.renderer,h=!0,g=this.options,l=0,t=this.getLabel();a.isString(e)&&(e=[!1,e]);B(e.slice(0,m.length+1),function(a,e){if(!1!==a){e=m[e-1]||{isHeader:!0,plotX:m[0].plotX};var y=e.series||c,x=y.tt,q=e.series||{},A="highcharts-color-"+n(e.colorIndex,q.colorIndex,"none");x||(y.tt=x=d.label(null,null,null,"callout",null,null,g.useHTML).addClass("highcharts-tooltip-box "+A).attr({padding:g.padding,r:g.borderRadius,fill:g.backgroundColor,stroke:g.borderColor||e.color||q.color||
	"#333333","stroke-width":g.borderWidth}).add(t));x.isActive=!0;x.attr({text:a});x.css(g.style).shadow(g.shadow);a=x.getBBox();q=a.width+x.strokeWidth();e.isHeader?(l=a.height,q=Math.max(0,Math.min(e.plotX+b.plotLeft-q/2,b.chartWidth-q))):q=e.plotX+b.plotLeft-n(g.distance,16)-q;0>q&&(h=!1);a=(e.series&&e.series.yAxis&&e.series.yAxis.pos)+(e.plotY||0);a-=b.plotTop;f.push({target:e.isHeader?b.plotHeight+l:a,rank:e.isHeader?1:0,size:y.tt.getBBox().height+1,point:e,x:q,tt:x})}});this.cleanSplit();a.distribute(f,
	b.plotHeight+l);B(f,function(a){var d=a.point,c=d.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:h||d.isHeader?a.x:d.plotX+b.plotLeft+n(g.distance,16),y:a.pos+b.plotTop,anchorX:d.isHeader?d.plotX+b.plotLeft:d.plotX+c.xAxis.pos,anchorY:d.isHeader?a.pos+b.plotTop-15:d.plotY+c.yAxis.pos})})},updatePosition:function(a){var e=this.chart,c=this.getLabel(),c=(this.options.positioner||this.getPosition).call(this,c.width,c.height,a);this.move(Math.round(c.x),Math.round(c.y||0),a.plotX+e.plotLeft,
	a.plotY+e.plotTop)},getDateFormat:function(a,m,c,f){var b=D("%m-%d %H:%M:%S.%L",m),d,h,g={millisecond:15,second:12,minute:9,hour:6,day:3},l="millisecond";for(h in e){if(a===e.week&&+D("%w",m)===c&&"00:00:00.000"===b.substr(6)){h="week";break}if(e[h]>a){h=l;break}if(g[h]&&b.substr(g[h])!=="01-01 00:00:00.000".substr(g[h]))break;"week"!==h&&(l=h)}h&&(d=f[h]);return d},getXDateFormat:function(a,e,c){e=e.dateTimeLabelFormats;var f=c&&c.closestPointRange;return(f?this.getDateFormat(f,a.x,c.options.startOfWeek,
	e):e.day)||e.year},tooltipFooterHeaderFormatter:function(a,e){e=e?"footer":"header";var c=a.series,f=c.tooltipOptions,b=f.xDateFormat,d=c.xAxis,h=d&&"datetime"===d.options.type&&g(a.key),m=f[e+"Format"];h&&!b&&(b=this.getXDateFormat(a,f,d));h&&b&&B(a.point&&a.point.tooltipDateKeys||["key"],function(a){m=m.replace("{point."+a+"}","{point."+a+":"+b+"}")});return p(m,{point:a,series:c})},bodyFormatter:function(a){return l(a,function(a){var c=a.series.tooltipOptions;return(c[(a.point.formatPrefix||"point")+
	"Formatter"]||a.point.tooltipFormatter).call(a.point,c[(a.point.formatPrefix||"point")+"Format"])})}}})(N);(function(a){var D=a.addEvent,B=a.attr,G=a.charts,p=a.color,g=a.css,l=a.defined,r=a.each,n=a.extend,w=a.find,v=a.fireEvent,e=a.isObject,h=a.offset,m=a.pick,c=a.splat,f=a.Tooltip;a.Pointer=function(a,d){this.init(a,d)};a.Pointer.prototype={init:function(a,d){this.options=d;this.chart=a;this.runChartClick=d.chart.events&&!!d.chart.events.click;this.pinchDown=[];this.lastValidTouch={};f&&(a.tooltip=
	new f(a,d.tooltip),this.followTouchMove=m(d.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,c=b.options.chart,f=c.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(f=m(c.pinchType,f));this.zoomX=a=/x/.test(f);this.zoomY=f=/y/.test(f);this.zoomHor=a&&!b||f&&b;this.zoomVert=f&&!b||a&&b;this.hasZoom=a||f},normalize:function(a,d){var b;b=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;d||(this.chartPosition=d=h(this.chart.container));return n(a,
	{chartX:Math.round(b.pageX-d.left),chartY:Math.round(b.pageY-d.top)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};r(this.chart.axes,function(d){b[d.isXAxis?"xAxis":"yAxis"].push({axis:d,value:d.toValue(a[d.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,d,c){var b;r(a,function(a){var f=!(a.noSharedTooltip&&d)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(c,f);if((f=e(a,!0))&&!(f=!e(b,!0)))var f=b.distX-a.distX,h=b.dist-a.dist,m=(a.series.group&&a.series.group.zIndex)-
	(b.series.group&&b.series.group.zIndex),f=0<(0!==f&&d?f:0!==h?h:0!==m?m:b.series.index>a.series.index?-1:1);f&&(b=a)});return b},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,d){var b=a.series,c=b.xAxis,b=b.yAxis,f=m(a.clientX,a.plotX);if(c&&b)return d?{chartX:c.len+c.pos-f,chartY:b.len+b.pos-a.plotY}:{chartX:f+c.pos,chartY:a.plotY+b.pos}},getHoverData:function(b,c,f,h,g,t,l){var d,y=[],n=l&&l.isBoosting;h=!(!h||
	!b);l=c&&!c.stickyTracking?[c]:a.grep(f,function(a){return a.visible&&!(!g&&a.directTouch)&&m(a.options.enableMouseTracking,!0)&&a.stickyTracking});c=(d=h?b:this.findNearestKDPoint(l,g,t))&&d.series;d&&(g&&!c.noSharedTooltip?(l=a.grep(f,function(a){return a.visible&&!(!g&&a.directTouch)&&m(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),r(l,function(a){var b=w(a.points,function(a){return a.x===d.x&&!a.isNull});e(b)&&(n&&(b=a.getPoint(b)),y.push(b))})):y.push(d));return{hoverPoint:d,hoverSeries:c,
	hoverPoints:y}},runPointActions:function(b,c){var d=this.chart,f=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,e=f?f.shared:!1,h=c||d.hoverPoint,g=h&&h.series||d.hoverSeries,g=this.getHoverData(h,g,d.series,!!c||g&&g.directTouch&&this.isDirectTouch,e,b,{isBoosting:d.isBoosting}),l,h=g.hoverPoint;l=g.hoverPoints;c=(g=g.hoverSeries)&&g.tooltipOptions.followPointer;e=e&&g&&!g.noSharedTooltip;if(h&&(h!==d.hoverPoint||f&&f.isHidden)){r(d.hoverPoints||[],function(b){-1===a.inArray(b,l)&&b.setState()});
	r(l||[],function(a){a.setState("hover")});if(d.hoverSeries!==g)g.onMouseOver();d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!h.series)return;h.firePointEvent("mouseOver");d.hoverPoints=l;d.hoverPoint=h;f&&f.refresh(e?l:h,b)}else c&&f&&!f.isHidden&&(h=f.getAnchor([{}],b),f.updatePosition({plotX:h[0],plotY:h[1]}));this.unDocMouseMove||(this.unDocMouseMove=D(d.container.ownerDocument,"mousemove",function(b){var c=G[a.hoverChartIndex];if(c)c.pointer.onDocumentMouseMove(b)}));r(d.axes,function(c){var d=
	m(c.crosshair.snap,!0),f=d?a.find(l,function(a){return a.series[c.coll]===c}):void 0;f||!d?c.drawCrosshair(b,f):c.hideCrosshair()})},reset:function(a,d){var b=this.chart,f=b.hoverSeries,e=b.hoverPoint,h=b.hoverPoints,g=b.tooltip,m=g&&g.shared?h:e;a&&m&&r(c(m),function(b){b.series.isCartesian&&void 0===b.plotX&&(a=!1)});if(a)g&&m&&(g.refresh(m),e&&(e.setState(e.state,!0),r(b.axes,function(a){a.crosshair&&a.drawCrosshair(null,e)})));else{if(e)e.onMouseOut();h&&r(h,function(a){a.setState()});if(f)f.onMouseOut();
	g&&g.hide(d);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());r(b.axes,function(a){a.hideCrosshair()});this.hoverX=b.hoverPoints=b.hoverPoint=null}},scaleGroups:function(a,c){var b=this.chart,d;r(b.series,function(f){d=a||f.getPlotBox();f.xAxis&&f.xAxis.zoomEnabled&&f.group&&(f.group.attr(d),f.markerGroup&&(f.markerGroup.attr(d),f.markerGroup.clip(c?b.clipRect:null)),f.dataLabelsGroup&&f.dataLabelsGroup.attr(d))});b.clipRect.attr(c||b.clipBox)},dragStart:function(a){var b=this.chart;
	b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,c=b.options.chart,f=a.chartX,e=a.chartY,h=this.zoomHor,g=this.zoomVert,m=b.plotLeft,l=b.plotTop,n=b.plotWidth,q=b.plotHeight,A,E=this.selectionMarker,F=this.mouseDownX,k=this.mouseDownY,u=c.panKey&&a[c.panKey+"Key"];E&&E.touch||(f<m?f=m:f>m+n&&(f=m+n),e<l?e=l:e>l+q&&(e=l+q),this.hasDragged=Math.sqrt(Math.pow(F-f,2)+Math.pow(k-e,2)),10<this.hasDragged&&
	(A=b.isInsidePlot(F-m,k-l),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&A&&!u&&!E&&(this.selectionMarker=E=b.renderer.rect(m,l,h?1:n,g?1:q,0).attr({fill:c.selectionMarkerFill||p("#335cad").setOpacity(.25).get(),"class":"highcharts-selection-marker",zIndex:7}).add()),E&&h&&(f-=F,E.attr({width:Math.abs(f),x:(0<f?0:f)+F})),E&&g&&(f=e-k,E.attr({height:Math.abs(f),y:(0<f?0:f)+k})),A&&!E&&c.panning&&b.pan(a,c.panning)))},drop:function(a){var b=this,c=this.chart,f=this.hasPinched;if(this.selectionMarker){var e=
	{originalEvent:a,xAxis:[],yAxis:[]},h=this.selectionMarker,m=h.attr?h.attr("x"):h.x,x=h.attr?h.attr("y"):h.y,C=h.attr?h.attr("width"):h.width,p=h.attr?h.attr("height"):h.height,q;if(this.hasDragged||f)r(c.axes,function(c){if(c.zoomEnabled&&l(c.min)&&(f||b[{xAxis:"zoomX",yAxis:"zoomY"}[c.coll]])){var d=c.horiz,h="touchend"===a.type?c.minPixelPadding:0,k=c.toValue((d?m:x)+h),d=c.toValue((d?m+C:x+p)-h);e[c.coll].push({axis:c,min:Math.min(k,d),max:Math.max(k,d)});q=!0}}),q&&v(c,"selection",e,function(a){c.zoom(n(a,
	f?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();f&&this.scaleGroups()}c&&(g(c.container,{cursor:c._cursor}),c.cancelClick=10<this.hasDragged,c.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();this.dragStart(a)},onDocumentMouseUp:function(b){G[a.hoverChartIndex]&&G[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,
	c=this.chartPosition;a=this.normalize(a,c);!c||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var c=G[a.hoverChartIndex];c&&(b.relatedTarget||b.toElement)&&(c.pointer.reset(),c.pointer.chartPosition=null)},onContainerMouseMove:function(b){var c=this.chart;l(a.hoverChartIndex)&&G[a.hoverChartIndex]&&G[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=c.index);b=this.normalize(b);b.returnValue=!1;
	"mousedown"===c.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!c.isInsidePlot(b.chartX-c.plotLeft,b.chartY-c.plotTop)||c.openMenu||this.runPointActions(b)},inClass:function(a,c){for(var b;a;){if(b=B(a,"class")){if(-1!==b.indexOf(c))return!0;if(-1!==b.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||
	this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,c=b.hoverPoint,f=b.plotLeft,e=b.plotTop;a=this.normalize(a);b.cancelClick||(c&&this.inClass(a.target,"highcharts-tracker")?(v(c.series,"click",n(a,{point:c})),b.hoverPoint&&c.firePointEvent("click",a)):(n(a,this.getCoordinates(a)),b.isInsidePlot(a.chartX-f,a.chartY-e)&&v(b,"click",a)))},setDOMEvents:function(){var b=this,c=b.chart.container,f=c.ownerDocument;
	c.onmousedown=function(a){b.onContainerMouseDown(a)};c.onmousemove=function(a){b.onContainerMouseMove(a)};c.onclick=function(a){b.onContainerClick(a)};this.unbindContainerMouseLeave=D(c,"mouseleave",b.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=D(f,"mouseup",b.onDocumentMouseUp));a.hasTouch&&(c.ontouchstart=function(a){b.onContainerTouchStart(a)},c.ontouchmove=function(a){b.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=D(f,"touchend",b.onDocumentTouchEnd)))},
	destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();this.unbindContainerMouseLeave();a.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,c){b[c]=null})}}})(N);(function(a){var D=a.charts,B=a.each,G=a.extend,p=a.map,g=a.noop,l=a.pick;G(a.Pointer.prototype,{pinchTranslate:function(a,g,l,p,e,h){this.zoomHor&&
	this.pinchTranslateDirection(!0,a,g,l,p,e,h);this.zoomVert&&this.pinchTranslateDirection(!1,a,g,l,p,e,h)},pinchTranslateDirection:function(a,g,l,p,e,h,m,c){var f=this.chart,b=a?"x":"y",d=a?"X":"Y",y="chart"+d,n=a?"width":"height",r=f["plot"+(a?"Left":"Top")],t,v,x=c||1,C=f.inverted,w=f.bounds[a?"h":"v"],q=1===g.length,A=g[0][y],E=l[0][y],F=!q&&g[1][y],k=!q&&l[1][y],u;l=function(){!q&&20<Math.abs(A-F)&&(x=c||Math.abs(E-k)/Math.abs(A-F));v=(r-E)/x+A;t=f["plot"+(a?"Width":"Height")]/x};l();g=v;g<w.min?
	(g=w.min,u=!0):g+t>w.max&&(g=w.max-t,u=!0);u?(E-=.8*(E-m[b][0]),q||(k-=.8*(k-m[b][1])),l()):m[b]=[E,k];C||(h[b]=v-r,h[n]=t);h=C?1/x:x;e[n]=t;e[b]=g;p[C?a?"scaleY":"scaleX":"scale"+d]=x;p["translate"+d]=h*r+(E-h*A)},pinch:function(a){var n=this,r=n.chart,v=n.pinchDown,e=a.touches,h=e.length,m=n.lastValidTouch,c=n.hasZoom,f=n.selectionMarker,b={},d=1===h&&(n.inClass(a.target,"highcharts-tracker")&&r.runTrackerClick||n.runChartClick),y={};1<h&&(n.initiated=!0);c&&n.initiated&&!d&&a.preventDefault();
	p(e,function(a){return n.normalize(a)});"touchstart"===a.type?(B(e,function(a,b){v[b]={chartX:a.chartX,chartY:a.chartY}}),m.x=[v[0].chartX,v[1]&&v[1].chartX],m.y=[v[0].chartY,v[1]&&v[1].chartY],B(r.axes,function(a){if(a.zoomEnabled){var b=r.bounds[a.horiz?"h":"v"],c=a.minPixelPadding,f=a.toPixels(l(a.options.min,a.dataMin)),d=a.toPixels(l(a.options.max,a.dataMax)),e=Math.max(f,d);b.min=Math.min(a.pos,Math.min(f,d)-c);b.max=Math.max(a.pos+a.len,e+c)}}),n.res=!0):n.followTouchMove&&1===h?this.runPointActions(n.normalize(a)):
	v.length&&(f||(n.selectionMarker=f=G({destroy:g,touch:!0},r.plotBox)),n.pinchTranslate(v,e,b,f,y,m),n.hasPinched=c,n.scaleGroups(b,y),n.res&&(n.res=!1,this.reset(!1,0)))},touch:function(g,n){var r=this.chart,p,e;if(r.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=r.index;1===g.touches.length?(g=this.normalize(g),(e=r.isInsidePlot(g.chartX-r.plotLeft,g.chartY-r.plotTop))&&!r.openMenu?(n&&this.runPointActions(g),"touchmove"===g.type&&(n=this.pinchDown,p=n[0]?
	4<=Math.sqrt(Math.pow(n[0].chartX-g.chartX,2)+Math.pow(n[0].chartY-g.chartY,2)):!1),l(p,!0)&&this.pinch(g)):n&&this.reset()):2===g.touches.length&&this.pinch(g)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(g){D[a.hoverChartIndex]&&D[a.hoverChartIndex].pointer.drop(g)}})})(N);(function(a){var D=a.addEvent,B=a.charts,G=a.css,p=a.doc,g=a.extend,l=a.noop,r=a.Pointer,n=a.removeEvent,w=a.win,v=a.wrap;
	if(!a.hasTouch&&(w.PointerEvent||w.MSPointerEvent)){var e={},h=!!w.PointerEvent,m=function(){var c=[];c.item=function(a){return this[a]};a.objectEach(e,function(a){c.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return c},c=function(c,b,d,e){"touch"!==c.pointerType&&c.pointerType!==c.MSPOINTER_TYPE_TOUCH||!B[a.hoverChartIndex]||(e(c),e=B[a.hoverChartIndex].pointer,e[b]({type:d,target:c.currentTarget,preventDefault:l,touches:m()}))};g(r.prototype,{onContainerPointerDown:function(a){c(a,"onContainerTouchStart",
	"touchstart",function(a){e[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){c(a,"onContainerTouchMove","touchmove",function(a){e[a.pointerId]={pageX:a.pageX,pageY:a.pageY};e[a.pointerId].target||(e[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){c(a,"onDocumentTouchEnd","touchend",function(a){delete e[a.pointerId]})},batchMSEvents:function(a){a(this.chart.container,h?"pointerdown":"MSPointerDown",this.onContainerPointerDown);
	a(this.chart.container,h?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(p,h?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});v(r.prototype,"init",function(a,b,c){a.call(this,b,c);this.hasZoom&&G(b.container,{"-ms-touch-action":"none","touch-action":"none"})});v(r.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(D)});v(r.prototype,"destroy",function(a){this.batchMSEvents(n);a.call(this)})}})(N);(function(a){var D=a.addEvent,
	B=a.css,G=a.discardElement,p=a.defined,g=a.each,l=a.isFirefox,r=a.marginNames,n=a.merge,w=a.pick,v=a.setAnimation,e=a.stableSort,h=a.win,m=a.wrap;a.Legend=function(a,f){this.init(a,f)};a.Legend.prototype={init:function(a,f){this.chart=a;this.setOptions(f);f.enabled&&(this.render(),D(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},setOptions:function(a){var c=w(a.padding,8);this.options=a;this.itemStyle=a.itemStyle;this.itemHiddenStyle=n(this.itemStyle,a.itemHiddenStyle);this.itemMarginTop=
	a.itemMarginTop||0;this.padding=c;this.initialItemY=c-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=w(a.symbolWidth,16);this.pages=[]},update:function(a,f){var b=this.chart;this.setOptions(n(!0,this.options,a));this.destroy();b.isDirtyLegend=b.isDirtyBox=!0;w(f,!0)&&b.redraw()},colorizeItem:function(a,f){a.legendGroup[f?"removeClass":"addClass"]("highcharts-legend-item-hidden");var b=this.options,c=a.legendItem,e=a.legendLine,h=a.legendSymbol,g=this.itemHiddenStyle.color,b=f?b.itemStyle.color:
	g,m=f?a.color||g:g,l=a.options&&a.options.marker,x={fill:m};c&&c.css({fill:b,color:b});e&&e.attr({stroke:m});h&&(l&&h.isMarker&&(x=a.pointAttribs(),f||(x.stroke=x.fill=g)),h.attr(x))},positionItem:function(a){var c=this.options,b=c.symbolPadding,c=!c.rtl,d=a._legendItemPos,e=d[0],d=d[1],h=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(c?e:this.legendWidth-e-2*b-4,d);h&&(h.x=e,h.y=d)},destroyItem:function(a){var c=a.checkbox;g(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&
	(a[b]=a[b].destroy())});c&&G(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}g(this.getAllItems(),function(c){g(["legendItem","legendGroup"],a,c)});g("clipRect up down pager nav box title group".split(" "),a,this);this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,f,b=this.clipHeight||this.legendHeight,d=this.titleHeight;a&&(f=a.translateY,g(this.allItems,function(c){var e=c.checkbox,h;e&&(h=f+d+e.y+(this.scrollOffset||0)+3,B(e,
	{left:a.translateX+c.checkboxOffset+e.x-20+"px",top:h+"px",display:h>f-6&&h<f+b-6?"":"none"}))},this))},renderTitle:function(){var a=this.options,f=this.padding,b=a.title,d=0;b.text&&(this.title||(this.title=this.chart.renderer.label(b.text,f-3,f-4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).css(b.style).add(this.group)),a=this.title.getBBox(),d=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:d}));this.titleHeight=d},setText:function(c){var f=this.options;c.legendItem.attr({text:f.labelFormat?
	a.format(f.labelFormat,c):f.labelFormatter.call(c)})},renderItem:function(a){var c=this.chart,b=c.renderer,d=this.options,e="horizontal"===d.layout,h=this.symbolWidth,g=d.symbolPadding,m=this.itemStyle,l=this.itemHiddenStyle,x=this.padding,C=e?w(d.itemDistance,20):0,r=!d.rtl,q=d.width,A=d.itemMarginBottom||0,E=this.itemMarginTop,F=a.legendItem,k=!a.series,u=!k&&a.series.drawLegendSymbol?a.series:a,p=u.options,v=this.createCheckboxForItem&&p&&p.showCheckbox,p=h+g+C+(v?20:0),P=d.useHTML,I=a.options.className;
	F||(a.legendGroup=b.g("legend-item").addClass("highcharts-"+u.type+"-series highcharts-color-"+a.colorIndex+(I?" "+I:"")+(k?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=F=b.text("",r?h+g:-g,this.baseline||0,P).css(n(a.visible?m:l)).attr({align:r?"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(h=m.fontSize,this.fontMetrics=b.fontMetrics(h,F),this.baseline=this.fontMetrics.f+3+E,F.attr("y",this.baseline)),this.symbolHeight=d.symbolHeight||this.fontMetrics.f,
	u.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,F,P),v&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);m.width||F.css({width:(d.itemWidth||d.width||c.spacingBox.width)-p});this.setText(a);b=F.getBBox();m=a.checkboxOffset=d.itemWidth||a.legendItemWidth||b.width+p;this.itemHeight=b=Math.round(a.legendItemHeight||b.height||this.symbolHeight);e&&this.itemX-x+m>(q||c.spacingBox.width-2*x-d.x)&&(this.itemX=x,this.itemY+=E+this.lastLineHeight+A,this.lastLineHeight=0);this.maxItemWidth=
	Math.max(this.maxItemWidth,m);this.lastItemY=E+this.itemY+A;this.lastLineHeight=Math.max(b,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=m:(this.itemY+=E+b+A,this.lastLineHeight=b);this.offsetWidth=q||Math.max((e?this.itemX-x-(a.checkbox?0:C):m)+x,this.offsetWidth)},getAllItems:function(){var a=[];g(this.chart.series,function(c){var b=c&&c.options;c&&w(b.showInLegend,p(b.linkedTo)?!1:void 0,!0)&&(a=a.concat(c.legendItems||("point"===b.legendType?c.data:c)))});return a},
	adjustMargins:function(a,f){var b=this.chart,c=this.options,e=c.align.charAt(0)+c.verticalAlign.charAt(0)+c.layout.charAt(0);c.floating||g([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(d,h){d.test(e)&&!p(a[h])&&(b[r[h]]=Math.max(b[r[h]],b.legend[(h+1)%2?"legendHeight":"legendWidth"]+[1,-1,-1,1][h]*c[h%2?"x":"y"]+w(c.margin,12)+f[h]))})},render:function(){var a=this,f=a.chart,b=f.renderer,d=a.group,h,m,l,t,p=a.box,x=a.options,r=a.padding;a.itemX=r;a.itemY=a.initialItemY;a.offsetWidth=
	0;a.lastItemY=0;d||(a.group=d=b.g("legend").attr({zIndex:7}).add(),a.contentGroup=b.g().attr({zIndex:1}).add(d),a.scrollGroup=b.g().add(a.contentGroup));a.renderTitle();h=a.getAllItems();e(h,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||0)});x.reversed&&h.reverse();a.allItems=h;a.display=m=!!h.length;a.lastLineHeight=0;g(h,function(b){a.renderItem(b)});l=(x.width||a.offsetWidth)+r;t=a.lastItemY+a.lastLineHeight+a.titleHeight;t=a.handleOverflow(t);t+=
	r;p||(a.box=p=b.rect().addClass("highcharts-legend-box").attr({r:x.borderRadius}).add(d),p.isNew=!0);p.attr({stroke:x.borderColor,"stroke-width":x.borderWidth||0,fill:x.backgroundColor||"none"}).shadow(x.shadow);0<l&&0<t&&(p[p.isNew?"attr":"animate"](p.crisp.call({},{x:0,y:0,width:l,height:t},p.strokeWidth())),p.isNew=!1);p[m?"show":"hide"]();a.legendWidth=l;a.legendHeight=t;g(h,function(b){a.positionItem(b)});m&&d.align(n(x,{width:l,height:t}),!0,"spacingBox");f.isResizing||this.positionCheckboxes()},
	handleOverflow:function(a){var c=this,b=this.chart,d=b.renderer,e=this.options,h=e.y,m=this.padding,b=b.spacingBox.height+("top"===e.verticalAlign?-h:h)-m,h=e.maxHeight,l,n=this.clipRect,x=e.navigation,p=w(x.animation,!0),r=x.arrowSize||12,q=this.nav,A=this.pages,E,F=this.allItems,k=function(a){"number"===typeof a?n.attr({height:a}):n&&(c.clipRect=n.destroy(),c.contentGroup.clip());c.contentGroup.div&&(c.contentGroup.div.style.clip=a?"rect("+m+"px,9999px,"+(m+a)+"px,0)":"auto")};"horizontal"!==e.layout||
	"middle"===e.verticalAlign||e.floating||(b/=2);h&&(b=Math.min(b,h));A.length=0;a>b&&!1!==x.enabled?(this.clipHeight=l=Math.max(b-20-this.titleHeight-m,0),this.currentPage=w(this.currentPage,1),this.fullHeight=a,g(F,function(a,b){var c=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var d=A.length;if(!d||c-A[d-1]>l&&(E||c)!==A[d-1])A.push(E||c),d++;b===F.length-1&&c+a-A[d-1]>l&&A.push(c);c!==E&&(E=c)}),n||(n=c.clipRect=d.clipRect(0,m,9999,0),c.contentGroup.clip(n)),k(l),q||(this.nav=
	q=d.g().attr({zIndex:1}).add(this.group),this.up=d.symbol("triangle",0,0,r,r).on("click",function(){c.scroll(-1,p)}).add(q),this.pager=d.text("",15,10).addClass("highcharts-legend-navigation").css(x.style).add(q),this.down=d.symbol("triangle-down",0,0,r,r).on("click",function(){c.scroll(1,p)}).add(q)),c.scroll(0),a=b):q&&(k(),this.nav=q.destroy(),this.scrollGroup.attr({translateY:1}),this.clipHeight=0);return a},scroll:function(a,f){var b=this.pages,c=b.length;a=this.currentPage+a;var e=this.clipHeight,
	h=this.options.navigation,g=this.pager,m=this.padding;a>c&&(a=c);0<a&&(void 0!==f&&v(f,this.chart),this.nav.attr({translateX:m,translateY:e+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),g.attr({text:a+"/"+c}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===c?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),this.up.attr({fill:1===a?h.inactiveColor:h.activeColor}).css({cursor:1===
	a?"default":"pointer"}),this.down.attr({fill:a===c?h.inactiveColor:h.activeColor}).css({cursor:a===c?"default":"pointer"}),this.scrollOffset=-b[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=a,this.positionCheckboxes())}};a.LegendSymbolMixin={drawRectangle:function(a,f){var b=a.symbolHeight,c=a.options.squareSymbol;f.legendSymbol=this.chart.renderer.rect(c?(a.symbolWidth-b)/2:0,a.baseline-b+1,c?b:a.symbolWidth,b,w(a.options.symbolRadius,b/2)).addClass("highcharts-point").attr({zIndex:3}).add(f.legendGroup)},
	drawLineMarker:function(a){var c=this.options,b=c.marker,d=a.symbolWidth,e=a.symbolHeight,h=e/2,g=this.chart.renderer,m=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);var l;l={"stroke-width":c.lineWidth||0};c.dashStyle&&(l.dashstyle=c.dashStyle);this.legendLine=g.path(["M",0,a,"L",d,a]).addClass("highcharts-graph").attr(l).add(m);b&&!1!==b.enabled&&(c=Math.min(w(b.radius,h),h),0===this.symbol.indexOf("url")&&(b=n(b,{width:e,height:e}),c=0),this.legendSymbol=b=g.symbol(this.symbol,d/
	2-c,a-c,2*c,2*c,b).addClass("highcharts-point").add(m),b.isMarker=!0)}};(/Trident\/7\.0/.test(h.navigator.userAgent)||l)&&m(a.Legend.prototype,"positionItem",function(a,f){var b=this,c=function(){f._legendItemPos&&a.call(b,f)};c();setTimeout(c)})})(N);(function(a){var D=a.addEvent,B=a.animate,G=a.animObject,p=a.attr,g=a.doc,l=a.Axis,r=a.createElement,n=a.defaultOptions,w=a.discardElement,v=a.charts,e=a.css,h=a.defined,m=a.each,c=a.extend,f=a.find,b=a.fireEvent,d=a.grep,y=a.isNumber,H=a.isObject,J=
	a.isString,t=a.Legend,K=a.marginNames,x=a.merge,C=a.objectEach,L=a.Pointer,q=a.pick,A=a.pInt,E=a.removeEvent,F=a.seriesTypes,k=a.splat,u=a.svg,R=a.syncTimeout,M=a.win,P=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new P(a,b,c)};c(P.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(J(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var d,f,k=b.series,e=b.plotOptions||{};b.series=null;d=x(n,b);for(f in d.plotOptions)d.plotOptions[f].tooltip=
	e[f]&&x(e[f].tooltip)||void 0;d.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||b.tooltip;d.series=b.series=k;this.userOptions=b;b=d.chart;f=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=d;this.axes=[];this.series=[];this.hasCartesianSeries=b.showAxes;var q=this;q.index=v.length;v.push(q);a.chartCount++;f&&C(f,function(a,b){D(q,b,a)});q.xAxis=[];q.yAxis=[];q.pointCount=q.colorCounter=q.symbolCounter=
	0;q.firstRender()},initSeries:function(b){var c=this.options.chart;(c=F[b.type||c.type||c.defaultSeriesType])||a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,b,c){var d=c?b:a;a=c?a:b;return 0<=d&&d<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(d){var f=this.axes,k=this.series,e=this.pointer,q=this.legend,h=this.isDirtyLegend,
	g,l,u=this.hasCartesianSeries,A=this.isDirtyBox,E,t=this.renderer,n=t.isHidden(),x=[];this.setResponsive&&this.setResponsive(!1);a.setAnimation(d,this);n&&this.temporaryDisplay();this.layOutTitles();for(d=k.length;d--;)if(E=k[d],E.options.stacking&&(g=!0,E.isDirty)){l=!0;break}if(l)for(d=k.length;d--;)E=k[d],E.options.stacking&&(E.isDirty=!0);m(k,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),h=!0);a.isDirtyData&&b(a,"updatedData")});h&&q.options.enabled&&
	(q.render(),this.isDirtyLegend=!1);g&&this.getStacks();u&&m(f,function(a){a.updateNames();a.setScale()});this.getMargins();u&&(m(f,function(a){a.isDirty&&(A=!0)}),m(f,function(a){var d=a.min+","+a.max;a.extKey!==d&&(a.extKey=d,x.push(function(){b(a,"afterSetExtremes",c(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(A||g)&&a.redraw()}));A&&this.drawChartBox();b(this,"predraw");m(k,function(a){(A||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});e&&e.reset(!0);t.draw();b(this,"redraw");b(this,
	"render");n&&this.temporaryDisplay(!0);m(x,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===a}var c,d=this.series,k;c=f(this.axes,b)||f(this.series,b);for(k=0;!c&&k<d.length;k++)c=f(d[k].points||[],b);return c},getAxes:function(){var a=this,b=this.options,c=b.xAxis=k(b.xAxis||{}),b=b.yAxis=k(b.yAxis||{});m(c,function(a,b){a.index=b;a.isX=!0});m(b,function(a,b){a.index=b});c=c.concat(b);m(c,function(b){new l(a,b)})},getSelectedPoints:function(){var a=
	[];m(this.series,function(b){a=a.concat(d(b.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return d(this.series,function(a){return a.selected})},setTitle:function(a,b,c){var d=this,f=d.options,k;k=f.title=x({style:{color:"#333333",fontSize:f.isStock?"16px":"18px"}},f.title,a);f=f.subtitle=x({style:{color:"#666666"}},f.subtitle,b);m([["title",a,k],["subtitle",b,f]],function(a,b){var c=a[0],f=d[c],k=a[1];a=a[2];f&&k&&(d[c]=f=f.destroy());a&&!f&&(d[c]=d.renderer.text(a.text,
	0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),d[c].update=function(a){d.setTitle(!b&&a,b&&a)},d[c].css(a.style))});d.layOutTitles(c)},layOutTitles:function(a){var b=0,d,f=this.renderer,k=this.spacingBox;m(["title","subtitle"],function(a){var d=this[a],e=this.options[a];a="title"===a?-3:e.verticalAlign?0:b+2;var q;d&&(q=e.style.fontSize,q=f.fontMetrics(q,d).b,d.css({width:(e.width||k.width+e.widthAdjust)+"px"}).align(c({y:a+q},e),!1,"spacingBox"),e.floating||
	e.verticalAlign||(b=Math.ceil(b+d.getBBox(e.useHTML).height)))},this);d=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&d&&(this.isDirtyBox=d,this.hasRendered&&q(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,c=b.width,b=b.height,d=this.renderTo;h(c)||(this.containerWidth=a.getStyle(d,"width"));h(b)||(this.containerHeight=a.getStyle(d,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,
	this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(g.body.removeChild(c),c.hcOrigDetached=!1),c=c.parentNode;else for(;c&&c.style;){g.body.contains(c)||c.parentNode||(c.hcOrigDetached=!0,g.body.appendChild(c));if("none"===a.getStyle(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},
	b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===g.body)break}},setClassName:function(a){this.container.className="highcharts-container "+(a||"")},getContainer:function(){var b,d=this.options,f=d.chart,k,e;b=this.renderTo;var q=a.uniqueKey(),h;b||(this.renderTo=b=f.renderTo);J(b)&&(this.renderTo=b=g.getElementById(b));b||a.error(13,!0);k=A(p(b,"data-highcharts-chart"));y(k)&&v[k]&&
	v[k].hasRendered&&v[k].destroy();p(b,"data-highcharts-chart",this.index);b.innerHTML="";f.skipClone||b.offsetWidth||this.temporaryDisplay();this.getChartSize();k=this.chartWidth;e=this.chartHeight;h=c({position:"relative",overflow:"hidden",width:k+"px",height:e+"px",textAlign:"left",lineHeight:"normal",zIndex:0,"-webkit-tap-highlight-color":"rgba(0,0,0,0)"},f.style);this.container=b=r("div",{id:q},h,b);this._cursor=b.style.cursor;this.renderer=new (a[f.renderer]||a.Renderer)(b,k,e,null,f.forExport,
	d.exporting&&d.exporting.allowHTML);this.setClassName(f.className);this.renderer.setStyle(f.style);this.renderer.chartIndex=this.index},getMargins:function(a){var b=this.spacing,c=this.margin,d=this.titleOffset;this.resetMargins();d&&!h(c[0])&&(this.plotTop=Math.max(this.plotTop,d+this.options.title.margin+b[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(c,b);this.extraMargin&&(this[this.extraMargin.type]=(this[this.extraMargin.type]||0)+this.extraMargin.value);this.adjustPlotArea&&
	this.adjustPlotArea();a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],c=a.margin;a.hasCartesianSeries&&m(a.axes,function(a){a.visible&&a.getOffset()});m(K,function(d,f){h(c[f])||(a[d]+=b[f])});a.setChartSize()},reflow:function(b){var c=this,d=c.options.chart,f=c.renderTo,k=h(d.width)&&h(d.height),e=d.width||a.getStyle(f,"width"),d=d.height||a.getStyle(f,"height"),f=b?b.target:M;if(!k&&!c.isPrinting&&e&&d&&(f===M||f===g)){if(e!==c.containerWidth||d!==c.containerHeight)clearTimeout(c.reflowTimeout),
	c.reflowTimeout=R(function(){c.container&&c.setSize(void 0,void 0,!1)},b?100:0);c.containerWidth=e;c.containerHeight=d}},initReflow:function(){var a=this,b;b=D(M,"resize",function(b){a.reflow(b)});D(a,"destroy",b)},setSize:function(c,d,f){var k=this,q=k.renderer;k.isResizing+=1;a.setAnimation(f,k);k.oldChartHeight=k.chartHeight;k.oldChartWidth=k.chartWidth;void 0!==c&&(k.options.chart.width=c);void 0!==d&&(k.options.chart.height=d);k.getChartSize();c=q.globalAnimation;(c?B:e)(k.container,{width:k.chartWidth+
	"px",height:k.chartHeight+"px"},c);k.setChartSize(!0);q.setSize(k.chartWidth,k.chartHeight,f);m(k.axes,function(a){a.isDirty=!0;a.setScale()});k.isDirtyLegend=!0;k.isDirtyBox=!0;k.layOutTitles();k.getMargins();k.redraw(f);k.oldChartHeight=null;b(k,"resize");R(function(){k&&b(k,"endResize",null,function(){--k.isResizing})},G(c).duration)},setChartSize:function(a){var b=this.inverted,c=this.renderer,d=this.chartWidth,k=this.chartHeight,f=this.options.chart,e=this.spacing,q=this.clipOffset,h,g,l,u;this.plotLeft=
	h=Math.round(this.plotLeft);this.plotTop=g=Math.round(this.plotTop);this.plotWidth=l=Math.max(0,Math.round(d-h-this.marginRight));this.plotHeight=u=Math.max(0,Math.round(k-g-this.marginBottom));this.plotSizeX=b?u:l;this.plotSizeY=b?l:u;this.plotBorderWidth=f.plotBorderWidth||0;this.spacingBox=c.spacingBox={x:e[3],y:e[0],width:d-e[3]-e[1],height:k-e[0]-e[2]};this.plotBox=c.plotBox={x:h,y:g,width:l,height:u};d=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(d,q[3])/2);c=Math.ceil(Math.max(d,
	q[0])/2);this.clipBox={x:b,y:c,width:Math.floor(this.plotSizeX-Math.max(d,q[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(d,q[2])/2-c))};a||m(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;m(["margin","spacing"],function(c){var d=b[c],k=H(d)?d:[d,d,d,d];m(["Top","Right","Bottom","Left"],function(d,f){a[c][f]=q(b[c+d],k[f])})});m(K,function(b,c){a[b]=q(a.margin[c],a.spacing[c])});a.axisOffset=[0,0,0,0];a.clipOffset=
	[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,d=this.chartHeight,k=this.chartBackground,f=this.plotBackground,e=this.plotBorder,q,h=this.plotBGImage,g=a.backgroundColor,m=a.plotBackgroundColor,l=a.plotBackgroundImage,u,A=this.plotLeft,E=this.plotTop,t=this.plotWidth,n=this.plotHeight,x=this.plotBox,y=this.clipRect,F=this.clipBox,p="animate";k||(this.chartBackground=k=b.rect().addClass("highcharts-background").add(),p="attr");q=a.borderWidth||0;u=q+(a.shadow?
	8:0);g={fill:g||"none"};if(q||k["stroke-width"])g.stroke=a.borderColor,g["stroke-width"]=q;k.attr(g).shadow(a.shadow);k[p]({x:u/2,y:u/2,width:c-u-q%2,height:d-u-q%2,r:a.borderRadius});p="animate";f||(p="attr",this.plotBackground=f=b.rect().addClass("highcharts-plot-background").add());f[p](x);f.attr({fill:m||"none"}).shadow(a.plotShadow);l&&(h?h.animate(x):this.plotBGImage=b.image(l,A,E,t,n).add());y?y.animate({width:F.width,height:F.height}):this.clipRect=b.clipRect(F);p="animate";e||(p="attr",this.plotBorder=
	e=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());e.attr({stroke:a.plotBorderColor,"stroke-width":a.plotBorderWidth||0,fill:"none"});e[p](e.crisp({x:A,y:E,width:t,height:n},-e.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,c,d=a.options.series,k,f;m(["inverted","angular","polar"],function(e){c=F[b.type||b.defaultSeriesType];f=b[e]||c&&c.prototype[e];for(k=d&&d.length;!f&&k--;)(c=F[d[k].type])&&c.prototype[e]&&(f=!0);a[e]=f})},linkSeries:function(){var a=
	this,b=a.series;m(b,function(a){a.linkedSeries.length=0});m(b,function(b){var c=b.options.linkedTo;J(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=q(b.options.visible,c.options.visible,b.visible))})},renderSeries:function(){m(this.series,function(a){a.translate();a.render()})},renderLabels:function(){var a=this,b=a.options.labels;b.items&&m(b.items,function(d){var k=c(b.style,d.style),f=A(k.left)+a.plotLeft,e=A(k.top)+
	a.plotTop+12;delete k.left;delete k.top;a.renderer.text(d.html,f,e).attr({zIndex:2}).css(k).add()})},render:function(){var a=this.axes,b=this.renderer,c=this.options,d,k,f;this.setTitle();this.legend=new t(this,c.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();c=this.plotWidth;d=this.plotHeight=Math.max(this.plotHeight-21,0);m(a,function(a){a.setScale()});this.getAxisMargins();k=1.1<c/this.plotWidth;f=1.05<d/this.plotHeight;if(k||f)m(a,function(a){(a.horiz&&k||!a.horiz&&
	f)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&m(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=this;a=x(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",
	function(){a.href&&(M.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).css(a.style).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var c=this,d=c.axes,k=c.series,f=c.container,e,q=f&&f.parentNode;b(c,"destroy");c.renderer.forExport?a.erase(v,c):v[c.index]=void 0;a.chartCount--;c.renderTo.removeAttribute("data-highcharts-chart");E(c);for(e=d.length;e--;)d[e]=d[e].destroy();this.scroller&&this.scroller.destroy&&
	this.scroller.destroy();for(e=k.length;e--;)k[e]=k[e].destroy();m("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var b=c[a];b&&b.destroy&&(c[a]=b.destroy())});f&&(f.innerHTML="",E(f),q&&w(f));C(c,function(a,b){delete c[b]})},isReadyToRender:function(){var a=this;return u||M!=M.top||"complete"===g.readyState?!0:(g.attachEvent("onreadystatechange",function(){g.detachEvent("onreadystatechange",
	a.firstRender);"complete"===g.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,c=a.options;if(a.isReadyToRender()){a.getContainer();b(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();m(c.series||[],function(b){a.initSeries(b)});a.linkSeries();b(a,"beforeRender");L&&(a.pointer=new L(a,c));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){m([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&
	a.apply(this,[this])},this);b(this,"load");b(this,"render");h(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}})})(N);(function(a){var D,B=a.each,G=a.extend,p=a.erase,g=a.fireEvent,l=a.format,r=a.isArray,n=a.isNumber,w=a.pick,v=a.removeEvent;a.Point=D=function(){};a.Point.prototype={init:function(a,h,g){this.series=a;this.color=a.color;this.applyOptions(h,g);a.options.colorByPoint?(h=a.options.colors||a.chart.options.colors,this.color=this.color||h[a.colorCounter],
	h=h.length,g=a.colorCounter,a.colorCounter++,a.colorCounter===h&&(a.colorCounter=0)):g=a.colorIndex;this.colorIndex=w(this.colorIndex,g);a.chart.pointCount++;return this},applyOptions:function(a,h){var e=this.series,c=e.options.pointValKey||e.pointValKey;a=D.prototype.optionsToObject.call(this,a);G(this,a);this.options=this.options?G(this.options,a):a;a.group&&delete this.group;c&&(this.y=this[c]);this.isNull=w(this.isValid&&!this.isValid(),null===this.x||!n(this.y,!0));this.selected&&(this.state=
	"select");"name"in this&&void 0===h&&e.xAxis&&e.xAxis.hasNames&&(this.x=e.xAxis.nameToX(this));void 0===this.x&&e&&(this.x=void 0===h?e.autoIncrement(this):h);return this},optionsToObject:function(a){var e={},g=this.series,c=g.options.keys,f=c||g.pointArrayMap||["y"],b=f.length,d=0,l=0;if(n(a)||null===a)e[f[0]]=a;else if(r(a))for(!c&&a.length>b&&(g=typeof a[0],"string"===g?e.name=a[0]:"number"===g&&(e.x=a[0]),d++);l<b;)c&&void 0===a[d]||(e[f[l]]=a[d]),d++,l++;else"object"===typeof a&&(e=a,a.dataLabels&&
	(g._hasPointLabels=!0),a.marker&&(g._hasPointMarkers=!0));return e},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,
	h=a.zones,a=a.zoneAxis||"y",g=0,c;for(c=h[g];this[a]>=c.value;)c=h[++g];c&&c.color&&!this.options.color&&(this.color=c.color);return c},destroy:function(){var a=this.series.chart,h=a.hoverPoints,g;a.pointCount--;h&&(this.setState(),p(h,this),h.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)v(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);for(g in this)this[g]=null},destroyElements:function(){for(var a=["graphic","dataLabel",
	"dataLabelUpper","connector","shadowGroup"],h,g=6;g--;)h=a[g],this[h]&&(this[h]=this[h].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var e=this.series,g=e.tooltipOptions,c=w(g.valueDecimals,""),f=g.valuePrefix||"",b=g.valueSuffix||"";B(e.pointArrayMap||["y"],function(d){d="{point."+
	d;if(f||b)a=a.replace(d+"}",f+d+"}"+b);a=a.replace(d+"}",d+":,."+c+"f}")});return l(a,{point:this,series:this.series})},firePointEvent:function(a,h,m){var c=this,f=this.series.options;(f.point.events[a]||c.options&&c.options.events&&c.options.events[a])&&this.importEvents();"click"===a&&f.allowPointSelect&&(m=function(a){c.select&&c.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});g(this,a,h,m)},visible:!0}})(N);(function(a){var D=a.addEvent,B=a.animObject,G=a.arrayMax,p=a.arrayMin,g=a.correctFloat,
	l=a.Date,r=a.defaultOptions,n=a.defaultPlotOptions,w=a.defined,v=a.each,e=a.erase,h=a.extend,m=a.fireEvent,c=a.grep,f=a.isArray,b=a.isNumber,d=a.isString,y=a.merge,H=a.objectEach,J=a.pick,t=a.removeEvent,K=a.splat,x=a.SVGElement,C=a.syncTimeout,L=a.win;a.Series=a.seriesType("line",null,{lineWidth:2,allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{lineWidth:0,lineColor:"#ffffff",radius:4,states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2,lineWidthPlus:1},select:{fillColor:"#cccccc",
	lineColor:"#000000",lineWidth:2}}},point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},style:{fontSize:"11px",fontWeight:"bold",color:"contrast",textOutline:"1px contrast"},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10,opacity:.25}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},
	{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x","y"],coll:"series",init:function(a,b){var c=this,d,k=a.series,f;c.chart=a;c.options=b=c.setOptions(b);c.linkedSeries=[];c.bindAxes();h(c,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});d=b.events;H(d,function(a,b){D(c,b,a)});if(d&&d.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;c.getColor();
	c.getSymbol();v(c.parallelArrays,function(a){c[a+"Data"]=[]});c.setData(b.data,!1);c.isCartesian&&(a.hasCartesianSeries=!0);k.length&&(f=k[k.length-1]);c._i=J(f&&f._i,-1)+1;a.orderSeries(this.insert(k))},insert:function(a){var c=this.options.index,d;if(b(c)){for(d=a.length;d--;)if(c>=J(a[d].options.index,a[d]._i)){a.splice(d+1,0,this);break}-1===d&&a.unshift(this);d+=1}else a.push(this);return J(d,a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,f;v(b.axisTypes||[],function(k){v(d[k],
	function(a){f=a.options;if(c[k]===f.index||void 0!==c[k]&&c[k]===f.id||void 0===c[k]&&0===f.index)b.insert(a.series),b[k]=a,a.isDirty=!0});b[k]||b.optionalAxis===k||a.error(18,!0)})},updateParallelArrays:function(a,c){var d=a.series,f=arguments,k=b(c)?function(b){var f="y"===b&&d.toYData?d.toYData(a):a[b];d[b+"Data"][c]=f}:function(a){Array.prototype[c].apply(d[a+"Data"],Array.prototype.slice.call(f,2))};v(d.parallelArrays,k)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,
	b=J(b,a.pointStart,0);this.pointInterval=c=J(this.pointInterval,a.pointInterval,1);d&&(a=new l(b),"day"===d?a=+a[l.hcSetDate](a[l.hcGetDate]()+c):"month"===d?a=+a[l.hcSetMonth](a[l.hcGetMonth]()+c):"year"===d&&(a=+a[l.hcSetFullYear](a[l.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,c=b.options,d=c.plotOptions,f=(b.userOptions||{}).plotOptions||{},e=d[this.type];this.userOptions=a;b=y(e,d.series,a);this.tooltipOptions=y(r.tooltip,r.plotOptions.series&&
	r.plotOptions.series.tooltip,r.plotOptions[this.type].tooltip,c.tooltip.userOptions,d.series&&d.series.tooltip,d[this.type].tooltip,a.tooltip);this.stickyTracking=J(a.stickyTracking,f[this.type]&&f[this.type].stickyTracking,f.series&&f.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:b.stickyTracking);null===e.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+
	"Threshold"]||b.threshold||0,className:"highcharts-negative",color:b.negativeColor,fillColor:b.negativeFillColor});a.length&&w(a[a.length-1].value)&&a.push({color:this.color,fillColor:this.fillColor});return b},getCyclic:function(a,b,c){var d,f=this.chart,e=this.userOptions,h=a+"Index",q=a+"Counter",g=c?c.length:J(f.options.chart[a+"Count"],f[a+"Count"]);b||(d=J(e[h],e["_"+h]),w(d)||(f.series.length||(f[q]=0),e["_"+h]=d=f[q]%g,f[q]+=1),c&&(b=c[d]));void 0!==d&&(this[h]=d);this[a]=b},getColor:function(){this.options.colorByPoint?
	this.options.color=null:this.getCyclic("color",this.options.color||n[this.type].color,this.chart.options.colors)},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(c,e,h,g){var k=this,q=k.points,m=q&&q.length||0,l,t=k.options,A=k.chart,n=null,x=k.xAxis,E=t.turboThreshold,y=this.xData,p=this.yData,r=(l=k.pointArrayMap)&&l.length;c=c||[];l=c.length;e=J(e,!0);if(!1!==g&&l&&m===l&&!k.cropped&&
	!k.hasGroupedData&&k.visible)v(c,function(a,b){q[b].update&&a!==t.data[b]&&q[b].update(a,!1,null,!1)});else{k.xIncrement=null;k.colorCounter=0;v(this.parallelArrays,function(a){k[a+"Data"].length=0});if(E&&l>E){for(h=0;null===n&&h<l;)n=c[h],h++;if(b(n))for(h=0;h<l;h++)y[h]=this.autoIncrement(),p[h]=c[h];else if(f(n))if(r)for(h=0;h<l;h++)n=c[h],y[h]=n[0],p[h]=n.slice(1,r+1);else for(h=0;h<l;h++)n=c[h],y[h]=n[0],p[h]=n[1];else a.error(12)}else for(h=0;h<l;h++)void 0!==c[h]&&(n={series:k},k.pointClass.prototype.applyOptions.apply(n,
	[c[h]]),k.updateParallelArrays(n,h));p&&d(p[0])&&a.error(14,!0);k.data=[];k.options.data=k.userOptions.data=c;for(h=m;h--;)q[h]&&q[h].destroy&&q[h].destroy();x&&(x.minRange=x.userMinRange);k.isDirty=A.isDirtyBox=!0;k.isDirtyData=!!q;h=!1}"point"===t.legendType&&(this.processData(),this.generatePoints());e&&A.redraw(h)},processData:function(b){var c=this.xData,d=this.yData,f=c.length,k;k=0;var e,h,q=this.xAxis,g,l=this.options;g=l.cropThreshold;var m=this.getExtremesFromAll||l.getExtremesFromAll,n=
	this.isCartesian,l=q&&q.val2lin,t=q&&q.isLog,x=this.requireSorting,y,p;if(n&&!this.isDirty&&!q.isDirty&&!this.yAxis.isDirty&&!b)return!1;q&&(b=q.getExtremes(),y=b.min,p=b.max);if(n&&this.sorted&&!m&&(!g||f>g||this.forceCrop))if(c[f-1]<y||c[0]>p)c=[],d=[];else if(c[0]<y||c[f-1]>p)k=this.cropData(this.xData,this.yData,y,p),c=k.xData,d=k.yData,k=k.start,e=!0;for(g=c.length||1;--g;)f=t?l(c[g])-l(c[g-1]):c[g]-c[g-1],0<f&&(void 0===h||f<h)?h=f:0>f&&x&&(a.error(15),x=!1);this.cropped=e;this.cropStart=k;
	this.processedXData=c;this.processedYData=d;this.closestPointRange=h},cropData:function(a,b,c,d){var f=a.length,e=0,h=f,g=J(this.cropShoulder,1),q;for(q=0;q<f;q++)if(a[q]>=c){e=Math.max(0,q-g);break}for(c=q;c<f;c++)if(a[c]>d){h=c+g;break}return{xData:a.slice(e,h),yData:b.slice(e,h),start:e,end:h}},generatePoints:function(){var a=this.options,b=a.data,c=this.data,d,f=this.processedXData,e=this.processedYData,h=this.pointClass,g=f.length,l=this.cropStart||0,m,n=this.hasGroupedData,a=a.keys,t,x=[],y;
	c||n||(c=[],c.length=b.length,c=this.data=c);a&&n&&(this.options.keys=!1);for(y=0;y<g;y++)m=l+y,n?(t=(new h).init(this,[f[y]].concat(K(e[y]))),t.dataGroup=this.groupMap[y]):(t=c[m])||void 0===b[m]||(c[m]=t=(new h).init(this,b[m],f[y])),t&&(t.index=m,x[y]=t);this.options.keys=a;if(c&&(g!==(d=c.length)||n))for(y=0;y<d;y++)y!==l||n||(y+=g),c[y]&&(c[y].destroyElements(),c[y].plotX=void 0);this.data=c;this.points=x},getExtremes:function(a){var c=this.yAxis,d=this.processedXData,e,k=[],h=0;e=this.xAxis.getExtremes();
	var g=e.min,q=e.max,l,m,n,t;a=a||this.stackedYData||this.processedYData||[];e=a.length;for(t=0;t<e;t++)if(m=d[t],n=a[t],l=(b(n,!0)||f(n))&&(!c.positiveValuesOnly||n.length||0<n),m=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(d[t+1]||m)>=g&&(d[t-1]||m)<=q,l&&m)if(l=n.length)for(;l--;)null!==n[l]&&(k[h++]=n[l]);else k[h++]=n;this.dataMin=p(k);this.dataMax=G(k)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,c=a.stacking,
	d=this.xAxis,f=d.categories,k=this.yAxis,e=this.points,h=e.length,l=!!this.modifyValue,m=a.pointPlacement,n="between"===m||b(m),t=a.threshold,x=a.startFromThreshold?t:0,y,p,r,C,v=Number.MAX_VALUE;"between"===m&&(m=.5);b(m)&&(m*=J(a.pointRange||d.pointRange));for(a=0;a<h;a++){var K=e[a],H=K.x,L=K.y;p=K.low;var B=c&&k.stacks[(this.negStacks&&L<(x?0:t)?"-":"")+this.stackKey],D;k.positiveValuesOnly&&null!==L&&0>=L&&(K.isNull=!0);K.plotX=y=g(Math.min(Math.max(-1E5,d.translate(H,0,0,0,1,m,"flags"===this.type)),
	1E5));c&&this.visible&&!K.isNull&&B&&B[H]&&(C=this.getStackIndicator(C,H,this.index),D=B[H],L=D.points[C.key],p=L[0],L=L[1],p===x&&C.key===B[H].base&&(p=J(t,k.min)),k.positiveValuesOnly&&0>=p&&(p=null),K.total=K.stackTotal=D.total,K.percentage=D.total&&K.y/D.total*100,K.stackY=L,D.setOffset(this.pointXOffset||0,this.barW||0));K.yBottom=w(p)?k.translate(p,0,1,0,1):null;l&&(L=this.modifyValue(L,K));K.plotY=p="number"===typeof L&&Infinity!==L?Math.min(Math.max(-1E5,k.translate(L,0,1,0,1)),1E5):void 0;
	K.isInside=void 0!==p&&0<=p&&p<=k.len&&0<=y&&y<=d.len;K.clientX=n?g(d.translate(H,0,0,0,1,m)):y;K.negative=K.y<(t||0);K.category=f&&void 0!==f[K.x]?f[K.x]:K.x;K.isNull||(void 0!==r&&(v=Math.min(v,Math.abs(y-r))),r=y);K.zone=this.zones.length&&K.getZone()}this.closestPointRangePx=v},getValidPoints:function(a,b){var d=this.chart;return c(a||this.points||[],function(a){return b&&!d.isInsidePlot(a.plotX,a.plotY,d.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,
	f=b.inverted,e=this.clipBox,h=e||b.clipBox,g=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,h.height,c.xAxis,c.yAxis].join(),q=b[g],m=b[g+"m"];q||(a&&(h.width=0,f&&(h.x=b.plotSizeX),b[g+"m"]=m=d.clipRect(f?b.plotSizeX+99:-99,f?-b.plotLeft:-b.plotTop,99,f?b.chartWidth:b.chartHeight)),b[g]=q=d.clipRect(h),q.count={length:0});a&&!q.count[this.index]&&(q.count[this.index]=!0,q.count.length+=1);!1!==c.clip&&(this.group.clip(a||e?q:b.clipRect),this.markerGroup.clip(m),this.sharedClipKey=g);
	a||(q.count[this.index]&&(delete q.count[this.index],--q.count.length),0===q.count.length&&g&&b[g]&&(e||(b[g]=b[g].destroy()),b[g+"m"]&&(b[g+"m"]=b[g+"m"].destroy())))},animate:function(a){var b=this.chart,c=B(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX,x:0},c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99,x:0},c),this.animate=null)},afterAnimate:function(){this.setClip();m(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=
	this.points,b=this.chart,c,d,f,e,h=this.options.marker,g,m,l,n=this[this.specialGroup]||this.markerGroup,t,x=J(h.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=2*h.radius);if(!1!==h.enabled||this._hasPointMarkers)for(c=0;c<a.length;c++)d=a[c],e=d.graphic,g=d.marker||{},m=!!d.marker,f=x&&void 0===g.enabled||g.enabled,l=d.isInside,f&&!d.isNull?(f=J(g.symbol,this.symbol),d.hasImage=0===f.indexOf("url"),t=this.markerAttribs(d,d.selected&&"select"),e?e[l?"show":"hide"](!0).animate(t):l&&
	(0<t.width||d.hasImage)&&(d.graphic=e=b.renderer.symbol(f,t.x,t.y,t.width,t.height,m?g:h).add(n)),e&&e.attr(this.pointAttribs(d,d.selected&&"select")),e&&e.addClass(d.getClassName(),!0)):e&&(d.graphic=e.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},f=J(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],f=J(b&&b.radius,c&&c.radius,f+(c&&c.radiusPlus||0)));a.hasImage&&(f=0);a={x:Math.floor(a.plotX)-f,y:a.plotY-f};f&&(a.width=a.height=2*f);return a},pointAttribs:function(a,
	b){var c=this.options.marker,d=a&&a.options,f=d&&d.marker||{},e=this.color,h=d&&d.color,g=a&&a.color,d=J(f.lineWidth,c.lineWidth);a=a&&a.zone&&a.zone.color;e=h||a||g||e;a=f.fillColor||c.fillColor||e;e=f.lineColor||c.lineColor||e;b&&(c=c.states[b],b=f.states&&f.states[b]||{},d=J(b.lineWidth,c.lineWidth,d+J(b.lineWidthPlus,c.lineWidthPlus,0)),a=b.fillColor||c.fillColor||a,e=b.lineColor||c.lineColor||e);return{stroke:e,"stroke-width":d,fill:a}},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\/533/.test(L.navigator.userAgent),
	d,f,h=a.data||[],g,l;m(a,"destroy");t(a);v(a.axisTypes||[],function(b){(l=a[b])&&l.series&&(e(l.series,a),l.isDirty=l.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(f=h.length;f--;)(g=h[f])&&g.destroy&&g.destroy();a.points=null;clearTimeout(a.animationTimeout);H(a,function(a,b){a instanceof x&&!a.survive&&(d=c&&"group"===b?"hide":"destroy",a[d]())});b.hoverSeries===a&&(b.hoverSeries=null);e(b.series,a);b.orderSeries();H(a,function(b,c){delete a[c]})},getGraphPath:function(a,b,c){var d=
	this,f=d.options,e=f.step,h,g=[],m=[],l;a=a||d.points;(h=a.reversed)&&a.reverse();(e={right:1,center:2}[e]||e&&3)&&h&&(e=4-e);!f.connectNulls||b||c||(a=this.getValidPoints(a));v(a,function(k,h){var q=k.plotX,t=k.plotY,n=a[h-1];(k.leftCliff||n&&n.rightCliff)&&!c&&(l=!0);k.isNull&&!w(b)&&0<h?l=!f.connectNulls:k.isNull&&!b?l=!0:(0===h||l?h=["M",k.plotX,k.plotY]:d.getPointSpline?h=d.getPointSpline(a,k,h):e?(h=1===e?["L",n.plotX,t]:2===e?["L",(n.plotX+q)/2,n.plotY,"L",(n.plotX+q)/2,t]:["L",q,n.plotY],
	h.push("L",q,t)):h=["L",q,t],m.push(k.x),e&&m.push(k.x),g.push.apply(g,h),l=!1)});g.xMap=m;return d.graphPath=g},drawGraph:function(){var a=this,b=this.options,c=(this.gappedPath||this.getGraphPath).call(this),d=[["graph","highcharts-graph",b.lineColor||this.color,b.dashStyle]];v(this.zones,function(c,f){d.push(["zone-graph-"+f,"highcharts-graph highcharts-zone-graph-"+f+" "+(c.className||""),c.color||a.color,c.dashStyle||b.dashStyle])});v(d,function(d,f){var e=d[0],k=a[e];k?(k.endX=a.preventGraphAnimation?
	null:c.xMap,k.animate({d:c})):c.length&&(a[e]=a.chart.renderer.path(c).addClass(d[1]).attr({zIndex:1}).add(a.group),k={stroke:d[2],"stroke-width":b.lineWidth,fill:a.fillGraph&&a.color||"none"},d[3]?k.dashstyle=d[3]:"square"!==b.linecap&&(k["stroke-linecap"]=k["stroke-linejoin"]="round"),k=a[e].attr(k).shadow(2>f&&b.shadow));k&&(k.startX=c.xMap,k.isArea=c.isArea)})},applyZones:function(){var a=this,b=this.chart,c=b.renderer,d=this.zones,f,e,h=this.clips||[],g,l=this.graph,m=this.area,t=Math.max(b.chartWidth,
	b.chartHeight),n=this[(this.zoneAxis||"y")+"Axis"],x,y,p=b.inverted,r,C,w,K,L=!1;d.length&&(l||m)&&n&&void 0!==n.min&&(y=n.reversed,r=n.horiz,l&&l.hide(),m&&m.hide(),x=n.getExtremes(),v(d,function(d,k){f=y?r?b.plotWidth:0:r?0:n.toPixels(x.min);f=Math.min(Math.max(J(e,f),0),t);e=Math.min(Math.max(Math.round(n.toPixels(J(d.value,x.max),!0)),0),t);L&&(f=e=n.toPixels(x.max));C=Math.abs(f-e);w=Math.min(f,e);K=Math.max(f,e);n.isXAxis?(g={x:p?K:w,y:0,width:C,height:t},r||(g.x=b.plotHeight-g.x)):(g={x:0,
	y:p?K:w,width:t,height:C},r&&(g.y=b.plotWidth-g.y));p&&c.isVML&&(g=n.isXAxis?{x:0,y:y?w:K,height:g.width,width:b.chartWidth}:{x:g.y-b.plotLeft-b.spacingBox.x,y:0,width:g.height,height:b.chartHeight});h[k]?h[k].animate(g):(h[k]=c.clipRect(g),l&&a["zone-graph-"+k].clip(h[k]),m&&a["zone-area-"+k].clip(h[k]));L=d.value>x.max}),this.clips=h)},invertGroups:function(a){function b(){v(["group","markerGroup"],function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=
	c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,f;c.xAxis&&(f=D(d,"resize",b),D(c,"destroy",f),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,d,f){var e=this[a],k=!e;k&&(this[a]=e=this.chart.renderer.g().attr({zIndex:d||.1}).add(f));e.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(w(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(e.hasClass("highcharts-tracker")?" highcharts-tracker":
	""),!0);e.attr({visibility:c})[k?"attr":"animate"](this.getPlotBox());return e},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},render:function(){var a=this,b=a.chart,c,d=a.options,f=!!a.animate&&b.renderer.isSVG&&B(d.animation).duration,e=a.visible?"inherit":"hidden",h=d.zIndex,g=a.hasRendered,l=b.seriesGroup,m=b.inverted;c=a.plotGroup("group","series",e,h,l);a.markerGroup=
	a.plotGroup("markerGroup","markers",e,h,l);f&&a.animate(!0);c.inverted=a.isCartesian?m:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();a.invertGroups(m);!1===d.clip||a.sharedClipKey||g||c.clip(b.clipRect);f&&a.animate();g||(a.animationTimeout=C(function(){a.afterAnimate()},f));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,
	c=this.group,d=this.xAxis,f=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:J(d&&d.left,a.plotLeft),translateY:J(f&&f.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX","plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,f=this.chart.inverted;return this.searchKDTree({clientX:f?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:f?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,
	d,f){var e,k;if(k=c&&c.length)return e=b.kdAxisArray[d%f],c.sort(function(a,b){return a[e]-b[e]}),k=Math.floor(k/2),{point:c[k],left:a(c.slice(0,k),d+1,f),right:a(c.slice(k+1),d+1,f)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?2:1;delete b.kdTree;C(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,k,g){var l=b.point,m=d.kdAxisArray[k%g],q,n,t=l;n=w(a[f])&&w(l[f])?
	Math.pow(a[f]-l[f],2):null;q=w(a[e])&&w(l[e])?Math.pow(a[e]-l[e],2):null;q=(n||0)+(q||0);l.dist=w(q)?Math.sqrt(q):Number.MAX_VALUE;l.distX=w(n)?Math.sqrt(n):Number.MAX_VALUE;m=a[m]-l[m];q=0>m?"left":"right";n=0>m?"right":"left";b[q]&&(q=c(a,b[q],k+1,g),t=q[h]<t[h]?q:l);b[n]&&Math.sqrt(m*m)<t[h]&&(a=c(a,b[n],k+1,g),t=a[h]<t[h]?a:t);return t}var d=this,f=this.kdAxisArray[0],e=this.kdAxisArray[1],h=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||
	this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(N);(function(a){var D=a.Axis,B=a.Chart,G=a.correctFloat,p=a.defined,g=a.destroyObjectProperties,l=a.each,r=a.format,n=a.objectEach,w=a.pick,v=a.Series;a.StackItem=function(a,h,g,c,f){var b=a.chart.inverted;this.axis=a;this.isNegative=g;this.options=h;this.x=c;this.total=null;this.points={};this.stack=f;this.rightCliff=this.leftCliff=0;this.alignOptions={align:h.align||(b?g?"left":"right":"center"),verticalAlign:h.verticalAlign||(b?
	"middle":g?"bottom":"top"),y:w(h.y,b?4:g?14:-6),x:w(h.x,b?g?-6:6:0)};this.textAlign=h.textAlign||(b?g?"right":"left":"center")};a.StackItem.prototype={destroy:function(){g(this,this.axis)},render:function(a){var e=this.options,g=e.format,g=g?r(g,this):e.formatter.call(this);this.label?this.label.attr({text:g,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(g,null,null,e.useHTML).css(e.style).attr({align:this.textAlign,rotation:e.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,
	h){var e=this.axis,c=e.chart,f=e.translate(e.usePercentage?100:this.total,0,0,0,1),e=e.translate(0),e=Math.abs(f-e);a=c.xAxis[0].translate(this.x)+a;f=this.getStackBox(c,this,a,f,h,e);if(h=this.label)h.align(this.alignOptions,null,f),f=h.alignAttr,h[!1===this.options.crop||c.isInsidePlot(f.x,f.y)?"show":"hide"](!0)},getStackBox:function(a,h,g,c,f,b){var d=h.axis.reversed,e=a.inverted;a=a.plotHeight;h=h.isNegative&&!d||!h.isNegative&&d;return{x:e?h?c:c-b:g,y:e?a-g-f:h?a-c-b:a-c,width:e?b:f,height:e?
	f:b}}};B.prototype.getStacks=function(){var a=this;l(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});l(a.series,function(e){!e.options.stacking||!0!==e.visible&&!1!==a.options.chart.ignoreHiddenSeries||(e.stackKey=e.type+w(e.options.stack,""))})};D.prototype.buildStacks=function(){var a=this.series,h=w(this.options.reversedStacks,!0),g=a.length,c;if(!this.isXAxis){this.usePercentage=!1;for(c=g;c--;)a[h?c:g-c-1].setStackedPoints();for(c=0;c<g;c++)a[c].modifyStacks()}};D.prototype.renderStackTotals=
	function(){var a=this.chart,h=a.renderer,g=this.stacks,c=this.stackTotalGroup;c||(this.stackTotalGroup=c=h.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());c.translate(a.plotLeft,a.plotTop);n(g,function(a){n(a,function(a){a.render(c)})})};D.prototype.resetStacks=function(){var a=this,h=a.stacks;a.isXAxis||n(h,function(e){n(e,function(c,f){c.touched<a.stacksTouched?(c.destroy(),delete e[f]):(c.total=null,c.cum=null)})})};D.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&
	(a=this.stacks=this.oldStacks),n(a,function(a){n(a,function(a){a.cum=a.total})}))};v.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var e=this.processedXData,h=this.processedYData,g=[],c=h.length,f=this.options,b=f.threshold,d=f.startFromThreshold?b:0,l=f.stack,f=f.stacking,n=this.stackKey,r="-"+n,t=this.negStacks,v=this.yAxis,x=v.stacks,C=v.oldStacks,L,q,A,E,F,k,u;v.stacksTouched+=1;for(F=0;F<c;F++)k=e[F],u=h[F],
	L=this.getStackIndicator(L,k,this.index),E=L.key,A=(q=t&&u<(d?0:b))?r:n,x[A]||(x[A]={}),x[A][k]||(C[A]&&C[A][k]?(x[A][k]=C[A][k],x[A][k].total=null):x[A][k]=new a.StackItem(v,v.options.stackLabels,q,k,l)),A=x[A][k],null!==u&&(A.points[E]=A.points[this.index]=[w(A.cum,d)],p(A.cum)||(A.base=E),A.touched=v.stacksTouched,0<L.index&&!1===this.singleStacks&&(A.points[E][0]=A.points[this.index+","+k+",0"][0])),"percent"===f?(q=q?n:r,t&&x[q]&&x[q][k]?(q=x[q][k],A.total=q.total=Math.max(q.total,A.total)+Math.abs(u)||
	0):A.total=G(A.total+(Math.abs(u)||0))):A.total=G(A.total+(u||0)),A.cum=w(A.cum,d)+(u||0),null!==u&&(A.points[E].push(A.cum),g[F]=A.cum);"percent"===f&&(v.usePercentage=!0);this.stackedYData=g;v.oldStacks={}}};v.prototype.modifyStacks=function(){var a=this,h=a.stackKey,g=a.yAxis.stacks,c=a.processedXData,f,b=a.options.stacking;a[b+"Stacker"]&&l([h,"-"+h],function(d){for(var e=c.length,h,l;e--;)if(h=c[e],f=a.getStackIndicator(f,h,a.index,d),l=(h=g[d]&&g[d][h])&&h.points[f.key])a[b+"Stacker"](l,h,e)})};
	v.prototype.percentStacker=function(a,h,g){h=h.total?100/h.total:0;a[0]=G(a[0]*h);a[1]=G(a[1]*h);this.stackedYData[g]=a[1]};v.prototype.getStackIndicator=function(a,h,g,c){!p(a)||a.x!==h||c&&a.key!==c?a={x:h,index:0,key:c}:a.index++;a.key=[g,h,a.index].join();return a}})(N);(function(a){var D=a.addEvent,B=a.animate,G=a.Axis,p=a.createElement,g=a.css,l=a.defined,r=a.each,n=a.erase,w=a.extend,v=a.fireEvent,e=a.inArray,h=a.isNumber,m=a.isObject,c=a.isArray,f=a.merge,b=a.objectEach,d=a.pick,y=a.Point,
	H=a.Series,J=a.seriesTypes,t=a.setAnimation,K=a.splat;w(a.Chart.prototype,{addSeries:function(a,b,c){var f,e=this;a&&(b=d(b,!0),v(e,"addSeries",{options:a},function(){f=e.initSeries(a);e.isDirtyLegend=!0;e.linkSeries();b&&e.redraw(c)}));return f},addAxis:function(a,b,c,e){var h=b?"xAxis":"yAxis",g=this.options;a=f(a,{index:this[h].length,isX:b});b=new G(this,a);g[h]=K(g[h]||{});g[h].push(a);d(c,!0)&&this.redraw(e);return b},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,f=c.loading,
	e=function(){d&&g(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=p("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=p("span",{className:"highcharts-loading-inner"},null,d),D(b,"redraw",e));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;g(d,w(f.style,{zIndex:10}));g(b.loadingSpan,f.labelStyle);b.loadingShown||(g(d,{opacity:0,display:""}),B(d,{opacity:f.style.opacity||
	.5},{duration:f.showDuration||0}));b.loadingShown=!0;e()},hideLoading:function(){var a=this.options,b=this.loadingDiv;b&&(b.className="highcharts-loading highcharts-loading-hidden",B(b,{opacity:0},{duration:a.loading.hideDuration||100,complete:function(){g(b,{display:"none"})}}));this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
	propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions tooltip".split(" "),update:function(a,c,g){var m=this,n={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},t=a.chart,x,k,y=[];if(t){f(!0,m.options.chart,t);"className"in t&&m.setClassName(t.className);if("inverted"in t||"polar"in t)m.propFromSeries(),x=!0;"alignTicks"in t&&(x=!0);b(t,function(a,b){-1!==e("chart."+b,m.propsRequireUpdateSeries)&&(k=!0);-1!==e(b,m.propsRequireDirtyBox)&&
	(m.isDirtyBox=!0)});"style"in t&&m.renderer.setStyle(t.style)}a.colors&&(this.options.colors=a.colors);a.plotOptions&&f(!0,this.options.plotOptions,a.plotOptions);b(a,function(a,b){if(m[b]&&"function"===typeof m[b].update)m[b].update(a,!1);else if("function"===typeof m[n[b]])m[n[b]](a);"chart"!==b&&-1!==e(b,m.propsRequireUpdateSeries)&&(k=!0)});r("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){a[b]&&(r(K(a[b]),function(a,c){(c=l(a.id)&&m.get(a.id)||m[b][c])&&c.coll===b&&(c.update(a,
	!1),g&&(c.touched=!0));if(!c&&g)if("series"===b)m.addSeries(a,!1).touched=!0;else if("xAxis"===b||"yAxis"===b)m.addAxis(a,"xAxis"===b,!1).touched=!0}),g&&r(m[b],function(a){a.touched?delete a.touched:y.push(a)}))});r(y,function(a){a.remove(!1)});x&&r(m.axes,function(a){a.update({},!1)});k&&r(m.series,function(a){a.update({},!1)});a.loading&&f(!0,m.options.loading,a.loading);x=t&&t.width;t=t&&t.height;h(x)&&x!==m.chartWidth||h(t)&&t!==m.chartHeight?m.setSize(x,t):d(c,!0)&&m.redraw()},setSubtitle:function(a){this.setTitle(void 0,
	a)}});w(y.prototype,{update:function(a,b,c,f){function e(){h.applyOptions(a);null===h.y&&k&&(h.graphic=k.destroy());m(a,!0)&&(k&&k.element&&a&&a.marker&&void 0!==a.marker.symbol&&(h.graphic=k.destroy()),a&&a.dataLabels&&h.dataLabel&&(h.dataLabel=h.dataLabel.destroy()),h.connector&&(h.connector=h.connector.destroy()));l=h.index;g.updateParallelArrays(h,l);n.data[l]=m(n.data[l],!0)||m(a,!0)?h.options:a;g.isDirty=g.isDirtyData=!0;!g.fixedBox&&g.hasCartesianSeries&&(t.isDirtyBox=!0);"point"===n.legendType&&
	(t.isDirtyLegend=!0);b&&t.redraw(c)}var h=this,g=h.series,k=h.graphic,l,t=g.chart,n=g.options;b=d(b,!0);!1===f?e():h.firePointEvent("update",{options:a},e)},remove:function(a,b){this.series.removePoint(e(this,this.series.data),a,b)}});w(H.prototype,{addPoint:function(a,b,c,f){var e=this.options,h=this.data,g=this.chart,k=this.xAxis,k=k&&k.hasNames&&k.names,l=e.data,m,t,n=this.xData,q,x;b=d(b,!0);m={series:this};this.pointClass.prototype.applyOptions.apply(m,[a]);x=m.x;q=n.length;if(this.requireSorting&&
	x<n[q-1])for(t=!0;q&&n[q-1]>x;)q--;this.updateParallelArrays(m,"splice",q,0,0);this.updateParallelArrays(m,q);k&&m.name&&(k[x]=m.name);l.splice(q,0,a);t&&(this.data.splice(q,0,null),this.processData());"point"===e.legendType&&this.generatePoints();c&&(h[0]&&h[0].remove?h[0].remove(!1):(h.shift(),this.updateParallelArrays(m,"shift"),l.shift()));this.isDirtyData=this.isDirty=!0;b&&g.redraw(f)},removePoint:function(a,b,c){var f=this,e=f.data,h=e[a],g=f.points,k=f.chart,l=function(){g&&g.length===e.length&&
	g.splice(a,1);e.splice(a,1);f.options.data.splice(a,1);f.updateParallelArrays(h||{series:f},"splice",a,1);h&&h.destroy();f.isDirty=!0;f.isDirtyData=!0;b&&k.redraw()};t(c,k);b=d(b,!0);h?h.firePointEvent("remove",null,l):l()},remove:function(a,b,c){function f(){e.destroy();h.isDirtyLegend=h.isDirtyBox=!0;h.linkSeries();d(a,!0)&&h.redraw(b)}var e=this,h=e.chart;!1!==c?v(e,"remove",null,f):f()},update:function(a,b){var c=this,e=c.chart,h=c.userOptions,g=c.oldType||c.type,l=a.type||h.type||e.options.chart.type,
	k=J[g].prototype,m,t=["group","markerGroup","dataLabelsGroup"],n=["navigatorSeries","baseSeries"],y=c.finishedAnimating&&{animation:!1};if(Object.keys&&"data"===Object.keys(a).toString())return this.setData(a.data,b);if(l&&l!==g||void 0!==a.zIndex)t.length=0;n=t.concat(n);r(n,function(a){n[a]=c[a];delete c[a]});a=f(h,y,{index:c.index,pointStart:c.xData[0]},{data:c.options.data},a);c.remove(!1,null,!1);for(m in k)c[m]=void 0;w(c,J[l||g].prototype);r(n,function(a){c[a]=n[a]});c.init(e,a);c.oldType=
	g;e.linkSeries();d(b,!0)&&e.redraw(!1)}});w(G.prototype,{update:function(a,b){var c=this.chart;a=c.options[this.coll][this.options.index]=f(this.userOptions,a);this.destroy(!0);this.init(c,w(a,{events:void 0}));c.isDirtyBox=!0;d(b,!0)&&c.redraw()},remove:function(a){for(var b=this.chart,f=this.coll,e=this.series,h=e.length;h--;)e[h]&&e[h].remove(!1);n(b.axes,this);n(b[f],this);c(b.options[f])?b.options[f].splice(this.options.index,1):delete b.options[f];r(b[f],function(a,b){a.options.index=b});this.destroy();
	b.isDirtyBox=!0;d(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},b)},setCategories:function(a,b){this.update({categories:a},b)}})})(N);(function(a){var D=a.color,B=a.each,G=a.map,p=a.pick,g=a.Series,l=a.seriesType;l("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(g){var l=[],r=[],v=this.xAxis,e=this.yAxis,h=e.stacks[this.stackKey],m={},c=this.index,f=e.series,b=f.length,d,y=p(e.options.reversedStacks,!0)?1:-1,H;g=g||this.points;if(this.options.stacking){for(H=
	0;H<g.length;H++)g[H].leftNull=g[H].rightNull=null,m[g[H].x]=g[H];a.objectEach(h,function(a,b){null!==a.total&&r.push(b)});r.sort(function(a,b){return a-b});d=G(f,function(){return this.visible});B(r,function(a,f){var g=0,n,t;if(m[a]&&!m[a].isNull)l.push(m[a]),B([-1,1],function(e){var g=1===e?"rightNull":"leftNull",l=0,p=h[r[f+e]];if(p)for(H=c;0<=H&&H<b;)n=p.points[H],n||(H===c?m[a][g]=!0:d[H]&&(t=h[a].points[H])&&(l-=t[1]-t[0])),H+=y;m[a][1===e?"rightCliff":"leftCliff"]=l});else{for(H=c;0<=H&&H<
	b;){if(n=h[a].points[H]){g=n[1];break}H+=y}g=e.translate(g,0,1,0,1);l.push({isNull:!0,plotX:v.translate(a,0,0,0,1),x:a,plotY:g,yBottom:g})}})}return l},getGraphPath:function(a){var l=g.prototype.getGraphPath,r=this.options,v=r.stacking,e=this.yAxis,h,m,c=[],f=[],b=this.index,d,y=e.stacks[this.stackKey],H=r.threshold,J=e.getThreshold(r.threshold),t,r=r.connectNulls||"percent"===v,K=function(h,g,l){var m=a[h];h=v&&y[m.x].points[b];var t=m[l+"Null"]||0;l=m[l+"Cliff"]||0;var n,p,m=!0;l||t?(n=(t?h[0]:
	h[1])+l,p=h[0]+l,m=!!t):!v&&a[g]&&a[g].isNull&&(n=p=H);void 0!==n&&(f.push({plotX:d,plotY:null===n?J:e.getThreshold(n),isNull:m,isCliff:!0}),c.push({plotX:d,plotY:null===p?J:e.getThreshold(p),doCurve:!1}))};a=a||this.points;v&&(a=this.getStackPoints(a));for(h=0;h<a.length;h++)if(m=a[h].isNull,d=p(a[h].rectPlotX,a[h].plotX),t=p(a[h].yBottom,J),!m||r)r||K(h,h-1,"left"),m&&!v&&r||(f.push(a[h]),c.push({x:h,plotX:d,plotY:t})),r||K(h,h+1,"right");h=l.call(this,f,!0,!0);c.reversed=!0;m=l.call(this,c,!0,
	!0);m.length&&(m[0]="L");m=h.concat(m);l=l.call(this,f,!1,r);m.xMap=h.xMap;this.areaPath=m;return l},drawGraph:function(){this.areaPath=[];g.prototype.drawGraph.apply(this);var a=this,l=this.areaPath,w=this.options,v=[["area","highcharts-area",this.color,w.fillColor]];B(this.zones,function(e,h){v.push(["zone-area-"+h,"highcharts-area highcharts-zone-area-"+h+" "+e.className,e.color||a.color,e.fillColor||w.fillColor])});B(v,function(e){var h=e[0],g=a[h];g?(g.endX=a.preventGraphAnimation?null:l.xMap,
	g.animate({d:l})):(g=a[h]=a.chart.renderer.path(l).addClass(e[1]).attr({fill:p(e[3],D(e[2]).setOpacity(p(w.fillOpacity,.75)).get()),zIndex:0}).add(a.group),g.isArea=!0);g.startX=l.xMap;g.shiftUnit=w.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(N);(function(a){var D=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,G,p){var g=G.plotX,l=G.plotY,r=a[p-1];p=a[p+1];var n,w,v,e;if(r&&!r.isNull&&!1!==r.doCurve&&!G.isCliff&&p&&!p.isNull&&!1!==p.doCurve&&!G.isCliff){a=
	r.plotY;v=p.plotX;p=p.plotY;var h=0;n=(1.5*g+r.plotX)/2.5;w=(1.5*l+a)/2.5;v=(1.5*g+v)/2.5;e=(1.5*l+p)/2.5;v!==n&&(h=(e-w)*(v-g)/(v-n)+l-e);w+=h;e+=h;w>a&&w>l?(w=Math.max(a,l),e=2*l-w):w<a&&w<l&&(w=Math.min(a,l),e=2*l-w);e>p&&e>l?(e=Math.max(p,l),w=2*l-e):e<p&&e<l&&(e=Math.min(p,l),w=2*l-e);G.rightContX=v;G.rightContY=e}G=["C",D(r.rightContX,r.plotX),D(r.rightContY,r.plotY),D(n,g),D(w,l),g,l];r.rightContX=r.rightContY=null;return G}})})(N);(function(a){var D=a.seriesTypes.area.prototype,B=a.seriesType;
	B("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:D.getStackPoints,getGraphPath:D.getGraphPath,drawGraph:D.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(N);(function(a){var D=a.animObject,B=a.color,G=a.each,p=a.extend,g=a.isNumber,l=a.merge,r=a.pick,n=a.Series,w=a.seriesType,v=a.svg;w("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1,brightness:.1},select:{color:"#cccccc",
	borderColor:"#000000"}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0,borderColor:"#ffffff"},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){n.prototype.init.apply(this,arguments);var a=this,h=a.chart;h.hasRendered&&G(h.series,function(e){e.type===a.type&&(e.isDirty=!0)})},getColumnMetrics:function(){var a=this,h=a.options,g=a.xAxis,c=a.yAxis,f=g.reversed,
	b,d={},l=0;!1===h.grouping?l=1:G(a.chart.series,function(f){var e=f.options,g=f.yAxis,h;f.type!==a.type||!f.visible&&a.chart.options.chart.ignoreHiddenSeries||c.len!==g.len||c.pos!==g.pos||(e.stacking?(b=f.stackKey,void 0===d[b]&&(d[b]=l++),h=d[b]):!1!==e.grouping&&(h=l++),f.columnIndex=h)});var n=Math.min(Math.abs(g.transA)*(g.ordinalSlope||h.pointRange||g.closestPointRange||g.tickInterval||1),g.len),p=n*h.groupPadding,t=(n-2*p)/(l||1),h=Math.min(h.maxPointWidth||g.len,r(h.pointWidth,t*(1-2*h.pointPadding)));
	a.columnMetrics={width:h,offset:(t-h)/2+(p+((a.columnIndex||0)+(f?1:0))*t-n/2)*(f?-1:1)};return a.columnMetrics},crispCol:function(a,g,l,c){var f=this.chart,b=this.borderWidth,d=-(b%2?.5:0),b=b%2?.5:1;f.inverted&&f.renderer.isVML&&(b+=1);this.options.crisp&&(l=Math.round(a+l)+d,a=Math.round(a)+d,l-=a);c=Math.round(g+c)+b;d=.5>=Math.abs(g)&&.5<c;g=Math.round(g)+b;c-=g;d&&c&&(--g,c+=1);return{x:a,y:g,width:l,height:c}},translate:function(){var a=this,g=a.chart,l=a.options,c=a.dense=2>a.closestPointRange*
	a.xAxis.transA,c=a.borderWidth=r(l.borderWidth,c?0:1),f=a.yAxis,b=l.threshold,d=a.translatedThreshold=f.getThreshold(b),p=r(l.minPointLength,5),v=a.getColumnMetrics(),w=v.width,t=a.barW=Math.max(w,1+2*c),K=a.pointXOffset=v.offset;g.inverted&&(d-=.5);l.pointPadding&&(t=Math.ceil(t));n.prototype.translate.apply(a);G(a.points,function(c){var e=r(c.yBottom,d),h=999+Math.abs(e),h=Math.min(Math.max(-h,c.plotY),f.len+h),l=c.plotX+K,m=t,n=Math.min(h,e),y,k=Math.max(h,e)-n;p&&Math.abs(k)<p&&(k=p,y=!f.reversed&&
	!c.negative||f.reversed&&c.negative,c.y===b&&a.dataMax<=b&&f.min<b&&(y=!y),n=Math.abs(n-d)>p?e-p:d-(y?p:0));c.barX=l;c.pointWidth=w;c.tooltipPos=g.inverted?[f.len+f.pos-g.plotLeft-h,a.xAxis.len-l-m/2,k]:[l+m/2,h+f.pos-g.plotTop,k];c.shapeType="rect";c.shapeArgs=a.crispCol.apply(a,c.isNull?[l,d,m,0]:[l,n,m,k])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},pointAttribs:function(a,
	g){var e=this.options,c,f=this.pointAttrToOptions||{};c=f.stroke||"borderColor";var b=f["stroke-width"]||"borderWidth",d=a&&a.color||this.color,h=a&&a[c]||e[c]||this.color||d,n=a&&a[b]||e[b]||this[b]||0,f=e.dashStyle;a&&this.zones.length&&(d=a.getZone(),d=a.options.color||d&&d.color||this.color);g&&(a=l(e.states[g],a.options.states&&a.options.states[g]||{}),g=a.brightness,d=a.color||void 0!==g&&B(d).brighten(a.brightness).get()||d,h=a[c]||h,n=a[b]||n,f=a.dashStyle||f);c={fill:d,stroke:h,"stroke-width":n};
	f&&(c.dashstyle=f);return c},drawPoints:function(){var a=this,h=this.chart,m=a.options,c=h.renderer,f=m.animationLimit||250,b;G(a.points,function(d){var e=d.graphic;if(g(d.plotY)&&null!==d.y){b=d.shapeArgs;if(e)e[h.pointCount<f?"animate":"attr"](l(b));else d.graphic=e=c[d.shapeType](b).add(d.group||a.group);m.borderRadius&&e.attr({r:m.borderRadius});e.attr(a.pointAttribs(d,d.selected&&"select")).shadow(m.shadow,null,m.stacking&&!m.borderRadius);e.addClass(d.getClassName(),!0)}else e&&(d.graphic=e.destroy())})},
	animate:function(a){var e=this,g=this.yAxis,c=e.options,f=this.chart.inverted,b={},d=f?"translateX":"translateY",l;v&&(a?(b.scaleY=.001,a=Math.min(g.pos+g.len,Math.max(g.pos,g.toPixels(c.threshold))),f?b.translateX=a-g.len:b.translateY=a,e.group.attr(b)):(l=e.group.attr(d),e.group.animate({scaleY:1},p(D(e.options.animation),{step:function(a,c){b[d]=l+c.pos*(g.pos-l);e.group.attr(b)}})),e.animate=null))},remove:function(){var a=this,g=a.chart;g.hasRendered&&G(g.series,function(e){e.type===a.type&&
	(e.isDirty=!0)});n.prototype.remove.apply(a,arguments)}})})(N);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(N);(function(a){var D=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan style\x3d"color:{point.color}"\x3e\u25cf\x3c/span\x3e \x3cspan style\x3d"font-size: 0.85em"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},
	{sorted:!1,requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&D.prototype.drawGraph.call(this)}})})(N);(function(a){var D=a.deg2rad,B=a.isNumber,G=a.pick,p=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,l=this.chart,r=2*(a.slicedOffset||0),n=l.plotWidth-2*r,l=l.plotHeight-2*r,w=a.center,w=[G(w[0],"50%"),G(w[1],"50%"),a.size||"100%",a.innerSize||0],v=Math.min(n,
	l),e,h;for(e=0;4>e;++e)h=w[e],a=2>e||2===e&&/%$/.test(h),w[e]=p(h,[n,l,v,w[2]][e])+(a?r:0);w[3]>w[2]&&(w[3]=w[2]);return w},getStartAndEndRadians:function(a,l){a=B(a)?a:0;l=B(l)&&l>a&&360>l-a?l:a+360;return{start:D*(a+-90),end:D*(l+-90)}}}})(N);(function(a){var D=a.addEvent,B=a.CenteredSeriesMixin,G=a.defined,p=a.each,g=a.extend,l=B.getStartAndEndRadians,r=a.inArray,n=a.noop,w=a.pick,v=a.Point,e=a.Series,h=a.seriesType,m=a.setAnimation;h("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,
	enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0},borderColor:"#ffffff",borderWidth:1,states:{hover:{brightness:.1,shadow:!1}}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var c=
	this,b=c.points,d=c.startAngleRad;a||(p(b,function(a){var b=a.graphic,f=a.shapeArgs;b&&(b.attr({r:a.startR||c.center[3]/2,start:d,end:d}),b.animate({r:f.r,start:f.start,end:f.end},c.options.animation))}),c.animate=null)},updateTotals:function(){var a,f=0,b=this.points,d=b.length,e,g=this.options.ignoreHiddenPoint;for(a=0;a<d;a++)e=b[a],f+=g&&!e.visible?0:e.isNull?0:e.y;this.total=f;for(a=0;a<d;a++)e=b[a],e.percentage=0<f&&(e.visible||!g)?e.y/f*100:0,e.total=f},generatePoints:function(){e.prototype.generatePoints.call(this);
	this.updateTotals()},translate:function(a){this.generatePoints();var c=0,b=this.options,d=b.slicedOffset,e=d+(b.borderWidth||0),g,h,m,n=l(b.startAngle,b.endAngle),p=this.startAngleRad=n.start,n=(this.endAngleRad=n.end)-p,r=this.points,v,q=b.dataLabels.distance,b=b.ignoreHiddenPoint,A,E=r.length,F;a||(this.center=a=this.getCenter());this.getX=function(b,c,d){m=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(m)*(a[2]/2+d.labelDistance)};for(A=0;A<E;A++){F=r[A];
	F.labelDistance=w(F.options.dataLabels&&F.options.dataLabels.distance,q);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,F.labelDistance);g=p+c*n;if(!b||F.visible)c+=F.percentage/100;h=p+c*n;F.shapeType="arc";F.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*g)/1E3,end:Math.round(1E3*h)/1E3};m=(h+g)/2;m>1.5*Math.PI?m-=2*Math.PI:m<-Math.PI/2&&(m+=2*Math.PI);F.slicedTranslation={translateX:Math.round(Math.cos(m)*d),translateY:Math.round(Math.sin(m)*d)};h=Math.cos(m)*a[2]/
	2;v=Math.sin(m)*a[2]/2;F.tooltipPos=[a[0]+.7*h,a[1]+.7*v];F.half=m<-Math.PI/2||m>Math.PI/2?1:0;F.angle=m;g=Math.min(e,F.labelDistance/5);F.labelPos=[a[0]+h+Math.cos(m)*F.labelDistance,a[1]+v+Math.sin(m)*F.labelDistance,a[0]+h+Math.cos(m)*g,a[1]+v+Math.sin(m)*g,a[0]+h,a[1]+v,0>F.labelDistance?"center":F.half?"right":"left",m]}},drawGraph:null,drawPoints:function(){var a=this,f=a.chart.renderer,b,d,e,h,l=a.options.shadow;l&&!a.shadowGroup&&(a.shadowGroup=f.g("shadow").add(a.group));p(a.points,function(c){d=
	c.graphic;if(c.isNull)d&&(c.graphic=d.destroy());else{h=c.shapeArgs;b=c.getTranslate();var m=c.shadowGroup;l&&!m&&(m=c.shadowGroup=f.g("shadow").add(a.shadowGroup));m&&m.attr(b);e=a.pointAttribs(c,c.selected&&"select");d?d.setRadialReference(a.center).attr(e).animate(g(h,b)):(c.graphic=d=f[c.shapeType](h).setRadialReference(a.center).attr(b).add(a.group),c.visible||d.attr({visibility:"hidden"}),d.attr(e).attr({"stroke-linejoin":"round"}).shadow(l,m));d.addClass(c.getClassName())}})},searchPoint:n,
	sortByAngle:function(a,f){a.sort(function(a,c){return void 0!==a.angle&&(c.angle-a.angle)*f})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:B.getCenter,getSymbol:n},{init:function(){v.prototype.init.apply(this,arguments);var a=this,f;a.name=w(a.name,"Slice");f=function(b){a.slice("select"===b.type)};D(a,"select",f);D(a,"unselect",f);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=this.y},setVisible:function(a,f){var b=this,c=b.series,e=c.chart,g=c.options.ignoreHiddenPoint;
	f=w(f,g);a!==b.visible&&(b.visible=b.options.visible=a=void 0===a?!b.visible:a,c.options.data[r(b,c.data)]=b.options,p(["graphic","dataLabel","connector","shadowGroup"],function(c){if(b[c])b[c][a?"show":"hide"](!0)}),b.legendItem&&e.legend.colorizeItem(b,a),a||"hover"!==b.state||b.setState(""),g&&(c.isDirty=!0),f&&e.redraw())},slice:function(a,f,b){var c=this.series;m(b,c.chart);w(f,!0);this.sliced=this.options.sliced=G(a)?a:!this.sliced;c.options.data[r(this,c.data)]=this.options;this.graphic.animate(this.getTranslate());
	this.shadowGroup&&this.shadowGroup.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var c=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(c.x,c.y,c.r+a,c.r+a,{innerR:this.shapeArgs.r,start:c.start,end:c.end})}})})(N);(function(a){var D=a.addEvent,B=a.arrayMax,G=a.defined,p=a.each,g=a.extend,l=a.format,r=a.map,n=a.merge,w=a.noop,v=a.pick,e=a.relativeLength,h=a.Series,
	m=a.seriesTypes,c=a.stableSort;a.distribute=function(a,b){function d(a,b){return a.target-b.target}var f,e=!0,g=a,h=[],l;l=0;for(f=a.length;f--;)l+=a[f].size;if(l>b){c(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(l=f=0;l<=b;)l+=a[f].size,f++;h=a.splice(f-1,a.length)}c(a,d);for(a=r(a,function(a){return{size:a.size,targets:[a.target],align:v(a.align,.5)}});e;){for(f=a.length;f--;)e=a[f],l=(Math.min.apply(0,e.targets)+Math.max.apply(0,e.targets))/2,e.pos=Math.min(Math.max(0,l-e.size*e.align),
	b-e.size);f=a.length;for(e=!1;f--;)0<f&&a[f-1].pos+a[f-1].size>a[f].pos&&(a[f-1].size+=a[f].size,a[f-1].targets=a[f-1].targets.concat(a[f].targets),a[f-1].align=.5,a[f-1].pos+a[f-1].size>b&&(a[f-1].pos=b-a[f-1].size),a.splice(f,1),e=!0)}f=0;p(a,function(a){var b=0;p(a.targets,function(){g[f].pos=a.pos+b;b+=g[f].size;f++})});g.push.apply(g,h);c(g,d)};h.prototype.drawDataLabels=function(){function c(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<
	c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}var b=this,d=b.options,e=d.dataLabels,g=b.points,h,m,r=b.hasRendered||0,x,w,B=v(e.defer,!!d.animation),q=b.chart.renderer;if(e.enabled||b._hasPointLabels)b.dlProcessOptions&&b.dlProcessOptions(e),w=b.plotGroup("dataLabelsGroup","data-labels",B&&!r?"hidden":"visible",e.zIndex||6),B&&(w.attr({opacity:+r}),r||D(b,"afterAnimate",function(){b.visible&&w.show(!0);w[d.animation?"animate":"attr"]({opacity:1},
	{duration:200})})),m=e,p(g,function(f){var g,t=f.dataLabel,k,p,r=f.connector,y=!t,C;h=f.dlOptions||f.options&&f.options.dataLabels;(g=v(h&&h.enabled,m.enabled)&&!f.isNull)&&(g=!0===c(f,h||e));g&&(e=n(m,h),k=f.getLabelConfig(),C=e[f.formatPrefix+"Format"]||e.format,x=G(C)?l(C,k):(e[f.formatPrefix+"Formatter"]||e.formatter).call(k,e),C=e.style,k=e.rotation,C.color=v(e.color,C.color,b.color,"#000000"),"contrast"===C.color&&(f.contrastColor=q.getContrast(f.color||b.color),C.color=e.inside||0>v(f.labelDistance,
	e.distance)||d.stacking?f.contrastColor:"#000000"),d.cursor&&(C.cursor=d.cursor),p={fill:e.backgroundColor,stroke:e.borderColor,"stroke-width":e.borderWidth,r:e.borderRadius||0,rotation:k,padding:e.padding,zIndex:1},a.objectEach(p,function(a,b){void 0===a&&delete p[b]}));!t||g&&G(x)?g&&G(x)&&(t?p.text=x:(t=f.dataLabel=q[k?"text":"label"](x,0,-9999,e.shape,null,null,e.useHTML,null,"data-label"),t.addClass("highcharts-data-label-color-"+f.colorIndex+" "+(e.className||"")+(e.useHTML?"highcharts-tracker":
	""))),t.attr(p),t.css(C).shadow(e.shadow),t.added||t.add(w),b.alignDataLabel(f,t,e,null,y)):(f.dataLabel=t=t.destroy(),r&&(f.connector=r.destroy()))})};h.prototype.alignDataLabel=function(a,b,c,e,h){var d=this.chart,f=d.inverted,l=v(a.dlBox&&a.dlBox.centerX,a.plotX,-9999),m=v(a.plotY,-9999),n=b.getBBox(),p,q=c.rotation,r=c.align,w=this.visible&&(a.series.forceDL||d.isInsidePlot(l,Math.round(m),f)||e&&d.isInsidePlot(l,f?e.x+1:e.y+e.height-1,f)),y="justify"===v(c.overflow,"justify");if(w&&(p=c.style.fontSize,
	p=d.renderer.fontMetrics(p,b).b,e=g({x:f?this.yAxis.len-m:l,y:Math.round(f?this.xAxis.len-l:m),width:0,height:0},e),g(c,{width:n.width,height:n.height}),q?(y=!1,l=d.renderer.rotCorr(p,q),l={x:e.x+c.x+e.width/2+l.x,y:e.y+c.y+{top:0,middle:.5,bottom:1}[c.verticalAlign]*e.height},b[h?"attr":"animate"](l).attr({align:r}),m=(q+720)%360,m=180<m&&360>m,"left"===r?l.y-=m?n.height:0:"center"===r?(l.x-=n.width/2,l.y-=n.height/2):"right"===r&&(l.x-=n.width,l.y-=m?0:n.height)):(b.align(c,null,e),l=b.alignAttr),
	y?a.isLabelJustified=this.justifyDataLabel(b,c,l,n,e,h):v(c.crop,!0)&&(w=d.isInsidePlot(l.x,l.y)&&d.isInsidePlot(l.x+n.width,l.y+n.height)),c.shape&&!q))b[h?"attr":"animate"]({anchorX:f?d.plotWidth-a.plotY:a.plotX,anchorY:f?d.plotHeight-a.plotX:a.plotY});w||(b.attr({y:-9999}),b.placed=!1)};h.prototype.justifyDataLabel=function(a,b,c,e,g,h){var d=this.chart,f=b.align,l=b.verticalAlign,m,n,q=a.box?0:a.padding||0;m=c.x+q;0>m&&("right"===f?b.align="left":b.x=-m,n=!0);m=c.x+e.width-q;m>d.plotWidth&&("left"===
	f?b.align="right":b.x=d.plotWidth-m,n=!0);m=c.y+q;0>m&&("bottom"===l?b.verticalAlign="top":b.y=-m,n=!0);m=c.y+e.height-q;m>d.plotHeight&&("top"===l?b.verticalAlign="bottom":b.y=d.plotHeight-m,n=!0);n&&(a.placed=!h,a.align(b,null,g));return n};m.pie&&(m.pie.prototype.drawDataLabels=function(){var c=this,b=c.data,d,e=c.chart,g=c.options.dataLabels,l=v(g.connectorPadding,10),m=v(g.connectorWidth,1),n=e.plotWidth,r=e.plotHeight,w,D=c.center,q=D[2]/2,A=D[1],E,F,k,u,N=[[],[]],M,P,I,Q,z=[0,0,0,0];c.visible&&
	(g.enabled||c._hasPointLabels)&&(p(b,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),h.prototype.drawDataLabels.apply(c),p(b,function(a){a.dataLabel&&a.visible&&(N[a.half].push(a),a.dataLabel._pos=null)}),p(N,function(b,f){var h,m,t=b.length,x=[],w;if(t)for(c.sortByAngle(b,f-.5),0<c.maxLabelDistance&&(h=Math.max(0,A-q-c.maxLabelDistance),m=Math.min(A+q+c.maxLabelDistance,e.plotHeight),
	p(b,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,A-q-a.labelDistance),a.bottom=Math.min(A+q+a.labelDistance,e.plotHeight),w=a.dataLabel.getBBox().height||21,a.positionsIndex=x.push({target:a.labelPos[1]-a.top+w/2,size:w,rank:a.y})-1)}),a.distribute(x,m+w-h)),Q=0;Q<t;Q++)d=b[Q],m=d.positionsIndex,k=d.labelPos,E=d.dataLabel,I=!1===d.visible?"hidden":"inherit",P=h=k[1],x&&G(x[m])&&(void 0===x[m].pos?I="hidden":(u=x[m].size,P=d.top+x[m].pos)),delete d.positionIndex,M=g.justify?D[0]+(f?
	-1:1)*(q+d.labelDistance):c.getX(P<d.top+2||P>d.bottom-2?h:P,f,d),E._attr={visibility:I,align:k[6]},E._pos={x:M+g.x+({left:l,right:-l}[k[6]]||0),y:P+g.y-10},k.x=M,k.y=P,v(g.crop,!0)&&(F=E.getBBox().width,h=null,M-F<l?(h=Math.round(F-M+l),z[3]=Math.max(h,z[3])):M+F>n-l&&(h=Math.round(M+F-n+l),z[1]=Math.max(h,z[1])),0>P-u/2?z[0]=Math.max(Math.round(-P+u/2),z[0]):P+u/2>r&&(z[2]=Math.max(Math.round(P+u/2-r),z[2])),E.sideOverflow=h)}),0===B(z)||this.verifyDataLabelOverflow(z))&&(this.placeDataLabels(),
	m&&p(this.points,function(a){var b;w=a.connector;if((E=a.dataLabel)&&E._pos&&a.visible&&0<a.labelDistance){I=E._attr.visibility;if(b=!w)a.connector=w=e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex).add(c.dataLabelsGroup),w.attr({"stroke-width":m,stroke:g.connectorColor||a.color||"#666666"});w[b?"attr":"animate"]({d:c.connectorPath(a.labelPos)});w.attr("visibility",I)}else w&&(a.connector=w.destroy())}))},m.pie.prototype.connectorPath=function(a){var b=
	a.x,c=a.y;return v(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",a[4],a[5]]},m.pie.prototype.placeDataLabels=function(){p(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+"px",textOverflow:"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),
	b.moved=!0):b&&b.attr({y:-9999}))},this)},m.pie.prototype.alignDataLabel=w,m.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,c=this.options,f=c.center,g=c.minSize||80,h,l=null!==c.size;l||(null!==f[0]?h=Math.max(b[2]-Math.max(a[1],a[3]),g):(h=Math.max(b[2]-a[1]-a[3],g),b[0]+=(a[3]-a[1])/2),null!==f[1]?h=Math.max(Math.min(h,b[2]-Math.max(a[0],a[2])),g):(h=Math.max(Math.min(h,b[2]-a[0]-a[2]),g),b[1]+=(a[0]-a[2])/2),h<b[2]?(b[2]=h,b[3]=Math.min(e(c.innerSize||0,h),h),this.translate(b),
	this.drawDataLabels&&this.drawDataLabels()):l=!0);return l});m.column&&(m.column.prototype.alignDataLabel=function(a,b,c,e,g){var d=this.chart.inverted,f=a.series,l=a.dlBox||a.shapeArgs,m=v(a.below,a.plotY>v(this.translatedThreshold,f.yAxis.len)),p=v(c.inside,!!this.options.stacking);l&&(e=n(l),0>e.y&&(e.height+=e.y,e.y=0),l=e.y+e.height-f.yAxis.len,0<l&&(e.height-=l),d&&(e={x:f.yAxis.len-e.y-e.height,y:f.xAxis.len-e.x-e.width,width:e.height,height:e.width}),p||(d?(e.x+=m?0:e.width,e.width=0):(e.y+=
	m?e.height:0,e.height=0)));c.align=v(c.align,!d||p?"center":m?"right":"left");c.verticalAlign=v(c.verticalAlign,d||p?"middle":m?"top":"bottom");h.prototype.alignDataLabel.call(this,a,b,c,e,g);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(N);(function(a){var D=a.Chart,B=a.each,G=a.objectEach,p=a.pick;a=a.addEvent;a(D.prototype,"render",function(){var a=[];B(this.labelCollectors||[],function(g){a=a.concat(g())});B(this.yAxis||[],function(g){g.options.stackLabels&&
	!g.options.stackLabels.allowOverlap&&G(g.stacks,function(g){G(g,function(g){a.push(g.label)})})});B(this.series||[],function(g){var l=g.options.dataLabels,n=g.dataLabelCollections||["dataLabel"];(l.enabled||g._hasPointLabels)&&!l.allowOverlap&&g.visible&&B(n,function(l){B(g.points,function(g){g[l]&&(g[l].labelrank=p(g.labelrank,g.shapeArgs&&g.shapeArgs.height),a.push(g[l]))})})});this.hideOverlappingLabels(a)});D.prototype.hideOverlappingLabels=function(a){var g=a.length,p,n,w,v,e,h,m,c,f,b=function(a,
	b,c,f,e,g,h,l){return!(e>a+c||e+h<a||g>b+f||g+l<b)};for(n=0;n<g;n++)if(p=a[n])p.oldOpacity=p.opacity,p.newOpacity=1,p.width||(w=p.getBBox(),p.width=w.width,p.height=w.height);a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(n=0;n<g;n++)for(w=a[n],p=n+1;p<g;++p)if(v=a[p],w&&v&&w!==v&&w.placed&&v.placed&&0!==w.newOpacity&&0!==v.newOpacity&&(e=w.alignAttr,h=v.alignAttr,m=w.parentGroup,c=v.parentGroup,f=2*(w.box?0:w.padding||0),e=b(e.x+m.translateX,e.y+m.translateY,w.width-f,w.height-
	f,h.x+c.translateX,h.y+c.translateY,v.width-f,v.height-f)))(w.labelrank<v.labelrank?w:v).newOpacity=0;B(a,function(a){var b,c;a&&(c=a.newOpacity,a.oldOpacity!==c&&a.placed&&(c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(N);(function(a){var D=a.addEvent,B=a.Chart,G=a.createElement,p=a.css,g=a.defaultOptions,l=a.defaultPlotOptions,r=a.each,n=a.extend,w=a.fireEvent,v=a.hasTouch,e=a.inArray,h=a.isObject,m=a.Legend,c=a.merge,
	f=a.pick,b=a.Point,d=a.Series,y=a.seriesTypes,H=a.svg,J;J=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};r(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(r(a.trackerGroups,function(d){if(a[d]){a[d].addClass("highcharts-tracker").on("mouseover",c).on("mouseout",function(a){b.onTrackerMouseOut(a)});
	if(v)a[d].on("touchstart",c);a.options.cursor&&a[d].css(p).css({cursor:a.options.cursor})}}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=this,b=a.options,c=b.trackByArea,d=[].concat(c?a.areaPath:a.graphPath),f=d.length,e=a.chart,g=e.pointer,h=e.renderer,l=e.options.tooltip.snap,k=a.tracker,m,n=function(){if(e.hoverSeries!==a)a.onMouseOver()},p="rgba(192,192,192,"+(H?.0001:.002)+")";if(f&&!c)for(m=f+1;m--;)"M"===d[m]&&d.splice(m+1,0,d[m+1]-l,d[m+2],"L"),(m&&"M"===d[m]||m===f)&&d.splice(m,
	0,"L",d[m-2]+l,d[m-1]);k?k.attr({d:d}):a.graph&&(a.tracker=h.path(d).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:p,fill:c?p:"none","stroke-width":a.graph.strokeWidth()+(c?0:2*l),zIndex:2}).add(a.group),r([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",n).on("mouseout",function(a){g.onTrackerMouseOut(a)});b.cursor&&a.css({cursor:b.cursor});if(v)a.on("touchstart",n)}))}};y.column&&(y.column.prototype.drawTracker=J.drawTrackerPoint);
	y.pie&&(y.pie.prototype.drawTracker=J.drawTrackerPoint);y.scatter&&(y.scatter.prototype.drawTracker=J.drawTrackerPoint);n(m.prototype,{setItemEvents:function(a,b,d){var f=this,e=f.chart.renderer.boxWrapper,g="highcharts-legend-"+(a.series?"point":"series")+"-active";(d?b:a.legendGroup).on("mouseover",function(){a.setState("hover");e.addClass(g);b.css(f.options.itemHoverStyle)}).on("mouseout",function(){b.css(c(a.visible?f.itemStyle:f.itemHiddenStyle));e.removeClass(g);a.setState()}).on("click",function(b){var c=
	function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):w(a,"legendItemClick",b,c)})},createCheckboxForItem:function(a){a.checkbox=G("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);D(a.checkbox,"click",function(b){w(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});g.legend.itemStyle.cursor="pointer";n(B.prototype,{showResetZoom:function(){var a=
	this,b=g.lang,c=a.options.chart.resetZoomButton,d=c.theme,f=d.states,e="chart"===c.relativeTo?null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,null,null,function(){a.zoomOut()},d,f&&f.hover).attr({align:c.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(c.position,!1,e)},zoomOut:function(){var a=this;w(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var b,c=this.pointer,d=!1,e;!a||a.resetSelection?(r(this.axes,function(a){b=
	a.zoom()}),c.initiated=!1):r(a.xAxis.concat(a.yAxis),function(a){var f=a.axis;c[f.isXAxis?"zoomX":"zoomY"]&&(b=f.zoom(a.min,a.max),f.displayBtn&&(d=!0))});e=this.resetZoomButton;d&&!e?this.showResetZoom():!d&&h(e)&&(this.resetZoomButton=e.destroy());b&&this.redraw(f(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,d=c.hoverPoints,f;d&&r(d,function(a){a.setState()});r("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var d=b.horiz,e=a[d?"chartX":
	"chartY"],d=d?"mouseDownX":"mouseDownY",g=c[d],k=(b.pointRange||0)/2,h=b.getExtremes(),l=b.toValue(g-e,!0)+k,k=b.toValue(g+b.len-e,!0)-k,m=k<l,g=m?k:l,l=m?l:k,k=Math.min(h.dataMin,b.toValue(b.toPixels(h.min)-b.minPixelPadding)),m=Math.max(h.dataMax,b.toValue(b.toPixels(h.max)+b.minPixelPadding)),n;n=k-g;0<n&&(l+=n,g=k);n=l-m;0<n&&(l=m,g-=n);b.series.length&&g!==h.min&&l!==h.max&&(b.setExtremes(g,l,!1,!1,{trigger:"pan"}),f=!0);c[d]=e});f&&c.redraw(!1);p(c.container,{cursor:"move"})}});n(b.prototype,
	{select:function(a,b){var c=this,d=c.series,g=d.chart;a=f(a,!c.selected);c.firePointEvent(a?"select":"unselect",{accumulate:b},function(){c.selected=c.options.selected=a;d.options.data[e(c,d.data)]=c.options;c.setState(a&&"select");b||r(g.getSelectedPoints(),function(a){a.selected&&a!==c&&(a.selected=a.options.selected=!1,d.options.data[e(a,d.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,
	b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");r(a.hoverPoints||[],function(a){a.setState()});a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,d=c(b.series.options.point,b.options).events;b.events=d;a.objectEach(d,function(a,c){D(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,b){var c=Math.floor(this.plotX),d=this.plotY,e=this.series,g=e.options.states[a]||{},h=l[e.type].marker&&
	e.options.marker,m=h&&!1===h.enabled,p=h&&h.states&&h.states[a]||{},k=!1===p.enabled,t=e.stateMarkerGraphic,r=this.marker||{},v=e.chart,w=e.halo,y,B=h&&e.markerAttribs;a=a||"";if(!(a===this.state&&!b||this.selected&&"select"!==a||!1===g.enabled||a&&(k||m&&!1===p.enabled)||a&&r.states&&r.states[a]&&!1===r.states[a].enabled)){B&&(y=e.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),this.graphic.animate(e.pointAttribs(this,
	a),f(v.options.chart.animation,g.animation)),y&&this.graphic.animate(y,f(v.options.chart.animation,p.animation,h.animation)),t&&t.hide();else{if(a&&p){h=r.symbol||e.symbol;t&&t.currentSymbol!==h&&(t=t.destroy());if(t)t[b?"animate":"attr"]({x:y.x,y:y.y});else h&&(e.stateMarkerGraphic=t=v.renderer.symbol(h,y.x,y.y,y.width,y.height).add(e.markerGroup),t.currentSymbol=h);t&&t.attr(e.pointAttribs(this,a))}t&&(t[a&&v.isInsidePlot(c,d,v.inverted)?"show":"hide"](),t.element.point=this)}(c=g.halo)&&c.size?
	(w||(e.halo=w=v.renderer.path().add((this.graphic||t).parentGroup)),w[b?"animate":"attr"]({d:this.haloPath(c.size)}),w.attr({"class":"highcharts-halo highcharts-color-"+f(this.colorIndex,e.colorIndex)}),w.point=this,w.attr(n({fill:this.color||e.color,"fill-opacity":c.opacity,zIndex:-1},c.attributes))):w&&w.point&&w.point.haloPath&&w.animate({d:w.point.haloPath(0)});this.state=a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});
	n(d.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&w(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&w(this,"mouseOut");!c||this.stickyTracking||c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this,c=b.options,d=b.graph,e=c.states,
	g=c.lineWidth,c=0;a=a||"";if(b.state!==a&&(r([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a,!e[a]||!1!==e[a].enabled)&&(a&&(g=e[a].lineWidth||g+(e[a].lineWidthPlus||0)),d&&!d.dashstyle))for(g={"stroke-width":g},d.animate(g,f(b.chart.options.chart.animation,e[a]&&e[a].animation));b["zone-graph-"+c];)b["zone-graph-"+c].attr(g),c+=1},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,
	f,g=d.options.chart.ignoreHiddenSeries,h=c.visible;f=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!h:a)?"show":"hide";r(["group","dataLabelsGroup","markerGroup","tracker","tt"],function(a){if(c[a])c[a][f]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&r(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});r(c.linkedSeries,function(b){b.setVisible(a,!1)});g&&(d.isDirtyBox=
	!0);!1!==b&&d.redraw();w(c,f)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:a;this.checkbox&&(this.checkbox.checked=a);w(this,a?"select":"unselect")},drawTracker:J.drawTrackerGraph})})(N);(function(a){var D=a.Chart,B=a.each,G=a.inArray,p=a.isArray,g=a.isObject,l=a.pick,r=a.splat;D.prototype.setResponsive=function(g){var l=this.options.responsive,n=[],e=this.currentResponsive;l&&l.rules&&B(l.rules,function(e){void 0===
	e._id&&(e._id=a.uniqueKey());this.matchResponsiveRule(e,n,g)},this);var h=a.merge.apply(0,a.map(n,function(e){return a.find(l.rules,function(a){return a._id===e}).chartOptions})),n=n.toString()||void 0;n!==(e&&e.ruleIds)&&(e&&this.update(e.undoOptions,g),n?(this.currentResponsive={ruleIds:n,mergedOptions:h,undoOptions:this.currentOptions(h)},this.update(h,g)):this.currentResponsive=void 0)};D.prototype.matchResponsiveRule=function(a,g){var n=a.condition;(n.callback||function(){return this.chartWidth<=
	l(n.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=l(n.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=l(n.minWidth,0)&&this.chartHeight>=l(n.minHeight,0)}).call(this)&&g.push(a._id)};D.prototype.currentOptions=function(l){function n(e,h,l,c){var f;a.objectEach(e,function(a,d){if(!c&&-1<G(d,["series","xAxis","yAxis"]))for(a=r(a),l[d]=[],f=0;f<a.length;f++)h[d][f]&&(l[d][f]={},n(a[f],h[d][f],l[d][f],c+1));else g(a)?(l[d]=p(a)?[]:{},n(a,h[d]||{},l[d],c+1)):l[d]=h[d]||null})}var v={};n(l,this.options,v,
	0);return v}})(N);return N});


/***/ }),
/* 382 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(262);
	
	var _PathUtils = __webpack_require__(94);
	
	var _createTransitionManager = __webpack_require__(318);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(382);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(94);
	
	var _LocationUtils = __webpack_require__(262);
	
	var _createTransitionManager = __webpack_require__(318);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(825),
	    isArguments = __webpack_require__(76),
	    isArray = __webpack_require__(5),
	    isBuffer = __webpack_require__(205),
	    isIndex = __webpack_require__(75),
	    isTypedArray = __webpack_require__(277);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ }),
/* 386 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(388),
	    eq = __webpack_require__(198);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(270);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(152),
	    isArray = __webpack_require__(5);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ }),
/* 390 */
/***/ (function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(152),
	    getPrototype = __webpack_require__(323),
	    getSymbols = __webpack_require__(324),
	    stubArray = __webpack_require__(396);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ }),
/* 392 */
/***/ (function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ }),
/* 393 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(206),
	    isLength = __webpack_require__(207);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(385),
	    baseKeysIn = __webpack_require__(824),
	    isArrayLike = __webpack_require__(394);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ }),
/* 396 */
/***/ (function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ }),
/* 397 */
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),
/* 398 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(940);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(581);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(895);
	
	var _HelmetConstants = __webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),
/* 400 */
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(729);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(909);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(407);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(408);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(326);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(328);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(411);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(332);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(280),
	    _assign = __webpack_require__(63);
	
	var ReactNoopUpdateQueue = __webpack_require__(415);
	
	var canDefineProperty = __webpack_require__(416);
	var emptyObject = __webpack_require__(260);
	var invariant = __webpack_require__(35);
	var lowPriorityWarning = __webpack_require__(936);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ }),
/* 413 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ }),
/* 414 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(261);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ }),
/* 417 */,
/* 418 */,
/* 419 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(326);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(954);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ }),
/* 421 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(423);

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var bind = __webpack_require__(338);
	var Axios = __webpack_require__(425);
	var defaults = __webpack_require__(282);
	
	/**
	 * Create an instance of Axios
	 *
	 * @param {Object} defaultConfig The default config for the instance
	 * @return {Axios} A new instance of Axios
	 */
	function createInstance(defaultConfig) {
	  var context = new Axios(defaultConfig);
	  var instance = bind(Axios.prototype.request, context);
	
	  // Copy axios.prototype to instance
	  utils.extend(instance, Axios.prototype, context);
	
	  // Copy context to instance
	  utils.extend(instance, context);
	
	  return instance;
	}
	
	// Create the default instance to be exported
	var axios = createInstance(defaults);
	
	// Expose Axios class to allow class inheritance
	axios.Axios = Axios;
	
	// Factory for creating new instances
	axios.create = function create(instanceConfig) {
	  return createInstance(utils.merge(defaults, instanceConfig));
	};
	
	// Expose Cancel & CancelToken
	axios.Cancel = __webpack_require__(335);
	axios.CancelToken = __webpack_require__(424);
	axios.isCancel = __webpack_require__(336);
	
	// Expose all/spread
	axios.all = function all(promises) {
	  return Promise.all(promises);
	};
	axios.spread = __webpack_require__(439);
	
	module.exports = axios;
	
	// Allow use of default import syntax in TypeScript
	module.exports.default = axios;


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var Cancel = __webpack_require__(335);
	
	/**
	 * A `CancelToken` is an object that can be used to request cancellation of an operation.
	 *
	 * @class
	 * @param {Function} executor The executor function.
	 */
	function CancelToken(executor) {
	  if (typeof executor !== 'function') {
	    throw new TypeError('executor must be a function.');
	  }
	
	  var resolvePromise;
	  this.promise = new Promise(function promiseExecutor(resolve) {
	    resolvePromise = resolve;
	  });
	
	  var token = this;
	  executor(function cancel(message) {
	    if (token.reason) {
	      // Cancellation has already been requested
	      return;
	    }
	
	    token.reason = new Cancel(message);
	    resolvePromise(token.reason);
	  });
	}
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	CancelToken.prototype.throwIfRequested = function throwIfRequested() {
	  if (this.reason) {
	    throw this.reason;
	  }
	};
	
	/**
	 * Returns an object that contains a new `CancelToken` and a function that, when called,
	 * cancels the `CancelToken`.
	 */
	CancelToken.source = function source() {
	  var cancel;
	  var token = new CancelToken(function executor(c) {
	    cancel = c;
	  });
	  return {
	    token: token,
	    cancel: cancel
	  };
	};
	
	module.exports = CancelToken;


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var defaults = __webpack_require__(282);
	var utils = __webpack_require__(17);
	var InterceptorManager = __webpack_require__(426);
	var dispatchRequest = __webpack_require__(427);
	
	/**
	 * Create a new instance of Axios
	 *
	 * @param {Object} instanceConfig The default config for the instance
	 */
	function Axios(instanceConfig) {
	  this.defaults = instanceConfig;
	  this.interceptors = {
	    request: new InterceptorManager(),
	    response: new InterceptorManager()
	  };
	}
	
	/**
	 * Dispatch a request
	 *
	 * @param {Object} config The config specific for this request (merged with this.defaults)
	 */
	Axios.prototype.request = function request(config) {
	  /*eslint no-param-reassign:0*/
	  // Allow for axios('example/url'[, config]) a la fetch API
	  if (typeof config === 'string') {
	    config = utils.merge({
	      url: arguments[0]
	    }, arguments[1]);
	  }
	
	  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	  config.method = config.method.toLowerCase();
	
	  // Hook up interceptors middleware
	  var chain = [dispatchRequest, undefined];
	  var promise = Promise.resolve(config);
	
	  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
	    chain.unshift(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
	    chain.push(interceptor.fulfilled, interceptor.rejected);
	  });
	
	  while (chain.length) {
	    promise = promise.then(chain.shift(), chain.shift());
	  }
	
	  return promise;
	};
	
	// Provide aliases for supported request methods
	utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url
	    }));
	  };
	});
	
	utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
	  /*eslint func-names:0*/
	  Axios.prototype[method] = function(url, data, config) {
	    return this.request(utils.merge(config || {}, {
	      method: method,
	      url: url,
	      data: data
	    }));
	  };
	});
	
	module.exports = Axios;


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	function InterceptorManager() {
	  this.handlers = [];
	}
	
	/**
	 * Add a new interceptor to the stack
	 *
	 * @param {Function} fulfilled The function to handle `then` for a `Promise`
	 * @param {Function} rejected The function to handle `reject` for a `Promise`
	 *
	 * @return {Number} An ID used to remove interceptor later
	 */
	InterceptorManager.prototype.use = function use(fulfilled, rejected) {
	  this.handlers.push({
	    fulfilled: fulfilled,
	    rejected: rejected
	  });
	  return this.handlers.length - 1;
	};
	
	/**
	 * Remove an interceptor from the stack
	 *
	 * @param {Number} id The ID that was returned by `use`
	 */
	InterceptorManager.prototype.eject = function eject(id) {
	  if (this.handlers[id]) {
	    this.handlers[id] = null;
	  }
	};
	
	/**
	 * Iterate over all the registered interceptors
	 *
	 * This method is particularly useful for skipping over any
	 * interceptors that may have become `null` calling `eject`.
	 *
	 * @param {Function} fn The function to call for each interceptor
	 */
	InterceptorManager.prototype.forEach = function forEach(fn) {
	  utils.forEach(this.handlers, function forEachHandler(h) {
	    if (h !== null) {
	      fn(h);
	    }
	  });
	};
	
	module.exports = InterceptorManager;


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	var transformData = __webpack_require__(430);
	var isCancel = __webpack_require__(336);
	var defaults = __webpack_require__(282);
	var isAbsoluteURL = __webpack_require__(435);
	var combineURLs = __webpack_require__(433);
	
	/**
	 * Throws a `Cancel` if cancellation has been requested.
	 */
	function throwIfCancellationRequested(config) {
	  if (config.cancelToken) {
	    config.cancelToken.throwIfRequested();
	  }
	}
	
	/**
	 * Dispatch a request to the server using the configured adapter.
	 *
	 * @param {object} config The config that is to be used for the request
	 * @returns {Promise} The Promise to be fulfilled
	 */
	module.exports = function dispatchRequest(config) {
	  throwIfCancellationRequested(config);
	
	  // Support baseURL config
	  if (config.baseURL && !isAbsoluteURL(config.url)) {
	    config.url = combineURLs(config.baseURL, config.url);
	  }
	
	  // Ensure headers exist
	  config.headers = config.headers || {};
	
	  // Transform request data
	  config.data = transformData(
	    config.data,
	    config.headers,
	    config.transformRequest
	  );
	
	  // Flatten headers
	  config.headers = utils.merge(
	    config.headers.common || {},
	    config.headers[config.method] || {},
	    config.headers || {}
	  );
	
	  utils.forEach(
	    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
	    function cleanHeaderConfig(method) {
	      delete config.headers[method];
	    }
	  );
	
	  var adapter = config.adapter || defaults.adapter;
	
	  return adapter(config).then(function onAdapterResolution(response) {
	    throwIfCancellationRequested(config);
	
	    // Transform response data
	    response.data = transformData(
	      response.data,
	      response.headers,
	      config.transformResponse
	    );
	
	    return response;
	  }, function onAdapterRejection(reason) {
	    if (!isCancel(reason)) {
	      throwIfCancellationRequested(config);
	
	      // Transform response data
	      if (reason && reason.response) {
	        reason.response.data = transformData(
	          reason.response.data,
	          reason.response.headers,
	          config.transformResponse
	        );
	      }
	    }
	
	    return Promise.reject(reason);
	  });
	};


/***/ }),
/* 428 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Update an Error with the specified config, error code, and response.
	 *
	 * @param {Error} error The error to update.
	 * @param {Object} config The config.
	 * @param {string} [code] The error code (for example, 'ECONNABORTED').
	 * @param {Object} [request] The request.
	 * @param {Object} [response] The response.
	 * @returns {Error} The error.
	 */
	module.exports = function enhanceError(error, config, code, request, response) {
	  error.config = config;
	  if (code) {
	    error.code = code;
	  }
	  error.request = request;
	  error.response = response;
	  return error;
	};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var createError = __webpack_require__(337);
	
	/**
	 * Resolve or reject a Promise based on response status.
	 *
	 * @param {Function} resolve A function that resolves the promise.
	 * @param {Function} reject A function that rejects the promise.
	 * @param {object} response The response.
	 */
	module.exports = function settle(resolve, reject, response) {
	  var validateStatus = response.config.validateStatus;
	  // Note: status is not exposed by XDomainRequest
	  if (!response.status || !validateStatus || validateStatus(response.status)) {
	    resolve(response);
	  } else {
	    reject(createError(
	      'Request failed with status code ' + response.status,
	      response.config,
	      null,
	      response.request,
	      response
	    ));
	  }
	};


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	/**
	 * Transform the data for a request or a response
	 *
	 * @param {Object|String} data The data to be transformed
	 * @param {Array} headers The headers for the request or response
	 * @param {Array|Function} fns A single function or Array of functions
	 * @returns {*} The resulting transformed data
	 */
	module.exports = function transformData(data, headers, fns) {
	  /*eslint no-param-reassign:0*/
	  utils.forEach(fns, function transform(fn) {
	    data = fn(data, headers);
	  });
	
	  return data;
	};


/***/ }),
/* 431 */
/***/ (function(module, exports) {

	'use strict';
	
	// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
	var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
	function E() {
	  this.message = 'String contains an invalid character';
	}
	E.prototype = new Error;
	E.prototype.code = 5;
	E.prototype.name = 'InvalidCharacterError';
	
	function btoa(input) {
	  var str = String(input);
	  var output = '';
	  for (
	    // initialize result and counter
	    var block, charCode, idx = 0, map = chars;
	    // if the next str index does not exist:
	    //   change the mapping table to "="
	    //   check if d has no fractional digits
	    str.charAt(idx | 0) || (map = '=', idx % 1);
	    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
	    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
	  ) {
	    charCode = str.charCodeAt(idx += 3 / 4);
	    if (charCode > 0xFF) {
	      throw new E();
	    }
	    block = block << 8 | charCode;
	  }
	  return output;
	}
	
	module.exports = btoa;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	function encode(val) {
	  return encodeURIComponent(val).
	    replace(/%40/gi, '@').
	    replace(/%3A/gi, ':').
	    replace(/%24/g, '$').
	    replace(/%2C/gi, ',').
	    replace(/%20/g, '+').
	    replace(/%5B/gi, '[').
	    replace(/%5D/gi, ']');
	}
	
	/**
	 * Build a URL by appending params to the end
	 *
	 * @param {string} url The base of the url (e.g., http://www.google.com)
	 * @param {object} [params] The params to be appended
	 * @returns {string} The formatted url
	 */
	module.exports = function buildURL(url, params, paramsSerializer) {
	  /*eslint no-param-reassign:0*/
	  if (!params) {
	    return url;
	  }
	
	  var serializedParams;
	  if (paramsSerializer) {
	    serializedParams = paramsSerializer(params);
	  } else if (utils.isURLSearchParams(params)) {
	    serializedParams = params.toString();
	  } else {
	    var parts = [];
	
	    utils.forEach(params, function serialize(val, key) {
	      if (val === null || typeof val === 'undefined') {
	        return;
	      }
	
	      if (utils.isArray(val)) {
	        key = key + '[]';
	      }
	
	      if (!utils.isArray(val)) {
	        val = [val];
	      }
	
	      utils.forEach(val, function parseValue(v) {
	        if (utils.isDate(v)) {
	          v = v.toISOString();
	        } else if (utils.isObject(v)) {
	          v = JSON.stringify(v);
	        }
	        parts.push(encode(key) + '=' + encode(v));
	      });
	    });
	
	    serializedParams = parts.join('&');
	  }
	
	  if (serializedParams) {
	    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
	  }
	
	  return url;
	};


/***/ }),
/* 433 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Creates a new URL by combining the specified URLs
	 *
	 * @param {string} baseURL The base URL
	 * @param {string} relativeURL The relative URL
	 * @returns {string} The combined URL
	 */
	module.exports = function combineURLs(baseURL, relativeURL) {
	  return relativeURL
	    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
	    : baseURL;
	};


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs support document.cookie
	  (function standardBrowserEnv() {
	    return {
	      write: function write(name, value, expires, path, domain, secure) {
	        var cookie = [];
	        cookie.push(name + '=' + encodeURIComponent(value));
	
	        if (utils.isNumber(expires)) {
	          cookie.push('expires=' + new Date(expires).toGMTString());
	        }
	
	        if (utils.isString(path)) {
	          cookie.push('path=' + path);
	        }
	
	        if (utils.isString(domain)) {
	          cookie.push('domain=' + domain);
	        }
	
	        if (secure === true) {
	          cookie.push('secure');
	        }
	
	        document.cookie = cookie.join('; ');
	      },
	
	      read: function read(name) {
	        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
	        return (match ? decodeURIComponent(match[3]) : null);
	      },
	
	      remove: function remove(name) {
	        this.write(name, '', Date.now() - 86400000);
	      }
	    };
	  })() :
	
	  // Non standard browser env (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return {
	      write: function write() {},
	      read: function read() { return null; },
	      remove: function remove() {}
	    };
	  })()
	);


/***/ }),
/* 435 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Determines whether the specified URL is absolute
	 *
	 * @param {string} url The URL to test
	 * @returns {boolean} True if the specified URL is absolute, otherwise false
	 */
	module.exports = function isAbsoluteURL(url) {
	  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
	  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
	  // by any combination of letters, digits, plus, period, or hyphen.
	  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
	};


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = (
	  utils.isStandardBrowserEnv() ?
	
	  // Standard browser envs have full support of the APIs needed to test
	  // whether the request URL is of the same origin as current location.
	  (function standardBrowserEnv() {
	    var msie = /(msie|trident)/i.test(navigator.userAgent);
	    var urlParsingNode = document.createElement('a');
	    var originURL;
	
	    /**
	    * Parse a URL to discover it's components
	    *
	    * @param {String} url The URL to be parsed
	    * @returns {Object}
	    */
	    function resolveURL(url) {
	      var href = url;
	
	      if (msie) {
	        // IE needs attribute set twice to normalize properties
	        urlParsingNode.setAttribute('href', href);
	        href = urlParsingNode.href;
	      }
	
	      urlParsingNode.setAttribute('href', href);
	
	      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
	      return {
	        href: urlParsingNode.href,
	        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
	        host: urlParsingNode.host,
	        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
	        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
	        hostname: urlParsingNode.hostname,
	        port: urlParsingNode.port,
	        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
	                  urlParsingNode.pathname :
	                  '/' + urlParsingNode.pathname
	      };
	    }
	
	    originURL = resolveURL(window.location.href);
	
	    /**
	    * Determine if a URL shares the same origin as the current location
	    *
	    * @param {String} requestURL The URL to test
	    * @returns {boolean} True if URL shares the same origin, otherwise false
	    */
	    return function isURLSameOrigin(requestURL) {
	      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
	      return (parsed.protocol === originURL.protocol &&
	            parsed.host === originURL.host);
	    };
	  })() :
	
	  // Non standard browser envs (web workers, react-native) lack needed support.
	  (function nonStandardBrowserEnv() {
	    return function isURLSameOrigin() {
	      return true;
	    };
	  })()
	);


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	module.exports = function normalizeHeaderName(headers, normalizedName) {
	  utils.forEach(headers, function processHeader(value, name) {
	    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
	      headers[normalizedName] = value;
	      delete headers[name];
	    }
	  });
	};


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(17);
	
	// Headers whose duplicates are ignored by node
	// c.f. https://nodejs.org/api/http.html#http_message_headers
	var ignoreDuplicateOf = [
	  'age', 'authorization', 'content-length', 'content-type', 'etag',
	  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
	  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
	  'referer', 'retry-after', 'user-agent'
	];
	
	/**
	 * Parse headers into an object
	 *
	 * ```
	 * Date: Wed, 27 Aug 2014 08:58:49 GMT
	 * Content-Type: application/json
	 * Connection: keep-alive
	 * Transfer-Encoding: chunked
	 * ```
	 *
	 * @param {String} headers Headers needing to be parsed
	 * @returns {Object} Headers parsed into an object
	 */
	module.exports = function parseHeaders(headers) {
	  var parsed = {};
	  var key;
	  var val;
	  var i;
	
	  if (!headers) { return parsed; }
	
	  utils.forEach(headers.split('\n'), function parser(line) {
	    i = line.indexOf(':');
	    key = utils.trim(line.substr(0, i)).toLowerCase();
	    val = utils.trim(line.substr(i + 1));
	
	    if (key) {
	      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
	        return;
	      }
	      if (key === 'set-cookie') {
	        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
	      } else {
	        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
	      }
	    }
	  });
	
	  return parsed;
	};


/***/ }),
/* 439 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Syntactic sugar for invoking a function and expanding an array for arguments.
	 *
	 * Common use case would be to use `Function.prototype.apply`.
	 *
	 *  ```js
	 *  function f(x, y, z) {}
	 *  var args = [1, 2, 3];
	 *  f.apply(null, args);
	 *  ```
	 *
	 * With `spread` this example can be re-written.
	 *
	 *  ```js
	 *  spread(function(x, y, z) {})([1, 2, 3]);
	 *  ```
	 *
	 * @param {Function} callback
	 * @returns {Function}
	 */
	module.exports = function spread(callback) {
	  return function wrap(arr) {
	    return callback.apply(null, arr);
	  };
	};


/***/ }),
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(598);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	var _highchartsConfigurator = __webpack_require__(504);
	
	var _highchartsConfigurator2 = _interopRequireDefault(_highchartsConfigurator);
	
	var _ReactHighcharts = __webpack_require__(479);
	
	var _ReactHighcharts2 = _interopRequireDefault(_ReactHighcharts);
	
	__webpack_require__(625);
	
	__webpack_require__(624);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import get from "lodash/fp/get";
	
	// eslint-disable-next-line import/default
	
	
	var Highcharts = void 0;
	var ReactHighcharts = void 0;
	
	// Default and override styles
	
	var Chart = function (_Component) {
	  _inherits(Chart, _Component);
	
	  function Chart(props) {
	    _classCallCheck(this, Chart);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.state = {
	      HighchartEl: "div", // A placeholder element for server rendering
	      config: null, // will be a valid Highcharts config after mounting
	      chartReady: false,
	      errorFound: false
	    };
	
	    _this.onChartReady = _this.onChartReady.bind(_this);
	    return _this;
	  }
	
	  Chart.prototype.getConfig = function getConfig() {
	    var options = _extends({}, {
	      disableDataLabels: this.props.disableDataLabels,
	      title: this.props.title,
	      type: this.props.type,
	      yAxisLabel: this.props.yAxisLabel,
	      yAxisLabel2: this.props.yAxisLabel2,
	      suffix: this.props.suffix,
	      prefix: this.props.prefix,
	      stacking: this.props.stacking,
	      groups: [this.props.group]
	    });
	    // We only receive one group, but the configurator expects an array of
	    // groups. We pass in a one element array of groups and the id of that
	    // group as the 'selected' group.
	    var selectedGroupId = this.props.group.id;
	    return _highchartsConfigurator2.default.getConfig(options, selectedGroupId);
	  };
	
	  Chart.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    // Setup highcharts now that we're definitely running in the browser
	    // Specifically import /js/highcharts to enable CSS-based styling
	    // See: https://www.highcharts.com/docs/chart-design-and-style/style-by-css
	    Highcharts = __webpack_require__(727);
	    ReactHighcharts = _ReactHighcharts2.default.withHighcharts(Highcharts);
	
	    // The `lang` attribute is global and can't be set within the config...
	    Highcharts.setOptions({
	      lang: {
	        thousandsSep: ","
	      }
	    });
	
	    window.setTimeout(function () {
	      _this2.setState({
	        config: _this2.getConfig(),
	        HighchartEl: ReactHighcharts
	      });
	    }, 200);
	  };
	
	  /**
	   * Override theme CSS to hide or show the y axis line based on the yAxisLabel
	   * prop. We're using Highcharts in styled mode so can't change this via the
	   * Highcharts api.
	   */
	
	
	  Chart.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    // const chartRef = this.chartRef;
	    // const yAxisLabel = this.props.yAxisLabel;
	    // if (chartRef) {
	    //   const axisLine = get(".chart.yAxis[0].axisLine", chartRef);
	    //   if (axisLine) {
	    //     // not all charts have an axisLine
	    //     chartRef.chart.yAxis[0].axisLine.element.style.strokeWidth = yAxisLabel
	    //       ? 1
	    //       : 0;
	    //   }
	    // }
	    if (prevProps.group !== this.props.group) {
	      this.setState({ config: this.getConfig() });
	    }
	  };
	
	  Chart.prototype.componentDidCatch = function componentDidCatch() /*error , info*/{
	    this.setState({ errorFound: true });
	    // console.log("Error found", error, info);
	  };
	
	  Chart.prototype.onChartReady = function onChartReady() {
	    var chartReady = this.state.chartReady;
	
	    if (!chartReady) {
	      this.setState({ chartReady: true });
	    }
	  };
	
	  Chart.prototype.errorMessage = function errorMessage() {
	    return _react2.default.createElement(
	      "p",
	      { style: { color: "black", padding: "10px" } },
	      "There was an error displaying this chart."
	    );
	  };
	
	  Chart.prototype.render = function render() {
	    var _this3 = this;
	
	    var children = this.props.children;
	    var _state = this.state,
	        HighchartEl = _state.HighchartEl,
	        config = _state.config,
	        chartReady = _state.chartReady,
	        errorFound = _state.errorFound;
	    // React complains if we pass the callback prop to our placeholder div
	    // Only add it to chartProps once we have a real Highcharts element
	
	    var chartProps = { config: config, ref: function ref(chart) {
	        return _this3.chartRef = chart;
	      } };
	    if (typeof HighchartEl === "function") chartProps.callback = this.onChartReady;
	
	    return _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.root },
	      errorFound ? this.errorMessage() : _react2.default.createElement(
	        "div",
	        {
	          className: chartReady ? _indexModule2.default.chartWrapperReady : _indexModule2.default.chartWrapper
	        },
	        _react2.default.createElement(HighchartEl, chartProps)
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.footer },
	        children
	      )
	    );
	  };
	
	  return Chart;
	}(_react.Component);
	
	Chart.defaultProps = {
	  skipTitle: false,
	  type: "column",
	  stacking: false,
	  yAxisLabel: "",
	  yAxisLabel2: "",
	  prefix: "",
	  suffix: ""
	};
	
	Chart.propTypes = {
	  disableDataLabels: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  skipTitle: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(["column", "bar", "line", "pie", "column_line"]),
	  stacking: _propTypes2.default.bool,
	  yAxisLabel: _propTypes2.default.string,
	  yAxisLabel2: _propTypes2.default.string,
	  suffix: _propTypes2.default.string,
	  prefix: _propTypes2.default.string,
	  onDownloadClick: _propTypes2.default.func,
	  // Highcharts data
	  group: _propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    categories: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    name: _propTypes2.default.string,
	    series: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      name: _propTypes2.default.string,
	      data: _propTypes2.default.array // numbers or objects
	    }))
	  })
	};
	
	exports.default = Chart;
	module.exports = exports["default"];

/***/ }),
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _container = __webpack_require__(246);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _indexModule = __webpack_require__(613);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Preview = function Preview(_ref) {
	  var articleId = _ref.articleId,
	      title = _ref.title,
	      titleNumber = _ref.titleNumber,
	      path = _ref.path,
	      onClick = _ref.onClick,
	      isSelected = _ref.isSelected;
	
	  return _react2.default.createElement(
	    _gatsbyLink2.default,
	    {
	      className: isSelected ? _indexModule2.default.rootActive : _indexModule2.default.root,
	      to: path,
	      activeClassName: _indexModule2.default.rootActive,
	      onClick: onClick ? function (e) {
	        return onClick(e, articleId);
	      } : null // Optional custom click handler
	    },
	    _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.header },
	      _react2.default.createElement(
	        "h1",
	        { className: _indexModule2.default.number },
	        titleNumber
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _indexModule2.default.save },
	        _react2.default.createElement(_container2.default, { articleId: articleId })
	      )
	    ),
	    _react2.default.createElement(
	      "h3",
	      { className: _indexModule2.default.title },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.view },
	      _react2.default.createElement(
	        "span",
	        { className: _indexModule2.default.viewText },
	        "View"
	      )
	    )
	  );
	};
	
	Preview.propTypes = {
	  articleId: _propTypes2.default.number,
	  title: _propTypes2.default.string,
	  titleNumber: _propTypes2.default.string,
	  path: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  onClick: _propTypes2.default.func,
	  isSelected: _propTypes2.default.bool
	};
	
	exports.default = Preview;
	module.exports = exports["default"];

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(480)("Chart", __webpack_require__(381));

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var React = __webpack_require__(1);
	var createReactClass = __webpack_require__(580);
	var PropTypes = __webpack_require__(2);
	var win = typeof global === "undefined" ? window : global;
	
	module.exports = function (chartType, Highcharts) {
	  var displayName = "Highcharts" + chartType;
	  var result = createReactClass({
	    displayName: displayName,
	
	    propTypes: {
	      config: PropTypes.object,
	      isPureConfig: PropTypes.bool,
	      neverReflow: PropTypes.bool,
	      callback: PropTypes.func,
	      domProps: PropTypes.object
	    },
	    getDefaultProps: function getDefaultProps() {
	      return {
	        callback: function callback() {},
	        domProps: {}
	      };
	    },
	    setChartRef: function setChartRef(chartRef) {
	      this.chartRef = chartRef;
	    },
	    renderChart: function renderChart(config) {
	      var _this = this;
	
	      if (!config) {
	        throw new Error("Config must be specified for the " + displayName + " component");
	      }
	      var chartConfig = config.chart;
	      this.chart = new Highcharts[chartType](_extends({}, config, {
	        chart: _extends({}, chartConfig, {
	          renderTo: this.chartRef
	        })
	      }), this.props.callback);
	
	      if (!this.props.neverReflow) {
	        win && win.requestAnimationFrame && requestAnimationFrame(function () {
	          _this.chart && _this.chart.options && _this.chart.reflow();
	        });
	      }
	    },
	
	    shouldComponentUpdate: function shouldComponentUpdate(nextProps) {
	      if (nextProps.neverReflow || nextProps.isPureConfig && this.props.config === nextProps.config) {
	        return true;
	      }
	      this.renderChart(nextProps.config);
	      return false;
	    },
	
	
	    getChart: function getChart() {
	      if (!this.chart) {
	        throw new Error("getChart() should not be called before the component is mounted");
	      }
	      return this.chart;
	    },
	
	    componentDidMount: function componentDidMount() {
	      this.renderChart(this.props.config);
	    },
	
	    componentWillUnmount: function componentWillUnmount() {
	      this.chart.destroy();
	    },
	
	
	    render: function render() {
	      return React.createElement("div", _extends({ ref: this.setChartRef }, this.props.domProps));
	    }
	  });
	
	  result.Highcharts = Highcharts;
	  result.withHighcharts = function (Highcharts) {
	    return module.exports(chartType, Highcharts);
	  };
	  return result;
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSvgInline = __webpack_require__(9);
	
	var _reactSvgInline2 = _interopRequireDefault(_reactSvgInline);
	
	var _selectIcon = __webpack_require__(884);
	
	var _selectIcon2 = _interopRequireDefault(_selectIcon);
	
	var _indexModule = __webpack_require__(618);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SelectControl = function SelectControl(_ref) {
	  var label = _ref.label,
	      values = _ref.values,
	      selectedId = _ref.selectedId,
	      onChange = _ref.onChange;
	  return _react2.default.createElement(
	    "div",
	    { className: _indexModule2.default.root },
	    _react2.default.createElement(
	      "label",
	      { className: _indexModule2.default.label },
	      "Dataset",
	      _react2.default.createElement(
	        "select",
	        { className: _indexModule2.default.element, onChange: onChange, value: selectedId },
	        values.map(function (value) {
	          return _react2.default.createElement(
	            "option",
	            { key: value.id, value: value.id },
	            value.name
	          );
	        })
	      ),
	      _react2.default.createElement(_reactSvgInline2.default, { className: _indexModule2.default.icon, svg: _selectIcon2.default })
	    )
	  );
	};
	
	SelectControl.propTypes = {
	  label: _propTypes2.default.string,
	  values: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	    id: _propTypes2.default.number,
	    name: _propTypes2.default.string
	  })),
	  selectedId: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	};
	
	exports.default = SelectControl;
	module.exports = exports["default"];

/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _indexModule = __webpack_require__(620);
	
	var _indexModule2 = _interopRequireDefault(_indexModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Table = function Table(_ref) {
	  var group = _ref.group,
	      children = _ref.children;
	
	  return _react2.default.createElement(
	    "div",
	    { className: _indexModule2.default.root },
	    _react2.default.createElement(
	      "table",
	      { className: _indexModule2.default.table },
	      _react2.default.createElement(
	        "thead",
	        { className: _indexModule2.default.thead },
	        _react2.default.createElement(
	          "tr",
	          { className: _indexModule2.default.tr },
	          group.categories.map(function (category) {
	            return _react2.default.createElement(
	              "th",
	              { key: category, className: _indexModule2.default.th },
	              category
	            );
	          })
	        )
	      ),
	      _react2.default.createElement(
	        "tbody",
	        { className: _indexModule2.default.tbody },
	        group.series.map(function (series) {
	          return _react2.default.createElement(
	            "tr",
	            { key: series.name, className: _indexModule2.default.tr },
	            series.data.map(function (data, index) {
	              return _react2.default.createElement(
	                "td",
	                { key: index, className: _indexModule2.default.td },
	                data
	              );
	            })
	          );
	        })
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _indexModule2.default.footer },
	      children
	    )
	  );
	};
	
	Table.propTypes = {
	  group: _propTypes2.default.shape({
	    categories: _propTypes2.default.arrayOf(_propTypes2.default.string),
	    series: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	      name: _propTypes2.default.string,
	      data: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]))
	    }))
	  })
	  // title: PropTypes.string
	};
	
	exports.default = Table;
	module.exports = exports["default"];

/***/ }),
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // eslint-disable-next-line import/default
	
	
	var _highcharts = __webpack_require__(381);
	
	var _highcharts2 = _interopRequireDefault(_highcharts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Given a set of highcharts data and some config options, return a valid
	 * Highcharts config.
	 *
	 * Written as an ES5 module that will run in Node or a browser without
	 * compilation.
	 *
	 * Usage in node:
	 *
	 * const hc = require('./highchartsConfigurator')
	 * hc.getConfig(options, groupId)
	 *
	 * Usage in a browser:
	 *
	 * <script src="highchartsConfigurator.js"></script>
	   <script>
	    console.log(highchartsConfigurator.getConfig(options, groupId));
	   </script>
	 */
	
	(function (exports) {
	  var CHART_TYPES = ["bar", "column", "line", "pie", "column_line"];
	
	  var defaultConfig = {
	    chart: { type: "bar", colorCount: 13 },
	    title: false,
	    plotOptions: {
	      bar: {
	        stacking: false,
	        dataLabels: {
	          padding: 2,
	          enabled: true
	        }
	      },
	      column: {
	        stacking: false,
	        dataLabels: {
	          padding: 2,
	          enabled: true
	        }
	      },
	      line: {
	        dataLabels: {
	          padding: 2,
	          enabled: true
	        },
	        zIndex: 100
	      },
	      pie: {
	        dataLabels: {
	          padding: 2,
	          enabled: true
	        }
	      },
	      series: {
	        dataLabels: {
	          padding: 2,
	          enabled: true,
	          format: "{point.options.labelText}"
	        }
	      }
	    },
	    navigation: {
	      buttonOptions: {
	        enabled: false
	      }
	    },
	    legend: {
	      align: "left",
	      padding: 15
	    },
	    yAxis: {
	      endOnTick: false,
	      title: { text: "" },
	      visible: true,
	      lineWidth: 10,
	      maxPadding: 0.15,
	      labels: {
	        distance: -20,
	        padding: 2,
	        enabled: false,
	        autoRotation: [-45, -90],
	        x: -5
	      }
	    },
	    series: [],
	    xAxis: {
	      categories: [],
	      labels: {
	        distance: -20,
	        padding: 2,
	        autoRotation: [-45, -90],
	        y: 16
	      }
	    },
	    tooltip: {
	      valuePrefix: "",
	      valueSuffix: "",
	      pointFormat: "<span class=\"highcharts-color-{point.colorIndex}\">\u25CF</span> {series.name}: <b>{point.labelText}</b><br/>"
	    },
	    credits: { enabled: false }
	  };
	
	  exports.getConfig = function (options, groupId) {
	    var type = options.type || CHART_TYPES[0];
	    var stacking = options.stacking || false;
	    var yAxisLabel = options.yAxisLabel || "";
	    var suffix = options.suffix || "";
	    var prefix = options.prefix || "";
	    var groups = options.groups || [];
	
	    // No labels under 400px
	    if (window.innerWidth <= 400) {
	      options.disableDataLabels = true;
	    }
	
	    var currentGroup = groups.find(function (group) {
	      return group.id === groupId;
	    });
	
	    // Poor man's deep copy
	    var configCopy = JSON.parse(JSON.stringify(defaultConfig));
	
	    // Assign options to default config
	    var config = _extends({}, configCopy, {
	      series: currentGroup.series
	    });
	
	    config.chart.type = type;
	    config.xAxis.categories = currentGroup.categories;
	    config.yAxis.title.text = yAxisLabel;
	    config.yAxis.labels.enabled = !!yAxisLabel;
	    config.tooltip.valuePrefix = prefix;
	    config.tooltip.valueSuffix = suffix;
	    config.plotOptions.bar.stacking = stacking;
	    config.plotOptions.column.stacking = stacking;
	
	    if (stacking) {
	      config.tooltip.shared = true;
	
	      if (config.series.length >= 3) {
	        config.plotOptions.bar.dataLabels.enabled = false;
	        config.plotOptions.column.dataLabels.enabled = false;
	        config.plotOptions.series.dataLabels.enabled = false;
	      }
	    }
	
	    if (options.type === "bar") {
	      // reset our default xAxis y label position (xAxis is vertical on bar charts)
	      config.xAxis.labels.y = null;
	
	      // Change aspect ratio to give extra height to bar charts with a lot of categories
	      if (currentGroup.categories.length > 5) config.chart.height = "100%"; // 1:1 aspect ratio
	    }
	
	    if (options.type === "line") {
	      // Use orange as the first series colour, then use high contrast colours
	      config.series = config.series.map(function (serie, index) {
	        var colorIndex = void 0;
	        switch (index) {
	          case 0:
	            colorIndex = 9;
	            break;
	          case 1:
	            colorIndex = 0;
	            break;
	          case 2:
	            colorIndex = 2;
	            break;
	          default:
	            colorIndex = index + 1;
	            break;
	        }
	        serie.colorIndex = colorIndex;
	
	        // Set proper padding on the data labels
	        serie.dataLabels = { y: -8 };
	        return serie;
	      });
	    }
	
	    if (options.type === "column_line") {
	      // Delete existing chart type, type is specified within the series
	      delete config.chart.type;
	
	      // Setup second axis and axis labels
	      var yAxis = _extends({}, config.yAxis);
	      var yAxisDeepCopy = JSON.parse(JSON.stringify(config.yAxis)); // Note that this will fail for any unserializable fields
	      var yAxis2 = _extends({}, yAxisDeepCopy, {
	        opposite: true, // put this axis on the other side
	        labels: { x: 1 // undo negative x, so labels don't overlap the axis
	        } });
	      yAxis2.title.text = options.yAxisLabel2;
	      config.yAxis = [yAxis, yAxis2];
	
	      config.series = config.series.map(function (serie) {
	        if (serie.type === "line") {
	          // For the first series (the line) set a custom colour and zIndex
	          serie.colorIndex = 6;
	          // Set custom options for the line data labels
	          serie.dataLabels = {
	            padding: 4,
	            y: -8
	          };
	        }
	        return serie;
	      });
	    }
	
	    if (options.type === "pie") {
	      // Different label formatting for pie charts
	      config.plotOptions.pie.dataLabels.format = "<b>{point.name}</b>: {point.percentage:.1f} %";
	      config.tooltip.pointFormat = "{series.name}: <b>{point.percentage:.1f}%</b> / <b>{point.labelText}</b>";
	      config.series = [config.series[0]];
	      config.series.colorByPoint = true;
	    }
	
	    // Modify series data for all chart types
	    config.series = config.series.map(function (serie) {
	      // Protect against null values (they'll crash Highcharts)
	      if (serie.type === null) delete serie.type;
	      if (serie.yAxis === null) delete serie.yAxis;
	      if (serie.zIndex === null) delete serie.zIndex;
	
	      // apply the disableDataLabels option
	      if (options.disableDataLabels) serie.dataLabels = false;
	
	      // Allow string data labels, set value to 0 if so.
	      serie.data = serie.data.map(function (point) {
	        if ((typeof point === "undefined" ? "undefined" : _typeof(point)) !== "object") {
	          return {
	            y: typeof point === "string" ? 0 : point,
	            labelText: typeof point === "string" ? point : _highcharts2.default.numberFormat(point, -1, ".", ",")
	          };
	        } else {
	          return point;
	        }
	      });
	
	      return serie;
	    });
	    return config;
	  };
	})( false ? undefined["highchartsConfigurator"] = {} : exports);

/***/ }),
/* 505 */,
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(518), __esModule: true };

/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(519), __esModule: true };

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(520), __esModule: true };

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(521), __esModule: true };

/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(522), __esModule: true };

/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(523), __esModule: true };

/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(524), __esModule: true };

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(507);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ }),
/* 514 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(375);
	__webpack_require__(376);
	__webpack_require__(377);
	__webpack_require__(577);
	module.exports = __webpack_require__(89).Map;


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(375);
	__webpack_require__(376);
	__webpack_require__(377);
	__webpack_require__(579);
	module.exports = __webpack_require__(89).Set;


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

	var core = __webpack_require__(34);
	var $JSON = core.JSON || (core.JSON = { stringify: JSON.stringify });
	module.exports = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON.stringify.apply($JSON, arguments);
	};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(544);
	module.exports = __webpack_require__(34).Object.assign;


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(545);
	var $Object = __webpack_require__(34).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(546);
	module.exports = __webpack_require__(34).Object.keys;


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(547);
	module.exports = __webpack_require__(34).Object.setPrototypeOf;


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(550);
	__webpack_require__(548);
	__webpack_require__(551);
	__webpack_require__(552);
	module.exports = __webpack_require__(34).Symbol;


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(549);
	__webpack_require__(553);
	module.exports = __webpack_require__(302).f('iterator');


/***/ }),
/* 525 */
/***/ (function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ }),
/* 526 */
/***/ (function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(87);
	var toLength = __webpack_require__(542);
	var toAbsoluteIndex = __webpack_require__(541);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(129);
	var gOPS = __webpack_require__(294);
	var pIE = __webpack_require__(251);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

	var document = __webpack_require__(36).document;
	module.exports = document && document.documentElement;


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(348);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(293);
	var descriptor = __webpack_require__(252);
	var setToStringTag = __webpack_require__(295);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(85)(IteratorPrototype, __webpack_require__(88)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 532 */
/***/ (function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

	var META = __webpack_require__(253)('meta');
	var isObject = __webpack_require__(128);
	var has = __webpack_require__(66);
	var setDesc = __webpack_require__(86).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(84)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(129);
	var gOPS = __webpack_require__(294);
	var pIE = __webpack_require__(251);
	var toObject = __webpack_require__(299);
	var IObject = __webpack_require__(352);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(84)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(86);
	var anObject = __webpack_require__(127);
	var getKeys = __webpack_require__(129);
	
	module.exports = __webpack_require__(82) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(87);
	var gOPN = __webpack_require__(355).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(66);
	var toObject = __webpack_require__(299);
	var IE_PROTO = __webpack_require__(296)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(83);
	var core = __webpack_require__(34);
	var fails = __webpack_require__(84);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(128);
	var anObject = __webpack_require__(127);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(349)(Function.call, __webpack_require__(354).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(298);
	var defined = __webpack_require__(289);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(298);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(298);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(526);
	var step = __webpack_require__(532);
	var Iterators = __webpack_require__(291);
	var toIObject = __webpack_require__(87);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(353)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(83);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(534) });


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(83);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(293) });


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(299);
	var $keys = __webpack_require__(129);
	
	__webpack_require__(538)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(83);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(539).set });


/***/ }),
/* 548 */
/***/ (function(module, exports) {



/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(540)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(353)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(36);
	var has = __webpack_require__(66);
	var DESCRIPTORS = __webpack_require__(82);
	var $export = __webpack_require__(83);
	var redefine = __webpack_require__(357);
	var META = __webpack_require__(533).KEY;
	var $fails = __webpack_require__(84);
	var shared = __webpack_require__(297);
	var setToStringTag = __webpack_require__(295);
	var uid = __webpack_require__(253);
	var wks = __webpack_require__(88);
	var wksExt = __webpack_require__(302);
	var wksDefine = __webpack_require__(301);
	var enumKeys = __webpack_require__(528);
	var isArray = __webpack_require__(530);
	var anObject = __webpack_require__(127);
	var toIObject = __webpack_require__(87);
	var toPrimitive = __webpack_require__(300);
	var createDesc = __webpack_require__(252);
	var _create = __webpack_require__(293);
	var gOPNExt = __webpack_require__(536);
	var $GOPD = __webpack_require__(354);
	var $DP = __webpack_require__(86);
	var $keys = __webpack_require__(129);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(355).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(251).f = $propertyIsEnumerable;
	  __webpack_require__(294).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(292)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    replacer = args[1];
	    if (typeof replacer == 'function') $replacer = replacer;
	    if ($replacer || !isArray(replacer)) replacer = function (key, value) {
	      if ($replacer) value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(85)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('asyncIterator');


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(301)('observable');


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

	__webpack_require__(543);
	var global = __webpack_require__(36);
	var hide = __webpack_require__(85);
	var Iterators = __webpack_require__(291);
	var TO_STRING_TAG = __webpack_require__(88)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(14)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(91)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(258);
	var toLength = __webpack_require__(373);
	var toAbsoluteIndex = __webpack_require__(573);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(30);
	var setPrototypeOf = __webpack_require__(570).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ }),
/* 557 */
/***/ (function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(255);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(130);
	var ITERATOR = __webpack_require__(14)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(37);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(368);
	var descriptor = __webpack_require__(310);
	var setToStringTag = __webpack_require__(257);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(91)(IteratorPrototype, __webpack_require__(14)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

	var global = __webpack_require__(18);
	var macrotask = __webpack_require__(372).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(255)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver
	  } else if (Observer) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    var promise = Promise.resolve();
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(92);
	var anObject = __webpack_require__(37);
	var getKeys = __webpack_require__(369);
	
	module.exports = __webpack_require__(67) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(567);
	var createDesc = __webpack_require__(310);
	var toIObject = __webpack_require__(258);
	var toPrimitive = __webpack_require__(374);
	var has = __webpack_require__(68);
	var IE8_DOM_DEFINE = __webpack_require__(362);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(67) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(68);
	var toObject = __webpack_require__(574);
	var IE_PROTO = __webpack_require__(312)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

	var has = __webpack_require__(68);
	var toIObject = __webpack_require__(258);
	var arrayIndexOf = __webpack_require__(555)(false);
	var IE_PROTO = __webpack_require__(312)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ }),
/* 567 */
/***/ (function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 568 */
/***/ (function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(37);
	var isObject = __webpack_require__(30);
	var newPromiseCapability = __webpack_require__(367);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(30);
	var anObject = __webpack_require__(37);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(90)(Function.call, __webpack_require__(564).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(37);
	var aFunction = __webpack_require__(254);
	var SPECIES = __webpack_require__(14)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(313);
	var defined = __webpack_require__(305);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(313);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(305);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(304);
	var ITERATOR = __webpack_require__(14)('iterator');
	var Iterators = __webpack_require__(130);
	module.exports = __webpack_require__(89).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(554);
	var step = __webpack_require__(364);
	var Iterators = __webpack_require__(130);
	var toIObject = __webpack_require__(258);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(309)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(358);
	var validate = __webpack_require__(314);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(359)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(365);
	var global = __webpack_require__(18);
	var ctx = __webpack_require__(90);
	var classof = __webpack_require__(304);
	var $export = __webpack_require__(307);
	var isObject = __webpack_require__(30);
	var aFunction = __webpack_require__(254);
	var anInstance = __webpack_require__(303);
	var forOf = __webpack_require__(308);
	var speciesConstructor = __webpack_require__(571);
	var task = __webpack_require__(372).set;
	var microtask = __webpack_require__(562)();
	var newPromiseCapabilityModule = __webpack_require__(367);
	var perform = __webpack_require__(568);
	var promiseResolve = __webpack_require__(569);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(14)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value);
	            if (domain) domain.exit();
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  if (promise._h == 1) return false;
	  var chain = promise._a || promise._c;
	  var i = 0;
	  var reaction;
	  while (chain.length > i) {
	    reaction = chain[i++];
	    if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	  } return true;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(311)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(257)($Promise, PROMISE);
	__webpack_require__(370)(PROMISE);
	Wrapper = __webpack_require__(89)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(363)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(358);
	var validate = __webpack_require__(314);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(359)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(378);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(583);
	var isArguments = __webpack_require__(582);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),
/* 582 */
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),
/* 583 */
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(315);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var off = function off() {};
	if (_inDOM2.default) {
	  off = function () {
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.removeEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.detachEvent('on' + eventName, handler);
	    };
	  }();
	}
	
	exports.default = off;
	module.exports = exports['default'];

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(315);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var on = function on() {};
	if (_inDOM2.default) {
	  on = function () {
	
	    if (document.addEventListener) return function (node, eventName, handler, capture) {
	      return node.addEventListener(eventName, handler, capture || false);
	    };else if (document.attachEvent) return function (node, eventName, handler) {
	      return node.attachEvent('on' + eventName, function (e) {
	        e = e || window.event;
	        e.target = e.target || e.srcElement;
	        e.currentTarget = node;
	        handler.call(node, e);
	      });
	    };
	  }();
	}
	
	exports.default = on;
	module.exports = exports['default'];

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(379);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
	
	  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = scrollTop;
	
	var _isWindow = __webpack_require__(379);
	
	var _isWindow2 = _interopRequireDefault(_isWindow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function scrollTop(node, val) {
	  var win = (0, _isWindow2.default)(node);
	
	  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
	
	  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
	}
	module.exports = exports['default'];

/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _inDOM = __webpack_require__(315);
	
	var _inDOM2 = _interopRequireDefault(_inDOM);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
	var cancel = 'clearTimeout';
	var raf = fallback;
	var compatRaf = void 0;
	
	var getKey = function getKey(vendor, k) {
	  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
	};
	
	if (_inDOM2.default) {
	  vendors.some(function (vendor) {
	    var rafKey = getKey(vendor, 'request');
	
	    if (rafKey in window) {
	      cancel = getKey(vendor, 'cancel');
	      return raf = function raf(cb) {
	        return window[rafKey](cb);
	      };
	    }
	  });
	}
	
	/* https://github.com/component/raf */
	var prev = new Date().getTime();
	function fallback(fn) {
	  var curr = new Date().getTime(),
	      ms = Math.max(0, 16 - (curr - prev)),
	      req = setTimeout(fn, ms);
	
	  prev = curr;
	  return req;
	}
	
	compatRaf = function compatRaf(cb) {
	  return raf(cb);
	};
	compatRaf.cancel = function (id) {
	  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
	};
	exports.default = compatRaf;
	module.exports = exports['default'];

/***/ }),
/* 592 */,
/* 593 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-ActionButton----index-module---root---w1dyq","rootLarge":"src-components-ActionButton----index-module---rootLarge---2AMde src-components-ActionButton----index-module---root---w1dyq"};

/***/ }),
/* 594 */,
/* 595 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-BlockChart----index-module---root---20yZ6","insight":"src-components-BlockChart----index-module---insight---3zWPT","title":"src-components-BlockChart----index-module---title---3jwUF","select":"src-components-BlockChart----index-module---select---1M4cn"};

/***/ }),
/* 596 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-BlockChartImage----index-module---root---11_CK","insight":"src-components-BlockChartImage----index-module---insight---2gR2c","title":"src-components-BlockChartImage----index-module---title---VDEGL","image":"src-components-BlockChartImage----index-module---image---29xEV"};

/***/ }),
/* 597 */,
/* 598 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"chartWrapper":"src-components-Chart----index-module---chartWrapper---LiLj4","chartWrapperReady":"src-components-Chart----index-module---chartWrapperReady---3a9MM src-components-Chart----index-module---chartWrapper---LiLj4","footer":"src-components-Chart----index-module---footer---2-eJP"};

/***/ }),
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-FigureFooter----index-module---root---3onr_","section":"src-components-FigureFooter----index-module---section---1a6Mn","social":"src-components-FigureFooter----index-module---social---1ro1z","socialAction":"src-components-FigureFooter----index-module---socialAction---1IHuQ","list":"src-components-FigureFooter----index-module---list---2VO5o","term":"src-components-FigureFooter----index-module---term---3yT5I","definition":"src-components-FigureFooter----index-module---definition---1AMH6"};

/***/ }),
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-Preview----index-module---root---3YQuI","view":"src-components-Preview----index-module---view---3vCA2","rootActive":"src-components-Preview----index-module---rootActive---1oj3y src-components-Preview----index-module---root---3YQuI","header":"src-components-Preview----index-module---header---MzIhG","number":"src-components-Preview----index-module---number---2etch","save":"src-components-Preview----index-module---save---1waWd","type":"src-components-Preview----index-module---type---1G8le","title":"src-components-Preview----index-module---title---1pelZ","viewText":"src-components-Preview----index-module---viewText---1_Fc5"};

/***/ }),
/* 614 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-PreviewList----index-module---root---2QxGg","header":"src-components-PreviewList----index-module---header---1Wh4b","title":"src-components-PreviewList----index-module---title---3VU4J","inner":"src-components-PreviewList----index-module---inner---2r8z_"};

/***/ }),
/* 615 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-PrimaryButton----index-module---root---26r5E","rootInverted":"src-components-PrimaryButton----index-module---rootInverted---b94Xu src-components-PrimaryButton----index-module---root---26r5E"};

/***/ }),
/* 616 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-Save----index-module---root---3aT2U","saveIcon":"src-components-Save----index-module---saveIcon---2NkZ4","saveIconActive":"src-components-Save----index-module---saveIconActive---3M0Zv src-components-Save----index-module---saveIcon---2NkZ4","text":"src-components-Save----index-module---text---i2dob","textLarge":"src-components-Save----index-module---textLarge---3IzPc src-components-Save----index-module---text---i2dob"};

/***/ }),
/* 617 */,
/* 618 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-SelectControl----index-module---root---3vACP","label":"src-components-SelectControl----index-module---label---2JdSm","icon":"src-components-SelectControl----index-module---icon---1lijN","element":"src-components-SelectControl----index-module---element---3xr_T"};

/***/ }),
/* 619 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-Share----index-module---root---3nJyZ","icon":"src-components-Share----index-module---icon---31_Lp"};

/***/ }),
/* 620 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"root":"src-components-Table----index-module---root---9FzgZ","table":"src-components-Table----index-module---table---2bbYv","tr":"src-components-Table----index-module---tr---3VNJw","td":"src-components-Table----index-module---td---dBP0-","th":"src-components-Table----index-module---th---251SE","tbody":"src-components-Table----index-module---tbody---3ZFAd","button":"src-components-Table----index-module---button---20o9M","footer":"src-components-Table----index-module---footer---1OSRp"};

/***/ }),
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */,
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(69);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ }),
/* 628 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(633);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ }),
/* 630 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ }),
/* 631 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ }),
/* 632 */
/***/ (function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(632);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ }),
/* 634 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ }),
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */,
/* 708 */,
/* 709 */,
/* 710 */,
/* 711 */,
/* 712 */,
/* 713 */,
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(250);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(288);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(287);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(223);
	
	var _scrollBehavior = __webpack_require__(951);
	
	var _scrollBehavior2 = _interopRequireDefault(_scrollBehavior);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StateStorage = __webpack_require__(725);
	
	var _StateStorage2 = _interopRequireDefault(_StateStorage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired,
	  location: _propTypes2.default.object.isRequired,
	  history: _propTypes2.default.object.isRequired
	};
	
	var childContextTypes = {
	  scrollBehavior: _propTypes2.default.object.isRequired
	};
	
	var ScrollContext = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContext, _React$Component);
	
	  function ScrollContext(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContext);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.registerElement = function (key, element, shouldUpdateScroll) {
	      _this.scrollBehavior.registerElement(key, element, shouldUpdateScroll, _this.getRouterProps());
	    };
	
	    _this.unregisterElement = function (key) {
	      _this.scrollBehavior.unregisterElement(key);
	    };
	
	    var history = props.history;
	
	
	    _this.scrollBehavior = new _scrollBehavior2.default({
	      addTransitionHook: history.listen,
	      stateStorage: new _StateStorage2.default(),
	      getCurrentLocation: function getCurrentLocation() {
	        return _this.props.location;
	      },
	      shouldUpdateScroll: _this.shouldUpdateScroll
	    });
	
	    _this.scrollBehavior.updateScroll(null, _this.getRouterProps());
	    return _this;
	  }
	
	  ScrollContext.prototype.getChildContext = function getChildContext() {
	    return {
	      scrollBehavior: this
	    };
	  };
	
	  ScrollContext.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props = this.props,
	        location = _props.location,
	        history = _props.history;
	
	    var prevLocation = prevProps.location;
	
	    if (location === prevLocation) {
	      return;
	    }
	
	    var prevRouterProps = {
	      history: prevProps.history,
	      location: prevProps.location
	    };
	
	    this.scrollBehavior.updateScroll(prevRouterProps, { history: history, location: location });
	  };
	
	  ScrollContext.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.scrollBehavior.stop();
	  };
	
	  ScrollContext.prototype.getRouterProps = function getRouterProps() {
	    var _props2 = this.props,
	        history = _props2.history,
	        location = _props2.location;
	
	    return { history: history, location: location };
	  };
	
	  ScrollContext.prototype.render = function render() {
	    return _react2.default.Children.only(this.props.children);
	  };
	
	  return ScrollContext;
	}(_react2.default.Component);
	
	ScrollContext.propTypes = propTypes;
	ScrollContext.childContextTypes = childContextTypes;
	
	exports.default = (0, _reactRouterDom.withRouter)(ScrollContext);

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(250);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(288);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(287);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(99);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  scrollKey: _propTypes2.default.string.isRequired,
	  shouldUpdateScroll: _propTypes2.default.func,
	  children: _propTypes2.default.element.isRequired
	};
	
	var contextTypes = {
	  // This is necessary when rendering on the client. However, when rendering on
	  // the server, this container will do nothing, and thus does not require the
	  // scroll behavior context.
	  scrollBehavior: _propTypes2.default.object
	};
	
	var ScrollContainer = function (_React$Component) {
	  (0, _inherits3.default)(ScrollContainer, _React$Component);
	
	  function ScrollContainer(props, context) {
	    (0, _classCallCheck3.default)(this, ScrollContainer);
	
	    // We don't re-register if the scroll key changes, so make sure we
	    // unregister with the initial scroll key just in case the user changes it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props, context));
	
	    _this.shouldUpdateScroll = function (prevRouterProps, routerProps) {
	      var shouldUpdateScroll = _this.props.shouldUpdateScroll;
	
	      if (!shouldUpdateScroll) {
	        return true;
	      }
	
	      // Hack to allow accessing scrollBehavior._stateStorage.
	      return shouldUpdateScroll.call(_this.context.scrollBehavior.scrollBehavior, prevRouterProps, routerProps);
	    };
	
	    _this.scrollKey = props.scrollKey;
	    return _this;
	  }
	
	  ScrollContainer.prototype.componentDidMount = function componentDidMount() {
	    this.context.scrollBehavior.registerElement(this.props.scrollKey, _reactDom2.default.findDOMNode(this), // eslint-disable-line react/no-find-dom-node
	    this.shouldUpdateScroll);
	
	    // Only keep around the current DOM node in development, as this is only
	    // for emitting the appropriate warning.
	    if (false) {
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	    }
	  };
	
	  ScrollContainer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	     false ? (0, _warning2.default)(nextProps.scrollKey === this.props.scrollKey, "<ScrollContainer> does not support changing scrollKey.") : void 0;
	  };
	
	  ScrollContainer.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (false) {
	      var prevDomNode = this.domNode;
	      this.domNode = _reactDom2.default.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
	
	      process.env.NODE_ENV !== "production" ? (0, _warning2.default)(this.domNode === prevDomNode, "<ScrollContainer> does not support changing DOM node.") : void 0;
	    }
	  };
	
	  ScrollContainer.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.context.scrollBehavior.unregisterElement(this.scrollKey);
	  };
	
	  ScrollContainer.prototype.render = function render() {
	    return this.props.children;
	  };
	
	  return ScrollContainer;
	}(_react2.default.Component);
	
	ScrollContainer.propTypes = propTypes;
	ScrollContainer.contextTypes = contextTypes;
	
	exports.default = ScrollContainer;

/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _stringify = __webpack_require__(506);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _classCallCheck2 = __webpack_require__(250);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var STATE_KEY_PREFIX = "@@scroll|";
	var GATSBY_ROUTER_SCROLL_STATE = "___GATSBY_REACT_ROUTER_SCROLL";
	
	var SessionStorage = function () {
	  function SessionStorage() {
	    (0, _classCallCheck3.default)(this, SessionStorage);
	  }
	
	  SessionStorage.prototype.read = function read(location, key) {
	    var stateKey = this.getStateKey(location, key);
	
	    try {
	      var value = sessionStorage.getItem(stateKey);
	      return JSON.parse(value);
	    } catch (e) {
	      console.warn("[gatsby-react-router-scroll] Unable to access sessionStorage; sessionStorage is not available.");
	
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE] && window[GATSBY_ROUTER_SCROLL_STATE][stateKey]) {
	        return window[GATSBY_ROUTER_SCROLL_STATE][stateKey];
	      }
	
	      return {};
	    }
	  };
	
	  SessionStorage.prototype.save = function save(location, key, value) {
	    var stateKey = this.getStateKey(location, key);
	    var storedValue = (0, _stringify2.default)(value);
	
	    try {
	      sessionStorage.setItem(stateKey, storedValue);
	    } catch (e) {
	      if (window && window[GATSBY_ROUTER_SCROLL_STATE]) {
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      } else {
	        window[GATSBY_ROUTER_SCROLL_STATE] = {};
	        window[GATSBY_ROUTER_SCROLL_STATE][stateKey] = JSON.parse(storedValue);
	      }
	
	      console.warn("[gatsby-react-router-scroll] Unable to save state in sessionStorage; sessionStorage is not available.");
	    }
	  };
	
	  SessionStorage.prototype.getStateKey = function getStateKey(location, key) {
	    var locationKey = location.key;
	    var stateKeyBase = "" + STATE_KEY_PREFIX + locationKey;
	    return key === null || typeof key === "undefined" ? stateKeyBase : stateKeyBase + "|" + key;
	  };
	
	  return SessionStorage;
	}();
	
	exports.default = SessionStorage;

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _ScrollBehaviorContext = __webpack_require__(723);
	
	var _ScrollBehaviorContext2 = _interopRequireDefault(_ScrollBehaviorContext);
	
	var _ScrollContainer = __webpack_require__(724);
	
	var _ScrollContainer2 = _interopRequireDefault(_ScrollContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ScrollContainer = _ScrollContainer2.default;
	exports.ScrollContext = _ScrollBehaviorContext2.default;

/***/ }),
/* 727 */
/***/ (function(module, exports) {

	/*
	 Highcharts JS v6.0.3 (2017-11-14)
	
	 (c) 2009-2016 Torstein Honsi
	
	 License: www.highcharts.com/license
	*/
	(function(S,L){"object"===typeof module&&module.exports?module.exports=S.document?L(S):L:S.Highcharts=L(S)})("undefined"!==typeof window?window:this,function(S){var L=function(){var a="undefined"===typeof S?window:S,z=a.document,A=a.navigator&&a.navigator.userAgent||"",D=z&&z.createElementNS&&!!z.createElementNS("http://www.w3.org/2000/svg","svg").createSVGRect,q=/(edge|msie|trident)/i.test(A)&&!a.opera,g=/Firefox/.test(A),e=g&&4>parseInt(A.split("Firefox/")[1],10);return a.Highcharts?a.Highcharts.error(16,
	!0):{product:"Highcharts",version:"6.0.3",deg2rad:2*Math.PI/360,doc:z,hasBidiBug:e,hasTouch:z&&void 0!==z.documentElement.ontouchstart,isMS:q,isWebKit:/AppleWebKit/.test(A),isFirefox:g,isTouchDevice:/(Mobile|Android|Windows Phone)/.test(A),SVG_NS:"http://www.w3.org/2000/svg",chartCount:0,seriesTypes:{},symbolSizes:{},svg:D,win:a,marginNames:["plotTop","marginRight","marginBottom","plotLeft"],noop:function(){},charts:[]}}();(function(a){a.timers=[];var z=a.charts,A=a.doc,D=a.win;a.error=function(q,
	g){q=a.isNumber(q)?"Highcharts error #"+q+": www.highcharts.com/errors/"+q:q;if(g)throw Error(q);D.console&&console.log(q)};a.Fx=function(a,g,e){this.options=g;this.elem=a;this.prop=e};a.Fx.prototype={dSetter:function(){var a=this.paths[0],g=this.paths[1],e=[],k=this.now,t=a.length,p;if(1===k)e=this.toD;else if(t===g.length&&1>k)for(;t--;)p=parseFloat(a[t]),e[t]=isNaN(p)?g[t]:k*parseFloat(g[t]-p)+p;else e=g;this.elem.attr("d",e,null,!0)},update:function(){var a=this.elem,g=this.prop,e=this.now,k=
	this.options.step;if(this[g+"Setter"])this[g+"Setter"]();else a.attr?a.element&&a.attr(g,e,null,!0):a.style[g]=e+this.unit;k&&k.call(a,e,this)},run:function(q,g,e){var k=this,t=k.options,p=function(a){return p.stopped?!1:k.step(a)},l=D.requestAnimationFrame||function(a){setTimeout(a,13)},c=function(){a.timers=a.grep(a.timers,function(a){return a()});a.timers.length&&l(c)};q===g?(delete t.curAnim[this.prop],t.complete&&0===a.keys(t.curAnim).length&&t.complete()):(this.startTime=+new Date,this.start=
	q,this.end=g,this.unit=e,this.now=this.start,this.pos=0,p.elem=this.elem,p.prop=this.prop,p()&&1===a.timers.push(p)&&l(c))},step:function(q){var g=+new Date,e,k=this.options,t=this.elem,p=k.complete,l=k.duration,c=k.curAnim;t.attr&&!t.element?q=!1:q||g>=l+this.startTime?(this.now=this.end,this.pos=1,this.update(),e=c[this.prop]=!0,a.objectEach(c,function(a){!0!==a&&(e=!1)}),e&&p&&p.call(t),q=!1):(this.pos=k.easing((g-this.startTime)/l),this.now=this.start+(this.end-this.start)*this.pos,this.update(),
	q=!0);return q},initPath:function(q,g,e){function k(a){var b,h;for(w=a.length;w--;)b="M"===a[w]||"L"===a[w],h=/[a-zA-Z]/.test(a[w+3]),b&&h&&a.splice(w+1,0,a[w+1],a[w+2],a[w+1],a[w+2])}function t(a,h){for(;a.length<b;){a[0]=h[b-a.length];var c=a.slice(0,d);[].splice.apply(a,[0,0].concat(c));m&&(c=a.slice(a.length-d),[].splice.apply(a,[a.length,0].concat(c)),w--)}a[0]="M"}function p(a,c){for(var n=(b-a.length)/d;0<n&&n--;)h=a.slice().splice(a.length/F-d,d*F),h[0]=c[b-d-n*d],y&&(h[d-6]=h[d-2],h[d-5]=
	h[d-1]),[].splice.apply(a,[a.length/F,0].concat(h)),m&&n--}g=g||"";var l,c=q.startX,n=q.endX,y=-1<g.indexOf("C"),d=y?7:3,b,h,w;g=g.split(" ");e=e.slice();var m=q.isArea,F=m?2:1,J;y&&(k(g),k(e));if(c&&n){for(w=0;w<c.length;w++)if(c[w]===n[0]){l=w;break}else if(c[0]===n[n.length-c.length+w]){l=w;J=!0;break}void 0===l&&(g=[])}g.length&&a.isNumber(l)&&(b=e.length+l*F*d,J?(t(g,e),p(e,g)):(t(e,g),p(g,e)));return[g,e]}};a.Fx.prototype.fillSetter=a.Fx.prototype.strokeSetter=function(){this.elem.attr(this.prop,
	a.color(this.start).tweenTo(a.color(this.end),this.pos),null,!0)};a.extend=function(a,g){var e;a||(a={});for(e in g)a[e]=g[e];return a};a.merge=function(){var q,g=arguments,e,k={},t=function(e,l){"object"!==typeof e&&(e={});a.objectEach(l,function(c,n){!a.isObject(c,!0)||a.isClass(c)||a.isDOMElement(c)?e[n]=l[n]:e[n]=t(e[n]||{},c)});return e};!0===g[0]&&(k=g[1],g=Array.prototype.slice.call(g,2));e=g.length;for(q=0;q<e;q++)k=t(k,g[q]);return k};a.pInt=function(a,g){return parseInt(a,g||10)};a.isString=
	function(a){return"string"===typeof a};a.isArray=function(a){a=Object.prototype.toString.call(a);return"[object Array]"===a||"[object Array Iterator]"===a};a.isObject=function(q,g){return!!q&&"object"===typeof q&&(!g||!a.isArray(q))};a.isDOMElement=function(q){return a.isObject(q)&&"number"===typeof q.nodeType};a.isClass=function(q){var g=q&&q.constructor;return!(!a.isObject(q,!0)||a.isDOMElement(q)||!g||!g.name||"Object"===g.name)};a.isNumber=function(a){return"number"===typeof a&&!isNaN(a)};a.erase=
	function(a,g){for(var e=a.length;e--;)if(a[e]===g){a.splice(e,1);break}};a.defined=function(a){return void 0!==a&&null!==a};a.attr=function(q,g,e){var k;a.isString(g)?a.defined(e)?q.setAttribute(g,e):q&&q.getAttribute&&(k=q.getAttribute(g)):a.defined(g)&&a.isObject(g)&&a.objectEach(g,function(a,e){q.setAttribute(e,a)});return k};a.splat=function(q){return a.isArray(q)?q:[q]};a.syncTimeout=function(a,g,e){if(g)return setTimeout(a,g,e);a.call(0,e)};a.pick=function(){var a=arguments,g,e,k=a.length;for(g=
	0;g<k;g++)if(e=a[g],void 0!==e&&null!==e)return e};a.css=function(q,g){a.isMS&&!a.svg&&g&&void 0!==g.opacity&&(g.filter="alpha(opacity\x3d"+100*g.opacity+")");a.extend(q.style,g)};a.createElement=function(q,g,e,k,t){q=A.createElement(q);var p=a.css;g&&a.extend(q,g);t&&p(q,{padding:0,border:"none",margin:0});e&&p(q,e);k&&k.appendChild(q);return q};a.extendClass=function(q,g){var e=function(){};e.prototype=new q;a.extend(e.prototype,g);return e};a.pad=function(a,g,e){return Array((g||2)+1-String(a).length).join(e||
	0)+a};a.relativeLength=function(a,g,e){return/%$/.test(a)?g*parseFloat(a)/100+(e||0):parseFloat(a)};a.wrap=function(a,g,e){var k=a[g];a[g]=function(){var a=Array.prototype.slice.call(arguments),g=arguments,l=this;l.proceed=function(){k.apply(l,arguments.length?arguments:g)};a.unshift(k);a=e.apply(this,a);l.proceed=null;return a}};a.getTZOffset=function(q){var g=a.Date;return 6E4*(g.hcGetTimezoneOffset&&g.hcGetTimezoneOffset(q)||g.hcTimezoneOffset||0)};a.dateFormat=function(q,g,e){if(!a.defined(g)||
	isNaN(g))return a.defaultOptions.lang.invalidDate||"";q=a.pick(q,"%Y-%m-%d %H:%M:%S");var k=a.Date,t=new k(g-a.getTZOffset(g)),p=t[k.hcGetHours](),l=t[k.hcGetDay](),c=t[k.hcGetDate](),n=t[k.hcGetMonth](),y=t[k.hcGetFullYear](),d=a.defaultOptions.lang,b=d.weekdays,h=d.shortWeekdays,w=a.pad,k=a.extend({a:h?h[l]:b[l].substr(0,3),A:b[l],d:w(c),e:w(c,2," "),w:l,b:d.shortMonths[n],B:d.months[n],m:w(n+1),y:y.toString().substr(2,2),Y:y,H:w(p),k:p,I:w(p%12||12),l:p%12||12,M:w(t[k.hcGetMinutes]()),p:12>p?"AM":
	"PM",P:12>p?"am":"pm",S:w(t.getSeconds()),L:w(Math.round(g%1E3),3)},a.dateFormats);a.objectEach(k,function(a,b){for(;-1!==q.indexOf("%"+b);)q=q.replace("%"+b,"function"===typeof a?a(g):a)});return e?q.substr(0,1).toUpperCase()+q.substr(1):q};a.formatSingle=function(q,g){var e=/\.([0-9])/,k=a.defaultOptions.lang;/f$/.test(q)?(e=(e=q.match(e))?e[1]:-1,null!==g&&(g=a.numberFormat(g,e,k.decimalPoint,-1<q.indexOf(",")?k.thousandsSep:""))):g=a.dateFormat(q,g);return g};a.format=function(q,g){for(var e=
	"{",k=!1,t,p,l,c,n=[],y;q;){e=q.indexOf(e);if(-1===e)break;t=q.slice(0,e);if(k){t=t.split(":");p=t.shift().split(".");c=p.length;y=g;for(l=0;l<c;l++)y&&(y=y[p[l]]);t.length&&(y=a.formatSingle(t.join(":"),y));n.push(y)}else n.push(t);q=q.slice(e+1);e=(k=!k)?"}":"{"}n.push(q);return n.join("")};a.getMagnitude=function(a){return Math.pow(10,Math.floor(Math.log(a)/Math.LN10))};a.normalizeTickInterval=function(q,g,e,k,t){var p,l=q;e=a.pick(e,1);p=q/e;g||(g=t?[1,1.2,1.5,2,2.5,3,4,5,6,8,10]:[1,2,2.5,5,10],
	!1===k&&(1===e?g=a.grep(g,function(a){return 0===a%1}):.1>=e&&(g=[1/e])));for(k=0;k<g.length&&!(l=g[k],t&&l*e>=q||!t&&p<=(g[k]+(g[k+1]||g[k]))/2);k++);return l=a.correctFloat(l*e,-Math.round(Math.log(.001)/Math.LN10))};a.stableSort=function(a,g){var e=a.length,k,t;for(t=0;t<e;t++)a[t].safeI=t;a.sort(function(a,l){k=g(a,l);return 0===k?a.safeI-l.safeI:k});for(t=0;t<e;t++)delete a[t].safeI};a.arrayMin=function(a){for(var g=a.length,e=a[0];g--;)a[g]<e&&(e=a[g]);return e};a.arrayMax=function(a){for(var g=
	a.length,e=a[0];g--;)a[g]>e&&(e=a[g]);return e};a.destroyObjectProperties=function(q,g){a.objectEach(q,function(a,k){a&&a!==g&&a.destroy&&a.destroy();delete q[k]})};a.discardElement=function(q){var g=a.garbageBin;g||(g=a.createElement("div"));q&&g.appendChild(q);g.innerHTML=""};a.correctFloat=function(a,g){return parseFloat(a.toPrecision(g||14))};a.setAnimation=function(q,g){g.renderer.globalAnimation=a.pick(q,g.options.chart.animation,!0)};a.animObject=function(q){return a.isObject(q)?a.merge(q):
	{duration:q?500:0}};a.timeUnits={millisecond:1,second:1E3,minute:6E4,hour:36E5,day:864E5,week:6048E5,month:24192E5,year:314496E5};a.numberFormat=function(q,g,e,k){q=+q||0;g=+g;var t=a.defaultOptions.lang,p=(q.toString().split(".")[1]||"").split("e")[0].length,l,c,n=q.toString().split("e");-1===g?g=Math.min(p,20):a.isNumber(g)||(g=2);c=(Math.abs(n[1]?n[0]:q)+Math.pow(10,-Math.max(g,p)-1)).toFixed(g);p=String(a.pInt(c));l=3<p.length?p.length%3:0;e=a.pick(e,t.decimalPoint);k=a.pick(k,t.thousandsSep);
	q=(0>q?"-":"")+(l?p.substr(0,l)+k:"");q+=p.substr(l).replace(/(\d{3})(?=\d)/g,"$1"+k);g&&(q+=e+c.slice(-g));n[1]&&(q+="e"+n[1]);return q};Math.easeInOutSine=function(a){return-.5*(Math.cos(Math.PI*a)-1)};a.getStyle=function(q,g,e){if("width"===g)return Math.min(q.offsetWidth,q.scrollWidth)-a.getStyle(q,"padding-left")-a.getStyle(q,"padding-right");if("height"===g)return Math.min(q.offsetHeight,q.scrollHeight)-a.getStyle(q,"padding-top")-a.getStyle(q,"padding-bottom");D.getComputedStyle||a.error(27,
	!0);if(q=D.getComputedStyle(q,void 0))q=q.getPropertyValue(g),a.pick(e,"opacity"!==g)&&(q=a.pInt(q));return q};a.inArray=function(q,g){return(a.indexOfPolyfill||Array.prototype.indexOf).call(g,q)};a.grep=function(q,g){return(a.filterPolyfill||Array.prototype.filter).call(q,g)};a.find=Array.prototype.find?function(a,g){return a.find(g)}:function(a,g){var e,k=a.length;for(e=0;e<k;e++)if(g(a[e],e))return a[e]};a.map=function(a,g){for(var e=[],k=0,t=a.length;k<t;k++)e[k]=g.call(a[k],a[k],k,a);return e};
	a.keys=function(q){return(a.keysPolyfill||Object.keys).call(void 0,q)};a.reduce=function(q,g,e){return(a.reducePolyfill||Array.prototype.reduce).call(q,g,e)};a.offset=function(a){var g=A.documentElement;a=a.parentElement?a.getBoundingClientRect():{top:0,left:0};return{top:a.top+(D.pageYOffset||g.scrollTop)-(g.clientTop||0),left:a.left+(D.pageXOffset||g.scrollLeft)-(g.clientLeft||0)}};a.stop=function(q,g){for(var e=a.timers.length;e--;)a.timers[e].elem!==q||g&&g!==a.timers[e].prop||(a.timers[e].stopped=
	!0)};a.each=function(q,g,e){return(a.forEachPolyfill||Array.prototype.forEach).call(q,g,e)};a.objectEach=function(a,g,e){for(var k in a)a.hasOwnProperty(k)&&g.call(e,a[k],k,a)};a.addEvent=function(q,g,e){var k,t,p=q.addEventListener||a.addEventListenerPolyfill;q.hcEvents&&!q.hasOwnProperty("hcEvents")&&(t={},a.objectEach(q.hcEvents,function(a,c){t[c]=a.slice(0)}),q.hcEvents=t);k=q.hcEvents=q.hcEvents||{};p&&p.call(q,g,e,!1);k[g]||(k[g]=[]);k[g].push(e);return function(){a.removeEvent(q,g,e)}};a.removeEvent=
	function(q,g,e){function k(c,l){var d=q.removeEventListener||a.removeEventListenerPolyfill;d&&d.call(q,c,l,!1)}function t(){var c,e;q.nodeName&&(g?(c={},c[g]=!0):c=l,a.objectEach(c,function(a,b){if(l[b])for(e=l[b].length;e--;)k(b,l[b][e])}))}var p,l=q.hcEvents,c;l&&(g?(p=l[g]||[],e?(c=a.inArray(e,p),-1<c&&(p.splice(c,1),l[g]=p),k(g,e)):(t(),l[g]=[])):(t(),q.hcEvents={}))};a.fireEvent=function(q,g,e,k){var t;t=q.hcEvents;var p,l;e=e||{};if(A.createEvent&&(q.dispatchEvent||q.fireEvent))t=A.createEvent("Events"),
	t.initEvent(g,!0,!0),a.extend(t,e),q.dispatchEvent?q.dispatchEvent(t):q.fireEvent(g,t);else if(t)for(t=t[g]||[],p=t.length,e.target||a.extend(e,{preventDefault:function(){e.defaultPrevented=!0},target:q,type:g}),g=0;g<p;g++)(l=t[g])&&!1===l.call(q,e)&&e.preventDefault();k&&!e.defaultPrevented&&k(e)};a.animate=function(q,g,e){var k,t="",p,l,c;a.isObject(e)||(c=arguments,e={duration:c[2],easing:c[3],complete:c[4]});a.isNumber(e.duration)||(e.duration=400);e.easing="function"===typeof e.easing?e.easing:
	Math[e.easing]||Math.easeInOutSine;e.curAnim=a.merge(g);a.objectEach(g,function(c,y){a.stop(q,y);l=new a.Fx(q,e,y);p=null;"d"===y?(l.paths=l.initPath(q,q.d,g.d),l.toD=g.d,k=0,p=1):q.attr?k=q.attr(y):(k=parseFloat(a.getStyle(q,y))||0,"opacity"!==y&&(t="px"));p||(p=c);p&&p.match&&p.match("px")&&(p=p.replace(/px/g,""));l.run(k,p,t)})};a.seriesType=function(q,g,e,k,t){var p=a.getOptions(),l=a.seriesTypes;p.plotOptions[q]=a.merge(p.plotOptions[g],e);l[q]=a.extendClass(l[g]||function(){},k);l[q].prototype.type=
	q;t&&(l[q].prototype.pointClass=a.extendClass(a.Point,t));return l[q]};a.uniqueKey=function(){var a=Math.random().toString(36).substring(2,9),g=0;return function(){return"highcharts-"+a+"-"+g++}}();D.jQuery&&(D.jQuery.fn.highcharts=function(){var q=[].slice.call(arguments);if(this[0])return q[0]?(new (a[a.isString(q[0])?q.shift():"Chart"])(this[0],q[0],q[1]),this):z[a.attr(this[0],"data-highcharts-chart")]})})(L);(function(a){var z=a.each,A=a.isNumber,D=a.map,q=a.merge,g=a.pInt;a.Color=function(e){if(!(this instanceof
	a.Color))return new a.Color(e);this.init(e)};a.Color.prototype={parsers:[{regex:/rgba\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]?(?:\.[0-9]+)?)\s*\)/,parse:function(a){return[g(a[1]),g(a[2]),g(a[3]),parseFloat(a[4],10)]}},{regex:/rgb\(\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*,\s*([0-9]{1,3})\s*\)/,parse:function(a){return[g(a[1]),g(a[2]),g(a[3]),1]}}],names:{none:"rgba(255,255,255,0)",white:"#ffffff",black:"#000000"},init:function(e){var k,g,p,l;if((this.input=e=this.names[e&&
	e.toLowerCase?e.toLowerCase():""]||e)&&e.stops)this.stops=D(e.stops,function(c){return new a.Color(c[1])});else if(e&&e.charAt&&"#"===e.charAt()&&(k=e.length,e=parseInt(e.substr(1),16),7===k?g=[(e&16711680)>>16,(e&65280)>>8,e&255,1]:4===k&&(g=[(e&3840)>>4|(e&3840)>>8,(e&240)>>4|e&240,(e&15)<<4|e&15,1])),!g)for(p=this.parsers.length;p--&&!g;)l=this.parsers[p],(k=l.regex.exec(e))&&(g=l.parse(k));this.rgba=g||[]},get:function(a){var e=this.input,g=this.rgba,p;this.stops?(p=q(e),p.stops=[].concat(p.stops),
	z(this.stops,function(l,c){p.stops[c]=[p.stops[c][0],l.get(a)]})):p=g&&A(g[0])?"rgb"===a||!a&&1===g[3]?"rgb("+g[0]+","+g[1]+","+g[2]+")":"a"===a?g[3]:"rgba("+g.join(",")+")":e;return p},brighten:function(a){var e,t=this.rgba;if(this.stops)z(this.stops,function(e){e.brighten(a)});else if(A(a)&&0!==a)for(e=0;3>e;e++)t[e]+=g(255*a),0>t[e]&&(t[e]=0),255<t[e]&&(t[e]=255);return this},setOpacity:function(a){this.rgba[3]=a;return this},tweenTo:function(a,k){var e=this.rgba,g=a.rgba;g.length&&e&&e.length?
	(a=1!==g[3]||1!==e[3],k=(a?"rgba(":"rgb(")+Math.round(g[0]+(e[0]-g[0])*(1-k))+","+Math.round(g[1]+(e[1]-g[1])*(1-k))+","+Math.round(g[2]+(e[2]-g[2])*(1-k))+(a?","+(g[3]+(e[3]-g[3])*(1-k)):"")+")"):k=a.input||"none";return k}};a.color=function(e){return new a.Color(e)}})(L);(function(a){var z,A,D=a.addEvent,q=a.animate,g=a.attr,e=a.charts,k=a.color,t=a.css,p=a.createElement,l=a.defined,c=a.deg2rad,n=a.destroyObjectProperties,y=a.doc,d=a.each,b=a.extend,h=a.erase,w=a.grep,m=a.hasTouch,F=a.inArray,J=
	a.isArray,C=a.isFirefox,H=a.isMS,u=a.isObject,G=a.isString,v=a.isWebKit,E=a.merge,x=a.noop,I=a.objectEach,f=a.pick,r=a.pInt,N=a.removeEvent,K=a.splat,B=a.stop,P=a.svg,R=a.SVG_NS,Q=a.symbolSizes,O=a.win;z=a.SVGElement=function(){return this};b(z.prototype,{opacity:1,SVG_NS:R,textProps:"direction fontSize fontWeight fontFamily fontStyle color lineHeight width textAlign textDecoration textOverflow textOutline".split(" "),init:function(a,f){this.element="span"===f?p(f):y.createElementNS(this.SVG_NS,f);
	this.renderer=a},animate:function(b,r,h){r=a.animObject(f(r,this.renderer.globalAnimation,!0));0!==r.duration?(h&&(r.complete=h),q(this,b,r)):(this.attr(b,null,h),r.step&&r.step.call(this));return this},colorGradient:function(f,b,r){var M=this.renderer,h,B,m,c,x,v,w,n,T,K,e=[],u;f.radialGradient?B="radialGradient":f.linearGradient&&(B="linearGradient");B&&(m=f[B],x=M.gradients,w=f.stops,K=r.radialReference,J(m)&&(f[B]=m={x1:m[0],y1:m[1],x2:m[2],y2:m[3],gradientUnits:"userSpaceOnUse"}),"radialGradient"===
	B&&K&&!l(m.gradientUnits)&&(c=m,m=E(m,M.getRadialAttr(K,c),{gradientUnits:"userSpaceOnUse"})),I(m,function(a,f){"id"!==f&&e.push(f,a)}),I(w,function(a){e.push(a)}),e=e.join(","),x[e]?K=x[e].attr("id"):(m.id=K=a.uniqueKey(),x[e]=v=M.createElement(B).attr(m).add(M.defs),v.radAttr=c,v.stops=[],d(w,function(f){0===f[1].indexOf("rgba")?(h=a.color(f[1]),n=h.get("rgb"),T=h.get("a")):(n=f[1],T=1);f=M.createElement("stop").attr({offset:f[0],"stop-color":n,"stop-opacity":T}).add(v);v.stops.push(f)})),u="url("+
	M.url+"#"+K+")",r.setAttribute(b,u),r.gradient=e,f.toString=function(){return u})},applyTextOutline:function(f){var b=this.element,r,M,B,m,c;-1!==f.indexOf("contrast")&&(f=f.replace(/contrast/g,this.renderer.getContrast(b.style.fill)));f=f.split(" ");M=f[f.length-1];if((B=f[0])&&"none"!==B&&a.svg){this.fakeTS=!0;f=[].slice.call(b.getElementsByTagName("tspan"));this.ySetter=this.xSetter;B=B.replace(/(^[\d\.]+)(.*?)$/g,function(a,f,b){return 2*f+b});for(c=f.length;c--;)r=f[c],"highcharts-text-outline"===
	r.getAttribute("class")&&h(f,b.removeChild(r));m=b.firstChild;d(f,function(a,f){0===f&&(a.setAttribute("x",b.getAttribute("x")),f=b.getAttribute("y"),a.setAttribute("y",f||0),null===f&&b.setAttribute("y",0));a=a.cloneNode(1);g(a,{"class":"highcharts-text-outline",fill:M,stroke:M,"stroke-width":B,"stroke-linejoin":"round"});b.insertBefore(a,m)})}},attr:function(a,f,b,r){var h,M=this.element,d,m=this,c,x;"string"===typeof a&&void 0!==f&&(h=a,a={},a[h]=f);"string"===typeof a?m=(this[a+"Getter"]||this._defaultGetter).call(this,
	a,M):(I(a,function(f,b){c=!1;r||B(this,b);this.symbolName&&/^(x|y|width|height|r|start|end|innerR|anchorX|anchorY)$/.test(b)&&(d||(this.symbolAttr(a),d=!0),c=!0);!this.rotation||"x"!==b&&"y"!==b||(this.doTransform=!0);c||(x=this[b+"Setter"]||this._defaultSetter,x.call(this,f,b,M))},this),this.afterSetters());b&&b();return m},afterSetters:function(){this.doTransform&&(this.updateTransform(),this.doTransform=!1)},addClass:function(a,f){var b=this.attr("class")||"";-1===b.indexOf(a)&&(f||(a=(b+(b?" ":
	"")+a).replace("  "," ")),this.attr("class",a));return this},hasClass:function(a){return-1!==F(a,(this.attr("class")||"").split(" "))},removeClass:function(a){return this.attr("class",(this.attr("class")||"").replace(a,""))},symbolAttr:function(a){var b=this;d("x y r start end width height innerR anchorX anchorY".split(" "),function(r){b[r]=f(a[r],b[r])});b.attr({d:b.renderer.symbols[b.symbolName](b.x,b.y,b.width,b.height,b)})},clip:function(a){return this.attr("clip-path",a?"url("+this.renderer.url+
	"#"+a.id+")":"none")},crisp:function(a,f){var b=this,r={},h;f=f||a.strokeWidth||0;h=Math.round(f)%2/2;a.x=Math.floor(a.x||b.x||0)+h;a.y=Math.floor(a.y||b.y||0)+h;a.width=Math.floor((a.width||b.width||0)-2*h);a.height=Math.floor((a.height||b.height||0)-2*h);l(a.strokeWidth)&&(a.strokeWidth=f);I(a,function(a,f){b[f]!==a&&(b[f]=r[f]=a)});return r},css:function(a){var f=this.styles,h={},M=this.element,d,B="",m,c=!f,x=["textOutline","textOverflow","width"];a&&a.color&&(a.fill=a.color);f&&I(a,function(a,
	b){a!==f[b]&&(h[b]=a,c=!0)});c&&(f&&(a=b(f,h)),d=this.textWidth=a&&a.width&&"auto"!==a.width&&"text"===M.nodeName.toLowerCase()&&r(a.width),this.styles=a,d&&!P&&this.renderer.forExport&&delete a.width,H&&!P?t(this.element,a):(m=function(a,f){return"-"+f.toLowerCase()},I(a,function(a,f){-1===F(f,x)&&(B+=f.replace(/([A-Z])/g,m)+":"+a+";")}),B&&g(M,"style",B)),this.added&&("text"===this.element.nodeName&&this.renderer.buildText(this),a&&a.textOutline&&this.applyTextOutline(a.textOutline)));return this},
	getStyle:function(a){return O.getComputedStyle(this.element||this,"").getPropertyValue(a)},strokeWidth:function(){var a=this.getStyle("stroke-width"),f;a.indexOf("px")===a.length-2?a=r(a):(f=y.createElementNS(R,"rect"),g(f,{width:a,"stroke-width":0}),this.element.parentNode.appendChild(f),a=f.getBBox().width,f.parentNode.removeChild(f));return a},on:function(a,f){var b=this,r=b.element;m&&"click"===a?(r.ontouchstart=function(a){b.touchEventFired=Date.now();a.preventDefault();f.call(r,a)},r.onclick=
	function(a){(-1===O.navigator.userAgent.indexOf("Android")||1100<Date.now()-(b.touchEventFired||0))&&f.call(r,a)}):r["on"+a]=f;return this},setRadialReference:function(a){var f=this.renderer.gradients[this.element.gradient];this.element.radialReference=a;f&&f.radAttr&&f.animate(this.renderer.getRadialAttr(a,f.radAttr));return this},translate:function(a,f){return this.attr({translateX:a,translateY:f})},invert:function(a){this.inverted=a;this.updateTransform();return this},updateTransform:function(){var a=
	this.translateX||0,b=this.translateY||0,r=this.scaleX,h=this.scaleY,d=this.inverted,B=this.rotation,m=this.matrix,c=this.element;d&&(a+=this.width,b+=this.height);a=["translate("+a+","+b+")"];l(m)&&a.push("matrix("+m.join(",")+")");d?a.push("rotate(90) scale(-1,1)"):B&&a.push("rotate("+B+" "+f(this.rotationOriginX,c.getAttribute("x"),0)+" "+f(this.rotationOriginY,c.getAttribute("y")||0)+")");(l(r)||l(h))&&a.push("scale("+f(r,1)+" "+f(h,1)+")");a.length&&c.setAttribute("transform",a.join(" "))},toFront:function(){var a=
	this.element;a.parentNode.appendChild(a);return this},align:function(a,b,r){var d,B,M,m,c={};B=this.renderer;M=B.alignedObjects;var x,v;if(a){if(this.alignOptions=a,this.alignByTranslate=b,!r||G(r))this.alignTo=d=r||"renderer",h(M,this),M.push(this),r=null}else a=this.alignOptions,b=this.alignByTranslate,d=this.alignTo;r=f(r,B[d],B);d=a.align;B=a.verticalAlign;M=(r.x||0)+(a.x||0);m=(r.y||0)+(a.y||0);"right"===d?x=1:"center"===d&&(x=2);x&&(M+=(r.width-(a.width||0))/x);c[b?"translateX":"x"]=Math.round(M);
	"bottom"===B?v=1:"middle"===B&&(v=2);v&&(m+=(r.height-(a.height||0))/v);c[b?"translateY":"y"]=Math.round(m);this[this.placed?"animate":"attr"](c);this.placed=!0;this.alignAttr=c;return this},getBBox:function(a,r){var h,B=this.renderer,M,m=this.element,x=this.styles,v,w=this.textStr,n,K=B.cache,e=B.cacheKeys,u;r=f(r,this.rotation);M=r*c;v=m&&z.prototype.getStyle.call(m,"font-size");l(w)&&(u=w.toString(),-1===u.indexOf("\x3c")&&(u=u.replace(/[0-9]/g,"0")),u+=["",r||0,v,x&&x.width,x&&x.textOverflow].join());
	u&&!a&&(h=K[u]);if(!h){if(m.namespaceURI===this.SVG_NS||B.forExport){try{(n=this.fakeTS&&function(a){d(m.querySelectorAll(".highcharts-text-outline"),function(f){f.style.display=a})})&&n("none"),h=m.getBBox?b({},m.getBBox()):{width:m.offsetWidth,height:m.offsetHeight},n&&n("")}catch(V){}if(!h||0>h.width)h={width:0,height:0}}else h=this.htmlGetBBox();B.isSVG&&(a=h.width,B=h.height,x&&"11px"===x.fontSize&&17===Math.round(B)&&(h.height=B=14),r&&(h.width=Math.abs(B*Math.sin(M))+Math.abs(a*Math.cos(M)),
	h.height=Math.abs(B*Math.cos(M))+Math.abs(a*Math.sin(M))));if(u&&0<h.height){for(;250<e.length;)delete K[e.shift()];K[u]||e.push(u);K[u]=h}}return h},show:function(a){return this.attr({visibility:a?"inherit":"visible"})},hide:function(){return this.attr({visibility:"hidden"})},fadeOut:function(a){var f=this;f.animate({opacity:0},{duration:a||150,complete:function(){f.attr({y:-9999})}})},add:function(a){var f=this.renderer,b=this.element,r;a&&(this.parentGroup=a);this.parentInverted=a&&a.inverted;
	void 0!==this.textStr&&f.buildText(this);this.added=!0;if(!a||a.handleZ||this.zIndex)r=this.zIndexSetter();r||(a?a.element:f.box).appendChild(b);if(this.onAdd)this.onAdd();return this},safeRemoveChild:function(a){var f=a.parentNode;f&&f.removeChild(a)},destroy:function(){var a=this,f=a.element||{},b=a.renderer.isSVG&&"SPAN"===f.nodeName&&a.parentGroup,r=f.ownerSVGElement;f.onclick=f.onmouseout=f.onmouseover=f.onmousemove=f.point=null;B(a);a.clipPath&&r&&(d(r.querySelectorAll("[clip-path],[CLIP-PATH]"),
	function(f){f.getAttribute("clip-path").match(RegExp('[("]#'+a.clipPath.element.id+'[)"]'))&&f.removeAttribute("clip-path")}),a.clipPath=a.clipPath.destroy());if(a.stops){for(r=0;r<a.stops.length;r++)a.stops[r]=a.stops[r].destroy();a.stops=null}for(a.safeRemoveChild(f);b&&b.div&&0===b.div.childNodes.length;)f=b.parentGroup,a.safeRemoveChild(b.div),delete b.div,b=f;a.alignTo&&h(a.renderer.alignedObjects,a);I(a,function(f,b){delete a[b]});return null},xGetter:function(a){"circle"===this.element.nodeName&&
	("x"===a?a="cx":"y"===a&&(a="cy"));return this._defaultGetter(a)},_defaultGetter:function(a){a=f(this[a],this.element?this.element.getAttribute(a):null,0);/^[\-0-9\.]+$/.test(a)&&(a=parseFloat(a));return a},dSetter:function(a,f,b){a&&a.join&&(a=a.join(" "));/(NaN| {2}|^$)/.test(a)&&(a="M 0 0");this[f]!==a&&(b.setAttribute(f,a),this[f]=a)},alignSetter:function(a){this.element.setAttribute("text-anchor",{left:"start",center:"middle",right:"end"}[a])},opacitySetter:function(a,f,b){this[f]=a;b.setAttribute(f,
	a)},titleSetter:function(a){var b=this.element.getElementsByTagName("title")[0];b||(b=y.createElementNS(this.SVG_NS,"title"),this.element.appendChild(b));b.firstChild&&b.removeChild(b.firstChild);b.appendChild(y.createTextNode(String(f(a),"").replace(/<[^>]*>/g,"")))},textSetter:function(a){a!==this.textStr&&(delete this.bBox,this.textStr=a,this.added&&this.renderer.buildText(this))},fillSetter:function(a,f,b){"string"===typeof a?b.setAttribute(f,a):a&&this.colorGradient(a,f,b)},visibilitySetter:function(a,
	f,b){"inherit"===a?b.removeAttribute(f):this[f]!==a&&b.setAttribute(f,a);this[f]=a},zIndexSetter:function(a,f){var b=this.renderer,h=this.parentGroup,d=(h||b).element||b.box,B,m=this.element,c,x,b=d===b.box;B=this.added;var v;l(a)&&(m.zIndex=a,a=+a,this[f]===a&&(B=!1),this[f]=a);if(B){(a=this.zIndex)&&h&&(h.handleZ=!0);f=d.childNodes;for(v=f.length-1;0<=v&&!c;v--)if(h=f[v],B=h.zIndex,x=!l(B),h!==m)if(0>a&&x&&!b&&!v)d.insertBefore(m,f[v]),c=!0;else if(r(B)<=a||x&&(!l(a)||0<=a))d.insertBefore(m,f[v+
	1]||null),c=!0;c||(d.insertBefore(m,f[b?3:0]||null),c=!0)}return c},_defaultSetter:function(a,f,b){b.setAttribute(f,a)}});z.prototype.yGetter=z.prototype.xGetter;z.prototype.translateXSetter=z.prototype.translateYSetter=z.prototype.rotationSetter=z.prototype.verticalAlignSetter=z.prototype.rotationOriginXSetter=z.prototype.rotationOriginYSetter=z.prototype.scaleXSetter=z.prototype.scaleYSetter=z.prototype.matrixSetter=function(a,f){this[f]=a;this.doTransform=!0};A=a.SVGRenderer=function(){this.init.apply(this,
	arguments)};b(A.prototype,{Element:z,SVG_NS:R,init:function(a,f,b,r,h,d){var B;r=this.createElement("svg").attr({version:"1.1","class":"highcharts-root"});B=r.element;a.appendChild(B);g(a,"dir","ltr");-1===a.innerHTML.indexOf("xmlns")&&g(B,"xmlns",this.SVG_NS);this.isSVG=!0;this.box=B;this.boxWrapper=r;this.alignedObjects=[];this.url=(C||v)&&y.getElementsByTagName("base").length?O.location.href.replace(/#.*?$/,"").replace(/<[^>]*>/g,"").replace(/([\('\)])/g,"\\$1").replace(/ /g,"%20"):"";this.createElement("desc").add().element.appendChild(y.createTextNode("Created with Highcharts 6.0.3"));
	this.defs=this.createElement("defs").add();this.allowHTML=d;this.forExport=h;this.gradients={};this.cache={};this.cacheKeys=[];this.imgCount=0;this.setSize(f,b,!1);var m;C&&a.getBoundingClientRect&&(f=function(){t(a,{left:0,top:0});m=a.getBoundingClientRect();t(a,{left:Math.ceil(m.left)-m.left+"px",top:Math.ceil(m.top)-m.top+"px"})},f(),this.unSubPixelFix=D(O,"resize",f))},definition:function(a){function f(a,r){var h;d(K(a),function(a){var d=b.createElement(a.tagName),B={};I(a,function(a,f){"tagName"!==
	f&&"children"!==f&&"textContent"!==f&&(B[f]=a)});d.attr(B);d.add(r||b.defs);a.textContent&&d.element.appendChild(y.createTextNode(a.textContent));f(a.children||[],d);h=d});return h}var b=this;return f(a)},isHidden:function(){return!this.boxWrapper.getBBox().width},destroy:function(){var a=this.defs;this.box=null;this.boxWrapper=this.boxWrapper.destroy();n(this.gradients||{});this.gradients=null;a&&(this.defs=a.destroy());this.unSubPixelFix&&this.unSubPixelFix();return this.alignedObjects=null},createElement:function(a){var f=
	new this.Element;f.init(this,a);return f},draw:x,getRadialAttr:function(a,f){return{cx:a[0]-a[2]/2+f.cx*a[2],cy:a[1]-a[2]/2+f.cy*a[2],r:f.r*a[2]}},getSpanWidth:function(a,f){var b=a.getBBox(!0).width;!P&&this.forExport&&(b=this.measureSpanWidth(f.firstChild.data,a.styles));return b},applyEllipsis:function(a,f,b,r){var h=a.rotation,d=b,B,m=0,c=b.length,x=function(a){f.removeChild(f.firstChild);a&&f.appendChild(y.createTextNode(a))},v;a.rotation=0;d=this.getSpanWidth(a,f);if(v=d>r){for(;m<=c;)B=Math.ceil((m+
	c)/2),d=b.substring(0,B)+"\u2026",x(d),d=this.getSpanWidth(a,f),m===c?m=c+1:d>r?c=B-1:m=B;0===c&&x("")}a.rotation=h;return v},escapes:{"\x26":"\x26amp;","\x3c":"\x26lt;","\x3e":"\x26gt;","'":"\x26#39;",'"':"\x26quot"},buildText:function(a){var b=a.element,h=this,B=h.forExport,m=f(a.textStr,"").toString(),c=-1!==m.indexOf("\x3c"),x=b.childNodes,v,n,l,K,u=g(b,"x"),e=a.styles,E=a.textWidth,k=e&&e.lineHeight,N=e&&e.textOutline,M=e&&"ellipsis"===e.textOverflow,C=e&&"nowrap"===e.whiteSpace,H,F=x.length,
	p=E&&!a.added&&this.box,Q=function(a){return k?r(k):h.fontMetrics(void 0,a.getAttribute("style")?a:b).h},q=function(a){I(h.escapes,function(f,b){a=a.replace(new RegExp(f,"g"),b)});return a},e=[m,M,C,k,N,e&&e.fontSize,E].join();if(e!==a.textCache){for(a.textCache=e;F--;)b.removeChild(x[F]);c||N||M||E||-1!==m.indexOf(" ")?(v=/<.*class="([^"]+)".*>/,n=/<.*style="([^"]+)".*>/,l=/<.*href="([^"]+)".*>/,p&&p.appendChild(b),m=c?m.replace(/<(b|strong)>/g,'\x3cspan class\x3d"highcharts-strong"\x3e').replace(/<(i|em)>/g,
	'\x3cspan class\x3d"highcharts-emphasized"\x3e').replace(/<a/g,"\x3cspan").replace(/<\/(b|strong|i|em|a)>/g,"\x3c/span\x3e").split(/<br.*?>/g):[m],m=w(m,function(a){return""!==a}),d(m,function(f,r){var m,c=0;f=f.replace(/^\s+|\s+$/g,"").replace(/<span/g,"|||\x3cspan").replace(/<\/span>/g,"\x3c/span\x3e|||");m=f.split("|||");d(m,function(f){if(""!==f||1===m.length){var d={},x=y.createElementNS(h.SVG_NS,"tspan"),w,e;v.test(f)&&(w=f.match(v)[1],g(x,"class",w));n.test(f)&&(e=f.match(n)[1].replace(/(;| |^)color([ :])/,
	"$1fill$2"),g(x,"style",e));l.test(f)&&!B&&(g(x,"onclick",'location.href\x3d"'+f.match(l)[1]+'"'),g(x,"class","highcharts-anchor"));f=q(f.replace(/<[a-zA-Z\/](.|\n)*?>/g,"")||" ");if(" "!==f){x.appendChild(y.createTextNode(f));c?d.dx=0:r&&null!==u&&(d.x=u);g(x,d);b.appendChild(x);!c&&H&&(!P&&B&&t(x,{display:"block"}),g(x,"dy",Q(x)));if(E){d=f.replace(/([^\^])-/g,"$1- ").split(" ");w=1<m.length||r||1<d.length&&!C;var k=[],N,F=Q(x),p=a.rotation;for(M&&(K=h.applyEllipsis(a,x,f,E));!M&&w&&(d.length||
	k.length);)a.rotation=0,N=h.getSpanWidth(a,x),f=N>E,void 0===K&&(K=f),f&&1!==d.length?(x.removeChild(x.firstChild),k.unshift(d.pop())):(d=k,k=[],d.length&&!C&&(x=y.createElementNS(R,"tspan"),g(x,{dy:F,x:u}),e&&g(x,"style",e),b.appendChild(x)),N>E&&(E=N)),d.length&&x.appendChild(y.createTextNode(d.join(" ").replace(/- /g,"-")));a.rotation=p}c++}}});H=H||b.childNodes.length}),K&&a.attr("title",a.textStr),p&&p.removeChild(b),N&&a.applyTextOutline&&a.applyTextOutline(N)):b.appendChild(y.createTextNode(q(m)))}},
	getContrast:function(a){a=k(a).rgba;return 510<a[0]+a[1]+a[2]?"#000000":"#FFFFFF"},button:function(a,f,b,r,h,d,B,m,x){var c=this.label(a,f,b,x,null,null,null,null,"button"),v=0;c.attr(E({padding:8,r:2},h));D(c.element,H?"mouseover":"mouseenter",function(){3!==v&&c.setState(1)});D(c.element,H?"mouseout":"mouseleave",function(){3!==v&&c.setState(v)});c.setState=function(a){1!==a&&(c.state=v=a);c.removeClass(/highcharts-button-(normal|hover|pressed|disabled)/).addClass("highcharts-button-"+["normal",
	"hover","pressed","disabled"][a||0])};return c.on("click",function(a){3!==v&&r.call(c,a)})},crispLine:function(a,f){a[1]===a[4]&&(a[1]=a[4]=Math.round(a[1])-f%2/2);a[2]===a[5]&&(a[2]=a[5]=Math.round(a[2])+f%2/2);return a},path:function(a){var f={};J(a)?f.d=a:u(a)&&b(f,a);return this.createElement("path").attr(f)},circle:function(a,f,b){a=u(a)?a:{x:a,y:f,r:b};f=this.createElement("circle");f.xSetter=f.ySetter=function(a,f,b){b.setAttribute("c"+f,a)};return f.attr(a)},arc:function(a,f,b,r,h,d){u(a)?
	(r=a,f=r.y,b=r.r,a=r.x):r={innerR:r,start:h,end:d};a=this.symbol("arc",a,f,b,b,r);a.r=b;return a},rect:function(a,f,b,r,h,d){h=u(a)?a.r:h;d=this.createElement("rect");a=u(a)?a:void 0===a?{}:{x:a,y:f,width:Math.max(b,0),height:Math.max(r,0)};h&&(a.r=h);d.rSetter=function(a,f,b){g(b,{rx:a,ry:a})};return d.attr(a)},setSize:function(a,b,r){var h=this.alignedObjects,d=h.length;this.width=a;this.height=b;for(this.boxWrapper.animate({width:a,height:b},{step:function(){this.attr({viewBox:"0 0 "+this.attr("width")+
	" "+this.attr("height")})},duration:f(r,!0)?void 0:0});d--;)h[d].align()},g:function(a){var f=this.createElement("g");return a?f.attr({"class":"highcharts-"+a}):f},image:function(a,f,r,h,d){var B={preserveAspectRatio:"none"};1<arguments.length&&b(B,{x:f,y:r,width:h,height:d});B=this.createElement("image").attr(B);B.element.setAttributeNS?B.element.setAttributeNS("http://www.w3.org/1999/xlink","href",a):B.element.setAttribute("hc-svg-href",a);return B},symbol:function(a,r,h,B,m,c){var x=this,v,w=/^url\((.*?)\)$/,
	n=w.test(a),K=!n&&(this.symbols[a]?a:"circle"),u=K&&this.symbols[K],E=l(r)&&u&&u.call(this.symbols,Math.round(r),Math.round(h),B,m,c),k,N;u?(v=this.path(E),b(v,{symbolName:K,x:r,y:h,width:B,height:m}),c&&b(v,c)):n&&(k=a.match(w)[1],v=this.image(k),v.imgwidth=f(Q[k]&&Q[k].width,c&&c.width),v.imgheight=f(Q[k]&&Q[k].height,c&&c.height),N=function(){v.attr({width:v.width,height:v.height})},d(["width","height"],function(a){v[a+"Setter"]=function(a,f){var b={},r=this["img"+f],h="width"===f?"translateX":
	"translateY";this[f]=a;l(r)&&(this.element&&this.element.setAttribute(f,r),this.alignByTranslate||(b[h]=((this[f]||0)-r)/2,this.attr(b)))}}),l(r)&&v.attr({x:r,y:h}),v.isImg=!0,l(v.imgwidth)&&l(v.imgheight)?N():(v.attr({width:0,height:0}),p("img",{onload:function(){var a=e[x.chartIndex];0===this.width&&(t(this,{position:"absolute",top:"-999em"}),y.body.appendChild(this));Q[k]={width:this.width,height:this.height};v.imgwidth=this.width;v.imgheight=this.height;v.element&&N();this.parentNode&&this.parentNode.removeChild(this);
	x.imgCount--;if(!x.imgCount&&a&&a.onload)a.onload()},src:k}),this.imgCount++));return v},symbols:{circle:function(a,f,b,r){return this.arc(a+b/2,f+r/2,b/2,r/2,{start:0,end:2*Math.PI,open:!1})},square:function(a,f,b,r){return["M",a,f,"L",a+b,f,a+b,f+r,a,f+r,"Z"]},triangle:function(a,f,b,r){return["M",a+b/2,f,"L",a+b,f+r,a,f+r,"Z"]},"triangle-down":function(a,f,b,r){return["M",a,f,"L",a+b,f,a+b/2,f+r,"Z"]},diamond:function(a,f,b,r){return["M",a+b/2,f,"L",a+b,f+r/2,a+b/2,f+r,a,f+r/2,"Z"]},arc:function(a,
	b,r,h,d){var B=d.start,m=d.r||r,c=d.r||h||r,x=d.end-.001;r=d.innerR;h=f(d.open,.001>Math.abs(d.end-d.start-2*Math.PI));var v=Math.cos(B),w=Math.sin(B),n=Math.cos(x),x=Math.sin(x);d=.001>d.end-B-Math.PI?0:1;m=["M",a+m*v,b+c*w,"A",m,c,0,d,1,a+m*n,b+c*x];l(r)&&m.push(h?"M":"L",a+r*n,b+r*x,"A",r,r,0,d,0,a+r*v,b+r*w);m.push(h?"":"Z");return m},callout:function(a,f,b,r,h){var d=Math.min(h&&h.r||0,b,r),B=d+6,m=h&&h.anchorX;h=h&&h.anchorY;var c;c=["M",a+d,f,"L",a+b-d,f,"C",a+b,f,a+b,f,a+b,f+d,"L",a+b,f+r-
	d,"C",a+b,f+r,a+b,f+r,a+b-d,f+r,"L",a+d,f+r,"C",a,f+r,a,f+r,a,f+r-d,"L",a,f+d,"C",a,f,a,f,a+d,f];m&&m>b?h>f+B&&h<f+r-B?c.splice(13,3,"L",a+b,h-6,a+b+6,h,a+b,h+6,a+b,f+r-d):c.splice(13,3,"L",a+b,r/2,m,h,a+b,r/2,a+b,f+r-d):m&&0>m?h>f+B&&h<f+r-B?c.splice(33,3,"L",a,h+6,a-6,h,a,h-6,a,f+d):c.splice(33,3,"L",a,r/2,m,h,a,r/2,a,f+d):h&&h>r&&m>a+B&&m<a+b-B?c.splice(23,3,"L",m+6,f+r,m,f+r+6,m-6,f+r,a+d,f+r):h&&0>h&&m>a+B&&m<a+b-B&&c.splice(3,3,"L",m-6,f,m,f-6,m+6,f,b-d,f);return c}},clipRect:function(f,b,r,
	h){var d=a.uniqueKey(),B=this.createElement("clipPath").attr({id:d}).add(this.defs);f=this.rect(f,b,r,h,0).add(B);f.id=d;f.clipPath=B;f.count=0;return f},text:function(a,f,b,r){var h={};if(r&&(this.allowHTML||!this.forExport))return this.html(a,f,b);h.x=Math.round(f||0);b&&(h.y=Math.round(b));if(a||0===a)h.text=a;a=this.createElement("text").attr(h);r||(a.xSetter=function(a,f,b){var r=b.getElementsByTagName("tspan"),h,d=b.getAttribute(f),B;for(B=0;B<r.length;B++)h=r[B],h.getAttribute(f)===d&&h.setAttribute(f,
	a);b.setAttribute(f,a)});return a},fontMetrics:function(a,f){a=f&&z.prototype.getStyle.call(f,"font-size");a=/px/.test(a)?r(a):/em/.test(a)?parseFloat(a)*(f?this.fontMetrics(null,f.parentNode).f:16):12;f=24>a?a+3:Math.round(1.2*a);return{h:f,b:Math.round(.8*f),f:a}},rotCorr:function(a,f,b){var r=a;f&&b&&(r=Math.max(r*Math.cos(f*c),4));return{x:-a/3*Math.sin(f*c),y:r}},label:function(f,r,h,B,m,c,x,v,w){var n=this,e=n.g("button"!==w&&"label"),K=e.text=n.text("",0,0,x).attr({zIndex:1}),u,k,P=0,g=3,C=
	0,y,F,H,p,t,R={},Q,q=/^url\((.*?)\)$/.test(B),I=q,G,J,M,O;w&&e.addClass("highcharts-"+w);I=!0;G=function(){return u.strokeWidth()%2/2};J=function(){var a=K.element.style,f={};k=(void 0===y||void 0===F||t)&&l(K.textStr)&&K.getBBox();e.width=(y||k.width||0)+2*g+C;e.height=(F||k.height||0)+2*g;Q=g+n.fontMetrics(a&&a.fontSize,K).b;I&&(u||(e.box=u=n.symbols[B]||q?n.symbol(B):n.rect(),u.addClass(("button"===w?"":"highcharts-label-box")+(w?" highcharts-"+w+"-box":"")),u.add(e),a=G(),f.x=a,f.y=(v?-Q:0)+a),
	f.width=Math.round(e.width),f.height=Math.round(e.height),u.attr(b(f,R)),R={})};M=function(){var a=C+g,f;f=v?0:Q;l(y)&&k&&("center"===t||"right"===t)&&(a+={center:.5,right:1}[t]*(y-k.width));if(a!==K.x||f!==K.y)K.attr("x",a),void 0!==f&&K.attr("y",f);K.x=a;K.y=f};O=function(a,f){u?u.attr(a,f):R[a]=f};e.onAdd=function(){K.add(e);e.attr({text:f||0===f?f:"",x:r,y:h});u&&l(m)&&e.attr({anchorX:m,anchorY:c})};e.widthSetter=function(f){y=a.isNumber(f)?f:null};e.heightSetter=function(a){F=a};e["text-alignSetter"]=
	function(a){t=a};e.paddingSetter=function(a){l(a)&&a!==g&&(g=e.padding=a,M())};e.paddingLeftSetter=function(a){l(a)&&a!==C&&(C=a,M())};e.alignSetter=function(a){a={left:0,center:.5,right:1}[a];a!==P&&(P=a,k&&e.attr({x:H}))};e.textSetter=function(a){void 0!==a&&K.textSetter(a);J();M()};e["stroke-widthSetter"]=function(a,f){a&&(I=!0);this["stroke-width"]=a;O(f,a)};e.rSetter=function(a,f){O(f,a)};e.anchorXSetter=function(a,f){m=e.anchorX=a;O(f,Math.round(a)-G()-H)};e.anchorYSetter=function(a,f){c=e.anchorY=
	a;O(f,a-p)};e.xSetter=function(a){e.x=a;P&&(a-=P*((y||k.width)+2*g));H=Math.round(a);e.attr("translateX",H)};e.ySetter=function(a){p=e.y=Math.round(a);e.attr("translateY",p)};var T=e.css;return b(e,{css:function(a){if(a){var f={};a=E(a);d(e.textProps,function(b){void 0!==a[b]&&(f[b]=a[b],delete a[b])});K.css(f)}return T.call(e,a)},getBBox:function(){return{width:k.width+2*g,height:k.height+2*g,x:k.x-g,y:k.y-g}},destroy:function(){N(e.element,"mouseenter");N(e.element,"mouseleave");K&&(K=K.destroy());
	u&&(u=u.destroy());z.prototype.destroy.call(e);e=n=J=M=O=null}})}});a.Renderer=A})(L);(function(a){var z=a.attr,A=a.createElement,D=a.css,q=a.defined,g=a.each,e=a.extend,k=a.isFirefox,t=a.isMS,p=a.isWebKit,l=a.pick,c=a.pInt,n=a.SVGRenderer,y=a.win,d=a.wrap;e(a.SVGElement.prototype,{htmlCss:function(a){var b=this.element;if(b=a&&"SPAN"===b.tagName&&a.width)delete a.width,this.textWidth=b,this.updateTransform();a&&"ellipsis"===a.textOverflow&&(a.whiteSpace="nowrap",a.overflow="hidden");this.styles=
	e(this.styles,a);D(this.element,a);return this},htmlGetBBox:function(){var a=this.element;return{x:a.offsetLeft,y:a.offsetTop,width:a.offsetWidth,height:a.offsetHeight}},htmlUpdateTransform:function(){if(this.added){var a=this.renderer,h=this.element,d=this.x||0,m=this.y||0,e=this.textAlign||"left",n={left:0,center:.5,right:1}[e],l=this.styles;D(h,{marginLeft:this.translateX||0,marginTop:this.translateY||0});this.inverted&&g(h.childNodes,function(b){a.invertChild(b,h)});if("SPAN"===h.tagName){var k=
	this.rotation,u=c(this.textWidth),y=l&&l.whiteSpace,v=[k,e,h.innerHTML,this.textWidth,this.textAlign].join();v!==this.cTT&&(l=a.fontMetrics(h.style.fontSize).b,q(k)&&this.setSpanRotation(k,n,l),D(h,{width:"",whiteSpace:y||"nowrap"}),h.offsetWidth>u&&/[ \-]/.test(h.textContent||h.innerText)&&D(h,{width:u+"px",display:"block",whiteSpace:y||"normal"}),this.getSpanCorrection(h.offsetWidth,l,n,k,e));D(h,{left:d+(this.xCorr||0)+"px",top:m+(this.yCorr||0)+"px"});p&&(l=h.offsetHeight);this.cTT=v}}else this.alignOnAdd=
	!0},setSpanRotation:function(a,h,d){var b={},c=this.renderer.getTransformKey();b[c]=b.transform="rotate("+a+"deg)";b[c+(k?"Origin":"-origin")]=b.transformOrigin=100*h+"% "+d+"px";D(this.element,b)},getSpanCorrection:function(a,h,d){this.xCorr=-a*d;this.yCorr=-h}});e(n.prototype,{getTransformKey:function(){return t&&!/Edge/.test(y.navigator.userAgent)?"-ms-transform":p?"-webkit-transform":k?"MozTransform":y.opera?"-o-transform":""},html:function(a,h,c){var b=this.createElement("span"),n=b.element,
	w=b.renderer,k=w.isSVG,y=function(a,b){g(["opacity","visibility"],function(h){d(a,h+"Setter",function(a,h,d,f){a.call(this,h,d,f);b[d]=h})})};b.textSetter=function(a){a!==n.innerHTML&&delete this.bBox;this.textStr=a;n.innerHTML=l(a,"");b.htmlUpdateTransform()};k&&y(b,b.element.style);b.xSetter=b.ySetter=b.alignSetter=b.rotationSetter=function(a,h){"align"===h&&(h="textAlign");b[h]=a;b.htmlUpdateTransform()};b.attr({text:a,x:Math.round(h),y:Math.round(c)}).css({position:"absolute"});n.style.whiteSpace=
	"nowrap";b.css=b.htmlCss;k&&(b.add=function(a){var h,d=w.box.parentNode,c=[];if(this.parentGroup=a){if(h=a.div,!h){for(;a;)c.push(a),a=a.parentGroup;g(c.reverse(),function(a){function m(b,r){a[r]=b;t?f[w.getTransformKey()]="translate("+(a.x||a.translateX)+"px,"+(a.y||a.translateY)+"px)":"translateX"===r?f.left=b+"px":f.top=b+"px";a.doTransform=!0}var f,r=z(a.element,"class");r&&(r={className:r});h=a.div=a.div||A("div",r,{position:"absolute",left:(a.translateX||0)+"px",top:(a.translateY||0)+"px",display:a.display,
	opacity:a.opacity,pointerEvents:a.styles&&a.styles.pointerEvents},h||d);f=h.style;e(a,{classSetter:function(a){this.element.setAttribute("class",a);h.className=a},on:function(){c[0].div&&b.on.apply({element:c[0].div},arguments);return a},translateXSetter:m,translateYSetter:m});y(a,f)})}}else h=d;h.appendChild(n);b.added=!0;b.alignOnAdd&&b.htmlUpdateTransform();return b});return b}})})(L);(function(a){function z(){var k=a.defaultOptions.global,g=e.moment;if(k.timezone){if(g)return function(a){return-g.tz(a,
	k.timezone).utcOffset()};a.error(25)}return k.useUTC&&k.getTimezoneOffset}function A(){var k=a.defaultOptions.global,t,p=k.useUTC,l=p?"getUTC":"get",c=p?"setUTC":"set",n="Minutes Hours Day Date Month FullYear".split(" "),y=n.concat(["Milliseconds","Seconds"]);a.Date=t=k.Date||e.Date;t.hcTimezoneOffset=p&&k.timezoneOffset;t.hcGetTimezoneOffset=z();t.hcMakeTime=function(a,b,h,c,m,e){var d;p?(d=t.UTC.apply(0,arguments),d+=D(d)):d=(new t(a,b,g(h,1),g(c,0),g(m,0),g(e,0))).getTime();return d};for(k=0;k<
	n.length;k++)t["hcGet"+n[k]]=l+n[k];for(k=0;k<y.length;k++)t["hcSet"+y[k]]=c+y[k]}var D=a.getTZOffset,q=a.merge,g=a.pick,e=a.win;a.defaultOptions={symbols:["circle","diamond","square","triangle","triangle-down"],lang:{loading:"Loading...",months:"January February March April May June July August September October November December".split(" "),shortMonths:"Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(" "),weekdays:"Sunday Monday Tuesday Wednesday Thursday Friday Saturday".split(" "),decimalPoint:".",
	numericSymbols:"kMGTPE".split(""),resetZoom:"Reset zoom",resetZoomTitle:"Reset zoom level 1:1",thousandsSep:" "},global:{useUTC:!0},chart:{borderRadius:0,colorCount:10,defaultSeriesType:"line",ignoreHiddenSeries:!0,spacing:[10,10,15,10],resetZoomButton:{theme:{zIndex:20},position:{align:"right",x:-10,y:10}},width:null,height:null},title:{text:"Chart title",align:"center",margin:15,widthAdjust:-44},subtitle:{text:"",align:"center",widthAdjust:-44},plotOptions:{},labels:{style:{position:"absolute",
	color:"#333333"}},legend:{enabled:!0,align:"center",layout:"horizontal",labelFormatter:function(){return this.name},borderColor:"#999999",borderRadius:0,navigation:{},itemCheckboxStyle:{position:"absolute",width:"13px",height:"13px"},squareSymbol:!0,symbolPadding:5,verticalAlign:"bottom",x:0,y:0,title:{}},loading:{},tooltip:{enabled:!0,animation:a.svg,borderRadius:3,dateTimeLabelFormats:{millisecond:"%A, %b %e, %H:%M:%S.%L",second:"%A, %b %e, %H:%M:%S",minute:"%A, %b %e, %H:%M",hour:"%A, %b %e, %H:%M",
	day:"%A, %b %e, %Y",week:"Week from %A, %b %e, %Y",month:"%B %Y",year:"%Y"},footerFormat:"",padding:8,snap:a.isTouchDevice?25:10,headerFormat:'\x3cspan class\x3d"highcharts-header"\x3e{point.key}\x3c/span\x3e\x3cbr/\x3e',pointFormat:'\x3cspan class\x3d"highcharts-color-{point.colorIndex}"\x3e\u25cf\x3c/span\x3e {series.name}: \x3cspan class\x3d"highcharts-strong"\x3e{point.y}\x3c/span\x3e\x3cbr/\x3e'},credits:{enabled:!0,href:"http://www.highcharts.com",position:{align:"right",x:-10,verticalAlign:"bottom",
	y:-5},text:"Highcharts.com"}};a.setOptions=function(e){a.defaultOptions=q(!0,a.defaultOptions,e);A();return a.defaultOptions};a.getOptions=function(){return a.defaultOptions};a.defaultPlotOptions=a.defaultOptions.plotOptions;A()})(L);(function(a){var z=a.correctFloat,A=a.defined,D=a.destroyObjectProperties,q=a.isNumber,g=a.pick,e=a.deg2rad;a.Tick=function(a,e,g,l){this.axis=a;this.pos=e;this.type=g||"";this.isNewLabel=this.isNew=!0;g||l||this.addLabel()};a.Tick.prototype={addLabel:function(){var a=
	this.axis,e=a.options,p=a.chart,l=a.categories,c=a.names,n=this.pos,y=e.labels,d=a.tickPositions,b=n===d[0],h=n===d[d.length-1],c=l?g(l[n],c[n],n):n,l=this.label,d=d.info,w;a.isDatetimeAxis&&d&&(w=e.dateTimeLabelFormats[d.higherRanks[n]||d.unitName]);this.isFirst=b;this.isLast=h;e=a.labelFormatter.call({axis:a,chart:p,isFirst:b,isLast:h,dateTimeLabelFormat:w,value:a.isLog?z(a.lin2log(c)):c,pos:n});A(l)?l&&l.attr({text:e}):(this.labelLength=(this.label=l=A(e)&&y.enabled?p.renderer.text(e,0,0,y.useHTML).add(a.labelGroup):
	null)&&l.getBBox().width,this.rotation=0)},getLabelSize:function(){return this.label?this.label.getBBox()[this.axis.horiz?"height":"width"]:0},handleOverflow:function(a){var k=this.axis,p=a.x,l=k.chart.chartWidth,c=k.chart.spacing,n=g(k.labelLeft,Math.min(k.pos,c[3])),c=g(k.labelRight,Math.max(k.pos+k.len,l-c[1])),y=this.label,d=this.rotation,b={left:0,center:.5,right:1}[k.labelAlign],h=y.getBBox().width,w=k.getSlotWidth(),m=w,F=1,q,C={};if(d)0>d&&p-b*h<n?q=Math.round(p/Math.cos(d*e)-n):0<d&&p+b*
	h>c&&(q=Math.round((l-p)/Math.cos(d*e)));else if(l=p+(1-b)*h,p-b*h<n?m=a.x+m*(1-b)-n:l>c&&(m=c-a.x+m*b,F=-1),m=Math.min(w,m),m<w&&"center"===k.labelAlign&&(a.x+=F*(w-m-b*(w-Math.min(h,m)))),h>m||k.autoRotation&&(y.styles||{}).width)q=m;q&&(C.width=q,(k.options.labels.style||{}).textOverflow||(C.textOverflow="ellipsis"),y.css(C))},getPosition:function(a,e,g,l){var c=this.axis,n=c.chart,k=l&&n.oldChartHeight||n.chartHeight;return{x:a?c.translate(e+g,null,null,l)+c.transB:c.left+c.offset+(c.opposite?
	(l&&n.oldChartWidth||n.chartWidth)-c.right-c.left:0),y:a?k-c.bottom+c.offset-(c.opposite?c.height:0):k-c.translate(e+g,null,null,l)-c.transB}},getLabelPosition:function(a,g,p,l,c,n,y,d){var b=this.axis,h=b.transA,w=b.reversed,m=b.staggerLines,k=b.tickRotCorr||{x:0,y:0},q=c.y;A(q)||(q=0===b.side?p.rotation?-8:-p.getBBox().height:2===b.side?k.y+8:Math.cos(p.rotation*e)*(k.y-p.getBBox(!1,0).height/2));a=a+c.x+k.x-(n&&l?n*h*(w?-1:1):0);g=g+q-(n&&!l?n*h*(w?1:-1):0);m&&(p=y/(d||1)%m,b.opposite&&(p=m-p-
	1),g+=b.labelOffset/m*p);return{x:a,y:Math.round(g)}},getMarkPath:function(a,e,g,l,c,n){return n.crispLine(["M",a,e,"L",a+(c?0:-g),e+(c?g:0)],l)},renderGridLine:function(a,e,g){var l=this.axis,c=this.gridLine,n={},k=this.pos,d=this.type,b=l.tickmarkOffset,h=l.chart.renderer;c||(d||(n.zIndex=1),a&&(n.opacity=0),this.gridLine=c=h.path().attr(n).addClass("highcharts-"+(d?d+"-":"")+"grid-line").add(l.gridGroup));if(!a&&c&&(a=l.getPlotLinePath(k+b,c.strokeWidth()*g,a,!0)))c[this.isNew?"attr":"animate"]({d:a,
	opacity:e})},renderMark:function(a,e,g){var l=this.axis,c=l.chart.renderer,n=this.type,k=l.tickSize(n?n+"Tick":"tick"),d=this.mark,b=!d,h=a.x;a=a.y;k&&(l.opposite&&(k[0]=-k[0]),b&&(this.mark=d=c.path().addClass("highcharts-"+(n?n+"-":"")+"tick").add(l.axisGroup)),d[b?"attr":"animate"]({d:this.getMarkPath(h,a,k[0],d.strokeWidth()*g,l.horiz,c),opacity:e}))},renderLabel:function(a,e,p,l){var c=this.axis,n=c.horiz,k=c.options,d=this.label,b=k.labels,h=b.step,w=c.tickmarkOffset,m=!0,F=a.x;a=a.y;d&&q(F)&&
	(d.xy=a=this.getLabelPosition(F,a,d,n,b,w,l,h),this.isFirst&&!this.isLast&&!g(k.showFirstLabel,1)||this.isLast&&!this.isFirst&&!g(k.showLastLabel,1)?m=!1:!n||c.isRadial||b.step||b.rotation||e||0===p||this.handleOverflow(a),h&&l%h&&(m=!1),m&&q(a.y)?(a.opacity=p,d[this.isNewLabel?"attr":"animate"](a),this.isNewLabel=!1):(d.attr("y",-9999),this.isNewLabel=!0))},render:function(a,e,p){var l=this.axis,c=l.horiz,n=this.getPosition(c,this.pos,l.tickmarkOffset,e),k=n.x,d=n.y,l=c&&k===l.pos+l.len||!c&&d===
	l.pos?-1:1;p=g(p,1);this.isActive=!0;this.renderGridLine(e,p,l);this.renderMark(n,p,l);this.renderLabel(n,e,p,a);this.isNew=!1},destroy:function(){D(this,this.axis)}}})(L);var U=function(a){var z=a.addEvent,A=a.animObject,D=a.arrayMax,q=a.arrayMin,g=a.correctFloat,e=a.defaultOptions,k=a.defined,t=a.deg2rad,p=a.destroyObjectProperties,l=a.each,c=a.extend,n=a.fireEvent,y=a.format,d=a.getMagnitude,b=a.grep,h=a.inArray,w=a.isArray,m=a.isNumber,F=a.isString,J=a.merge,C=a.normalizeTickInterval,H=a.objectEach,
	u=a.pick,G=a.removeEvent,v=a.splat,E=a.syncTimeout,x=a.Tick,I=function(){this.init.apply(this,arguments)};a.extend(I.prototype,{defaultOptions:{dateTimeLabelFormats:{millisecond:"%H:%M:%S.%L",second:"%H:%M:%S",minute:"%H:%M",hour:"%H:%M",day:"%e. %b",week:"%e. %b",month:"%b '%y",year:"%Y"},endOnTick:!1,labels:{enabled:!0,x:0},maxPadding:.01,minorTickLength:2,minorTickPosition:"outside",minPadding:.01,startOfWeek:1,startOnTick:!1,tickLength:10,tickmarkPlacement:"between",tickPixelInterval:100,tickPosition:"outside",
	title:{align:"middle"},type:"linear"},defaultYAxisOptions:{endOnTick:!0,tickPixelInterval:72,showLastLabel:!0,labels:{x:-8},maxPadding:.05,minPadding:.05,startOnTick:!0,title:{rotation:270,text:"Values"},stackLabels:{allowOverlap:!1,enabled:!1,formatter:function(){return a.numberFormat(this.total,-1)}}},defaultLeftAxisOptions:{labels:{x:-15},title:{rotation:270}},defaultRightAxisOptions:{labels:{x:15},title:{rotation:90}},defaultBottomAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},
	defaultTopAxisOptions:{labels:{autoRotation:[-45],x:0},title:{rotation:0}},init:function(a,b){var f=b.isX,r=this;r.chart=a;r.horiz=a.inverted&&!r.isZAxis?!f:f;r.isXAxis=f;r.coll=r.coll||(f?"xAxis":"yAxis");r.opposite=b.opposite;r.side=b.side||(r.horiz?r.opposite?0:2:r.opposite?1:3);r.setOptions(b);var d=this.options,c=d.type;r.labelFormatter=d.labels.formatter||r.defaultLabelFormatter;r.userOptions=b;r.minPixelPadding=0;r.reversed=d.reversed;r.visible=!1!==d.visible;r.zoomEnabled=!1!==d.zoomEnabled;
	r.hasNames="category"===c||!0===d.categories;r.categories=d.categories||r.hasNames;r.names=r.names||[];r.plotLinesAndBandsGroups={};r.isLog="logarithmic"===c;r.isDatetimeAxis="datetime"===c;r.positiveValuesOnly=r.isLog&&!r.allowNegativeLog;r.isLinked=k(d.linkedTo);r.ticks={};r.labelEdge=[];r.minorTicks={};r.plotLinesAndBands=[];r.alternateBands={};r.len=0;r.minRange=r.userMinRange=d.minRange||d.maxZoom;r.range=d.range;r.offset=d.offset||0;r.stacks={};r.oldStacks={};r.stacksTouched=0;r.max=null;r.min=
	null;r.crosshair=u(d.crosshair,v(a.options.tooltip.crosshairs)[f?0:1],!1);b=r.options.events;-1===h(r,a.axes)&&(f?a.axes.splice(a.xAxis.length,0,r):a.axes.push(r),a[r.coll].push(r));r.series=r.series||[];a.inverted&&!r.isZAxis&&f&&void 0===r.reversed&&(r.reversed=!0);H(b,function(a,f){z(r,f,a)});r.lin2log=d.linearToLogConverter||r.lin2log;r.isLog&&(r.val2lin=r.log2lin,r.lin2val=r.lin2log)},setOptions:function(a){this.options=J(this.defaultOptions,"yAxis"===this.coll&&this.defaultYAxisOptions,[this.defaultTopAxisOptions,
	this.defaultRightAxisOptions,this.defaultBottomAxisOptions,this.defaultLeftAxisOptions][this.side],J(e[this.coll],a))},defaultLabelFormatter:function(){var f=this.axis,b=this.value,h=f.categories,d=this.dateTimeLabelFormat,B=e.lang,c=B.numericSymbols,B=B.numericSymbolMagnitude||1E3,m=c&&c.length,v,x=f.options.labels.format,f=f.isLog?Math.abs(b):f.tickInterval;if(x)v=y(x,this);else if(h)v=b;else if(d)v=a.dateFormat(d,b);else if(m&&1E3<=f)for(;m--&&void 0===v;)h=Math.pow(B,m+1),f>=h&&0===10*b%h&&null!==
	c[m]&&0!==b&&(v=a.numberFormat(b/h,-1)+c[m]);void 0===v&&(v=1E4<=Math.abs(b)?a.numberFormat(b,-1):a.numberFormat(b,-1,void 0,""));return v},getSeriesExtremes:function(){var a=this,r=a.chart;a.hasVisibleSeries=!1;a.dataMin=a.dataMax=a.threshold=null;a.softThreshold=!a.isXAxis;a.buildStacks&&a.buildStacks();l(a.series,function(f){if(f.visible||!r.options.chart.ignoreHiddenSeries){var h=f.options,d=h.threshold,c;a.hasVisibleSeries=!0;a.positiveValuesOnly&&0>=d&&(d=null);if(a.isXAxis)h=f.xData,h.length&&
	(f=q(h),c=D(h),m(f)||f instanceof Date||(h=b(h,m),f=q(h)),a.dataMin=Math.min(u(a.dataMin,h[0],f),f),a.dataMax=Math.max(u(a.dataMax,h[0],c),c));else if(f.getExtremes(),c=f.dataMax,f=f.dataMin,k(f)&&k(c)&&(a.dataMin=Math.min(u(a.dataMin,f),f),a.dataMax=Math.max(u(a.dataMax,c),c)),k(d)&&(a.threshold=d),!h.softThreshold||a.positiveValuesOnly)a.softThreshold=!1}})},translate:function(a,b,h,d,c,e){var f=this.linkedParent||this,r=1,B=0,v=d?f.oldTransA:f.transA;d=d?f.oldMin:f.min;var x=f.minPixelPadding;
	c=(f.isOrdinal||f.isBroken||f.isLog&&c)&&f.lin2val;v||(v=f.transA);h&&(r*=-1,B=f.len);f.reversed&&(r*=-1,B-=r*(f.sector||f.len));b?(a=(a*r+B-x)/v+d,c&&(a=f.lin2val(a))):(c&&(a=f.val2lin(a)),a=m(d)?r*(a-d)*v+B+r*x+(m(e)?v*e:0):void 0);return a},toPixels:function(a,b){return this.translate(a,!1,!this.horiz,null,!0)+(b?0:this.pos)},toValue:function(a,b){return this.translate(a-(b?0:this.pos),!0,!this.horiz,null,!0)},getPlotLinePath:function(a,b,h,d,c){var f=this.chart,r=this.left,B=this.top,v,e,x=h&&
	f.oldChartHeight||f.chartHeight,n=h&&f.oldChartWidth||f.chartWidth,w;v=this.transB;var l=function(a,f,b){if(a<f||a>b)d?a=Math.min(Math.max(f,a),b):w=!0;return a};c=u(c,this.translate(a,null,null,h));a=h=Math.round(c+v);v=e=Math.round(x-c-v);m(c)?this.horiz?(v=B,e=x-this.bottom,a=h=l(a,r,r+this.width)):(a=r,h=n-this.right,v=e=l(v,B,B+this.height)):(w=!0,d=!1);return w&&!d?null:f.renderer.crispLine(["M",a,v,"L",h,e],b||1)},getLinearTickPositions:function(a,b,h){var f,r=g(Math.floor(b/a)*a);h=g(Math.ceil(h/
	a)*a);var d=[],c;g(r+a)===r&&(c=20);if(this.single)return[b];for(b=r;b<=h;){d.push(b);b=g(b+a,c);if(b===f)break;f=b}return d},getMinorTickInterval:function(){var a=this.options;return!0===a.minorTicks?u(a.minorTickInterval,"auto"):!1===a.minorTicks?null:a.minorTickInterval},getMinorTickPositions:function(){var a=this,b=a.options,h=a.tickPositions,d=a.minorTickInterval,c=[],m=a.pointRangePadding||0,v=a.min-m,m=a.max+m,e=m-v;if(e&&e/d<a.len/3)if(a.isLog)l(this.paddedTicks,function(f,b,r){b&&c.push.apply(c,
	a.getLogTickPositions(d,r[b-1],r[b],!0))});else if(a.isDatetimeAxis&&"auto"===this.getMinorTickInterval())c=c.concat(a.getTimeTicks(a.normalizeTimeTickInterval(d),v,m,b.startOfWeek));else for(b=v+(h[0]-v)%d;b<=m&&b!==c[0];b+=d)c.push(b);0!==c.length&&a.trimTicks(c);return c},adjustForMinRange:function(){var a=this.options,b=this.min,h=this.max,d,c,m,v,e,x,n,w;this.isXAxis&&void 0===this.minRange&&!this.isLog&&(k(a.min)||k(a.max)?this.minRange=null:(l(this.series,function(a){x=a.xData;for(v=n=a.xIncrement?
	1:x.length-1;0<v;v--)if(e=x[v]-x[v-1],void 0===m||e<m)m=e}),this.minRange=Math.min(5*m,this.dataMax-this.dataMin)));h-b<this.minRange&&(c=this.dataMax-this.dataMin>=this.minRange,w=this.minRange,d=(w-h+b)/2,d=[b-d,u(a.min,b-d)],c&&(d[2]=this.isLog?this.log2lin(this.dataMin):this.dataMin),b=D(d),h=[b+w,u(a.max,b+w)],c&&(h[2]=this.isLog?this.log2lin(this.dataMax):this.dataMax),h=q(h),h-b<w&&(d[0]=h-w,d[1]=u(a.min,h-w),b=D(d)));this.min=b;this.max=h},getClosest:function(){var a;this.categories?a=1:l(this.series,
	function(f){var b=f.closestPointRange,r=f.visible||!f.chart.options.chart.ignoreHiddenSeries;!f.noSharedTooltip&&k(b)&&r&&(a=k(a)?Math.min(a,b):b)});return a},nameToX:function(a){var f=w(this.categories),b=f?this.categories:this.names,d=a.options.x,c;a.series.requireSorting=!1;k(d)||(d=!1===this.options.uniqueNames?a.series.autoIncrement():h(a.name,b));-1===d?f||(c=b.length):c=d;void 0!==c&&(this.names[c]=a.name);return c},updateNames:function(){var a=this;0<this.names.length&&(this.names.length=
	0,this.minRange=this.userMinRange,l(this.series||[],function(f){f.xIncrement=null;if(!f.points||f.isDirtyData)f.processData(),f.generatePoints();l(f.points,function(b,r){var h;b.options&&(h=a.nameToX(b),void 0!==h&&h!==b.x&&(b.x=h,f.xData[r]=h))})}))},setAxisTranslation:function(a){var f=this,b=f.max-f.min,h=f.axisPointRange||0,d,c=0,m=0,v=f.linkedParent,e=!!f.categories,x=f.transA,n=f.isXAxis;if(n||e||h)d=f.getClosest(),v?(c=v.minPointOffset,m=v.pointRangePadding):l(f.series,function(a){var b=e?
	1:n?u(a.options.pointRange,d,0):f.axisPointRange||0;a=a.options.pointPlacement;h=Math.max(h,b);f.single||(c=Math.max(c,F(a)?0:b/2),m=Math.max(m,"on"===a?0:b))}),v=f.ordinalSlope&&d?f.ordinalSlope/d:1,f.minPointOffset=c*=v,f.pointRangePadding=m*=v,f.pointRange=Math.min(h,b),n&&(f.closestPointRange=d);a&&(f.oldTransA=x);f.translationSlope=f.transA=x=f.options.staticScale||f.len/(b+m||1);f.transB=f.horiz?f.left:f.bottom;f.minPixelPadding=x*c},minFromRange:function(){return this.max-this.range},setTickInterval:function(f){var b=
	this,h=b.chart,c=b.options,v=b.isLog,e=b.log2lin,x=b.isDatetimeAxis,w=b.isXAxis,E=b.isLinked,y=c.maxPadding,H=c.minPadding,F=c.tickInterval,p=c.tickPixelInterval,q=b.categories,t=b.threshold,I=b.softThreshold,G,J,A,z;x||q||E||this.getTickAmount();A=u(b.userMin,c.min);z=u(b.userMax,c.max);E?(b.linkedParent=h[b.coll][c.linkedTo],h=b.linkedParent.getExtremes(),b.min=u(h.min,h.dataMin),b.max=u(h.max,h.dataMax),c.type!==b.linkedParent.options.type&&a.error(11,1)):(!I&&k(t)&&(b.dataMin>=t?(G=t,H=0):b.dataMax<=
	t&&(J=t,y=0)),b.min=u(A,G,b.dataMin),b.max=u(z,J,b.dataMax));v&&(b.positiveValuesOnly&&!f&&0>=Math.min(b.min,u(b.dataMin,b.min))&&a.error(10,1),b.min=g(e(b.min),15),b.max=g(e(b.max),15));b.range&&k(b.max)&&(b.userMin=b.min=A=Math.max(b.dataMin,b.minFromRange()),b.userMax=z=b.max,b.range=null);n(b,"foundExtremes");b.beforePadding&&b.beforePadding();b.adjustForMinRange();!(q||b.axisPointRange||b.usePercentage||E)&&k(b.min)&&k(b.max)&&(e=b.max-b.min)&&(!k(A)&&H&&(b.min-=e*H),!k(z)&&y&&(b.max+=e*y));
	m(c.softMin)&&(b.min=Math.min(b.min,c.softMin));m(c.softMax)&&(b.max=Math.max(b.max,c.softMax));m(c.floor)&&(b.min=Math.max(b.min,c.floor));m(c.ceiling)&&(b.max=Math.min(b.max,c.ceiling));I&&k(b.dataMin)&&(t=t||0,!k(A)&&b.min<t&&b.dataMin>=t?b.min=t:!k(z)&&b.max>t&&b.dataMax<=t&&(b.max=t));b.tickInterval=b.min===b.max||void 0===b.min||void 0===b.max?1:E&&!F&&p===b.linkedParent.options.tickPixelInterval?F=b.linkedParent.tickInterval:u(F,this.tickAmount?(b.max-b.min)/Math.max(this.tickAmount-1,1):void 0,
	q?1:(b.max-b.min)*p/Math.max(b.len,p));w&&!f&&l(b.series,function(a){a.processData(b.min!==b.oldMin||b.max!==b.oldMax)});b.setAxisTranslation(!0);b.beforeSetTickPositions&&b.beforeSetTickPositions();b.postProcessTickInterval&&(b.tickInterval=b.postProcessTickInterval(b.tickInterval));b.pointRange&&!F&&(b.tickInterval=Math.max(b.pointRange,b.tickInterval));f=u(c.minTickInterval,b.isDatetimeAxis&&b.closestPointRange);!F&&b.tickInterval<f&&(b.tickInterval=f);x||v||F||(b.tickInterval=C(b.tickInterval,
	null,d(b.tickInterval),u(c.allowDecimals,!(.5<b.tickInterval&&5>b.tickInterval&&1E3<b.max&&9999>b.max)),!!this.tickAmount));this.tickAmount||(b.tickInterval=b.unsquish());this.setTickPositions()},setTickPositions:function(){var a=this.options,b,h=a.tickPositions;b=this.getMinorTickInterval();var d=a.tickPositioner,c=a.startOnTick,m=a.endOnTick;this.tickmarkOffset=this.categories&&"between"===a.tickmarkPlacement&&1===this.tickInterval?.5:0;this.minorTickInterval="auto"===b&&this.tickInterval?this.tickInterval/
	5:b;this.single=this.min===this.max&&k(this.min)&&!this.tickAmount&&(parseInt(this.min,10)===this.min||!1!==a.allowDecimals);this.tickPositions=b=h&&h.slice();!b&&(b=this.isDatetimeAxis?this.getTimeTicks(this.normalizeTimeTickInterval(this.tickInterval,a.units),this.min,this.max,a.startOfWeek,this.ordinalPositions,this.closestPointRange,!0):this.isLog?this.getLogTickPositions(this.tickInterval,this.min,this.max):this.getLinearTickPositions(this.tickInterval,this.min,this.max),b.length>this.len&&(b=
	[b[0],b.pop()],b[0]===b[1]&&(b.length=1)),this.tickPositions=b,d&&(d=d.apply(this,[this.min,this.max])))&&(this.tickPositions=b=d);this.paddedTicks=b.slice(0);this.trimTicks(b,c,m);this.isLinked||(this.single&&2>b.length&&(this.min-=.5,this.max+=.5),h||d||this.adjustTickAmount())},trimTicks:function(a,b,h){var f=a[0],d=a[a.length-1],c=this.minPointOffset||0;if(!this.isLinked){if(b&&-Infinity!==f)this.min=f;else for(;this.min-c>a[0];)a.shift();if(h)this.max=d;else for(;this.max+c<a[a.length-1];)a.pop();
	0===a.length&&k(f)&&a.push((d+f)/2)}},alignToOthers:function(){var a={},b,h=this.options;!1===this.chart.options.chart.alignTicks||!1===h.alignTicks||this.isLog||l(this.chart[this.coll],function(f){var h=f.options,h=[f.horiz?h.left:h.top,h.width,h.height,h.pane].join();f.series.length&&(a[h]?b=!0:a[h]=1)});return b},getTickAmount:function(){var a=this.options,b=a.tickAmount,h=a.tickPixelInterval;!k(a.tickInterval)&&this.len<h&&!this.isRadial&&!this.isLog&&a.startOnTick&&a.endOnTick&&(b=2);!b&&this.alignToOthers()&&
	(b=Math.ceil(this.len/h)+1);4>b&&(this.finalTickAmt=b,b=5);this.tickAmount=b},adjustTickAmount:function(){var a=this.tickInterval,b=this.tickPositions,h=this.tickAmount,d=this.finalTickAmt,c=b&&b.length;if(c<h){for(;b.length<h;)b.push(g(b[b.length-1]+a));this.transA*=(c-1)/(h-1);this.max=b[b.length-1]}else c>h&&(this.tickInterval*=2,this.setTickPositions());if(k(d)){for(a=h=b.length;a--;)(3===d&&1===a%2||2>=d&&0<a&&a<h-1)&&b.splice(a,1);this.finalTickAmt=void 0}},setScale:function(){var a,b;this.oldMin=
	this.min;this.oldMax=this.max;this.oldAxisLength=this.len;this.setAxisSize();b=this.len!==this.oldAxisLength;l(this.series,function(b){if(b.isDirtyData||b.isDirty||b.xAxis.isDirty)a=!0});b||a||this.isLinked||this.forceRedraw||this.userMin!==this.oldUserMin||this.userMax!==this.oldUserMax||this.alignToOthers()?(this.resetStacks&&this.resetStacks(),this.forceRedraw=!1,this.getSeriesExtremes(),this.setTickInterval(),this.oldUserMin=this.userMin,this.oldUserMax=this.userMax,this.isDirty||(this.isDirty=
	b||this.min!==this.oldMin||this.max!==this.oldMax)):this.cleanStacks&&this.cleanStacks()},setExtremes:function(a,b,h,d,m){var f=this,r=f.chart;h=u(h,!0);l(f.series,function(a){delete a.kdTree});m=c(m,{min:a,max:b});n(f,"setExtremes",m,function(){f.userMin=a;f.userMax=b;f.eventArgs=m;h&&r.redraw(d)})},zoom:function(a,b){var f=this.dataMin,h=this.dataMax,d=this.options,c=Math.min(f,u(d.min,f)),d=Math.max(h,u(d.max,h));if(a!==this.min||b!==this.max)this.allowZoomOutside||(k(f)&&(a<c&&(a=c),a>d&&(a=d)),
	k(h)&&(b<c&&(b=c),b>d&&(b=d))),this.displayBtn=void 0!==a||void 0!==b,this.setExtremes(a,b,!1,void 0,{trigger:"zoom"});return!0},setAxisSize:function(){var b=this.chart,h=this.options,d=h.offsets||[0,0,0,0],c=this.horiz,m=this.width=Math.round(a.relativeLength(u(h.width,b.plotWidth-d[3]+d[1]),b.plotWidth)),v=this.height=Math.round(a.relativeLength(u(h.height,b.plotHeight-d[0]+d[2]),b.plotHeight)),e=this.top=Math.round(a.relativeLength(u(h.top,b.plotTop+d[0]),b.plotHeight,b.plotTop)),h=this.left=Math.round(a.relativeLength(u(h.left,
	b.plotLeft+d[3]),b.plotWidth,b.plotLeft));this.bottom=b.chartHeight-v-e;this.right=b.chartWidth-m-h;this.len=Math.max(c?m:v,0);this.pos=c?h:e},getExtremes:function(){var a=this.isLog,b=this.lin2log;return{min:a?g(b(this.min)):this.min,max:a?g(b(this.max)):this.max,dataMin:this.dataMin,dataMax:this.dataMax,userMin:this.userMin,userMax:this.userMax}},getThreshold:function(a){var b=this.isLog,f=this.lin2log,h=b?f(this.min):this.min,b=b?f(this.max):this.max;null===a?a=h:h>a?a=h:b<a&&(a=b);return this.translate(a,
	0,1,0,1)},autoLabelAlign:function(a){a=(u(a,0)-90*this.side+720)%360;return 15<a&&165>a?"right":195<a&&345>a?"left":"center"},tickSize:function(a){var b=this.options,f=b[a+"Length"],h=u(b[a+"Width"],"tick"===a&&this.isXAxis?1:0);if(h&&f)return"inside"===b[a+"Position"]&&(f=-f),[f,h]},labelMetrics:function(){var a=this.tickPositions&&this.tickPositions[0]||0;return this.chart.renderer.fontMetrics(this.options.labels.style&&this.options.labels.style.fontSize,this.ticks[a]&&this.ticks[a].label)},unsquish:function(){var a=
	this.options.labels,b=this.horiz,h=this.tickInterval,d=h,c=this.len/(((this.categories?1:0)+this.max-this.min)/h),m,v=a.rotation,e=this.labelMetrics(),x,n=Number.MAX_VALUE,w,g=function(a){a/=c||1;a=1<a?Math.ceil(a):1;return a*h};b?(w=!a.staggerLines&&!a.step&&(k(v)?[v]:c<u(a.autoRotationLimit,80)&&a.autoRotation))&&l(w,function(a){var b;if(a===v||a&&-90<=a&&90>=a)x=g(Math.abs(e.h/Math.sin(t*a))),b=x+Math.abs(a/360),b<n&&(n=b,m=a,d=x)}):a.step||(d=g(e.h));this.autoRotation=w;this.labelRotation=u(m,
	v);return d},getSlotWidth:function(){var a=this.chart,b=this.horiz,h=this.options.labels,d=Math.max(this.tickPositions.length-(this.categories?0:1),1),c=a.margin[3];return b&&2>(h.step||0)&&!h.rotation&&(this.staggerLines||1)*this.len/d||!b&&(h.style&&parseInt(h.style.width,10)||c&&c-a.spacing[3]||.33*a.chartWidth)},renderUnsquish:function(){var a=this.chart,b=a.renderer,h=this.tickPositions,d=this.ticks,c=this.options.labels,m=this.horiz,v=this.getSlotWidth(),e=Math.max(1,Math.round(v-2*(c.padding||
	5))),x={},n=this.labelMetrics(),w=c.style&&c.style.textOverflow,u,g=0,k,E;F(c.rotation)||(x.rotation=c.rotation||0);l(h,function(a){(a=d[a])&&a.labelLength>g&&(g=a.labelLength)});this.maxLabelLength=g;if(this.autoRotation)g>e&&g>n.h?x.rotation=this.labelRotation:this.labelRotation=0;else if(v&&(u={width:e+"px"},!w))for(u.textOverflow="clip",k=h.length;!m&&k--;)if(E=h[k],e=d[E].label)e.styles&&"ellipsis"===e.styles.textOverflow?e.css({textOverflow:"clip"}):d[E].labelLength>v&&e.css({width:v+"px"}),
	e.getBBox().height>this.len/h.length-(n.h-n.f)&&(e.specCss={textOverflow:"ellipsis"});x.rotation&&(u={width:(g>.5*a.chartHeight?.33*a.chartHeight:a.chartHeight)+"px"},w||(u.textOverflow="ellipsis"));if(this.labelAlign=c.align||this.autoLabelAlign(this.labelRotation))x.align=this.labelAlign;l(h,function(a){var b=(a=d[a])&&a.label;b&&(b.attr(x),u&&b.css(J(u,b.specCss)),delete b.specCss,a.rotation=x.rotation)});this.tickRotCorr=b.rotCorr(n.b,this.labelRotation||0,0!==this.side)},hasData:function(){return this.hasVisibleSeries||
	k(this.min)&&k(this.max)&&this.tickPositions&&0<this.tickPositions.length},addTitle:function(a){var b=this.chart.renderer,f=this.horiz,h=this.opposite,d=this.options.title,c;this.axisTitle||((c=d.textAlign)||(c=(f?{low:"left",middle:"center",high:"right"}:{low:h?"right":"left",middle:"center",high:h?"left":"right"})[d.align]),this.axisTitle=b.text(d.text,0,0,d.useHTML).attr({zIndex:7,rotation:d.rotation||0,align:c}).addClass("highcharts-axis-title").add(this.axisGroup),this.axisTitle.isNew=!0);this.axisTitle.css({width:this.len});
	this.axisTitle[a?"show":"hide"](!0)},generateTick:function(a){var b=this.ticks;b[a]?b[a].addLabel():b[a]=new x(this,a)},getOffset:function(){var a=this,b=a.chart,h=b.renderer,d=a.options,c=a.tickPositions,m=a.ticks,v=a.horiz,e=a.side,x=b.inverted&&!a.isZAxis?[1,0,3,2][e]:e,n,w,g=0,E,C=0,y=d.title,F=d.labels,p=0,q=b.axisOffset,b=b.clipOffset,t=[-1,1,1,-1][e],I=d.className,G=a.axisParent,J=this.tickSize("tick");n=a.hasData();a.showAxis=w=n||u(d.showEmpty,!0);a.staggerLines=a.horiz&&F.staggerLines;a.axisGroup||
	(a.gridGroup=h.g("grid").attr({zIndex:d.gridZIndex||1}).addClass("highcharts-"+this.coll.toLowerCase()+"-grid "+(I||"")).add(G),a.axisGroup=h.g("axis").attr({zIndex:d.zIndex||2}).addClass("highcharts-"+this.coll.toLowerCase()+" "+(I||"")).add(G),a.labelGroup=h.g("axis-labels").attr({zIndex:F.zIndex||7}).addClass("highcharts-"+a.coll.toLowerCase()+"-labels "+(I||"")).add(G));n||a.isLinked?(l(c,function(b,f){a.generateTick(b,f)}),a.renderUnsquish(),!1===F.reserveSpace||0!==e&&2!==e&&{1:"left",3:"right"}[e]!==
	a.labelAlign&&"center"!==a.labelAlign||l(c,function(a){p=Math.max(m[a].getLabelSize(),p)}),a.staggerLines&&(p*=a.staggerLines,a.labelOffset=p*(a.opposite?-1:1))):H(m,function(a,b){a.destroy();delete m[b]});y&&y.text&&!1!==y.enabled&&(a.addTitle(w),w&&!1!==y.reserveSpace&&(a.titleOffset=g=a.axisTitle.getBBox()[v?"height":"width"],E=y.offset,C=k(E)?0:u(y.margin,v?5:10)));a.renderLine();a.offset=t*u(d.offset,q[e]);a.tickRotCorr=a.tickRotCorr||{x:0,y:0};h=0===e?-a.labelMetrics().h:2===e?a.tickRotCorr.y:
	0;C=Math.abs(p)+C;p&&(C=C-h+t*(v?u(F.y,a.tickRotCorr.y+8*t):F.x));a.axisTitleMargin=u(E,C);q[e]=Math.max(q[e],a.axisTitleMargin+g+t*a.offset,C,n&&c.length&&J?J[0]+t*a.offset:0);d=d.offset?0:2*Math.floor(a.axisLine.strokeWidth()/2);b[x]=Math.max(b[x],d)},getLinePath:function(a){var b=this.chart,f=this.opposite,h=this.offset,d=this.horiz,c=this.left+(f?this.width:0)+h,h=b.chartHeight-this.bottom-(f?this.height:0)+h;f&&(a*=-1);return b.renderer.crispLine(["M",d?this.left:c,d?h:this.top,"L",d?b.chartWidth-
	this.right:c,d?h:b.chartHeight-this.bottom],a)},renderLine:function(){this.axisLine||(this.axisLine=this.chart.renderer.path().addClass("highcharts-axis-line").add(this.axisGroup))},getTitlePosition:function(){var a=this.horiz,b=this.left,h=this.top,d=this.len,c=this.options.title,m=a?b:h,e=this.opposite,v=this.offset,x=c.x||0,n=c.y||0,w=this.axisTitle,l=this.chart.renderer.fontMetrics(c.style&&c.style.fontSize,w),w=Math.max(w.getBBox(null,0).height-l.h-1,0),d={low:m+(a?0:d),middle:m+d/2,high:m+(a?
	d:0)}[c.align],b=(a?h+this.height:b)+(a?1:-1)*(e?-1:1)*this.axisTitleMargin+[-w,w,l.f,-w][this.side];return{x:a?d+x:b+(e?this.width:0)+v+x,y:a?b+n-(e?this.height:0)+v:d+n}},renderMinorTick:function(a){var b=this.chart.hasRendered&&m(this.oldMin),f=this.minorTicks;f[a]||(f[a]=new x(this,a,"minor"));b&&f[a].isNew&&f[a].render(null,!0);f[a].render(null,!1,1)},renderTick:function(a,b){var f=this.isLinked,h=this.ticks,d=this.chart.hasRendered&&m(this.oldMin);if(!f||a>=this.min&&a<=this.max)h[a]||(h[a]=
	new x(this,a)),d&&h[a].isNew&&h[a].render(b,!0,.1),h[a].render(b)},render:function(){var b=this,h=b.chart,d=b.options,c=b.isLog,e=b.lin2log,v=b.isLinked,n=b.tickPositions,w=b.axisTitle,u=b.ticks,g=b.minorTicks,k=b.alternateBands,C=d.stackLabels,y=d.alternateGridColor,F=b.tickmarkOffset,p=b.axisLine,q=b.showAxis,t=A(h.renderer.globalAnimation),I,G;b.labelEdge.length=0;b.overlap=!1;l([u,g,k],function(a){H(a,function(a){a.isActive=!1})});if(b.hasData()||v)b.minorTickInterval&&!b.categories&&l(b.getMinorTickPositions(),
	function(a){b.renderMinorTick(a)}),n.length&&(l(n,function(a,h){b.renderTick(a,h)}),F&&(0===b.min||b.single)&&(u[-1]||(u[-1]=new x(b,-1,null,!0)),u[-1].render(-1))),y&&l(n,function(f,d){G=void 0!==n[d+1]?n[d+1]+F:b.max-F;0===d%2&&f<b.max&&G<=b.max+(h.polar?-F:F)&&(k[f]||(k[f]=new a.PlotLineOrBand(b)),I=f+F,k[f].options={from:c?e(I):I,to:c?e(G):G,color:y},k[f].render(),k[f].isActive=!0)}),b._addedPlotLB||(l((d.plotLines||[]).concat(d.plotBands||[]),function(a){b.addPlotBandOrLine(a)}),b._addedPlotLB=
	!0);l([u,g,k],function(a){var b,f=[],d=t.duration;H(a,function(a,b){a.isActive||(a.render(b,!1,0),a.isActive=!1,f.push(b))});E(function(){for(b=f.length;b--;)a[f[b]]&&!a[f[b]].isActive&&(a[f[b]].destroy(),delete a[f[b]])},a!==k&&h.hasRendered&&d?d:0)});p&&(p[p.isPlaced?"animate":"attr"]({d:this.getLinePath(p.strokeWidth())}),p.isPlaced=!0,p[q?"show":"hide"](!0));w&&q&&(d=b.getTitlePosition(),m(d.y)?(w[w.isNew?"attr":"animate"](d),w.isNew=!1):(w.attr("y",-9999),w.isNew=!0));C&&C.enabled&&b.renderStackTotals();
	b.isDirty=!1},redraw:function(){this.visible&&(this.render(),l(this.plotLinesAndBands,function(a){a.render()}));l(this.series,function(a){a.isDirty=!0})},keepProps:"extKey hcEvents names series userMax userMin".split(" "),destroy:function(a){var b=this,f=b.stacks,d=b.plotLinesAndBands,c;a||G(b);H(f,function(a,b){p(a);f[b]=null});l([b.ticks,b.minorTicks,b.alternateBands],function(a){p(a)});if(d)for(a=d.length;a--;)d[a].destroy();l("stackTotalGroup axisLine axisTitle axisGroup gridGroup labelGroup cross".split(" "),
	function(a){b[a]&&(b[a]=b[a].destroy())});for(c in b.plotLinesAndBandsGroups)b.plotLinesAndBandsGroups[c]=b.plotLinesAndBandsGroups[c].destroy();H(b,function(a,f){-1===h(f,b.keepProps)&&delete b[f]})},drawCrosshair:function(a,b){var h,f=this.crosshair,d=u(f.snap,!0),c,m=this.cross;a||(a=this.cross&&this.cross.e);this.crosshair&&!1!==(k(b)||!d)?(d?k(b)&&(c=this.isXAxis?b.plotX:this.len-b.plotY):c=a&&(this.horiz?a.chartX-this.pos:this.len-a.chartY+this.pos),k(c)&&(h=this.getPlotLinePath(b&&(this.isXAxis?
	b.x:u(b.stackY,b.y)),null,null,null,c)||null),k(h)?(b=this.categories&&!this.isRadial,m||(this.cross=m=this.chart.renderer.path().addClass("highcharts-crosshair highcharts-crosshair-"+(b?"category ":"thin ")+f.className).attr({zIndex:u(f.zIndex,2)}).add()),m.show().attr({d:h}),b&&!f.width&&m.attr({"stroke-width":this.transA}),this.cross.e=a):this.hideCrosshair()):this.hideCrosshair()},hideCrosshair:function(){this.cross&&this.cross.hide()}});return a.Axis=I}(L);(function(a){var z=a.Axis,A=a.Date,
	D=a.dateFormat,q=a.defaultOptions,g=a.defined,e=a.each,k=a.extend,t=a.getMagnitude,p=a.getTZOffset,l=a.normalizeTickInterval,c=a.pick,n=a.timeUnits;z.prototype.getTimeTicks=function(a,d,b,h){var w=[],m={},l=q.global.useUTC,y,C=new A(d-Math.max(p(d),p(b))),H=A.hcMakeTime,u=a.unitRange,t=a.count,v,E;if(g(d)){C[A.hcSetMilliseconds](u>=n.second?0:t*Math.floor(C.getMilliseconds()/t));if(u>=n.second)C[A.hcSetSeconds](u>=n.minute?0:t*Math.floor(C.getSeconds()/t));if(u>=n.minute)C[A.hcSetMinutes](u>=n.hour?
	0:t*Math.floor(C[A.hcGetMinutes]()/t));if(u>=n.hour)C[A.hcSetHours](u>=n.day?0:t*Math.floor(C[A.hcGetHours]()/t));if(u>=n.day)C[A.hcSetDate](u>=n.month?1:t*Math.floor(C[A.hcGetDate]()/t));u>=n.month&&(C[A.hcSetMonth](u>=n.year?0:t*Math.floor(C[A.hcGetMonth]()/t)),y=C[A.hcGetFullYear]());if(u>=n.year)C[A.hcSetFullYear](y-y%t);if(u===n.week)C[A.hcSetDate](C[A.hcGetDate]()-C[A.hcGetDay]()+c(h,1));y=C[A.hcGetFullYear]();h=C[A.hcGetMonth]();var x=C[A.hcGetDate](),I=C[A.hcGetHours]();if(A.hcTimezoneOffset||
	A.hcGetTimezoneOffset)E=(!l||!!A.hcGetTimezoneOffset)&&(b-d>4*n.month||p(d)!==p(b)),C=C.getTime(),v=p(C),C=new A(C+v);l=C.getTime();for(d=1;l<b;)w.push(l),l=u===n.year?H(y+d*t,0):u===n.month?H(y,h+d*t):!E||u!==n.day&&u!==n.week?E&&u===n.hour?H(y,h,x,I+d*t,0,0,v)-v:l+u*t:H(y,h,x+d*t*(u===n.day?1:7)),d++;w.push(l);u<=n.hour&&1E4>w.length&&e(w,function(a){0===a%18E5&&"000000000"===D("%H%M%S%L",a)&&(m[a]="day")})}w.info=k(a,{higherRanks:m,totalRange:u*t});return w};z.prototype.normalizeTimeTickInterval=
	function(a,d){var b=d||[["millisecond",[1,2,5,10,20,25,50,100,200,500]],["second",[1,2,5,10,15,30]],["minute",[1,2,5,10,15,30]],["hour",[1,2,3,4,6,8,12]],["day",[1,2]],["week",[1,2]],["month",[1,2,3,4,6]],["year",null]];d=b[b.length-1];var h=n[d[0]],c=d[1],m;for(m=0;m<b.length&&!(d=b[m],h=n[d[0]],c=d[1],b[m+1]&&a<=(h*c[c.length-1]+n[b[m+1][0]])/2);m++);h===n.year&&a<5*h&&(c=[1,2,5]);a=l(a/h,c,"year"===d[0]?Math.max(t(a/h),1):1);return{unitRange:h,count:a,unitName:d[0]}}})(L);(function(a){var z=a.Axis,
	A=a.getMagnitude,D=a.map,q=a.normalizeTickInterval,g=a.pick;z.prototype.getLogTickPositions=function(a,k,t,p){var e=this.options,c=this.len,n=this.lin2log,y=this.log2lin,d=[];p||(this._minorAutoInterval=null);if(.5<=a)a=Math.round(a),d=this.getLinearTickPositions(a,k,t);else if(.08<=a)for(var c=Math.floor(k),b,h,w,m,F,e=.3<a?[1,2,4]:.15<a?[1,2,4,6,8]:[1,2,3,4,5,6,7,8,9];c<t+1&&!F;c++)for(h=e.length,b=0;b<h&&!F;b++)w=y(n(c)*e[b]),w>k&&(!p||m<=t)&&void 0!==m&&d.push(m),m>t&&(F=!0),m=w;else k=n(k),t=
	n(t),a=p?this.getMinorTickInterval():e.tickInterval,a=g("auto"===a?null:a,this._minorAutoInterval,e.tickPixelInterval/(p?5:1)*(t-k)/((p?c/this.tickPositions.length:c)||1)),a=q(a,null,A(a)),d=D(this.getLinearTickPositions(a,k,t),y),p||(this._minorAutoInterval=a/5);p||(this.tickInterval=a);return d};z.prototype.log2lin=function(a){return Math.log(a)/Math.LN10};z.prototype.lin2log=function(a){return Math.pow(10,a)}})(L);(function(a,z){var A=a.arrayMax,D=a.arrayMin,q=a.defined,g=a.destroyObjectProperties,
	e=a.each,k=a.erase,t=a.merge,p=a.pick;a.PlotLineOrBand=function(a,c){this.axis=a;c&&(this.options=c,this.id=c.id)};a.PlotLineOrBand.prototype={render:function(){var e=this,c=e.axis,n=c.horiz,g=e.options,d=g.label,b=e.label,h=g.to,w=g.from,m=g.value,k=q(w)&&q(h),J=q(m),C=e.svgElem,H=!C,u=[],G=p(g.zIndex,0),v=g.events,u={"class":"highcharts-plot-"+(k?"band ":"line ")+(g.className||"")},E={},x=c.chart.renderer,I=k?"bands":"lines",f;f=c.log2lin;c.isLog&&(w=f(w),h=f(h),m=f(m));E.zIndex=G;I+="-"+G;(f=c.plotLinesAndBandsGroups[I])||
	(c.plotLinesAndBandsGroups[I]=f=x.g("plot-"+I).attr(E).add());H&&(e.svgElem=C=x.path().attr(u).add(f));if(J)u=c.getPlotLinePath(m,C.strokeWidth());else if(k)u=c.getPlotBandPath(w,h,g);else return;H&&u&&u.length?(C.attr({d:u}),v&&a.objectEach(v,function(a,b){C.on(b,function(a){v[b].apply(e,[a])})})):C&&(u?(C.show(),C.animate({d:u})):(C.hide(),b&&(e.label=b=b.destroy())));d&&q(d.text)&&u&&u.length&&0<c.width&&0<c.height&&!u.flat?(d=t({align:n&&k&&"center",x:n?!k&&4:10,verticalAlign:!n&&k&&"middle",
	y:n?k?16:10:k?6:-4,rotation:n&&!k&&90},d),this.renderLabel(d,u,k,G)):b&&b.hide();return e},renderLabel:function(a,c,e,g){var d=this.label,b=this.axis.chart.renderer;d||(d={align:a.textAlign||a.align,rotation:a.rotation,"class":"highcharts-plot-"+(e?"band":"line")+"-label "+(a.className||"")},d.zIndex=g,this.label=d=b.text(a.text,0,0,a.useHTML).attr(d).add());g=c.xBounds||[c[1],c[4],e?c[6]:c[1]];c=c.yBounds||[c[2],c[5],e?c[7]:c[2]];e=D(g);b=D(c);d.align(a,!1,{x:e,y:b,width:A(g)-e,height:A(c)-b});d.show()},
	destroy:function(){k(this.axis.plotLinesAndBands,this);delete this.axis;g(this)}};a.extend(z.prototype,{getPlotBandPath:function(a,c){var e=this.getPlotLinePath(c,null,null,!0),g=this.getPlotLinePath(a,null,null,!0),d=[],b=this.horiz,h=1,w;a=a<this.min&&c<this.min||a>this.max&&c>this.max;if(g&&e)for(a&&(w=g.toString()===e.toString(),h=0),a=0;a<g.length;a+=6)b&&e[a+1]===g[a+1]?(e[a+1]+=h,e[a+4]+=h):b||e[a+2]!==g[a+2]||(e[a+2]+=h,e[a+5]+=h),d.push("M",g[a+1],g[a+2],"L",g[a+4],g[a+5],e[a+4],e[a+5],e[a+
	1],e[a+2],"z"),d.flat=w;return d},addPlotBand:function(a){return this.addPlotBandOrLine(a,"plotBands")},addPlotLine:function(a){return this.addPlotBandOrLine(a,"plotLines")},addPlotBandOrLine:function(e,c){var n=(new a.PlotLineOrBand(this,e)).render(),g=this.userOptions;n&&(c&&(g[c]=g[c]||[],g[c].push(e)),this.plotLinesAndBands.push(n));return n},removePlotBandOrLine:function(a){for(var c=this.plotLinesAndBands,n=this.options,g=this.userOptions,d=c.length;d--;)c[d].id===a&&c[d].destroy();e([n.plotLines||
	[],g.plotLines||[],n.plotBands||[],g.plotBands||[]],function(b){for(d=b.length;d--;)b[d].id===a&&k(b,b[d])})},removePlotBand:function(a){this.removePlotBandOrLine(a)},removePlotLine:function(a){this.removePlotBandOrLine(a)}})})(L,U);(function(a){var z=a.dateFormat,A=a.each,D=a.extend,q=a.format,g=a.isNumber,e=a.map,k=a.merge,t=a.pick,p=a.splat,l=a.syncTimeout,c=a.timeUnits;a.Tooltip=function(){this.init.apply(this,arguments)};a.Tooltip.prototype={init:function(a,c){this.chart=a;this.options=c;this.crosshairs=
	[];this.now={x:0,y:0};this.isHidden=!0;this.split=c.split&&!a.inverted;this.shared=c.shared||this.split},cleanSplit:function(a){A(this.chart.series,function(c){var d=c&&c.tt;d&&(!d.isActive||a?c.tt=d.destroy():d.isActive=!1)})},applyFilter:function(){var a=this.chart;a.renderer.definition({tagName:"filter",id:"drop-shadow-"+a.index,opacity:.5,children:[{tagName:"feGaussianBlur",in:"SourceAlpha",stdDeviation:1},{tagName:"feOffset",dx:1,dy:1},{tagName:"feComponentTransfer",children:[{tagName:"feFuncA",
	type:"linear",slope:.3}]},{tagName:"feMerge",children:[{tagName:"feMergeNode"},{tagName:"feMergeNode",in:"SourceGraphic"}]}]});a.renderer.definition({tagName:"style",textContent:".highcharts-tooltip-"+a.index+"{filter:url(#drop-shadow-"+a.index+")}"})},getLabel:function(){var a=this.chart.renderer,c=this.options;this.label||(this.label=this.split?a.g("tooltip"):a.label("",0,0,c.shape||"callout",null,null,c.useHTML,null,"tooltip").attr({padding:c.padding,r:c.borderRadius}),this.applyFilter(),this.label.addClass("highcharts-tooltip-"+
	this.chart.index),this.label.attr({zIndex:8}).add());return this.label},update:function(a){this.destroy();k(!0,this.chart.options.tooltip.userOptions,a);this.init(this.chart,k(!0,this.options,a))},destroy:function(){this.label&&(this.label=this.label.destroy());this.split&&this.tt&&(this.cleanSplit(this.chart,!0),this.tt=this.tt.destroy());clearTimeout(this.hideTimer);clearTimeout(this.tooltipTimeout)},move:function(a,c,d,b){var h=this,e=h.now,m=!1!==h.options.animation&&!h.isHidden&&(1<Math.abs(a-
	e.x)||1<Math.abs(c-e.y)),n=h.followPointer||1<h.len;D(e,{x:m?(2*e.x+a)/3:a,y:m?(e.y+c)/2:c,anchorX:n?void 0:m?(2*e.anchorX+d)/3:d,anchorY:n?void 0:m?(e.anchorY+b)/2:b});h.getLabel().attr(e);m&&(clearTimeout(this.tooltipTimeout),this.tooltipTimeout=setTimeout(function(){h&&h.move(a,c,d,b)},32))},hide:function(a){var c=this;clearTimeout(this.hideTimer);a=t(a,this.options.hideDelay,500);this.isHidden||(this.hideTimer=l(function(){c.getLabel()[a?"fadeOut":"hide"]();c.isHidden=!0},a))},getAnchor:function(a,
	c){var d,b=this.chart,h=b.inverted,w=b.plotTop,m=b.plotLeft,g=0,n=0,k,l;a=p(a);d=a[0].tooltipPos;this.followPointer&&c&&(void 0===c.chartX&&(c=b.pointer.normalize(c)),d=[c.chartX-b.plotLeft,c.chartY-w]);d||(A(a,function(a){k=a.series.yAxis;l=a.series.xAxis;g+=a.plotX+(!h&&l?l.left-m:0);n+=(a.plotLow?(a.plotLow+a.plotHigh)/2:a.plotY)+(!h&&k?k.top-w:0)}),g/=a.length,n/=a.length,d=[h?b.plotWidth-n:g,this.shared&&!h&&1<a.length&&c?c.chartY-w:h?b.plotHeight-g:n]);return e(d,Math.round)},getPosition:function(a,
	c,d){var b=this.chart,h=this.distance,e={},m=b.inverted&&d.h||0,g,n=["y",b.chartHeight,c,d.plotY+b.plotTop,b.plotTop,b.plotTop+b.plotHeight],k=["x",b.chartWidth,a,d.plotX+b.plotLeft,b.plotLeft,b.plotLeft+b.plotWidth],l=!this.followPointer&&t(d.ttBelow,!b.inverted===!!d.negative),u=function(a,b,f,d,c,v){var x=f<d-h,w=d+h+f<b,r=d-h-f;d+=h;if(l&&w)e[a]=d;else if(!l&&x)e[a]=r;else if(x)e[a]=Math.min(v-f,0>r-m?r:r-m);else if(w)e[a]=Math.max(c,d+m+f>b?d:d+m);else return!1},p=function(a,b,f,d){var c;d<h||
	d>b-h?c=!1:e[a]=d<f/2?1:d>b-f/2?b-f-2:d-f/2;return c},v=function(a){var b=n;n=k;k=b;g=a},E=function(){!1!==u.apply(0,n)?!1!==p.apply(0,k)||g||(v(!0),E()):g?e.x=e.y=0:(v(!0),E())};(b.inverted||1<this.len)&&v();E();return e},defaultFormatter:function(a){var c=this.points||p(this),d;d=[a.tooltipFooterHeaderFormatter(c[0])];d=d.concat(a.bodyFormatter(c));d.push(a.tooltipFooterHeaderFormatter(c[0],!0));return d},refresh:function(a,c){var d,b=this.options,h=a,e,m={},g=[];d=b.formatter||this.defaultFormatter;
	var m=this.shared,n;b.enabled&&(clearTimeout(this.hideTimer),this.followPointer=p(h)[0].series.tooltipOptions.followPointer,e=this.getAnchor(h,c),c=e[0],b=e[1],!m||h.series&&h.series.noSharedTooltip?m=h.getLabelConfig():(A(h,function(a){a.setState("hover");g.push(a.getLabelConfig())}),m={x:h[0].category,y:h[0].y},m.points=g,h=h[0]),this.len=g.length,m=d.call(m,this),n=h.series,this.distance=t(n.tooltipOptions.distance,16),!1===m?this.hide():(d=this.getLabel(),this.isHidden&&d.attr({opacity:1}).show(),
	this.split?this.renderSplit(m,p(a)):(d.css({width:this.chart.spacingBox.width}),d.attr({text:m&&m.join?m.join(""):m}),d.removeClass(/highcharts-color-[\d]+/g).addClass("highcharts-color-"+t(h.colorIndex,n.colorIndex)),this.updatePosition({plotX:c,plotY:b,negative:h.negative,ttBelow:h.ttBelow,h:e[2]||0})),this.isHidden=!1))},renderSplit:function(c,e){var d=this,b=[],h=this.chart,w=h.renderer,m=!0,g=this.options,n=0,k=this.getLabel();a.isString(c)&&(c=[!1,c]);A(c.slice(0,e.length+1),function(a,c){if(!1!==
	a){c=e[c-1]||{isHeader:!0,plotX:e[0].plotX};var u=c.series||d,v=u.tt,E="highcharts-color-"+t(c.colorIndex,(c.series||{}).colorIndex,"none");v||(u.tt=v=w.label(null,null,null,"callout",null,null,g.useHTML).addClass("highcharts-tooltip-box "+E).attr({padding:g.padding,r:g.borderRadius}).add(k));v.isActive=!0;v.attr({text:a});a=v.getBBox();E=a.width+v.strokeWidth();c.isHeader?(n=a.height,E=Math.max(0,Math.min(c.plotX+h.plotLeft-E/2,h.chartWidth-E))):E=c.plotX+h.plotLeft-t(g.distance,16)-E;0>E&&(m=!1);
	a=(c.series&&c.series.yAxis&&c.series.yAxis.pos)+(c.plotY||0);a-=h.plotTop;b.push({target:c.isHeader?h.plotHeight+n:a,rank:c.isHeader?1:0,size:u.tt.getBBox().height+1,point:c,x:E,tt:v})}});this.cleanSplit();a.distribute(b,h.plotHeight+n);A(b,function(a){var b=a.point,d=b.series;a.tt.attr({visibility:void 0===a.pos?"hidden":"inherit",x:m||b.isHeader?a.x:b.plotX+h.plotLeft+t(g.distance,16),y:a.pos+h.plotTop,anchorX:b.isHeader?b.plotX+h.plotLeft:b.plotX+d.xAxis.pos,anchorY:b.isHeader?a.pos+h.plotTop-
	15:b.plotY+d.yAxis.pos})})},updatePosition:function(a){var c=this.chart,d=this.getLabel(),d=(this.options.positioner||this.getPosition).call(this,d.width,d.height,a);this.move(Math.round(d.x),Math.round(d.y||0),a.plotX+c.plotLeft,a.plotY+c.plotTop)},getDateFormat:function(a,e,d,b){var h=z("%m-%d %H:%M:%S.%L",e),g,m,n={millisecond:15,second:12,minute:9,hour:6,day:3},k="millisecond";for(m in c){if(a===c.week&&+z("%w",e)===d&&"00:00:00.000"===h.substr(6)){m="week";break}if(c[m]>a){m=k;break}if(n[m]&&
	h.substr(n[m])!=="01-01 00:00:00.000".substr(n[m]))break;"week"!==m&&(k=m)}m&&(g=b[m]);return g},getXDateFormat:function(a,c,d){c=c.dateTimeLabelFormats;var b=d&&d.closestPointRange;return(b?this.getDateFormat(b,a.x,d.options.startOfWeek,c):c.day)||c.year},tooltipFooterHeaderFormatter:function(a,c){c=c?"footer":"header";var d=a.series,b=d.tooltipOptions,h=b.xDateFormat,e=d.xAxis,m=e&&"datetime"===e.options.type&&g(a.key),n=b[c+"Format"];m&&!h&&(h=this.getXDateFormat(a,b,e));m&&h&&A(a.point&&a.point.tooltipDateKeys||
	["key"],function(a){n=n.replace("{point."+a+"}","{point."+a+":"+h+"}")});return q(n,{point:a,series:d})},bodyFormatter:function(a){return e(a,function(a){var d=a.series.tooltipOptions;return(d[(a.point.formatPrefix||"point")+"Formatter"]||a.point.tooltipFormatter).call(a.point,d[(a.point.formatPrefix||"point")+"Format"])})}}})(L);(function(a){var z=a.addEvent,A=a.attr,D=a.charts,q=a.css,g=a.defined,e=a.each,k=a.extend,t=a.find,p=a.fireEvent,l=a.isObject,c=a.offset,n=a.pick,y=a.splat,d=a.Tooltip;a.Pointer=
	function(a,h){this.init(a,h)};a.Pointer.prototype={init:function(a,h){this.options=h;this.chart=a;this.runChartClick=h.chart.events&&!!h.chart.events.click;this.pinchDown=[];this.lastValidTouch={};d&&(a.tooltip=new d(a,h.tooltip),this.followTouchMove=n(h.tooltip.followTouchMove,!0));this.setDOMEvents()},zoomOption:function(a){var b=this.chart,d=b.options.chart,c=d.zoomType||"",b=b.inverted;/touch/.test(a.type)&&(c=n(d.pinchType,c));this.zoomX=a=/x/.test(c);this.zoomY=c=/y/.test(c);this.zoomHor=a&&
	!b||c&&b;this.zoomVert=c&&!b||a&&b;this.hasZoom=a||c},normalize:function(a,h){var b;b=a.touches?a.touches.length?a.touches.item(0):a.changedTouches[0]:a;h||(this.chartPosition=h=c(this.chart.container));return k(a,{chartX:Math.round(b.pageX-h.left),chartY:Math.round(b.pageY-h.top)})},getCoordinates:function(a){var b={xAxis:[],yAxis:[]};e(this.chart.axes,function(h){b[h.isXAxis?"xAxis":"yAxis"].push({axis:h,value:h.toValue(a[h.horiz?"chartX":"chartY"])})});return b},findNearestKDPoint:function(a,h,
	d){var b;e(a,function(a){var c=!(a.noSharedTooltip&&h)&&0>a.options.findNearestPointBy.indexOf("y");a=a.searchPoint(d,c);if((c=l(a,!0))&&!(c=!l(b,!0)))var c=b.distX-a.distX,e=b.dist-a.dist,m=(a.series.group&&a.series.group.zIndex)-(b.series.group&&b.series.group.zIndex),c=0<(0!==c&&h?c:0!==e?e:0!==m?m:b.series.index>a.series.index?-1:1);c&&(b=a)});return b},getPointFromEvent:function(a){a=a.target;for(var b;a&&!b;)b=a.point,a=a.parentNode;return b},getChartCoordinatesFromPoint:function(a,h){var b=
	a.series,d=b.xAxis,b=b.yAxis,c=n(a.clientX,a.plotX);if(d&&b)return h?{chartX:d.len+d.pos-c,chartY:b.len+b.pos-a.plotY}:{chartX:c+d.pos,chartY:a.plotY+b.pos}},getHoverData:function(b,h,d,c,g,k,C){var m,w=[],p=C&&C.isBoosting;c=!(!c||!b);C=h&&!h.stickyTracking?[h]:a.grep(d,function(a){return a.visible&&!(!g&&a.directTouch)&&n(a.options.enableMouseTracking,!0)&&a.stickyTracking});h=(m=c?b:this.findNearestKDPoint(C,g,k))&&m.series;m&&(g&&!h.noSharedTooltip?(C=a.grep(d,function(a){return a.visible&&!(!g&&
	a.directTouch)&&n(a.options.enableMouseTracking,!0)&&!a.noSharedTooltip}),e(C,function(a){var b=t(a.points,function(a){return a.x===m.x&&!a.isNull});l(b)&&(p&&(b=a.getPoint(b)),w.push(b))})):w.push(m));return{hoverPoint:m,hoverSeries:h,hoverPoints:w}},runPointActions:function(b,h){var d=this.chart,c=d.tooltip&&d.tooltip.options.enabled?d.tooltip:void 0,g=c?c.shared:!1,k=h||d.hoverPoint,l=k&&k.series||d.hoverSeries,l=this.getHoverData(k,l,d.series,!!h||l&&l.directTouch&&this.isDirectTouch,g,b,{isBoosting:d.isBoosting}),
	p,k=l.hoverPoint;p=l.hoverPoints;h=(l=l.hoverSeries)&&l.tooltipOptions.followPointer;g=g&&l&&!l.noSharedTooltip;if(k&&(k!==d.hoverPoint||c&&c.isHidden)){e(d.hoverPoints||[],function(b){-1===a.inArray(b,p)&&b.setState()});e(p||[],function(a){a.setState("hover")});if(d.hoverSeries!==l)l.onMouseOver();d.hoverPoint&&d.hoverPoint.firePointEvent("mouseOut");if(!k.series)return;k.firePointEvent("mouseOver");d.hoverPoints=p;d.hoverPoint=k;c&&c.refresh(g?p:k,b)}else h&&c&&!c.isHidden&&(k=c.getAnchor([{}],
	b),c.updatePosition({plotX:k[0],plotY:k[1]}));this.unDocMouseMove||(this.unDocMouseMove=z(d.container.ownerDocument,"mousemove",function(b){var h=D[a.hoverChartIndex];if(h)h.pointer.onDocumentMouseMove(b)}));e(d.axes,function(h){var d=n(h.crosshair.snap,!0),c=d?a.find(p,function(a){return a.series[h.coll]===h}):void 0;c||!d?h.drawCrosshair(b,c):h.hideCrosshair()})},reset:function(a,h){var b=this.chart,d=b.hoverSeries,c=b.hoverPoint,g=b.hoverPoints,k=b.tooltip,n=k&&k.shared?g:c;a&&n&&e(y(n),function(b){b.series.isCartesian&&
	void 0===b.plotX&&(a=!1)});if(a)k&&n&&(k.refresh(n),c&&(c.setState(c.state,!0),e(b.axes,function(a){a.crosshair&&a.drawCrosshair(null,c)})));else{if(c)c.onMouseOut();g&&e(g,function(a){a.setState()});if(d)d.onMouseOut();k&&k.hide(h);this.unDocMouseMove&&(this.unDocMouseMove=this.unDocMouseMove());e(b.axes,function(a){a.hideCrosshair()});this.hoverX=b.hoverPoints=b.hoverPoint=null}},scaleGroups:function(a,h){var b=this.chart,d;e(b.series,function(c){d=a||c.getPlotBox();c.xAxis&&c.xAxis.zoomEnabled&&
	c.group&&(c.group.attr(d),c.markerGroup&&(c.markerGroup.attr(d),c.markerGroup.clip(h?b.clipRect:null)),c.dataLabelsGroup&&c.dataLabelsGroup.attr(d))});b.clipRect.attr(h||b.clipBox)},dragStart:function(a){var b=this.chart;b.mouseIsDown=a.type;b.cancelClick=!1;b.mouseDownX=this.mouseDownX=a.chartX;b.mouseDownY=this.mouseDownY=a.chartY},drag:function(a){var b=this.chart,d=b.options.chart,c=a.chartX,e=a.chartY,g=this.zoomHor,k=this.zoomVert,n=b.plotLeft,l=b.plotTop,p=b.plotWidth,v=b.plotHeight,E,x=this.selectionMarker,
	t=this.mouseDownX,f=this.mouseDownY,r=d.panKey&&a[d.panKey+"Key"];x&&x.touch||(c<n?c=n:c>n+p&&(c=n+p),e<l?e=l:e>l+v&&(e=l+v),this.hasDragged=Math.sqrt(Math.pow(t-c,2)+Math.pow(f-e,2)),10<this.hasDragged&&(E=b.isInsidePlot(t-n,f-l),b.hasCartesianSeries&&(this.zoomX||this.zoomY)&&E&&!r&&!x&&(this.selectionMarker=x=b.renderer.rect(n,l,g?1:p,k?1:v,0).attr({"class":"highcharts-selection-marker",zIndex:7}).add()),x&&g&&(c-=t,x.attr({width:Math.abs(c),x:(0<c?0:c)+t})),x&&k&&(c=e-f,x.attr({height:Math.abs(c),
	y:(0<c?0:c)+f})),E&&!x&&d.panning&&b.pan(a,d.panning)))},drop:function(a){var b=this,d=this.chart,c=this.hasPinched;if(this.selectionMarker){var n={originalEvent:a,xAxis:[],yAxis:[]},l=this.selectionMarker,t=l.attr?l.attr("x"):l.x,H=l.attr?l.attr("y"):l.y,u=l.attr?l.attr("width"):l.width,y=l.attr?l.attr("height"):l.height,v;if(this.hasDragged||c)e(d.axes,function(d){if(d.zoomEnabled&&g(d.min)&&(c||b[{xAxis:"zoomX",yAxis:"zoomY"}[d.coll]])){var h=d.horiz,e="touchend"===a.type?d.minPixelPadding:0,f=
	d.toValue((h?t:H)+e),h=d.toValue((h?t+u:H+y)-e);n[d.coll].push({axis:d,min:Math.min(f,h),max:Math.max(f,h)});v=!0}}),v&&p(d,"selection",n,function(a){d.zoom(k(a,c?{animation:!1}:null))});this.selectionMarker=this.selectionMarker.destroy();c&&this.scaleGroups()}d&&(q(d.container,{cursor:d._cursor}),d.cancelClick=10<this.hasDragged,d.mouseIsDown=this.hasDragged=this.hasPinched=!1,this.pinchDown=[])},onContainerMouseDown:function(a){a=this.normalize(a);this.zoomOption(a);a.preventDefault&&a.preventDefault();
	this.dragStart(a)},onDocumentMouseUp:function(b){D[a.hoverChartIndex]&&D[a.hoverChartIndex].pointer.drop(b)},onDocumentMouseMove:function(a){var b=this.chart,d=this.chartPosition;a=this.normalize(a,d);!d||this.inClass(a.target,"highcharts-tracker")||b.isInsidePlot(a.chartX-b.plotLeft,a.chartY-b.plotTop)||this.reset()},onContainerMouseLeave:function(b){var d=D[a.hoverChartIndex];d&&(b.relatedTarget||b.toElement)&&(d.pointer.reset(),d.pointer.chartPosition=null)},onContainerMouseMove:function(b){var d=
	this.chart;g(a.hoverChartIndex)&&D[a.hoverChartIndex]&&D[a.hoverChartIndex].mouseIsDown||(a.hoverChartIndex=d.index);b=this.normalize(b);b.returnValue=!1;"mousedown"===d.mouseIsDown&&this.drag(b);!this.inClass(b.target,"highcharts-tracker")&&!d.isInsidePlot(b.chartX-d.plotLeft,b.chartY-d.plotTop)||d.openMenu||this.runPointActions(b)},inClass:function(a,d){for(var b;a;){if(b=A(a,"class")){if(-1!==b.indexOf(d))return!0;if(-1!==b.indexOf("highcharts-container"))return!1}a=a.parentNode}},onTrackerMouseOut:function(a){var b=
	this.chart.hoverSeries;a=a.relatedTarget||a.toElement;this.isDirectTouch=!1;if(!(!b||!a||b.stickyTracking||this.inClass(a,"highcharts-tooltip")||this.inClass(a,"highcharts-series-"+b.index)&&this.inClass(a,"highcharts-tracker")))b.onMouseOut()},onContainerClick:function(a){var b=this.chart,d=b.hoverPoint,c=b.plotLeft,e=b.plotTop;a=this.normalize(a);b.cancelClick||(d&&this.inClass(a.target,"highcharts-tracker")?(p(d.series,"click",k(a,{point:d})),b.hoverPoint&&d.firePointEvent("click",a)):(k(a,this.getCoordinates(a)),
	b.isInsidePlot(a.chartX-c,a.chartY-e)&&p(b,"click",a)))},setDOMEvents:function(){var b=this,d=b.chart.container,c=d.ownerDocument;d.onmousedown=function(a){b.onContainerMouseDown(a)};d.onmousemove=function(a){b.onContainerMouseMove(a)};d.onclick=function(a){b.onContainerClick(a)};this.unbindContainerMouseLeave=z(d,"mouseleave",b.onContainerMouseLeave);a.unbindDocumentMouseUp||(a.unbindDocumentMouseUp=z(c,"mouseup",b.onDocumentMouseUp));a.hasTouch&&(d.ontouchstart=function(a){b.onContainerTouchStart(a)},
	d.ontouchmove=function(a){b.onContainerTouchMove(a)},a.unbindDocumentTouchEnd||(a.unbindDocumentTouchEnd=z(c,"touchend",b.onDocumentTouchEnd)))},destroy:function(){var b=this;b.unDocMouseMove&&b.unDocMouseMove();this.unbindContainerMouseLeave();a.chartCount||(a.unbindDocumentMouseUp&&(a.unbindDocumentMouseUp=a.unbindDocumentMouseUp()),a.unbindDocumentTouchEnd&&(a.unbindDocumentTouchEnd=a.unbindDocumentTouchEnd()));clearInterval(b.tooltipTimeout);a.objectEach(b,function(a,d){b[d]=null})}}})(L);(function(a){var z=
	a.charts,A=a.each,D=a.extend,q=a.map,g=a.noop,e=a.pick;D(a.Pointer.prototype,{pinchTranslate:function(a,e,g,l,c,n){this.zoomHor&&this.pinchTranslateDirection(!0,a,e,g,l,c,n);this.zoomVert&&this.pinchTranslateDirection(!1,a,e,g,l,c,n)},pinchTranslateDirection:function(a,e,g,l,c,n,q,d){var b=this.chart,h=a?"x":"y",k=a?"X":"Y",m="chart"+k,p=a?"width":"height",t=b["plot"+(a?"Left":"Top")],C,H,u=d||1,y=b.inverted,v=b.bounds[a?"h":"v"],E=1===e.length,x=e[0][m],I=g[0][m],f=!E&&e[1][m],r=!E&&g[1][m],N;g=
	function(){!E&&20<Math.abs(x-f)&&(u=d||Math.abs(I-r)/Math.abs(x-f));H=(t-I)/u+x;C=b["plot"+(a?"Width":"Height")]/u};g();e=H;e<v.min?(e=v.min,N=!0):e+C>v.max&&(e=v.max-C,N=!0);N?(I-=.8*(I-q[h][0]),E||(r-=.8*(r-q[h][1])),g()):q[h]=[I,r];y||(n[h]=H-t,n[p]=C);n=y?1/u:u;c[p]=C;c[h]=e;l[y?a?"scaleY":"scaleX":"scale"+k]=u;l["translate"+k]=n*t+(I-n*x)},pinch:function(a){var k=this,p=k.chart,l=k.pinchDown,c=a.touches,n=c.length,y=k.lastValidTouch,d=k.hasZoom,b=k.selectionMarker,h={},w=1===n&&(k.inClass(a.target,
	"highcharts-tracker")&&p.runTrackerClick||k.runChartClick),m={};1<n&&(k.initiated=!0);d&&k.initiated&&!w&&a.preventDefault();q(c,function(a){return k.normalize(a)});"touchstart"===a.type?(A(c,function(a,b){l[b]={chartX:a.chartX,chartY:a.chartY}}),y.x=[l[0].chartX,l[1]&&l[1].chartX],y.y=[l[0].chartY,l[1]&&l[1].chartY],A(p.axes,function(a){if(a.zoomEnabled){var b=p.bounds[a.horiz?"h":"v"],d=a.minPixelPadding,c=a.toPixels(e(a.options.min,a.dataMin)),h=a.toPixels(e(a.options.max,a.dataMax)),m=Math.max(c,
	h);b.min=Math.min(a.pos,Math.min(c,h)-d);b.max=Math.max(a.pos+a.len,m+d)}}),k.res=!0):k.followTouchMove&&1===n?this.runPointActions(k.normalize(a)):l.length&&(b||(k.selectionMarker=b=D({destroy:g,touch:!0},p.plotBox)),k.pinchTranslate(l,c,h,b,m,y),k.hasPinched=d,k.scaleGroups(h,m),k.res&&(k.res=!1,this.reset(!1,0)))},touch:function(g,q){var k=this.chart,l,c;if(k.index!==a.hoverChartIndex)this.onContainerMouseLeave({relatedTarget:!0});a.hoverChartIndex=k.index;1===g.touches.length?(g=this.normalize(g),
	(c=k.isInsidePlot(g.chartX-k.plotLeft,g.chartY-k.plotTop))&&!k.openMenu?(q&&this.runPointActions(g),"touchmove"===g.type&&(q=this.pinchDown,l=q[0]?4<=Math.sqrt(Math.pow(q[0].chartX-g.chartX,2)+Math.pow(q[0].chartY-g.chartY,2)):!1),e(l,!0)&&this.pinch(g)):q&&this.reset()):2===g.touches.length&&this.pinch(g)},onContainerTouchStart:function(a){this.zoomOption(a);this.touch(a,!0)},onContainerTouchMove:function(a){this.touch(a)},onDocumentTouchEnd:function(e){z[a.hoverChartIndex]&&z[a.hoverChartIndex].pointer.drop(e)}})})(L);
	(function(a){var z=a.addEvent,A=a.charts,D=a.css,q=a.doc,g=a.extend,e=a.noop,k=a.Pointer,t=a.removeEvent,p=a.win,l=a.wrap;if(!a.hasTouch&&(p.PointerEvent||p.MSPointerEvent)){var c={},n=!!p.PointerEvent,y=function(){var b=[];b.item=function(a){return this[a]};a.objectEach(c,function(a){b.push({pageX:a.pageX,pageY:a.pageY,target:a.target})});return b},d=function(b,d,c,m){"touch"!==b.pointerType&&b.pointerType!==b.MSPOINTER_TYPE_TOUCH||!A[a.hoverChartIndex]||(m(b),m=A[a.hoverChartIndex].pointer,m[d]({type:c,
	target:b.currentTarget,preventDefault:e,touches:y()}))};g(k.prototype,{onContainerPointerDown:function(a){d(a,"onContainerTouchStart","touchstart",function(a){c[a.pointerId]={pageX:a.pageX,pageY:a.pageY,target:a.currentTarget}})},onContainerPointerMove:function(a){d(a,"onContainerTouchMove","touchmove",function(a){c[a.pointerId]={pageX:a.pageX,pageY:a.pageY};c[a.pointerId].target||(c[a.pointerId].target=a.currentTarget)})},onDocumentPointerUp:function(a){d(a,"onDocumentTouchEnd","touchend",function(a){delete c[a.pointerId]})},
	batchMSEvents:function(a){a(this.chart.container,n?"pointerdown":"MSPointerDown",this.onContainerPointerDown);a(this.chart.container,n?"pointermove":"MSPointerMove",this.onContainerPointerMove);a(q,n?"pointerup":"MSPointerUp",this.onDocumentPointerUp)}});l(k.prototype,"init",function(a,d,c){a.call(this,d,c);this.hasZoom&&D(d.container,{"-ms-touch-action":"none","touch-action":"none"})});l(k.prototype,"setDOMEvents",function(a){a.apply(this);(this.hasZoom||this.followTouchMove)&&this.batchMSEvents(z)});
	l(k.prototype,"destroy",function(a){this.batchMSEvents(t);a.call(this)})}})(L);(function(a){var z=a.addEvent,A=a.css,D=a.discardElement,q=a.defined,g=a.each,e=a.isFirefox,k=a.marginNames,t=a.merge,p=a.pick,l=a.setAnimation,c=a.stableSort,n=a.win,y=a.wrap;a.Legend=function(a,b){this.init(a,b)};a.Legend.prototype={init:function(a,b){this.chart=a;this.setOptions(b);b.enabled&&(this.render(),z(this.chart,"endResize",function(){this.legend.positionCheckboxes()}))},setOptions:function(a){var b=p(a.padding,
	8);this.options=a;this.itemMarginTop=a.itemMarginTop||0;this.padding=b;this.initialItemY=b-5;this.itemHeight=this.maxItemWidth=0;this.symbolWidth=p(a.symbolWidth,16);this.pages=[]},update:function(a,b){var d=this.chart;this.setOptions(t(!0,this.options,a));this.destroy();d.isDirtyLegend=d.isDirtyBox=!0;p(b,!0)&&d.redraw()},colorizeItem:function(a,b){a.legendGroup[b?"removeClass":"addClass"]("highcharts-legend-item-hidden")},positionItem:function(a){var b=this.options,d=b.symbolPadding,b=!b.rtl,c=
	a._legendItemPos,e=c[0],c=c[1],g=a.checkbox;(a=a.legendGroup)&&a.element&&a.translate(b?e:this.legendWidth-e-2*d-4,c);g&&(g.x=e,g.y=c)},destroyItem:function(a){var b=a.checkbox;g(["legendItem","legendLine","legendSymbol","legendGroup"],function(b){a[b]&&(a[b]=a[b].destroy())});b&&D(a.checkbox)},destroy:function(){function a(a){this[a]&&(this[a]=this[a].destroy())}g(this.getAllItems(),function(b){g(["legendItem","legendGroup"],a,b)});g("clipRect up down pager nav box title group".split(" "),a,this);
	this.display=null},positionCheckboxes:function(){var a=this.group&&this.group.alignAttr,b,c=this.clipHeight||this.legendHeight,e=this.titleHeight;a&&(b=a.translateY,g(this.allItems,function(d){var h=d.checkbox,m;h&&(m=b+e+h.y+(this.scrollOffset||0)+3,A(h,{left:a.translateX+d.checkboxOffset+h.x-20+"px",top:m+"px",display:m>b-6&&m<b+c-6?"":"none"}))},this))},renderTitle:function(){var a=this.options,b=this.padding,c=a.title,e=0;c.text&&(this.title||(this.title=this.chart.renderer.label(c.text,b-3,b-
	4,null,null,null,a.useHTML,null,"legend-title").attr({zIndex:1}).add(this.group)),a=this.title.getBBox(),e=a.height,this.offsetWidth=a.width,this.contentGroup.attr({translateY:e}));this.titleHeight=e},setText:function(d){var b=this.options;d.legendItem.attr({text:b.labelFormat?a.format(b.labelFormat,d):b.labelFormatter.call(d)})},renderItem:function(a){var b=this.chart,c=b.renderer,d=this.options,e="horizontal"===d.layout,g=this.symbolWidth,n=d.symbolPadding,k=this.padding,l=e?p(d.itemDistance,20):
	0,u=!d.rtl,q=d.width,v=d.itemMarginBottom||0,E=this.itemMarginTop,x=a.legendItem,t=!a.series,f=!t&&a.series.drawLegendSymbol?a.series:a,r=f.options,y=this.createCheckboxForItem&&r&&r.showCheckbox,r=g+n+l+(y?20:0),K=d.useHTML,B=a.options.className;x||(a.legendGroup=c.g("legend-item").addClass("highcharts-"+f.type+"-series highcharts-color-"+a.colorIndex+(B?" "+B:"")+(t?" highcharts-series-"+a.index:"")).attr({zIndex:1}).add(this.scrollGroup),a.legendItem=x=c.text("",u?g+n:-n,this.baseline||0,K).attr({align:u?
	"left":"right",zIndex:2}).add(a.legendGroup),this.baseline||(this.fontMetrics=c.fontMetrics(12,x),this.baseline=this.fontMetrics.f+3+E,x.attr("y",this.baseline)),this.symbolHeight=d.symbolHeight||this.fontMetrics.f,f.drawLegendSymbol(this,a),this.setItemEvents&&this.setItemEvents(a,x,K),y&&this.createCheckboxForItem(a));this.colorizeItem(a,a.visible);x.css({width:(d.itemWidth||d.width||b.spacingBox.width)-r});this.setText(a);c=x.getBBox();g=a.checkboxOffset=d.itemWidth||a.legendItemWidth||c.width+
	r;this.itemHeight=c=Math.round(a.legendItemHeight||c.height||this.symbolHeight);e&&this.itemX-k+g>(q||b.spacingBox.width-2*k-d.x)&&(this.itemX=k,this.itemY+=E+this.lastLineHeight+v,this.lastLineHeight=0);this.maxItemWidth=Math.max(this.maxItemWidth,g);this.lastItemY=E+this.itemY+v;this.lastLineHeight=Math.max(c,this.lastLineHeight);a._legendItemPos=[this.itemX,this.itemY];e?this.itemX+=g:(this.itemY+=E+c+v,this.lastLineHeight=c);this.offsetWidth=q||Math.max((e?this.itemX-k-(a.checkbox?0:l):g)+k,this.offsetWidth)},
	getAllItems:function(){var a=[];g(this.chart.series,function(b){var c=b&&b.options;b&&p(c.showInLegend,q(c.linkedTo)?!1:void 0,!0)&&(a=a.concat(b.legendItems||("point"===c.legendType?b.data:b)))});return a},adjustMargins:function(a,b){var c=this.chart,d=this.options,e=d.align.charAt(0)+d.verticalAlign.charAt(0)+d.layout.charAt(0);d.floating||g([/(lth|ct|rth)/,/(rtv|rm|rbv)/,/(rbh|cb|lbh)/,/(lbv|lm|ltv)/],function(h,g){h.test(e)&&!q(a[g])&&(c[k[g]]=Math.max(c[k[g]],c.legend[(g+1)%2?"legendHeight":
	"legendWidth"]+[1,-1,-1,1][g]*d[g%2?"x":"y"]+p(d.margin,12)+b[g]))})},render:function(){var a=this,b=a.chart,h=b.renderer,e=a.group,m,n,k,l,p=a.box,u=a.options,q=a.padding;a.itemX=q;a.itemY=a.initialItemY;a.offsetWidth=0;a.lastItemY=0;e||(a.group=e=h.g("legend").attr({zIndex:7}).add(),a.contentGroup=h.g().attr({zIndex:1}).add(e),a.scrollGroup=h.g().add(a.contentGroup));a.renderTitle();m=a.getAllItems();c(m,function(a,b){return(a.options&&a.options.legendIndex||0)-(b.options&&b.options.legendIndex||
	0)});u.reversed&&m.reverse();a.allItems=m;a.display=n=!!m.length;a.lastLineHeight=0;g(m,function(b){a.renderItem(b)});k=(u.width||a.offsetWidth)+q;l=a.lastItemY+a.lastLineHeight+a.titleHeight;l=a.handleOverflow(l);l+=q;p||(a.box=p=h.rect().addClass("highcharts-legend-box").attr({r:u.borderRadius}).add(e),p.isNew=!0);0<k&&0<l&&(p[p.isNew?"attr":"animate"](p.crisp.call({},{x:0,y:0,width:k,height:l},p.strokeWidth())),p.isNew=!1);p[n?"show":"hide"]();"none"===e.getStyle("display")&&(k=l=0);a.legendWidth=
	k;a.legendHeight=l;g(m,function(b){a.positionItem(b)});n&&e.align(t(u,{width:k,height:l}),!0,"spacingBox");b.isResizing||this.positionCheckboxes()},handleOverflow:function(a){var b=this,c=this.chart,d=c.renderer,e=this.options,k=e.y,n=this.padding,c=c.spacingBox.height+("top"===e.verticalAlign?-k:k)-n,k=e.maxHeight,l,q=this.clipRect,u=e.navigation,t=p(u.animation,!0),v=u.arrowSize||12,E=this.nav,x=this.pages,I,f=this.allItems,r=function(a){"number"===typeof a?q.attr({height:a}):q&&(b.clipRect=q.destroy(),
	b.contentGroup.clip());b.contentGroup.div&&(b.contentGroup.div.style.clip=a?"rect("+n+"px,9999px,"+(n+a)+"px,0)":"auto")};"horizontal"!==e.layout||"middle"===e.verticalAlign||e.floating||(c/=2);k&&(c=Math.min(c,k));x.length=0;a>c&&!1!==u.enabled?(this.clipHeight=l=Math.max(c-20-this.titleHeight-n,0),this.currentPage=p(this.currentPage,1),this.fullHeight=a,g(f,function(a,b){var c=a._legendItemPos[1];a=Math.round(a.legendItem.getBBox().height);var d=x.length;if(!d||c-x[d-1]>l&&(I||c)!==x[d-1])x.push(I||
	c),d++;b===f.length-1&&c+a-x[d-1]>l&&x.push(c);c!==I&&(I=c)}),q||(q=b.clipRect=d.clipRect(0,n,9999,0),b.contentGroup.clip(q)),r(l),E||(this.nav=E=d.g().attr({zIndex:1}).add(this.group),this.up=d.symbol("triangle",0,0,v,v).on("click",function(){b.scroll(-1,t)}).add(E),this.pager=d.text("",15,10).addClass("highcharts-legend-navigation").add(E),this.down=d.symbol("triangle-down",0,0,v,v).on("click",function(){b.scroll(1,t)}).add(E)),b.scroll(0),a=c):E&&(r(),this.nav=E.destroy(),this.scrollGroup.attr({translateY:1}),
	this.clipHeight=0);return a},scroll:function(a,b){var c=this.pages,d=c.length;a=this.currentPage+a;var e=this.clipHeight,g=this.pager,k=this.padding;a>d&&(a=d);0<a&&(void 0!==b&&l(b,this.chart),this.nav.attr({translateX:k,translateY:e+this.padding+7+this.titleHeight,visibility:"visible"}),this.up.attr({"class":1===a?"highcharts-legend-nav-inactive":"highcharts-legend-nav-active"}),g.attr({text:a+"/"+d}),this.down.attr({x:18+this.pager.getBBox().width,"class":a===d?"highcharts-legend-nav-inactive":
	"highcharts-legend-nav-active"}),this.scrollOffset=-c[a-1]+this.initialItemY,this.scrollGroup.animate({translateY:this.scrollOffset}),this.currentPage=a,this.positionCheckboxes())}};a.LegendSymbolMixin={drawRectangle:function(a,b){var c=a.symbolHeight,d=a.options.squareSymbol;b.legendSymbol=this.chart.renderer.rect(d?(a.symbolWidth-c)/2:0,a.baseline-c+1,d?c:a.symbolWidth,c,p(a.options.symbolRadius,c/2)).addClass("highcharts-point").attr({zIndex:3}).add(b.legendGroup)},drawLineMarker:function(a){var b=
	this.options.marker,c,d=a.symbolWidth,e=a.symbolHeight;c=e/2;var g=this.chart.renderer,k=this.legendGroup;a=a.baseline-Math.round(.3*a.fontMetrics.b);this.legendLine=g.path(["M",0,a,"L",d,a]).addClass("highcharts-graph").attr({}).add(k);b&&!1!==b.enabled&&(c=Math.min(p(b.radius,c),c),0===this.symbol.indexOf("url")&&(b=t(b,{width:e,height:e}),c=0),this.legendSymbol=b=g.symbol(this.symbol,d/2-c,a-c,2*c,2*c,b).addClass("highcharts-point").add(k),b.isMarker=!0)}};(/Trident\/7\.0/.test(n.navigator.userAgent)||
	e)&&y(a.Legend.prototype,"positionItem",function(a,b){var c=this,d=function(){b._legendItemPos&&a.call(c,b)};d();setTimeout(d)})})(L);(function(a){var z=a.addEvent,A=a.animObject,D=a.attr,q=a.doc,g=a.Axis,e=a.createElement,k=a.defaultOptions,t=a.discardElement,p=a.charts,l=a.defined,c=a.each,n=a.extend,y=a.find,d=a.fireEvent,b=a.grep,h=a.isNumber,w=a.isObject,m=a.isString,F=a.Legend,J=a.marginNames,C=a.merge,H=a.objectEach,u=a.Pointer,G=a.pick,v=a.pInt,E=a.removeEvent,x=a.seriesTypes,I=a.splat,f=
	a.svg,r=a.syncTimeout,N=a.win,K=a.Chart=function(){this.getArgs.apply(this,arguments)};a.chart=function(a,b,c){return new K(a,b,c)};n(K.prototype,{callbacks:[],getArgs:function(){var a=[].slice.call(arguments);if(m(a[0])||a[0].nodeName)this.renderTo=a.shift();this.init(a[0],a[1])},init:function(b,c){var f,d,h=b.series,e=b.plotOptions||{};b.series=null;f=C(k,b);for(d in f.plotOptions)f.plotOptions[d].tooltip=e[d]&&C(e[d].tooltip)||void 0;f.tooltip.userOptions=b.chart&&b.chart.forExport&&b.tooltip.userOptions||
	b.tooltip;f.series=b.series=h;this.userOptions=b;b=f.chart;d=b.events;this.margin=[];this.spacing=[];this.bounds={h:{},v:{}};this.labelCollectors=[];this.callback=c;this.isResizing=0;this.options=f;this.axes=[];this.series=[];this.hasCartesianSeries=b.showAxes;var v=this;v.index=p.length;p.push(v);a.chartCount++;d&&H(d,function(a,b){z(v,b,a)});v.xAxis=[];v.yAxis=[];v.pointCount=v.colorCounter=v.symbolCounter=0;v.firstRender()},initSeries:function(b){var c=this.options.chart;(c=x[b.type||c.type||c.defaultSeriesType])||
	a.error(17,!0);c=new c;c.init(this,b);return c},orderSeries:function(a){var b=this.series;for(a=a||0;a<b.length;a++)b[a]&&(b[a].index=a,b[a].name=b[a].name||"Series "+(b[a].index+1))},isInsidePlot:function(a,b,c){var f=c?b:a;a=c?a:b;return 0<=f&&f<=this.plotWidth&&0<=a&&a<=this.plotHeight},redraw:function(b){var f=this.axes,h=this.series,e=this.pointer,v=this.legend,g=this.isDirtyLegend,x,m,k=this.hasCartesianSeries,r=this.isDirtyBox,l,B=this.renderer,E=B.isHidden(),u=[];this.setResponsive&&this.setResponsive(!1);
	a.setAnimation(b,this);E&&this.temporaryDisplay();this.layOutTitles();for(b=h.length;b--;)if(l=h[b],l.options.stacking&&(x=!0,l.isDirty)){m=!0;break}if(m)for(b=h.length;b--;)l=h[b],l.options.stacking&&(l.isDirty=!0);c(h,function(a){a.isDirty&&"point"===a.options.legendType&&(a.updateTotals&&a.updateTotals(),g=!0);a.isDirtyData&&d(a,"updatedData")});g&&v.options.enabled&&(v.render(),this.isDirtyLegend=!1);x&&this.getStacks();k&&c(f,function(a){a.updateNames();a.setScale()});this.getMargins();k&&(c(f,
	function(a){a.isDirty&&(r=!0)}),c(f,function(a){var b=a.min+","+a.max;a.extKey!==b&&(a.extKey=b,u.push(function(){d(a,"afterSetExtremes",n(a.eventArgs,a.getExtremes()));delete a.eventArgs}));(r||x)&&a.redraw()}));r&&this.drawChartBox();d(this,"predraw");c(h,function(a){(r||a.isDirty)&&a.visible&&a.redraw();a.isDirtyData=!1});e&&e.reset(!0);B.draw();d(this,"redraw");d(this,"render");E&&this.temporaryDisplay(!0);c(u,function(a){a.call()})},get:function(a){function b(b){return b.id===a||b.options&&b.options.id===
	a}var c,f=this.series,d;c=y(this.axes,b)||y(this.series,b);for(d=0;!c&&d<f.length;d++)c=y(f[d].points||[],b);return c},getAxes:function(){var a=this,b=this.options,f=b.xAxis=I(b.xAxis||{}),b=b.yAxis=I(b.yAxis||{});c(f,function(a,b){a.index=b;a.isX=!0});c(b,function(a,b){a.index=b});f=f.concat(b);c(f,function(b){new g(a,b)})},getSelectedPoints:function(){var a=[];c(this.series,function(c){a=a.concat(b(c.data||[],function(a){return a.selected}))});return a},getSelectedSeries:function(){return b(this.series,
	function(a){return a.selected})},setTitle:function(a,b,f){var d=this,h=d.options,e;e=h.title=C(h.title,a);h=h.subtitle=C(h.subtitle,b);c([["title",a,e],["subtitle",b,h]],function(a,b){var c=a[0],f=d[c],h=a[1];a=a[2];f&&h&&(d[c]=f=f.destroy());a&&!f&&(d[c]=d.renderer.text(a.text,0,0,a.useHTML).attr({align:a.align,"class":"highcharts-"+c,zIndex:a.zIndex||4}).add(),d[c].update=function(a){d.setTitle(!b&&a,b&&a)})});d.layOutTitles(f)},layOutTitles:function(a){var b=0,f,d=this.renderer,h=this.spacingBox;
	c(["title","subtitle"],function(a){var c=this[a],f=this.options[a];a="title"===a?-3:f.verticalAlign?0:b+2;var e;c&&(e=d.fontMetrics(e,c).b,c.css({width:(f.width||h.width+f.widthAdjust)+"px"}).align(n({y:a+e},f),!1,"spacingBox"),f.floating||f.verticalAlign||(b=Math.ceil(b+c.getBBox(f.useHTML).height)))},this);f=this.titleOffset!==b;this.titleOffset=b;!this.isDirtyBox&&f&&(this.isDirtyBox=f,this.hasRendered&&G(a,!0)&&this.isDirtyBox&&this.redraw())},getChartSize:function(){var b=this.options.chart,
	c=b.width,b=b.height,f=this.renderTo;l(c)||(this.containerWidth=a.getStyle(f,"width"));l(b)||(this.containerHeight=a.getStyle(f,"height"));this.chartWidth=Math.max(0,c||this.containerWidth||600);this.chartHeight=Math.max(0,a.relativeLength(b,this.chartWidth)||(1<this.containerHeight?this.containerHeight:400))},temporaryDisplay:function(b){var c=this.renderTo;if(b)for(;c&&c.style;)c.hcOrigStyle&&(a.css(c,c.hcOrigStyle),delete c.hcOrigStyle),c.hcOrigDetached&&(q.body.removeChild(c),c.hcOrigDetached=
	!1),c=c.parentNode;else for(;c&&c.style;){q.body.contains(c)||c.parentNode||(c.hcOrigDetached=!0,q.body.appendChild(c));if("none"===a.getStyle(c,"display",!1)||c.hcOricDetached)c.hcOrigStyle={display:c.style.display,height:c.style.height,overflow:c.style.overflow},b={display:"block",overflow:"hidden"},c!==this.renderTo&&(b.height=0),a.css(c,b),c.offsetWidth||c.style.setProperty("display","block","important");c=c.parentNode;if(c===q.body)break}},setClassName:function(a){this.container.className="highcharts-container "+
	(a||"")},getContainer:function(){var b,c=this.options,f=c.chart,d,g;b=this.renderTo;var x=a.uniqueKey(),r;b||(this.renderTo=b=f.renderTo);m(b)&&(this.renderTo=b=q.getElementById(b));b||a.error(13,!0);d=v(D(b,"data-highcharts-chart"));h(d)&&p[d]&&p[d].hasRendered&&p[d].destroy();D(b,"data-highcharts-chart",this.index);b.innerHTML="";f.skipClone||b.offsetWidth||this.temporaryDisplay();this.getChartSize();d=this.chartWidth;g=this.chartHeight;this.container=b=e("div",{id:x},void 0,b);this._cursor=b.style.cursor;
	this.renderer=new (a[f.renderer]||a.Renderer)(b,d,g,null,f.forExport,c.exporting&&c.exporting.allowHTML);this.setClassName(f.className);for(r in c.defs)this.renderer.definition(c.defs[r]);this.renderer.chartIndex=this.index},getMargins:function(a){var b=this.spacing,c=this.margin,f=this.titleOffset;this.resetMargins();f&&!l(c[0])&&(this.plotTop=Math.max(this.plotTop,f+this.options.title.margin+b[0]));this.legend&&this.legend.display&&this.legend.adjustMargins(c,b);this.extraMargin&&(this[this.extraMargin.type]=
	(this[this.extraMargin.type]||0)+this.extraMargin.value);this.adjustPlotArea&&this.adjustPlotArea();a||this.getAxisMargins()},getAxisMargins:function(){var a=this,b=a.axisOffset=[0,0,0,0],f=a.margin;a.hasCartesianSeries&&c(a.axes,function(a){a.visible&&a.getOffset()});c(J,function(c,d){l(f[d])||(a[c]+=b[d])});a.setChartSize()},reflow:function(b){var c=this,f=c.options.chart,d=c.renderTo,h=l(f.width)&&l(f.height),e=f.width||a.getStyle(d,"width"),f=f.height||a.getStyle(d,"height"),d=b?b.target:N;if(!h&&
	!c.isPrinting&&e&&f&&(d===N||d===q)){if(e!==c.containerWidth||f!==c.containerHeight)clearTimeout(c.reflowTimeout),c.reflowTimeout=r(function(){c.container&&c.setSize(void 0,void 0,!1)},b?100:0);c.containerWidth=e;c.containerHeight=f}},initReflow:function(){var a=this,b;b=z(N,"resize",function(b){a.reflow(b)});z(a,"destroy",b)},setSize:function(b,f,h){var e=this,v=e.renderer;e.isResizing+=1;a.setAnimation(h,e);e.oldChartHeight=e.chartHeight;e.oldChartWidth=e.chartWidth;void 0!==b&&(e.options.chart.width=
	b);void 0!==f&&(e.options.chart.height=f);e.getChartSize();e.setChartSize(!0);v.setSize(e.chartWidth,e.chartHeight,h);c(e.axes,function(a){a.isDirty=!0;a.setScale()});e.isDirtyLegend=!0;e.isDirtyBox=!0;e.layOutTitles();e.getMargins();e.redraw(h);e.oldChartHeight=null;d(e,"resize");r(function(){e&&d(e,"endResize",null,function(){--e.isResizing})},A(void 0).duration)},setChartSize:function(a){var b=this.inverted,f=this.renderer,d=this.chartWidth,h=this.chartHeight,e=this.options.chart,v=this.spacing,
	g=this.clipOffset,x,m,r,k;this.plotLeft=x=Math.round(this.plotLeft);this.plotTop=m=Math.round(this.plotTop);this.plotWidth=r=Math.max(0,Math.round(d-x-this.marginRight));this.plotHeight=k=Math.max(0,Math.round(h-m-this.marginBottom));this.plotSizeX=b?k:r;this.plotSizeY=b?r:k;this.plotBorderWidth=e.plotBorderWidth||0;this.spacingBox=f.spacingBox={x:v[3],y:v[0],width:d-v[3]-v[1],height:h-v[0]-v[2]};this.plotBox=f.plotBox={x:x,y:m,width:r,height:k};d=2*Math.floor(this.plotBorderWidth/2);b=Math.ceil(Math.max(d,
	g[3])/2);f=Math.ceil(Math.max(d,g[0])/2);this.clipBox={x:b,y:f,width:Math.floor(this.plotSizeX-Math.max(d,g[1])/2-b),height:Math.max(0,Math.floor(this.plotSizeY-Math.max(d,g[2])/2-f))};a||c(this.axes,function(a){a.setAxisSize();a.setAxisTranslation()})},resetMargins:function(){var a=this,b=a.options.chart;c(["margin","spacing"],function(f){var d=b[f],h=w(d)?d:[d,d,d,d];c(["Top","Right","Bottom","Left"],function(c,d){a[f][d]=G(b[f+c],h[d])})});c(J,function(b,c){a[b]=G(a.margin[c],a.spacing[c])});a.axisOffset=
	[0,0,0,0];a.clipOffset=[0,0,0,0]},drawChartBox:function(){var a=this.options.chart,b=this.renderer,c=this.chartWidth,f=this.chartHeight,d=this.chartBackground,h=this.plotBackground,e=this.plotBorder,v,g,x=this.plotLeft,m=this.plotTop,r=this.plotWidth,k=this.plotHeight,n=this.plotBox,l=this.clipRect,E=this.clipBox,u="animate";d||(this.chartBackground=d=b.rect().addClass("highcharts-background").add(),u="attr");v=g=d.strokeWidth();d[u]({x:g/2,y:g/2,width:c-g-v%2,height:f-g-v%2,r:a.borderRadius});u=
	"animate";h||(u="attr",this.plotBackground=h=b.rect().addClass("highcharts-plot-background").add());h[u](n);l?l.animate({width:E.width,height:E.height}):this.clipRect=b.clipRect(E);u="animate";e||(u="attr",this.plotBorder=e=b.rect().addClass("highcharts-plot-border").attr({zIndex:1}).add());e[u](e.crisp({x:x,y:m,width:r,height:k},-e.strokeWidth()));this.isDirtyBox=!1},propFromSeries:function(){var a=this,b=a.options.chart,f,d=a.options.series,h,e;c(["inverted","angular","polar"],function(c){f=x[b.type||
	b.defaultSeriesType];e=b[c]||f&&f.prototype[c];for(h=d&&d.length;!e&&h--;)(f=x[d[h].type])&&f.prototype[c]&&(e=!0);a[c]=e})},linkSeries:function(){var a=this,b=a.series;c(b,function(a){a.linkedSeries.length=0});c(b,function(b){var c=b.options.linkedTo;m(c)&&(c=":previous"===c?a.series[b.index-1]:a.get(c))&&c.linkedParent!==b&&(c.linkedSeries.push(b),b.linkedParent=c,b.visible=G(b.options.visible,c.options.visible,b.visible))})},renderSeries:function(){c(this.series,function(a){a.translate();a.render()})},
	renderLabels:function(){var a=this,b=a.options.labels;b.items&&c(b.items,function(c){var f=n(b.style,c.style),d=v(f.left)+a.plotLeft,h=v(f.top)+a.plotTop+12;delete f.left;delete f.top;a.renderer.text(c.html,d,h).attr({zIndex:2}).css(f).add()})},render:function(){var a=this.axes,b=this.renderer,f=this.options,d,h,e;this.setTitle();this.legend=new F(this,f.legend);this.getStacks&&this.getStacks();this.getMargins(!0);this.setChartSize();f=this.plotWidth;d=this.plotHeight=Math.max(this.plotHeight-21,
	0);c(a,function(a){a.setScale()});this.getAxisMargins();h=1.1<f/this.plotWidth;e=1.05<d/this.plotHeight;if(h||e)c(a,function(a){(a.horiz&&h||!a.horiz&&e)&&a.setTickInterval(!0)}),this.getMargins();this.drawChartBox();this.hasCartesianSeries&&c(a,function(a){a.visible&&a.render()});this.seriesGroup||(this.seriesGroup=b.g("series-group").attr({zIndex:3}).add());this.renderSeries();this.renderLabels();this.addCredits();this.setResponsive&&this.setResponsive();this.hasRendered=!0},addCredits:function(a){var b=
	this;a=C(!0,this.options.credits,a);a.enabled&&!this.credits&&(this.credits=this.renderer.text(a.text+(this.mapCredits||""),0,0).addClass("highcharts-credits").on("click",function(){a.href&&(N.location.href=a.href)}).attr({align:a.position.align,zIndex:8}).add().align(a.position),this.credits.update=function(a){b.credits=b.credits.destroy();b.addCredits(a)})},destroy:function(){var b=this,f=b.axes,h=b.series,e=b.container,v,g=e&&e.parentNode;d(b,"destroy");b.renderer.forExport?a.erase(p,b):p[b.index]=
	void 0;a.chartCount--;b.renderTo.removeAttribute("data-highcharts-chart");E(b);for(v=f.length;v--;)f[v]=f[v].destroy();this.scroller&&this.scroller.destroy&&this.scroller.destroy();for(v=h.length;v--;)h[v]=h[v].destroy();c("title subtitle chartBackground plotBackground plotBGImage plotBorder seriesGroup clipRect credits pointer rangeSelector legend resetZoomButton tooltip renderer".split(" "),function(a){var c=b[a];c&&c.destroy&&(b[a]=c.destroy())});e&&(e.innerHTML="",E(e),g&&t(e));H(b,function(a,
	c){delete b[c]})},isReadyToRender:function(){var a=this;return f||N!=N.top||"complete"===q.readyState?!0:(q.attachEvent("onreadystatechange",function(){q.detachEvent("onreadystatechange",a.firstRender);"complete"===q.readyState&&a.firstRender()}),!1)},firstRender:function(){var a=this,b=a.options;if(a.isReadyToRender()){a.getContainer();d(a,"init");a.resetMargins();a.setChartSize();a.propFromSeries();a.getAxes();c(b.series||[],function(b){a.initSeries(b)});a.linkSeries();d(a,"beforeRender");u&&(a.pointer=
	new u(a,b));a.render();if(!a.renderer.imgCount&&a.onload)a.onload();a.temporaryDisplay(!0)}},onload:function(){c([this.callback].concat(this.callbacks),function(a){a&&void 0!==this.index&&a.apply(this,[this])},this);d(this,"load");d(this,"render");l(this.index)&&!1!==this.options.chart.reflow&&this.initReflow();this.onload=null}})})(L);(function(a){var z,A=a.each,D=a.extend,q=a.erase,g=a.fireEvent,e=a.format,k=a.isArray,t=a.isNumber,p=a.pick,l=a.removeEvent;a.Point=z=function(){};a.Point.prototype=
	{init:function(a,e,g){var c=a.chart.options.chart.colorCount;this.series=a;this.applyOptions(e,g);a.options.colorByPoint?(e=a.colorCounter,a.colorCounter++,a.colorCounter===c&&(a.colorCounter=0)):e=a.colorIndex;this.colorIndex=p(this.colorIndex,e);a.chart.pointCount++;return this},applyOptions:function(a,e){var c=this.series,d=c.options.pointValKey||c.pointValKey;a=z.prototype.optionsToObject.call(this,a);D(this,a);this.options=this.options?D(this.options,a):a;a.group&&delete this.group;d&&(this.y=
	this[d]);this.isNull=p(this.isValid&&!this.isValid(),null===this.x||!t(this.y,!0));this.selected&&(this.state="select");"name"in this&&void 0===e&&c.xAxis&&c.xAxis.hasNames&&(this.x=c.xAxis.nameToX(this));void 0===this.x&&c&&(this.x=void 0===e?c.autoIncrement(this):e);return this},optionsToObject:function(a){var c={},e=this.series,d=e.options.keys,b=d||e.pointArrayMap||["y"],h=b.length,g=0,m=0;if(t(a)||null===a)c[b[0]]=a;else if(k(a))for(!d&&a.length>h&&(e=typeof a[0],"string"===e?c.name=a[0]:"number"===
	e&&(c.x=a[0]),g++);m<h;)d&&void 0===a[g]||(c[b[m]]=a[g]),g++,m++;else"object"===typeof a&&(c=a,a.dataLabels&&(e._hasPointLabels=!0),a.marker&&(e._hasPointMarkers=!0));return c},getClassName:function(){return"highcharts-point"+(this.selected?" highcharts-point-select":"")+(this.negative?" highcharts-negative":"")+(this.isNull?" highcharts-null-point":"")+(void 0!==this.colorIndex?" highcharts-color-"+this.colorIndex:"")+(this.options.className?" "+this.options.className:"")+(this.zone&&this.zone.className?
	" "+this.zone.className.replace("highcharts-negative",""):"")},getZone:function(){var a=this.series,e=a.zones,a=a.zoneAxis||"y",g=0,d;for(d=e[g];this[a]>=d.value;)d=e[++g];d&&d.color&&!this.options.color&&(this.color=d.color);return d},destroy:function(){var a=this.series.chart,e=a.hoverPoints,g;a.pointCount--;e&&(this.setState(),q(e,this),e.length||(a.hoverPoints=null));if(this===a.hoverPoint)this.onMouseOut();if(this.graphic||this.dataLabel)l(this),this.destroyElements();this.legendItem&&a.legend.destroyItem(this);
	for(g in this)this[g]=null},destroyElements:function(){for(var a=["graphic","dataLabel","dataLabelUpper","connector","shadowGroup"],e,g=6;g--;)e=a[g],this[e]&&(this[e]=this[e].destroy())},getLabelConfig:function(){return{x:this.category,y:this.y,color:this.color,colorIndex:this.colorIndex,key:this.name||this.category,series:this.series,point:this,percentage:this.percentage,total:this.total||this.stackTotal}},tooltipFormatter:function(a){var c=this.series,g=c.tooltipOptions,d=p(g.valueDecimals,""),
	b=g.valuePrefix||"",h=g.valueSuffix||"";A(c.pointArrayMap||["y"],function(c){c="{point."+c;if(b||h)a=a.replace(c+"}",b+c+"}"+h);a=a.replace(c+"}",c+":,."+d+"f}")});return e(a,{point:this,series:this.series})},firePointEvent:function(a,e,k){var c=this,b=this.series.options;(b.point.events[a]||c.options&&c.options.events&&c.options.events[a])&&this.importEvents();"click"===a&&b.allowPointSelect&&(k=function(a){c.select&&c.select(null,a.ctrlKey||a.metaKey||a.shiftKey)});g(this,a,e,k)},visible:!0}})(L);
	(function(a){var z=a.addEvent,A=a.animObject,D=a.arrayMax,q=a.arrayMin,g=a.correctFloat,e=a.Date,k=a.defaultOptions,t=a.defined,p=a.each,l=a.erase,c=a.extend,n=a.fireEvent,y=a.grep,d=a.isArray,b=a.isNumber,h=a.isString,w=a.merge,m=a.objectEach,F=a.pick,J=a.removeEvent,C=a.splat,H=a.SVGElement,u=a.syncTimeout,G=a.win;a.Series=a.seriesType("line",null,{allowPointSelect:!1,showCheckbox:!1,animation:{duration:1E3},events:{},marker:{radius:4,states:{hover:{animation:{duration:50},enabled:!0,radiusPlus:2}}},
	point:{events:{}},dataLabels:{align:"center",formatter:function(){return null===this.y?"":a.numberFormat(this.y,-1)},verticalAlign:"bottom",x:0,y:0,padding:5},cropThreshold:300,pointRange:0,softThreshold:!0,states:{hover:{animation:{duration:50},lineWidthPlus:1,marker:{},halo:{size:10}},select:{marker:{}}},stickyTracking:!0,turboThreshold:1E3,findNearestPointBy:"x"},{isCartesian:!0,pointClass:a.Point,sorted:!0,requireSorting:!0,directTouch:!1,axisTypes:["xAxis","yAxis"],colorCounter:0,parallelArrays:["x",
	"y"],coll:"series",init:function(a,b){var d=this,e,f=a.series,h;d.chart=a;d.options=b=d.setOptions(b);d.linkedSeries=[];d.bindAxes();c(d,{name:b.name,state:"",visible:!1!==b.visible,selected:!0===b.selected});e=b.events;m(e,function(a,b){z(d,b,a)});if(e&&e.click||b.point&&b.point.events&&b.point.events.click||b.allowPointSelect)a.runTrackerClick=!0;d.getColor();d.getSymbol();p(d.parallelArrays,function(a){d[a+"Data"]=[]});d.setData(b.data,!1);d.isCartesian&&(a.hasCartesianSeries=!0);f.length&&(h=
	f[f.length-1]);d._i=F(h&&h._i,-1)+1;a.orderSeries(this.insert(f))},insert:function(a){var c=this.options.index,d;if(b(c)){for(d=a.length;d--;)if(c>=F(a[d].options.index,a[d]._i)){a.splice(d+1,0,this);break}-1===d&&a.unshift(this);d+=1}else a.push(this);return F(d,a.length-1)},bindAxes:function(){var b=this,c=b.options,d=b.chart,e;p(b.axisTypes||[],function(f){p(d[f],function(a){e=a.options;if(c[f]===e.index||void 0!==c[f]&&c[f]===e.id||void 0===c[f]&&0===e.index)b.insert(a.series),b[f]=a,a.isDirty=
	!0});b[f]||b.optionalAxis===f||a.error(18,!0)})},updateParallelArrays:function(a,c){var d=a.series,e=arguments,f=b(c)?function(b){var f="y"===b&&d.toYData?d.toYData(a):a[b];d[b+"Data"][c]=f}:function(a){Array.prototype[c].apply(d[a+"Data"],Array.prototype.slice.call(e,2))};p(d.parallelArrays,f)},autoIncrement:function(){var a=this.options,b=this.xIncrement,c,d=a.pointIntervalUnit,b=F(b,a.pointStart,0);this.pointInterval=c=F(this.pointInterval,a.pointInterval,1);d&&(a=new e(b),"day"===d?a=+a[e.hcSetDate](a[e.hcGetDate]()+
	c):"month"===d?a=+a[e.hcSetMonth](a[e.hcGetMonth]()+c):"year"===d&&(a=+a[e.hcSetFullYear](a[e.hcGetFullYear]()+c)),c=a-b);this.xIncrement=b+c;return b},setOptions:function(a){var b=this.chart,c=b.options,d=c.plotOptions,f=(b.userOptions||{}).plotOptions||{},e=d[this.type];this.userOptions=a;b=w(e,d.series,a);this.tooltipOptions=w(k.tooltip,k.plotOptions.series&&k.plotOptions.series.tooltip,k.plotOptions[this.type].tooltip,c.tooltip.userOptions,d.series&&d.series.tooltip,d[this.type].tooltip,a.tooltip);
	this.stickyTracking=F(a.stickyTracking,f[this.type]&&f[this.type].stickyTracking,f.series&&f.series.stickyTracking,this.tooltipOptions.shared&&!this.noSharedTooltip?!0:b.stickyTracking);null===e.marker&&delete b.marker;this.zoneAxis=b.zoneAxis;a=this.zones=(b.zones||[]).slice();!b.negativeColor&&!b.negativeFillColor||b.zones||a.push({value:b[this.zoneAxis+"Threshold"]||b.threshold||0,className:"highcharts-negative"});a.length&&t(a[a.length-1].value)&&a.push({});return b},getCyclic:function(a,b,c){var d,
	f=this.chart,e=this.userOptions,h=a+"Index",g=a+"Counter",v=c?c.length:F(f.options.chart[a+"Count"],f[a+"Count"]);b||(d=F(e[h],e["_"+h]),t(d)||(f.series.length||(f[g]=0),e["_"+h]=d=f[g]%v,f[g]+=1),c&&(b=c[d]));void 0!==d&&(this[h]=d);this[a]=b},getColor:function(){this.getCyclic("color")},getSymbol:function(){this.getCyclic("symbol",this.options.marker.symbol,this.chart.options.symbols)},drawLegendSymbol:a.LegendSymbolMixin.drawLineMarker,setData:function(c,e,g,m){var f=this,v=f.points,k=v&&v.length||
	0,l,x=f.options,n=f.chart,u=null,q=f.xAxis,E=x.turboThreshold,w=this.xData,t=this.yData,C=(l=f.pointArrayMap)&&l.length;c=c||[];l=c.length;e=F(e,!0);if(!1!==m&&l&&k===l&&!f.cropped&&!f.hasGroupedData&&f.visible)p(c,function(a,b){v[b].update&&a!==x.data[b]&&v[b].update(a,!1,null,!1)});else{f.xIncrement=null;f.colorCounter=0;p(this.parallelArrays,function(a){f[a+"Data"].length=0});if(E&&l>E){for(g=0;null===u&&g<l;)u=c[g],g++;if(b(u))for(g=0;g<l;g++)w[g]=this.autoIncrement(),t[g]=c[g];else if(d(u))if(C)for(g=
	0;g<l;g++)u=c[g],w[g]=u[0],t[g]=u.slice(1,C+1);else for(g=0;g<l;g++)u=c[g],w[g]=u[0],t[g]=u[1];else a.error(12)}else for(g=0;g<l;g++)void 0!==c[g]&&(u={series:f},f.pointClass.prototype.applyOptions.apply(u,[c[g]]),f.updateParallelArrays(u,g));t&&h(t[0])&&a.error(14,!0);f.data=[];f.options.data=f.userOptions.data=c;for(g=k;g--;)v[g]&&v[g].destroy&&v[g].destroy();q&&(q.minRange=q.userMinRange);f.isDirty=n.isDirtyBox=!0;f.isDirtyData=!!v;g=!1}"point"===x.legendType&&(this.processData(),this.generatePoints());
	e&&n.redraw(g)},processData:function(b){var c=this.xData,d=this.yData,e=c.length,f;f=0;var h,g,v=this.xAxis,m,k=this.options;m=k.cropThreshold;var l=this.getExtremesFromAll||k.getExtremesFromAll,n=this.isCartesian,k=v&&v.val2lin,u=v&&v.isLog,p=this.requireSorting,q,w;if(n&&!this.isDirty&&!v.isDirty&&!this.yAxis.isDirty&&!b)return!1;v&&(b=v.getExtremes(),q=b.min,w=b.max);if(n&&this.sorted&&!l&&(!m||e>m||this.forceCrop))if(c[e-1]<q||c[0]>w)c=[],d=[];else if(c[0]<q||c[e-1]>w)f=this.cropData(this.xData,
	this.yData,q,w),c=f.xData,d=f.yData,f=f.start,h=!0;for(m=c.length||1;--m;)e=u?k(c[m])-k(c[m-1]):c[m]-c[m-1],0<e&&(void 0===g||e<g)?g=e:0>e&&p&&(a.error(15),p=!1);this.cropped=h;this.cropStart=f;this.processedXData=c;this.processedYData=d;this.closestPointRange=g},cropData:function(a,b,c,d){var f=a.length,e=0,h=f,g=F(this.cropShoulder,1),m;for(m=0;m<f;m++)if(a[m]>=c){e=Math.max(0,m-g);break}for(c=m;c<f;c++)if(a[c]>d){h=c+g;break}return{xData:a.slice(e,h),yData:b.slice(e,h),start:e,end:h}},generatePoints:function(){var a=
	this.options,b=a.data,c=this.data,d,f=this.processedXData,e=this.processedYData,h=this.pointClass,g=f.length,m=this.cropStart||0,k,l=this.hasGroupedData,a=a.keys,n,u=[],p;c||l||(c=[],c.length=b.length,c=this.data=c);a&&l&&(this.options.keys=!1);for(p=0;p<g;p++)k=m+p,l?(n=(new h).init(this,[f[p]].concat(C(e[p]))),n.dataGroup=this.groupMap[p]):(n=c[k])||void 0===b[k]||(c[k]=n=(new h).init(this,b[k],f[p])),n&&(n.index=k,u[p]=n);this.options.keys=a;if(c&&(g!==(d=c.length)||l))for(p=0;p<d;p++)p!==m||l||
	(p+=g),c[p]&&(c[p].destroyElements(),c[p].plotX=void 0);this.data=c;this.points=u},getExtremes:function(a){var c=this.yAxis,e=this.processedXData,h,f=[],g=0;h=this.xAxis.getExtremes();var m=h.min,v=h.max,k,l,n,u;a=a||this.stackedYData||this.processedYData||[];h=a.length;for(u=0;u<h;u++)if(l=e[u],n=a[u],k=(b(n,!0)||d(n))&&(!c.positiveValuesOnly||n.length||0<n),l=this.getExtremesFromAll||this.options.getExtremesFromAll||this.cropped||(e[u+1]||l)>=m&&(e[u-1]||l)<=v,k&&l)if(k=n.length)for(;k--;)null!==
	n[k]&&(f[g++]=n[k]);else f[g++]=n;this.dataMin=q(f);this.dataMax=D(f)},translate:function(){this.processedXData||this.processData();this.generatePoints();var a=this.options,c=a.stacking,d=this.xAxis,e=d.categories,f=this.yAxis,h=this.points,m=h.length,k=!!this.modifyValue,l=a.pointPlacement,n="between"===l||b(l),u=a.threshold,p=a.startFromThreshold?u:0,q,w,C,H,y=Number.MAX_VALUE;"between"===l&&(l=.5);b(l)&&(l*=F(a.pointRange||d.pointRange));for(a=0;a<m;a++){var G=h[a],A=G.x,J=G.y;w=G.low;var z=c&&
	f.stacks[(this.negStacks&&J<(p?0:u)?"-":"")+this.stackKey],D;f.positiveValuesOnly&&null!==J&&0>=J&&(G.isNull=!0);G.plotX=q=g(Math.min(Math.max(-1E5,d.translate(A,0,0,0,1,l,"flags"===this.type)),1E5));c&&this.visible&&!G.isNull&&z&&z[A]&&(H=this.getStackIndicator(H,A,this.index),D=z[A],J=D.points[H.key],w=J[0],J=J[1],w===p&&H.key===z[A].base&&(w=F(u,f.min)),f.positiveValuesOnly&&0>=w&&(w=null),G.total=G.stackTotal=D.total,G.percentage=D.total&&G.y/D.total*100,G.stackY=J,D.setOffset(this.pointXOffset||
	0,this.barW||0));G.yBottom=t(w)?f.translate(w,0,1,0,1):null;k&&(J=this.modifyValue(J,G));G.plotY=w="number"===typeof J&&Infinity!==J?Math.min(Math.max(-1E5,f.translate(J,0,1,0,1)),1E5):void 0;G.isInside=void 0!==w&&0<=w&&w<=f.len&&0<=q&&q<=d.len;G.clientX=n?g(d.translate(A,0,0,0,1,l)):q;G.negative=G.y<(u||0);G.category=e&&void 0!==e[G.x]?e[G.x]:G.x;G.isNull||(void 0!==C&&(y=Math.min(y,Math.abs(q-C))),C=q);G.zone=this.zones.length&&G.getZone()}this.closestPointRangePx=y},getValidPoints:function(a,
	b){var c=this.chart;return y(a||this.points||[],function(a){return b&&!c.isInsidePlot(a.plotX,a.plotY,c.inverted)?!1:!a.isNull})},setClip:function(a){var b=this.chart,c=this.options,d=b.renderer,f=b.inverted,e=this.clipBox,h=e||b.clipBox,g=this.sharedClipKey||["_sharedClip",a&&a.duration,a&&a.easing,h.height,c.xAxis,c.yAxis].join(),m=b[g],k=b[g+"m"];m||(a&&(h.width=0,f&&(h.x=b.plotSizeX),b[g+"m"]=k=d.clipRect(f?b.plotSizeX+99:-99,f?-b.plotLeft:-b.plotTop,99,f?b.chartWidth:b.chartHeight)),b[g]=m=d.clipRect(h),
	m.count={length:0});a&&!m.count[this.index]&&(m.count[this.index]=!0,m.count.length+=1);!1!==c.clip&&(this.group.clip(a||e?m:b.clipRect),this.markerGroup.clip(k),this.sharedClipKey=g);a||(m.count[this.index]&&(delete m.count[this.index],--m.count.length),0===m.count.length&&g&&b[g]&&(e||(b[g]=b[g].destroy()),b[g+"m"]&&(b[g+"m"]=b[g+"m"].destroy())))},animate:function(a){var b=this.chart,c=A(this.options.animation),d;a?this.setClip(c):(d=this.sharedClipKey,(a=b[d])&&a.animate({width:b.plotSizeX,x:0},
	c),b[d+"m"]&&b[d+"m"].animate({width:b.plotSizeX+99,x:0},c),this.animate=null)},afterAnimate:function(){this.setClip();n(this,"afterAnimate");this.finishedAnimating=!0},drawPoints:function(){var a=this.points,b=this.chart,c,d,f,e,h=this.options.marker,g,m,k,l=this[this.specialGroup]||this.markerGroup,n,u=F(h.enabled,this.xAxis.isRadial?!0:null,this.closestPointRangePx>=2*h.radius);if(!1!==h.enabled||this._hasPointMarkers)for(c=0;c<a.length;c++)d=a[c],e=d.graphic,g=d.marker||{},m=!!d.marker,f=u&&void 0===
	g.enabled||g.enabled,k=d.isInside,f&&!d.isNull?(f=F(g.symbol,this.symbol),d.hasImage=0===f.indexOf("url"),n=this.markerAttribs(d,d.selected&&"select"),e?e[k?"show":"hide"](!0).animate(n):k&&(0<n.width||d.hasImage)&&(d.graphic=e=b.renderer.symbol(f,n.x,n.y,n.width,n.height,m?g:h).add(l)),e&&e.addClass(d.getClassName(),!0)):e&&(d.graphic=e.destroy())},markerAttribs:function(a,b){var c=this.options.marker,d=a.marker||{},f=F(d.radius,c.radius);b&&(c=c.states[b],b=d.states&&d.states[b],f=F(b&&b.radius,
	c&&c.radius,f+(c&&c.radiusPlus||0)));a.hasImage&&(f=0);a={x:Math.floor(a.plotX)-f,y:a.plotY-f};f&&(a.width=a.height=2*f);return a},destroy:function(){var a=this,b=a.chart,c=/AppleWebKit\/533/.test(G.navigator.userAgent),d,f,e=a.data||[],h,g;n(a,"destroy");J(a);p(a.axisTypes||[],function(b){(g=a[b])&&g.series&&(l(g.series,a),g.isDirty=g.forceRedraw=!0)});a.legendItem&&a.chart.legend.destroyItem(a);for(f=e.length;f--;)(h=e[f])&&h.destroy&&h.destroy();a.points=null;clearTimeout(a.animationTimeout);m(a,
	function(a,b){a instanceof H&&!a.survive&&(d=c&&"group"===b?"hide":"destroy",a[d]())});b.hoverSeries===a&&(b.hoverSeries=null);l(b.series,a);b.orderSeries();m(a,function(b,c){delete a[c]})},getGraphPath:function(a,b,c){var d=this,f=d.options,e=f.step,h,g=[],m=[],k;a=a||d.points;(h=a.reversed)&&a.reverse();(e={right:1,center:2}[e]||e&&3)&&h&&(e=4-e);!f.connectNulls||b||c||(a=this.getValidPoints(a));p(a,function(h,l){var n=h.plotX,v=h.plotY,u=a[l-1];(h.leftCliff||u&&u.rightCliff)&&!c&&(k=!0);h.isNull&&
	!t(b)&&0<l?k=!f.connectNulls:h.isNull&&!b?k=!0:(0===l||k?l=["M",h.plotX,h.plotY]:d.getPointSpline?l=d.getPointSpline(a,h,l):e?(l=1===e?["L",u.plotX,v]:2===e?["L",(u.plotX+n)/2,u.plotY,"L",(u.plotX+n)/2,v]:["L",n,u.plotY],l.push("L",n,v)):l=["L",n,v],m.push(h.x),e&&m.push(h.x),g.push.apply(g,l),k=!1)});g.xMap=m;return d.graphPath=g},drawGraph:function(){var a=this,b=(this.gappedPath||this.getGraphPath).call(this),c=[["graph","highcharts-graph"]];p(this.zones,function(a,b){c.push(["zone-graph-"+b,"highcharts-graph highcharts-zone-graph-"+
	b+" "+(a.className||"")])});p(c,function(c,d){d=c[0];var f=a[d];f?(f.endX=a.preventGraphAnimation?null:b.xMap,f.animate({d:b})):b.length&&(a[d]=a.chart.renderer.path(b).addClass(c[1]).attr({zIndex:1}).add(a.group));f&&(f.startX=b.xMap,f.isArea=b.isArea)})},applyZones:function(){var a=this,b=this.chart,c=b.renderer,d=this.zones,f,e,h=this.clips||[],g,m=this.graph,k=this.area,l=Math.max(b.chartWidth,b.chartHeight),n=this[(this.zoneAxis||"y")+"Axis"],u,q,w=b.inverted,t,C,H,G,y=!1;d.length&&(m||k)&&n&&
	void 0!==n.min&&(q=n.reversed,t=n.horiz,m&&m.hide(),k&&k.hide(),u=n.getExtremes(),p(d,function(d,v){f=q?t?b.plotWidth:0:t?0:n.toPixels(u.min);f=Math.min(Math.max(F(e,f),0),l);e=Math.min(Math.max(Math.round(n.toPixels(F(d.value,u.max),!0)),0),l);y&&(f=e=n.toPixels(u.max));C=Math.abs(f-e);H=Math.min(f,e);G=Math.max(f,e);n.isXAxis?(g={x:w?G:H,y:0,width:C,height:l},t||(g.x=b.plotHeight-g.x)):(g={x:0,y:w?G:H,width:l,height:C},t&&(g.y=b.plotWidth-g.y));h[v]?h[v].animate(g):(h[v]=c.clipRect(g),m&&a["zone-graph-"+
	v].clip(h[v]),k&&a["zone-area-"+v].clip(h[v]));y=d.value>u.max}),this.clips=h)},invertGroups:function(a){function b(){p(["group","markerGroup"],function(b){c[b]&&(d.renderer.isVML&&c[b].attr({width:c.yAxis.len,height:c.xAxis.len}),c[b].width=c.yAxis.len,c[b].height=c.xAxis.len,c[b].invert(a))})}var c=this,d=c.chart,f;c.xAxis&&(f=z(d,"resize",b),z(c,"destroy",f),b(a),c.invertGroups=b)},plotGroup:function(a,b,c,d,f){var e=this[a],h=!e;h&&(this[a]=e=this.chart.renderer.g().attr({zIndex:d||.1}).add(f));
	e.addClass("highcharts-"+b+" highcharts-series-"+this.index+" highcharts-"+this.type+"-series "+(t(this.colorIndex)?"highcharts-color-"+this.colorIndex+" ":"")+(this.options.className||"")+(e.hasClass("highcharts-tracker")?" highcharts-tracker":""),!0);e.attr({visibility:c})[h?"attr":"animate"](this.getPlotBox());return e},getPlotBox:function(){var a=this.chart,b=this.xAxis,c=this.yAxis;a.inverted&&(b=c,c=this.xAxis);return{translateX:b?b.left:a.plotLeft,translateY:c?c.top:a.plotTop,scaleX:1,scaleY:1}},
	render:function(){var a=this,b=a.chart,c,d=a.options,f=!!a.animate&&b.renderer.isSVG&&A(d.animation).duration,e=a.visible?"inherit":"hidden",h=d.zIndex,g=a.hasRendered,m=b.seriesGroup,k=b.inverted;c=a.plotGroup("group","series",e,h,m);a.markerGroup=a.plotGroup("markerGroup","markers",e,h,m);f&&a.animate(!0);c.inverted=a.isCartesian?k:!1;a.drawGraph&&(a.drawGraph(),a.applyZones());a.drawDataLabels&&a.drawDataLabels();a.visible&&a.drawPoints();a.drawTracker&&!1!==a.options.enableMouseTracking&&a.drawTracker();
	a.invertGroups(k);!1===d.clip||a.sharedClipKey||g||c.clip(b.clipRect);f&&a.animate();g||(a.animationTimeout=u(function(){a.afterAnimate()},f));a.isDirty=!1;a.hasRendered=!0},redraw:function(){var a=this.chart,b=this.isDirty||this.isDirtyData,c=this.group,d=this.xAxis,f=this.yAxis;c&&(a.inverted&&c.attr({width:a.plotWidth,height:a.plotHeight}),c.animate({translateX:F(d&&d.left,a.plotLeft),translateY:F(f&&f.top,a.plotTop)}));this.translate();this.render();b&&delete this.kdTree},kdAxisArray:["clientX",
	"plotY"],searchPoint:function(a,b){var c=this.xAxis,d=this.yAxis,f=this.chart.inverted;return this.searchKDTree({clientX:f?c.len-a.chartY+c.pos:a.chartX-c.pos,plotY:f?d.len-a.chartX+d.pos:a.chartY-d.pos},b)},buildKDTree:function(){function a(c,d,e){var f,h;if(h=c&&c.length)return f=b.kdAxisArray[d%e],c.sort(function(a,b){return a[f]-b[f]}),h=Math.floor(h/2),{point:c[h],left:a(c.slice(0,h),d+1,e),right:a(c.slice(h+1),d+1,e)}}this.buildingKdTree=!0;var b=this,c=-1<b.options.findNearestPointBy.indexOf("y")?
	2:1;delete b.kdTree;u(function(){b.kdTree=a(b.getValidPoints(null,!b.directTouch),c,c);b.buildingKdTree=!1},b.options.kdNow?0:1)},searchKDTree:function(a,b){function c(a,b,g,m){var k=b.point,l=d.kdAxisArray[g%m],n,u,v=k;u=t(a[f])&&t(k[f])?Math.pow(a[f]-k[f],2):null;n=t(a[e])&&t(k[e])?Math.pow(a[e]-k[e],2):null;n=(u||0)+(n||0);k.dist=t(n)?Math.sqrt(n):Number.MAX_VALUE;k.distX=t(u)?Math.sqrt(u):Number.MAX_VALUE;l=a[l]-k[l];n=0>l?"left":"right";u=0>l?"right":"left";b[n]&&(n=c(a,b[n],g+1,m),v=n[h]<v[h]?
	n:k);b[u]&&Math.sqrt(l*l)<v[h]&&(a=c(a,b[u],g+1,m),v=a[h]<v[h]?a:v);return v}var d=this,f=this.kdAxisArray[0],e=this.kdAxisArray[1],h=b?"distX":"dist";b=-1<d.options.findNearestPointBy.indexOf("y")?2:1;this.kdTree||this.buildingKdTree||this.buildKDTree();if(this.kdTree)return c(a,this.kdTree,b,b)}})})(L);(function(a){var z=a.Axis,A=a.Chart,D=a.correctFloat,q=a.defined,g=a.destroyObjectProperties,e=a.each,k=a.format,t=a.objectEach,p=a.pick,l=a.Series;a.StackItem=function(a,e,g,d,b){var c=a.chart.inverted;
	this.axis=a;this.isNegative=g;this.options=e;this.x=d;this.total=null;this.points={};this.stack=b;this.rightCliff=this.leftCliff=0;this.alignOptions={align:e.align||(c?g?"left":"right":"center"),verticalAlign:e.verticalAlign||(c?"middle":g?"bottom":"top"),y:p(e.y,c?4:g?14:-6),x:p(e.x,c?g?-6:6:0)};this.textAlign=e.textAlign||(c?g?"right":"left":"center")};a.StackItem.prototype={destroy:function(){g(this,this.axis)},render:function(a){var c=this.options,e=c.format,e=e?k(e,this):c.formatter.call(this);
	this.label?this.label.attr({text:e,visibility:"hidden"}):this.label=this.axis.chart.renderer.text(e,null,null,c.useHTML).css(c.style).attr({align:this.textAlign,rotation:c.rotation,visibility:"hidden"}).add(a)},setOffset:function(a,e){var c=this.axis,d=c.chart,b=c.translate(c.usePercentage?100:this.total,0,0,0,1),c=c.translate(0),c=Math.abs(b-c);a=d.xAxis[0].translate(this.x)+a;b=this.getStackBox(d,this,a,b,e,c);if(e=this.label)e.align(this.alignOptions,null,b),b=e.alignAttr,e[!1===this.options.crop||
	d.isInsidePlot(b.x,b.y)?"show":"hide"](!0)},getStackBox:function(a,e,g,d,b,h){var c=e.axis.reversed,m=a.inverted;a=a.plotHeight;e=e.isNegative&&!c||!e.isNegative&&c;return{x:m?e?d:d-h:g,y:m?a-g-b:e?a-d-h:a-d,width:m?h:b,height:m?b:h}}};A.prototype.getStacks=function(){var a=this;e(a.yAxis,function(a){a.stacks&&a.hasVisibleSeries&&(a.oldStacks=a.stacks)});e(a.series,function(c){!c.options.stacking||!0!==c.visible&&!1!==a.options.chart.ignoreHiddenSeries||(c.stackKey=c.type+p(c.options.stack,""))})};
	z.prototype.buildStacks=function(){var a=this.series,e=p(this.options.reversedStacks,!0),g=a.length,d;if(!this.isXAxis){this.usePercentage=!1;for(d=g;d--;)a[e?d:g-d-1].setStackedPoints();for(d=0;d<g;d++)a[d].modifyStacks()}};z.prototype.renderStackTotals=function(){var a=this.chart,e=a.renderer,g=this.stacks,d=this.stackTotalGroup;d||(this.stackTotalGroup=d=e.g("stack-labels").attr({visibility:"visible",zIndex:6}).add());d.translate(a.plotLeft,a.plotTop);t(g,function(a){t(a,function(a){a.render(d)})})};
	z.prototype.resetStacks=function(){var a=this,e=a.stacks;a.isXAxis||t(e,function(c){t(c,function(d,b){d.touched<a.stacksTouched?(d.destroy(),delete c[b]):(d.total=null,d.cum=null)})})};z.prototype.cleanStacks=function(){var a;this.isXAxis||(this.oldStacks&&(a=this.stacks=this.oldStacks),t(a,function(a){t(a,function(a){a.cum=a.total})}))};l.prototype.setStackedPoints=function(){if(this.options.stacking&&(!0===this.visible||!1===this.chart.options.chart.ignoreHiddenSeries)){var c=this.processedXData,
	e=this.processedYData,g=[],d=e.length,b=this.options,h=b.threshold,k=b.startFromThreshold?h:0,m=b.stack,b=b.stacking,l=this.stackKey,t="-"+l,C=this.negStacks,H=this.yAxis,u=H.stacks,G=H.oldStacks,v,E,x,A,f,r,z;H.stacksTouched+=1;for(f=0;f<d;f++)r=c[f],z=e[f],v=this.getStackIndicator(v,r,this.index),A=v.key,x=(E=C&&z<(k?0:h))?t:l,u[x]||(u[x]={}),u[x][r]||(G[x]&&G[x][r]?(u[x][r]=G[x][r],u[x][r].total=null):u[x][r]=new a.StackItem(H,H.options.stackLabels,E,r,m)),x=u[x][r],null!==z&&(x.points[A]=x.points[this.index]=
	[p(x.cum,k)],q(x.cum)||(x.base=A),x.touched=H.stacksTouched,0<v.index&&!1===this.singleStacks&&(x.points[A][0]=x.points[this.index+","+r+",0"][0])),"percent"===b?(E=E?l:t,C&&u[E]&&u[E][r]?(E=u[E][r],x.total=E.total=Math.max(E.total,x.total)+Math.abs(z)||0):x.total=D(x.total+(Math.abs(z)||0))):x.total=D(x.total+(z||0)),x.cum=p(x.cum,k)+(z||0),null!==z&&(x.points[A].push(x.cum),g[f]=x.cum);"percent"===b&&(H.usePercentage=!0);this.stackedYData=g;H.oldStacks={}}};l.prototype.modifyStacks=function(){var a=
	this,g=a.stackKey,k=a.yAxis.stacks,d=a.processedXData,b,h=a.options.stacking;a[h+"Stacker"]&&e([g,"-"+g],function(c){for(var e=d.length,g,l;e--;)if(g=d[e],b=a.getStackIndicator(b,g,a.index,c),l=(g=k[c]&&k[c][g])&&g.points[b.key])a[h+"Stacker"](l,g,e)})};l.prototype.percentStacker=function(a,e,g){e=e.total?100/e.total:0;a[0]=D(a[0]*e);a[1]=D(a[1]*e);this.stackedYData[g]=a[1]};l.prototype.getStackIndicator=function(a,e,g,d){!q(a)||a.x!==e||d&&a.key!==d?a={x:e,index:0,key:d}:a.index++;a.key=[g,e,a.index].join();
	return a}})(L);(function(a){var z=a.addEvent,A=a.Axis,D=a.createElement,q=a.css,g=a.defined,e=a.each,k=a.erase,t=a.extend,p=a.fireEvent,l=a.inArray,c=a.isNumber,n=a.isObject,y=a.isArray,d=a.merge,b=a.objectEach,h=a.pick,w=a.Point,m=a.Series,F=a.seriesTypes,J=a.setAnimation,C=a.splat;t(a.Chart.prototype,{addSeries:function(a,b,c){var d,e=this;a&&(b=h(b,!0),p(e,"addSeries",{options:a},function(){d=e.initSeries(a);e.isDirtyLegend=!0;e.linkSeries();b&&e.redraw(c)}));return d},addAxis:function(a,b,c,e){var g=
	b?"xAxis":"yAxis",m=this.options;a=d(a,{index:this[g].length,isX:b});b=new A(this,a);m[g]=C(m[g]||{});m[g].push(a);h(c,!0)&&this.redraw(e);return b},showLoading:function(a){var b=this,c=b.options,d=b.loadingDiv,e=function(){d&&q(d,{left:b.plotLeft+"px",top:b.plotTop+"px",width:b.plotWidth+"px",height:b.plotHeight+"px"})};d||(b.loadingDiv=d=D("div",{className:"highcharts-loading highcharts-loading-hidden"},null,b.container),b.loadingSpan=D("span",{className:"highcharts-loading-inner"},null,d),z(b,
	"redraw",e));d.className="highcharts-loading";b.loadingSpan.innerHTML=a||c.lang.loading;b.loadingShown=!0;e()},hideLoading:function(){var a=this.loadingDiv;a&&(a.className="highcharts-loading highcharts-loading-hidden");this.loadingShown=!1},propsRequireDirtyBox:"backgroundColor borderColor borderWidth margin marginTop marginRight marginBottom marginLeft spacing spacingTop spacingRight spacingBottom spacingLeft borderRadius plotBackgroundColor plotBackgroundImage plotBorderColor plotBorderWidth plotShadow shadow".split(" "),
	propsRequireUpdateSeries:"chart.inverted chart.polar chart.ignoreHiddenSeries chart.type colors plotOptions tooltip".split(" "),update:function(a,m,k){var n=this,u={credits:"addCredits",title:"setTitle",subtitle:"setSubtitle"},p=a.chart,q,f,r=[];if(p){d(!0,n.options.chart,p);"className"in p&&n.setClassName(p.className);if("inverted"in p||"polar"in p)n.propFromSeries(),q=!0;"alignTicks"in p&&(q=!0);b(p,function(a,b){-1!==l("chart."+b,n.propsRequireUpdateSeries)&&(f=!0);-1!==l(b,n.propsRequireDirtyBox)&&
	(n.isDirtyBox=!0)})}a.plotOptions&&d(!0,this.options.plotOptions,a.plotOptions);b(a,function(a,b){if(n[b]&&"function"===typeof n[b].update)n[b].update(a,!1);else if("function"===typeof n[u[b]])n[u[b]](a);"chart"!==b&&-1!==l(b,n.propsRequireUpdateSeries)&&(f=!0)});e("xAxis yAxis zAxis series colorAxis pane".split(" "),function(b){a[b]&&(e(C(a[b]),function(a,c){(c=g(a.id)&&n.get(a.id)||n[b][c])&&c.coll===b&&(c.update(a,!1),k&&(c.touched=!0));if(!c&&k)if("series"===b)n.addSeries(a,!1).touched=!0;else if("xAxis"===
	b||"yAxis"===b)n.addAxis(a,"xAxis"===b,!1).touched=!0}),k&&e(n[b],function(a){a.touched?delete a.touched:r.push(a)}))});e(r,function(a){a.remove(!1)});q&&e(n.axes,function(a){a.update({},!1)});f&&e(n.series,function(a){a.update({},!1)});a.loading&&d(!0,n.options.loading,a.loading);q=p&&p.width;p=p&&p.height;c(q)&&q!==n.chartWidth||c(p)&&p!==n.chartHeight?n.setSize(q,p):h(m,!0)&&n.redraw()},setSubtitle:function(a){this.setTitle(void 0,a)}});t(w.prototype,{update:function(a,b,c,d){function e(){g.applyOptions(a);
	null===g.y&&f&&(g.graphic=f.destroy());n(a,!0)&&(f&&f.element&&a&&a.marker&&void 0!==a.marker.symbol&&(g.graphic=f.destroy()),a&&a.dataLabels&&g.dataLabel&&(g.dataLabel=g.dataLabel.destroy()),g.connector&&(g.connector=g.connector.destroy()));k=g.index;m.updateParallelArrays(g,k);u.data[k]=n(u.data[k],!0)||n(a,!0)?g.options:a;m.isDirty=m.isDirtyData=!0;!m.fixedBox&&m.hasCartesianSeries&&(l.isDirtyBox=!0);"point"===u.legendType&&(l.isDirtyLegend=!0);b&&l.redraw(c)}var g=this,m=g.series,f=g.graphic,
	k,l=m.chart,u=m.options;b=h(b,!0);!1===d?e():g.firePointEvent("update",{options:a},e)},remove:function(a,b){this.series.removePoint(l(this,this.series.data),a,b)}});t(m.prototype,{addPoint:function(a,b,c,d){var e=this.options,g=this.data,m=this.chart,f=this.xAxis,f=f&&f.hasNames&&f.names,k=e.data,l,n,u=this.xData,p,v;b=h(b,!0);l={series:this};this.pointClass.prototype.applyOptions.apply(l,[a]);v=l.x;p=u.length;if(this.requireSorting&&v<u[p-1])for(n=!0;p&&u[p-1]>v;)p--;this.updateParallelArrays(l,
	"splice",p,0,0);this.updateParallelArrays(l,p);f&&l.name&&(f[v]=l.name);k.splice(p,0,a);n&&(this.data.splice(p,0,null),this.processData());"point"===e.legendType&&this.generatePoints();c&&(g[0]&&g[0].remove?g[0].remove(!1):(g.shift(),this.updateParallelArrays(l,"shift"),k.shift()));this.isDirtyData=this.isDirty=!0;b&&m.redraw(d)},removePoint:function(a,b,c){var d=this,e=d.data,g=e[a],m=d.points,f=d.chart,k=function(){m&&m.length===e.length&&m.splice(a,1);e.splice(a,1);d.options.data.splice(a,1);d.updateParallelArrays(g||
	{series:d},"splice",a,1);g&&g.destroy();d.isDirty=!0;d.isDirtyData=!0;b&&f.redraw()};J(c,f);b=h(b,!0);g?g.firePointEvent("remove",null,k):k()},remove:function(a,b,c){function d(){e.destroy();g.isDirtyLegend=g.isDirtyBox=!0;g.linkSeries();h(a,!0)&&g.redraw(b)}var e=this,g=e.chart;!1!==c?p(e,"remove",null,d):d()},update:function(a,b){var c=this,g=c.chart,m=c.userOptions,k=c.oldType||c.type,l=a.type||m.type||g.options.chart.type,f=F[k].prototype,n,u=["group","markerGroup","dataLabelsGroup"],p=["navigatorSeries",
	"baseSeries"],q=c.finishedAnimating&&{animation:!1};if(Object.keys&&"data"===Object.keys(a).toString())return this.setData(a.data,b);if(l&&l!==k||void 0!==a.zIndex)u.length=0;p=u.concat(p);e(p,function(a){p[a]=c[a];delete c[a]});a=d(m,q,{index:c.index,pointStart:c.xData[0]},{data:c.options.data},a);c.remove(!1,null,!1);for(n in f)c[n]=void 0;t(c,F[l||k].prototype);e(p,function(a){c[a]=p[a]});c.init(g,a);c.oldType=k;g.linkSeries();h(b,!0)&&g.redraw(!1)}});t(A.prototype,{update:function(a,b){var c=
	this.chart;a=c.options[this.coll][this.options.index]=d(this.userOptions,a);this.destroy(!0);this.init(c,t(a,{events:void 0}));c.isDirtyBox=!0;h(b,!0)&&c.redraw()},remove:function(a){for(var b=this.chart,c=this.coll,d=this.series,g=d.length;g--;)d[g]&&d[g].remove(!1);k(b.axes,this);k(b[c],this);y(b.options[c])?b.options[c].splice(this.options.index,1):delete b.options[c];e(b[c],function(a,b){a.options.index=b});this.destroy();b.isDirtyBox=!0;h(a,!0)&&b.redraw()},setTitle:function(a,b){this.update({title:a},
	b)},setCategories:function(a,b){this.update({categories:a},b)}})})(L);(function(a){var z=a.each,A=a.map,D=a.pick,q=a.Series,g=a.seriesType;g("area","line",{softThreshold:!1,threshold:0},{singleStacks:!1,getStackPoints:function(e){var g=[],q=[],p=this.xAxis,l=this.yAxis,c=l.stacks[this.stackKey],n={},y=this.index,d=l.series,b=d.length,h,w=D(l.options.reversedStacks,!0)?1:-1,m;e=e||this.points;if(this.options.stacking){for(m=0;m<e.length;m++)e[m].leftNull=e[m].rightNull=null,n[e[m].x]=e[m];a.objectEach(c,
	function(a,b){null!==a.total&&q.push(b)});q.sort(function(a,b){return a-b});h=A(d,function(){return this.visible});z(q,function(a,d){var e=0,k,u;if(n[a]&&!n[a].isNull)g.push(n[a]),z([-1,1],function(e){var g=1===e?"rightNull":"leftNull",l=0,p=c[q[d+e]];if(p)for(m=y;0<=m&&m<b;)k=p.points[m],k||(m===y?n[a][g]=!0:h[m]&&(u=c[a].points[m])&&(l-=u[1]-u[0])),m+=w;n[a][1===e?"rightCliff":"leftCliff"]=l});else{for(m=y;0<=m&&m<b;){if(k=c[a].points[m]){e=k[1];break}m+=w}e=l.translate(e,0,1,0,1);g.push({isNull:!0,
	plotX:p.translate(a,0,0,0,1),x:a,plotY:e,yBottom:e})}})}return g},getGraphPath:function(a){var e=q.prototype.getGraphPath,g=this.options,p=g.stacking,l=this.yAxis,c,n,y=[],d=[],b=this.index,h,w=l.stacks[this.stackKey],m=g.threshold,F=l.getThreshold(g.threshold),A,g=g.connectNulls||"percent"===p,C=function(c,e,g){var k=a[c];c=p&&w[k.x].points[b];var n=k[g+"Null"]||0;g=k[g+"Cliff"]||0;var u,q,k=!0;g||n?(u=(n?c[0]:c[1])+g,q=c[0]+g,k=!!n):!p&&a[e]&&a[e].isNull&&(u=q=m);void 0!==u&&(d.push({plotX:h,plotY:null===
	u?F:l.getThreshold(u),isNull:k,isCliff:!0}),y.push({plotX:h,plotY:null===q?F:l.getThreshold(q),doCurve:!1}))};a=a||this.points;p&&(a=this.getStackPoints(a));for(c=0;c<a.length;c++)if(n=a[c].isNull,h=D(a[c].rectPlotX,a[c].plotX),A=D(a[c].yBottom,F),!n||g)g||C(c,c-1,"left"),n&&!p&&g||(d.push(a[c]),y.push({x:c,plotX:h,plotY:A})),g||C(c,c+1,"right");c=e.call(this,d,!0,!0);y.reversed=!0;n=e.call(this,y,!0,!0);n.length&&(n[0]="L");n=c.concat(n);e=e.call(this,d,!1,g);n.xMap=c.xMap;this.areaPath=n;return e},
	drawGraph:function(){this.areaPath=[];q.prototype.drawGraph.apply(this);var a=this,g=this.areaPath,t=this.options,p=[["area","highcharts-area"]];z(this.zones,function(a,c){p.push(["zone-area-"+c,"highcharts-area highcharts-zone-area-"+c+" "+a.className])});z(p,function(e){var c=e[0],k=a[c];k?(k.endX=a.preventGraphAnimation?null:g.xMap,k.animate({d:g})):(k=a[c]=a.chart.renderer.path(g).addClass(e[1]).attr({zIndex:0}).add(a.group),k.isArea=!0);k.startX=g.xMap;k.shiftUnit=t.step?2:1})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(L);
	(function(a){var z=a.pick;a=a.seriesType;a("spline","line",{},{getPointSpline:function(a,D,q){var g=D.plotX,e=D.plotY,k=a[q-1];q=a[q+1];var t,p,l,c;if(k&&!k.isNull&&!1!==k.doCurve&&!D.isCliff&&q&&!q.isNull&&!1!==q.doCurve&&!D.isCliff){a=k.plotY;l=q.plotX;q=q.plotY;var n=0;t=(1.5*g+k.plotX)/2.5;p=(1.5*e+a)/2.5;l=(1.5*g+l)/2.5;c=(1.5*e+q)/2.5;l!==t&&(n=(c-p)*(l-g)/(l-t)+e-c);p+=n;c+=n;p>a&&p>e?(p=Math.max(a,e),c=2*e-p):p<a&&p<e&&(p=Math.min(a,e),c=2*e-p);c>q&&c>e?(c=Math.max(q,e),p=2*e-c):c<q&&c<e&&
	(c=Math.min(q,e),p=2*e-c);D.rightContX=l;D.rightContY=c}D=["C",z(k.rightContX,k.plotX),z(k.rightContY,k.plotY),z(t,g),z(p,e),g,e];k.rightContX=k.rightContY=null;return D}})})(L);(function(a){var z=a.seriesTypes.area.prototype,A=a.seriesType;A("areaspline","spline",a.defaultPlotOptions.area,{getStackPoints:z.getStackPoints,getGraphPath:z.getGraphPath,drawGraph:z.drawGraph,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle})})(L);(function(a){var z=a.animObject,A=a.each,D=a.extend,q=a.isNumber,g=a.merge,
	e=a.pick,k=a.Series,t=a.seriesType,p=a.svg;t("column","line",{borderRadius:0,crisp:!0,groupPadding:.2,marker:null,pointPadding:.1,minPointLength:0,cropThreshold:50,pointRange:null,states:{hover:{halo:!1}},dataLabels:{align:null,verticalAlign:null,y:null},softThreshold:!1,startFromThreshold:!0,stickyTracking:!1,tooltip:{distance:6},threshold:0},{cropShoulder:0,directTouch:!0,trackerGroups:["group","dataLabelsGroup"],negStacks:!0,init:function(){k.prototype.init.apply(this,arguments);var a=this,c=a.chart;
	c.hasRendered&&A(c.series,function(c){c.type===a.type&&(c.isDirty=!0)})},getColumnMetrics:function(){var a=this,c=a.options,g=a.xAxis,k=a.yAxis,d=g.reversed,b,h={},p=0;!1===c.grouping?p=1:A(a.chart.series,function(c){var d=c.options,e=c.yAxis,g;c.type!==a.type||!c.visible&&a.chart.options.chart.ignoreHiddenSeries||k.len!==e.len||k.pos!==e.pos||(d.stacking?(b=c.stackKey,void 0===h[b]&&(h[b]=p++),g=h[b]):!1!==d.grouping&&(g=p++),c.columnIndex=g)});var m=Math.min(Math.abs(g.transA)*(g.ordinalSlope||
	c.pointRange||g.closestPointRange||g.tickInterval||1),g.len),q=m*c.groupPadding,t=(m-2*q)/(p||1),c=Math.min(c.maxPointWidth||g.len,e(c.pointWidth,t*(1-2*c.pointPadding)));a.columnMetrics={width:c,offset:(t-c)/2+(q+((a.columnIndex||0)+(d?1:0))*t-m/2)*(d?-1:1)};return a.columnMetrics},crispCol:function(a,c,e,g){var d=this.chart,b=this.borderWidth,h=-(b%2?.5:0),b=b%2?.5:1;d.inverted&&d.renderer.isVML&&(b+=1);this.options.crisp&&(e=Math.round(a+e)+h,a=Math.round(a)+h,e-=a);g=Math.round(c+g)+b;h=.5>=Math.abs(c)&&
	.5<g;c=Math.round(c)+b;g-=c;h&&g&&(--c,g+=1);return{x:a,y:c,width:e,height:g}},translate:function(){var a=this,c=a.chart,g=a.options,p=a.dense=2>a.closestPointRange*a.xAxis.transA,p=a.borderWidth=e(g.borderWidth,p?0:1),d=a.yAxis,b=g.threshold,h=a.translatedThreshold=d.getThreshold(b),q=e(g.minPointLength,5),m=a.getColumnMetrics(),t=m.width,z=a.barW=Math.max(t,1+2*p),C=a.pointXOffset=m.offset;c.inverted&&(h-=.5);g.pointPadding&&(z=Math.ceil(z));k.prototype.translate.apply(a);A(a.points,function(g){var m=
	e(g.yBottom,h),k=999+Math.abs(m),k=Math.min(Math.max(-k,g.plotY),d.len+k),l=g.plotX+C,n=z,p=Math.min(k,m),w,f=Math.max(k,m)-p;q&&Math.abs(f)<q&&(f=q,w=!d.reversed&&!g.negative||d.reversed&&g.negative,g.y===b&&a.dataMax<=b&&d.min<b&&(w=!w),p=Math.abs(p-h)>q?m-q:h-(w?q:0));g.barX=l;g.pointWidth=t;g.tooltipPos=c.inverted?[d.len+d.pos-c.plotLeft-k,a.xAxis.len-l-n/2,f]:[l+n/2,k+d.pos-c.plotTop,f];g.shapeType="rect";g.shapeArgs=a.crispCol.apply(a,g.isNull?[l,h,n,0]:[l,p,n,f])})},getSymbol:a.noop,drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,
	drawGraph:function(){this.group[this.dense?"addClass":"removeClass"]("highcharts-dense-data")},drawPoints:function(){var a=this,c=this.chart,e=a.options,k=c.renderer,d=e.animationLimit||250,b;A(a.points,function(h){var l=h.graphic;if(q(h.plotY)&&null!==h.y){b=h.shapeArgs;if(l)l[c.pointCount<d?"animate":"attr"](g(b));else h.graphic=l=k[h.shapeType](b).add(h.group||a.group);e.borderRadius&&l.attr({r:e.borderRadius});l.addClass(h.getClassName(),!0)}else l&&(h.graphic=l.destroy())})},animate:function(a){var c=
	this,e=this.yAxis,g=c.options,d=this.chart.inverted,b={},h=d?"translateX":"translateY",k;p&&(a?(b.scaleY=.001,a=Math.min(e.pos+e.len,Math.max(e.pos,e.toPixels(g.threshold))),d?b.translateX=a-e.len:b.translateY=a,c.group.attr(b)):(k=c.group.attr(h),c.group.animate({scaleY:1},D(z(c.options.animation),{step:function(a,d){b[h]=k+d.pos*(e.pos-k);c.group.attr(b)}})),c.animate=null))},remove:function(){var a=this,c=a.chart;c.hasRendered&&A(c.series,function(c){c.type===a.type&&(c.isDirty=!0)});k.prototype.remove.apply(a,
	arguments)}})})(L);(function(a){a=a.seriesType;a("bar","column",null,{inverted:!0})})(L);(function(a){var z=a.Series;a=a.seriesType;a("scatter","line",{lineWidth:0,findNearestPointBy:"xy",marker:{enabled:!0},tooltip:{headerFormat:'\x3cspan class\x3d"highcharts-color-{point.colorIndex}"\x3e\u25cf\x3c/span\x3e \x3cspan class\x3d"highcharts-header"\x3e {series.name}\x3c/span\x3e\x3cbr/\x3e',pointFormat:"x: \x3cb\x3e{point.x}\x3c/b\x3e\x3cbr/\x3ey: \x3cb\x3e{point.y}\x3c/b\x3e\x3cbr/\x3e"}},{sorted:!1,
	requireSorting:!1,noSharedTooltip:!0,trackerGroups:["group","markerGroup","dataLabelsGroup"],takeOrdinalPosition:!1,drawGraph:function(){this.options.lineWidth&&z.prototype.drawGraph.call(this)}})})(L);(function(a){var z=a.deg2rad,A=a.isNumber,D=a.pick,q=a.relativeLength;a.CenteredSeriesMixin={getCenter:function(){var a=this.options,e=this.chart,k=2*(a.slicedOffset||0),t=e.plotWidth-2*k,e=e.plotHeight-2*k,p=a.center,p=[D(p[0],"50%"),D(p[1],"50%"),a.size||"100%",a.innerSize||0],l=Math.min(t,e),c,n;
	for(c=0;4>c;++c)n=p[c],a=2>c||2===c&&/%$/.test(n),p[c]=q(n,[t,e,l,p[2]][c])+(a?k:0);p[3]>p[2]&&(p[3]=p[2]);return p},getStartAndEndRadians:function(a,e){a=A(a)?a:0;e=A(e)&&e>a&&360>e-a?e:a+360;return{start:z*(a+-90),end:z*(e+-90)}}}})(L);(function(a){var z=a.addEvent,A=a.CenteredSeriesMixin,D=a.defined,q=a.each,g=a.extend,e=A.getStartAndEndRadians,k=a.inArray,t=a.noop,p=a.pick,l=a.Point,c=a.Series,n=a.seriesType,y=a.setAnimation;n("pie","line",{center:[null,null],clip:!1,colorByPoint:!0,dataLabels:{distance:30,
	enabled:!0,formatter:function(){return this.point.isNull?void 0:this.point.name},x:0},ignoreHiddenPoint:!0,legendType:"point",marker:null,size:null,showInLegend:!1,slicedOffset:10,stickyTracking:!1,tooltip:{followPointer:!0}},{isCartesian:!1,requireSorting:!1,directTouch:!0,noSharedTooltip:!0,trackerGroups:["group","dataLabelsGroup"],axisTypes:[],pointAttribs:a.seriesTypes.column.prototype.pointAttribs,animate:function(a){var b=this,c=b.points,d=b.startAngleRad;a||(q(c,function(a){var c=a.graphic,
	e=a.shapeArgs;c&&(c.attr({r:a.startR||b.center[3]/2,start:d,end:d}),c.animate({r:e.r,start:e.start,end:e.end},b.options.animation))}),b.animate=null)},updateTotals:function(){var a,b=0,c=this.points,e=c.length,g,k=this.options.ignoreHiddenPoint;for(a=0;a<e;a++)g=c[a],b+=k&&!g.visible?0:g.isNull?0:g.y;this.total=b;for(a=0;a<e;a++)g=c[a],g.percentage=0<b&&(g.visible||!k)?g.y/b*100:0,g.total=b},generatePoints:function(){c.prototype.generatePoints.call(this);this.updateTotals()},translate:function(a){this.generatePoints();
	var b=0,c=this.options,d=c.slicedOffset,g=d+(c.borderWidth||0),k,l,n,q=e(c.startAngle,c.endAngle),u=this.startAngleRad=q.start,q=(this.endAngleRad=q.end)-u,t=this.points,v,y=c.dataLabels.distance,c=c.ignoreHiddenPoint,x,z=t.length,f;a||(this.center=a=this.getCenter());this.getX=function(b,c,d){n=Math.asin(Math.min((b-a[1])/(a[2]/2+d.labelDistance),1));return a[0]+(c?-1:1)*Math.cos(n)*(a[2]/2+d.labelDistance)};for(x=0;x<z;x++){f=t[x];f.labelDistance=p(f.options.dataLabels&&f.options.dataLabels.distance,
	y);this.maxLabelDistance=Math.max(this.maxLabelDistance||0,f.labelDistance);k=u+b*q;if(!c||f.visible)b+=f.percentage/100;l=u+b*q;f.shapeType="arc";f.shapeArgs={x:a[0],y:a[1],r:a[2]/2,innerR:a[3]/2,start:Math.round(1E3*k)/1E3,end:Math.round(1E3*l)/1E3};n=(l+k)/2;n>1.5*Math.PI?n-=2*Math.PI:n<-Math.PI/2&&(n+=2*Math.PI);f.slicedTranslation={translateX:Math.round(Math.cos(n)*d),translateY:Math.round(Math.sin(n)*d)};l=Math.cos(n)*a[2]/2;v=Math.sin(n)*a[2]/2;f.tooltipPos=[a[0]+.7*l,a[1]+.7*v];f.half=n<-Math.PI/
	2||n>Math.PI/2?1:0;f.angle=n;k=Math.min(g,f.labelDistance/5);f.labelPos=[a[0]+l+Math.cos(n)*f.labelDistance,a[1]+v+Math.sin(n)*f.labelDistance,a[0]+l+Math.cos(n)*k,a[1]+v+Math.sin(n)*k,a[0]+l,a[1]+v,0>f.labelDistance?"center":f.half?"right":"left",n]}},drawGraph:null,drawPoints:function(){var a=this,b=a.chart.renderer,c,e,k;q(a.points,function(d){e=d.graphic;d.isNull?e&&(d.graphic=e.destroy()):(k=d.shapeArgs,c=d.getTranslate(),e?e.setRadialReference(a.center).animate(g(k,c)):(d.graphic=e=b[d.shapeType](k).setRadialReference(a.center).attr(c).add(a.group),
	d.visible||e.attr({visibility:"hidden"})),e.addClass(d.getClassName()))})},searchPoint:t,sortByAngle:function(a,b){a.sort(function(a,c){return void 0!==a.angle&&(c.angle-a.angle)*b})},drawLegendSymbol:a.LegendSymbolMixin.drawRectangle,getCenter:A.getCenter,getSymbol:t},{init:function(){l.prototype.init.apply(this,arguments);var a=this,b;a.name=p(a.name,"Slice");b=function(b){a.slice("select"===b.type)};z(a,"select",b);z(a,"unselect",b);return a},isValid:function(){return a.isNumber(this.y,!0)&&0<=
	this.y},setVisible:function(a,b){var c=this,d=c.series,e=d.chart,g=d.options.ignoreHiddenPoint;b=p(b,g);a!==c.visible&&(c.visible=c.options.visible=a=void 0===a?!c.visible:a,d.options.data[k(c,d.data)]=c.options,q(["graphic","dataLabel","connector","shadowGroup"],function(b){if(c[b])c[b][a?"show":"hide"](!0)}),c.legendItem&&e.legend.colorizeItem(c,a),a||"hover"!==c.state||c.setState(""),g&&(d.isDirty=!0),b&&e.redraw())},slice:function(a,b,c){var d=this.series;y(c,d.chart);p(b,!0);this.sliced=this.options.sliced=
	D(a)?a:!this.sliced;d.options.data[k(this,d.data)]=this.options;this.graphic.animate(this.getTranslate())},getTranslate:function(){return this.sliced?this.slicedTranslation:{translateX:0,translateY:0}},haloPath:function(a){var b=this.shapeArgs;return this.sliced||!this.visible?[]:this.series.chart.renderer.symbols.arc(b.x,b.y,b.r+a,b.r+a,{innerR:this.shapeArgs.r,start:b.start,end:b.end})}})})(L);(function(a){var z=a.addEvent,A=a.arrayMax,D=a.defined,q=a.each,g=a.extend,e=a.format,k=a.map,t=a.merge,
	p=a.noop,l=a.pick,c=a.relativeLength,n=a.Series,y=a.seriesTypes,d=a.stableSort;a.distribute=function(a,c){function b(a,b){return a.target-b.target}var e,g=!0,h=a,n=[],p;p=0;for(e=a.length;e--;)p+=a[e].size;if(p>c){d(a,function(a,b){return(b.rank||0)-(a.rank||0)});for(p=e=0;p<=c;)p+=a[e].size,e++;n=a.splice(e-1,a.length)}d(a,b);for(a=k(a,function(a){return{size:a.size,targets:[a.target],align:l(a.align,.5)}});g;){for(e=a.length;e--;)g=a[e],p=(Math.min.apply(0,g.targets)+Math.max.apply(0,g.targets))/
	2,g.pos=Math.min(Math.max(0,p-g.size*g.align),c-g.size);e=a.length;for(g=!1;e--;)0<e&&a[e-1].pos+a[e-1].size>a[e].pos&&(a[e-1].size+=a[e].size,a[e-1].targets=a[e-1].targets.concat(a[e].targets),a[e-1].align=.5,a[e-1].pos+a[e-1].size>c&&(a[e-1].pos=c-a[e-1].size),a.splice(e,1),g=!0)}e=0;q(a,function(a){var b=0;q(a.targets,function(){h[e].pos=a.pos+b;b+=h[e].size;e++})});h.push.apply(h,n);d(h,b)};n.prototype.drawDataLabels=function(){function b(a,b){var c=b.filter;return c?(b=c.operator,a=a[c.property],
	c=c.value,"\x3e"===b&&a>c||"\x3c"===b&&a<c||"\x3e\x3d"===b&&a>=c||"\x3c\x3d"===b&&a<=c||"\x3d\x3d"===b&&a==c||"\x3d\x3d\x3d"===b&&a===c?!0:!1):!0}var c=this,d=c.options,g=d.dataLabels,k=c.points,n,p,y=c.hasRendered||0,u,G,v=l(g.defer,!!d.animation),E=c.chart.renderer;if(g.enabled||c._hasPointLabels)c.dlProcessOptions&&c.dlProcessOptions(g),G=c.plotGroup("dataLabelsGroup","data-labels",v&&!y?"hidden":"visible",g.zIndex||6),v&&(G.attr({opacity:+y}),y||z(c,"afterAnimate",function(){c.visible&&G.show(!0);
	G[d.animation?"animate":"attr"]({opacity:1},{duration:200})})),p=g,q(k,function(d){var h,f=d.dataLabel,k,m,q=d.connector,v=!f,w;n=d.dlOptions||d.options&&d.options.dataLabels;(h=l(n&&n.enabled,p.enabled)&&!d.isNull)&&(h=!0===b(d,n||g));h&&(g=t(p,n),k=d.getLabelConfig(),w=g[d.formatPrefix+"Format"]||g.format,u=D(w)?e(w,k):(g[d.formatPrefix+"Formatter"]||g.formatter).call(k,g),k=g.rotation,m={r:g.borderRadius||0,rotation:k,padding:g.padding,zIndex:1},a.objectEach(m,function(a,b){void 0===a&&delete m[b]}));
	!f||h&&D(u)?h&&D(u)&&(f?m.text=u:(f=d.dataLabel=E[k?"text":"label"](u,0,-9999,g.shape,null,null,g.useHTML,null,"data-label"),f.addClass("highcharts-data-label-color-"+d.colorIndex+" "+(g.className||"")+(g.useHTML?"highcharts-tracker":""))),f.attr(m),f.added||f.add(G),c.alignDataLabel(d,f,g,null,v)):(d.dataLabel=f=f.destroy(),q&&(d.connector=q.destroy()))})};n.prototype.alignDataLabel=function(a,c,d,e,k){var b=this.chart,h=b.inverted,m=l(a.dlBox&&a.dlBox.centerX,a.plotX,-9999),n=l(a.plotY,-9999),p=
	c.getBBox(),q,t=d.rotation,w=d.align,y=this.visible&&(a.series.forceDL||b.isInsidePlot(m,Math.round(n),h)||e&&b.isInsidePlot(m,h?e.x+1:e.y+e.height-1,h)),f="justify"===l(d.overflow,"justify");if(y&&(q=b.renderer.fontMetrics(void 0,c).b,e=g({x:h?this.yAxis.len-n:m,y:Math.round(h?this.xAxis.len-m:n),width:0,height:0},e),g(d,{width:p.width,height:p.height}),t?(f=!1,m=b.renderer.rotCorr(q,t),m={x:e.x+d.x+e.width/2+m.x,y:e.y+d.y+{top:0,middle:.5,bottom:1}[d.verticalAlign]*e.height},c[k?"attr":"animate"](m).attr({align:w}),
	n=(t+720)%360,n=180<n&&360>n,"left"===w?m.y-=n?p.height:0:"center"===w?(m.x-=p.width/2,m.y-=p.height/2):"right"===w&&(m.x-=p.width,m.y-=n?0:p.height)):(c.align(d,null,e),m=c.alignAttr),f?a.isLabelJustified=this.justifyDataLabel(c,d,m,p,e,k):l(d.crop,!0)&&(y=b.isInsidePlot(m.x,m.y)&&b.isInsidePlot(m.x+p.width,m.y+p.height)),d.shape&&!t))c[k?"attr":"animate"]({anchorX:h?b.plotWidth-a.plotY:a.plotX,anchorY:h?b.plotHeight-a.plotX:a.plotY});y||(c.attr({y:-9999}),c.placed=!1)};n.prototype.justifyDataLabel=
	function(a,c,d,e,g,k){var b=this.chart,h=c.align,m=c.verticalAlign,l,n,p=a.box?0:a.padding||0;l=d.x+p;0>l&&("right"===h?c.align="left":c.x=-l,n=!0);l=d.x+e.width-p;l>b.plotWidth&&("left"===h?c.align="right":c.x=b.plotWidth-l,n=!0);l=d.y+p;0>l&&("bottom"===m?c.verticalAlign="top":c.y=-l,n=!0);l=d.y+e.height-p;l>b.plotHeight&&("top"===m?c.verticalAlign="bottom":c.y=b.plotHeight-l,n=!0);n&&(a.placed=!k,a.align(c,null,g));return n};y.pie&&(y.pie.prototype.drawDataLabels=function(){var b=this,c=b.data,
	d,e=b.chart,g=b.options.dataLabels,k=l(g.connectorPadding,10),p=l(g.connectorWidth,1),t=e.plotWidth,u=e.plotHeight,y,v=b.center,E=v[2]/2,x=v[1],z,f,r,N,K=[[],[]],B,P,L,Q,O=[0,0,0,0];b.visible&&(g.enabled||b._hasPointLabels)&&(q(c,function(a){a.dataLabel&&a.visible&&a.dataLabel.shortened&&(a.dataLabel.attr({width:"auto"}).css({width:"auto",textOverflow:"clip"}),a.dataLabel.shortened=!1)}),n.prototype.drawDataLabels.apply(b),q(c,function(a){a.dataLabel&&a.visible&&(K[a.half].push(a),a.dataLabel._pos=
	null)}),q(K,function(c,h){var m,n,p=c.length,C=[],w;if(p)for(b.sortByAngle(c,h-.5),0<b.maxLabelDistance&&(m=Math.max(0,x-E-b.maxLabelDistance),n=Math.min(x+E+b.maxLabelDistance,e.plotHeight),q(c,function(a){0<a.labelDistance&&a.dataLabel&&(a.top=Math.max(0,x-E-a.labelDistance),a.bottom=Math.min(x+E+a.labelDistance,e.plotHeight),w=a.dataLabel.getBBox().height||21,a.positionsIndex=C.push({target:a.labelPos[1]-a.top+w/2,size:w,rank:a.y})-1)}),a.distribute(C,n+w-m)),Q=0;Q<p;Q++)d=c[Q],n=d.positionsIndex,
	r=d.labelPos,z=d.dataLabel,L=!1===d.visible?"hidden":"inherit",P=m=r[1],C&&D(C[n])&&(void 0===C[n].pos?L="hidden":(N=C[n].size,P=d.top+C[n].pos)),delete d.positionIndex,B=g.justify?v[0]+(h?-1:1)*(E+d.labelDistance):b.getX(P<d.top+2||P>d.bottom-2?m:P,h,d),z._attr={visibility:L,align:r[6]},z._pos={x:B+g.x+({left:k,right:-k}[r[6]]||0),y:P+g.y-10},r.x=B,r.y=P,l(g.crop,!0)&&(f=z.getBBox().width,m=null,B-f<k?(m=Math.round(f-B+k),O[3]=Math.max(m,O[3])):B+f>t-k&&(m=Math.round(B+f-t+k),O[1]=Math.max(m,O[1])),
	0>P-N/2?O[0]=Math.max(Math.round(-P+N/2),O[0]):P+N/2>u&&(O[2]=Math.max(Math.round(P+N/2-u),O[2])),z.sideOverflow=m)}),0===A(O)||this.verifyDataLabelOverflow(O))&&(this.placeDataLabels(),p&&q(this.points,function(a){var c;y=a.connector;if((z=a.dataLabel)&&z._pos&&a.visible&&0<a.labelDistance){L=z._attr.visibility;if(c=!y)a.connector=y=e.renderer.path().addClass("highcharts-data-label-connector  highcharts-color-"+a.colorIndex).add(b.dataLabelsGroup);y[c?"attr":"animate"]({d:b.connectorPath(a.labelPos)});
	y.attr("visibility",L)}else y&&(a.connector=y.destroy())}))},y.pie.prototype.connectorPath=function(a){var b=a.x,c=a.y;return l(this.options.dataLabels.softConnector,!0)?["M",b+("left"===a[6]?5:-5),c,"C",b,c,2*a[2]-a[4],2*a[3]-a[5],a[2],a[3],"L",a[4],a[5]]:["M",b+("left"===a[6]?5:-5),c,"L",a[2],a[3],"L",a[4],a[5]]},y.pie.prototype.placeDataLabels=function(){q(this.points,function(a){var b=a.dataLabel;b&&a.visible&&((a=b._pos)?(b.sideOverflow&&(b._attr.width=b.getBBox().width-b.sideOverflow,b.css({width:b._attr.width+
	"px",textOverflow:"ellipsis"}),b.shortened=!0),b.attr(b._attr),b[b.moved?"animate":"attr"](a),b.moved=!0):b&&b.attr({y:-9999}))},this)},y.pie.prototype.alignDataLabel=p,y.pie.prototype.verifyDataLabelOverflow=function(a){var b=this.center,d=this.options,e=d.center,g=d.minSize||80,k,l=null!==d.size;l||(null!==e[0]?k=Math.max(b[2]-Math.max(a[1],a[3]),g):(k=Math.max(b[2]-a[1]-a[3],g),b[0]+=(a[3]-a[1])/2),null!==e[1]?k=Math.max(Math.min(k,b[2]-Math.max(a[0],a[2])),g):(k=Math.max(Math.min(k,b[2]-a[0]-
	a[2]),g),b[1]+=(a[0]-a[2])/2),k<b[2]?(b[2]=k,b[3]=Math.min(c(d.innerSize||0,k),k),this.translate(b),this.drawDataLabels&&this.drawDataLabels()):l=!0);return l});y.column&&(y.column.prototype.alignDataLabel=function(a,c,d,e,g){var b=this.chart.inverted,h=a.series,k=a.dlBox||a.shapeArgs,m=l(a.below,a.plotY>l(this.translatedThreshold,h.yAxis.len)),p=l(d.inside,!!this.options.stacking);k&&(e=t(k),0>e.y&&(e.height+=e.y,e.y=0),k=e.y+e.height-h.yAxis.len,0<k&&(e.height-=k),b&&(e={x:h.yAxis.len-e.y-e.height,
	y:h.xAxis.len-e.x-e.width,width:e.height,height:e.width}),p||(b?(e.x+=m?0:e.width,e.width=0):(e.y+=m?e.height:0,e.height=0)));d.align=l(d.align,!b||p?"center":m?"right":"left");d.verticalAlign=l(d.verticalAlign,b||p?"middle":m?"top":"bottom");n.prototype.alignDataLabel.call(this,a,c,d,e,g);a.isLabelJustified&&a.contrastColor&&a.dataLabel.css({color:a.contrastColor})})})(L);(function(a){var z=a.Chart,A=a.each,D=a.objectEach,q=a.pick;a=a.addEvent;a(z.prototype,"render",function(){var a=[];A(this.labelCollectors||
	[],function(e){a=a.concat(e())});A(this.yAxis||[],function(e){e.options.stackLabels&&!e.options.stackLabels.allowOverlap&&D(e.stacks,function(e){D(e,function(e){a.push(e.label)})})});A(this.series||[],function(e){var g=e.options.dataLabels,t=e.dataLabelCollections||["dataLabel"];(g.enabled||e._hasPointLabels)&&!g.allowOverlap&&e.visible&&A(t,function(g){A(e.points,function(e){e[g]&&(e[g].labelrank=q(e.labelrank,e.shapeArgs&&e.shapeArgs.height),a.push(e[g]))})})});this.hideOverlappingLabels(a)});z.prototype.hideOverlappingLabels=
	function(a){var e=a.length,g,q,p,l,c,n,y,d,b,h=function(a,b,c,d,e,g,h,k){return!(e>a+c||e+h<a||g>b+d||g+k<b)};for(q=0;q<e;q++)if(g=a[q])g.oldOpacity=g.opacity,g.newOpacity=1,g.width||(p=g.getBBox(),g.width=p.width,g.height=p.height);a.sort(function(a,b){return(b.labelrank||0)-(a.labelrank||0)});for(q=0;q<e;q++)for(p=a[q],g=q+1;g<e;++g)if(l=a[g],p&&l&&p!==l&&p.placed&&l.placed&&0!==p.newOpacity&&0!==l.newOpacity&&(c=p.alignAttr,n=l.alignAttr,y=p.parentGroup,d=l.parentGroup,b=2*(p.box?0:p.padding||
	0),c=h(c.x+y.translateX,c.y+y.translateY,p.width-b,p.height-b,n.x+d.translateX,n.y+d.translateY,l.width-b,l.height-b)))(p.labelrank<l.labelrank?p:l).newOpacity=0;A(a,function(a){var b,c;a&&(c=a.newOpacity,a.oldOpacity!==c&&a.placed&&(c?a.show(!0):b=function(){a.hide()},a.alignAttr.opacity=c,a[a.isOld?"animate":"attr"](a.alignAttr,null,b)),a.isOld=!0)})}})(L);(function(a){var z=a.addEvent,A=a.Chart,D=a.createElement,q=a.css,g=a.defaultOptions,e=a.defaultPlotOptions,k=a.each,t=a.extend,p=a.fireEvent,
	l=a.hasTouch,c=a.inArray,n=a.isObject,y=a.Legend,d=a.merge,b=a.pick,h=a.Point,w=a.Series,m=a.seriesTypes,F=a.svg,J;J=a.TrackerMixin={drawTrackerPoint:function(){var a=this,b=a.chart.pointer,c=function(a){var c=b.getPointFromEvent(a);void 0!==c&&(b.isDirectTouch=!0,c.onMouseOver(a))};k(a.points,function(a){a.graphic&&(a.graphic.element.point=a);a.dataLabel&&(a.dataLabel.div?a.dataLabel.div.point=a:a.dataLabel.element.point=a)});a._hasTracking||(k(a.trackerGroups,function(e){if(a[e]&&(a[e].addClass("highcharts-tracker").on("mouseover",
	c).on("mouseout",function(a){b.onTrackerMouseOut(a)}),l))a[e].on("touchstart",c)}),a._hasTracking=!0)},drawTrackerGraph:function(){var a=this,b=a.options.trackByArea,c=[].concat(b?a.areaPath:a.graphPath),e=c.length,d=a.chart,g=d.pointer,h=d.renderer,m=d.options.tooltip.snap,f=a.tracker,n,p=function(){if(d.hoverSeries!==a)a.onMouseOver()},q="rgba(192,192,192,"+(F?.0001:.002)+")";if(e&&!b)for(n=e+1;n--;)"M"===c[n]&&c.splice(n+1,0,c[n+1]-m,c[n+2],"L"),(n&&"M"===c[n]||n===e)&&c.splice(n,0,"L",c[n-2]+
	m,c[n-1]);f?f.attr({d:c}):a.graph&&(a.tracker=h.path(c).attr({"stroke-linejoin":"round",visibility:a.visible?"visible":"hidden",stroke:q,fill:b?q:"none","stroke-width":a.graph.strokeWidth()+(b?0:2*m),zIndex:2}).add(a.group),k([a.tracker,a.markerGroup],function(a){a.addClass("highcharts-tracker").on("mouseover",p).on("mouseout",function(a){g.onTrackerMouseOut(a)});if(l)a.on("touchstart",p)}))}};m.column&&(m.column.prototype.drawTracker=J.drawTrackerPoint);m.pie&&(m.pie.prototype.drawTracker=J.drawTrackerPoint);
	m.scatter&&(m.scatter.prototype.drawTracker=J.drawTrackerPoint);t(y.prototype,{setItemEvents:function(a,b,c){var e=this.chart.renderer.boxWrapper,d="highcharts-legend-"+(a.series?"point":"series")+"-active";(c?b:a.legendGroup).on("mouseover",function(){a.setState("hover");e.addClass(d)}).on("mouseout",function(){e.removeClass(d);a.setState()}).on("click",function(b){var c=function(){a.setVisible&&a.setVisible()};b={browserEvent:b};a.firePointEvent?a.firePointEvent("legendItemClick",b,c):p(a,"legendItemClick",
	b,c)})},createCheckboxForItem:function(a){a.checkbox=D("input",{type:"checkbox",checked:a.selected,defaultChecked:a.selected},this.options.itemCheckboxStyle,this.chart.container);z(a.checkbox,"click",function(b){p(a.series||a,"checkboxClick",{checked:b.target.checked,item:a},function(){a.select()})})}});t(A.prototype,{showResetZoom:function(){var a=this,b=g.lang,c=a.options.chart.resetZoomButton,e=c.theme,d=e.states,h="chart"===c.relativeTo?null:"plotBox";this.resetZoomButton=a.renderer.button(b.resetZoom,
	null,null,function(){a.zoomOut()},e,d&&d.hover).attr({align:c.position.align,title:b.resetZoomTitle}).addClass("highcharts-reset-zoom").add().align(c.position,!1,h)},zoomOut:function(){var a=this;p(a,"selection",{resetSelection:!0},function(){a.zoom()})},zoom:function(a){var c,e=this.pointer,d=!1,g;!a||a.resetSelection?(k(this.axes,function(a){c=a.zoom()}),e.initiated=!1):k(a.xAxis.concat(a.yAxis),function(a){var b=a.axis;e[b.isXAxis?"zoomX":"zoomY"]&&(c=b.zoom(a.min,a.max),b.displayBtn&&(d=!0))});
	g=this.resetZoomButton;d&&!g?this.showResetZoom():!d&&n(g)&&(this.resetZoomButton=g.destroy());c&&this.redraw(b(this.options.chart.animation,a&&a.animation,100>this.pointCount))},pan:function(a,b){var c=this,e=c.hoverPoints,d;e&&k(e,function(a){a.setState()});k("xy"===b?[1,0]:[1],function(b){b=c[b?"xAxis":"yAxis"][0];var e=b.horiz,g=a[e?"chartX":"chartY"],e=e?"mouseDownX":"mouseDownY",f=c[e],h=(b.pointRange||0)/2,k=b.getExtremes(),l=b.toValue(f-g,!0)+h,h=b.toValue(f+b.len-g,!0)-h,m=h<l,f=m?h:l,l=
	m?l:h,h=Math.min(k.dataMin,b.toValue(b.toPixels(k.min)-b.minPixelPadding)),m=Math.max(k.dataMax,b.toValue(b.toPixels(k.max)+b.minPixelPadding)),n;n=h-f;0<n&&(l+=n,f=h);n=l-m;0<n&&(l=m,f-=n);b.series.length&&f!==k.min&&l!==k.max&&(b.setExtremes(f,l,!1,!1,{trigger:"pan"}),d=!0);c[e]=g});d&&c.redraw(!1);q(c.container,{cursor:"move"})}});t(h.prototype,{select:function(a,e){var d=this,g=d.series,h=g.chart;a=b(a,!d.selected);d.firePointEvent(a?"select":"unselect",{accumulate:e},function(){d.selected=d.options.selected=
	a;g.options.data[c(d,g.data)]=d.options;d.setState(a&&"select");e||k(h.getSelectedPoints(),function(a){a.selected&&a!==d&&(a.selected=a.options.selected=!1,g.options.data[c(a,g.data)]=a.options,a.setState(""),a.firePointEvent("unselect"))})})},onMouseOver:function(a){var b=this.series.chart,c=b.pointer;a=a?c.normalize(a):c.getChartCoordinatesFromPoint(this,b.inverted);c.runPointActions(a,this)},onMouseOut:function(){var a=this.series.chart;this.firePointEvent("mouseOut");k(a.hoverPoints||[],function(a){a.setState()});
	a.hoverPoints=a.hoverPoint=null},importEvents:function(){if(!this.hasImportedEvents){var b=this,c=d(b.series.options.point,b.options).events;b.events=c;a.objectEach(c,function(a,c){z(b,c,a)});this.hasImportedEvents=!0}},setState:function(a,c){var d=Math.floor(this.plotX),g=this.plotY,h=this.series,k=h.options.states[a]||{},l=e[h.type].marker&&h.options.marker,m=l&&!1===l.enabled,f=l&&l.states&&l.states[a]||{},n=!1===f.enabled,p=h.stateMarkerGraphic,q=this.marker||{},t=h.chart,w=h.halo,y,z=l&&h.markerAttribs;
	a=a||"";if(!(a===this.state&&!c||this.selected&&"select"!==a||!1===k.enabled||a&&(n||m&&!1===f.enabled)||a&&q.states&&q.states[a]&&!1===q.states[a].enabled)){z&&(y=h.markerAttribs(this,a));if(this.graphic)this.state&&this.graphic.removeClass("highcharts-point-"+this.state),a&&this.graphic.addClass("highcharts-point-"+a),y&&this.graphic.animate(y,b(t.options.chart.animation,f.animation,l.animation)),p&&p.hide();else{if(a&&f)if(l=q.symbol||h.symbol,p&&p.currentSymbol!==l&&(p=p.destroy()),p)p[c?"animate":
	"attr"]({x:y.x,y:y.y});else l&&(h.stateMarkerGraphic=p=t.renderer.symbol(l,y.x,y.y,y.width,y.height).add(h.markerGroup),p.currentSymbol=l);p&&(p[a&&t.isInsidePlot(d,g,t.inverted)?"show":"hide"](),p.element.point=this)}(d=k.halo)&&d.size?(w||(h.halo=w=t.renderer.path().add((this.graphic||p).parentGroup)),w[c?"animate":"attr"]({d:this.haloPath(d.size)}),w.attr({"class":"highcharts-halo highcharts-color-"+b(this.colorIndex,h.colorIndex)}),w.point=this):w&&w.point&&w.point.haloPath&&w.animate({d:w.point.haloPath(0)});
	this.state=a}},haloPath:function(a){return this.series.chart.renderer.symbols.circle(Math.floor(this.plotX)-a,this.plotY-a,2*a,2*a)}});t(w.prototype,{onMouseOver:function(){var a=this.chart,b=a.hoverSeries;if(b&&b!==this)b.onMouseOut();this.options.events.mouseOver&&p(this,"mouseOver");this.setState("hover");a.hoverSeries=this},onMouseOut:function(){var a=this.options,b=this.chart,c=b.tooltip,d=b.hoverPoint;b.hoverSeries=null;if(d)d.onMouseOut();this&&a.events.mouseOut&&p(this,"mouseOut");!c||this.stickyTracking||
	c.shared&&!this.noSharedTooltip||c.hide();this.setState()},setState:function(a){var b=this;a=a||"";b.state!==a&&(k([b.group,b.markerGroup,b.dataLabelsGroup],function(c){c&&(b.state&&c.removeClass("highcharts-series-"+b.state),a&&c.addClass("highcharts-series-"+a))}),b.state=a)},setVisible:function(a,b){var c=this,d=c.chart,e=c.legendItem,g,h=d.options.chart.ignoreHiddenSeries,l=c.visible;g=(c.visible=a=c.options.visible=c.userOptions.visible=void 0===a?!l:a)?"show":"hide";k(["group","dataLabelsGroup",
	"markerGroup","tracker","tt"],function(a){if(c[a])c[a][g]()});if(d.hoverSeries===c||(d.hoverPoint&&d.hoverPoint.series)===c)c.onMouseOut();e&&d.legend.colorizeItem(c,a);c.isDirty=!0;c.options.stacking&&k(d.series,function(a){a.options.stacking&&a.visible&&(a.isDirty=!0)});k(c.linkedSeries,function(b){b.setVisible(a,!1)});h&&(d.isDirtyBox=!0);!1!==b&&d.redraw();p(c,g)},show:function(){this.setVisible(!0)},hide:function(){this.setVisible(!1)},select:function(a){this.selected=a=void 0===a?!this.selected:
	a;this.checkbox&&(this.checkbox.checked=a);p(this,a?"select":"unselect")},drawTracker:J.drawTrackerGraph})})(L);(function(a){var z=a.Chart,A=a.each,D=a.inArray,q=a.isArray,g=a.isObject,e=a.pick,k=a.splat;z.prototype.setResponsive=function(e){var g=this.options.responsive,k=[],c=this.currentResponsive;g&&g.rules&&A(g.rules,function(c){void 0===c._id&&(c._id=a.uniqueKey());this.matchResponsiveRule(c,k,e)},this);var n=a.merge.apply(0,a.map(k,function(c){return a.find(g.rules,function(a){return a._id===
	c}).chartOptions})),k=k.toString()||void 0;k!==(c&&c.ruleIds)&&(c&&this.update(c.undoOptions,e),k?(this.currentResponsive={ruleIds:k,mergedOptions:n,undoOptions:this.currentOptions(n)},this.update(n,e)):this.currentResponsive=void 0)};z.prototype.matchResponsiveRule=function(a,g){var k=a.condition;(k.callback||function(){return this.chartWidth<=e(k.maxWidth,Number.MAX_VALUE)&&this.chartHeight<=e(k.maxHeight,Number.MAX_VALUE)&&this.chartWidth>=e(k.minWidth,0)&&this.chartHeight>=e(k.minHeight,0)}).call(this)&&
	g.push(a._id)};z.prototype.currentOptions=function(e){function p(c,e,l,d){var b;a.objectEach(c,function(a,c){if(!d&&-1<D(c,["series","xAxis","yAxis"]))for(a=k(a),l[c]=[],b=0;b<a.length;b++)e[c][b]&&(l[c][b]={},p(a[b],e[c][b],l[c][b],d+1));else g(a)?(l[c]=q(a)?[]:{},p(a,e[c]||{},l[c],d+1)):l[c]=e[c]||null})}var l={};p(e,this.options,l,0);return l}})(L);return L});


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(262);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(94);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(317);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(383);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(384);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ }),
/* 729 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 730 */
/***/ (function(module, exports) {

	/*!
	 * Determine if an object is a Buffer
	 *
	 * @author   Feross Aboukhadijeh <https://feross.org>
	 * @license  MIT
	 */
	
	// The _isBuffer check is for Safari 5-7 support, because it's missing
	// Object.prototype.constructor. Remove this eventually
	module.exports = function (obj) {
	  return obj != null && (isBuffer(obj) || isSlowBuffer(obj) || !!obj._isBuffer)
	}
	
	function isBuffer (obj) {
	  return !!obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
	}
	
	// For Node v0.10 support. Remove this eventually.
	function isSlowBuffer (obj) {
	  return typeof obj.readFloatLE === 'function' && typeof obj.slice === 'function' && isBuffer(obj.slice(0, 0))
	}


/***/ }),
/* 731 */
/***/ (function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ }),
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.9.1 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = getNative;


/***/ }),
/* 810 */
/***/ (function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isArguments;


/***/ }),
/* 811 */
/***/ (function(module, exports) {

	/**
	 * lodash 3.0.4 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	
	/** `Object#toString` result references. */
	var arrayTag = '[object Array]',
	    funcTag = '[object Function]';
	
	/** Used to detect host constructors (Safari > 5). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/**
	 * Checks if `value` is object-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var fnToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  fnToString.call(hasOwnProperty).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeIsArray = getNative(Array, 'isArray');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = object == null ? undefined : object[key];
	  return isNative(value) ? value : undefined;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(function() { return arguments; }());
	 * // => false
	 */
	var isArray = nativeIsArray || function(value) {
	  return isObjectLike(value) && isLength(value.length) && objToString.call(value) == arrayTag;
	};
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in older versions of Chrome and Safari which return 'function' for regexes
	  // and Safari 8 equivalents which return 'object' for typed array constructors.
	  return isObject(value) && objToString.call(value) == funcTag;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is a native function.
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function, else `false`.
	 * @example
	 *
	 * _.isNative(Array.prototype.push);
	 * // => true
	 *
	 * _.isNative(_);
	 * // => false
	 */
	function isNative(value) {
	  if (value == null) {
	    return false;
	  }
	  if (isFunction(value)) {
	    return reIsNative.test(fnToString.call(value));
	  }
	  return isObjectLike(value) && reIsHostCtor.test(value);
	}
	
	module.exports = isArray;


/***/ }),
/* 812 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * lodash 3.1.2 (Custom Build) <https://lodash.com/>
	 * Build: `lodash modern modularize exports="npm" -o ./`
	 * Copyright 2012-2015 The Dojo Foundation <http://dojofoundation.org/>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 * Available under MIT license <https://lodash.com/license>
	 */
	var getNative = __webpack_require__(809),
	    isArguments = __webpack_require__(810),
	    isArray = __webpack_require__(811);
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^\d+$/;
	
	/** Used for native method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/* Native method references for those with the same name as other `lodash` methods. */
	var nativeKeys = getNative(Object, 'keys');
	
	/**
	 * Used as the [maximum length](http://ecma-international.org/ecma-262/6.0/#sec-number.max_safe_integer)
	 * of an array-like value.
	 */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792)
	 * that affects Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	/**
	 * Checks if `value` is array-like.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  value = (typeof value == 'number' || reIsUint.test(value)) ? +value : -1;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return value > -1 && value % 1 == 0 && value < length;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is based on [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 */
	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * A fallback implementation of `Object.keys` which creates an array of the
	 * own enumerable property names of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function shimKeys(object) {
	  var props = keysIn(object),
	      propsLength = props.length,
	      length = propsLength && object.length;
	
	  var allowIndexes = !!length && isLength(length) &&
	    (isArray(object) || isArguments(object));
	
	  var index = -1,
	      result = [];
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if ((allowIndexes && isIndex(key, length)) || hasOwnProperty.call(object, key)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is the [language type](https://es5.github.io/#x8) of `Object`.
	 * (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(1);
	 * // => false
	 */
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	var keys = !nativeKeys ? shimKeys : function(object) {
	  var Ctor = object == null ? undefined : object.constructor;
	  if ((typeof Ctor == 'function' && Ctor.prototype === object) ||
	      (typeof object != 'function' && isArrayLike(object))) {
	    return shimKeys(object);
	  }
	  return isObject(object) ? nativeKeys(object) : [];
	};
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  if (object == null) {
	    return [];
	  }
	  if (!isObject(object)) {
	    object = Object(object);
	  }
	  var length = object.length;
	  length = (length && isLength(length) &&
	    (isArray(object) || isArguments(object)) && length) || 0;
	
	  var Ctor = object.constructor,
	      index = -1,
	      isProto = typeof Ctor == 'function' && Ctor.prototype === object,
	      result = Array(length),
	      skipIndexes = length > 0;
	
	  while (++index < length) {
	    result[index] = (index + '');
	  }
	  for (var key in object) {
	    if (!(skipIndexes && isIndex(key, length)) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ }),
/* 813 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(74),
	    root = __webpack_require__(7);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(840),
	    hashDelete = __webpack_require__(841),
	    hashGet = __webpack_require__(842),
	    hashHas = __webpack_require__(843),
	    hashSet = __webpack_require__(844);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(74),
	    root = __webpack_require__(7);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ }),
/* 816 */
/***/ (function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(74),
	    root = __webpack_require__(7);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ }),
/* 817 */
/***/ (function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ }),
/* 818 */
/***/ (function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ }),
/* 819 */
/***/ (function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(269),
	    keysIn = __webpack_require__(395);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ }),
/* 821 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    isObjectLike = __webpack_require__(29);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ }),
/* 822 */
/***/ (function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(206),
	    isMasked = __webpack_require__(849),
	    isObject = __webpack_require__(11),
	    toSource = __webpack_require__(393);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(95),
	    isLength = __webpack_require__(207),
	    isObjectLike = __webpack_require__(29);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(11),
	    isPrototype = __webpack_require__(325),
	    nativeKeysIn = __webpack_require__(861);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ }),
/* 825 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ }),
/* 826 */
/***/ (function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(7);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(281)(module)))

/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(322);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(817),
	    arrayReduce = __webpack_require__(386),
	    mapToArray = __webpack_require__(274);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ }),
/* 830 */
/***/ (function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(818),
	    arrayReduce = __webpack_require__(386),
	    setToArray = __webpack_require__(276);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(19);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(322);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(269),
	    getSymbols = __webpack_require__(324);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(269),
	    getSymbolsIn = __webpack_require__(391);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

	var root = __webpack_require__(7);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(389),
	    getSymbolsIn = __webpack_require__(391),
	    keysIn = __webpack_require__(395);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ }),
/* 838 */
/***/ (function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(19);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ }),
/* 839 */
/***/ (function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ }),
/* 840 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(275);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ }),
/* 841 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(275);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(275);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(275);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ }),
/* 845 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(322),
	    cloneDataView = __webpack_require__(828),
	    cloneMap = __webpack_require__(829),
	    cloneRegExp = __webpack_require__(830),
	    cloneSet = __webpack_require__(831),
	    cloneSymbol = __webpack_require__(832),
	    cloneTypedArray = __webpack_require__(833);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(31),
	    getPrototype = __webpack_require__(323),
	    isPrototype = __webpack_require__(325);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ }),
/* 848 */
/***/ (function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(836);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ }),
/* 850 */
/***/ (function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ }),
/* 851 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(266);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ }),
/* 852 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(266);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ }),
/* 853 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(266);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ }),
/* 854 */
/***/ (function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(266);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ }),
/* 855 */
/***/ (function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(814),
	    ListCache = __webpack_require__(263),
	    Map = __webpack_require__(321);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ }),
/* 856 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(272);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ }),
/* 857 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(272);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ }),
/* 858 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(272);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ }),
/* 859 */
/***/ (function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(272);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ }),
/* 860 */
/***/ (function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(392);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ }),
/* 861 */
/***/ (function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ }),
/* 862 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(390);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(281)(module)))

/***/ }),
/* 863 */
/***/ (function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ }),
/* 864 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(263);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ }),
/* 865 */
/***/ (function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ }),
/* 866 */
/***/ (function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ }),
/* 867 */
/***/ (function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ }),
/* 868 */
/***/ (function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(263),
	    Map = __webpack_require__(321),
	    MapCache = __webpack_require__(70);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ }),
/* 869 */,
/* 870 */
/***/ (function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ }),
/* 871 */,
/* 872 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ }),
/* 873 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(875);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(69);
	var invariant = __webpack_require__(35);
	var ReactPropTypesSecret = __webpack_require__(398);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 875 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(69);
	var invariant = __webpack_require__(35);
	var warning = __webpack_require__(261);
	var assign = __webpack_require__(63);
	
	var ReactPropTypesSecret = __webpack_require__(398);
	var checkPropTypes = __webpack_require__(872);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ }),
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"8\" viewBox=\"0 0 15 8\">\n  <polyline fill=\"none\" stroke=\"#000\" points=\"0 0 6.472 7.583 13 0\" transform=\"translate(1)\"/>\n</svg>\n"

/***/ }),
/* 885 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewBox=\"0 0 28 28\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#00ADD9\" d=\"M0,14 C0,6.26801312 6.26801312,0 14,0 C21.7319869,0 28,6.26801312 28,14 C28,21.7319869 21.7319869,28 14,28 C6.26801312,28 0,21.7319869 0,14 Z\"/>\n    <path fill=\"#FFF\" d=\"M10.0463949,11.4693146 L10.0463949,21.2411199 L6.94218059,21.2411199 L6.94218059,11.4693146 L10.0463949,11.4693146 Z M10.2508463,8.44650097 C10.2508463,9.38477432 9.57673946,10.1355487 8.49434975,10.1355487 L8.47451214,10.1355487 C7.43235559,10.1355487 6.75862069,9.38477432 6.75862069,8.44650097 C6.75862069,7.48838165 7.45287512,6.75862069 8.51480729,6.75862069 C9.57673946,6.75862069 10.2306987,7.48838165 10.2508463,8.44650097 Z M21.2413793,15.6382654 L21.2412553,21.2411199 L18.137165,21.2411199 L18.137165,16.0131985 C18.137165,14.7000569 17.6879671,13.8040048 16.5642283,13.8040048 C15.7066236,13.8040048 15.1958051,14.4080746 14.9714541,14.9915202 C14.8893759,15.2006163 14.8692284,15.49195 14.8692284,15.783997 L14.8692284,21.2413793 L11.7646421,21.2413793 C11.7646421,21.2413793 11.8055572,12.3865097 11.7646421,11.469574 L14.8692284,11.469574 L14.8692284,12.8536682 C15.2812308,12.1883094 16.0191279,11.2398536 17.6672615,11.2398536 C19.7099777,11.2398536 21.2413793,12.6367894 21.2413793,15.6382654 Z\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 886 */
/***/ (function(module, exports) {

	module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"22\" height=\"22\" viewBox=\"0 0 28 28\">\n  <g fill=\"none\" fill-rule=\"evenodd\">\n    <path fill=\"#00ADD9\" d=\"M0,14 C0,6.26801312 6.26801312,0 14,0 C21.7319869,0 28,6.26801312 28,14 C28,21.7319869 21.7319869,28 14,28 C6.26801312,28 0,21.7319869 0,14 Z\"/>\n    <path fill=\"#FFF\" d=\"M13.7977989,11.9261722 L13.8281462,12.4019533 L13.3223576,12.3436944 C11.481287,12.1203686 9.87287928,11.3630029 8.50725005,10.0910169 L7.83960909,9.45987878 L7.66764096,9.92594998 C7.30347316,10.9649004 7.53613592,12.0621097 8.29481883,12.8000557 C8.69944972,13.207868 8.60840777,13.2661269 7.91041949,13.0233815 C7.66764096,12.945703 7.45520975,12.8874441 7.4349782,12.9165735 C7.3641678,12.9845423 7.60694633,13.8681356 7.799146,14.217689 C8.06215607,14.7031798 8.59829199,15.1789608 9.18500678,15.4605455 L9.68067961,15.6838713 L9.09396483,15.6935811 C8.52748159,15.6935811 8.50725005,15.7032909 8.56794468,15.9071971 C8.77026012,16.5383352 9.56940612,17.2083125 10.4595941,17.499607 L11.0867719,17.7035132 L10.5405202,18.0142273 C9.73125847,18.4608789 8.78037589,18.7133341 7.82949331,18.7327538 C7.37428357,18.7424636 7,18.7813029 7,18.8104323 C7,18.9075305 8.2341242,19.4512802 8.95234402,19.6648962 C11.1070035,20.2960343 13.6662938,20.0241594 15.5882905,18.9463697 C16.9539198,18.1792942 18.319549,16.654853 18.9568426,15.1789608 C19.3007789,14.3924657 19.6447151,12.9554128 19.6447151,12.2660158 C19.6447151,11.8193642 19.6750625,11.7611053 20.2415457,11.2270654 C20.5753662,10.9163513 20.8889551,10.5765077 20.9496498,10.4794095 C21.0508075,10.294923 21.0406917,10.294923 20.5247873,10.4599899 C19.6649467,10.7512844 19.5435574,10.7124451 19.9684199,10.2755034 C20.2820088,9.96478925 20.6562924,9.40161988 20.6562924,9.236553 C20.6562924,9.20742354 20.5045558,9.25597263 20.3325877,9.34336098 C20.1505038,9.44045915 19.7458729,9.5861064 19.4423997,9.67349475 L18.896148,9.83856163 L18.4004752,9.51813768 C18.1273493,9.34336098 17.74295,9.14916464 17.5406345,9.09090574 C17.0247302,8.95496831 16.2356999,8.97438794 15.7703744,9.12974501 C14.5059029,9.56668676 13.7067569,10.6930255 13.7977989,11.9261722 Z\"/>\n  </g>\n</svg>\n"

/***/ }),
/* 887 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 React v16.0.0
	 react-dom.production.min.js
	
	 Copyright (c) 2013-present, Facebook, Inc.
	
	 This source code is licensed under the MIT license found in the
	 LICENSE file in the root directory of this source tree.
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(1);__webpack_require__(35);var l=__webpack_require__(628),n=__webpack_require__(63),ba=__webpack_require__(627),ca=__webpack_require__(69),da=__webpack_require__(260),ea=__webpack_require__(634),fa=__webpack_require__(629),ha=__webpack_require__(630),ia=__webpack_require__(631);
	function w(a){for(var b=arguments.length-1,c="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,d=0;d<b;d++)c+="\x26args[]\x3d"+encodeURIComponent(arguments[d+1]);b=Error(c+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}aa?void 0:w("227");
	function ja(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}
	var ka={Namespaces:{html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"},getIntrinsicNamespace:ja,getChildNamespace:function(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ja(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}},la=null,oa={};
	function pa(){if(la)for(var a in oa){var b=oa[a],c=la.indexOf(a);-1<c?void 0:w("96",a);if(!qa.plugins[c]){b.extractEvents?void 0:w("97",a);qa.plugins[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;qa.eventNameDispatchConfigs.hasOwnProperty(h)?w("99",h):void 0;qa.eventNameDispatchConfigs[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ra(k[e],g,h);e=!0}else f.registrationName?(ra(f.registrationName,g,h),e=!0):e=!1;e?void 0:w("98",d,a)}}}}
	function ra(a,b,c){qa.registrationNameModules[a]?w("100",a):void 0;qa.registrationNameModules[a]=b;qa.registrationNameDependencies[a]=b.eventTypes[c].dependencies}
	var qa={plugins:[],eventNameDispatchConfigs:{},registrationNameModules:{},registrationNameDependencies:{},possibleRegistrationNames:null,injectEventPluginOrder:function(a){la?w("101"):void 0;la=Array.prototype.slice.call(a);pa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];oa.hasOwnProperty(c)&&oa[c]===d||(oa[c]?w("102",c):void 0,oa[c]=d,b=!0)}b&&pa()}},sa=qa,ta={children:!0,dangerouslySetInnerHTML:!0,autoFocus:!0,defaultValue:!0,defaultChecked:!0,
	innerHTML:!0,suppressContentEditableWarning:!0,style:!0};function ua(a,b){return(a&b)===b}
	var wa={MUST_USE_PROPERTY:1,HAS_BOOLEAN_VALUE:4,HAS_NUMERIC_VALUE:8,HAS_POSITIVE_NUMERIC_VALUE:24,HAS_OVERLOADED_BOOLEAN_VALUE:32,HAS_STRING_BOOLEAN_VALUE:64,injectDOMPropertyConfig:function(a){var b=wa,c=a.Properties||{},d=a.DOMAttributeNamespaces||{},e=a.DOMAttributeNames||{};a=a.DOMMutationMethods||{};for(var f in c){xa.properties.hasOwnProperty(f)?w("48",f):void 0;var g=f.toLowerCase(),h=c[f];g={attributeName:g,attributeNamespace:null,propertyName:f,mutationMethod:null,mustUseProperty:ua(h,b.MUST_USE_PROPERTY),
	hasBooleanValue:ua(h,b.HAS_BOOLEAN_VALUE),hasNumericValue:ua(h,b.HAS_NUMERIC_VALUE),hasPositiveNumericValue:ua(h,b.HAS_POSITIVE_NUMERIC_VALUE),hasOverloadedBooleanValue:ua(h,b.HAS_OVERLOADED_BOOLEAN_VALUE),hasStringBooleanValue:ua(h,b.HAS_STRING_BOOLEAN_VALUE)};1>=g.hasBooleanValue+g.hasNumericValue+g.hasOverloadedBooleanValue?void 0:w("50",f);e.hasOwnProperty(f)&&(g.attributeName=e[f]);d.hasOwnProperty(f)&&(g.attributeNamespace=d[f]);a.hasOwnProperty(f)&&(g.mutationMethod=a[f]);xa.properties[f]=
	g}}},xa={ID_ATTRIBUTE_NAME:"data-reactid",ROOT_ATTRIBUTE_NAME:"data-reactroot",ATTRIBUTE_NAME_START_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD",ATTRIBUTE_NAME_CHAR:":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040",
	properties:{},shouldSetAttribute:function(a,b){if(xa.isReservedProp(a)||!("o"!==a[0]&&"O"!==a[0]||"n"!==a[1]&&"N"!==a[1]))return!1;if(null===b)return!0;switch(typeof b){case "boolean":return xa.shouldAttributeAcceptBooleanValue(a);case "undefined":case "number":case "string":case "object":return!0;default:return!1}},getPropertyInfo:function(a){return xa.properties.hasOwnProperty(a)?xa.properties[a]:null},shouldAttributeAcceptBooleanValue:function(a){if(xa.isReservedProp(a))return!0;var b=xa.getPropertyInfo(a);
	if(b)return b.hasBooleanValue||b.hasStringBooleanValue||b.hasOverloadedBooleanValue;a=a.toLowerCase().slice(0,5);return"data-"===a||"aria-"===a},isReservedProp:function(a){return ta.hasOwnProperty(a)},injection:wa},A=xa,E={IndeterminateComponent:0,FunctionalComponent:1,ClassComponent:2,HostRoot:3,HostPortal:4,HostComponent:5,HostText:6,CoroutineComponent:7,CoroutineHandlerPhase:8,YieldComponent:9,Fragment:10},F={ELEMENT_NODE:1,TEXT_NODE:3,COMMENT_NODE:8,DOCUMENT_NODE:9,DOCUMENT_FRAGMENT_NODE:11},
	ya=E.HostComponent,za=E.HostText,Aa=F.ELEMENT_NODE,Ba=F.COMMENT_NODE,Ea=A.ID_ATTRIBUTE_NAME,Fa={hasCachedChildNodes:1},Ga=Math.random().toString(36).slice(2),Ha="__reactInternalInstance$"+Ga,Ia="__reactEventHandlers$"+Ga;function La(a){for(var b;b=a._renderedComponent;)a=b;return a}function Ma(a,b){a=La(a);a._hostNode=b;b[Ha]=a}
	function Na(a,b){if(!(a._flags&Fa.hasCachedChildNodes)){var c=a._renderedChildren;b=b.firstChild;var d;a:for(d in c)if(c.hasOwnProperty(d)){var e=c[d],f=La(e)._domID;if(0!==f){for(;null!==b;b=b.nextSibling){var g=b,h=f;if(g.nodeType===Aa&&g.getAttribute(Ea)===""+h||g.nodeType===Ba&&g.nodeValue===" react-text: "+h+" "||g.nodeType===Ba&&g.nodeValue===" react-empty: "+h+" "){Ma(e,b);continue a}}w("32",f)}}a._flags|=Fa.hasCachedChildNodes}}
	function Oa(a){if(a[Ha])return a[Ha];for(var b=[];!a[Ha];)if(b.push(a),a.parentNode)a=a.parentNode;else return null;var c=a[Ha];if(c.tag===ya||c.tag===za)return c;for(;a&&(c=a[Ha]);a=b.pop()){var d=c;b.length&&Na(c,a)}return d}
	var G={getClosestInstanceFromNode:Oa,getInstanceFromNode:function(a){var b=a[Ha];if(b)return b.tag===ya||b.tag===za?b:b._hostNode===a?b:null;b=Oa(a);return null!=b&&b._hostNode===a?b:null},getNodeFromInstance:function(a){if(a.tag===ya||a.tag===za)return a.stateNode;void 0===a._hostNode?w("33"):void 0;if(a._hostNode)return a._hostNode;for(var b=[];!a._hostNode;)b.push(a),a._hostParent?void 0:w("34"),a=a._hostParent;for(;b.length;a=b.pop())Na(a,a._hostNode);return a._hostNode},precacheChildNodes:Na,
	precacheNode:Ma,uncacheNode:function(a){var b=a._hostNode;b&&(delete b[Ha],a._hostNode=null)},precacheFiberNode:function(a,b){b[Ha]=a},getFiberCurrentPropsFromNode:function(a){return a[Ia]||null},updateFiberProps:function(a,b){a[Ia]=b}},Pa={remove:function(a){a._reactInternalFiber=void 0},get:function(a){return a._reactInternalFiber},has:function(a){return void 0!==a._reactInternalFiber},set:function(a,b){a._reactInternalFiber=b}},Qa={ReactCurrentOwner:aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner};
	function Ra(a){if("function"===typeof a.getName)return a.getName();if("number"===typeof a.tag){a=a.type;if("string"===typeof a)return a;if("function"===typeof a)return a.displayName||a.name}return null}var J={NoEffect:0,PerformedWork:1,Placement:2,Update:4,PlacementAndUpdate:6,Deletion:8,ContentReset:16,Callback:32,Err:64,Ref:128},Sa=E.HostComponent,Ta=E.HostRoot,Ua=E.HostPortal,Va=E.HostText,Wa=J.NoEffect,Xa=J.Placement;
	function Za(a){var b=a;if(a.alternate)for(;b["return"];)b=b["return"];else{if((b.effectTag&Xa)!==Wa)return 1;for(;b["return"];)if(b=b["return"],(b.effectTag&Xa)!==Wa)return 1}return b.tag===Ta?2:3}function $a(a){2!==Za(a)?w("188"):void 0}
	function ab(a){var b=a.alternate;if(!b)return b=Za(a),3===b?w("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c["return"],f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return $a(e),a;if(g===d)return $a(e),b;g=g.sibling}w("188")}if(c["return"]!==d["return"])c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:w("189")}}c.alternate!==d?w("190"):void 0}c.tag!==Ta?w("188"):void 0;return c.stateNode.current===c?a:b}
	var bb={isFiberMounted:function(a){return 2===Za(a)},isMounted:function(a){return(a=Pa.get(a))?2===Za(a):!1},findCurrentFiberUsingSlowPath:ab,findCurrentHostFiber:function(a){a=ab(a);if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null},findCurrentHostFiberWithNoPortals:function(a){a=ab(a);
	if(!a)return null;for(var b=a;;){if(b.tag===Sa||b.tag===Va)return b;if(b.child&&b.tag!==Ua)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b["return"]||b["return"]===a)return null;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}return null}},K={_caughtError:null,_hasCaughtError:!1,_rethrowError:null,_hasRethrowError:!1,injection:{injectErrorUtils:function(a){"function"!==typeof a.invokeGuardedCallback?w("197"):void 0;cb=a.invokeGuardedCallback}},invokeGuardedCallback:function(a,
	b,c,d,e,f,g,h,k){cb.apply(K,arguments)},invokeGuardedCallbackAndCatchFirstError:function(a,b,c,d,e,f,g,h,k){K.invokeGuardedCallback.apply(this,arguments);if(K.hasCaughtError()){var p=K.clearCaughtError();K._hasRethrowError||(K._hasRethrowError=!0,K._rethrowError=p)}},rethrowCaughtError:function(){return db.apply(K,arguments)},hasCaughtError:function(){return K._hasCaughtError},clearCaughtError:function(){if(K._hasCaughtError){var a=K._caughtError;K._caughtError=null;K._hasCaughtError=!1;return a}w("198")}};
	function cb(a,b,c,d,e,f,g,h,k){K._hasCaughtError=!1;K._caughtError=null;var p=Array.prototype.slice.call(arguments,3);try{b.apply(c,p)}catch(x){K._caughtError=x,K._hasCaughtError=!0}}function db(){if(K._hasRethrowError){var a=K._rethrowError;K._rethrowError=null;K._hasRethrowError=!1;throw a;}}var eb=K,fb;function gb(a,b,c,d){b=a.type||"unknown-event";a.currentTarget=hb.getNodeFromInstance(d);eb.invokeGuardedCallbackAndCatchFirstError(b,c,void 0,a);a.currentTarget=null}
	var hb={isEndish:function(a){return"topMouseUp"===a||"topTouchEnd"===a||"topTouchCancel"===a},isMoveish:function(a){return"topMouseMove"===a||"topTouchMove"===a},isStartish:function(a){return"topMouseDown"===a||"topTouchStart"===a},executeDirectDispatch:function(a){var b=a._dispatchListeners,c=a._dispatchInstances;Array.isArray(b)?w("103"):void 0;a.currentTarget=b?hb.getNodeFromInstance(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b},executeDispatchesInOrder:function(a,
	b){var c=a._dispatchListeners,d=a._dispatchInstances;if(Array.isArray(c))for(var e=0;e<c.length&&!a.isPropagationStopped();e++)gb(a,b,c[e],d[e]);else c&&gb(a,b,c,d);a._dispatchListeners=null;a._dispatchInstances=null},executeDispatchesInOrderStopAtTrue:function(a){a:{var b=a._dispatchListeners;var c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++){if(b[d](a,c[d])){b=c[d];break a}}else if(b&&b(a,c)){b=c;break a}b=null}a._dispatchInstances=null;a._dispatchListeners=
	null;return b},hasDispatches:function(a){return!!a._dispatchListeners},getFiberCurrentPropsFromNode:function(a){return fb.getFiberCurrentPropsFromNode(a)},getInstanceFromNode:function(a){return fb.getInstanceFromNode(a)},getNodeFromInstance:function(a){return fb.getNodeFromInstance(a)},injection:{injectComponentTree:function(a){fb=a}}},ib=hb,jb=null,kb=null,lb=null;
	function mb(a){if(a=ib.getInstanceFromNode(a))if("number"===typeof a.tag){jb&&"function"===typeof jb.restoreControlledState?void 0:w("194");var b=ib.getFiberCurrentPropsFromNode(a.stateNode);jb.restoreControlledState(a.stateNode,a.type,b)}else"function"!==typeof a.restoreControlledState?w("195"):void 0,a.restoreControlledState()}
	var nb={injection:{injectFiberControlledHostComponent:function(a){jb=a}},enqueueStateRestore:function(a){kb?lb?lb.push(a):lb=[a]:kb=a},restoreStateIfNeeded:function(){if(kb){var a=kb,b=lb;lb=kb=null;mb(a);if(b)for(a=0;a<b.length;a++)mb(b[a])}}};function ob(a,b,c,d,e,f){return a(b,c,d,e,f)}function pb(a,b){return a(b)}function qb(a,b){return pb(a,b)}
	var rb=!1,sb={batchedUpdates:function(a,b){if(rb)return ob(qb,a,b);rb=!0;try{return ob(qb,a,b)}finally{rb=!1,nb.restoreStateIfNeeded()}},injection:{injectStackBatchedUpdates:function(a){ob=a},injectFiberBatchedUpdates:function(a){pb=a}}},tb=F.TEXT_NODE;function ub(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return a.nodeType===tb?a.parentNode:a}var vb=E.HostRoot,wb=[];
	function xb(a){var b=a.targetInst;do{if(!b){a.ancestors.push(b);break}var c=b;if("number"===typeof c.tag){for(;c["return"];)c=c["return"];c=c.tag!==vb?null:c.stateNode.containerInfo}else{for(;c._hostParent;)c=c._hostParent;c=G.getNodeFromInstance(c).parentNode}if(!c)break;a.ancestors.push(b);b=G.getClosestInstanceFromNode(c)}while(b);for(c=0;c<a.ancestors.length;c++)b=a.ancestors[c],yb._handleTopLevel(a.topLevelType,b,a.nativeEvent,ub(a.nativeEvent))}
	var yb={_enabled:!0,_handleTopLevel:null,setHandleTopLevel:function(a){yb._handleTopLevel=a},setEnabled:function(a){yb._enabled=!!a},isEnabled:function(){return yb._enabled},trapBubbledEvent:function(a,b,c){return c?ba.listen(c,b,yb.dispatchEvent.bind(null,a)):null},trapCapturedEvent:function(a,b,c){return c?ba.capture(c,b,yb.dispatchEvent.bind(null,a)):null},dispatchEvent:function(a,b){if(yb._enabled){var c=ub(b);c=G.getClosestInstanceFromNode(c);null===c||"number"!==typeof c.tag||bb.isFiberMounted(c)||
	(c=null);if(wb.length){var d=wb.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{sb.batchedUpdates(xb,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>wb.length&&wb.push(a)}}}},L=yb;function Cb(a,b){null==b?w("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function Db(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Eb=null;function Fb(a,b){a&&(ib.executeDispatchesInOrder(a,b),a.isPersistent()||a.constructor.release(a))}function Gb(a){return Fb(a,!0)}function Hb(a){return Fb(a,!1)}
	function Ib(a,b,c){switch(a){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":return!(!c.disabled||"button"!==b&&"input"!==b&&"select"!==b&&"textarea"!==b);default:return!1}}
	var Jb={injection:{injectEventPluginOrder:sa.injectEventPluginOrder,injectEventPluginsByName:sa.injectEventPluginsByName},getListener:function(a,b){if("number"===typeof a.tag){var c=a.stateNode;if(!c)return null;var d=ib.getFiberCurrentPropsFromNode(c);if(!d)return null;c=d[b];if(Ib(b,a.type,d))return null}else{d=a._currentElement;if("string"===typeof d||"number"===typeof d||!a._rootNodeID)return null;a=d.props;c=a[b];if(Ib(b,d.type,a))return null}c&&"function"!==typeof c?w("231",b,typeof c):void 0;
	return c},extractEvents:function(a,b,c,d){for(var e,f=sa.plugins,g=0;g<f.length;g++){var h=f[g];h&&(h=h.extractEvents(a,b,c,d))&&(e=Cb(e,h))}return e},enqueueEvents:function(a){a&&(Eb=Cb(Eb,a))},processEventQueue:function(a){var b=Eb;Eb=null;a?Db(b,Gb):Db(b,Hb);Eb?w("95"):void 0;eb.rethrowCaughtError()}},Kb;l.canUseDOM&&(Kb=document.implementation&&document.implementation.hasFeature&&!0!==document.implementation.hasFeature("",""));
	function Lb(a,b){if(!l.canUseDOM||b&&!("addEventListener"in document))return!1;b="on"+a;var c=b in document;c||(c=document.createElement("div"),c.setAttribute(b,"return;"),c="function"===typeof c[b]);!c&&Kb&&"wheel"===a&&(c=document.implementation.hasFeature("Events.wheel","3.0"));return c}function Mb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;c["ms"+a]="MS"+b;c["O"+a]="o"+b.toLowerCase();return c}
	var Nb={animationend:Mb("Animation","AnimationEnd"),animationiteration:Mb("Animation","AnimationIteration"),animationstart:Mb("Animation","AnimationStart"),transitionend:Mb("Transition","TransitionEnd")},Ob={},Pb={};l.canUseDOM&&(Pb=document.createElement("div").style,"AnimationEvent"in window||(delete Nb.animationend.animation,delete Nb.animationiteration.animation,delete Nb.animationstart.animation),"TransitionEvent"in window||delete Nb.transitionend.transition);
	function Qb(a){if(Ob[a])return Ob[a];if(!Nb[a])return a;var b=Nb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Pb)return Ob[a]=b[c];return""}
	var Rb={topAbort:"abort",topAnimationEnd:Qb("animationend")||"animationend",topAnimationIteration:Qb("animationiteration")||"animationiteration",topAnimationStart:Qb("animationstart")||"animationstart",topBlur:"blur",topCancel:"cancel",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topChange:"change",topClick:"click",topClose:"close",topCompositionEnd:"compositionend",topCompositionStart:"compositionstart",topCompositionUpdate:"compositionupdate",topContextMenu:"contextmenu",topCopy:"copy",
	topCut:"cut",topDoubleClick:"dblclick",topDrag:"drag",topDragEnd:"dragend",topDragEnter:"dragenter",topDragExit:"dragexit",topDragLeave:"dragleave",topDragOver:"dragover",topDragStart:"dragstart",topDrop:"drop",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topFocus:"focus",topInput:"input",topKeyDown:"keydown",topKeyPress:"keypress",topKeyUp:"keyup",topLoadedData:"loadeddata",topLoad:"load",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",
	topMouseDown:"mousedown",topMouseMove:"mousemove",topMouseOut:"mouseout",topMouseOver:"mouseover",topMouseUp:"mouseup",topPaste:"paste",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topScroll:"scroll",topSeeked:"seeked",topSeeking:"seeking",topSelectionChange:"selectionchange",topStalled:"stalled",topSuspend:"suspend",topTextInput:"textInput",topTimeUpdate:"timeupdate",topToggle:"toggle",topTouchCancel:"touchcancel",topTouchEnd:"touchend",topTouchMove:"touchmove",
	topTouchStart:"touchstart",topTransitionEnd:Qb("transitionend")||"transitionend",topVolumeChange:"volumechange",topWaiting:"waiting",topWheel:"wheel"},Sb={},Tb=0,Ub="_reactListenersID"+(""+Math.random()).slice(2);function Vb(a){Object.prototype.hasOwnProperty.call(a,Ub)||(a[Ub]=Tb++,Sb[a[Ub]]={});return Sb[a[Ub]]}
	var M=n({},{handleTopLevel:function(a,b,c,d){a=Jb.extractEvents(a,b,c,d);Jb.enqueueEvents(a);Jb.processEventQueue(!1)}},{setEnabled:function(a){L&&L.setEnabled(a)},isEnabled:function(){return!(!L||!L.isEnabled())},listenTo:function(a,b){var c=Vb(b);a=sa.registrationNameDependencies[a];for(var d=0;d<a.length;d++){var e=a[d];c.hasOwnProperty(e)&&c[e]||("topWheel"===e?Lb("wheel")?L.trapBubbledEvent("topWheel","wheel",b):Lb("mousewheel")?L.trapBubbledEvent("topWheel","mousewheel",b):L.trapBubbledEvent("topWheel",
	"DOMMouseScroll",b):"topScroll"===e?L.trapCapturedEvent("topScroll","scroll",b):"topFocus"===e||"topBlur"===e?(L.trapCapturedEvent("topFocus","focus",b),L.trapCapturedEvent("topBlur","blur",b),c.topBlur=!0,c.topFocus=!0):"topCancel"===e?(Lb("cancel",!0)&&L.trapCapturedEvent("topCancel","cancel",b),c.topCancel=!0):"topClose"===e?(Lb("close",!0)&&L.trapCapturedEvent("topClose","close",b),c.topClose=!0):Rb.hasOwnProperty(e)&&L.trapBubbledEvent(e,Rb[e],b),c[e]=!0)}},isListeningToAllDependencies:function(a,
	b){b=Vb(b);a=sa.registrationNameDependencies[a];for(var c=0;c<a.length;c++){var d=a[c];if(!b.hasOwnProperty(d)||!b[d])return!1}return!0},trapBubbledEvent:function(a,b,c){return L.trapBubbledEvent(a,b,c)},trapCapturedEvent:function(a,b,c){return L.trapCapturedEvent(a,b,c)}}),Wb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,
	flexOrder:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Xb=["Webkit","ms","Moz","O"];
	Object.keys(Wb).forEach(function(a){Xb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Wb[b]=Wb[a]})});
	var Yb={isUnitlessNumber:Wb,shorthandPropertyExpansions:{background:{backgroundAttachment:!0,backgroundColor:!0,backgroundImage:!0,backgroundPositionX:!0,backgroundPositionY:!0,backgroundRepeat:!0},backgroundPosition:{backgroundPositionX:!0,backgroundPositionY:!0},border:{borderWidth:!0,borderStyle:!0,borderColor:!0},borderBottom:{borderBottomWidth:!0,borderBottomStyle:!0,borderBottomColor:!0},borderLeft:{borderLeftWidth:!0,borderLeftStyle:!0,borderLeftColor:!0},borderRight:{borderRightWidth:!0,borderRightStyle:!0,
	borderRightColor:!0},borderTop:{borderTopWidth:!0,borderTopStyle:!0,borderTopColor:!0},font:{fontStyle:!0,fontVariant:!0,fontWeight:!0,fontSize:!0,lineHeight:!0,fontFamily:!0},outline:{outlineWidth:!0,outlineStyle:!0,outlineColor:!0}}},Zb=Yb.isUnitlessNumber,$b=!1;if(l.canUseDOM){var ac=document.createElement("div").style;try{ac.font=""}catch(a){$b=!0}}
	var bc={createDangerousStringForStyles:function(){},setValueForStyles:function(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--");var e=c;var f=b[c];e=null==f||"boolean"===typeof f||""===f?"":d||"number"!==typeof f||0===f||Zb.hasOwnProperty(e)&&Zb[e]?(""+f).trim():f+"px";"float"===c&&(c="cssFloat");if(d)a.setProperty(c,e);else if(e)a[c]=e;else if(d=$b&&Yb.shorthandPropertyExpansions[c])for(var g in d)a[g]="";else a[c]=""}}},cc=new RegExp("^["+A.ATTRIBUTE_NAME_START_CHAR+
	"]["+A.ATTRIBUTE_NAME_CHAR+"]*$"),dc={},ec={};function fc(a){if(ec.hasOwnProperty(a))return!0;if(dc.hasOwnProperty(a))return!1;if(cc.test(a))return ec[a]=!0;dc[a]=!0;return!1}
	var gc={setAttributeForID:function(a,b){a.setAttribute(A.ID_ATTRIBUTE_NAME,b)},setAttributeForRoot:function(a){a.setAttribute(A.ROOT_ATTRIBUTE_NAME,"")},getValueForProperty:function(){},getValueForAttribute:function(){},setValueForProperty:function(a,b,c){var d=A.getPropertyInfo(b);if(d&&A.shouldSetAttribute(b,c)){var e=d.mutationMethod;e?e(a,c):null==c||d.hasBooleanValue&&!c||d.hasNumericValue&&isNaN(c)||d.hasPositiveNumericValue&&1>c||d.hasOverloadedBooleanValue&&!1===c?gc.deleteValueForProperty(a,
	b):d.mustUseProperty?a[d.propertyName]=c:(b=d.attributeName,(e=d.attributeNamespace)?a.setAttributeNS(e,b,""+c):d.hasBooleanValue||d.hasOverloadedBooleanValue&&!0===c?a.setAttribute(b,""):a.setAttribute(b,""+c))}else gc.setValueForAttribute(a,b,A.shouldSetAttribute(b,c)?c:null)},setValueForAttribute:function(a,b,c){fc(b)&&(null==c?a.removeAttribute(b):a.setAttribute(b,""+c))},deleteValueForAttribute:function(a,b){a.removeAttribute(b)},deleteValueForProperty:function(a,b){var c=A.getPropertyInfo(b);
	c?(b=c.mutationMethod)?b(a,void 0):c.mustUseProperty?a[c.propertyName]=c.hasBooleanValue?!1:"":a.removeAttribute(c.attributeName):a.removeAttribute(b)}},hc=gc,ic=Qa.ReactDebugCurrentFrame;function jc(){return null}
	var kc={current:null,phase:null,resetCurrentFiber:function(){ic.getCurrentStack=null;kc.current=null;kc.phase=null},setCurrentFiber:function(a,b){ic.getCurrentStack=jc;kc.current=a;kc.phase=b},getCurrentFiberOwnerName:function(){return null},getCurrentFiberStackAddendum:jc},lc=kc,mc={getHostProps:function(a,b){var c=b.value,d=b.checked;return n({type:void 0,step:void 0,min:void 0,max:void 0},b,{defaultChecked:void 0,defaultValue:void 0,value:null!=c?c:a._wrapperState.initialValue,checked:null!=d?
	d:a._wrapperState.initialChecked})},initWrapperState:function(a,b){var c=b.defaultValue;a._wrapperState={initialChecked:null!=b.checked?b.checked:b.defaultChecked,initialValue:null!=b.value?b.value:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}},updateWrapper:function(a,b){var c=b.checked;null!=c&&hc.setValueForProperty(a,"checked",c||!1);c=b.value;if(null!=c)if(0===c&&""===a.value)a.value="0";else if("number"===b.type){if(b=parseFloat(a.value)||0,c!=b||c==b&&a.value!=
	c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else null==b.value&&null!=b.defaultValue&&a.defaultValue!==""+b.defaultValue&&(a.defaultValue=""+b.defaultValue),null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)},postMountWrapper:function(a,b){switch(b.type){case "submit":case "reset":break;case "color":case "date":case "datetime":case "datetime-local":case "month":case "time":case "week":a.value="";a.value=a.defaultValue;break;default:a.value=a.value}b=a.name;""!==
	b&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!a.defaultChecked;""!==b&&(a.name=b)},restoreControlledState:function(a,b){mc.updateWrapper(a,b);var c=b.name;if("radio"===b.type&&null!=c){for(b=a;b.parentNode;)b=b.parentNode;c=b.querySelectorAll("input[name\x3d"+JSON.stringify(""+c)+'][type\x3d"radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=G.getFiberCurrentPropsFromNode(d);e?void 0:w("90");mc.updateWrapper(d,e)}}}}},qc=mc;
	function rc(a){var b="";aa.Children.forEach(a,function(a){null==a||"string"!==typeof a&&"number"!==typeof a||(b+=a)});return b}var sc={validateProps:function(){},postMountWrapper:function(a,b){null!=b.value&&a.setAttribute("value",b.value)},getHostProps:function(a,b){a=n({children:void 0},b);if(b=rc(b.children))a.children=b;return a}};
	function tc(a,b,c){a=a.options;if(b){b={};for(var d=0;d<c.length;d++)b["$"+c[d]]=!0;for(c=0;c<a.length;c++)d=b.hasOwnProperty("$"+a[c].value),a[c].selected!==d&&(a[c].selected=d)}else{c=""+c;b=null;for(d=0;d<a.length;d++){if(a[d].value===c){a[d].selected=!0;return}null!==b||a[d].disabled||(b=a[d])}null!==b&&(b.selected=!0)}}
	var uc={getHostProps:function(a,b){return n({},b,{value:void 0})},initWrapperState:function(a,b){var c=b.value;a._wrapperState={initialValue:null!=c?c:b.defaultValue,wasMultiple:!!b.multiple}},postMountWrapper:function(a,b){a.multiple=!!b.multiple;var c=b.value;null!=c?tc(a,!!b.multiple,c):null!=b.defaultValue&&tc(a,!!b.multiple,b.defaultValue)},postUpdateWrapper:function(a,b){a._wrapperState.initialValue=void 0;var c=a._wrapperState.wasMultiple;a._wrapperState.wasMultiple=!!b.multiple;var d=b.value;
	null!=d?tc(a,!!b.multiple,d):c!==!!b.multiple&&(null!=b.defaultValue?tc(a,!!b.multiple,b.defaultValue):tc(a,!!b.multiple,b.multiple?[]:""))},restoreControlledState:function(a,b){var c=b.value;null!=c&&tc(a,!!b.multiple,c)}},vc={getHostProps:function(a,b){null!=b.dangerouslySetInnerHTML?w("91"):void 0;return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})},initWrapperState:function(a,b){var c=b.value,d=c;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?
	w("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:w("93"),b=b[0]),c=""+b),null==c&&(c=""),d=c);a._wrapperState={initialValue:""+d}},updateWrapper:function(a,b){var c=b.value;null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&(a.defaultValue=c));null!=b.defaultValue&&(a.defaultValue=b.defaultValue)},postMountWrapper:function(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)},restoreControlledState:function(a,b){vc.updateWrapper(a,b)}},wc=vc,xc=n({menuitem:!0},{area:!0,
	base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});function yc(a,b){b&&(xc[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?w("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?w("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:w("61")),null!=b.style&&"object"!==typeof b.style?w("62",""):void 0)}
	function zc(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ac(a){var b=zc(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"function"===typeof c.get&&"function"===typeof c.set)return Object.defineProperty(a,b,{enumerable:c.enumerable,configurable:!0,get:function(){return c.get.call(this)},set:function(a){d=""+a;c.set.call(this,a)}}),{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=null;delete a[b]}}}
	var Bc={_getTrackerFromNode:function(a){return a._valueTracker},track:function(a){a._valueTracker||(a._valueTracker=Ac(a))},updateValueIfChanged:function(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=zc(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1},stopTracking:function(a){(a=a._valueTracker)&&a.stopTracking()}};
	function Cc(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	var Dc=ka.Namespaces,Ec,Fc=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Dc.svg||"innerHTML"in a)a.innerHTML=b;else for(Ec=Ec||document.createElement("div"),Ec.innerHTML="\x3csvg\x3e"+b+"\x3c/svg\x3e",b=Ec.firstChild;b.firstChild;)a.appendChild(b.firstChild)}),Gc=/["'&<>]/,Hc=F.TEXT_NODE;
	function Ic(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&c.nodeType===Hc){c.nodeValue=b;return}}a.textContent=b}
	l.canUseDOM&&("textContent"in document.documentElement||(Ic=function(a,b){if(a.nodeType===Hc)a.nodeValue=b;else{if("boolean"===typeof b||"number"===typeof b)b=""+b;else{b=""+b;var c=Gc.exec(b);if(c){var d="",e,f=0;for(e=c.index;e<b.length;e++){switch(b.charCodeAt(e)){case 34:c="\x26quot;";break;case 38:c="\x26amp;";break;case 39:c="\x26#x27;";break;case 60:c="\x26lt;";break;case 62:c="\x26gt;";break;default:continue}f!==e&&(d+=b.substring(f,e));f=e+1;d+=c}b=f!==e?d+b.substring(f,e):d}}Fc(a,b)}}));
	var Jc=Ic,Kc=lc.getCurrentFiberOwnerName,Lc=F.DOCUMENT_NODE,Mc=F.DOCUMENT_FRAGMENT_NODE,Nc=M.listenTo,Oc=sa.registrationNameModules,Pc=ka.Namespaces.html,Qc=ka.getIntrinsicNamespace;function Rc(a,b){Nc(b,a.nodeType===Lc||a.nodeType===Mc?a:a.ownerDocument)}
	var Sc={topAbort:"abort",topCanPlay:"canplay",topCanPlayThrough:"canplaythrough",topDurationChange:"durationchange",topEmptied:"emptied",topEncrypted:"encrypted",topEnded:"ended",topError:"error",topLoadedData:"loadeddata",topLoadedMetadata:"loadedmetadata",topLoadStart:"loadstart",topPause:"pause",topPlay:"play",topPlaying:"playing",topProgress:"progress",topRateChange:"ratechange",topSeeked:"seeked",topSeeking:"seeking",topStalled:"stalled",topSuspend:"suspend",topTimeUpdate:"timeupdate",topVolumeChange:"volumechange",
	topWaiting:"waiting"},N={createElement:function(a,b,c,d){c=c.nodeType===Lc?c:c.ownerDocument;d===Pc&&(d=Qc(a));d===Pc?"script"===a?(a=c.createElement("div"),a.innerHTML="\x3cscript\x3e\x3c/script\x3e",a=a.removeChild(a.firstChild)):a="string"===typeof b.is?c.createElement(a,{is:b.is}):c.createElement(a):a=c.createElementNS(d,a);return a},createTextNode:function(a,b){return(b.nodeType===Lc?b:b.ownerDocument).createTextNode(a)},setInitialProperties:function(a,b,c,d){var e=Cc(b,c);switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
	"load",a);var f=c;break;case "video":case "audio":for(f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);f=c;break;case "source":M.trapBubbledEvent("topError","error",a);f=c;break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);f=c;break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);f=c;break;case "details":M.trapBubbledEvent("topToggle","toggle",a);f=c;break;case "input":qc.initWrapperState(a,
	c);f=qc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "option":sc.validateProps(a,c);f=sc.getHostProps(a,c);break;case "select":uc.initWrapperState(a,c);f=uc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;case "textarea":wc.initWrapperState(a,c);f=wc.getHostProps(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(d,"onChange");break;default:f=c}yc(b,f,Kc);var g=f,h;for(h in g)if(g.hasOwnProperty(h)){var k=g[h];"style"===
	h?bc.setValueForStyles(a,k):"dangerouslySetInnerHTML"===h?(k=k?k.__html:void 0,null!=k&&Fc(a,k)):"children"===h?"string"===typeof k?Jc(a,k):"number"===typeof k&&Jc(a,""+k):"suppressContentEditableWarning"!==h&&(Oc.hasOwnProperty(h)?null!=k&&Rc(d,h):e?hc.setValueForAttribute(a,h,k):null!=k&&hc.setValueForProperty(a,h,k))}switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "option":sc.postMountWrapper(a,c);break;case "select":uc.postMountWrapper(a,
	c);break;default:"function"===typeof f.onClick&&(a.onclick=ca)}},diffProperties:function(a,b,c,d,e){var f=null;switch(b){case "input":c=qc.getHostProps(a,c);d=qc.getHostProps(a,d);f=[];break;case "option":c=sc.getHostProps(a,c);d=sc.getHostProps(a,d);f=[];break;case "select":c=uc.getHostProps(a,c);d=uc.getHostProps(a,d);f=[];break;case "textarea":c=wc.getHostProps(a,c);d=wc.getHostProps(a,d);f=[];break;default:"function"!==typeof c.onClick&&"function"===typeof d.onClick&&(a.onclick=ca)}yc(b,d,Kc);
	var g,h;a=null;for(g in c)if(!d.hasOwnProperty(g)&&c.hasOwnProperty(g)&&null!=c[g])if("style"===g)for(h in b=c[g],b)b.hasOwnProperty(h)&&(a||(a={}),a[h]="");else"dangerouslySetInnerHTML"!==g&&"children"!==g&&"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?f||(f=[]):(f=f||[]).push(g,null));for(g in d){var k=d[g];b=null!=c?c[g]:void 0;if(d.hasOwnProperty(g)&&k!==b&&(null!=k||null!=b))if("style"===g)if(b){for(h in b)!b.hasOwnProperty(h)||k&&k.hasOwnProperty(h)||(a||(a={}),a[h]="");for(h in k)k.hasOwnProperty(h)&&
	b[h]!==k[h]&&(a||(a={}),a[h]=k[h])}else a||(f||(f=[]),f.push(g,a)),a=k;else"dangerouslySetInnerHTML"===g?(k=k?k.__html:void 0,b=b?b.__html:void 0,null!=k&&b!==k&&(f=f||[]).push(g,""+k)):"children"===g?b===k||"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(g,""+k):"suppressContentEditableWarning"!==g&&(Oc.hasOwnProperty(g)?(null!=k&&Rc(e,g),f||b===k||(f=[])):(f=f||[]).push(g,k))}a&&(f=f||[]).push("style",a);return f},updateProperties:function(a,b,c,d,e){Cc(c,d);d=Cc(c,e);for(var f=0;f<b.length;f+=
	2){var g=b[f],h=b[f+1];"style"===g?bc.setValueForStyles(a,h):"dangerouslySetInnerHTML"===g?Fc(a,h):"children"===g?Jc(a,h):d?null!=h?hc.setValueForAttribute(a,g,h):hc.deleteValueForAttribute(a,g):null!=h?hc.setValueForProperty(a,g,h):hc.deleteValueForProperty(a,g)}switch(c){case "input":qc.updateWrapper(a,e);Bc.updateValueIfChanged(a);break;case "textarea":wc.updateWrapper(a,e);break;case "select":uc.postUpdateWrapper(a,e)}},diffHydratedProperties:function(a,b,c,d,e){switch(b){case "iframe":case "object":M.trapBubbledEvent("topLoad",
	"load",a);break;case "video":case "audio":for(var f in Sc)Sc.hasOwnProperty(f)&&M.trapBubbledEvent(f,Sc[f],a);break;case "source":M.trapBubbledEvent("topError","error",a);break;case "img":case "image":M.trapBubbledEvent("topError","error",a);M.trapBubbledEvent("topLoad","load",a);break;case "form":M.trapBubbledEvent("topReset","reset",a);M.trapBubbledEvent("topSubmit","submit",a);break;case "details":M.trapBubbledEvent("topToggle","toggle",a);break;case "input":qc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid",
	"invalid",a);Rc(e,"onChange");break;case "option":sc.validateProps(a,c);break;case "select":uc.initWrapperState(a,c);M.trapBubbledEvent("topInvalid","invalid",a);Rc(e,"onChange");break;case "textarea":wc.initWrapperState(a,c),M.trapBubbledEvent("topInvalid","invalid",a),Rc(e,"onChange")}yc(b,c,Kc);d=null;for(var g in c)c.hasOwnProperty(g)&&(f=c[g],"children"===g?"string"===typeof f?a.textContent!==f&&(d=["children",f]):"number"===typeof f&&a.textContent!==""+f&&(d=["children",""+f]):Oc.hasOwnProperty(g)&&
	null!=f&&Rc(e,g));switch(b){case "input":Bc.track(a);qc.postMountWrapper(a,c);break;case "textarea":Bc.track(a);wc.postMountWrapper(a,c);break;case "select":case "option":break;default:"function"===typeof c.onClick&&(a.onclick=ca)}return d},diffHydratedText:function(a,b){return a.nodeValue!==b},warnForDeletedHydratableElement:function(){},warnForDeletedHydratableText:function(){},warnForInsertedHydratedElement:function(){},warnForInsertedHydratedText:function(){},restoreControlledState:function(a,
	b,c){switch(b){case "input":qc.restoreControlledState(a,c);break;case "textarea":wc.restoreControlledState(a,c);break;case "select":uc.restoreControlledState(a,c)}}},Tc=void 0;
	if(l.canUseDOM)if("function"!==typeof requestIdleCallback){var Uc=null,Vc=null,Wc=!1,Xc=!1,Yc=0,Zc=33,$c=33,ad={timeRemaining:"object"===typeof performance&&"function"===typeof performance.now?function(){return Yc-performance.now()}:function(){return Yc-Date.now()}},bd="__reactIdleCallback$"+Math.random().toString(36).slice(2);window.addEventListener("message",function(a){a.source===window&&a.data===bd&&(Wc=!1,a=Vc,Vc=null,null!==a&&a(ad))},!1);var cd=function(a){Xc=!1;var b=a-Yc+$c;b<$c&&Zc<$c?(8>
	b&&(b=8),$c=b<Zc?Zc:b):Zc=b;Yc=a+$c;Wc||(Wc=!0,window.postMessage(bd,"*"));b=Uc;Uc=null;null!==b&&b(a)};Tc=function(a){Vc=a;Xc||(Xc=!0,requestAnimationFrame(cd));return 0}}else Tc=requestIdleCallback;else Tc=function(a){setTimeout(function(){a({timeRemaining:function(){return Infinity}})});return 0};
	var dd={rIC:Tc},ed={enableAsyncSubtreeAPI:!0},Q={NoWork:0,SynchronousPriority:1,TaskPriority:2,HighPriority:3,LowPriority:4,OffscreenPriority:5},fd=J.Callback,gd=Q.NoWork,hd=Q.SynchronousPriority,id=Q.TaskPriority,jd=E.ClassComponent,kd=E.HostRoot,md=void 0,nd=void 0;function od(a,b){return a!==id&&a!==hd||b!==id&&b!==hd?a===gd&&b!==gd?-255:a!==gd&&b===gd?255:a-b:0}function pd(){return{first:null,last:null,hasForceUpdate:!1,callbackList:null}}
	function qd(a,b,c,d){null!==c?c.next=b:(b.next=a.first,a.first=b);null!==d?b.next=d:a.last=b}function rd(a,b){b=b.priorityLevel;var c=null;if(null!==a.last&&0>=od(a.last.priorityLevel,b))c=a.last;else for(a=a.first;null!==a&&0>=od(a.priorityLevel,b);)c=a,a=a.next;return c}
	function sd(a,b){var c=a.alternate,d=a.updateQueue;null===d&&(d=a.updateQueue=pd());null!==c?(a=c.updateQueue,null===a&&(a=c.updateQueue=pd())):a=null;md=d;nd=a!==d?a:null;var e=md;c=nd;var f=rd(e,b),g=null!==f?f.next:e.first;if(null===c)return qd(e,b,f,g),null;d=rd(c,b);a=null!==d?d.next:c.first;qd(e,b,f,g);if(g===a&&null!==g||f===d&&null!==f)return null===d&&(c.first=b),null===a&&(c.last=null),null;b={priorityLevel:b.priorityLevel,partialState:b.partialState,callback:b.callback,isReplace:b.isReplace,
	isForced:b.isForced,isTopLevelUnmount:b.isTopLevelUnmount,next:null};qd(c,b,d,a);return b}function td(a,b,c,d){a=a.partialState;return"function"===typeof a?a.call(b,c,d):a}
	var ud={addUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:!1,next:null})},addReplaceUpdate:function(a,b,c,d){sd(a,{priorityLevel:d,partialState:b,callback:c,isReplace:!0,isForced:!1,isTopLevelUnmount:!1,next:null})},addForceUpdate:function(a,b,c){sd(a,{priorityLevel:c,partialState:null,callback:b,isReplace:!1,isForced:!0,isTopLevelUnmount:!1,next:null})},getUpdatePriority:function(a){var b=a.updateQueue;return null===b||a.tag!==
	jd&&a.tag!==kd?gd:null!==b.first?b.first.priorityLevel:gd},addTopLevelUpdate:function(a,b,c,d){var e=null===b.element;b={priorityLevel:d,partialState:b,callback:c,isReplace:!1,isForced:!1,isTopLevelUnmount:e,next:null};a=sd(a,b);e&&(e=md,c=nd,null!==e&&null!==b.next&&(b.next=null,e.last=b),null!==c&&null!==a&&null!==a.next&&(a.next=null,c.last=b))},beginUpdateQueue:function(a,b,c,d,e,f,g){null!==a&&a.updateQueue===c&&(c=b.updateQueue={first:c.first,last:c.last,callbackList:null,hasForceUpdate:!1});
	a=c.callbackList;for(var h=c.hasForceUpdate,k=!0,p=c.first;null!==p&&0>=od(p.priorityLevel,g);){c.first=p.next;null===c.first&&(c.last=null);var x;if(p.isReplace)e=td(p,d,e,f),k=!0;else if(x=td(p,d,e,f))e=k?n({},e,x):n(e,x),k=!1;p.isForced&&(h=!0);null===p.callback||p.isTopLevelUnmount&&null!==p.next||(a=null!==a?a:[],a.push(p.callback),b.effectTag|=fd);p=p.next}c.callbackList=a;c.hasForceUpdate=h;null!==c.first||null!==a||h||(b.updateQueue=null);return e},commitCallbacks:function(a,b,c){a=b.callbackList;
	if(null!==a)for(b.callbackList=null,b=0;b<a.length;b++){var d=a[b];"function"!==typeof d?w("191",d):void 0;d.call(c)}}},vd=[],wd=-1,xd={createCursor:function(a){return{current:a}},isEmpty:function(){return-1===wd},pop:function(a){0>wd||(a.current=vd[wd],vd[wd]=null,wd--)},push:function(a,b){wd++;vd[wd]=a.current;a.current=b},reset:function(){for(;-1<wd;)vd[wd]=null,wd--}},yd=bb.isFiberMounted,zd=E.ClassComponent,Ad=E.HostRoot,Bd=xd.createCursor,Cd=xd.pop,Dd=xd.push,Ed=Bd(da),Fd=Bd(!1),Ld=da;
	function Md(a,b,c){a=a.stateNode;a.__reactInternalMemoizedUnmaskedChildContext=b;a.__reactInternalMemoizedMaskedChildContext=c}function Nd(a){return a.tag===zd&&null!=a.type.childContextTypes}function Od(a,b){var c=a.stateNode,d=a.type.childContextTypes;if("function"!==typeof c.getChildContext)return b;c=c.getChildContext();for(var e in c)e in d?void 0:w("108",Ra(a)||"Unknown",e);return n({},b,c)}
	var R={getUnmaskedContext:function(a){return Nd(a)?Ld:Ed.current},cacheContext:Md,getMaskedContext:function(a,b){var c=a.type.contextTypes;if(!c)return da;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&Md(a,b,e);return e},hasContextChanged:function(){return Fd.current},isContextConsumer:function(a){return a.tag===zd&&null!=a.type.contextTypes},isContextProvider:Nd,popContextProvider:function(a){Nd(a)&&
	(Cd(Fd,a),Cd(Ed,a))},popTopLevelContextObject:function(a){Cd(Fd,a);Cd(Ed,a)},pushTopLevelContextObject:function(a,b,c){null!=Ed.cursor?w("168"):void 0;Dd(Ed,b,a);Dd(Fd,c,a)},processChildContext:Od,pushContextProvider:function(a){if(!Nd(a))return!1;var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||da;Ld=Ed.current;Dd(Ed,b,a);Dd(Fd,Fd.current,a);return!0},invalidateContextProvider:function(a,b){var c=a.stateNode;c?void 0:w("169");if(b){var d=Od(a,Ld,!0);c.__reactInternalMemoizedMergedChildContext=
	d;Cd(Fd,a);Cd(Ed,a);Dd(Ed,d,a)}else Cd(Fd,a);Dd(Fd,b,a)},resetContext:function(){Ld=da;Ed.current=da;Fd.current=!1},findCurrentUnmaskedContext:function(a){for(yd(a)&&a.tag===zd?void 0:w("170");a.tag!==Ad;){if(Nd(a))return a.stateNode.__reactInternalMemoizedMergedChildContext;(a=a["return"])?void 0:w("171")}return a.stateNode.context}},Pd={NoContext:0,AsyncUpdates:1},Qd=E.IndeterminateComponent,Rd=E.ClassComponent,Sd=E.HostRoot,Td=E.HostComponent,Ud=E.HostText,Vd=E.HostPortal,Wd=E.CoroutineComponent,
	Xd=E.YieldComponent,Yd=E.Fragment,Zd=Q.NoWork,$d=Pd.NoContext,ae=J.NoEffect;function be(a,b,c){this.tag=a;this.key=b;this.stateNode=this.type=null;this.sibling=this.child=this["return"]=null;this.index=0;this.memoizedState=this.updateQueue=this.memoizedProps=this.pendingProps=this.ref=null;this.internalContextTag=c;this.effectTag=ae;this.lastEffect=this.firstEffect=this.nextEffect=null;this.pendingWorkPriority=Zd;this.alternate=null}
	function ce(a,b,c){var d=void 0;"function"===typeof a?(d=a.prototype&&a.prototype.isReactComponent?new be(Rd,b,c):new be(Qd,b,c),d.type=a):"string"===typeof a?(d=new be(Td,b,c),d.type=a):"object"===typeof a&&null!==a&&"number"===typeof a.tag?d=a:w("130",null==a?a:typeof a,"");return d}
	var de={createWorkInProgress:function(a,b){var c=a.alternate;null===c?(c=new be(a.tag,a.key,a.internalContextTag),c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.effectTag=ae,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.pendingWorkPriority=b;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c},createHostRootFiber:function(){return new be(Sd,null,$d)},
	createFiberFromElement:function(a,b,c){b=ce(a.type,a.key,b,null);b.pendingProps=a.props;b.pendingWorkPriority=c;return b},createFiberFromFragment:function(a,b,c){b=new be(Yd,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromText:function(a,b,c){b=new be(Ud,null,b);b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromElementType:ce,createFiberFromHostInstanceForDeletion:function(){var a=new be(Td,null,$d);a.type="DELETED";return a},createFiberFromCoroutine:function(a,
	b,c){b=new be(Wd,a.key,b);b.type=a.handler;b.pendingProps=a;b.pendingWorkPriority=c;return b},createFiberFromYield:function(a,b){return new be(Xd,null,b)},createFiberFromPortal:function(a,b,c){b=new be(Vd,a.key,b);b.pendingProps=a.children||[];b.pendingWorkPriority=c;b.stateNode={containerInfo:a.containerInfo,implementation:a.implementation};return b},largerPriority:function(a,b){return a!==Zd&&(b===Zd||b>a)?a:b}},ee=de.createHostRootFiber,fe=E.IndeterminateComponent,ge=E.FunctionalComponent,he=E.ClassComponent,
	ie=E.HostComponent,je,ke;"function"===typeof Symbol&&Symbol["for"]?(je=Symbol["for"]("react.coroutine"),ke=Symbol["for"]("react.yield")):(je=60104,ke=60105);
	var le={createCoroutine:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:je,key:null==d?null:""+d,children:a,handler:b,props:c}},createYield:function(a){return{$$typeof:ke,value:a}},isCoroutine:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===je},isYield:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===ke},REACT_YIELD_TYPE:ke,REACT_COROUTINE_TYPE:je},me="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.portal")||
	60106,ne={createPortal:function(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:me,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}},isPortal:function(a){return"object"===typeof a&&null!==a&&a.$$typeof===me},REACT_PORTAL_TYPE:me},oe=le.REACT_COROUTINE_TYPE,pe=le.REACT_YIELD_TYPE,qe=ne.REACT_PORTAL_TYPE,re=de.createWorkInProgress,se=de.createFiberFromElement,te=de.createFiberFromFragment,ue=de.createFiberFromText,ve=de.createFiberFromCoroutine,
	we=de.createFiberFromYield,xe=de.createFiberFromPortal,ye=Array.isArray,ze=E.FunctionalComponent,Ae=E.ClassComponent,Be=E.HostText,Ce=E.HostPortal,De=E.CoroutineComponent,Ee=E.YieldComponent,Fe=E.Fragment,Ge=J.NoEffect,He=J.Placement,Ie=J.Deletion,Je="function"===typeof Symbol&&Symbol.iterator,Ke="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;
	function Le(a){if(null===a||"undefined"===typeof a)return null;a=Je&&a[Je]||a["@@iterator"];return"function"===typeof a?a:null}
	function Me(a,b){var c=b.ref;if(null!==c&&"function"!==typeof c){if(b._owner){b=b._owner;var d=void 0;b&&("number"===typeof b.tag?(b.tag!==Ae?w("110"):void 0,d=b.stateNode):d=b.getPublicInstance());d?void 0:w("147",c);var e=""+c;if(null!==a&&null!==a.ref&&a.ref._stringRef===e)return a.ref;a=function(a){var b=d.refs===da?d.refs={}:d.refs;null===a?delete b[e]:b[e]=a};a._stringRef=e;return a}"string"!==typeof c?w("148"):void 0;b._owner?void 0:w("149",c)}return c}
	function Ne(a,b){"textarea"!==a.type&&w("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Oe(a,b){function c(c,d){if(b){if(!a){if(null===d.alternate)return;d=d.alternate}var m=c.lastEffect;null!==m?(m.nextEffect=d,c.lastEffect=d):c.firstEffect=c.lastEffect=d;d.nextEffect=null;d.effectTag=Ie}}function d(a,d){if(!b)return null;for(;null!==d;)c(a,d),d=d.sibling;return null}function e(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function f(b,c){if(a)return b=re(b,c),b.index=0,b.sibling=null,b;b.pendingWorkPriority=c;b.effectTag=Ge;
	b.index=0;b.sibling=null;return b}function g(a,c,d){a.index=d;if(!b)return c;d=a.alternate;if(null!==d)return d=d.index,d<c?(a.effectTag=He,c):d;a.effectTag=He;return c}function h(a){b&&null===a.alternate&&(a.effectTag=He);return a}function k(a,b,c,d){if(null===b||b.tag!==Be)return c=ue(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function p(a,b,c,d){if(null===b||b.type!==c.type)return d=se(c,a.internalContextTag,d),d.ref=Me(b,c),d["return"]=a,d;d=f(b,
	d);d.ref=Me(b,c);d.pendingProps=c.props;d["return"]=a;return d}function x(a,b,c,d){if(null===b||b.tag!==De)return c=ve(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function S(a,b,c,d){if(null===b||b.tag!==Ee)return b=we(c,a.internalContextTag,d),b.type=c.value,b["return"]=a,b;b=f(b,d);b.type=c.value;b["return"]=a;return b}function D(a,b,c,d){if(null===b||b.tag!==Ce||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return c=
	xe(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c.children||[];b["return"]=a;return b}function y(a,b,c,d){if(null===b||b.tag!==Fe)return c=te(c,a.internalContextTag,d),c["return"]=a,c;b=f(b,d);b.pendingProps=c;b["return"]=a;return b}function B(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ue(""+b,a.internalContextTag,c),b["return"]=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ke:return c=se(b,a.internalContextTag,c),c.ref=Me(null,b),c["return"]=
	a,c;case oe:return b=ve(b,a.internalContextTag,c),b["return"]=a,b;case pe:return c=we(b,a.internalContextTag,c),c.type=b.value,c["return"]=a,c;case qe:return b=xe(b,a.internalContextTag,c),b["return"]=a,b}if(ye(b)||Le(b))return b=te(b,a.internalContextTag,c),b["return"]=a,b;Ne(a,b)}return null}function H(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:k(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ke:return c.key===e?p(a,
	b,c,d):null;case oe:return c.key===e?x(a,b,c,d):null;case pe:return null===e?S(a,b,c,d):null;case qe:return c.key===e?D(a,b,c,d):null}if(ye(c)||Le(c))return null!==e?null:y(a,b,c,d);Ne(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||null,k(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ke:return a=a.get(null===d.key?c:d.key)||null,p(b,a,d,e);case oe:return a=a.get(null===d.key?c:d.key)||null,x(b,a,d,e);case pe:return a=a.get(c)||
	null,S(b,a,d,e);case qe:return a=a.get(null===d.key?c:d.key)||null,D(b,a,d,e)}if(ye(d)||Le(d))return a=a.get(c)||null,y(b,a,d,e);Ne(b,d)}return null}function Ca(a,f,h,k){for(var m=null,t=null,q=f,r=f=0,p=null;null!==q&&r<h.length;r++){q.index>r?(p=q,q=null):p=q.sibling;var v=H(a,q,h[r],k);if(null===v){null===q&&(q=p);break}b&&q&&null===v.alternate&&c(a,q);f=g(v,f,r);null===t?m=v:t.sibling=v;t=v;q=p}if(r===h.length)return d(a,q),m;if(null===q){for(;r<h.length;r++)if(q=B(a,h[r],k))f=g(q,f,r),null===
	t?m=q:t.sibling=q,t=q;return m}for(q=e(a,q);r<h.length;r++)if(p=C(q,a,r,h[r],k)){if(b&&null!==p.alternate)q["delete"](null===p.key?r:p.key);f=g(p,f,r);null===t?m=p:t.sibling=p;t=p}b&&q.forEach(function(b){return c(a,b)});return m}function r(a,f,h,r){var m=Le(h);"function"!==typeof m?w("150"):void 0;h=m.call(h);null==h?w("151"):void 0;for(var t=m=null,q=f,k=f=0,p=null,v=h.next();null!==q&&!v.done;k++,v=h.next()){q.index>k?(p=q,q=null):p=q.sibling;var V=H(a,q,v.value,r);if(null===V){q||(q=p);break}b&&
	q&&null===V.alternate&&c(a,q);f=g(V,f,k);null===t?m=V:t.sibling=V;t=V;q=p}if(v.done)return d(a,q),m;if(null===q){for(;!v.done;k++,v=h.next())v=B(a,v.value,r),null!==v&&(f=g(v,f,k),null===t?m=v:t.sibling=v,t=v);return m}for(q=e(a,q);!v.done;k++,v=h.next())if(v=C(q,a,k,v.value,r),null!==v){if(b&&null!==v.alternate)q["delete"](null===v.key?k:v.key);f=g(v,f,k);null===t?m=v:t.sibling=v;t=v}b&&q.forEach(function(b){return c(a,b)});return m}return function(a,b,e,g){var m="object"===typeof e&&null!==e;if(m)switch(e.$$typeof){case Ke:a:{var C=
	e.key;for(m=b;null!==m;){if(m.key===C)if(m.type===e.type){d(a,m.sibling);b=f(m,g);b.ref=Me(m,e);b.pendingProps=e.props;b["return"]=a;a=b;break a}else{d(a,m);break}else c(a,m);m=m.sibling}g=se(e,a.internalContextTag,g);g.ref=Me(b,e);g["return"]=a;a=g}return h(a);case oe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===De){d(a,b.sibling);b=f(b,g);b.pendingProps=e;b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=ve(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a);case pe:a:{if(null!==
	b)if(b.tag===Ee){d(a,b.sibling);b=f(b,g);b.type=e.value;b["return"]=a;a=b;break a}else d(a,b);b=we(e,a.internalContextTag,g);b.type=e.value;b["return"]=a;a=b}return h(a);case qe:a:{for(m=e.key;null!==b;){if(b.key===m)if(b.tag===Ce&&b.stateNode.containerInfo===e.containerInfo&&b.stateNode.implementation===e.implementation){d(a,b.sibling);b=f(b,g);b.pendingProps=e.children||[];b["return"]=a;a=b;break a}else{d(a,b);break}else c(a,b);b=b.sibling}e=xe(e,a.internalContextTag,g);e["return"]=a;a=e}return h(a)}if("string"===
	typeof e||"number"===typeof e)return e=""+e,null!==b&&b.tag===Be?(d(a,b.sibling),b=f(b,g),b.pendingProps=e,b["return"]=a,a=b):(d(a,b),e=ue(e,a.internalContextTag,g),e["return"]=a,a=e),h(a);if(ye(e))return Ca(a,b,e,g);if(Le(e))return r(a,b,e,g);m&&Ne(a,e);if("undefined"===typeof e)switch(a.tag){case Ae:case ze:e=a.type,w("152",e.displayName||e.name||"Component")}return d(a,b)}}
	var Pe=Oe(!0,!0),Qe=Oe(!1,!0),Re=Oe(!1,!1),Se={reconcileChildFibers:Pe,reconcileChildFibersInPlace:Qe,mountChildFibersInPlace:Re,cloneChildFibers:function(a,b){null!==a&&b.child!==a.child?w("153"):void 0;if(null!==b.child){a=b.child;var c=re(a,a.pendingWorkPriority);c.pendingProps=a.pendingProps;b.child=c;for(c["return"]=b;null!==a.sibling;)a=a.sibling,c=c.sibling=re(a,a.pendingWorkPriority),c.pendingProps=a.pendingProps,c["return"]=b;c.sibling=null}}},Te=J.Update,Ue=Pd.AsyncUpdates,Ve=R.cacheContext,
	We=R.getMaskedContext,Xe=R.getUnmaskedContext,Ye=R.isContextConsumer,Ze=ud.addUpdate,$e=ud.addReplaceUpdate,af=ud.addForceUpdate,bf=ud.beginUpdateQueue,cf=R.hasContextChanged,df=bb.isMounted;
	function ef(a,b,c,d){function e(a,b){b.updater=f;a.stateNode=b;Pa.set(b,a)}var f={isMounted:df,enqueueSetState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);Ze(c,d,void 0===e?null:e,f);a(c,f)},enqueueReplaceState:function(c,d,e){c=Pa.get(c);var f=b(c,!1);$e(c,d,void 0===e?null:e,f);a(c,f)},enqueueForceUpdate:function(c,d){c=Pa.get(c);var e=b(c,!1);af(c,void 0===d?null:d,e);a(c,e)}};return{adoptClassInstance:e,constructClassInstance:function(a,b){var c=a.type,d=Xe(a),f=Ye(a),g=f?We(a,d):da;b=new c(b,g);
	e(a,b);f&&Ve(a,d,g);return b},mountClassInstance:function(a,b){var c=a.alternate,d=a.stateNode,e=d.state||null,g=a.pendingProps;g?void 0:w("158");var h=Xe(a);d.props=g;d.state=e;d.refs=da;d.context=We(a,h);ed.enableAsyncSubtreeAPI&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent&&(a.internalContextTag|=Ue);"function"===typeof d.componentWillMount&&(h=d.state,d.componentWillMount(),h!==d.state&&f.enqueueReplaceState(d,d.state,null),h=a.updateQueue,null!==
	h&&(d.state=bf(c,a,h,d,e,g,b)));"function"===typeof d.componentDidMount&&(a.effectTag|=Te)},updateClassInstance:function(a,b,e){var g=b.stateNode;g.props=b.memoizedProps;g.state=b.memoizedState;var h=b.memoizedProps,k=b.pendingProps;k||(k=h,null==k?w("159"):void 0);var D=g.context,y=Xe(b);y=We(b,y);"function"!==typeof g.componentWillReceiveProps||h===k&&D===y||(D=g.state,g.componentWillReceiveProps(k,y),g.state!==D&&f.enqueueReplaceState(g,g.state,null));D=b.memoizedState;e=null!==b.updateQueue?bf(a,
	b,b.updateQueue,g,D,k,e):D;if(!(h!==k||D!==e||cf()||null!==b.updateQueue&&b.updateQueue.hasForceUpdate))return"function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),!1;var B=k;if(null===h||null!==b.updateQueue&&b.updateQueue.hasForceUpdate)B=!0;else{var H=b.stateNode,C=b.type;B="function"===typeof H.shouldComponentUpdate?H.shouldComponentUpdate(B,e,y):C.prototype&&C.prototype.isPureReactComponent?!ea(h,B)||!ea(D,e):!0}B?("function"===typeof g.componentWillUpdate&&
	g.componentWillUpdate(k,e,y),"function"===typeof g.componentDidUpdate&&(b.effectTag|=Te)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&D===a.memoizedState||(b.effectTag|=Te),c(b,k),d(b,e));g.props=k;g.state=e;g.context=y;return B}}}
	var ff=Se.mountChildFibersInPlace,gf=Se.reconcileChildFibers,hf=Se.reconcileChildFibersInPlace,jf=Se.cloneChildFibers,kf=ud.beginUpdateQueue,lf=R.getMaskedContext,mf=R.getUnmaskedContext,nf=R.hasContextChanged,of=R.pushContextProvider,pf=R.pushTopLevelContextObject,qf=R.invalidateContextProvider,rf=E.IndeterminateComponent,sf=E.FunctionalComponent,tf=E.ClassComponent,uf=E.HostRoot,wf=E.HostComponent,xf=E.HostText,yf=E.HostPortal,zf=E.CoroutineComponent,Af=E.CoroutineHandlerPhase,Bf=E.YieldComponent,
	Cf=E.Fragment,Df=Q.NoWork,Ef=Q.OffscreenPriority,Ff=J.PerformedWork,Gf=J.Placement,Hf=J.ContentReset,If=J.Err,Jf=J.Ref,Kf=Qa.ReactCurrentOwner;
	function Lf(a,b,c,d,e){function f(a,b,c){g(a,b,c,b.pendingWorkPriority)}function g(a,b,c,d){b.child=null===a?ff(b,b.child,c,d):a.child===b.child?gf(b,b.child,c,d):hf(b,b.child,c,d)}function h(a,b){var c=b.ref;null===c||a&&a.ref===c||(b.effectTag|=Jf)}function k(a,b,c,d){h(a,b);if(!c)return d&&qf(b,!1),x(a,b);c=b.stateNode;Kf.current=b;var e=c.render();b.effectTag|=Ff;f(a,b,e);b.memoizedState=c.state;b.memoizedProps=c.props;d&&qf(b,!0);return b.child}function p(a){var b=a.stateNode;b.pendingContext?
	pf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&pf(a,b.context,!1);C(a,b.containerInfo)}function x(a,b){jf(a,b);return b.child}function S(a,b){switch(b.tag){case uf:p(b);break;case tf:of(b);break;case yf:C(b,b.stateNode.containerInfo)}return null}var D=a.shouldSetTextContent,y=a.useSyncScheduling,B=a.shouldDeprioritizeSubtree,H=b.pushHostContext,C=b.pushHostContainer,Ca=c.enterHydrationState,r=c.resetHydrationState,m=c.tryToClaimNextHydratableInstance;a=ef(d,e,function(a,b){a.memoizedProps=
	b},function(a,b){a.memoizedState=b});var t=a.adoptClassInstance,v=a.constructClassInstance,V=a.mountClassInstance,ld=a.updateClassInstance;return{beginWork:function(a,b,c){if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);switch(b.tag){case rf:null!==a?w("155"):void 0;var d=b.type,e=b.pendingProps,g=mf(b);g=lf(b,g);d=d(e,g);b.effectTag|=Ff;"object"===typeof d&&null!==d&&"function"===typeof d.render?(b.tag=tf,e=of(b),t(b,d),V(b,c),b=k(a,b,!0,e)):(b.tag=sf,f(a,b,d),b.memoizedProps=
	e,b=b.child);return b;case sf:a:{e=b.type;c=b.pendingProps;d=b.memoizedProps;if(nf())null===c&&(c=d);else if(null===c||d===c){b=x(a,b);break a}d=mf(b);d=lf(b,d);e=e(c,d);b.effectTag|=Ff;f(a,b,e);b.memoizedProps=c;b=b.child}return b;case tf:return e=of(b),d=void 0,null===a?b.stateNode?w("153"):(v(b,b.pendingProps),V(b,c),d=!0):d=ld(a,b,c),k(a,b,d,e);case uf:return p(b),d=b.updateQueue,null!==d?(e=b.memoizedState,d=kf(a,b,d,null,e,null,c),e===d?(r(),b=x(a,b)):(e=d.element,null!==a&&null!==a.child||
	!Ca(b)?(r(),f(a,b,e)):(b.effectTag|=Gf,b.child=ff(b,b.child,e,c)),b.memoizedState=d,b=b.child)):(r(),b=x(a,b)),b;case wf:H(b);null===a&&m(b);e=b.type;var q=b.memoizedProps;d=b.pendingProps;null===d&&(d=q,null===d?w("154"):void 0);g=null!==a?a.memoizedProps:null;nf()||null!==d&&q!==d?(q=d.children,D(e,d)?q=null:g&&D(e,g)&&(b.effectTag|=Hf),h(a,b),c!==Ef&&!y&&B(e,d)?(b.pendingWorkPriority=Ef,b=null):(f(a,b,q),b.memoizedProps=d,b=b.child)):b=x(a,b);return b;case xf:return null===a&&m(b),a=b.pendingProps,
	null===a&&(a=b.memoizedProps),b.memoizedProps=a,null;case Af:b.tag=zf;case zf:c=b.pendingProps;if(nf())null===c&&(c=a&&a.memoizedProps,null===c?w("154"):void 0);else if(null===c||b.memoizedProps===c)c=b.memoizedProps;e=c.children;d=b.pendingWorkPriority;b.stateNode=null===a?ff(b,b.stateNode,e,d):a.child===b.child?gf(b,b.stateNode,e,d):hf(b,b.stateNode,e,d);b.memoizedProps=c;return b.stateNode;case Bf:return null;case yf:a:{C(b,b.stateNode.containerInfo);c=b.pendingWorkPriority;e=b.pendingProps;if(nf())null===
	e&&(e=a&&a.memoizedProps,null==e?w("154"):void 0);else if(null===e||b.memoizedProps===e){b=x(a,b);break a}null===a?b.child=hf(b,b.child,e,c):f(a,b,e);b.memoizedProps=e;b=b.child}return b;case Cf:a:{c=b.pendingProps;if(nf())null===c&&(c=b.memoizedProps);else if(null===c||b.memoizedProps===c){b=x(a,b);break a}f(a,b,c);b.memoizedProps=c;b=b.child}return b;default:w("156")}},beginFailedWork:function(a,b,c){switch(b.tag){case tf:of(b);break;case uf:p(b);break;default:w("157")}b.effectTag|=If;null===a?
	b.child=null:b.child!==a.child&&(b.child=a.child);if(b.pendingWorkPriority===Df||b.pendingWorkPriority>c)return S(a,b);b.firstEffect=null;b.lastEffect=null;g(a,b,null,c);b.tag===tf&&(a=b.stateNode,b.memoizedProps=a.props,b.memoizedState=a.state);return b.child}}}
	var Mf=Se.reconcileChildFibers,Nf=R.popContextProvider,Of=R.popTopLevelContextObject,Pf=E.IndeterminateComponent,Qf=E.FunctionalComponent,Rf=E.ClassComponent,Sf=E.HostRoot,Tf=E.HostComponent,Uf=E.HostText,Vf=E.HostPortal,Wf=E.CoroutineComponent,Xf=E.CoroutineHandlerPhase,Yf=E.YieldComponent,Zf=E.Fragment,ag=J.Placement,bg=J.Ref,cg=J.Update,dg=Q.OffscreenPriority;
	function eg(a,b,c){var d=a.createInstance,e=a.createTextInstance,f=a.appendInitialChild,g=a.finalizeInitialChildren,h=a.prepareUpdate,k=b.getRootHostContainer,p=b.popHostContext,x=b.getHostContext,S=b.popHostContainer,D=c.prepareToHydrateHostInstance,y=c.prepareToHydrateHostTextInstance,B=c.popHydrationState;return{completeWork:function(a,b,c){var r=b.pendingProps;if(null===r)r=b.memoizedProps;else if(b.pendingWorkPriority!==dg||c===dg)b.pendingProps=null;switch(b.tag){case Qf:return null;case Rf:return Nf(b),
	null;case Sf:S(b);Of(b);r=b.stateNode;r.pendingContext&&(r.context=r.pendingContext,r.pendingContext=null);if(null===a||null===a.child)B(b),b.effectTag&=~ag;return null;case Tf:p(b);c=k();var m=b.type;if(null!==a&&null!=b.stateNode){var t=a.memoizedProps,C=b.stateNode,V=x();r=h(C,m,t,r,c,V);if(b.updateQueue=r)b.effectTag|=cg;a.ref!==b.ref&&(b.effectTag|=bg)}else{if(!r)return null===b.stateNode?w("166"):void 0,null;a=x();if(B(b))D(b,c,a)&&(b.effectTag|=cg);else{a=d(m,r,c,a,b);a:for(t=b.child;null!==
	t;){if(t.tag===Tf||t.tag===Uf)f(a,t.stateNode);else if(t.tag!==Vf&&null!==t.child){t=t.child;continue}if(t===b)break a;for(;null===t.sibling;){if(null===t["return"]||t["return"]===b)break a;t=t["return"]}t=t.sibling}g(a,m,r,c)&&(b.effectTag|=cg);b.stateNode=a}null!==b.ref&&(b.effectTag|=bg)}return null;case Uf:if(a&&null!=b.stateNode)a.memoizedProps!==r&&(b.effectTag|=cg);else{if("string"!==typeof r)return null===b.stateNode?w("166"):void 0,null;a=k();c=x();B(b)?y(b)&&(b.effectTag|=cg):b.stateNode=
	e(r,a,c,b)}return null;case Wf:(r=b.memoizedProps)?void 0:w("165");b.tag=Xf;c=[];a:for((m=b.stateNode)&&(m["return"]=b);null!==m;){if(m.tag===Tf||m.tag===Uf||m.tag===Vf)w("164");else if(m.tag===Yf)c.push(m.type);else if(null!==m.child){m.child["return"]=m;m=m.child;continue}for(;null===m.sibling;){if(null===m["return"]||m["return"]===b)break a;m=m["return"]}m.sibling["return"]=m["return"];m=m.sibling}m=r.handler;r=m(r.props,c);b.child=Mf(b,null!==a?a.child:null,r,b.pendingWorkPriority);return b.child;
	case Xf:return b.tag=Wf,null;case Yf:return null;case Zf:return null;case Vf:return b.effectTag|=cg,S(b),null;case Pf:w("167");default:w("156")}}}}var fg=null,gg=null;function hg(a){return function(b){try{return a(b)}catch(c){}}}
	var ig={injectInternals:function(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!b.supportsFiber)return!0;try{var c=b.inject(a);fg=hg(function(a){return b.onCommitFiberRoot(c,a)});gg=hg(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0},onCommitRoot:function(a){"function"===typeof fg&&fg(a)},onCommitUnmount:function(a){"function"===typeof gg&&gg(a)}},jg=E.ClassComponent,kg=E.HostRoot,lg=E.HostComponent,mg=E.HostText,ng=
	E.HostPortal,og=E.CoroutineComponent,pg=ud.commitCallbacks,qg=ig.onCommitUnmount,rg=J.Placement,sg=J.Update,tg=J.Callback,ug=J.ContentReset;
	function vg(a,b){function c(a){var c=a.ref;if(null!==c)try{c(null)}catch(t){b(a,t)}}function d(a){return a.tag===lg||a.tag===kg||a.tag===ng}function e(a){for(var b=a;;)if(g(b),null!==b.child&&b.tag!==ng)b.child["return"]=b,b=b.child;else{if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"]}b.sibling["return"]=b["return"];b=b.sibling}}function f(a){for(var b=a,c=!1,d=void 0,f=void 0;;){if(!c){c=b["return"];a:for(;;){null===c?w("160"):void 0;switch(c.tag){case lg:d=
	c.stateNode;f=!1;break a;case kg:d=c.stateNode.containerInfo;f=!0;break a;case ng:d=c.stateNode.containerInfo;f=!0;break a}c=c["return"]}c=!0}if(b.tag===lg||b.tag===mg)e(b),f?C(d,b.stateNode):H(d,b.stateNode);else if(b.tag===ng?d=b.stateNode.containerInfo:g(b),null!==b.child){b.child["return"]=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b["return"]||b["return"]===a)return;b=b["return"];b.tag===ng&&(c=!1)}b.sibling["return"]=b["return"];b=b.sibling}}function g(a){"function"===
	typeof qg&&qg(a);switch(a.tag){case jg:c(a);var d=a.stateNode;if("function"===typeof d.componentWillUnmount)try{d.props=a.memoizedProps,d.state=a.memoizedState,d.componentWillUnmount()}catch(t){b(a,t)}break;case lg:c(a);break;case og:e(a.stateNode);break;case ng:f(a)}}var h=a.commitMount,k=a.commitUpdate,p=a.resetTextContent,x=a.commitTextUpdate,S=a.appendChild,D=a.appendChildToContainer,y=a.insertBefore,B=a.insertInContainerBefore,H=a.removeChild,C=a.removeChildFromContainer,Ca=a.getPublicInstance;
	return{commitPlacement:function(a){a:{for(var b=a["return"];null!==b;){if(d(b)){var c=b;break a}b=b["return"]}w("160");c=void 0}var e=b=void 0;switch(c.tag){case lg:b=c.stateNode;e=!1;break;case kg:b=c.stateNode.containerInfo;e=!0;break;case ng:b=c.stateNode.containerInfo;e=!0;break;default:w("161")}c.effectTag&ug&&(p(b),c.effectTag&=~ug);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c["return"]||d(c["return"])){c=null;break a}c=c["return"]}c.sibling["return"]=c["return"];for(c=c.sibling;c.tag!==
	lg&&c.tag!==mg;){if(c.effectTag&rg)continue b;if(null===c.child||c.tag===ng)continue b;else c.child["return"]=c,c=c.child}if(!(c.effectTag&rg)){c=c.stateNode;break a}}for(var f=a;;){if(f.tag===lg||f.tag===mg)c?e?B(b,f.stateNode,c):y(b,f.stateNode,c):e?D(b,f.stateNode):S(b,f.stateNode);else if(f.tag!==ng&&null!==f.child){f.child["return"]=f;f=f.child;continue}if(f===a)break;for(;null===f.sibling;){if(null===f["return"]||f["return"]===a)return;f=f["return"]}f.sibling["return"]=f["return"];f=f.sibling}},
	commitDeletion:function(a){f(a);a["return"]=null;a.child=null;a.alternate&&(a.alternate.child=null,a.alternate["return"]=null)},commitWork:function(a,b){switch(b.tag){case jg:break;case lg:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&k(c,f,e,a,d,b)}break;case mg:null===b.stateNode?w("162"):void 0;c=b.memoizedProps;x(b.stateNode,null!==a?a.memoizedProps:c,c);break;case kg:break;case ng:break;default:w("163")}},
	commitLifeCycles:function(a,b){switch(b.tag){case jg:var c=b.stateNode;if(b.effectTag&sg)if(null===a)c.props=b.memoizedProps,c.state=b.memoizedState,c.componentDidMount();else{var d=a.memoizedProps;a=a.memoizedState;c.props=b.memoizedProps;c.state=b.memoizedState;c.componentDidUpdate(d,a)}b.effectTag&tg&&null!==b.updateQueue&&pg(b,b.updateQueue,c);break;case kg:a=b.updateQueue;null!==a&&pg(b,a,b.child&&b.child.stateNode);break;case lg:c=b.stateNode;null===a&&b.effectTag&sg&&h(c,b.type,b.memoizedProps,
	b);break;case mg:break;case ng:break;default:w("163")}},commitAttachRef:function(a){var b=a.ref;if(null!==b){var c=a.stateNode;switch(a.tag){case lg:b(Ca(c));break;default:b(c)}}},commitDetachRef:function(a){a=a.ref;null!==a&&a(null)}}}var wg=xd.createCursor,xg=xd.pop,yg=xd.push,zg={};
	function Ag(a){function b(a){a===zg?w("174"):void 0;return a}var c=a.getChildHostContext,d=a.getRootHostContext,e=wg(zg),f=wg(zg),g=wg(zg);return{getHostContext:function(){return b(e.current)},getRootHostContainer:function(){return b(g.current)},popHostContainer:function(a){xg(e,a);xg(f,a);xg(g,a)},popHostContext:function(a){f.current===a&&(xg(e,a),xg(f,a))},pushHostContainer:function(a,b){yg(g,b,a);b=d(b);yg(f,a,a);yg(e,b,a)},pushHostContext:function(a){var d=b(g.current),h=b(e.current);d=c(h,a.type,
	d);h!==d&&(yg(f,a,a),yg(e,d,a))},resetHostContainer:function(){e.current=zg;g.current=zg}}}var Bg=E.HostComponent,Cg=E.HostText,Dg=E.HostRoot,Eg=J.Deletion,Fg=J.Placement,Gg=de.createFiberFromHostInstanceForDeletion;
	function Hg(a){function b(a,b){var c=Gg();c.stateNode=b;c["return"]=a;c.effectTag=Eg;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function c(a,b){switch(a.tag){case Bg:return f(b,a.type,a.pendingProps);case Cg:return g(b,a.pendingProps);default:return!1}}function d(a){for(a=a["return"];null!==a&&a.tag!==Bg&&a.tag!==Dg;)a=a["return"];y=a}var e=a.shouldSetTextContent,f=a.canHydrateInstance,g=a.canHydrateTextInstance,h=a.getNextHydratableSibling,k=a.getFirstHydratableChild,
	p=a.hydrateInstance,x=a.hydrateTextInstance,S=a.didNotHydrateInstance,D=a.didNotFindHydratableInstance;a=a.didNotFindHydratableTextInstance;if(!(f&&g&&h&&k&&p&&x&&S&&D&&a))return{enterHydrationState:function(){return!1},resetHydrationState:function(){},tryToClaimNextHydratableInstance:function(){},prepareToHydrateHostInstance:function(){w("175")},prepareToHydrateHostTextInstance:function(){w("176")},popHydrationState:function(){return!1}};var y=null,B=null,H=!1;return{enterHydrationState:function(a){B=
	k(a.stateNode.containerInfo);y=a;return H=!0},resetHydrationState:function(){B=y=null;H=!1},tryToClaimNextHydratableInstance:function(a){if(H){var d=B;if(d){if(!c(a,d)){d=h(d);if(!d||!c(a,d)){a.effectTag|=Fg;H=!1;y=a;return}b(y,B)}a.stateNode=d;y=a;B=k(d)}else a.effectTag|=Fg,H=!1,y=a}},prepareToHydrateHostInstance:function(a,b,c){b=p(a.stateNode,a.type,a.memoizedProps,b,c,a);a.updateQueue=b;return null!==b?!0:!1},prepareToHydrateHostTextInstance:function(a){return x(a.stateNode,a.memoizedProps,a)},
	popHydrationState:function(a){if(a!==y)return!1;if(!H)return d(a),H=!0,!1;var c=a.type;if(a.tag!==Bg||"head"!==c&&"body"!==c&&!e(c,a.memoizedProps))for(c=B;c;)b(a,c),c=h(c);d(a);B=y?h(a.stateNode):null;return!0}}}
	var Ig=R.popContextProvider,Jg=xd.reset,Kg=Qa.ReactCurrentOwner,Lg=de.createWorkInProgress,Mg=de.largerPriority,Ng=ig.onCommitRoot,T=Q.NoWork,Og=Q.SynchronousPriority,U=Q.TaskPriority,Pg=Q.HighPriority,Qg=Q.LowPriority,Rg=Q.OffscreenPriority,Sg=Pd.AsyncUpdates,Tg=J.PerformedWork,Ug=J.Placement,Vg=J.Update,Wg=J.PlacementAndUpdate,Xg=J.Deletion,Yg=J.ContentReset,Zg=J.Callback,$g=J.Err,ah=J.Ref,bh=E.HostRoot,ch=E.HostComponent,dh=E.HostPortal,eh=E.ClassComponent,fh=ud.getUpdatePriority,gh=R.resetContext;
	function hh(a){function b(){for(;null!==ma&&ma.current.pendingWorkPriority===T;){ma.isScheduled=!1;var a=ma.nextScheduledRoot;ma.nextScheduledRoot=null;if(ma===zb)return zb=ma=null,z=T,null;ma=a}a=ma;for(var b=null,c=T;null!==a;)a.current.pendingWorkPriority!==T&&(c===T||c>a.current.pendingWorkPriority)&&(c=a.current.pendingWorkPriority,b=a),a=a.nextScheduledRoot;null!==b?(z=c,Jg(),gh(),t(),I=Lg(b.current,c),b!==nc&&(oc=0,nc=b)):(z=T,nc=I=null)}function c(c){Hd=!0;na=null;var d=c.stateNode;d.current===
	c?w("177"):void 0;z!==Og&&z!==U||oc++;Kg.current=null;if(c.effectTag>Tg)if(null!==c.lastEffect){c.lastEffect.nextEffect=c;var e=c.firstEffect}else e=c;else e=c.firstEffect;Ui();for(u=e;null!==u;){var f=!1,g=void 0;try{for(;null!==u;){var h=u.effectTag;h&Yg&&a.resetTextContent(u.stateNode);if(h&ah){var k=u.alternate;null!==k&&Ph(k)}switch(h&~(Zg|$g|Yg|ah|Tg)){case Ug:q(u);u.effectTag&=~Ug;break;case Wg:q(u);u.effectTag&=~Ug;vf(u.alternate,u);break;case Vg:vf(u.alternate,u);break;case Xg:Id=!0,Mh(u),
	Id=!1}u=u.nextEffect}}catch(Jd){f=!0,g=Jd}f&&(null===u?w("178"):void 0,x(u,g),null!==u&&(u=u.nextEffect))}Vi();d.current=c;for(u=e;null!==u;){d=!1;e=void 0;try{for(;null!==u;){var Gd=u.effectTag;Gd&(Vg|Zg)&&Nh(u.alternate,u);Gd&ah&&Oh(u);if(Gd&$g)switch(f=u,g=void 0,null!==P&&(g=P.get(f),P["delete"](f),null==g&&null!==f.alternate&&(f=f.alternate,g=P.get(f),P["delete"](f))),null==g?w("184"):void 0,f.tag){case eh:f.stateNode.componentDidCatch(g.error,{componentStack:g.componentStack});break;case bh:null===
	Ja&&(Ja=g.error);break;default:w("157")}var m=u.nextEffect;u.nextEffect=null;u=m}}catch(Jd){d=!0,e=Jd}d&&(null===u?w("178"):void 0,x(u,e),null!==u&&(u=u.nextEffect))}Hd=!1;"function"===typeof Ng&&Ng(c.stateNode);va&&(va.forEach(H),va=null);b()}function d(a){for(;;){var b=Lh(a.alternate,a,z),c=a["return"],d=a.sibling;var e=a;if(!(e.pendingWorkPriority!==T&&e.pendingWorkPriority>z)){for(var f=fh(e),g=e.child;null!==g;)f=Mg(f,g.pendingWorkPriority),g=g.sibling;e.pendingWorkPriority=f}if(null!==b)return b;
	null!==c&&(null===c.firstEffect&&(c.firstEffect=a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),a.effectTag>Tg&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a));if(null!==d)return d;if(null!==c)a=c;else{na=a;break}}return null}function e(a){var b=V(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}function f(a){var b=ld(a.alternate,a,z);null===b&&(b=d(a));Kg.current=null;return b}
	function g(a){p(Rg,a)}function h(){if(null!==P&&0<P.size&&z===U)for(;null!==I;){var a=I;I=null!==P&&(P.has(a)||null!==a.alternate&&P.has(a.alternate))?f(I):e(I);if(null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,null===P||0===P.size||z!==U))break}}function k(a,d){null!==na?(O=U,c(na),h()):null===I&&b();if(!(z===T||z>a)){O=z;a:do{if(z<=U)for(;null!==I&&!(I=e(I),null===I&&(null===na?w("179"):void 0,O=U,c(na),O=z,h(),z===T||z>a||z>U)););else if(null!==d)for(;null!==I&&!Ab;)if(1<d.timeRemaining()){if(I=
	e(I),null===I)if(null===na?w("179"):void 0,1<d.timeRemaining()){if(O=U,c(na),O=z,h(),z===T||z>a||z<Pg)break}else Ab=!0}else Ab=!0;switch(z){case Og:case U:if(z<=a)continue a;break a;case Pg:case Qg:case Rg:if(null===d)break a;if(!Ab&&z<=a)continue a;break a;case T:break a;default:w("181")}}while(1)}}function p(a,b){Da?w("182"):void 0;Da=!0;var c=O,d=!1,e=null;try{k(a,b)}catch(Kd){d=!0,e=Kd}for(;d;){if(Ya){Ja=e;break}var h=I;if(null===h)Ya=!0;else{var p=x(h,e);null===p?w("183"):void 0;if(!Ya){try{d=
	p;e=a;p=b;for(var q=d;null!==h;){switch(h.tag){case eh:Ig(h);break;case ch:m(h);break;case bh:r(h);break;case dh:r(h)}if(h===q||h.alternate===q)break;h=h["return"]}I=f(d);k(e,p)}catch(Kd){d=!0;e=Kd;continue}break}}}O=c;null!==b&&(Bb=!1);z>U&&!Bb&&($f(g),Bb=!0);a=Ja;Ya=Ab=Da=!1;nc=Ka=P=Ja=null;oc=0;if(null!==a)throw a;}function x(a,b){var c=Kg.current=null,d=!1,e=!1,f=null;if(a.tag===bh)c=a,S(a)&&(Ya=!0);else for(var g=a["return"];null!==g&&null===c;){g.tag===eh?"function"===typeof g.stateNode.componentDidCatch&&
	(d=!0,f=Ra(g),c=g,e=!0):g.tag===bh&&(c=g);if(S(g)){if(Id||null!==va&&(va.has(g)||null!==g.alternate&&va.has(g.alternate)))return null;c=null;e=!1}g=g["return"]}if(null!==c){null===Ka&&(Ka=new Set);Ka.add(c);var h="";g=a;do{a:switch(g.tag){case fe:case ge:case he:case ie:var k=g._debugOwner,m=g._debugSource;var p=Ra(g);var q=null;k&&(q=Ra(k));k=m;p="\n    in "+(p||"Unknown")+(k?" (at "+k.fileName.replace(/^.*[\\\/]/,"")+":"+k.lineNumber+")":q?" (created by "+q+")":"");break a;default:p=""}h+=p;g=g["return"]}while(g);
	g=h;a=Ra(a);null===P&&(P=new Map);b={componentName:a,componentStack:g,error:b,errorBoundary:d?c.stateNode:null,errorBoundaryFound:d,errorBoundaryName:f,willRetry:e};P.set(c,b);try{console.error(b.error)}catch(Wi){console.error(Wi)}Hd?(null===va&&(va=new Set),va.add(c)):H(c);return c}null===Ja&&(Ja=b);return null}function S(a){return null!==Ka&&(Ka.has(a)||null!==a.alternate&&Ka.has(a.alternate))}function D(a,b){return y(a,b,!1)}function y(a,b){oc>Xi&&(Ya=!0,w("185"));!Da&&b<=z&&(I=null);for(var c=
	!0;null!==a&&c;){c=!1;if(a.pendingWorkPriority===T||a.pendingWorkPriority>b)c=!0,a.pendingWorkPriority=b;null!==a.alternate&&(a.alternate.pendingWorkPriority===T||a.alternate.pendingWorkPriority>b)&&(c=!0,a.alternate.pendingWorkPriority=b);if(null===a["return"])if(a.tag===bh){var d=a.stateNode;b===T||d.isScheduled||(d.isScheduled=!0,zb?zb.nextScheduledRoot=d:ma=d,zb=d);if(!Da)switch(b){case Og:pc?p(Og,null):p(U,null);break;case U:W?void 0:w("186");break;default:Bb||($f(g),Bb=!0)}}else break;a=a["return"]}}
	function B(a,b){var c=O;c===T&&(c=!Yi||a.internalContextTag&Sg||b?Qg:Og);return c===Og&&(Da||W)?U:c}function H(a){y(a,U,!0)}var C=Ag(a),Ca=Hg(a),r=C.popHostContainer,m=C.popHostContext,t=C.resetHostContainer,v=Lf(a,C,Ca,D,B),V=v.beginWork,ld=v.beginFailedWork,Lh=eg(a,C,Ca).completeWork;C=vg(a,x);var q=C.commitPlacement,Mh=C.commitDeletion,vf=C.commitWork,Nh=C.commitLifeCycles,Oh=C.commitAttachRef,Ph=C.commitDetachRef,$f=a.scheduleDeferredCallback,Yi=a.useSyncScheduling,Ui=a.prepareForCommit,Vi=a.resetAfterCommit,
	O=T,Da=!1,Ab=!1,W=!1,pc=!1,I=null,z=T,u=null,na=null,ma=null,zb=null,Bb=!1,P=null,Ka=null,va=null,Ja=null,Ya=!1,Hd=!1,Id=!1,Xi=1E3,oc=0,nc=null;return{scheduleUpdate:D,getPriorityContext:B,batchedUpdates:function(a,b){var c=W;W=!0;try{return a(b)}finally{W=c,Da||W||p(U,null)}},unbatchedUpdates:function(a){var b=pc,c=W;pc=W;W=!1;try{return a()}finally{W=c,pc=b}},flushSync:function(a){var b=W,c=O;W=!0;O=Og;try{return a()}finally{W=b,O=c,Da?w("187"):void 0,p(U,null)}},deferredUpdates:function(a){var b=
	O;O=Qg;try{return a()}finally{O=b}}}}function ih(){w("196")}function jh(a){if(!a)return da;a=Pa.get(a);return"number"===typeof a.tag?ih(a):a._processChildContext(a._context)}jh._injectFiber=function(a){ih=a};var kh=ud.addTopLevelUpdate,lh=R.findCurrentUnmaskedContext,mh=R.isContextProvider,nh=R.processChildContext,oh=E.HostComponent,ph=bb.findCurrentHostFiber,qh=bb.findCurrentHostFiberWithNoPortals;jh._injectFiber(function(a){var b=lh(a);return mh(a)?nh(a,b,!1):b});var rh=F.TEXT_NODE;
	function sh(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function th(a,b){var c=sh(a);a=0;for(var d;c;){if(c.nodeType===rh){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=sh(c)}}var uh=null;function vh(){!uh&&l.canUseDOM&&(uh="textContent"in document.documentElement?"textContent":"innerText");return uh}
	var wh={getOffsets:function(a){var b=window.getSelection&&window.getSelection();if(!b||0===b.rangeCount)return null;var c=b.anchorNode,d=b.anchorOffset,e=b.focusNode,f=b.focusOffset,g=b.getRangeAt(0);try{g.startContainer.nodeType,g.endContainer.nodeType}catch(k){return null}b=b.anchorNode===b.focusNode&&b.anchorOffset===b.focusOffset?0:g.toString().length;var h=g.cloneRange();h.selectNodeContents(a);h.setEnd(g.startContainer,g.startOffset);a=h.startContainer===h.endContainer&&h.startOffset===h.endOffset?
	0:h.toString().length;g=a+b;b=document.createRange();b.setStart(c,d);b.setEnd(e,f);c=b.collapsed;return{start:c?g:a,end:c?a:g}},setOffsets:function(a,b){if(window.getSelection){var c=window.getSelection(),d=a[vh()].length,e=Math.min(b.start,d);b=void 0===b.end?e:Math.min(b.end,d);!c.extend&&e>b&&(d=b,b=e,e=d);d=th(a,e);a=th(a,b);if(d&&a){var f=document.createRange();f.setStart(d.node,d.offset);c.removeAllRanges();e>b?(c.addRange(f),c.extend(a.node,a.offset)):(f.setEnd(a.node,a.offset),c.addRange(f))}}}},
	xh=F.ELEMENT_NODE,yh={hasSelectionCapabilities:function(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&"text"===a.type||"textarea"===b||"true"===a.contentEditable)},getSelectionInformation:function(){var a=ia();return{focusedElem:a,selectionRange:yh.hasSelectionCapabilities(a)?yh.getSelection(a):null}},restoreSelection:function(a){var b=ia(),c=a.focusedElem;a=a.selectionRange;if(b!==c&&fa(document.documentElement,c)){yh.hasSelectionCapabilities(c)&&yh.setSelection(c,a);b=
	[];for(a=c;a=a.parentNode;)a.nodeType===xh&&b.push({element:a,left:a.scrollLeft,top:a.scrollTop});ha(c);for(c=0;c<b.length;c++)a=b[c],a.element.scrollLeft=a.left,a.element.scrollTop=a.top}},getSelection:function(a){return("selectionStart"in a?{start:a.selectionStart,end:a.selectionEnd}:wh.getOffsets(a))||{start:0,end:0}},setSelection:function(a,b){var c=b.start,d=b.end;void 0===d&&(d=c);"selectionStart"in a?(a.selectionStart=c,a.selectionEnd=Math.min(d,a.value.length)):wh.setOffsets(a,b)}},zh=yh,
	Ah=F.ELEMENT_NODE;function Bh(){w("211")}function Ch(){w("212")}function Dh(a){if(null==a)return null;if(a.nodeType===Ah)return a;var b=Pa.get(a);if(b)return"number"===typeof b.tag?Bh(b):Ch(b);"function"===typeof a.render?w("188"):w("213",Object.keys(a))}Dh._injectFiber=function(a){Bh=a};Dh._injectStack=function(a){Ch=a};var Eh=E.HostComponent;function Fh(a){if(void 0!==a._hostParent)return a._hostParent;if("number"===typeof a.tag){do a=a["return"];while(a&&a.tag!==Eh);if(a)return a}return null}
	function Gh(a,b){for(var c=0,d=a;d;d=Fh(d))c++;d=0;for(var e=b;e;e=Fh(e))d++;for(;0<c-d;)a=Fh(a),c--;for(;0<d-c;)b=Fh(b),d--;for(;c--;){if(a===b||a===b.alternate)return a;a=Fh(a);b=Fh(b)}return null}
	var Hh={isAncestor:function(a,b){for(;b;){if(a===b||a===b.alternate)return!0;b=Fh(b)}return!1},getLowestCommonAncestor:Gh,getParentInstance:function(a){return Fh(a)},traverseTwoPhase:function(a,b,c){for(var d=[];a;)d.push(a),a=Fh(a);for(a=d.length;0<a--;)b(d[a],"captured",c);for(a=0;a<d.length;a++)b(d[a],"bubbled",c)},traverseEnterLeave:function(a,b,c,d,e){for(var f=a&&b?Gh(a,b):null,g=[];a&&a!==f;)g.push(a),a=Fh(a);for(a=[];b&&b!==f;)a.push(b),b=Fh(b);for(b=0;b<g.length;b++)c(g[b],"bubbled",d);for(b=
	a.length;0<b--;)c(a[b],"captured",e)}},Ih=Jb.getListener;function Jh(a,b,c){if(b=Ih(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a)}function Kh(a){a&&a.dispatchConfig.phasedRegistrationNames&&Hh.traverseTwoPhase(a._targetInst,Jh,a)}function Qh(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?Hh.getParentInstance(b):null;Hh.traverseTwoPhase(b,Jh,a)}}
	function Rh(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ih(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=Cb(c._dispatchListeners,b),c._dispatchInstances=Cb(c._dispatchInstances,a))}function Sh(a){a&&a.dispatchConfig.registrationName&&Rh(a._targetInst,null,a)}
	var Th={accumulateTwoPhaseDispatches:function(a){Db(a,Kh)},accumulateTwoPhaseDispatchesSkipTarget:function(a){Db(a,Qh)},accumulateDirectDispatches:function(a){Db(a,Sh)},accumulateEnterLeaveDispatches:function(a,b,c,d){Hh.traverseEnterLeave(c,d,Rh,a,b)}},X={_root:null,_startText:null,_fallbackText:null},Uh={initialize:function(a){X._root=a;X._startText=Uh.getText();return!0},reset:function(){X._root=null;X._startText=null;X._fallbackText=null},getData:function(){if(X._fallbackText)return X._fallbackText;
	var a,b=X._startText,c=b.length,d,e=Uh.getText(),f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);X._fallbackText=e.slice(a,1<d?1-d:void 0);return X._fallbackText},getText:function(){return"value"in X._root?X._root.value:X._root[vh()]}},Vh=Uh,Wh="dispatchConfig _targetInst nativeEvent isDefaultPrevented isPropagationStopped _dispatchListeners _dispatchInstances".split(" "),Xh={type:null,target:null,currentTarget:ca.thatReturnsNull,eventPhase:null,bubbles:null,
	cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	function Y(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?ca.thatReturnsTrue:ca.thatReturnsFalse;this.isPropagationStopped=ca.thatReturnsFalse;return this}
	n(Y.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=ca.thatReturnsTrue)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=ca.thatReturnsTrue)},persist:function(){this.isPersistent=ca.thatReturnsTrue},isPersistent:ca.thatReturnsFalse,
	destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=null;for(a=0;a<Wh.length;a++)this[Wh[a]]=null}});Y.Interface=Xh;Y.augmentClass=function(a,b){function c(){}c.prototype=this.prototype;var d=new c;n(d,a.prototype);a.prototype=d;a.prototype.constructor=a;a.Interface=n({},this.Interface,b);a.augmentClass=this.augmentClass;Yh(a)};Yh(Y);function Zh(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
	function $h(a){a instanceof this?void 0:w("223");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Yh(a){a.eventPool=[];a.getPooled=Zh;a.release=$h}function ai(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ai,{data:null});function bi(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(bi,{data:null});var ci=[9,13,27,32],di=l.canUseDOM&&"CompositionEvent"in window,ei=null;l.canUseDOM&&"documentMode"in document&&(ei=document.documentMode);var fi;
	if(fi=l.canUseDOM&&"TextEvent"in window&&!ei){var gi=window.opera;fi=!("object"===typeof gi&&"function"===typeof gi.version&&12>=parseInt(gi.version(),10))}
	var hi=fi,ii=l.canUseDOM&&(!di||ei&&8<ei&&11>=ei),ji=String.fromCharCode(32),ki={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["topCompositionEnd","topKeyPress","topTextInput","topPaste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"topBlur topCompositionEnd topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"topBlur topCompositionStart topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"topBlur topCompositionUpdate topKeyDown topKeyPress topKeyUp topMouseDown".split(" ")}},li=!1;
	function mi(a,b){switch(a){case "topKeyUp":return-1!==ci.indexOf(b.keyCode);case "topKeyDown":return 229!==b.keyCode;case "topKeyPress":case "topMouseDown":case "topBlur":return!0;default:return!1}}function ni(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var oi=!1;function pi(a,b){switch(a){case "topCompositionEnd":return ni(b);case "topKeyPress":if(32!==b.which)return null;li=!0;return ji;case "topTextInput":return a=b.data,a===ji&&li?null:a;default:return null}}
	function qi(a,b){if(oi)return"topCompositionEnd"===a||!di&&mi(a,b)?(a=Vh.getData(),Vh.reset(),oi=!1,a):null;switch(a){case "topPaste":return null;case "topKeyPress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "topCompositionEnd":return ii?null:b.data;default:return null}}
	var ri={eventTypes:ki,extractEvents:function(a,b,c,d){var e;if(di)b:{switch(a){case "topCompositionStart":var f=ki.compositionStart;break b;case "topCompositionEnd":f=ki.compositionEnd;break b;case "topCompositionUpdate":f=ki.compositionUpdate;break b}f=void 0}else oi?mi(a,c)&&(f=ki.compositionEnd):"topKeyDown"===a&&229===c.keyCode&&(f=ki.compositionStart);f?(ii&&(oi||f!==ki.compositionStart?f===ki.compositionEnd&&oi&&(e=Vh.getData()):oi=Vh.initialize(d)),f=ai.getPooled(f,b,c,d),e?f.data=e:(e=ni(c),
	null!==e&&(f.data=e)),Th.accumulateTwoPhaseDispatches(f),e=f):e=null;(a=hi?pi(a,c):qi(a,c))?(b=bi.getPooled(ki.beforeInput,b,c,d),b.data=a,Th.accumulateTwoPhaseDispatches(b)):b=null;return[e,b]}},si={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function ti(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!si[a.type]:"textarea"===b?!0:!1}
	var ui={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"topBlur topChange topClick topFocus topInput topKeyDown topKeyUp topSelectionChange".split(" ")}};function vi(a,b,c){a=Y.getPooled(ui.change,a,b,c);a.type="change";nb.enqueueStateRestore(c);Th.accumulateTwoPhaseDispatches(a);return a}var wi=null,xi=null;function yi(a){Jb.enqueueEvents(a);Jb.processEventQueue(!1)}
	function zi(a){var b=G.getNodeFromInstance(a);if(Bc.updateValueIfChanged(b))return a}function Ai(a,b){if("topChange"===a)return b}var Bi=!1;l.canUseDOM&&(Bi=Lb("input")&&(!document.documentMode||9<document.documentMode));function Ci(){wi&&(wi.detachEvent("onpropertychange",Di),xi=wi=null)}function Di(a){"value"===a.propertyName&&zi(xi)&&(a=vi(xi,a,ub(a)),sb.batchedUpdates(yi,a))}function Ei(a,b,c){"topFocus"===a?(Ci(),wi=b,xi=c,wi.attachEvent("onpropertychange",Di)):"topBlur"===a&&Ci()}
	function Fi(a){if("topSelectionChange"===a||"topKeyUp"===a||"topKeyDown"===a)return zi(xi)}function Gi(a,b){if("topClick"===a)return zi(b)}function Hi(a,b){if("topInput"===a||"topChange"===a)return zi(b)}
	var Ii={eventTypes:ui,_isInputEventSupported:Bi,extractEvents:function(a,b,c,d){var e=b?G.getNodeFromInstance(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ai;else if(ti(e))if(Bi)g=Hi;else{g=Fi;var h=Ei}else f=e.nodeName,!f||"input"!==f.toLowerCase()||"checkbox"!==e.type&&"radio"!==e.type||(g=Gi);if(g&&(g=g(a,b)))return vi(g,c,d);h&&h(a,e,b);"topBlur"===a&&null!=b&&(a=b._wrapperState||e._wrapperState)&&a.controlled&&"number"===e.type&&(a=""+e.value,
	e.getAttribute("value")!==a&&e.setAttribute("value",a))}};function Ji(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(Ji,{view:function(a){if(a.view)return a.view;a=ub(a);return a.window===a?a:(a=a.ownerDocument)?a.defaultView||a.parentWindow:window},detail:function(a){return a.detail||0}});var Ki={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Li(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Ki[a])?!!b[a]:!1}function Mi(){return Li}
	function Ni(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(Ni,{screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Mi,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)}});
	var Oi={mouseEnter:{registrationName:"onMouseEnter",dependencies:["topMouseOut","topMouseOver"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["topMouseOut","topMouseOver"]}},Pi={eventTypes:Oi,extractEvents:function(a,b,c,d){if("topMouseOver"===a&&(c.relatedTarget||c.fromElement)||"topMouseOut"!==a&&"topMouseOver"!==a)return null;var e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;"topMouseOut"===a?(a=b,b=(b=c.relatedTarget||c.toElement)?G.getClosestInstanceFromNode(b):
	null):a=null;if(a===b)return null;var f=null==a?e:G.getNodeFromInstance(a);e=null==b?e:G.getNodeFromInstance(b);var g=Ni.getPooled(Oi.mouseLeave,a,c,d);g.type="mouseleave";g.target=f;g.relatedTarget=e;c=Ni.getPooled(Oi.mouseEnter,b,c,d);c.type="mouseenter";c.target=e;c.relatedTarget=f;Th.accumulateEnterLeaveDispatches(g,c,a,b);return[g,c]}},Qi=F.DOCUMENT_NODE,Ri=l.canUseDOM&&"documentMode"in document&&11>=document.documentMode,Si={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},
	dependencies:"topBlur topContextMenu topFocus topKeyDown topKeyUp topMouseDown topMouseUp topSelectionChange".split(" ")}},Ti=null,Zi=null,$i=null,aj=!1,bj=M.isListeningToAllDependencies;
	function cj(a,b){if(aj||null==Ti||Ti!==ia())return null;var c=Ti;"selectionStart"in c&&zh.hasSelectionCapabilities(c)?c={start:c.selectionStart,end:c.selectionEnd}:window.getSelection?(c=window.getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset}):c=void 0;return $i&&ea($i,c)?null:($i=c,a=Y.getPooled(Si.select,Zi,a,b),a.type="select",a.target=Ti,Th.accumulateTwoPhaseDispatches(a),a)}
	var dj={eventTypes:Si,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:d.nodeType===Qi?d:d.ownerDocument;if(!e||!bj("onSelect",e))return null;e=b?G.getNodeFromInstance(b):window;switch(a){case "topFocus":if(ti(e)||"true"===e.contentEditable)Ti=e,Zi=b,$i=null;break;case "topBlur":$i=Zi=Ti=null;break;case "topMouseDown":aj=!0;break;case "topContextMenu":case "topMouseUp":return aj=!1,cj(c,d);case "topSelectionChange":if(Ri)break;case "topKeyDown":case "topKeyUp":return cj(c,d)}return null}};
	function ej(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(ej,{animationName:null,elapsedTime:null,pseudoElement:null});function fj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(fj,{clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}});function gj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(gj,{relatedTarget:null});function hj(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;return 32<=a||13===a?a:0}
	var ij={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},jj={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"};function kj(a,b,c,d){return Y.call(this,a,b,c,d)}
	Ji.augmentClass(kj,{key:function(a){if(a.key){var b=ij[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=hj(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?jj[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Mi,charCode:function(a){return"keypress"===a.type?hj(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
	a.type?hj(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}});function lj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(lj,{dataTransfer:null});function mj(a,b,c,d){return Y.call(this,a,b,c,d)}Ji.augmentClass(mj,{touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Mi});function nj(a,b,c,d){return Y.call(this,a,b,c,d)}Y.augmentClass(nj,{propertyName:null,elapsedTime:null,pseudoElement:null});
	function oj(a,b,c,d){return Y.call(this,a,b,c,d)}Ni.augmentClass(oj,{deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null});var pj={},qj={};
	"abort animationEnd animationIteration animationStart blur cancel canPlay canPlayThrough click close contextMenu copy cut doubleClick drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error focus input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing progress rateChange reset scroll seeked seeking stalled submit suspend timeUpdate toggle touchCancel touchEnd touchMove touchStart transitionEnd volumeChange waiting wheel".split(" ").forEach(function(a){var b=a[0].toUpperCase()+
	a.slice(1),c="on"+b;b="top"+b;c={phasedRegistrationNames:{bubbled:c,captured:c+"Capture"},dependencies:[b]};pj[a]=c;qj[b]=c});
	var rj={eventTypes:pj,extractEvents:function(a,b,c,d){var e=qj[a];if(!e)return null;switch(a){case "topAbort":case "topCancel":case "topCanPlay":case "topCanPlayThrough":case "topClose":case "topDurationChange":case "topEmptied":case "topEncrypted":case "topEnded":case "topError":case "topInput":case "topInvalid":case "topLoad":case "topLoadedData":case "topLoadedMetadata":case "topLoadStart":case "topPause":case "topPlay":case "topPlaying":case "topProgress":case "topRateChange":case "topReset":case "topSeeked":case "topSeeking":case "topStalled":case "topSubmit":case "topSuspend":case "topTimeUpdate":case "topToggle":case "topVolumeChange":case "topWaiting":var f=Y;
	break;case "topKeyPress":if(0===hj(c))return null;case "topKeyDown":case "topKeyUp":f=kj;break;case "topBlur":case "topFocus":f=gj;break;case "topClick":if(2===c.button)return null;case "topDoubleClick":case "topMouseDown":case "topMouseMove":case "topMouseUp":case "topMouseOut":case "topMouseOver":case "topContextMenu":f=Ni;break;case "topDrag":case "topDragEnd":case "topDragEnter":case "topDragExit":case "topDragLeave":case "topDragOver":case "topDragStart":case "topDrop":f=lj;break;case "topTouchCancel":case "topTouchEnd":case "topTouchMove":case "topTouchStart":f=
	mj;break;case "topAnimationEnd":case "topAnimationIteration":case "topAnimationStart":f=ej;break;case "topTransitionEnd":f=nj;break;case "topScroll":f=Ji;break;case "topWheel":f=oj;break;case "topCopy":case "topCut":case "topPaste":f=fj}f?void 0:w("86",a);a=f.getPooled(e,b,c,d);Th.accumulateTwoPhaseDispatches(a);return a}};L.setHandleTopLevel(M.handleTopLevel);Jb.injection.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin TapEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));
	ib.injection.injectComponentTree(G);Jb.injection.injectEventPluginsByName({SimpleEventPlugin:rj,EnterLeaveEventPlugin:Pi,ChangeEventPlugin:Ii,SelectEventPlugin:dj,BeforeInputEventPlugin:ri});
	var sj=A.injection.MUST_USE_PROPERTY,Z=A.injection.HAS_BOOLEAN_VALUE,tj=A.injection.HAS_NUMERIC_VALUE,uj=A.injection.HAS_POSITIVE_NUMERIC_VALUE,vj=A.injection.HAS_STRING_BOOLEAN_VALUE,wj={Properties:{allowFullScreen:Z,allowTransparency:vj,async:Z,autoPlay:Z,capture:Z,checked:sj|Z,cols:uj,contentEditable:vj,controls:Z,"default":Z,defer:Z,disabled:Z,download:A.injection.HAS_OVERLOADED_BOOLEAN_VALUE,draggable:vj,formNoValidate:Z,hidden:Z,loop:Z,multiple:sj|Z,muted:sj|Z,noValidate:Z,open:Z,playsInline:Z,
	readOnly:Z,required:Z,reversed:Z,rows:uj,rowSpan:tj,scoped:Z,seamless:Z,selected:sj|Z,size:uj,start:tj,span:uj,spellCheck:vj,style:0,itemScope:Z,acceptCharset:0,className:0,htmlFor:0,httpEquiv:0,value:vj},DOMAttributeNames:{acceptCharset:"accept-charset",className:"class",htmlFor:"for",httpEquiv:"http-equiv"},DOMMutationMethods:{value:function(a,b){if(null==b)return a.removeAttribute("value");"number"!==a.type||!1===a.hasAttribute("value")?a.setAttribute("value",""+b):a.validity&&!a.validity.badInput&&
	a.ownerDocument.activeElement!==a&&a.setAttribute("value",""+b)}}},xj=A.injection.HAS_STRING_BOOLEAN_VALUE,yj={xlink:"http://www.w3.org/1999/xlink",xml:"http://www.w3.org/XML/1998/namespace"},zj={Properties:{autoReverse:xj,externalResourcesRequired:xj,preserveAlpha:xj},DOMAttributeNames:{autoReverse:"autoReverse",externalResourcesRequired:"externalResourcesRequired",preserveAlpha:"preserveAlpha"},DOMAttributeNamespaces:{xlinkActuate:yj.xlink,xlinkArcrole:yj.xlink,xlinkHref:yj.xlink,xlinkRole:yj.xlink,
	xlinkShow:yj.xlink,xlinkTitle:yj.xlink,xlinkType:yj.xlink,xmlBase:yj.xml,xmlLang:yj.xml,xmlSpace:yj.xml}},Aj=/[\-\:]([a-z])/g;function Bj(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode x-height xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type xml:base xmlns:xlink xml:lang xml:space".split(" ").forEach(function(a){var b=a.replace(Aj,
	Bj);zj.Properties[b]=0;zj.DOMAttributeNames[b]=a});A.injection.injectDOMPropertyConfig(wj);A.injection.injectDOMPropertyConfig(zj);
	var Cj=ig.injectInternals,Dj=F.ELEMENT_NODE,Ej=F.TEXT_NODE,Fj=F.COMMENT_NODE,Gj=F.DOCUMENT_NODE,Hj=F.DOCUMENT_FRAGMENT_NODE,Ij=A.ROOT_ATTRIBUTE_NAME,Jj=ka.getChildNamespace,Kj=N.createElement,Lj=N.createTextNode,Mj=N.setInitialProperties,Nj=N.diffProperties,Oj=N.updateProperties,Pj=N.diffHydratedProperties,Qj=N.diffHydratedText,Rj=N.warnForDeletedHydratableElement,Sj=N.warnForDeletedHydratableText,Tj=N.warnForInsertedHydratedElement,Uj=N.warnForInsertedHydratedText,Vj=G.precacheFiberNode,Wj=G.updateFiberProps;
	nb.injection.injectFiberControlledHostComponent(N);Dh._injectFiber(function(a){return Xj.findHostInstance(a)});var Yj=null,Zj=null;function ak(a){return!(!a||a.nodeType!==Dj&&a.nodeType!==Gj&&a.nodeType!==Hj&&(a.nodeType!==Fj||" react-mount-point-unstable "!==a.nodeValue))}function bk(a){a=a?a.nodeType===Gj?a.documentElement:a.firstChild:null;return!(!a||a.nodeType!==Dj||!a.hasAttribute(Ij))}
	var Xj=function(a){var b=a.getPublicInstance;a=hh(a);var c=a.scheduleUpdate,d=a.getPriorityContext;return{createContainer:function(a){var b=ee();a={current:b,containerInfo:a,isScheduled:!1,nextScheduledRoot:null,context:null,pendingContext:null};return b.stateNode=a},updateContainer:function(a,b,g,h){var e=b.current;g=jh(g);null===b.context?b.context=g:b.pendingContext=g;b=h;h=d(e,ed.enableAsyncSubtreeAPI&&null!=a&&null!=a.type&&null!=a.type.prototype&&!0===a.type.prototype.unstable_isAsyncReactComponent);
	a={element:a};kh(e,a,void 0===b?null:b,h);c(e,h)},batchedUpdates:a.batchedUpdates,unbatchedUpdates:a.unbatchedUpdates,deferredUpdates:a.deferredUpdates,flushSync:a.flushSync,getPublicRootInstance:function(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case oh:return b(a.child.stateNode);default:return a.child.stateNode}},findHostInstance:function(a){a=ph(a);return null===a?null:a.stateNode},findHostInstanceWithNoPortals:function(a){a=qh(a);return null===a?null:a.stateNode}}}({getRootHostContext:function(a){if(a.nodeType===
	Gj)a=(a=a.documentElement)?a.namespaceURI:Jj(null,"");else{var b=a.nodeType===Fj?a.parentNode:a;a=b.namespaceURI||null;b=b.tagName;a=Jj(a,b)}return a},getChildHostContext:function(a,b){return Jj(a,b)},getPublicInstance:function(a){return a},prepareForCommit:function(){Yj=M.isEnabled();Zj=zh.getSelectionInformation();M.setEnabled(!1)},resetAfterCommit:function(){zh.restoreSelection(Zj);Zj=null;M.setEnabled(Yj);Yj=null},createInstance:function(a,b,c,d,e){a=Kj(a,b,c,d);Vj(e,a);Wj(a,b);return a},appendInitialChild:function(a,
	b){a.appendChild(b)},finalizeInitialChildren:function(a,b,c,d){Mj(a,b,c,d);a:{switch(b){case "button":case "input":case "select":case "textarea":a=!!c.autoFocus;break a}a=!1}return a},prepareUpdate:function(a,b,c,d,e){return Nj(a,b,c,d,e)},commitMount:function(a){a.focus()},commitUpdate:function(a,b,c,d,e){Wj(a,e);Oj(a,b,c,d,e)},shouldSetTextContent:function(a,b){return"textarea"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&
	"string"===typeof b.dangerouslySetInnerHTML.__html},resetTextContent:function(a){a.textContent=""},shouldDeprioritizeSubtree:function(a,b){return!!b.hidden},createTextInstance:function(a,b,c,d){a=Lj(a,b);Vj(d,a);return a},commitTextUpdate:function(a,b,c){a.nodeValue=c},appendChild:function(a,b){a.appendChild(b)},appendChildToContainer:function(a,b){a.nodeType===Fj?a.parentNode.insertBefore(b,a):a.appendChild(b)},insertBefore:function(a,b,c){a.insertBefore(b,c)},insertInContainerBefore:function(a,
	b,c){a.nodeType===Fj?a.parentNode.insertBefore(b,c):a.insertBefore(b,c)},removeChild:function(a,b){a.removeChild(b)},removeChildFromContainer:function(a,b){a.nodeType===Fj?a.parentNode.removeChild(b):a.removeChild(b)},canHydrateInstance:function(a,b){return a.nodeType===Dj&&b===a.nodeName.toLowerCase()},canHydrateTextInstance:function(a,b){return""===b?!1:a.nodeType===Ej},getNextHydratableSibling:function(a){for(a=a.nextSibling;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},getFirstHydratableChild:function(a){for(a=
	a.firstChild;a&&a.nodeType!==Dj&&a.nodeType!==Ej;)a=a.nextSibling;return a},hydrateInstance:function(a,b,c,d,e,f){Vj(f,a);Wj(a,c);return Pj(a,b,c,e,d)},hydrateTextInstance:function(a,b,c){Vj(c,a);return Qj(a,b)},didNotHydrateInstance:function(a,b){1===b.nodeType?Rj(a,b):Sj(a,b)},didNotFindHydratableInstance:function(a,b,c){Tj(a,b,c)},didNotFindHydratableTextInstance:function(a,b){Uj(a,b)},scheduleDeferredCallback:dd.rIC,useSyncScheduling:!0});sb.injection.injectFiberBatchedUpdates(Xj.batchedUpdates);
	function ck(a,b,c,d,e){ak(c)?void 0:w("200");var f=c._reactRootContainer;if(f)Xj.updateContainer(b,f,a,e);else{if(!d&&!bk(c))for(d=void 0;d=c.lastChild;)c.removeChild(d);var g=Xj.createContainer(c);f=c._reactRootContainer=g;Xj.unbatchedUpdates(function(){Xj.updateContainer(b,g,a,e)})}return Xj.getPublicRootInstance(f)}function dk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;ak(b)?void 0:w("200");return ne.createPortal(a,b,null,c)}
	var ek={createPortal:dk,hydrate:function(a,b,c){return ck(null,a,b,!0,c)},render:function(a,b,c){return ck(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){null!=a&&Pa.has(a)?void 0:w("38");return ck(a,b,c,!1,d)},unmountComponentAtNode:function(a){ak(a)?void 0:w("40");return a._reactRootContainer?(Xj.unbatchedUpdates(function(){ck(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},findDOMNode:Dh,unstable_createPortal:dk,unstable_batchedUpdates:sb.batchedUpdates,
	unstable_deferredUpdates:Xj.deferredUpdates,flushSync:Xj.flushSync,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{EventPluginHub:Jb,EventPluginRegistry:sa,EventPropagators:Th,ReactControlledComponent:nb,ReactDOMComponentTree:G,ReactDOMEventListener:L}};Cj({findFiberByHostInstance:G.getClosestInstanceFromNode,findHostInstanceByFiber:Xj.findHostInstance,bundleType:0,version:"16.0.0",rendererPackageName:"react-dom"});module.exports=ek;


/***/ }),
/* 888 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	__webpack_require__(893);
	
	var _propConverter = __webpack_require__(894);
	
	var _propConverter2 = _interopRequireDefault(_propConverter);
	
	var _domManipulation = __webpack_require__(889);
	
	var _helpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/**
	 * React Flip Move
	 * (c) 2016-present Joshua Comeau
	 *
	 * For information on how this code is laid out, check out CODE_TOUR.md
	 */
	
	/* eslint-disable react/prop-types */
	
	// eslint-disable-next-line no-duplicate-imports
	
	
	var transitionEnd = (0, _domManipulation.whichTransitionEvent)();
	var noBrowserSupport = !transitionEnd;
	
	function getKey(childData) {
	  return childData.key || '';
	}
	
	function getElementChildren(children) {
	  // Fix incomplete typing of Children.toArray
	  // eslint-disable-next-line flowtype/no-weak-types
	  return _react.Children.toArray(children);
	}
	
	var FlipMove = function (_Component) {
	  _inherits(FlipMove, _Component);
	
	  function FlipMove() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FlipMove);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FlipMove.__proto__ || Object.getPrototypeOf(FlipMove)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      children: getElementChildren(
	      // `this.props` ought to always be defined at this point, but a report
	      // was made about it not being defined in IE10.
	      // TODO: Test in IE10, to see if there's an underlying cause that can
	      // be addressed.
	      _this.props ? _this.props.children : []).map(function (element) {
	        return _extends({}, element, {
	          element: element,
	          appearing: true
	        });
	      })
	    }, _this.childrenData = {}, _this.parentData = {
	      domNode: null,
	      boundingBox: null
	    }, _this.heightPlaceholderData = {
	      domNode: null
	    }, _this.remainingAnimations = 0, _this.childrenToAnimate = [], _this.runAnimation = function () {
	      var dynamicChildren = _this.state.children.filter(_this.doesChildNeedToBeAnimated);
	
	      dynamicChildren.forEach(function (child, n) {
	        _this.remainingAnimations += 1;
	        _this.childrenToAnimate.push(getKey(child));
	        _this.animateChild(child, n);
	      });
	
	      if (typeof _this.props.onStartAll === 'function') {
	        _this.callChildrenHook(_this.props.onStartAll);
	      }
	    }, _this.doesChildNeedToBeAnimated = function (child) {
	      // If the child doesn't have a key, it's an immovable child (one that we
	      // do not want to do FLIP stuff to.)
	      if (!getKey(child)) {
	        return false;
	      }
	
	      var childData = _this.getChildData(getKey(child));
	      var childDomNode = childData.domNode;
	      var childBoundingBox = childData.boundingBox;
	      var parentBoundingBox = _this.parentData.boundingBox;
	
	      if (!childDomNode) {
	        return false;
	      }
	
	      var _this$props = _this.props,
	          appearAnimation = _this$props.appearAnimation,
	          enterAnimation = _this$props.enterAnimation,
	          leaveAnimation = _this$props.leaveAnimation,
	          getPosition = _this$props.getPosition;
	
	
	      var isAppearingWithAnimation = child.appearing && appearAnimation;
	      var isEnteringWithAnimation = child.entering && enterAnimation;
	      var isLeavingWithAnimation = child.leaving && leaveAnimation;
	
	      if (isAppearingWithAnimation || isEnteringWithAnimation || isLeavingWithAnimation) {
	        return true;
	      }
	
	      // If it isn't entering/leaving, we want to animate it if it's
	      // on-screen position has changed.
	
	      var _getPositionDelta = (0, _domManipulation.getPositionDelta)({
	        childDomNode: childDomNode,
	        childBoundingBox: childBoundingBox,
	        parentBoundingBox: parentBoundingBox,
	        getPosition: getPosition
	      }),
	          _getPositionDelta2 = _slicedToArray(_getPositionDelta, 2),
	          dX = _getPositionDelta2[0],
	          dY = _getPositionDelta2[1];
	
	      return dX !== 0 || dY !== 0;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	  // Copy props.children into state.
	  // To understand why this is important (and not an anti-pattern), consider
	  // how "leave" animations work. An item has "left" when the component
	  // receives a new set of props that do NOT contain the item.
	  // If we just render the props as-is, the item would instantly disappear.
	  // We want to keep the item rendered for a little while, until its animation
	  // can complete. Because we cannot mutate props, we make `state` the source
	  // of truth.
	
	
	  // FlipMove needs to know quite a bit about its children in order to do
	  // its job. We store these as a property on the instance. We're not using
	  // state, because we don't want changes to trigger re-renders, we just
	  // need a place to keep the data for reference, when changes happen.
	  // This field should not be accessed directly. Instead, use getChildData,
	  // putChildData, etc...
	
	
	  // Similarly, track the dom node and box of our parent element.
	
	
	  // If `maintainContainerHeight` prop is set to true, we'll create a
	  // placeholder element which occupies space so that the parent height
	  // doesn't change when items are removed from the document flow (which
	  // happens during leave animations)
	
	
	  // Keep track of remaining animations so we know when to fire the
	  // all-finished callback, and clean up after ourselves.
	  // NOTE: we can't simply use childrenToAnimate.length to track remaining
	  // animations, because we need to maintain the list of animating children,
	  // to pass to the `onFinishAll` handler.
	
	
	  _createClass(FlipMove, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Run our `appearAnimation` if it was requested, right after the
	      // component mounts.
	      var shouldTriggerFLIP = this.props.appearAnimation && !this.isAnimationDisabled(this.props);
	
	      if (shouldTriggerFLIP) {
	        this.prepForAnimation();
	        this.runAnimation();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // When the component is handed new props, we need to figure out the
	      // "resting" position of all currently-rendered DOM nodes.
	      // We store that data in this.parent and this.children,
	      // so it can be used later to work out the animation.
	      this.updateBoundingBoxCaches();
	
	      // Convert opaque children object to array.
	      var nextChildren = getElementChildren(nextProps.children);
	
	      // Next, we need to update our state, so that it contains our new set of
	      // children. If animation is disabled or unsupported, this is easy;
	      // we just copy our props into state.
	      // Assuming that we can animate, though, we have to do some work.
	      // Essentially, we want to keep just-deleted nodes in the DOM for a bit
	      // longer, so that we can animate them away.
	      this.setState({
	        children: this.isAnimationDisabled(nextProps) ? nextChildren.map(function (element) {
	          return _extends({}, element, { element: element });
	        }) : this.calculateNextSetOfChildren(nextChildren)
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(previousProps) {
	      // If the children have been re-arranged, moved, or added/removed,
	      // trigger the main FLIP animation.
	      //
	      // IMPORTANT: We need to make sure that the children have actually changed.
	      // At the end of the transition, we clean up nodes that need to be removed.
	      var oldChildrenKeys = getElementChildren(this.props.children).map(function (d) {
	        return d.key;
	      });
	      var nextChildrenKeys = getElementChildren(previousProps.children).map(function (d) {
	        return d.key;
	      });
	
	      var shouldTriggerFLIP = !(0, _helpers.arraysEqual)(oldChildrenKeys, nextChildrenKeys) && !this.isAnimationDisabled(this.props);
	
	      if (shouldTriggerFLIP) {
	        this.prepForAnimation();
	        this.runAnimation();
	      }
	    }
	  }, {
	    key: 'calculateNextSetOfChildren',
	    value: function calculateNextSetOfChildren(nextChildren) {
	      var _this2 = this;
	
	      // We want to:
	      //   - Mark all new children as `entering`
	      //   - Pull in previous children that aren't in nextChildren, and mark them
	      //     as `leaving`
	      //   - Preserve the nextChildren list order, with leaving children in their
	      //     appropriate places.
	      //
	
	      var updatedChildren = nextChildren.map(function (nextChild) {
	        var child = _this2.findChildByKey(nextChild.key);
	
	        // If the current child did exist, but it was in the midst of leaving,
	        // we want to treat it as though it's entering
	        var isEntering = !child || child.leaving;
	
	        return _extends({}, nextChild, { element: nextChild, entering: isEntering });
	      });
	
	      // This is tricky. We want to keep the nextChildren's ordering, but with
	      // any just-removed items maintaining their original position.
	      // eg.
	      //   this.state.children  = [ 1, 2, 3, 4 ]
	      //   nextChildren         = [ 3, 1 ]
	      //
	      // In this example, we've removed the '2' & '4'
	      // We want to end up with:  [ 2, 3, 1, 4 ]
	      //
	      // To accomplish that, we'll iterate through this.state.children. whenever
	      // we find a match, we'll append our `leaving` flag to it, and insert it
	      // into the nextChildren in its ORIGINAL position. Note that, as we keep
	      // inserting old items into the new list, the "original" position will
	      // keep incrementing.
	      var numOfChildrenLeaving = 0;
	      this.state.children.forEach(function (child, index) {
	        var isLeaving = !nextChildren.find(function (_ref2) {
	          var key = _ref2.key;
	          return key === getKey(child);
	        });
	
	        // If the child isn't leaving (or, if there is no leave animation),
	        // we don't need to add it into the state children.
	        if (!isLeaving || !_this2.props.leaveAnimation) return;
	
	        var nextChild = _extends({}, child, { leaving: true });
	        var nextChildIndex = index + numOfChildrenLeaving;
	
	        updatedChildren.splice(nextChildIndex, 0, nextChild);
	        numOfChildrenLeaving += 1;
	      });
	
	      return updatedChildren;
	    }
	  }, {
	    key: 'prepForAnimation',
	    value: function prepForAnimation() {
	      var _this3 = this;
	
	      // Our animation prep consists of:
	      // - remove children that are leaving from the DOM flow, so that the new
	      //   layout can be accurately calculated,
	      // - update the placeholder container height, if needed, to ensure that
	      //   the parent's height doesn't collapse.
	
	      var _props = this.props,
	          leaveAnimation = _props.leaveAnimation,
	          maintainContainerHeight = _props.maintainContainerHeight,
	          getPosition = _props.getPosition;
	
	      // we need to make all leaving nodes "invisible" to the layout calculations
	      // that will take place in the next step (this.runAnimation).
	
	      if (leaveAnimation) {
	        var leavingChildren = this.state.children.filter(function (child) {
	          return child.leaving;
	        });
	
	        leavingChildren.forEach(function (leavingChild) {
	          var childData = _this3.getChildData(getKey(leavingChild));
	
	          // We need to take the items out of the "flow" of the document, so that
	          // its siblings can move to take its place.
	          if (childData.boundingBox) {
	            (0, _domManipulation.removeNodeFromDOMFlow)(childData, _this3.props.verticalAlignment);
	          }
	        });
	
	        if (maintainContainerHeight && this.heightPlaceholderData.domNode) {
	          (0, _domManipulation.updateHeightPlaceholder)({
	            domNode: this.heightPlaceholderData.domNode,
	            parentData: this.parentData,
	            getPosition: getPosition
	          });
	        }
	      }
	
	      // For all children not in the middle of entering or leaving,
	      // we need to reset the transition, so that the NEW shuffle starts from
	      // the right place.
	      this.state.children.forEach(function (child) {
	        var _getChildData = _this3.getChildData(getKey(child)),
	            domNode = _getChildData.domNode;
	
	        // Ignore children that don't render DOM nodes (eg. by returning null)
	
	
	        if (!domNode) {
	          return;
	        }
	
	        if (!child.entering && !child.leaving) {
	          (0, _domManipulation.applyStylesToDOMNode)({
	            domNode: domNode,
	            styles: {
	              transition: ''
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'animateChild',
	    value: function animateChild(child, index) {
	      var _this4 = this;
	
	      var _getChildData2 = this.getChildData(getKey(child)),
	          domNode = _getChildData2.domNode;
	
	      if (!domNode) {
	        return;
	      }
	
	      // Apply the relevant style for this DOM node
	      // This is the offset from its actual DOM position.
	      // eg. if an item has been re-rendered 20px lower, we want to apply a
	      // style of 'transform: translate(-20px)', so that it appears to be where
	      // it started.
	      // In FLIP terminology, this is the 'Invert' stage.
	      (0, _domManipulation.applyStylesToDOMNode)({
	        domNode: domNode,
	        styles: this.computeInitialStyles(child)
	      });
	
	      // Start by invoking the onStart callback for this child.
	      if (this.props.onStart) this.props.onStart(child, domNode);
	
	      // Next, animate the item from it's artificially-offset position to its
	      // new, natural position.
	      requestAnimationFrame(function () {
	        requestAnimationFrame(function () {
	          // NOTE, RE: the double-requestAnimationFrame:
	          // Sadly, this is the most browser-compatible way to do this I've found.
	          // Essentially we need to set the initial styles outside of any request
	          // callbacks to avoid batching them. Then, a frame needs to pass with
	          // the styles above rendered. Then, on the second frame, we can apply
	          // our final styles to perform the animation.
	
	          // Our first order of business is to "undo" the styles applied in the
	          // previous frames, while also adding a `transition` property.
	          // This way, the item will smoothly transition from its old position
	          // to its new position.
	
	          // eslint-disable-next-line flowtype/require-variable-type
	          var styles = {
	            transition: (0, _domManipulation.createTransitionString)(index, _this4.props),
	            transform: '',
	            opacity: ''
	          };
	
	          if (child.appearing && _this4.props.appearAnimation) {
	            styles = _extends({}, styles, _this4.props.appearAnimation.to);
	          } else if (child.entering && _this4.props.enterAnimation) {
	            styles = _extends({}, styles, _this4.props.enterAnimation.to);
	          } else if (child.leaving && _this4.props.leaveAnimation) {
	            styles = _extends({}, styles, _this4.props.leaveAnimation.to);
	          }
	
	          // In FLIP terminology, this is the 'Play' stage.
	          (0, _domManipulation.applyStylesToDOMNode)({ domNode: domNode, styles: styles });
	        });
	      });
	
	      this.bindTransitionEndHandler(child);
	    }
	  }, {
	    key: 'bindTransitionEndHandler',
	    value: function bindTransitionEndHandler(child) {
	      var _this5 = this;
	
	      var _getChildData3 = this.getChildData(getKey(child)),
	          domNode = _getChildData3.domNode;
	
	      if (!domNode) {
	        return;
	      }
	
	      // The onFinish callback needs to be bound to the transitionEnd event.
	      // We also need to unbind it when the transition completes, so this ugly
	      // inline function is required (we need it here so it closes over
	      // dependent variables `child` and `domNode`)
	      var transitionEndHandler = function transitionEndHandler(ev) {
	        // It's possible that this handler is fired not on our primary transition,
	        // but on a nested transition (eg. a hover effect). Ignore these cases.
	        if (ev.target !== domNode) return;
	
	        // Remove the 'transition' inline style we added. This is cleanup.
	        domNode.style.transition = '';
	
	        // Trigger any applicable onFinish/onFinishAll hooks
	        _this5.triggerFinishHooks(child, domNode);
	
	        domNode.removeEventListener(transitionEnd, transitionEndHandler);
	
	        if (child.leaving) {
	          _this5.removeChildData(getKey(child));
	        }
	      };
	
	      domNode.addEventListener(transitionEnd, transitionEndHandler);
	    }
	  }, {
	    key: 'triggerFinishHooks',
	    value: function triggerFinishHooks(child, domNode) {
	      var _this6 = this;
	
	      if (this.props.onFinish) this.props.onFinish(child, domNode);
	
	      // Reduce the number of children we need to animate by 1,
	      // so that we can tell when all children have finished.
	      this.remainingAnimations -= 1;
	
	      if (this.remainingAnimations === 0) {
	        // Remove any items from the DOM that have left, and reset `entering`.
	        var nextChildren = this.state.children.filter(function (_ref3) {
	          var leaving = _ref3.leaving;
	          return !leaving;
	        }).map(function (item) {
	          return _extends({}, item, {
	            // fix for Flow
	            element: item.element,
	            appearing: false,
	            entering: false
	          });
	        });
	
	        this.setState({ children: nextChildren }, function () {
	          if (typeof _this6.props.onFinishAll === 'function') {
	            _this6.callChildrenHook(_this6.props.onFinishAll);
	          }
	
	          // Reset our variables for the next iteration
	          _this6.childrenToAnimate = [];
	        });
	
	        // If the placeholder was holding the container open while elements were
	        // leaving, we we can now set its height to zero.
	        if (this.heightPlaceholderData.domNode) {
	          this.heightPlaceholderData.domNode.style.height = '0';
	        }
	      }
	    }
	  }, {
	    key: 'callChildrenHook',
	    value: function callChildrenHook(hook) {
	      var _this7 = this;
	
	      var elements = [];
	      var domNodes = [];
	
	      this.childrenToAnimate.forEach(function (childKey) {
	        // If this was an exit animation, the child may no longer exist.
	        // If so, skip it.
	        var child = _this7.findChildByKey(childKey);
	
	        if (!child) {
	          return;
	        }
	
	        elements.push(child);
	
	        if (_this7.hasChildData(childKey)) {
	          domNodes.push(_this7.getChildData(childKey).domNode);
	        }
	      });
	
	      hook(elements, domNodes);
	    }
	  }, {
	    key: 'updateBoundingBoxCaches',
	    value: function updateBoundingBoxCaches() {
	      var _this8 = this;
	
	      // This is the ONLY place that parentData and childrenData's
	      // bounding boxes are updated. They will be calculated at other times
	      // to be compared to this value, but it's important that the cache is
	      // updated once per update.
	      var parentDomNode = this.parentData.domNode;
	
	      if (!parentDomNode) {
	        return;
	      }
	
	      this.parentData.boundingBox = this.props.getPosition(parentDomNode);
	
	      this.state.children.forEach(function (child) {
	        var childKey = getKey(child);
	
	        // It is possible that a child does not have a `key` property;
	        // Ignore these children, they don't need to be moved.
	        if (!childKey) {
	          return;
	        }
	
	        // In very rare circumstances, for reasons unknown, the ref is never
	        // populated for certain children. In this case, avoid doing this update.
	        // see: https://github.com/joshwcomeau/react-flip-move/pull/91
	        if (!_this8.hasChildData(childKey)) {
	          return;
	        }
	
	        var childData = _this8.getChildData(childKey);
	
	        // If the child element returns null, we need to avoid trying to
	        // account for it
	        if (!childData.domNode || !child) {
	          return;
	        }
	
	        _this8.setChildData(childKey, {
	          boundingBox: (0, _domManipulation.getRelativeBoundingBox)({
	            childDomNode: childData.domNode,
	            parentDomNode: parentDomNode,
	            getPosition: _this8.props.getPosition
	          })
	        });
	      });
	    }
	  }, {
	    key: 'computeInitialStyles',
	    value: function computeInitialStyles(child) {
	      if (child.appearing) {
	        return this.props.appearAnimation ? this.props.appearAnimation.from : {};
	      } else if (child.entering) {
	        if (!this.props.enterAnimation) {
	          return {};
	        }
	        // If this child was in the middle of leaving, it still has its
	        // absolute positioning styles applied. We need to undo those.
	        return _extends({
	          position: '',
	          top: '',
	          left: '',
	          right: '',
	          bottom: ''
	        }, this.props.enterAnimation.from);
	      } else if (child.leaving) {
	        return this.props.leaveAnimation ? this.props.leaveAnimation.from : {};
	      }
	
	      var childData = this.getChildData(getKey(child));
	      var childDomNode = childData.domNode;
	      var childBoundingBox = childData.boundingBox;
	      var parentBoundingBox = this.parentData.boundingBox;
	
	      if (!childDomNode) {
	        return {};
	      }
	
	      var _getPositionDelta3 = (0, _domManipulation.getPositionDelta)({
	        childDomNode: childDomNode,
	        childBoundingBox: childBoundingBox,
	        parentBoundingBox: parentBoundingBox,
	        getPosition: this.props.getPosition
	      }),
	          _getPositionDelta4 = _slicedToArray(_getPositionDelta3, 2),
	          dX = _getPositionDelta4[0],
	          dY = _getPositionDelta4[1];
	
	      return {
	        transform: 'translate(' + dX + 'px, ' + dY + 'px)'
	      };
	    }
	
	    // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: 'isAnimationDisabled',
	    value: function isAnimationDisabled(props) {
	      // If the component is explicitly passed a `disableAllAnimations` flag,
	      // we can skip this whole process. Similarly, if all of the numbers have
	      // been set to 0, there is no point in trying to animate; doing so would
	      // only cause a flicker (and the intent is probably to disable animations)
	      // We can also skip this rigamarole if there's no browser support for it.
	      return noBrowserSupport || props.disableAllAnimations || props.duration === 0 && props.delay === 0 && props.staggerDurationBy === 0 && props.staggerDelayBy === 0;
	    }
	  }, {
	    key: 'findChildByKey',
	    value: function findChildByKey(key) {
	      return this.state.children.find(function (child) {
	        return getKey(child) === key;
	      });
	    }
	  }, {
	    key: 'hasChildData',
	    value: function hasChildData(key) {
	      // Object has some built-in properties on its prototype, such as toString.  hasOwnProperty makes
	      // sure that key is present on childrenData itself, not on its prototype.
	      return Object.prototype.hasOwnProperty.call(this.childrenData, key);
	    }
	  }, {
	    key: 'getChildData',
	    value: function getChildData(key) {
	      return this.hasChildData(key) ? this.childrenData[key] : {};
	    }
	  }, {
	    key: 'setChildData',
	    value: function setChildData(key, data) {
	      this.childrenData[key] = _extends({}, this.getChildData(key), data);
	    }
	  }, {
	    key: 'removeChildData',
	    value: function removeChildData(key) {
	      delete this.childrenData[key];
	      this.setState(function (prevState) {
	        return _extends({}, prevState, {
	          children: prevState.children.filter(function (child) {
	            return child.element.key !== key;
	          })
	        });
	      });
	    }
	  }, {
	    key: 'createHeightPlaceholder',
	    value: function createHeightPlaceholder() {
	      var _this9 = this;
	
	      var typeName = this.props.typeName;
	
	      // If requested, create an invisible element at the end of the list.
	      // Its height will be modified to prevent the container from collapsing
	      // prematurely.
	
	      var isContainerAList = typeName === 'ul' || typeName === 'ol';
	      var placeholderType = isContainerAList ? 'li' : 'div';
	
	      return (0, _react.createElement)(placeholderType, {
	        key: 'height-placeholder',
	        ref: function ref(domNode) {
	          _this9.heightPlaceholderData.domNode = domNode;
	        },
	        style: { visibility: 'hidden', height: 0 }
	      });
	    }
	  }, {
	    key: 'childrenWithRefs',
	    value: function childrenWithRefs() {
	      var _this10 = this;
	
	      // We need to clone the provided children, capturing a reference to the
	      // underlying DOM node. Flip Move needs to use the React escape hatches to
	      // be able to do its calculations.
	      return this.state.children.map(function (child) {
	        return (0, _react.cloneElement)(child.element, {
	          ref: function ref(element) {
	            // Stateless Functional Components are not supported by FlipMove,
	            // because they don't have instances.
	            if (!element) {
	              return;
	            }
	
	            var domNode = (0, _domManipulation.getNativeNode)(element);
	            _this10.setChildData(getKey(child), { domNode: domNode });
	          }
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this11 = this;
	
	      var _props2 = this.props,
	          typeName = _props2.typeName,
	          delegated = _props2.delegated,
	          leaveAnimation = _props2.leaveAnimation,
	          maintainContainerHeight = _props2.maintainContainerHeight;
	
	
	      var children = this.childrenWithRefs();
	      if (leaveAnimation && maintainContainerHeight) {
	        children.push(this.createHeightPlaceholder());
	      }
	
	      var props = _extends({}, delegated, {
	        children: children,
	        ref: function ref(node) {
	          _this11.parentData.domNode = node;
	        }
	      });
	
	      return (0, _react.createElement)(typeName, props);
	    }
	  }]);
	
	  return FlipMove;
	}(_react.Component);
	
	exports.default = (0, _propConverter2.default)(FlipMove);
	module.exports = exports['default'];

/***/ }),
/* 889 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createTransitionString = exports.getNativeNode = exports.updateHeightPlaceholder = exports.removeNodeFromDOMFlow = exports.getPositionDelta = exports.getRelativeBoundingBox = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	/**
	 * React Flip Move
	 * (c) 2016-present Joshua Comeau
	 *
	 * These methods read from and write to the DOM.
	 * They almost always have side effects, and will hopefully become the
	 * only spot in the codebase with impure functions.
	 */
	
	
	exports.applyStylesToDOMNode = applyStylesToDOMNode;
	exports.whichTransitionEvent = whichTransitionEvent;
	
	var _reactDom = __webpack_require__(99);
	
	var _helpers = __webpack_require__(327);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function applyStylesToDOMNode(_ref) {
	  var domNode = _ref.domNode,
	      styles = _ref.styles;
	
	  // Can't just do an object merge because domNode.styles is no regular object.
	  // Need to do it this way for the engine to fire its `set` listeners.
	  Object.keys(styles).forEach(function (key) {
	    domNode.style.setProperty((0, _helpers.hyphenate)(key), styles[key]);
	  });
	}
	
	// Modified from Modernizr
	function whichTransitionEvent() {
	  var transitions = {
	    transition: 'transitionend',
	    '-o-transition': 'oTransitionEnd',
	    '-moz-transition': 'transitionend',
	    '-webkit-transition': 'webkitTransitionEnd'
	  };
	
	  // If we're running in a browserless environment (eg. SSR), it doesn't apply.
	  // Return a placeholder string, for consistent type return.
	  if (typeof document === 'undefined') return '';
	
	  var el = document.createElement('fakeelement');
	
	  var match = Object.keys(transitions).find(function (t) {
	    return el.style.getPropertyValue(t) !== undefined;
	  });
	
	  // If no `transition` is found, we must be running in a browser so ancient,
	  // React itself won't run. Return an empty string, for consistent type return
	  return match ? transitions[match] : '';
	}
	
	var getRelativeBoundingBox = exports.getRelativeBoundingBox = function getRelativeBoundingBox(_ref2) {
	  var childDomNode = _ref2.childDomNode,
	      parentDomNode = _ref2.parentDomNode,
	      getPosition = _ref2.getPosition;
	
	  var parentBox = getPosition(parentDomNode);
	
	  var _getPosition = getPosition(childDomNode),
	      top = _getPosition.top,
	      left = _getPosition.left,
	      right = _getPosition.right,
	      bottom = _getPosition.bottom,
	      width = _getPosition.width,
	      height = _getPosition.height;
	
	  return {
	    top: top - parentBox.top,
	    left: left - parentBox.left,
	    right: parentBox.right - right,
	    bottom: parentBox.bottom - bottom,
	    width: width,
	    height: height
	  };
	};
	
	/** getPositionDelta
	 * This method returns the delta between two bounding boxes, to figure out
	 * how many pixels on each axis the element has moved.
	 *
	 */
	var getPositionDelta = exports.getPositionDelta = function getPositionDelta(_ref3) {
	  var childDomNode = _ref3.childDomNode,
	      childBoundingBox = _ref3.childBoundingBox,
	      parentBoundingBox = _ref3.parentBoundingBox,
	      getPosition = _ref3.getPosition;
	
	  // TEMP: A mystery bug is sometimes causing unnecessary boundingBoxes to
	  var defaultBox = {
	    top: 0,
	    left: 0,
	    right: 0,
	    bottom: 0,
	    height: 0,
	    width: 0
	  };
	
	  // Our old box is its last calculated position, derived on mount or at the
	  // start of the previous animation.
	  var oldRelativeBox = childBoundingBox || defaultBox;
	  var parentBox = parentBoundingBox || defaultBox;
	
	  // Our new box is the new final resting place: Where we expect it to wind up
	  // after the animation. First we get the box in absolute terms (AKA relative
	  // to the viewport), and then we calculate its relative box (relative to the
	  // parent container)
	  var newAbsoluteBox = getPosition(childDomNode);
	  var newRelativeBox = {
	    top: newAbsoluteBox.top - parentBox.top,
	    left: newAbsoluteBox.left - parentBox.left
	  };
	
	  return [oldRelativeBox.left - newRelativeBox.left, oldRelativeBox.top - newRelativeBox.top];
	};
	
	/** removeNodeFromDOMFlow
	 * This method does something very sneaky: it removes a DOM node from the
	 * document flow, but without actually changing its on-screen position.
	 *
	 * It works by calculating where the node is, and then applying styles
	 * so that it winds up being positioned absolutely, but in exactly the
	 * same place.
	 *
	 * This is a vital part of the FLIP technique.
	 */
	var removeNodeFromDOMFlow = exports.removeNodeFromDOMFlow = function removeNodeFromDOMFlow(childData, verticalAlignment) {
	  var domNode = childData.domNode,
	      boundingBox = childData.boundingBox;
	
	
	  if (!domNode || !boundingBox) {
	    return;
	  }
	
	  // For this to work, we have to offset any given `margin`.
	  var computed = window.getComputedStyle(domNode);
	
	  // We need to clean up margins, by converting and removing suffix:
	  // eg. '21px' -> 21
	  var marginAttrs = ['margin-top', 'margin-left', 'margin-right'];
	  var margins = marginAttrs.reduce(function (acc, margin) {
	    var propertyVal = computed.getPropertyValue(margin);
	
	    return _extends({}, acc, _defineProperty({}, margin, Number(propertyVal.replace('px', ''))));
	  }, {});
	
	  // If we're bottom-aligned, we need to add the height of the child to its
	  // top offset. This is because, when the container is bottom-aligned, its
	  // height shrinks from the top, not the bottom. We're removing this node
	  // from the flow, so the top is going to drop by its height.
	  var topOffset = verticalAlignment === 'bottom' ? boundingBox.top - boundingBox.height : boundingBox.top;
	
	  var styles = {
	    position: 'absolute',
	    top: topOffset - margins['margin-top'] + 'px',
	    left: boundingBox.left - margins['margin-left'] + 'px',
	    right: boundingBox.right - margins['margin-right'] + 'px'
	  };
	
	  applyStylesToDOMNode({ domNode: domNode, styles: styles });
	};
	
	/** updateHeightPlaceholder
	 * An optional property to FlipMove is a `maintainContainerHeight` boolean.
	 * This property creates a node that fills space, so that the parent
	 * container doesn't collapse when its children are removed from the
	 * document flow.
	 */
	var updateHeightPlaceholder = exports.updateHeightPlaceholder = function updateHeightPlaceholder(_ref4) {
	  var domNode = _ref4.domNode,
	      parentData = _ref4.parentData,
	      getPosition = _ref4.getPosition;
	
	  var parentDomNode = parentData.domNode;
	  var parentBoundingBox = parentData.boundingBox;
	
	  if (!parentDomNode || !parentBoundingBox) {
	    return;
	  }
	
	  // We need to find the height of the container *without* the placeholder.
	  // Since it's possible that the placeholder might already be present,
	  // we first set its height to 0.
	  // This allows the container to collapse down to the size of just its
	  // content (plus container padding or borders if any).
	  applyStylesToDOMNode({ domNode: domNode, styles: { height: '0' } });
	
	  // Find the distance by which the container would be collapsed by elements
	  // leaving. We compare the freshly-available parent height with the original,
	  // cached container height.
	  var originalParentHeight = parentBoundingBox.height;
	  var collapsedParentHeight = getPosition(parentDomNode).height;
	  var reductionInHeight = originalParentHeight - collapsedParentHeight;
	
	  // If the container has become shorter, update the padding element's
	  // height to take up the difference. Otherwise set its height to zero,
	  // so that it has no effect.
	  var styles = {
	    height: reductionInHeight > 0 ? reductionInHeight + 'px' : '0'
	  };
	
	  applyStylesToDOMNode({ domNode: domNode, styles: styles });
	};
	
	var getNativeNode = exports.getNativeNode = function getNativeNode(element) {
	  // When running in a windowless environment, abort!
	  if (typeof HTMLElement === 'undefined') {
	    return null;
	  }
	
	  // `element` may already be a native node.
	  if (element instanceof HTMLElement) {
	    return element;
	  }
	
	  // While ReactDOM's `findDOMNode` is discouraged, it's the only
	  // publicly-exposed way to find the underlying DOM node for
	  // composite components.
	  var foundNode = (0, _reactDom.findDOMNode)(element);
	
	  if (foundNode && foundNode.nodeType === Node.TEXT_NODE) {
	    // Text nodes are not supported
	    return null;
	  }
	  // eslint-disable-next-line flowtype/no-weak-types
	  return foundNode;
	};
	
	var createTransitionString = exports.createTransitionString = function createTransitionString(index, props) {
	  var delay = props.delay,
	      duration = props.duration;
	  var staggerDurationBy = props.staggerDurationBy,
	      staggerDelayBy = props.staggerDelayBy,
	      easing = props.easing;
	
	
	  delay += index * staggerDelayBy;
	  duration += index * staggerDurationBy;
	
	  var cssProperties = ['transform', 'opacity'];
	
	  return cssProperties.map(function (prop) {
	    return prop + ' ' + duration + 'ms ' + easing + ' ' + delay + 'ms';
	  }).join(', ');
	};

/***/ }),
/* 890 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var enterPresets = exports.enterPresets = {
	  elevator: {
	    from: { transform: 'scale(0)', opacity: '0' },
	    to: { transform: '', opacity: '' }
	  },
	  fade: {
	    from: { opacity: '0' },
	    to: { opacity: '' }
	  },
	  accordionVertical: {
	    from: { transform: 'scaleY(0)', transformOrigin: 'center top' },
	    to: { transform: '', transformOrigin: 'center top' }
	  },
	  accordionHorizontal: {
	    from: { transform: 'scaleX(0)', transformOrigin: 'left center' },
	    to: { transform: '', transformOrigin: 'left center' }
	  },
	  none: null
	};
	/**
	 * React Flip Move | enterLeavePresets
	 * (c) 2016-present Joshua Comeau
	 *
	 * This contains the master list of presets available for enter/leave animations,
	 * along with the mapping between preset and styles.
	 */
	var leavePresets = exports.leavePresets = {
	  elevator: {
	    from: { transform: 'scale(1)', opacity: '1' },
	    to: { transform: 'scale(0)', opacity: '0' }
	  },
	  fade: {
	    from: { opacity: '1' },
	    to: { opacity: '0' }
	  },
	  accordionVertical: {
	    from: { transform: 'scaleY(1)', transformOrigin: 'center top' },
	    to: { transform: 'scaleY(0)', transformOrigin: 'center top' }
	  },
	  accordionHorizontal: {
	    from: { transform: 'scaleX(1)', transformOrigin: 'left center' },
	    to: { transform: 'scaleX(0)', transformOrigin: 'left center' }
	  },
	  none: null
	};
	
	// For now, appearPresets will be identical to enterPresets.
	// Assigning a custom export in case we ever want to add appear-specific ones.
	var appearPresets = exports.appearPresets = enterPresets;
	
	// Embarrassingly enough, v2.0 launched with typo'ed preset names.
	// To avoid penning a new major version over something so inconsequential,
	// we're supporting both spellings. In a future version, these alternatives
	// may be deprecated.
	// $FlowFixMe
	enterPresets.accordianVertical = enterPresets.accordionVertical;
	// $FlowFixMe
	enterPresets.accordianHorizontal = enterPresets.accordionHorizontal;
	// $FlowFixMe
	leavePresets.accordianVertical = leavePresets.accordionVertical;
	// $FlowFixMe
	leavePresets.accordianHorizontal = leavePresets.accordionHorizontal;
	
	var defaultPreset = exports.defaultPreset = 'elevator';
	var disablePreset = exports.disablePreset = 'none';

/***/ }),
/* 891 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	function warnOnce(msg) {
	  var hasWarned = false;
	  return function () {
	    if (!hasWarned) {
	      console.warn(msg);
	      hasWarned = true;
	    }
	  };
	}
	var statelessFunctionalComponentSupplied = exports.statelessFunctionalComponentSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a stateless functional component as a child to <FlipMove>. Unfortunately, SFCs aren\'t supported, because Flip Move needs access to the backing instances via refs, and SFCs don\'t have a public instance that holds that info.\n\nPlease wrap your components in a native element (eg. <div>), or a non-functional component.\n');
	
	var primitiveNodeSupplied = exports.primitiveNodeSupplied = warnOnce('\n>> Error, via react-flip-move <<\n\nYou provided a primitive (text or number) node as a child to <FlipMove>. Flip Move needs containers with unique keys to move children around.\n\nPlease wrap your value in a native element (eg. <span>), or a component.\n');
	
	var invalidTypeForTimingProp = exports.invalidTypeForTimingProp = function invalidTypeForTimingProp(args) {
	  return console.error('\n>> Error, via react-flip-move <<\n\nThe prop you provided for \'' + args.prop + '\' is invalid. It needs to be a positive integer, or a string that can be resolved to a number. The value you provided is \'' + args.value + '\'.\n\nAs a result,  the default value for this parameter will be used, which is \'' + args.defaultValue + '\'.\n');
	};
	
	var deprecatedDisableAnimations = exports.deprecatedDisableAnimations = warnOnce('\n>> Warning, via react-flip-move <<\n\nThe \'disableAnimations\' prop you provided is deprecated. Please switch to use \'disableAllAnimations\'.\n\nThis will become a silent error in future versions of react-flip-move.\n');
	
	var invalidEnterLeavePreset = exports.invalidEnterLeavePreset = function invalidEnterLeavePreset(args) {
	  return console.error('\n>> Error, via react-flip-move <<\n\nThe enter/leave preset you provided is invalid. We don\'t currently have a \'' + args.value + ' preset.\'\n\nAcceptable values are ' + args.acceptableValues + '. The default value of \'' + args.defaultValue + '\' will be used.\n');
	};

/***/ }),
/* 892 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _FlipMove = __webpack_require__(888);
	
	var _FlipMove2 = _interopRequireDefault(_FlipMove);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlipMove2.default;
	/**
	 * React Flip Move
	 * (c) 2016-present Joshua Comeau
	 */
	
	module.exports = exports['default'];

/***/ }),
/* 893 */
/***/ (function(module, exports) {

	'use strict';
	
	// @noflow
	/**
	 * React Flip Move - Polyfills
	 * (c) 2016-present Joshua Comeau
	 */
	
	/* eslint-disable */
	
	if (!Array.prototype.find) {
	  Array.prototype.find = function (predicate) {
	    if (this === null) {
	      throw new TypeError('Array.prototype.find called on null or undefined');
	    }
	    if (typeof predicate !== 'function') {
	      throw new TypeError('predicate must be a function');
	    }
	    var list = Object(this);
	    var length = list.length >>> 0;
	    var thisArg = arguments[1];
	    var value = void 0;
	
	    for (var i = 0; i < length; i++) {
	      value = list[i];
	      if (predicate.call(thisArg, value, i, list)) {
	        return value;
	      }
	    }
	    return undefined;
	  };
	}
	
	if (!Array.prototype.every) {
	  Array.prototype.every = function (callbackfn, thisArg) {
	    'use strict';
	
	    var T, k;
	
	    if (this == null) {
	      throw new TypeError('this is null or not defined');
	    }
	
	    var O = Object(this);
	    var len = O.length >>> 0;
	
	    if (typeof callbackfn !== 'function') {
	      throw new TypeError();
	    }
	
	    if (arguments.length > 1) {
	      T = thisArg;
	    }
	
	    k = 0;
	
	    while (k < len) {
	
	      var kValue;
	
	      if (k in O) {
	        kValue = O[k];
	
	        var testResult = callbackfn.call(T, kValue, k, O);
	
	        if (!testResult) {
	          return false;
	        }
	      }
	      k++;
	    }
	    return true;
	  };
	}
	
	if (!Array.isArray) {
	  Array.isArray = function (arg) {
	    return Object.prototype.toString.call(arg) === '[object Array]';
	  };
	}

/***/ }),
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _errorMessages = __webpack_require__(891);
	
	var _enterLeavePresets = __webpack_require__(890);
	
	var _helpers = __webpack_require__(327);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	/**
	 * React Flip Move | propConverter
	 * (c) 2016-present Joshua Comeau
	 *
	 * Abstracted away a bunch of the messy business with props.
	 *   - props flow types and defaultProps
	 *   - Type conversion (We accept 'string' and 'number' values for duration,
	 *     delay, and other fields, but we actually need them to be ints.)
	 *   - Children conversion (we need the children to be an array. May not always
	 *     be, if a single child is passed in.)
	 *   - Resolving animation presets into their base CSS styles
	 */
	/* eslint-disable block-scoped-var */
	
	// eslint-disable-next-line no-duplicate-imports
	
	
	function isProduction() {
	  try {
	    return ("production") === 'production';
	  } catch (e) {
	    return false;
	  }
	}
	
	function propConverter(ComposedComponent) {
	  var _class, _temp;
	
	  return _temp = _class = function (_Component) {
	    _inherits(FlipMovePropConverter, _Component);
	
	    function FlipMovePropConverter() {
	      _classCallCheck(this, FlipMovePropConverter);
	
	      return _possibleConstructorReturn(this, (FlipMovePropConverter.__proto__ || Object.getPrototypeOf(FlipMovePropConverter)).apply(this, arguments));
	    }
	
	    _createClass(FlipMovePropConverter, [{
	      key: 'checkChildren',
	
	
	      // eslint-disable-next-line class-methods-use-this
	      value: function checkChildren(children) {
	        // Skip all console warnings in production.
	        // Bail early, to avoid unnecessary work.
	        if (isProduction()) {
	          return;
	        }
	
	        // same as React.Node, but without fragments, see https://github.com/facebook/flow/issues/4781
	
	
	        // FlipMove does not support stateless functional components.
	        // Check to see if any supplied components won't work.
	        // If the child doesn't have a key, it means we aren't animating it.
	        // It's allowed to be an SFC, since we ignore it.
	        _react.Children.forEach(children, function (child) {
	          // null, undefined, and booleans will be filtered out by Children.toArray
	          if (child == null || typeof child === 'boolean') {
	            return;
	          }
	
	          if ((typeof child === 'undefined' ? 'undefined' : _typeof(child)) !== 'object') {
	            (0, _errorMessages.primitiveNodeSupplied)();
	            return;
	          }
	
	          if ((0, _helpers.isElementAnSFC)(child) && child.key != null) {
	            (0, _errorMessages.statelessFunctionalComponentSupplied)();
	          }
	        });
	      }
	    }, {
	      key: 'convertProps',
	      value: function convertProps(props) {
	        var workingProps = {
	          // explicitly bypass the props that don't need conversion
	          children: props.children,
	          easing: props.easing,
	          onStart: props.onStart,
	          onFinish: props.onFinish,
	          onStartAll: props.onStartAll,
	          onFinishAll: props.onFinishAll,
	          typeName: props.typeName,
	          disableAllAnimations: props.disableAllAnimations,
	          getPosition: props.getPosition,
	          maintainContainerHeight: props.maintainContainerHeight,
	          verticalAlignment: props.verticalAlignment,
	
	          // Do string-to-int conversion for all timing-related props
	          duration: this.convertTimingProp('duration'),
	          delay: this.convertTimingProp('delay'),
	          staggerDurationBy: this.convertTimingProp('staggerDurationBy'),
	          staggerDelayBy: this.convertTimingProp('staggerDelayBy'),
	
	          // Our enter/leave animations can be specified as boolean (default or
	          // disabled), string (preset name), or object (actual animation values).
	          // Let's standardize this so that they're always objects
	          appearAnimation: this.convertAnimationProp(props.appearAnimation, _enterLeavePresets.appearPresets),
	          enterAnimation: this.convertAnimationProp(props.enterAnimation, _enterLeavePresets.enterPresets),
	          leaveAnimation: this.convertAnimationProp(props.leaveAnimation, _enterLeavePresets.leavePresets),
	
	          delegated: {}
	        };
	
	        this.checkChildren(workingProps.children);
	
	        // Accept `disableAnimations`, but add a deprecation warning
	        if (typeof props.disableAnimations !== 'undefined') {
	          workingProps.disableAllAnimations = props.disableAnimations;
	
	          if (!isProduction()) {
	            (0, _errorMessages.deprecatedDisableAnimations)();
	          }
	        }
	
	        // Gather any additional props;
	        // they will be delegated to the ReactElement created.
	        var primaryPropKeys = Object.keys(workingProps);
	        var delegatedProps = (0, _helpers.omit)(this.props, primaryPropKeys);
	
	        // The FlipMove container element needs to have a non-static position.
	        // We use `relative` by default, but it can be overridden by the user.
	        // Now that we're delegating props, we need to merge this in.
	        delegatedProps.style = _extends({
	          position: 'relative'
	        }, delegatedProps.style);
	
	        workingProps.delegated = delegatedProps;
	
	        return workingProps;
	      }
	    }, {
	      key: 'convertTimingProp',
	      value: function convertTimingProp(prop) {
	        var rawValue = this.props[prop];
	
	        var value = typeof rawValue === 'number' ? rawValue : parseInt(rawValue, 10);
	
	        if (isNaN(value)) {
	          var defaultValue = FlipMovePropConverter.defaultProps[prop];
	
	          if (!isProduction()) {
	            (0, _errorMessages.invalidTypeForTimingProp)({
	              prop: prop,
	              value: rawValue,
	              defaultValue: defaultValue
	            });
	          }
	
	          return defaultValue;
	        }
	
	        return value;
	      }
	
	      // eslint-disable-next-line class-methods-use-this
	
	    }, {
	      key: 'convertAnimationProp',
	      value: function convertAnimationProp(animation, presets) {
	        switch (typeof animation === 'undefined' ? 'undefined' : _typeof(animation)) {
	          case 'boolean':
	            {
	              // If it's true, we want to use the default preset.
	              // If it's false, we want to use the 'none' preset.
	              return presets[animation ? _enterLeavePresets.defaultPreset : _enterLeavePresets.disablePreset];
	            }
	
	          case 'string':
	            {
	              var presetKeys = Object.keys(presets);
	
	              if (presetKeys.indexOf(animation) === -1) {
	                if (!isProduction()) {
	                  (0, _errorMessages.invalidEnterLeavePreset)({
	                    value: animation,
	                    acceptableValues: presetKeys.filter(function (key) {
	                      return key.indexOf('accordian') === -1;
	                    }).join(', '),
	                    defaultValue: _enterLeavePresets.defaultPreset
	                  });
	                }
	
	                return presets[_enterLeavePresets.defaultPreset];
	              }
	
	              return presets[animation];
	            }
	
	          default:
	            {
	              return animation;
	            }
	        }
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        return _react2.default.createElement(ComposedComponent, this.convertProps(this.props));
	      }
	    }]);
	
	    return FlipMovePropConverter;
	  }(_react.Component), _class.defaultProps = {
	    easing: 'ease-in-out',
	    duration: 350,
	    delay: 0,
	    staggerDurationBy: 0,
	    staggerDelayBy: 0,
	    typeName: 'div',
	    enterAnimation: _enterLeavePresets.defaultPreset,
	    leaveAnimation: _enterLeavePresets.defaultPreset,
	    disableAllAnimations: false,
	    getPosition: function getPosition(node) {
	      return node.getBoundingClientRect();
	    },
	    maintainContainerHeight: false,
	    verticalAlignment: 'top'
	  }, _temp;
	}
	
	exports.default = propConverter;
	module.exports = exports['default'];

/***/ }),
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(63);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(400);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(407);
	
	var _warning = __webpack_require__(328);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(405);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(910);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(904);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(905);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(906);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(907);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ }),
/* 904 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(224);
	
	var _wrapMapToProps = __webpack_require__(406);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ }),
/* 905 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(406);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(408);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ }),
/* 907 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(908);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ }),
/* 908 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(328);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ }),
/* 910 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ }),
/* 911 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(317);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(329);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ }),
/* 912 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(383);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(329);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ }),
/* 913 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(920);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 914 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(410);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(409);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ }),
/* 915 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(921);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 916 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(922);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 917 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(923);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 918 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(924);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 919 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(332);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ }),
/* 920 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(384);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(331);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ }),
/* 921 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ }),
/* 922 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(728);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ }),
/* 923 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(94);
	
	var _Router = __webpack_require__(331);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ }),
/* 924 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(16);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(332);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ }),
/* 925 */
/***/ (function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ }),
/* 926 */
/***/ (function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(731)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ }),
/* 927 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(280);
	
	var invariant = __webpack_require__(35);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(63);
	
	var ReactBaseClasses = __webpack_require__(412);
	var ReactChildren = __webpack_require__(930);
	var ReactDOMFactories = __webpack_require__(931);
	var ReactElement = __webpack_require__(100);
	var ReactPropTypes = __webpack_require__(932);
	var ReactVersion = __webpack_require__(933);
	
	var createReactClass = __webpack_require__(934);
	var onlyChild = __webpack_require__(937);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ }),
/* 930 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(928);
	var ReactElement = __webpack_require__(100);
	
	var emptyFunction = __webpack_require__(69);
	var traverseAllChildren = __webpack_require__(938);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(100);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ }),
/* 932 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(100),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(873);
	
	module.exports = factory(isValidElement);

/***/ }),
/* 933 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(412),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(100),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(415);
	var factory = __webpack_require__(378);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 935 */
/***/ (function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ }),
/* 936 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ }),
/* 937 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(280);
	
	var ReactElement = __webpack_require__(100);
	
	var invariant = __webpack_require__(35);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ }),
/* 938 */
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(280);
	
	var ReactCurrentOwner = __webpack_require__(413);
	var REACT_ELEMENT_TYPE = __webpack_require__(414);
	
	var getIteratorFn = __webpack_require__(935);
	var invariant = __webpack_require__(35);
	var KeyEscapeUtils = __webpack_require__(927);
	var warning = __webpack_require__(261);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(64);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(925);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(411);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ }),
/* 940 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(380);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(952);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),
/* 941 */,
/* 942 */,
/* 943 */,
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

	/*
	 React v16.0.0
	 react.production.min.js
	
	 Copyright (c) 2013-present, Facebook, Inc.
	
	 This source code is licensed under the MIT license found in the
	 LICENSE file in the root directory of this source tree.
	*/
	'use strict';var f=__webpack_require__(63),p=__webpack_require__(260);__webpack_require__(35);var r=__webpack_require__(69);
	function t(a){for(var b=arguments.length-1,d="Minified React error #"+a+"; visit http://facebook.github.io/react/docs/error-decoder.html?invariant\x3d"+a,e=0;e<b;e++)d+="\x26args[]\x3d"+encodeURIComponent(arguments[e+1]);b=Error(d+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings.");b.name="Invariant Violation";b.framesToPop=1;throw b;}
	var u={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}};function v(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}v.prototype.isReactComponent={};v.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?t("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};v.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
	function w(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}function x(){}x.prototype=v.prototype;var y=w.prototype=new x;y.constructor=w;f(y,v.prototype);y.isPureReactComponent=!0;function z(a,b,d){this.props=a;this.context=b;this.refs=p;this.updater=d||u}var A=z.prototype=new x;A.constructor=z;f(A,v.prototype);A.unstable_isAsyncReactComponent=!0;A.render=function(){return this.props.children};
	var B={Component:v,PureComponent:w,AsyncComponent:z},C={current:null},D=Object.prototype.hasOwnProperty,E="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103,F={key:!0,ref:!0,__self:!0,__source:!0};function G(a,b,d,e,c,g,k){return{$$typeof:E,type:a,key:b,ref:d,props:k,_owner:g}}
	G.createElement=function(a,b,d){var e,c={},g=null,k=null,m=null,q=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),m=void 0===b.__self?null:b.__self,q=void 0===b.__source?null:b.__source,b)D.call(b,e)&&!F.hasOwnProperty(e)&&(c[e]=b[e]);var l=arguments.length-2;if(1===l)c.children=d;else if(1<l){for(var h=Array(l),n=0;n<l;n++)h[n]=arguments[n+2];c.children=h}if(a&&a.defaultProps)for(e in l=a.defaultProps,l)void 0===c[e]&&(c[e]=l[e]);return G(a,g,k,m,q,C.current,c)};
	G.createFactory=function(a){var b=G.createElement.bind(null,a);b.type=a;return b};G.cloneAndReplaceKey=function(a,b){return G(a.type,b,a.ref,a._self,a._source,a._owner,a.props)};
	G.cloneElement=function(a,b,d){var e=f({},a.props),c=a.key,g=a.ref,k=a._self,m=a._source,q=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,q=C.current);void 0!==b.key&&(c=""+b.key);if(a.type&&a.type.defaultProps)var l=a.type.defaultProps;for(h in b)D.call(b,h)&&!F.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==l?l[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=d;else if(1<h){l=Array(h);for(var n=0;n<h;n++)l[n]=arguments[n+2];e.children=l}return G(a.type,c,g,k,m,q,e)};
	G.isValidElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===E};var H="function"===typeof Symbol&&Symbol.iterator,I="function"===typeof Symbol&&Symbol["for"]&&Symbol["for"]("react.element")||60103;function escape(a){var b={"\x3d":"\x3d0",":":"\x3d2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var J=/\/+/g,K=[];
	function L(a,b,d,e){if(K.length){var c=K.pop();c.result=a;c.keyPrefix=b;c.func=d;c.context=e;c.count=0;return c}return{result:a,keyPrefix:b,func:d,context:e,count:0}}function M(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>K.length&&K.push(a)}
	function N(a,b,d,e){var c=typeof a;if("undefined"===c||"boolean"===c)a=null;if(null===a||"string"===c||"number"===c||"object"===c&&a.$$typeof===I)return d(e,a,""===b?"."+O(a,0):b),1;var g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){c=a[k];var m=b+O(c,k);g+=N(c,m,d,e)}else if(m=H&&a[H]||a["@@iterator"],"function"===typeof m)for(a=m.call(a),k=0;!(c=a.next()).done;)c=c.value,m=b+O(c,k++),g+=N(c,m,d,e);else"object"===c&&(d=""+a,t("31","[object Object]"===d?"object with keys {"+
	Object.keys(a).join(", ")+"}":d,""));return g}function O(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function P(a,b){a.func.call(a.context,b,a.count++)}function Q(a,b,d){var e=a.result,c=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?R(a,e,d,r.thatReturnsArgument):null!=a&&(G.isValidElement(a)&&(a=G.cloneAndReplaceKey(a,c+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(J,"$\x26/")+"/")+d)),e.push(a))}
	function R(a,b,d,e,c){var g="";null!=d&&(g=(""+d).replace(J,"$\x26/")+"/");b=L(b,g,e,c);null==a||N(a,"",Q,b);M(b)}var S={forEach:function(a,b,d){if(null==a)return a;b=L(null,null,b,d);null==a||N(a,"",P,b);M(b)},map:function(a,b,d){if(null==a)return a;var e=[];R(a,e,null,b,d);return e},count:function(a){return null==a?0:N(a,"",r.thatReturnsNull,null)},toArray:function(a){var b=[];R(a,b,null,r.thatReturnsArgument);return b}};
	module.exports={Children:{map:S.map,forEach:S.forEach,count:S.count,toArray:S.toArray,only:function(a){G.isValidElement(a)?void 0:t("143");return a}},Component:B.Component,PureComponent:B.PureComponent,unstable_AsyncComponent:B.AsyncComponent,createElement:G.createElement,cloneElement:G.cloneElement,isValidElement:G.isValidElement,createFactory:G.createFactory,version:"16.0.0",__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentOwner:C,assign:f}};


/***/ }),
/* 945 */,
/* 946 */,
/* 947 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(419);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ }),
/* 949 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(420);
	
	var _isPlainObject = __webpack_require__(326);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(421);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ }),
/* 950 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _off = __webpack_require__(587);
	
	var _off2 = _interopRequireDefault(_off);
	
	var _on = __webpack_require__(588);
	
	var _on2 = _interopRequireDefault(_on);
	
	var _scrollLeft = __webpack_require__(589);
	
	var _scrollLeft2 = _interopRequireDefault(_scrollLeft);
	
	var _scrollTop = __webpack_require__(590);
	
	var _scrollTop2 = _interopRequireDefault(_scrollTop);
	
	var _requestAnimationFrame = __webpack_require__(591);
	
	var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);
	
	var _invariant = __webpack_require__(21);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /* eslint-disable no-underscore-dangle */
	
	// Try at most this many times to scroll, to avoid getting stuck.
	var MAX_SCROLL_ATTEMPTS = 2;
	
	var ScrollBehavior = function () {
	  function ScrollBehavior(_ref) {
	    var _this = this;
	
	    var addTransitionHook = _ref.addTransitionHook,
	        stateStorage = _ref.stateStorage,
	        getCurrentLocation = _ref.getCurrentLocation,
	        shouldUpdateScroll = _ref.shouldUpdateScroll;
	
	    _classCallCheck(this, ScrollBehavior);
	
	    this._onWindowScroll = function () {
	      // It's possible that this scroll operation was triggered by what will be a
	      // `POP` transition. Instead of updating the saved location immediately, we
	      // have to enqueue the update, then potentially cancel it if we observe a
	      // location update.
	      if (!_this._saveWindowPositionHandle) {
	        _this._saveWindowPositionHandle = (0, _requestAnimationFrame2.default)(_this._saveWindowPosition);
	      }
	
	      if (_this._windowScrollTarget) {
	        var _windowScrollTarget = _this._windowScrollTarget,
	            xTarget = _windowScrollTarget[0],
	            yTarget = _windowScrollTarget[1];
	
	        var x = (0, _scrollLeft2.default)(window);
	        var y = (0, _scrollTop2.default)(window);
	
	        if (x === xTarget && y === yTarget) {
	          _this._windowScrollTarget = null;
	          _this._cancelCheckWindowScroll();
	        }
	      }
	    };
	
	    this._saveWindowPosition = function () {
	      _this._saveWindowPositionHandle = null;
	
	      _this._savePosition(null, window);
	    };
	
	    this._checkWindowScrollPosition = function () {
	      _this._checkWindowScrollHandle = null;
	
	      // We can only get here if scrollTarget is set. Every code path that unsets
	      // scroll target also cancels the handle to avoid calling this handler.
	      // Still, check anyway just in case.
	      /* istanbul ignore if: paranoid guard */
	      if (!_this._windowScrollTarget) {
	        return;
	      }
	
	      _this.scrollToTarget(window, _this._windowScrollTarget);
	
	      ++_this._numWindowScrollAttempts;
	
	      /* istanbul ignore if: paranoid guard */
	      if (_this._numWindowScrollAttempts >= MAX_SCROLL_ATTEMPTS) {
	        _this._windowScrollTarget = null;
	        return;
	      }
	
	      _this._checkWindowScrollHandle = (0, _requestAnimationFrame2.default)(_this._checkWindowScrollPosition);
	    };
	
	    this._stateStorage = stateStorage;
	    this._getCurrentLocation = getCurrentLocation;
	    this._shouldUpdateScroll = shouldUpdateScroll;
	
	    // This helps avoid some jankiness in fighting against the browser's
	    // default scroll behavior on `POP` transitions.
	    /* istanbul ignore else: Travis browsers all support this */
	    if ('scrollRestoration' in window.history) {
	      this._oldScrollRestoration = window.history.scrollRestoration;
	      window.history.scrollRestoration = 'manual';
	    } else {
	      this._oldScrollRestoration = null;
	    }
	
	    this._saveWindowPositionHandle = null;
	    this._checkWindowScrollHandle = null;
	    this._windowScrollTarget = null;
	    this._numWindowScrollAttempts = 0;
	
	    this._scrollElements = {};
	
	    // We have to listen to each window scroll update rather than to just
	    // location updates, because some browsers will update scroll position
	    // before emitting the location change.
	    (0, _on2.default)(window, 'scroll', this._onWindowScroll);
	
	    this._removeTransitionHook = addTransitionHook(function () {
	      _requestAnimationFrame2.default.cancel(_this._saveWindowPositionHandle);
	      _this._saveWindowPositionHandle = null;
	
	      Object.keys(_this._scrollElements).forEach(function (key) {
	        var scrollElement = _this._scrollElements[key];
	        _requestAnimationFrame2.default.cancel(scrollElement.savePositionHandle);
	        scrollElement.savePositionHandle = null;
	
	        // It's fine to save element scroll positions here, though; the browser
	        // won't modify them.
	        _this._saveElementPosition(key);
	      });
	    });
	  }
	
	  ScrollBehavior.prototype.registerElement = function registerElement(key, element, shouldUpdateScroll, context) {
	    var _this2 = this;
	
	    !!this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is already an element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    var saveElementPosition = function saveElementPosition() {
	      _this2._saveElementPosition(key);
	    };
	
	    var scrollElement = {
	      element: element,
	      shouldUpdateScroll: shouldUpdateScroll,
	      savePositionHandle: null,
	
	      onScroll: function onScroll() {
	        if (!scrollElement.savePositionHandle) {
	          scrollElement.savePositionHandle = (0, _requestAnimationFrame2.default)(saveElementPosition);
	        }
	      }
	    };
	
	    this._scrollElements[key] = scrollElement;
	    (0, _on2.default)(element, 'scroll', scrollElement.onScroll);
	
	    this._updateElementScroll(key, null, context);
	  };
	
	  ScrollBehavior.prototype.unregisterElement = function unregisterElement(key) {
	    !this._scrollElements[key] ?  false ? (0, _invariant2.default)(false, 'ScrollBehavior: There is no element registered for `%s`.', key) : (0, _invariant2.default)(false) : void 0;
	
	    var _scrollElements$key = this._scrollElements[key],
	        element = _scrollElements$key.element,
	        onScroll = _scrollElements$key.onScroll,
	        savePositionHandle = _scrollElements$key.savePositionHandle;
	
	
	    (0, _off2.default)(element, 'scroll', onScroll);
	    _requestAnimationFrame2.default.cancel(savePositionHandle);
	
	    delete this._scrollElements[key];
	  };
	
	  ScrollBehavior.prototype.updateScroll = function updateScroll(prevContext, context) {
	    var _this3 = this;
	
	    this._updateWindowScroll(prevContext, context);
	
	    Object.keys(this._scrollElements).forEach(function (key) {
	      _this3._updateElementScroll(key, prevContext, context);
	    });
	  };
	
	  ScrollBehavior.prototype.stop = function stop() {
	    /* istanbul ignore if: not supported by any browsers on Travis */
	    if (this._oldScrollRestoration) {
	      window.history.scrollRestoration = this._oldScrollRestoration;
	    }
	
	    (0, _off2.default)(window, 'scroll', this._onWindowScroll);
	    this._cancelCheckWindowScroll();
	
	    this._removeTransitionHook();
	  };
	
	  ScrollBehavior.prototype._cancelCheckWindowScroll = function _cancelCheckWindowScroll() {
	    _requestAnimationFrame2.default.cancel(this._checkWindowScrollHandle);
	    this._checkWindowScrollHandle = null;
	  };
	
	  ScrollBehavior.prototype._saveElementPosition = function _saveElementPosition(key) {
	    var scrollElement = this._scrollElements[key];
	    scrollElement.savePositionHandle = null;
	
	    this._savePosition(key, scrollElement.element);
	  };
	
	  ScrollBehavior.prototype._savePosition = function _savePosition(key, element) {
	    this._stateStorage.save(this._getCurrentLocation(), key, [(0, _scrollLeft2.default)(element), (0, _scrollTop2.default)(element)]);
	  };
	
	  ScrollBehavior.prototype._updateWindowScroll = function _updateWindowScroll(prevContext, context) {
	    // Whatever we were doing before isn't relevant any more.
	    this._cancelCheckWindowScroll();
	
	    this._windowScrollTarget = this._getScrollTarget(null, this._shouldUpdateScroll, prevContext, context);
	
	    // Updating the window scroll position is really flaky. Just trying to
	    // scroll it isn't enough. Instead, try to scroll a few times until it
	    // works.
	    this._numWindowScrollAttempts = 0;
	    this._checkWindowScrollPosition();
	  };
	
	  ScrollBehavior.prototype._updateElementScroll = function _updateElementScroll(key, prevContext, context) {
	    var _scrollElements$key2 = this._scrollElements[key],
	        element = _scrollElements$key2.element,
	        shouldUpdateScroll = _scrollElements$key2.shouldUpdateScroll;
	
	
	    var scrollTarget = this._getScrollTarget(key, shouldUpdateScroll, prevContext, context);
	    if (!scrollTarget) {
	      return;
	    }
	
	    // Unlike with the window, there shouldn't be any flakiness to deal with
	    // here.
	    this.scrollToTarget(element, scrollTarget);
	  };
	
	  ScrollBehavior.prototype._getDefaultScrollTarget = function _getDefaultScrollTarget(location) {
	    var hash = location.hash;
	    if (hash && hash !== '#') {
	      return hash.charAt(0) === '#' ? hash.slice(1) : hash;
	    }
	    return [0, 0];
	  };
	
	  ScrollBehavior.prototype._getScrollTarget = function _getScrollTarget(key, shouldUpdateScroll, prevContext, context) {
	    var scrollTarget = shouldUpdateScroll ? shouldUpdateScroll.call(this, prevContext, context) : true;
	
	    if (!scrollTarget || Array.isArray(scrollTarget) || typeof scrollTarget === 'string') {
	      return scrollTarget;
	    }
	
	    var location = this._getCurrentLocation();
	
	    return this._getSavedScrollTarget(key, location) || this._getDefaultScrollTarget(location);
	  };
	
	  ScrollBehavior.prototype._getSavedScrollTarget = function _getSavedScrollTarget(key, location) {
	    if (location.action === 'PUSH') {
	      return null;
	    }
	
	    return this._stateStorage.read(location, key);
	  };
	
	  ScrollBehavior.prototype.scrollToTarget = function scrollToTarget(element, target) {
	    if (typeof target === 'string') {
	      var targetElement = document.getElementById(target) || document.getElementsByName(target)[0];
	      if (targetElement) {
	        targetElement.scrollIntoView();
	        return;
	      }
	
	      // Fallback to scrolling to top when target fragment doesn't exist.
	      target = [0, 0]; // eslint-disable-line no-param-reassign
	    }
	
	    var _target = target,
	        left = _target[0],
	        top = _target[1];
	
	    (0, _scrollLeft2.default)(element, left);
	    (0, _scrollTop2.default)(element, top);
	  };
	
	  return ScrollBehavior;
	}();
	
	exports.default = ScrollBehavior;
	module.exports = exports['default'];

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var fetchKeys = __webpack_require__(812);
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if (ret !== void 0) {
	        return !!ret;
	    }
	
	    if (objA === objB) {
	        return true;
	    }
	
	    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	        return false;
	    }
	
	    var keysA = fetchKeys(objA);
	    var keysB = fetchKeys(objB);
	
	    var len = keysA.length;
	    if (len !== keysB.length) {
	        return false;
	    }
	
	    compareContext = compareContext || null;
	
	    // Test for A's keys different from B.
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	    for (var i = 0; i < len; i++) {
	        var key = keysA[i];
	        if (!bHasOwnProperty(key)) {
	            return false;
	        }
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        var _ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	        if (_ret === false || _ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	    }
	
	    return true;
	};

/***/ }),
/* 953 */
/***/ (function(module, exports, __webpack_require__) {

	
	;(function (name, root, factory) {
	  if (true) {
	    module.exports = factory()
	  }
	  /* istanbul ignore next */
	  else if (typeof define === 'function' && define.amd) {
	    define(factory)
	  }
	  else {
	    root[name] = factory()
	  }
	}('slugify', this, function () {
	  var charMap = {
	    // latin
	    'À': 'A', 'Á': 'A', 'Â': 'A', 'Ã': 'A', 'Ä': 'A', 'Å': 'A', 'Æ': 'AE',
	    'Ç': 'C', 'È': 'E', 'É': 'E', 'Ê': 'E', 'Ë': 'E', 'Ì': 'I', 'Í': 'I',
	    'Î': 'I', 'Ï': 'I', 'Ð': 'D', 'Ñ': 'N', 'Ò': 'O', 'Ó': 'O', 'Ô': 'O',
	    'Õ': 'O', 'Ö': 'O', 'Ő': 'O', 'Ø': 'O', 'Ù': 'U', 'Ú': 'U', 'Û': 'U',
	    'Ü': 'U', 'Ű': 'U', 'Ý': 'Y', 'Þ': 'TH', 'ß': 'ss', 'à': 'a', 'á': 'a',
	    'â': 'a', 'ã': 'a', 'ä': 'a', 'å': 'a', 'æ': 'ae', 'ç': 'c', 'è': 'e',
	    'é': 'e', 'ê': 'e', 'ë': 'e', 'ì': 'i', 'í': 'i', 'î': 'i', 'ï': 'i',
	    'ð': 'd', 'ñ': 'n', 'ò': 'o', 'ó': 'o', 'ô': 'o', 'õ': 'o', 'ö': 'o',
	    'ő': 'o', 'ø': 'o', 'ù': 'u', 'ú': 'u', 'û': 'u', 'ü': 'u', 'ű': 'u',
	    'ý': 'y', 'þ': 'th', 'ÿ': 'y', 'ẞ': 'SS',
	    // greek
	    'α': 'a', 'β': 'b', 'γ': 'g', 'δ': 'd', 'ε': 'e', 'ζ': 'z', 'η': 'h', 'θ': '8',
	    'ι': 'i', 'κ': 'k', 'λ': 'l', 'μ': 'm', 'ν': 'n', 'ξ': '3', 'ο': 'o', 'π': 'p',
	    'ρ': 'r', 'σ': 's', 'τ': 't', 'υ': 'y', 'φ': 'f', 'χ': 'x', 'ψ': 'ps', 'ω': 'w',
	    'ά': 'a', 'έ': 'e', 'ί': 'i', 'ό': 'o', 'ύ': 'y', 'ή': 'h', 'ώ': 'w', 'ς': 's',
	    'ϊ': 'i', 'ΰ': 'y', 'ϋ': 'y', 'ΐ': 'i',
	    'Α': 'A', 'Β': 'B', 'Γ': 'G', 'Δ': 'D', 'Ε': 'E', 'Ζ': 'Z', 'Η': 'H', 'Θ': '8',
	    'Ι': 'I', 'Κ': 'K', 'Λ': 'L', 'Μ': 'M', 'Ν': 'N', 'Ξ': '3', 'Ο': 'O', 'Π': 'P',
	    'Ρ': 'R', 'Σ': 'S', 'Τ': 'T', 'Υ': 'Y', 'Φ': 'F', 'Χ': 'X', 'Ψ': 'PS', 'Ω': 'W',
	    'Ά': 'A', 'Έ': 'E', 'Ί': 'I', 'Ό': 'O', 'Ύ': 'Y', 'Ή': 'H', 'Ώ': 'W', 'Ϊ': 'I',
	    'Ϋ': 'Y',
	    // turkish
	    'ş': 's', 'Ş': 'S', 'ı': 'i', 'İ': 'I', 'ç': 'c', 'Ç': 'C', 'ü': 'u', 'Ü': 'U',
	    'ö': 'o', 'Ö': 'O', 'ğ': 'g', 'Ğ': 'G',
	    // russian
	    'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo', 'ж': 'zh',
	    'з': 'z', 'и': 'i', 'й': 'j', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o',
	    'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c',
	    'ч': 'ch', 'ш': 'sh', 'щ': 'sh', 'ъ': 'u', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu',
	    'я': 'ya',
	    'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'Yo', 'Ж': 'Zh',
	    'З': 'Z', 'И': 'I', 'Й': 'J', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N', 'О': 'O',
	    'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C',
	    'Ч': 'Ch', 'Ш': 'Sh', 'Щ': 'Sh', 'Ъ': 'U', 'Ы': 'Y', 'Ь': '', 'Э': 'E', 'Ю': 'Yu',
	    'Я': 'Ya',
	    // ukranian
	    'Є': 'Ye', 'І': 'I', 'Ї': 'Yi', 'Ґ': 'G', 'є': 'ye', 'і': 'i', 'ї': 'yi', 'ґ': 'g',
	    // czech
	    'č': 'c', 'ď': 'd', 'ě': 'e', 'ň': 'n', 'ř': 'r', 'š': 's', 'ť': 't', 'ů': 'u',
	    'ž': 'z', 'Č': 'C', 'Ď': 'D', 'Ě': 'E', 'Ň': 'N', 'Ř': 'R', 'Š': 'S', 'Ť': 'T',
	    'Ů': 'U', 'Ž': 'Z',
	    // polish
	    'ą': 'a', 'ć': 'c', 'ę': 'e', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ź': 'z',
	    'ż': 'z', 'Ą': 'A', 'Ć': 'C', 'Ę': 'e', 'Ł': 'L', 'Ń': 'N', 'Ś': 'S',
	    'Ź': 'Z', 'Ż': 'Z',
	    // latvian
	    'ā': 'a', 'č': 'c', 'ē': 'e', 'ģ': 'g', 'ī': 'i', 'ķ': 'k', 'ļ': 'l', 'ņ': 'n',
	    'š': 's', 'ū': 'u', 'ž': 'z', 'Ā': 'A', 'Č': 'C', 'Ē': 'E', 'Ģ': 'G', 'Ī': 'i',
	    'Ķ': 'k', 'Ļ': 'L', 'Ņ': 'N', 'Š': 'S', 'Ū': 'u', 'Ž': 'Z',
	    // serbian latin
	    'đ': 'dj', 'ǌ': 'nj', 'ǉ': 'lj', 'Đ': 'DJ', 'ǋ': 'NJ', 'ǈ': 'LJ',
	    // serbian cyrillic
	    'ђ': 'dj', 'ј': 'j', 'љ': 'lj', 'њ': 'nj', 'ћ': 'c', 'џ': 'dz', 'Ђ': 'DJ', 'Ј': 'J',
	    'Љ': 'LJ', 'Њ': 'NJ', 'Ћ': 'C', 'Џ': 'DZ',
	    // currency
	    '€': 'euro', '₢': 'cruzeiro', '₣': 'french franc', '£': 'pound',
	    '₤': 'lira', '₥': 'mill', '₦': 'naira', '₧': 'peseta', '₨': 'rupee',
	    '₩': 'won', '₪': 'new shequel', '₫': 'dong', '₭': 'kip', '₮': 'tugrik',
	    '₯': 'drachma', '₰': 'penny', '₱': 'peso', '₲': 'guarani', '₳': 'austral',
	    '₴': 'hryvnia', '₵': 'cedi', '¢': 'cent', '¥': 'yen', '元': 'yuan',
	    '円': 'yen', '﷼': 'rial', '₠': 'ecu', '¤': 'currency', '฿': 'baht',
	    '$': 'dollar', '₽': 'russian ruble',
	    // symbols
	    '©': '(c)', 'œ': 'oe', 'Œ': 'OE', '∑': 'sum', '®': '(r)', '†': '+',
	    '“': '"', '”': '"', '‘': "'", '’': "'", '∂': 'd', 'ƒ': 'f', '™': 'tm',
	    '℠': 'sm', '…': '...', '˚': 'o', 'º': 'o', 'ª': 'a', '•': '*',
	    '∆': 'delta', '∞': 'infinity', '♥': 'love', '&': 'and', '|': 'or',
	    '<': 'less', '>': 'greater'
	  }
	
	  function replace (string, options) {
	    options = (typeof options === 'string')
	      ? {replacement: options}
	      : options || {}
	
	    string = string.split('')
	      .reduce(function (result, ch) {
	        if (charMap[ch]) {
	          ch = charMap[ch]
	        }
	        // allowed
	        ch = ch.replace(options.remove || /[^\w\s$*_+~.()'"!\-:@]/g, '')
	        result += ch
	        return result
	      }, '')
	      // trim leading/trailing spaces
	      .replace(/^\s+|\s+$/g, '')
	      // convert spaces
	      .replace(/[-\s]+/g, options.replacement || '-')
	      // remove trailing separator
	      .replace('#{replacement}$', '')
	
	    return options.lower ? string.toLowerCase() : string
	  }
	
	  replace.extend = function (customMap) {
	    for (var key in customMap) {
	      charMap[key] = customMap[key]
	    }
	  }
	
	  return replace
	}))


/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(955);


/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(956);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(281)(module)))

/***/ }),
/* 956 */
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ }),
/* 957 */
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// commons-e7c16654db6cd77f4e64.js